var _C = Object.defineProperty;
var SC = (e, t, n) => t in e ? _C(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var $0 = (e, t, n) => SC(e, typeof t != "symbol" ? t + "" : t, n);
import te from "@emotion/styled";
import * as si from "react";
import Xe, { useReducer as qv, useCallback as Ge, forwardRef as pm, useContext as zo, memo as en, useMemo as Ee, useState as Se, useEffect as He, useRef as qt, useImperativeHandle as CC, Fragment as EC, useId as kC, isValidElement as Xv, cloneElement as TC } from "react";
import { pickBy as MC, capitalize as Jv, isEqual as Qs, merge as Y0, debounce as IC, downloadFile as NC, isString as OC, isObject as wd, getCodeLanguageByFileExtension as pf, getUUID as Kv, startCase as RC, getFileExtension as DC, eraseCookie as j0, getFormatDateFromNow as Zv, api as un, setErrorHandlingNotifications as PC, getFormatDateAndTime as Kn, isAiGeneratedMetadata as LC, parseActions as Bc, getStatusColor as W0, createHeadersFromMetadataAttributes as zC, isAiMetadataName as BC, separateSearchFilters as eA, populateColumnsConfigWithSort as FC, parseMetadataValues as tA, isEmpty as $C, getSortDirection as YC, formatBytes as H0 } from "@prometheus/utils";
import { ValidationMessageSeverity as gr, FileExtension as rn, MediaType as Zo, HealthStatus as ur, AnalysisSubmissionStatus as Sn, EntityType as $e, ConceptSetSectionTabs as Lr, TypesOfContainer as Ae, EntityIconNames as wt, analysisTypesMap as mm, studyStatuses as U0, AnalysisTypes as ya, analysisBaseInfoActions as jC, MetaAttributeTypes as Bt, containerTypes as gm, EntityTypes as mf, OtherImportTypes as li, ImportAtlasAsset as Mi, NameConflictResolution as Et, atlasAssetList as WC } from "@prometheus/enums";
import { produce as HC } from "immer";
import { Box as he, transparentize as $i, Spinner as yt, useTheme as Kr, SeverityIcons as UC, Button as Te, CollapsiblePanel as GC, Grid as R, FilterPanel as ym, Table as Ml, Block as dr, Tooltip as pt, Icon as pe, Typography as fe, Input as _r, useNotifications as Zr, IconActionButton as qe, DialogContent as nA, DialogActions as rA, Dialog as iA, DialogTitle as VC, Textarea as QC, Checkbox as aA, StatusTag as xm, Skeleton as ai, LoaderProgress as qC, Placeholder as XC, IconButton as Ra, BlockTitle as oA, FavoriteIcon as JC, Avatar as sA, MenuItem as su, MenuList as KC, Divider as Sa, Menu as lA, ClickAwayListener as cA, Badge as gf, PopoverContent as uA, Popover as fA, Portal as ZC, ComparisonIcon as Ph, HierarchyIcons as eE, tooltipClasses as G0, MuiTooltip as tE, ContentBlock as Fr, NewTable as ha, EmptyTableStub as nE, DropDownMenu as dA, setLightness as V0, StudyStatuses as rE, EditableInput as Kt, AnalysisIcon as hA, LogoBox as iE, IconActionDropdown as aE, EditableAutocomplete as oE, EditableDatePicker as Q0, WelcomePageIcon as yf, InputFilter as pA, ButtonGroup as sE, Paper as wr, Select as xr, Autocomplete as mA, Alert as vm, SEARCH_PRECISION_OPTIONS as q0, Radio as lu } from "@prometheus/components";
import { IconActionButton as FQ } from "@prometheus/components";
import { Status as Ce, InvitationTypes as Nt, ListActions as Fc, EntityActions as lE, AiSuggestionStatus as X0 } from "@prometheus/types";
import cE from "@monaco-editor/react";
import { setLightness as uE, transparentize as Un, darken as fE } from "polished";
import { useTranslation as Da } from "react-i18next";
import { DialogContext as Am, useInterval as gA, ModalContext as bm, useDownloadAnalysisTypes as dE, useMetadata as yA, useEntityList as xA, useVersions as hE, useExportList as pE, useMetadataValues as vA, UseMetadataValuesStatus as or, useSelectedConcepts as mE, useList as gE, UseFileExplorerStatus as yE, useFileExplorer as xE } from "@prometheus/hooks";
import { pdfjs as vE, Page as AE, Document as bE } from "react-pdf";
import { useTheme as kr } from "@emotion/react";
import Lh from "clsx";
import { useDispatch as Qi, useSelector as Rt } from "react-redux";
import { Link as wE, NavLink as AA, matchPath as bA, useBlocker as _E, useNavigate as Tr, useSearchParams as wA } from "react-router-dom";
import { getIncluded as J0, reloadCompareData as SE, removeCompareItem as CE, getImage as EE, setBreadcrumbs as kE, getSummary as TE, switchTenant as ME } from "@prometheus/redux";
import IE, { isNumber as NE } from "lodash";
import { LineChart as _A, Line as SA, ResponsiveContainer as OE, CartesianGrid as RE, XAxis as DE, YAxis as PE, Tooltip as LE } from "recharts";
import zE from "react-virtualized-auto-sizer";
const yV = te.div`
  padding: 16px;
`, BE = te.div`
  font-size: 13px;
  label {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.textColor.header;
}};
    font-weight: 700;
    display: ${({ inline: e }) => e ? "inline-block" : "block"};
    /* font-size: 12px; */
    margin-bottom: 5px;
  }
  .required {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.error.main;
}};
  }
  p {
    margin: 0;
    margin-top: 2px;
    font-size: 12px;
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.textColor.secondary;
}};
  }
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.textColor.secondary;
}};
`, xf = te.div`
  text-align: right;
  button:last-child {
    margin-left: 10px;
  }
`, xV = te.div`
  margin-bottom: 10px;
  h5 {
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: #626262;
  }
`, CA = {
  isLoading: !0,
  messages: [],
  filteredMessages: [],
  filters: [],
  filter: [],
  messagesCnt: 0,
  severity: gr.INFO,
  latestCheckedEntity: null
};
var ui = /* @__PURE__ */ ((e) => (e.GET_ENTITY_MESSAGES_PENDING = "GET_ENTITY_MESSAGES_PENDING", e.GET_ENTITY_MESSAGES_SUCCESS = "GET_ENTITY_MESSAGES_SUCCESS", e.GET_ENTITY_MESSAGES_FAILURE = "GET_ENTITY_MESSAGES_FAILURE", e.SET_FILTER = "SET_FILTER", e))(ui || {});
function K0(e = [], t = []) {
  return Array.isArray(t) && t.length ? e.filter((n) => t.includes(n.severity)) : e;
}
function FE(e = []) {
  if (!e.length) return [];
  const t = MC(
    EA(e),
    (r) => r > 0
  );
  return [
    {
      label: "Severity",
      type: "checkbox",
      collapsible: !0,
      name: "severity",
      options: Object.keys(t).map(
        (r) => ({
          name: `${Jv(r)} (${t[r]})`,
          value: r
        })
      )
    }
  ];
}
function EA(e = []) {
  const t = Object.keys(
    gr
  ).reduce(
    (n, r) => ({ ...n, [r]: 0 }),
    {}
  );
  return e.reduce((n, r) => ({
    ...n,
    [r.severity]: n[r.severity] + 1
  }), t);
}
function $E(e = []) {
  const t = EA(e);
  return t[gr.CRITICAL] ? gr.CRITICAL : t[gr.WARNING] ? gr.WARNING : gr.INFO;
}
function kA(e, t) {
  var n, r, i, a, o;
  switch (e) {
    case gr.WARNING:
      return ((n = t == null ? void 0 : t.palette) == null ? void 0 : n.warning.main) || "orange";
    case gr.CRITICAL:
      return ((r = t == null ? void 0 : t.palette) == null ? void 0 : r.error.main) || "red";
    case gr.INFO:
      return ((i = t == null ? void 0 : t.palette) == null ? void 0 : i.grey[500]) || "grey";
    case gr.DEFAULT:
      return ((a = t == null ? void 0 : t.palette) == null ? void 0 : a.info.main) || "blue";
    default:
      return ((o = t == null ? void 0 : t.palette) == null ? void 0 : o.grey[500]) || "grey";
  }
}
const YE = (e = CA, t) => HC(e, (n) => {
  switch (t.type) {
    case ui.GET_ENTITY_MESSAGES_PENDING:
      n.isLoading = !0;
      break;
    case ui.GET_ENTITY_MESSAGES_SUCCESS:
      const { messages: r = [], latestCheckedEntity: i } = t.payload;
      n.isLoading = !1, n.latestCheckedEntity = i, n.messages = r, n.filters = FE(r), n.filteredMessages = K0(r, n.filter), n.messagesCnt = r.length || 0, n.severity = $E(r);
      break;
    case ui.GET_ENTITY_MESSAGES_FAILURE:
      n.isLoading = !1, n.latestCheckedEntity = null;
      break;
    case ui.SET_FILTER:
      n.filter = t.payload, n.filteredMessages = K0(
        n.messages,
        n.filter
      );
      break;
  }
});
function vV(e) {
  const { getMessages: t, fixEntity: n, fixEntityAvailability: r } = e, [i, a] = qv(
    YE,
    CA
  ), {
    filteredMessages: o,
    messagesCnt: s,
    filter: c,
    filters: l,
    isLoading: u,
    severity: d,
    latestCheckedEntity: f
  } = i, h = Ge(
    async (g) => {
      if (!Qs(f, g))
        try {
          a({
            type: ui.GET_ENTITY_MESSAGES_PENDING
          });
          const v = await t(
            g.expression
          );
          a({
            type: ui.GET_ENTITY_MESSAGES_SUCCESS,
            payload: {
              messages: v,
              latestCheckedEntity: g
            }
          });
        } catch (v) {
          console.error(v), a({
            type: ui.GET_ENTITY_MESSAGES_FAILURE
          });
        }
    },
    [f]
  ), m = Ge(
    (g, v) => {
      a({
        type: ui.SET_FILTER,
        payload: v
      });
    },
    []
  );
  return {
    messages: o,
    messagesCnt: s,
    isLoading: u,
    filters: l,
    filter: c,
    severity: d,
    runCheck: h,
    fixEntity: n,
    setFilters: m,
    fixEntityAvailability: r
  };
}
var Ca = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function jE(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var zh = { exports: {} }, es = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z0;
function WE() {
  if (Z0) return es;
  Z0 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, a) {
    var o = null;
    if (a !== void 0 && (o = "" + a), i.key !== void 0 && (o = "" + i.key), "key" in i) {
      a = {};
      for (var s in i)
        s !== "key" && (a[s] = i[s]);
    } else a = i;
    return i = a.ref, {
      $$typeof: e,
      type: r,
      key: o,
      ref: i !== void 0 ? i : null,
      props: a
    };
  }
  return es.Fragment = t, es.jsx = n, es.jsxs = n, es;
}
var ts = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ey;
function HE() {
  return ey || (ey = 1, process.env.NODE_ENV !== "production" && function() {
    function e(S) {
      if (S == null) return null;
      if (typeof S == "function")
        return S.$$typeof === O ? null : S.displayName || S.name || null;
      if (typeof S == "string") return S;
      switch (S) {
        case g:
          return "Fragment";
        case _:
          return "Profiler";
        case v:
          return "StrictMode";
        case y:
          return "Suspense";
        case x:
          return "SuspenseList";
        case w:
          return "Activity";
      }
      if (typeof S == "object")
        switch (typeof S.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), S.$$typeof) {
          case m:
            return "Portal";
          case M:
            return (S.displayName || "Context") + ".Provider";
          case I:
            return (S._context.displayName || "Context") + ".Consumer";
          case k:
            var j = S.render;
            return S = S.displayName, S || (S = j.displayName || j.name || "", S = S !== "" ? "ForwardRef(" + S + ")" : "ForwardRef"), S;
          case b:
            return j = S.displayName || null, j !== null ? j : e(S.type) || "Memo";
          case A:
            j = S._payload, S = S._init;
            try {
              return e(S(j));
            } catch {
            }
        }
      return null;
    }
    function t(S) {
      return "" + S;
    }
    function n(S) {
      try {
        t(S);
        var j = !1;
      } catch {
        j = !0;
      }
      if (j) {
        j = console;
        var Y = j.error, N = typeof Symbol == "function" && Symbol.toStringTag && S[Symbol.toStringTag] || S.constructor.name || "Object";
        return Y.call(
          j,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          N
        ), t(S);
      }
    }
    function r(S) {
      if (S === g) return "<>";
      if (typeof S == "object" && S !== null && S.$$typeof === A)
        return "<...>";
      try {
        var j = e(S);
        return j ? "<" + j + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var S = P.A;
      return S === null ? null : S.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function o(S) {
      if (E.call(S, "key")) {
        var j = Object.getOwnPropertyDescriptor(S, "key").get;
        if (j && j.isReactWarning) return !1;
      }
      return S.key !== void 0;
    }
    function s(S, j) {
      function Y() {
        D || (D = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          j
        ));
      }
      Y.isReactWarning = !0, Object.defineProperty(S, "key", {
        get: Y,
        configurable: !0
      });
    }
    function c() {
      var S = e(this.type);
      return z[S] || (z[S] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), S = this.props.ref, S !== void 0 ? S : null;
    }
    function l(S, j, Y, N, X, G, q, $) {
      return Y = G.ref, S = {
        $$typeof: h,
        type: S,
        key: j,
        props: G,
        _owner: X
      }, (Y !== void 0 ? Y : null) !== null ? Object.defineProperty(S, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(S, "ref", { enumerable: !1, value: null }), S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(S, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(S, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: q
      }), Object.defineProperty(S, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    }
    function u(S, j, Y, N, X, G, q, $) {
      var Q = j.children;
      if (Q !== void 0)
        if (N)
          if (C(Q)) {
            for (N = 0; N < Q.length; N++)
              d(Q[N]);
            Object.freeze && Object.freeze(Q);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else d(Q);
      if (E.call(j, "key")) {
        Q = e(S);
        var V = Object.keys(j).filter(function(K) {
          return K !== "key";
        });
        N = 0 < V.length ? "{key: someKey, " + V.join(": ..., ") + ": ...}" : "{key: someKey}", L[Q + N] || (V = 0 < V.length ? "{" + V.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          N,
          Q,
          V,
          Q
        ), L[Q + N] = !0);
      }
      if (Q = null, Y !== void 0 && (n(Y), Q = "" + Y), o(j) && (n(j.key), Q = "" + j.key), "key" in j) {
        Y = {};
        for (var H in j)
          H !== "key" && (Y[H] = j[H]);
      } else Y = j;
      return Q && s(
        Y,
        typeof S == "function" ? S.displayName || S.name || "Unknown" : S
      ), l(
        S,
        Q,
        G,
        X,
        i(),
        Y,
        q,
        $
      );
    }
    function d(S) {
      typeof S == "object" && S !== null && S.$$typeof === h && S._store && (S._store.validated = 1);
    }
    var f = Xe, h = Symbol.for("react.transitional.element"), m = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), _ = Symbol.for("react.profiler"), I = Symbol.for("react.consumer"), M = Symbol.for("react.context"), k = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), w = Symbol.for("react.activity"), O = Symbol.for("react.client.reference"), P = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, E = Object.prototype.hasOwnProperty, C = Array.isArray, T = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      react_stack_bottom_frame: function(S) {
        return S();
      }
    };
    var D, z = {}, F = f.react_stack_bottom_frame.bind(
      f,
      a
    )(), W = T(r(a)), L = {};
    ts.Fragment = g, ts.jsx = function(S, j, Y, N, X) {
      var G = 1e4 > P.recentlyCreatedOwnerStacks++;
      return u(
        S,
        j,
        Y,
        !1,
        N,
        X,
        G ? Error("react-stack-top-frame") : F,
        G ? T(r(S)) : W
      );
    }, ts.jsxs = function(S, j, Y, N, X) {
      var G = 1e4 > P.recentlyCreatedOwnerStacks++;
      return u(
        S,
        j,
        Y,
        !0,
        N,
        X,
        G ? Error("react-stack-top-frame") : F,
        G ? T(r(S)) : W
      );
    };
  }()), ts;
}
process.env.NODE_ENV === "production" ? zh.exports = WE() : zh.exports = HE();
var Li = zh.exports;
function UE(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function GE(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var VE = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, a), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(GE(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = UE(i);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), gn = "-ms-", cu = "-moz-", lt = "-webkit-", TA = "comm", wm = "rule", _m = "decl", QE = "@import", MA = "@keyframes", qE = "@layer", XE = Math.abs, Af = String.fromCharCode, JE = Object.assign;
function KE(e, t) {
  return ln(e, 0) ^ 45 ? (((t << 2 ^ ln(e, 0)) << 2 ^ ln(e, 1)) << 2 ^ ln(e, 2)) << 2 ^ ln(e, 3) : 0;
}
function IA(e) {
  return e.trim();
}
function ZE(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ct(e, t, n) {
  return e.replace(t, n);
}
function Bh(e, t) {
  return e.indexOf(t);
}
function ln(e, t) {
  return e.charCodeAt(t) | 0;
}
function qs(e, t, n) {
  return e.slice(t, n);
}
function zr(e) {
  return e.length;
}
function Sm(e) {
  return e.length;
}
function rc(e, t) {
  return t.push(e), e;
}
function ek(e, t) {
  return e.map(t).join("");
}
var bf = 1, Co = 1, NA = 0, Pn = 0, Ut = 0, Bo = "";
function wf(e, t, n, r, i, a, o) {
  return { value: e, root: t, parent: n, type: r, props: i, children: a, line: bf, column: Co, length: o, return: "" };
}
function ns(e, t) {
  return JE(wf("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function tk() {
  return Ut;
}
function nk() {
  return Ut = Pn > 0 ? ln(Bo, --Pn) : 0, Co--, Ut === 10 && (Co = 1, bf--), Ut;
}
function Jn() {
  return Ut = Pn < NA ? ln(Bo, Pn++) : 0, Co++, Ut === 10 && (Co = 1, bf++), Ut;
}
function Ur() {
  return ln(Bo, Pn);
}
function $c() {
  return Pn;
}
function Il(e, t) {
  return qs(Bo, e, t);
}
function Xs(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function OA(e) {
  return bf = Co = 1, NA = zr(Bo = e), Pn = 0, [];
}
function RA(e) {
  return Bo = "", e;
}
function Yc(e) {
  return IA(Il(Pn - 1, Fh(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function rk(e) {
  for (; (Ut = Ur()) && Ut < 33; )
    Jn();
  return Xs(e) > 2 || Xs(Ut) > 3 ? "" : " ";
}
function ik(e, t) {
  for (; --t && Jn() && !(Ut < 48 || Ut > 102 || Ut > 57 && Ut < 65 || Ut > 70 && Ut < 97); )
    ;
  return Il(e, $c() + (t < 6 && Ur() == 32 && Jn() == 32));
}
function Fh(e) {
  for (; Jn(); )
    switch (Ut) {
      case e:
        return Pn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Fh(Ut);
        break;
      case 40:
        e === 41 && Fh(e);
        break;
      case 92:
        Jn();
        break;
    }
  return Pn;
}
function ak(e, t) {
  for (; Jn() && e + Ut !== 57; )
    if (e + Ut === 84 && Ur() === 47)
      break;
  return "/*" + Il(t, Pn - 1) + "*" + Af(e === 47 ? e : Jn());
}
function ok(e) {
  for (; !Xs(Ur()); )
    Jn();
  return Il(e, Pn);
}
function sk(e) {
  return RA(jc("", null, null, null, [""], e = OA(e), 0, [0], e));
}
function jc(e, t, n, r, i, a, o, s, c) {
  for (var l = 0, u = 0, d = o, f = 0, h = 0, m = 0, g = 1, v = 1, _ = 1, I = 0, M = "", k = i, y = a, x = r, b = M; v; )
    switch (m = I, I = Jn()) {
      case 40:
        if (m != 108 && ln(b, d - 1) == 58) {
          Bh(b += ct(Yc(I), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        b += Yc(I);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        b += rk(m);
        break;
      case 92:
        b += ik($c() - 1, 7);
        continue;
      case 47:
        switch (Ur()) {
          case 42:
          case 47:
            rc(lk(ak(Jn(), $c()), t, n), c);
            break;
          default:
            b += "/";
        }
        break;
      case 123 * g:
        s[l++] = zr(b) * _;
      case 125 * g:
      case 59:
      case 0:
        switch (I) {
          case 0:
          case 125:
            v = 0;
          case 59 + u:
            _ == -1 && (b = ct(b, /\f/g, "")), h > 0 && zr(b) - d && rc(h > 32 ? ny(b + ";", r, n, d - 1) : ny(ct(b, " ", "") + ";", r, n, d - 2), c);
            break;
          case 59:
            b += ";";
          default:
            if (rc(x = ty(b, t, n, l, u, i, s, M, k = [], y = [], d), a), I === 123)
              if (u === 0)
                jc(b, t, x, x, k, a, d, s, y);
              else
                switch (f === 99 && ln(b, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    jc(e, x, x, r && rc(ty(e, x, x, 0, 0, i, s, M, i, k = [], d), y), i, y, d, s, r ? k : y);
                    break;
                  default:
                    jc(b, x, x, x, [""], y, 0, s, y);
                }
        }
        l = u = h = 0, g = _ = 1, M = b = "", d = o;
        break;
      case 58:
        d = 1 + zr(b), h = m;
      default:
        if (g < 1) {
          if (I == 123)
            --g;
          else if (I == 125 && g++ == 0 && nk() == 125)
            continue;
        }
        switch (b += Af(I), I * g) {
          case 38:
            _ = u > 0 ? 1 : (b += "\f", -1);
            break;
          case 44:
            s[l++] = (zr(b) - 1) * _, _ = 1;
            break;
          case 64:
            Ur() === 45 && (b += Yc(Jn())), f = Ur(), u = d = zr(M = b += ok($c())), I++;
            break;
          case 45:
            m === 45 && zr(b) == 2 && (g = 0);
        }
    }
  return a;
}
function ty(e, t, n, r, i, a, o, s, c, l, u) {
  for (var d = i - 1, f = i === 0 ? a : [""], h = Sm(f), m = 0, g = 0, v = 0; m < r; ++m)
    for (var _ = 0, I = qs(e, d + 1, d = XE(g = o[m])), M = e; _ < h; ++_)
      (M = IA(g > 0 ? f[_] + " " + I : ct(I, /&\f/g, f[_]))) && (c[v++] = M);
  return wf(e, t, n, i === 0 ? wm : s, c, l, u);
}
function lk(e, t, n) {
  return wf(e, t, n, TA, Af(tk()), qs(e, 2, -2), 0);
}
function ny(e, t, n, r) {
  return wf(e, t, n, _m, qs(e, 0, r), qs(e, r + 1, -1), r);
}
function fo(e, t) {
  for (var n = "", r = Sm(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function ck(e, t, n, r) {
  switch (e.type) {
    case qE:
      if (e.children.length) break;
    case QE:
    case _m:
      return e.return = e.return || e.value;
    case TA:
      return "";
    case MA:
      return e.return = e.value + "{" + fo(e.children, r) + "}";
    case wm:
      e.value = e.props.join(",");
  }
  return zr(n = fo(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function uk(e) {
  var t = Sm(e);
  return function(n, r, i, a) {
    for (var o = "", s = 0; s < t; s++)
      o += e[s](n, r, i, a) || "";
    return o;
  };
}
function fk(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function dk(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var hk = function(t, n, r) {
  for (var i = 0, a = 0; i = a, a = Ur(), i === 38 && a === 12 && (n[r] = 1), !Xs(a); )
    Jn();
  return Il(t, Pn);
}, pk = function(t, n) {
  var r = -1, i = 44;
  do
    switch (Xs(i)) {
      case 0:
        i === 38 && Ur() === 12 && (n[r] = 1), t[r] += hk(Pn - 1, n, r);
        break;
      case 2:
        t[r] += Yc(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = Ur() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += Af(i);
    }
  while (i = Jn());
  return t;
}, mk = function(t, n) {
  return RA(pk(OA(t), n));
}, ry = /* @__PURE__ */ new WeakMap(), gk = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !ry.get(r)) && !i) {
      ry.set(t, !0);
      for (var a = [], o = mk(n, a), s = r.props, c = 0, l = 0; c < o.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = a[c] ? o[c].replace(/&\f/g, s[u]) : s[u] + " " + o[c];
    }
  }
}, yk = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function DA(e, t) {
  switch (KE(e, t)) {
    case 5103:
      return lt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return lt + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return lt + e + cu + e + gn + e + e;
    case 6828:
    case 4268:
      return lt + e + gn + e + e;
    case 6165:
      return lt + e + gn + "flex-" + e + e;
    case 5187:
      return lt + e + ct(e, /(\w+).+(:[^]+)/, lt + "box-$1$2" + gn + "flex-$1$2") + e;
    case 5443:
      return lt + e + gn + "flex-item-" + ct(e, /flex-|-self/, "") + e;
    case 4675:
      return lt + e + gn + "flex-line-pack" + ct(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return lt + e + gn + ct(e, "shrink", "negative") + e;
    case 5292:
      return lt + e + gn + ct(e, "basis", "preferred-size") + e;
    case 6060:
      return lt + "box-" + ct(e, "-grow", "") + lt + e + gn + ct(e, "grow", "positive") + e;
    case 4554:
      return lt + ct(e, /([^-])(transform)/g, "$1" + lt + "$2") + e;
    case 6187:
      return ct(ct(ct(e, /(zoom-|grab)/, lt + "$1"), /(image-set)/, lt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ct(e, /(image-set\([^]*)/, lt + "$1$`$1");
    case 4968:
      return ct(ct(e, /(.+:)(flex-)?(.*)/, lt + "box-pack:$3" + gn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + lt + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ct(e, /(.+)-inline(.+)/, lt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (zr(e) - 1 - t > 6) switch (ln(e, t + 1)) {
        case 109:
          if (ln(e, t + 4) !== 45) break;
        case 102:
          return ct(e, /(.+:)(.+)-([^]+)/, "$1" + lt + "$2-$3$1" + cu + (ln(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Bh(e, "stretch") ? DA(ct(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (ln(e, t + 1) !== 115) break;
    case 6444:
      switch (ln(e, zr(e) - 3 - (~Bh(e, "!important") && 10))) {
        case 107:
          return ct(e, ":", ":" + lt) + e;
        case 101:
          return ct(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + lt + (ln(e, 14) === 45 ? "inline-" : "") + "box$3$1" + lt + "$2$3$1" + gn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (ln(e, t + 11)) {
        case 114:
          return lt + e + gn + ct(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return lt + e + gn + ct(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return lt + e + gn + ct(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return lt + e + gn + e + e;
  }
  return e;
}
var xk = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case _m:
      t.return = DA(t.value, t.length);
      break;
    case MA:
      return fo([ns(t, {
        value: ct(t.value, "@", "@" + lt)
      })], i);
    case wm:
      if (t.length) return ek(t.props, function(a) {
        switch (ZE(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return fo([ns(t, {
              props: [ct(a, /:(read-\w+)/, ":" + cu + "$1")]
            })], i);
          case "::placeholder":
            return fo([ns(t, {
              props: [ct(a, /:(plac\w+)/, ":" + lt + "input-$1")]
            }), ns(t, {
              props: [ct(a, /:(plac\w+)/, ":" + cu + "$1")]
            }), ns(t, {
              props: [ct(a, /:(plac\w+)/, gn + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, vk = [xk], Ak = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(g) {
      var v = g.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || vk, a = {}, o, s = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var v = g.getAttribute("data-emotion").split(" "), _ = 1; _ < v.length; _++)
        a[v[_]] = !0;
      s.push(g);
    }
  );
  var c, l = [gk, yk];
  {
    var u, d = [ck, fk(function(g) {
      u.insert(g);
    })], f = uk(l.concat(i, d)), h = function(v) {
      return fo(sk(v), f);
    };
    c = function(v, _, I, M) {
      u = I, h(v ? v + "{" + _.styles + "}" : _.styles), M && (m.inserted[_.name] = !0);
    };
  }
  var m = {
    key: n,
    sheet: new VE({
      key: n,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: c
  };
  return m.sheet.hydrate(s), m;
}, $h = { exports: {} }, dt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iy;
function bk() {
  if (iy) return dt;
  iy = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function M(y) {
    if (typeof y == "object" && y !== null) {
      var x = y.$$typeof;
      switch (x) {
        case t:
          switch (y = y.type, y) {
            case c:
            case l:
            case r:
            case a:
            case i:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return y;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function k(y) {
    return M(y) === l;
  }
  return dt.AsyncMode = c, dt.ConcurrentMode = l, dt.ContextConsumer = s, dt.ContextProvider = o, dt.Element = t, dt.ForwardRef = u, dt.Fragment = r, dt.Lazy = m, dt.Memo = h, dt.Portal = n, dt.Profiler = a, dt.StrictMode = i, dt.Suspense = d, dt.isAsyncMode = function(y) {
    return k(y) || M(y) === c;
  }, dt.isConcurrentMode = k, dt.isContextConsumer = function(y) {
    return M(y) === s;
  }, dt.isContextProvider = function(y) {
    return M(y) === o;
  }, dt.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, dt.isForwardRef = function(y) {
    return M(y) === u;
  }, dt.isFragment = function(y) {
    return M(y) === r;
  }, dt.isLazy = function(y) {
    return M(y) === m;
  }, dt.isMemo = function(y) {
    return M(y) === h;
  }, dt.isPortal = function(y) {
    return M(y) === n;
  }, dt.isProfiler = function(y) {
    return M(y) === a;
  }, dt.isStrictMode = function(y) {
    return M(y) === i;
  }, dt.isSuspense = function(y) {
    return M(y) === d;
  }, dt.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === l || y === a || y === i || y === d || y === f || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === h || y.$$typeof === o || y.$$typeof === s || y.$$typeof === u || y.$$typeof === v || y.$$typeof === _ || y.$$typeof === I || y.$$typeof === g);
  }, dt.typeOf = M, dt;
}
var ht = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ay;
function wk() {
  return ay || (ay = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function M(U) {
      return typeof U == "string" || typeof U == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      U === r || U === l || U === a || U === i || U === d || U === f || typeof U == "object" && U !== null && (U.$$typeof === m || U.$$typeof === h || U.$$typeof === o || U.$$typeof === s || U.$$typeof === u || U.$$typeof === v || U.$$typeof === _ || U.$$typeof === I || U.$$typeof === g);
    }
    function k(U) {
      if (typeof U == "object" && U !== null) {
        var ee = U.$$typeof;
        switch (ee) {
          case t:
            var ce = U.type;
            switch (ce) {
              case c:
              case l:
              case r:
              case a:
              case i:
              case d:
                return ce;
              default:
                var se = ce && ce.$$typeof;
                switch (se) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return se;
                  default:
                    return ee;
                }
            }
          case n:
            return ee;
        }
      }
    }
    var y = c, x = l, b = s, A = o, w = t, O = u, P = r, E = m, C = h, T = n, D = a, z = i, F = d, W = !1;
    function L(U) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), S(U) || k(U) === c;
    }
    function S(U) {
      return k(U) === l;
    }
    function j(U) {
      return k(U) === s;
    }
    function Y(U) {
      return k(U) === o;
    }
    function N(U) {
      return typeof U == "object" && U !== null && U.$$typeof === t;
    }
    function X(U) {
      return k(U) === u;
    }
    function G(U) {
      return k(U) === r;
    }
    function q(U) {
      return k(U) === m;
    }
    function $(U) {
      return k(U) === h;
    }
    function Q(U) {
      return k(U) === n;
    }
    function V(U) {
      return k(U) === a;
    }
    function H(U) {
      return k(U) === i;
    }
    function K(U) {
      return k(U) === d;
    }
    ht.AsyncMode = y, ht.ConcurrentMode = x, ht.ContextConsumer = b, ht.ContextProvider = A, ht.Element = w, ht.ForwardRef = O, ht.Fragment = P, ht.Lazy = E, ht.Memo = C, ht.Portal = T, ht.Profiler = D, ht.StrictMode = z, ht.Suspense = F, ht.isAsyncMode = L, ht.isConcurrentMode = S, ht.isContextConsumer = j, ht.isContextProvider = Y, ht.isElement = N, ht.isForwardRef = X, ht.isFragment = G, ht.isLazy = q, ht.isMemo = $, ht.isPortal = Q, ht.isProfiler = V, ht.isStrictMode = H, ht.isSuspense = K, ht.isValidElementType = M, ht.typeOf = k;
  }()), ht;
}
process.env.NODE_ENV === "production" ? $h.exports = bk() : $h.exports = wk();
var Cm = $h.exports, PA = Cm, _k = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Sk = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, LA = {};
LA[PA.ForwardRef] = _k;
LA[PA.Memo] = Sk;
var Ck = !0;
function Ek(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : i && (r += i + " ");
  }), r;
}
var zA = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Ck === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, kk = function(t, n, r) {
  zA(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + i : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function Tk(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Mk = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Ik = /[A-Z]|^ms/g, Nk = /_EMO_([^_]+?)_([^]*?)_EMO_/g, BA = function(t) {
  return t.charCodeAt(1) === 45;
}, oy = function(t) {
  return t != null && typeof t != "boolean";
}, _d = /* @__PURE__ */ dk(function(e) {
  return BA(e) ? e : e.replace(Ik, "-$&").toLowerCase();
}), sy = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Nk, function(r, i, a) {
          return Br = {
            name: i,
            styles: a,
            next: Br
          }, i;
        });
  }
  return Mk[t] !== 1 && !BA(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Js(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return Br = {
          name: i.name,
          styles: i.styles,
          next: Br
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var o = a.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Br = {
              name: o.name,
              styles: o.styles,
              next: Br
            }, o = o.next;
        var s = a.styles + ";";
        return s;
      }
      return Ok(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = Br, l = n(e);
        return Br = c, Js(e, t, l);
      }
      break;
    }
  }
  var u = n;
  return u;
}
function Ok(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += Js(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var o = n[a];
      if (typeof o != "object") {
        var s = o;
        oy(s) && (r += _d(a) + ":" + sy(a, s) + ";");
      } else if (Array.isArray(o) && typeof o[0] == "string" && t == null)
        for (var c = 0; c < o.length; c++)
          oy(o[c]) && (r += _d(a) + ":" + sy(a, o[c]) + ";");
      else {
        var l = Js(e, t, o);
        switch (a) {
          case "animation":
          case "animationName": {
            r += _d(a) + ":" + l + ";";
            break;
          }
          default:
            r += a + "{" + l + "}";
        }
      }
    }
  return r;
}
var ly = /label:\s*([^\s;{]+)\s*(;|$)/g, Br;
function Rk(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  Br = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += Js(n, t, a);
  else {
    var o = a;
    i += o[0];
  }
  for (var s = 1; s < e.length; s++)
    if (i += Js(n, t, e[s]), r) {
      var c = a;
      i += c[s];
    }
  ly.lastIndex = 0;
  for (var l = "", u; (u = ly.exec(i)) !== null; )
    l += "-" + u[1];
  var d = Tk(i) + l;
  return {
    name: d,
    styles: i,
    next: Br
  };
}
var Dk = function(t) {
  return t();
}, Pk = si.useInsertionEffect ? si.useInsertionEffect : !1, Lk = Pk || Dk, FA = /* @__PURE__ */ si.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Ak({
    key: "css"
  }) : null
);
FA.Provider;
var zk = function(t) {
  return /* @__PURE__ */ pm(function(n, r) {
    var i = zo(FA);
    return t(n, i, r);
  });
}, Bk = /* @__PURE__ */ si.createContext({}), _f = {}.hasOwnProperty, Yh = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", $A = function(t, n) {
  var r = {};
  for (var i in n)
    _f.call(n, i) && (r[i] = n[i]);
  return r[Yh] = t, r;
}, Fk = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return zA(n, r, i), Lk(function() {
    return kk(n, r, i);
  }), null;
}, $k = /* @__PURE__ */ zk(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var i = e[Yh], a = [r], o = "";
  typeof e.className == "string" ? o = Ek(t.registered, a, e.className) : e.className != null && (o = e.className + " ");
  var s = Rk(a, void 0, si.useContext(Bk));
  o += t.key + "-" + s.name;
  var c = {};
  for (var l in e)
    _f.call(e, l) && l !== "css" && l !== Yh && (c[l] = e[l]);
  return c.className = o, n && (c.ref = n), /* @__PURE__ */ si.createElement(si.Fragment, null, /* @__PURE__ */ si.createElement(Fk, {
    cache: t,
    serialized: s,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ si.createElement(i, c));
}), YA = $k, ze = Li.Fragment, p = function(t, n, r) {
  return _f.call(n, "css") ? Li.jsx(YA, $A(t, n), r) : Li.jsx(t, n, r);
}, B = function(t, n, r) {
  return _f.call(n, "css") ? Li.jsxs(YA, $A(t, n), r) : Li.jsxs(t, n, r);
};
const Wc = te(he, {
  shouldForwardProp: (e) => e !== "color" && e !== "dense" && e !== "disabled" && e !== "inverted"
})(
  ({ theme: e, color: t = "info", dense: n, disabled: r, inverted: i }) => ({
    backgroundColor: i ? $i(0.6, "#ffffff") : $i(
      t === "info" ? 0.85 : 0.2,
      r ? e.palette.grey[400] : e.palette[t].main
    ),
    borderRadius: "2px",
    color: function() {
      return r ? e.palette.grey[400] : i ? "#ffffff" : t === "info" ? e.palette.textColor.primary : "#ffffff";
    }(),
    fontSize: n ? 11 : 12,
    padding: n ? "2px 5px" : "3px 6px",
    display: "inline-flex",
    height: n ? 17 : 19,
    lineHeight: "14px",
    boxSizing: "border-box",
    fontWeight: 400
  })
), Yk = te("div")(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  ".tab-title": {
    marginRight: "8px"
  }
})), jh = ({
  status: e,
  count: t,
  title: n,
  severity: r = "info",
  dense: i,
  hideZeroCount: a = !1,
  hideTitle: o = !1
}) => /* @__PURE__ */ B(Yk, { className: "tab-wrapper", children: [
  !o && /* @__PURE__ */ p("div", { className: "tab-title", children: n }),
  !a && (() => {
    switch (e) {
      case Ce.IN_PROGRESS:
        return /* @__PURE__ */ p(Wc, { dense: i, className: "tab-count", children: /* @__PURE__ */ p(yt, { size: 11, color: "info" }) });
      case Ce.IN_PROGRESS_RELOAD:
      case Ce.SUCCESS:
        return /* @__PURE__ */ p(Wc, { color: r, dense: i, className: "tab-count", children: t });
      case Ce.ERROR:
      case Ce.INITIAL:
      default:
        return /* @__PURE__ */ p(Wc, { color: r, dense: i, className: "tab-count", children: "0" });
    }
  })()
] }), AV = en((e) => {
  const {
    title: t = "Messages",
    messagesCnt: n,
    severity: r,
    showCnt: i = !0,
    isLoading: a = !1,
    max: o,
    hideTitle: s = !1
  } = e, c = o && !Number.isNaN(Number(o)) && Number(n) > Number(o) ? `${o}+` : n;
  return /* @__PURE__ */ p(
    jh,
    {
      title: t,
      status: a ? Ce.IN_PROGRESS : Ce.SUCCESS,
      count: c,
      severity: {
        INFO: "info",
        WARNING: "warning",
        CRITICAL: "error",
        DEFAULT: "info"
      }[r],
      hideTitle: s
    }
  );
}), jk = te.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
`, Wk = en((e) => {
  const { severity: t } = e, n = Kr(), r = kA(t, n);
  return /* @__PURE__ */ p(jk, { children: /* @__PURE__ */ p(UC, { iconName: t.toLowerCase(), color: r }) });
}), Hk = te.span`
  margin-right: 10px;
`, Uk = en((e) => {
  const { text: t, data: n, fixEntity: r, fixEntityAvailability: i } = e, { original: a } = n, o = Ee(
    () => i == null ? void 0 : i(a),
    []
  ), s = Ge(
    (c) => {
      c.preventDefault(), r == null || r(a);
    },
    [a]
  );
  return /* @__PURE__ */ B("div", { children: [
    /* @__PURE__ */ p(Hk, { children: Jv(t) }),
    o && /* @__PURE__ */ p(Te, { size: "small", variant: "outlined", onClick: s, children: "Fix it" })
  ] });
}), Gk = te.div`
  display: flex;
  color: #fff;
  background-color: ${({ severity: e, theme: t }) => kA(e, t)};
  /* margin-left: 5px; */
  padding: 0 6px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 16px;
  min-width: 8px;
  border-radius: 10px;
`, Vk = te.div`
  display: flex;
  margin-left: 5px;
  height: 16px;
  width: 16px;
  align-items: center;
`, bV = en(
  (e) => {
    const { visible: t, cnt: n, severity: r, isLoading: i } = e;
    return t ? /* @__PURE__ */ p(ze, { children: i ? /* @__PURE__ */ p(Vk, { children: /* @__PURE__ */ p(yt, { size: 12 }) }) : /* @__PURE__ */ p(
      Gk,
      {
        severity: r,
        className: "counter-badge",
        children: n
      }
    ) }) : null;
  }
), Qk = {
  columns: (e, t) => [
    {
      Header: "Severity",
      accessor: "severity",
      Cell: ({ value: n }) => /* @__PURE__ */ p(Wk, { severity: n })
      // @NOTICE: Use this syntax to enable typescript props checking
    },
    {
      Header: "Message",
      accessor: "message",
      sortType: (n, r, i) => {
        const a = n.original[i].toLowerCase(), o = r.original[i].toLowerCase();
        return a > o ? 1 : o > a ? -1 : 0;
      },
      Cell: ({ value: n, row: r }) => /* @__PURE__ */ p(
        Uk,
        {
          text: n,
          data: r,
          fixEntity: e,
          fixEntityAvailability: t
        }
      )
    }
  ]
}, qk = te(GC)`
  margin-right: 20px;
  min-width: 150px;
  box-shadow: none;
  .content-block__heading {
    /* font-size: 14px; */
    background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  }
  .filter-panel__content {
    padding: 12px;
  }
  .c-filter-panel {
    border: none;
    padding-bottom: 0;
  }
`, wV = en((e) => {
  const {
    messages: t,
    filters: n,
    setFilters: r,
    isLoading: i,
    loadingMessage: a = "Loading Messages",
    filter: o,
    fixEntity: s,
    fixEntityAvailability: c
  } = e, l = Ee(
    () => Qk.columns(s, c),
    [s]
  ), u = Ee(() => ({ severity: o }), [o]);
  return /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ B(R, { container: !0, p: 2, children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 3, children: /* @__PURE__ */ p(qk, { title: "Severity", visible: !0, collapsible: !0, children: /* @__PURE__ */ p("div", { className: "filter-panel__content", children: /* @__PURE__ */ p(
      ym,
      {
        showLabel: !1,
        filters: n,
        value: u,
        isLoading: i,
        onChange: r
      }
    ) }) }) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 9, children: /* @__PURE__ */ p(
      Ml,
      {
        columns: l,
        data: t,
        isLoading: i,
        loadingMessage: a,
        enableSorting: !0,
        enablePagination: !0,
        showColumnToggle: !0
      }
    ) })
  ] }) });
}), Ks = te(Te)`
  padding: 2px;
  min-width: 20px;
`;
te.div`
  /* padding: 20px; */
`;
const Xk = te.div`
  background-color: #d8e1ef;
  color: #343434;
  margin-right: -2px;
  padding: 8px 12px;
  justify-content: space-between;
`, Jk = te.div`
  position: relative;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-end;

  .monaco-editor {
    border: 1px solid #d8e1ef;
    /* border-top: none; */

    .line-numbers,
    .active-line-number {
      color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    }
    .margin {
      .current-line {
        background-color: ${({ theme: e }) => {
  var t;
  return uE(0.9, ((t = e.palette) == null ? void 0 : t.primary.main) || "#000000");
}};
      }
    }
    .margin {
      background-color: #e6ecf5;
    }
  }
`, Kk = te.div`
  display: flex;
  padding-bottom: 10px;
  position: absolute;
  right: 16px;
  top: 2px;
  z-index: 4;
`;
var jA = /* @__PURE__ */ ((e) => (e.APPLICATION_JSON = "application/json", e.APPLICATION_TEXT = "application/text", e))(jA || {});
const cy = {
  contextmenu: !1,
  readOnly: !0,
  domReadOnly: !0,
  scrollBeyondLastLine: !1,
  wordWrap: "wordWrapColumn",
  wrappingStrategy: "advanced",
  tabSize: 2,
  minimap: {
    enabled: !1
  },
  parameterHints: {
    enabled: !1
  },
  // inlineHints: {
  //   enabled: false,
  // },
  hover: {
    enabled: !1
  }
}, Zk = {
  folding: !0,
  foldingStrategy: "indentation",
  showFoldingControls: "always",
  foldingHighlight: !0
}, eT = {
  parameterHints: {
    enabled: !0
  },
  // inlineHints: {
  //   enabled: true,
  // },
  hover: {
    enabled: !0
  }
};
function tT(e, t = !0) {
  return !e.readOnly && t ? Y0(
    cy,
    eT,
    e
  ) : Y0(cy, e);
}
function nT(e) {
  try {
    return JSON.parse(e);
  } catch {
    return !1;
  }
}
const Nl = en((e) => {
  const { t } = Da(), [n, r] = Se(!1), {
    title: i = "",
    tooltipText: a = t("features.code_editor.tooltip_text"),
    fileName: o = t("features.code_editor.file"),
    fileExtension: s = rn.JSON,
    contentType: c = jA.APPLICATION_JSON,
    editorOptions: l = {},
    data: u,
    language: d = "plaintext",
    placeholder: f,
    placeholderStyles: h = {},
    height: m = "500px",
    containerStyles: g = {},
    readOnly: v = !1,
    enableValidation: _ = !0,
    enableCopy: I = !0,
    enableDownload: M = !0,
    onChange: k,
    remoteFile: y = !1,
    downloadMethod: x
  } = e, b = Ee(
    () => tT(
      {
        ...d === "json" ? Zk : {},
        ...l,
        readOnly: v,
        copyWithSyntaxHighlighting: !0
      },
      _
    ),
    [l, _, v, d]
  ), [A, w] = Se(""), O = I || M, P = f && !A, E = Ge(() => {
    r(!0), navigator.clipboard.writeText(A), IC(() => r(!1), 2e3)();
  }, [A]), C = Ge(() => {
    NC(A, `${o}.${s}`, c);
  }, [u, o, s, c, A]), T = Ge((D) => {
    k == null || k(D);
  }, []);
  return He(() => {
    if (!y) {
      if (d === "json")
        if (u && OC(u)) {
          const F = nT(u);
          w(F ? JSON.stringify(F, null, 2) : u);
        } else {
          const F = wd(u) ? JSON.stringify(u, null, 2) : u;
          w(F);
        }
      else
        w(u);
      return;
    }
    async function D() {
      const z = await x(
        wd(u) ? u == null ? void 0 : u.id : u
      ), F = wd(z) ? JSON.stringify(z, null, 2) : z;
      w(F);
    }
    D == null || D();
  }, [u]), /* @__PURE__ */ B(he, { sx: g, children: [
    i && /* @__PURE__ */ p(Xk, { title: i, children: i }),
    /* @__PURE__ */ B(Jk, { children: [
      O && /* @__PURE__ */ B(Kk, { className: "actions-container", children: [
        I && /* @__PURE__ */ p(
          Ks,
          {
            onClick: E,
            className: "actions-container__button-copy",
            name: "copyToClipboard",
            children: /* @__PURE__ */ p(
              pt,
              {
                text: a,
                controlled: !0,
                show: n,
                width: 130,
                children: /* @__PURE__ */ p(
                  pe,
                  {
                    iconName: "copy",
                    sx: { fontSize: 18 },
                    name: "Copy to clipboard"
                  }
                )
              }
            )
          }
        ),
        M && /* @__PURE__ */ p(
          Ks,
          {
            onClick: C,
            className: "actions-container__button-download",
            name: "downloadFile",
            children: /* @__PURE__ */ p(
              pe,
              {
                iconName: "download",
                sx: { fontSize: 18 },
                name: "Download as file"
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ p(
        cE,
        {
          height: m,
          language: d,
          value: A,
          options: b,
          onChange: T
        }
      ),
      P && /* @__PURE__ */ p(
        he,
        {
          sx: {
            color: "text.disabled",
            fontFamily: "monospace",
            fontSize: 13,
            left: 66,
            lineHeight: "19px",
            pointerEvents: "none",
            position: "absolute",
            right: 16,
            top: 6,
            whiteSpace: "pre",
            zIndex: 3,
            ...h
          },
          children: f
        }
      )
    ] })
  ] });
}), an = en((e) => {
  const { name: t, textLabel: n, required: r, children: i, inline: a } = e;
  return /* @__PURE__ */ B(BE, { inline: a, children: [
    /* @__PURE__ */ B("label", { htmlFor: t, children: [
      n,
      r ? /* @__PURE__ */ p("sup", { className: "required", children: "*" }) : /* @__PURE__ */ p(ze, {})
    ] }),
    i
  ] });
}), _V = (e) => {
  const { htmlFor: t, label: n, required: r, children: i } = e;
  return /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
    /* @__PURE__ */ B(
      fe,
      {
        variant: "subtitle1",
        component: "label",
        sx: {
          sup: {
            color: "error.main",
            ml: 0.25
          }
        },
        htmlFor: t,
        children: [
          n,
          r ? /* @__PURE__ */ p("sup", { className: "required", children: " *" }) : /* @__PURE__ */ p(ze, {})
        ]
      }
    ),
    i
  ] });
}, SV = (e) => {
  const {
    name: t,
    textLabel: n,
    htmlFor: r,
    required: i,
    children: a,
    description: o,
    labelSize: s,
    fullSize: c,
    dense: l
  } = e;
  return /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(
    R,
    {
      container: !0,
      alignItems: "center",
      columnSpacing: l ? 1.5 : 2,
      p: l ? 0 : 1,
      children: [
        /* @__PURE__ */ B(R, { item: !0, ...c ? {} : { xs: s || 7 }, children: [
          /* @__PURE__ */ B(
            fe,
            {
              component: "label",
              variant: "subtitle2",
              htmlFor: r || t,
              sx: {
                // fontSize: 14,
                fontWeight: 700,
                ".required": { color: "error.main" }
              },
              children: [
                n,
                i ? /* @__PURE__ */ p("span", { className: "required", children: "*" }) : /* @__PURE__ */ p(ze, {})
              ]
            }
          ),
          o && /* @__PURE__ */ p(fe, { variant: "subtitle2", children: o })
        ] }),
        /* @__PURE__ */ p(
          R,
          {
            item: !0,
            ...c ? { flexGrow: 1 } : { xs: 12 - (s || 7) },
            children: a
          }
        )
      ]
    }
  ) });
}, rT = en((e) => {
  const {
    nameKey: t,
    codeKey: n,
    editorHeight: r,
    editorTitle: i,
    fields: a = [],
    fileExtension: o,
    contentType: s,
    onSubmit: c,
    onFieldValueChange: l,
    isLoading: u = !1,
    submitButtonText: d = "Import",
    isSubmitDisabled: f = !1,
    fieldErrors: h = {},
    onCancel: m,
    footerStart: g
  } = e, v = Ee(
    () => pf(rn.JSON),
    []
  ), [_, I] = Se({
    [n]: "",
    ...a.reduce((y, x) => ({ ...y, [x.name]: x.defaultValue ?? "" }), {})
  }), M = (y) => {
    const x = typeof y == "string" ? n : y.target.name, b = typeof y == "string" ? y : y.target.value, A = { [x]: b };
    I((w) => ({ ...w, ...A })), l == null || l(x, b);
  }, k = Ge(
    (y) => {
      y.preventDefault(), c == null || c(_);
    },
    [_]
  );
  return /* @__PURE__ */ B(R, { container: !0, spacing: 1, children: [
    !!(a != null && a.length) && a.map(
      ({ name: y, label: x, type: b, Component: A, ...w }) => /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(an, { name: y, textLabel: x, children: [
        /* @__PURE__ */ p(
          A,
          {
            id: y,
            type: b,
            name: y,
            value: _[y] || "",
            onChange: M,
            fullWidth: !0,
            ...w
          }
        ),
        (h == null ? void 0 : h[y]) && /* @__PURE__ */ p(fe, { color: "error.main", variant: "caption", children: h[y] })
      ] }) }, y)
    ),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ p(
      Nl,
      {
        title: i,
        data: _[n] || "",
        fileName: _[t] || "File",
        height: r,
        language: v,
        onChange: M,
        fileExtension: o,
        contentType: s
      }
    ) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(xf, { children: /* @__PURE__ */ B(R, { container: !0, alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ p(R, { item: !0, children: g }),
      /* @__PURE__ */ B(R, { item: !0, children: [
        m && /* @__PURE__ */ p(
          Te,
          {
            variant: "outlined",
            onClick: m,
            size: "small",
            startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ p(
          Te,
          {
            variant: "contained",
            onClick: k,
            color: "success",
            startIcon: u ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: "import" }),
            disabled: u || f || a.some((y) => y.name === t) && !_[t] || !_[n],
            children: d
          }
        )
      ] })
    ] }) }) })
  ] });
}), uy = [
  {
    Component: _r,
    name: "name",
    label: "Name",
    type: "text"
  },
  {
    Component: _r,
    name: "description",
    label: "Description",
    type: "text"
  }
], CV = (e) => {
  const { enqueueSnackbar: t } = Zr(), n = Ee(() => uy, [uy]), [r, i] = Se(!1), { onChange: a, createMethod: o } = e, s = Ge(
    async (c) => {
      const { expression: l, name: u, ...d } = c;
      let f;
      i(!0);
      try {
        const h = JSON.parse(l);
        f = {
          name: u || "Imported Cohort",
          expression: h,
          ...d
        };
      } catch {
        t({
          message: "Cohort Definition is not valid!",
          variant: "error"
        }), i(!1);
        return;
      }
      try {
        const h = await o(f);
        a == null || a(h);
      } catch (h) {
        console.error(h), i(!1), t({
          message: "Failed to import Cohort!",
          variant: "error"
        });
      }
    },
    []
  );
  return /* @__PURE__ */ p(
    rT,
    {
      onSubmit: s,
      codeKey: "expression",
      nameKey: "name",
      editorTitle: "Cohort Definition",
      fields: n,
      isLoading: r,
      fileExtension: rn.JSON
    }
  );
}, iT = (e) => {
  const { onEdit: t, iconSize: n = 18 } = e;
  return /* @__PURE__ */ p(
    qe,
    {
      iconName: "edit",
      onClick: (r) => {
        r.stopPropagation(), t(r);
      },
      color: "default",
      noExpand: !0,
      size: "small"
    }
  );
}, aT = (e) => {
  const { onView: t } = e;
  return /* @__PURE__ */ p(
    qe,
    {
      iconName: "view",
      tooltipText: "View",
      onClick: (n) => {
        n.stopPropagation(), t(n);
      },
      color: "default",
      noExpand: !0,
      size: "small"
    }
  );
}, Em = (e) => {
  const {
    onSubmit: t,
    onDecline: n,
    onClose: r,
    text: i,
    confirmButtonText: a,
    cancelButtonText: o,
    TextField: s,
    variant: c = "info"
  } = e, [l, u] = Se(""), d = s;
  return /* @__PURE__ */ B(iA, { open: e.open, children: [
    /* @__PURE__ */ B(nA, { children: [
      /* @__PURE__ */ p("div", { className: "alert-dialog-description", children: i || "Are you sure you want to delete this item?" }),
      d && /* @__PURE__ */ p(
        d,
        {
          sx: { width: "100%" },
          value: l,
          onChange: (f) => {
            var h;
            u((h = f == null ? void 0 : f.target) == null ? void 0 : h.value);
          }
        }
      )
    ] }),
    /* @__PURE__ */ B(rA, { children: [
      /* @__PURE__ */ p(
        Te,
        {
          onClick: () => {
            n && n(), u(""), r && r();
          },
          variant: "outlined",
          name: "cancel",
          color: "darkGrey",
          children: o || "CANCEL"
        }
      ),
      /* @__PURE__ */ p(
        Te,
        {
          onClick: () => {
            t && t({ dismissNote: l }), u(""), r && r();
          },
          variant: "contained",
          name: "confirm",
          color: c,
          children: a || "CONFIRM"
        }
      )
    ] })
  ] });
}, EV = (e) => {
  const { onSubmit: t, onDecline: n, onClose: r, text: i } = e, [a, o] = Se(!1);
  return /* @__PURE__ */ B(iA, { open: e.open, children: [
    /* @__PURE__ */ p(VC, { children: "Consent Form" }),
    /* @__PURE__ */ p(nA, { children: /* @__PURE__ */ p(R, { container: !0, children: /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      QC,
      {
        id: "consent",
        name: "consent",
        value: i,
        onChange: () => {
        },
        maxRows: 20,
        minRows: 5,
        readOnly: !0,
        placeholder: "Enter consent form",
        disableHorizontalResize: !0
      },
      ""
    ) }) }) }),
    /* @__PURE__ */ p(rA, { children: /* @__PURE__ */ B(R, { container: !0, px: 2, mt: -2, children: [
      /* @__PURE__ */ p(R, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ B("label", { children: [
        /* @__PURE__ */ p(
          aA,
          {
            name: "createNew",
            onChange: () => {
              o(!a);
            },
            checked: a
          }
        ),
        /* @__PURE__ */ p(fe, { sx: { ml: 1 }, variant: "caption", children: "I confirm that I have read, understood, and will follow the agreement outlined in the consent form." })
      ] }) }),
      /* @__PURE__ */ B(R, { item: !0, xs: 12, display: "flex", justifyContent: "flex-end", children: [
        /* @__PURE__ */ p(
          Te,
          {
            onClick: () => {
              t && t(), r && r();
            },
            variant: "contained",
            name: "confirm",
            disabled: !a,
            color: "success",
            startIcon: /* @__PURE__ */ p(pe, { iconName: "submit" }),
            children: "Accept"
          }
        ),
        /* @__PURE__ */ p(
          Te,
          {
            onClick: () => {
              n && n(), r && r();
            },
            variant: "outlined",
            startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
            name: "cancel",
            sx: { ml: 1 },
            children: "Reject"
          }
        )
      ] })
    ] }) })
  ] });
}, oT = (e) => {
  const {
    onRemove: t,
    withConfirmation: n = !1,
    confirmationMessage: r = "Are you sure you want to delete this item?",
    iconSize: i = 18,
    size: a = "small"
  } = e, o = Xe.useContext(Am), s = (l) => {
    l == null || l.stopPropagation(), t(l);
  };
  return /* @__PURE__ */ p(
    qe,
    {
      size: a,
      iconName: "delete",
      onClick: (l) => {
        l.stopPropagation(), n && o ? o.showDialog(Em, {
          onSubmit: () => s(l),
          onClose: o == null ? void 0 : o.hideDialog,
          text: r,
          confirmButtonText: "DELETE",
          variant: "error"
        }) : s(l);
      },
      color: "error",
      noExpand: !0
    }
  );
}, sT = te.div`
  max-height: calc(100vh - 116px);
  overflow-y: scroll;
  padding: 16px;
`;
var WA = { exports: {} };
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ca, function n() {
    var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, i = !r.document && !!r.postMessage, a = r.IS_PAPA_WORKER || !1, o = {}, s = 0, c = { parse: function(A, w) {
      var O = (w = w || {}).dynamicTyping || !1;
      if (b(O) && (w.dynamicTypingFunction = O, O = {}), w.dynamicTyping = O, w.transform = !!b(w.transform) && w.transform, w.worker && c.WORKERS_SUPPORTED) {
        var P = function() {
          if (!c.WORKERS_SUPPORTED) return !1;
          var C = (D = r.URL || r.webkitURL || null, z = n.toString(), c.BLOB_URL || (c.BLOB_URL = D.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", z, ")();"], { type: "text/javascript" })))), T = new r.Worker(C), D, z;
          return T.onmessage = I, T.id = s++, o[T.id] = T;
        }();
        return P.userStep = w.step, P.userChunk = w.chunk, P.userComplete = w.complete, P.userError = w.error, w.step = b(w.step), w.chunk = b(w.chunk), w.complete = b(w.complete), w.error = b(w.error), delete w.worker, void P.postMessage({ input: A, config: w, workerId: P.id });
      }
      var E = null;
      return c.NODE_STREAM_INPUT, typeof A == "string" ? (A = function(C) {
        return C.charCodeAt(0) === 65279 ? C.slice(1) : C;
      }(A), E = w.download ? new d(w) : new h(w)) : A.readable === !0 && b(A.read) && b(A.on) ? E = new m(w) : (r.File && A instanceof File || A instanceof Object) && (E = new f(w)), E.stream(A);
    }, unparse: function(A, w) {
      var O = !1, P = !0, E = ",", C = `\r
`, T = '"', D = T + T, z = !1, F = null, W = !1;
      (function() {
        if (typeof w == "object") {
          if (typeof w.delimiter != "string" || c.BAD_DELIMITERS.filter(function(Y) {
            return w.delimiter.indexOf(Y) !== -1;
          }).length || (E = w.delimiter), (typeof w.quotes == "boolean" || typeof w.quotes == "function" || Array.isArray(w.quotes)) && (O = w.quotes), typeof w.skipEmptyLines != "boolean" && typeof w.skipEmptyLines != "string" || (z = w.skipEmptyLines), typeof w.newline == "string" && (C = w.newline), typeof w.quoteChar == "string" && (T = w.quoteChar), typeof w.header == "boolean" && (P = w.header), Array.isArray(w.columns)) {
            if (w.columns.length === 0) throw new Error("Option columns is empty");
            F = w.columns;
          }
          w.escapeChar !== void 0 && (D = w.escapeChar + T), (typeof w.escapeFormulae == "boolean" || w.escapeFormulae instanceof RegExp) && (W = w.escapeFormulae instanceof RegExp ? w.escapeFormulae : /^[=+\-@\t\r].*$/);
        }
      })();
      var L = new RegExp(v(T), "g");
      if (typeof A == "string" && (A = JSON.parse(A)), Array.isArray(A)) {
        if (!A.length || Array.isArray(A[0])) return S(null, A, z);
        if (typeof A[0] == "object") return S(F || Object.keys(A[0]), A, z);
      } else if (typeof A == "object") return typeof A.data == "string" && (A.data = JSON.parse(A.data)), Array.isArray(A.data) && (A.fields || (A.fields = A.meta && A.meta.fields || F), A.fields || (A.fields = Array.isArray(A.data[0]) ? A.fields : typeof A.data[0] == "object" ? Object.keys(A.data[0]) : []), Array.isArray(A.data[0]) || typeof A.data[0] == "object" || (A.data = [A.data])), S(A.fields || [], A.data || [], z);
      throw new Error("Unable to serialize unrecognized input");
      function S(Y, N, X) {
        var G = "";
        typeof Y == "string" && (Y = JSON.parse(Y)), typeof N == "string" && (N = JSON.parse(N));
        var q = Array.isArray(Y) && 0 < Y.length, $ = !Array.isArray(N[0]);
        if (q && P) {
          for (var Q = 0; Q < Y.length; Q++) 0 < Q && (G += E), G += j(Y[Q], Q);
          0 < N.length && (G += C);
        }
        for (var V = 0; V < N.length; V++) {
          var H = q ? Y.length : N[V].length, K = !1, U = q ? Object.keys(N[V]).length === 0 : N[V].length === 0;
          if (X && !q && (K = X === "greedy" ? N[V].join("").trim() === "" : N[V].length === 1 && N[V][0].length === 0), X === "greedy" && q) {
            for (var ee = [], ce = 0; ce < H; ce++) {
              var se = $ ? Y[ce] : ce;
              ee.push(N[V][se]);
            }
            K = ee.join("").trim() === "";
          }
          if (!K) {
            for (var ne = 0; ne < H; ne++) {
              0 < ne && !U && (G += E);
              var re = q && $ ? Y[ne] : ne;
              G += j(N[V][re], ne);
            }
            V < N.length - 1 && (!X || 0 < H && !U) && (G += C);
          }
        }
        return G;
      }
      function j(Y, N) {
        if (Y == null) return "";
        if (Y.constructor === Date) return JSON.stringify(Y).slice(1, 25);
        var X = !1;
        W && typeof Y == "string" && W.test(Y) && (Y = "'" + Y, X = !0);
        var G = Y.toString().replace(L, D);
        return (X = X || O === !0 || typeof O == "function" && O(Y, N) || Array.isArray(O) && O[N] || function(q, $) {
          for (var Q = 0; Q < $.length; Q++) if (-1 < q.indexOf($[Q])) return !0;
          return !1;
        }(G, c.BAD_DELIMITERS) || -1 < G.indexOf(E) || G.charAt(0) === " " || G.charAt(G.length - 1) === " ") ? T + G + T : G;
      }
    } };
    if (c.RECORD_SEP = "", c.UNIT_SEP = "", c.BYTE_ORDER_MARK = "\uFEFF", c.BAD_DELIMITERS = ["\r", `
`, '"', c.BYTE_ORDER_MARK], c.WORKERS_SUPPORTED = !i && !!r.Worker, c.NODE_STREAM_INPUT = 1, c.LocalChunkSize = 10485760, c.RemoteChunkSize = 5242880, c.DefaultDelimiter = ",", c.Parser = _, c.ParserHandle = g, c.NetworkStreamer = d, c.FileStreamer = f, c.StringStreamer = h, c.ReadableStreamStreamer = m, r.jQuery) {
      var l = r.jQuery;
      l.fn.parse = function(A) {
        var w = A.config || {}, O = [];
        return this.each(function(C) {
          if (!(l(this).prop("tagName").toUpperCase() === "INPUT" && l(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var T = 0; T < this.files.length; T++) O.push({ file: this.files[T], inputElem: this, instanceConfig: l.extend({}, w) });
        }), P(), this;
        function P() {
          if (O.length !== 0) {
            var C, T, D, z, F = O[0];
            if (b(A.before)) {
              var W = A.before(F.file, F.inputElem);
              if (typeof W == "object") {
                if (W.action === "abort") return C = "AbortError", T = F.file, D = F.inputElem, z = W.reason, void (b(A.error) && A.error({ name: C }, T, D, z));
                if (W.action === "skip") return void E();
                typeof W.config == "object" && (F.instanceConfig = l.extend(F.instanceConfig, W.config));
              } else if (W === "skip") return void E();
            }
            var L = F.instanceConfig.complete;
            F.instanceConfig.complete = function(S) {
              b(L) && L(S, F.file, F.inputElem), E();
            }, c.parse(F.file, F.instanceConfig);
          } else b(A.complete) && A.complete();
        }
        function E() {
          O.splice(0, 1), P();
        }
      };
    }
    function u(A) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(w) {
        var O = y(w);
        O.chunkSize = parseInt(O.chunkSize), w.step || w.chunk || (O.chunkSize = null), this._handle = new g(O), (this._handle.streamer = this)._config = O;
      }).call(this, A), this.parseChunk = function(w, O) {
        if (this.isFirstChunk && b(this._config.beforeFirstChunk)) {
          var P = this._config.beforeFirstChunk(w);
          P !== void 0 && (w = P);
        }
        this.isFirstChunk = !1, this._halted = !1;
        var E = this._partialLine + w;
        this._partialLine = "";
        var C = this._handle.parse(E, this._baseIndex, !this._finished);
        if (!this._handle.paused() && !this._handle.aborted()) {
          var T = C.meta.cursor;
          this._finished || (this._partialLine = E.substring(T - this._baseIndex), this._baseIndex = T), C && C.data && (this._rowCount += C.data.length);
          var D = this._finished || this._config.preview && this._rowCount >= this._config.preview;
          if (a) r.postMessage({ results: C, workerId: c.WORKER_ID, finished: D });
          else if (b(this._config.chunk) && !O) {
            if (this._config.chunk(C, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
            C = void 0, this._completeResults = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(C.data), this._completeResults.errors = this._completeResults.errors.concat(C.errors), this._completeResults.meta = C.meta), this._completed || !D || !b(this._config.complete) || C && C.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), D || C && C.meta.paused || this._nextChunk(), C;
        }
        this._halted = !0;
      }, this._sendError = function(w) {
        b(this._config.error) ? this._config.error(w) : a && this._config.error && r.postMessage({ workerId: c.WORKER_ID, error: w, finished: !1 });
      };
    }
    function d(A) {
      var w;
      (A = A || {}).chunkSize || (A.chunkSize = c.RemoteChunkSize), u.call(this, A), this._nextChunk = i ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(O) {
        this._input = O, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished) this._chunkLoaded();
        else {
          if (w = new XMLHttpRequest(), this._config.withCredentials && (w.withCredentials = this._config.withCredentials), i || (w.onload = x(this._chunkLoaded, this), w.onerror = x(this._chunkError, this)), w.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !i), this._config.downloadRequestHeaders) {
            var O = this._config.downloadRequestHeaders;
            for (var P in O) w.setRequestHeader(P, O[P]);
          }
          if (this._config.chunkSize) {
            var E = this._start + this._config.chunkSize - 1;
            w.setRequestHeader("Range", "bytes=" + this._start + "-" + E);
          }
          try {
            w.send(this._config.downloadRequestBody);
          } catch (C) {
            this._chunkError(C.message);
          }
          i && w.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        w.readyState === 4 && (w.status < 200 || 400 <= w.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : w.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(O) {
          var P = O.getResponseHeader("Content-Range");
          return P === null ? -1 : parseInt(P.substring(P.lastIndexOf("/") + 1));
        }(w), this.parseChunk(w.responseText)));
      }, this._chunkError = function(O) {
        var P = w.statusText || O;
        this._sendError(new Error(P));
      };
    }
    function f(A) {
      var w, O;
      (A = A || {}).chunkSize || (A.chunkSize = c.LocalChunkSize), u.call(this, A);
      var P = typeof FileReader < "u";
      this.stream = function(E) {
        this._input = E, O = E.slice || E.webkitSlice || E.mozSlice, P ? ((w = new FileReader()).onload = x(this._chunkLoaded, this), w.onerror = x(this._chunkError, this)) : w = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var E = this._input;
        if (this._config.chunkSize) {
          var C = Math.min(this._start + this._config.chunkSize, this._input.size);
          E = O.call(E, this._start, C);
        }
        var T = w.readAsText(E, this._config.encoding);
        P || this._chunkLoaded({ target: { result: T } });
      }, this._chunkLoaded = function(E) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(E.target.result);
      }, this._chunkError = function() {
        this._sendError(w.error);
      };
    }
    function h(A) {
      var w;
      u.call(this, A = A || {}), this.stream = function(O) {
        return w = O, this._nextChunk();
      }, this._nextChunk = function() {
        if (!this._finished) {
          var O, P = this._config.chunkSize;
          return P ? (O = w.substring(0, P), w = w.substring(P)) : (O = w, w = ""), this._finished = !w, this.parseChunk(O);
        }
      };
    }
    function m(A) {
      u.call(this, A = A || {});
      var w = [], O = !0, P = !1;
      this.pause = function() {
        u.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        u.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(E) {
        this._input = E, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        P && w.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), w.length ? this.parseChunk(w.shift()) : O = !0;
      }, this._streamData = x(function(E) {
        try {
          w.push(typeof E == "string" ? E : E.toString(this._config.encoding)), O && (O = !1, this._checkIsFinished(), this.parseChunk(w.shift()));
        } catch (C) {
          this._streamError(C);
        }
      }, this), this._streamError = x(function(E) {
        this._streamCleanUp(), this._sendError(E);
      }, this), this._streamEnd = x(function() {
        this._streamCleanUp(), P = !0, this._streamData("");
      }, this), this._streamCleanUp = x(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function g(A) {
      var w, O, P, E = Math.pow(2, 53), C = -E, T = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, D = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, z = this, F = 0, W = 0, L = !1, S = !1, j = [], Y = { data: [], errors: [], meta: {} };
      if (b(A.step)) {
        var N = A.step;
        A.step = function(V) {
          if (Y = V, q()) G();
          else {
            if (G(), Y.data.length === 0) return;
            F += V.data.length, A.preview && F > A.preview ? O.abort() : (Y.data = Y.data[0], N(Y, z));
          }
        };
      }
      function X(V) {
        return A.skipEmptyLines === "greedy" ? V.join("").trim() === "" : V.length === 1 && V[0].length === 0;
      }
      function G() {
        return Y && P && (Q("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + c.DefaultDelimiter + "'"), P = !1), A.skipEmptyLines && (Y.data = Y.data.filter(function(V) {
          return !X(V);
        })), q() && function() {
          if (!Y) return;
          function V(K, U) {
            b(A.transformHeader) && (K = A.transformHeader(K, U)), j.push(K);
          }
          if (Array.isArray(Y.data[0])) {
            for (var H = 0; q() && H < Y.data.length; H++) Y.data[H].forEach(V);
            Y.data.splice(0, 1);
          } else Y.data.forEach(V);
        }(), function() {
          if (!Y || !A.header && !A.dynamicTyping && !A.transform) return Y;
          function V(K, U) {
            var ee, ce = A.header ? {} : [];
            for (ee = 0; ee < K.length; ee++) {
              var se = ee, ne = K[ee];
              A.header && (se = ee >= j.length ? "__parsed_extra" : j[ee]), A.transform && (ne = A.transform(ne, se)), ne = $(se, ne), se === "__parsed_extra" ? (ce[se] = ce[se] || [], ce[se].push(ne)) : ce[se] = ne;
            }
            return A.header && (ee > j.length ? Q("FieldMismatch", "TooManyFields", "Too many fields: expected " + j.length + " fields but parsed " + ee, W + U) : ee < j.length && Q("FieldMismatch", "TooFewFields", "Too few fields: expected " + j.length + " fields but parsed " + ee, W + U)), ce;
          }
          var H = 1;
          return !Y.data.length || Array.isArray(Y.data[0]) ? (Y.data = Y.data.map(V), H = Y.data.length) : Y.data = V(Y.data, 0), A.header && Y.meta && (Y.meta.fields = j), W += H, Y;
        }();
      }
      function q() {
        return A.header && j.length === 0;
      }
      function $(V, H) {
        return K = V, A.dynamicTypingFunction && A.dynamicTyping[K] === void 0 && (A.dynamicTyping[K] = A.dynamicTypingFunction(K)), (A.dynamicTyping[K] || A.dynamicTyping) === !0 ? H === "true" || H === "TRUE" || H !== "false" && H !== "FALSE" && (function(U) {
          if (T.test(U)) {
            var ee = parseFloat(U);
            if (C < ee && ee < E) return !0;
          }
          return !1;
        }(H) ? parseFloat(H) : D.test(H) ? new Date(H) : H === "" ? null : H) : H;
        var K;
      }
      function Q(V, H, K, U) {
        var ee = { type: V, code: H, message: K };
        U !== void 0 && (ee.row = U), Y.errors.push(ee);
      }
      this.parse = function(V, H, K) {
        var U = A.quoteChar || '"';
        if (A.newline || (A.newline = function(se, ne) {
          se = se.substring(0, 1048576);
          var re = new RegExp(v(ne) + "([^]*?)" + v(ne), "gm"), Me = (se = se.replace(re, "")).split("\r"), Re = se.split(`
`), oe = 1 < Re.length && Re[0].length < Me[0].length;
          if (Me.length === 1 || oe) return `
`;
          for (var de = 0, ue = 0; ue < Me.length; ue++) Me[ue][0] === `
` && de++;
          return de >= Me.length / 2 ? `\r
` : "\r";
        }(V, U)), P = !1, A.delimiter) b(A.delimiter) && (A.delimiter = A.delimiter(V), Y.meta.delimiter = A.delimiter);
        else {
          var ee = function(se, ne, re, Me, Re) {
            var oe, de, ue, me;
            Re = Re || [",", "	", "|", ";", c.RECORD_SEP, c.UNIT_SEP];
            for (var Z = 0; Z < Re.length; Z++) {
              var le = Re[Z], J = 0, ae = 0, ge = 0;
              ue = void 0;
              for (var be = new _({ comments: Me, delimiter: le, newline: ne, preview: 10 }).parse(se), we = 0; we < be.data.length; we++) if (re && X(be.data[we])) ge++;
              else {
                var We = be.data[we].length;
                ae += We, ue !== void 0 ? 0 < We && (J += Math.abs(We - ue), ue = We) : ue = We;
              }
              0 < be.data.length && (ae /= be.data.length - ge), (de === void 0 || J <= de) && (me === void 0 || me < ae) && 1.99 < ae && (de = J, oe = le, me = ae);
            }
            return { successful: !!(A.delimiter = oe), bestDelimiter: oe };
          }(V, A.newline, A.skipEmptyLines, A.comments, A.delimitersToGuess);
          ee.successful ? A.delimiter = ee.bestDelimiter : (P = !0, A.delimiter = c.DefaultDelimiter), Y.meta.delimiter = A.delimiter;
        }
        var ce = y(A);
        return A.preview && A.header && ce.preview++, w = V, O = new _(ce), Y = O.parse(w, H, K), G(), L ? { meta: { paused: !0 } } : Y || { meta: { paused: !1 } };
      }, this.paused = function() {
        return L;
      }, this.pause = function() {
        L = !0, O.abort(), w = b(A.chunk) ? "" : w.substring(O.getCharIndex());
      }, this.resume = function() {
        z.streamer._halted ? (L = !1, z.streamer.parseChunk(w, !0)) : setTimeout(z.resume, 3);
      }, this.aborted = function() {
        return S;
      }, this.abort = function() {
        S = !0, O.abort(), Y.meta.aborted = !0, b(A.complete) && A.complete(Y), w = "";
      };
    }
    function v(A) {
      return A.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function _(A) {
      var w, O = (A = A || {}).delimiter, P = A.newline, E = A.comments, C = A.step, T = A.preview, D = A.fastMode, z = w = A.quoteChar === void 0 || A.quoteChar === null ? '"' : A.quoteChar;
      if (A.escapeChar !== void 0 && (z = A.escapeChar), (typeof O != "string" || -1 < c.BAD_DELIMITERS.indexOf(O)) && (O = ","), E === O) throw new Error("Comment character same as delimiter");
      E === !0 ? E = "#" : (typeof E != "string" || -1 < c.BAD_DELIMITERS.indexOf(E)) && (E = !1), P !== `
` && P !== "\r" && P !== `\r
` && (P = `
`);
      var F = 0, W = !1;
      this.parse = function(L, S, j) {
        if (typeof L != "string") throw new Error("Input must be a string");
        var Y = L.length, N = O.length, X = P.length, G = E.length, q = b(C), $ = [], Q = [], V = [], H = F = 0;
        if (!L) return ie();
        if (A.header && !S) {
          var K = L.split(P)[0].split(O), U = [], ee = {}, ce = !1;
          for (var se in K) {
            var ne = K[se];
            b(A.transformHeader) && (ne = A.transformHeader(ne, se));
            var re = ne, Me = ee[ne] || 0;
            for (0 < Me && (ce = !0, re = ne + "_" + Me), ee[ne] = Me + 1; U.includes(re); ) re = re + "_" + Me;
            U.push(re);
          }
          if (ce) {
            var Re = L.split(P);
            Re[0] = U.join(O), L = Re.join(P);
          }
        }
        if (D || D !== !1 && L.indexOf(w) === -1) {
          for (var oe = L.split(P), de = 0; de < oe.length; de++) {
            if (V = oe[de], F += V.length, de !== oe.length - 1) F += P.length;
            else if (j) return ie();
            if (!E || V.substring(0, G) !== E) {
              if (q) {
                if ($ = [], ge(V.split(O)), ve(), W) return ie();
              } else ge(V.split(O));
              if (T && T <= de) return $ = $.slice(0, T), ie(!0);
            }
          }
          return ie();
        }
        for (var ue = L.indexOf(O, F), me = L.indexOf(P, F), Z = new RegExp(v(z) + v(w), "g"), le = L.indexOf(w, F); ; ) if (L[F] !== w) if (E && V.length === 0 && L.substring(F, F + G) === E) {
          if (me === -1) return ie();
          F = me + X, me = L.indexOf(P, F), ue = L.indexOf(O, F);
        } else if (ue !== -1 && (ue < me || me === -1)) V.push(L.substring(F, ue)), F = ue + N, ue = L.indexOf(O, F);
        else {
          if (me === -1) break;
          if (V.push(L.substring(F, me)), We(me + X), q && (ve(), W)) return ie();
          if (T && $.length >= T) return ie(!0);
        }
        else for (le = F, F++; ; ) {
          if ((le = L.indexOf(w, le + 1)) === -1) return j || Q.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: $.length, index: F }), we();
          if (le === Y - 1) return we(L.substring(F, le).replace(Z, w));
          if (w !== z || L[le + 1] !== z) {
            if (w === z || le === 0 || L[le - 1] !== z) {
              ue !== -1 && ue < le + 1 && (ue = L.indexOf(O, le + 1)), me !== -1 && me < le + 1 && (me = L.indexOf(P, le + 1));
              var J = be(me === -1 ? ue : Math.min(ue, me));
              if (L.substr(le + 1 + J, N) === O) {
                V.push(L.substring(F, le).replace(Z, w)), L[F = le + 1 + J + N] !== w && (le = L.indexOf(w, F)), ue = L.indexOf(O, F), me = L.indexOf(P, F);
                break;
              }
              var ae = be(me);
              if (L.substring(le + 1 + ae, le + 1 + ae + X) === P) {
                if (V.push(L.substring(F, le).replace(Z, w)), We(le + 1 + ae + X), ue = L.indexOf(O, F), le = L.indexOf(w, F), q && (ve(), W)) return ie();
                if (T && $.length >= T) return ie(!0);
                break;
              }
              Q.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: $.length, index: F }), le++;
            }
          } else le++;
        }
        return we();
        function ge(_e) {
          $.push(_e), H = F;
        }
        function be(_e) {
          var Ie = 0;
          if (_e !== -1) {
            var Pe = L.substring(le + 1, _e);
            Pe && Pe.trim() === "" && (Ie = Pe.length);
          }
          return Ie;
        }
        function we(_e) {
          return j || (_e === void 0 && (_e = L.substring(F)), V.push(_e), F = Y, ge(V), q && ve()), ie();
        }
        function We(_e) {
          F = _e, ge(V), V = [], me = L.indexOf(P, F);
        }
        function ie(_e) {
          return { data: $, errors: Q, meta: { delimiter: O, linebreak: P, aborted: W, truncated: !!_e, cursor: H + (S || 0) } };
        }
        function ve() {
          C(ie()), $ = [], Q = [];
        }
      }, this.abort = function() {
        W = !0;
      }, this.getCharIndex = function() {
        return F;
      };
    }
    function I(A) {
      var w = A.data, O = o[w.workerId], P = !1;
      if (w.error) O.userError(w.error, w.file);
      else if (w.results && w.results.data) {
        var E = { abort: function() {
          P = !0, M(w.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: k, resume: k };
        if (b(O.userStep)) {
          for (var C = 0; C < w.results.data.length && (O.userStep({ data: w.results.data[C], errors: w.results.errors, meta: w.results.meta }, E), !P); C++) ;
          delete w.results;
        } else b(O.userChunk) && (O.userChunk(w.results, E, w.file), delete w.results);
      }
      w.finished && !P && M(w.workerId, w.results);
    }
    function M(A, w) {
      var O = o[A];
      b(O.userComplete) && O.userComplete(w), O.terminate(), delete o[A];
    }
    function k() {
      throw new Error("Not implemented.");
    }
    function y(A) {
      if (typeof A != "object" || A === null) return A;
      var w = Array.isArray(A) ? [] : {};
      for (var O in A) w[O] = y(A[O]);
      return w;
    }
    function x(A, w) {
      return function() {
        A.apply(w, arguments);
      };
    }
    function b(A) {
      return typeof A == "function";
    }
    return a && (r.onmessage = function(A) {
      var w = A.data;
      if (c.WORKER_ID === void 0 && w && (c.WORKER_ID = w.workerId), typeof w.input == "string") r.postMessage({ workerId: c.WORKER_ID, results: c.parse(w.input, w.config), finished: !0 });
      else if (r.File && w.input instanceof File || w.input instanceof Object) {
        var O = c.parse(w.input, w.config);
        O && r.postMessage({ workerId: c.WORKER_ID, results: O, finished: !0 });
      }
    }), (d.prototype = Object.create(u.prototype)).constructor = d, (f.prototype = Object.create(u.prototype)).constructor = f, (h.prototype = Object.create(h.prototype)).constructor = h, (m.prototype = Object.create(u.prototype)).constructor = m, c;
  });
})(WA);
var lT = WA.exports;
const cT = te.div`
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
function uT(e, t) {
  return (e || []).map((n) => ({
    Header: t.includes(n) ? "" : RC(n).toUpperCase(),
    accessor: n,
    Cell: ({ value: i }) => /* @__PURE__ */ p(cT, { title: i, children: i })
  }));
}
function fT(e) {
  const t = [], n = lT.parse(e, {
    header: !0,
    skipEmptyLines: "greedy",
    transformHeader(o) {
      let s = o;
      if (!o) {
        const c = Kv();
        s = c, t.push(c);
      }
      return s;
    }
  }), { data: r = [], meta: i = {} } = n, a = (i == null ? void 0 : i.fields) || [];
  return {
    columns: uT(a, t),
    rows: r
  };
}
const HA = en((e) => {
  const { data: t, height: n = 500, downloadMethod: r } = e, [i, a] = Se("");
  He(() => {
    async function c() {
      const l = r ? await r(t.id) : t.content || t;
      a(l);
    }
    return c(), () => {
      a("");
    };
  }, [t]);
  const { columns: o, rows: s } = Ee(() => fT(i), [i]);
  return /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ p(sT, { children: /* @__PURE__ */ p(
    Ml,
    {
      columns: o,
      data: s,
      isLoading: !i,
      enableSorting: !0,
      enablePagination: !0,
      totalElements: s == null ? void 0 : s.length
    }
  ) }) });
});
var UA = { exports: {} }, ic = { exports: {} }, hn = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fy;
function dT() {
  if (fy) return hn;
  fy = 1;
  var e = Xe;
  function t(c) {
    var l = "https://react.dev/errors/" + c;
    if (1 < arguments.length) {
      l += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var u = 2; u < arguments.length; u++)
        l += "&args[]=" + encodeURIComponent(arguments[u]);
    }
    return "Minified React error #" + c + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function n() {
  }
  var r = {
    d: {
      f: n,
      r: function() {
        throw Error(t(522));
      },
      D: n,
      C: n,
      L: n,
      m: n,
      X: n,
      S: n,
      M: n
    },
    p: 0,
    findDOMNode: null
  }, i = Symbol.for("react.portal");
  function a(c, l, u) {
    var d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: i,
      key: d == null ? null : "" + d,
      children: c,
      containerInfo: l,
      implementation: u
    };
  }
  var o = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function s(c, l) {
    if (c === "font") return "";
    if (typeof l == "string")
      return l === "use-credentials" ? l : "";
  }
  return hn.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, hn.createPortal = function(c, l) {
    var u = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11)
      throw Error(t(299));
    return a(c, l, null, u);
  }, hn.flushSync = function(c) {
    var l = o.T, u = r.p;
    try {
      if (o.T = null, r.p = 2, c) return c();
    } finally {
      o.T = l, r.p = u, r.d.f();
    }
  }, hn.preconnect = function(c, l) {
    typeof c == "string" && (l ? (l = l.crossOrigin, l = typeof l == "string" ? l === "use-credentials" ? l : "" : void 0) : l = null, r.d.C(c, l));
  }, hn.prefetchDNS = function(c) {
    typeof c == "string" && r.d.D(c);
  }, hn.preinit = function(c, l) {
    if (typeof c == "string" && l && typeof l.as == "string") {
      var u = l.as, d = s(u, l.crossOrigin), f = typeof l.integrity == "string" ? l.integrity : void 0, h = typeof l.fetchPriority == "string" ? l.fetchPriority : void 0;
      u === "style" ? r.d.S(
        c,
        typeof l.precedence == "string" ? l.precedence : void 0,
        {
          crossOrigin: d,
          integrity: f,
          fetchPriority: h
        }
      ) : u === "script" && r.d.X(c, {
        crossOrigin: d,
        integrity: f,
        fetchPriority: h,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0
      });
    }
  }, hn.preinitModule = function(c, l) {
    if (typeof c == "string")
      if (typeof l == "object" && l !== null) {
        if (l.as == null || l.as === "script") {
          var u = s(
            l.as,
            l.crossOrigin
          );
          r.d.M(c, {
            crossOrigin: u,
            integrity: typeof l.integrity == "string" ? l.integrity : void 0,
            nonce: typeof l.nonce == "string" ? l.nonce : void 0
          });
        }
      } else l == null && r.d.M(c);
  }, hn.preload = function(c, l) {
    if (typeof c == "string" && typeof l == "object" && l !== null && typeof l.as == "string") {
      var u = l.as, d = s(u, l.crossOrigin);
      r.d.L(c, u, {
        crossOrigin: d,
        integrity: typeof l.integrity == "string" ? l.integrity : void 0,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0,
        type: typeof l.type == "string" ? l.type : void 0,
        fetchPriority: typeof l.fetchPriority == "string" ? l.fetchPriority : void 0,
        referrerPolicy: typeof l.referrerPolicy == "string" ? l.referrerPolicy : void 0,
        imageSrcSet: typeof l.imageSrcSet == "string" ? l.imageSrcSet : void 0,
        imageSizes: typeof l.imageSizes == "string" ? l.imageSizes : void 0,
        media: typeof l.media == "string" ? l.media : void 0
      });
    }
  }, hn.preloadModule = function(c, l) {
    if (typeof c == "string")
      if (l) {
        var u = s(l.as, l.crossOrigin);
        r.d.m(c, {
          as: typeof l.as == "string" && l.as !== "script" ? l.as : void 0,
          crossOrigin: u,
          integrity: typeof l.integrity == "string" ? l.integrity : void 0
        });
      } else r.d.m(c);
  }, hn.requestFormReset = function(c) {
    r.d.r(c);
  }, hn.unstable_batchedUpdates = function(c, l) {
    return c(l);
  }, hn.useFormState = function(c, l, u) {
    return o.H.useFormState(c, l, u);
  }, hn.useFormStatus = function() {
    return o.H.useHostTransitionStatus();
  }, hn.version = "19.1.1", hn;
}
var pn = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dy;
function hT() {
  return dy || (dy = 1, process.env.NODE_ENV !== "production" && function() {
    function e() {
    }
    function t(d) {
      return "" + d;
    }
    function n(d, f, h) {
      var m = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        t(m);
        var g = !1;
      } catch {
        g = !0;
      }
      return g && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && m[Symbol.toStringTag] || m.constructor.name || "Object"
      ), t(m)), {
        $$typeof: l,
        key: m == null ? null : "" + m,
        children: d,
        containerInfo: f,
        implementation: h
      };
    }
    function r(d, f) {
      if (d === "font") return "";
      if (typeof f == "string")
        return f === "use-credentials" ? f : "";
    }
    function i(d) {
      return d === null ? "`null`" : d === void 0 ? "`undefined`" : d === "" ? "an empty string" : 'something with type "' + typeof d + '"';
    }
    function a(d) {
      return d === null ? "`null`" : d === void 0 ? "`undefined`" : d === "" ? "an empty string" : typeof d == "string" ? JSON.stringify(d) : typeof d == "number" ? "`" + d + "`" : 'something with type "' + typeof d + '"';
    }
    function o() {
      var d = u.H;
      return d === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var s = Xe, c = {
      d: {
        f: e,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: e,
        C: e,
        L: e,
        m: e,
        X: e,
        S: e,
        M: e
      },
      p: 0,
      findDOMNode: null
    }, l = Symbol.for("react.portal"), u = s.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), pn.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = c, pn.createPortal = function(d, f) {
      var h = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!f || f.nodeType !== 1 && f.nodeType !== 9 && f.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return n(d, f, null, h);
    }, pn.flushSync = function(d) {
      var f = u.T, h = c.p;
      try {
        if (u.T = null, c.p = 2, d)
          return d();
      } finally {
        u.T = f, c.p = h, c.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, pn.preconnect = function(d, f) {
      typeof d == "string" && d ? f != null && typeof f != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        a(f)
      ) : f != null && typeof f.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        i(f.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        i(d)
      ), typeof d == "string" && (f ? (f = f.crossOrigin, f = typeof f == "string" ? f === "use-credentials" ? f : "" : void 0) : f = null, c.d.C(d, f));
    }, pn.prefetchDNS = function(d) {
      if (typeof d != "string" || !d)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          i(d)
        );
      else if (1 < arguments.length) {
        var f = arguments[1];
        typeof f == "object" && f.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(f)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(f)
        );
      }
      typeof d == "string" && c.d.D(d);
    }, pn.preinit = function(d, f) {
      if (typeof d == "string" && d ? f == null || typeof f != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        a(f)
      ) : f.as !== "style" && f.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        a(f.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        i(d)
      ), typeof d == "string" && f && typeof f.as == "string") {
        var h = f.as, m = r(h, f.crossOrigin), g = typeof f.integrity == "string" ? f.integrity : void 0, v = typeof f.fetchPriority == "string" ? f.fetchPriority : void 0;
        h === "style" ? c.d.S(
          d,
          typeof f.precedence == "string" ? f.precedence : void 0,
          {
            crossOrigin: m,
            integrity: g,
            fetchPriority: v
          }
        ) : h === "script" && c.d.X(d, {
          crossOrigin: m,
          integrity: g,
          fetchPriority: v,
          nonce: typeof f.nonce == "string" ? f.nonce : void 0
        });
      }
    }, pn.preinitModule = function(d, f) {
      var h = "";
      if (typeof d == "string" && d || (h += " The `href` argument encountered was " + i(d) + "."), f !== void 0 && typeof f != "object" ? h += " The `options` argument encountered was " + i(f) + "." : f && "as" in f && f.as !== "script" && (h += " The `as` option encountered was " + a(f.as) + "."), h)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          h
        );
      else
        switch (h = f && typeof f.as == "string" ? f.as : "script", h) {
          case "script":
            break;
          default:
            h = a(h), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              h,
              d
            );
        }
      typeof d == "string" && (typeof f == "object" && f !== null ? (f.as == null || f.as === "script") && (h = r(
        f.as,
        f.crossOrigin
      ), c.d.M(d, {
        crossOrigin: h,
        integrity: typeof f.integrity == "string" ? f.integrity : void 0,
        nonce: typeof f.nonce == "string" ? f.nonce : void 0
      })) : f == null && c.d.M(d));
    }, pn.preload = function(d, f) {
      var h = "";
      if (typeof d == "string" && d || (h += " The `href` argument encountered was " + i(d) + "."), f == null || typeof f != "object" ? h += " The `options` argument encountered was " + i(f) + "." : typeof f.as == "string" && f.as || (h += " The `as` option encountered was " + i(f.as) + "."), h && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        h
      ), typeof d == "string" && typeof f == "object" && f !== null && typeof f.as == "string") {
        h = f.as;
        var m = r(
          h,
          f.crossOrigin
        );
        c.d.L(d, h, {
          crossOrigin: m,
          integrity: typeof f.integrity == "string" ? f.integrity : void 0,
          nonce: typeof f.nonce == "string" ? f.nonce : void 0,
          type: typeof f.type == "string" ? f.type : void 0,
          fetchPriority: typeof f.fetchPriority == "string" ? f.fetchPriority : void 0,
          referrerPolicy: typeof f.referrerPolicy == "string" ? f.referrerPolicy : void 0,
          imageSrcSet: typeof f.imageSrcSet == "string" ? f.imageSrcSet : void 0,
          imageSizes: typeof f.imageSizes == "string" ? f.imageSizes : void 0,
          media: typeof f.media == "string" ? f.media : void 0
        });
      }
    }, pn.preloadModule = function(d, f) {
      var h = "";
      typeof d == "string" && d || (h += " The `href` argument encountered was " + i(d) + "."), f !== void 0 && typeof f != "object" ? h += " The `options` argument encountered was " + i(f) + "." : f && "as" in f && typeof f.as != "string" && (h += " The `as` option encountered was " + i(f.as) + "."), h && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        h
      ), typeof d == "string" && (f ? (h = r(
        f.as,
        f.crossOrigin
      ), c.d.m(d, {
        as: typeof f.as == "string" && f.as !== "script" ? f.as : void 0,
        crossOrigin: h,
        integrity: typeof f.integrity == "string" ? f.integrity : void 0
      })) : c.d.m(d));
    }, pn.requestFormReset = function(d) {
      c.d.r(d);
    }, pn.unstable_batchedUpdates = function(d, f) {
      return d(f);
    }, pn.useFormState = function(d, f, h) {
      return o().useFormState(d, f, h);
    }, pn.useFormStatus = function() {
      return o().useHostTransitionStatus();
    }, pn.version = "19.1.1", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), pn;
}
var hy;
function pT() {
  if (hy) return ic.exports;
  hy = 1;
  function e() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (t) {
        console.error(t);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (e(), ic.exports = dT()) : ic.exports = hT(), ic.exports;
}
(function(e, t) {
  (function(n, r) {
    e.exports = r(Xe, pT());
  })(Ca, function(n, r) {
    return function(i) {
      var a = {};
      function o(s) {
        if (a[s]) return a[s].exports;
        var c = a[s] = { i: s, l: !1, exports: {} };
        return i[s].call(c.exports, c, c.exports, o), c.l = !0, c.exports;
      }
      return o.m = i, o.c = a, o.d = function(s, c, l) {
        o.o(s, c) || Object.defineProperty(s, c, { enumerable: !0, get: l });
      }, o.r = function(s) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
      }, o.t = function(s, c) {
        if (1 & c && (s = o(s)), 8 & c || 4 & c && typeof s == "object" && s && s.__esModule) return s;
        var l = /* @__PURE__ */ Object.create(null);
        if (o.r(l), Object.defineProperty(l, "default", { enumerable: !0, value: s }), 2 & c && typeof s != "string") for (var u in s) o.d(l, u, (function(d) {
          return s[d];
        }).bind(null, u));
        return l;
      }, o.n = function(s) {
        var c = s && s.__esModule ? function() {
          return s.default;
        } : function() {
          return s;
        };
        return o.d(c, "a", c), c;
      }, o.o = function(s, c) {
        return Object.prototype.hasOwnProperty.call(s, c);
      }, o.p = "", o(o.s = 4);
    }([function(i, a) {
      i.exports = n;
    }, function(i, a, o) {
      var s;
      /*!
        Copyright (c) 2017 Jed Watson.
        Licensed under the MIT License (MIT), see
        http://jedwatson.github.io/classnames
      */
      (function() {
        var c = {}.hasOwnProperty;
        function l() {
          for (var u = [], d = 0; d < arguments.length; d++) {
            var f = arguments[d];
            if (f) {
              var h = typeof f;
              if (h === "string" || h === "number") u.push(f);
              else if (Array.isArray(f) && f.length) {
                var m = l.apply(null, f);
                m && u.push(m);
              } else if (h === "object") for (var g in f) c.call(f, g) && f[g] && u.push(g);
            }
          }
          return u.join(" ");
        }
        i.exports ? (l.default = l, i.exports = l) : (s = (function() {
          return l;
        }).apply(a, [])) === void 0 || (i.exports = s);
      })();
    }, function(i, a) {
      i.exports = "data:application/vnd.ms-fontobject;base64,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";
    }, function(i, a) {
      i.exports = r;
    }, function(i, a, o) {
      i.exports = o(13);
    }, function(i, a, o) {
      var s = o(6);
      typeof s == "string" && (s = [[i.i, s, ""]]);
      var c = { insert: "head", singleton: !1 };
      o(12)(s, c), s.locals && (i.exports = s.locals);
    }, function(i, a, o) {
      a = i.exports = o(7)(!1);
      var s = o(8), c = s(o(2)), l = s(o(2) + "?#iefix"), u = s(o(9)), d = s(o(10)), f = s(o(11));
      a.push([i.i, `@font-face {
  font-family: 'icomoon';
  src: url(` + c + `);
  src: url(` + l + ") format('embedded-opentype'), url(" + u + ") format('truetype'), url(" + d + ") format('woff'), url(" + f + `) format('svg');
  font-weight: normal;
  font-style: normal;
}
.react-viewer {
  opacity: 0;
}
.react-viewer-inline {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 400px;
}
.react-viewer ul {
  margin: 0;
  padding: 0;
}
.react-viewer li {
  list-style: none;
}
.react-viewer-mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: #373737;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
  filter: alpha(opacity=50);
  z-index: 1000;
}
.react-viewer-btn {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
}
.react-viewer-btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.react-viewer-close {
  position: fixed;
  top: 0px;
  right: 0px;
  overflow: hidden;
  width: 40px;
  height: 40px;
  border-radius: 0 0 0 40px;
  cursor: pointer;
  z-index: 1010;
}
.react-viewer-close > i {
  position: relative;
  top: 4px;
  left: 18px;
}
.react-viewer-canvas {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1005;
}
.react-viewer-canvas > img {
  display: block;
  width: auto;
  height: auto;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
.react-viewer-canvas > img.drag {
  cursor: move;
}
.react-viewer-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  text-align: center;
  z-index: 1005;
}
.react-viewer-inline > .react-viewer-mask,
.react-viewer-inline > .react-viewer-close,
.react-viewer-inline > .react-viewer-canvas,
.react-viewer-inline > .react-viewer-footer {
  position: absolute;
}
.react-viewer-attribute {
  margin: 0 20px;
  margin-bottom: 6px;
  opacity: 0.8;
  color: #ccc;
  font-size: 15px;
}
.react-viewer-showTotal {
  float: right;
}
.react-viewer-toolbar {
  overflow: hidden;
  height: 28px;
  margin-bottom: 6px !important;
}
.react-viewer-toolbar li {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 28px;
  margin-right: 3px;
  cursor: pointer;
  line-height: 28px;
}
.react-viewer-toolbar li:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.react-viewer li.empty {
  background-color: transparent;
  cursor: default;
}
.react-viewer-navbar {
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
}
.react-viewer-list {
  height: 50px;
  padding: 1px;
  text-align: left;
}
.react-viewer-list > li {
  display: inline-block;
  width: 30px;
  height: 50px;
  cursor: pointer;
  overflow: hidden;
  margin-right: 1px;
}
.react-viewer-list > li > img {
  width: 60px;
  height: 50px;
  margin-left: -15px;
  opacity: 0.5;
}
.react-viewer-list > li.active > img {
  opacity: 1;
}
.react-viewer-transition {
  -webkit-transition: opacity 0.3s ease-out;
  -o-transition: opacity 0.3s ease-out;
  transition: opacity 0.3s ease-out;
}
.react-viewer-image-transition {
  -webkit-transition-property: width, height, margin, -webkit-transform;
  transition-property: width, height, margin, -webkit-transform;
  -o-transition-property: width, height, margin, transform;
  transition-property: width, height, margin, transform;
  transition-property: width, height, margin, transform, -webkit-transform;
  -webkit-transition-duration: 0.3s;
       -o-transition-duration: 0.3s;
          transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
       -o-transition-timing-function: ease-out;
          transition-timing-function: ease-out;
}
.react-viewer-list-transition {
  -webkit-transition: margin 0.3s ease-out;
  -o-transition: margin 0.3s ease-out;
  transition: margin 0.3s ease-out;
}
.react-viewer-icon {
  font-family: 'icomoon' !important;
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  font-size: 13px;
}
.react-viewer-icon-zoomIn:before {
  content: '\\ea0a';
}
.react-viewer-icon-zoomOut:before {
  content: '\\ea0b';
}
.react-viewer-icon-prev:before {
  content: '\\ea38';
}
.react-viewer-icon-next:before {
  content: '\\ea34';
}
.react-viewer-icon-close:before {
  content: '\\ea0f';
}
.react-viewer-icon-rotateLeft:before {
  content: '\\e967';
}
.react-viewer-icon-rotateRight:before {
  content: '\\e968';
}
.react-viewer-icon-reset:before {
  content: '\\e984';
}
.react-viewer-icon-scaleX:before {
  content: '\\ea60';
}
.react-viewer-icon-scaleY:before {
  content: '\\ea5f';
}
.react-viewer-icon-download:before {
  content: '\\e9c7';
}
.circle-loading {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  border: 10px solid rgba(255, 255, 255, 0.2);
  border-top-color: #FFF;
  -webkit-animation: spin 1s infinite linear;
          animation: spin 1s infinite linear;
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
`, ""]);
    }, function(i, a, o) {
      i.exports = function(s) {
        var c = [];
        return c.toString = function() {
          return this.map(function(l) {
            var u = function(d, f) {
              var h = d[1] || "", m = d[3];
              if (!m) return h;
              if (f && typeof btoa == "function") {
                var g = (_ = m, I = btoa(unescape(encodeURIComponent(JSON.stringify(_)))), M = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(I), "/*# ".concat(M, " */")), v = m.sources.map(function(k) {
                  return "/*# sourceURL=".concat(m.sourceRoot).concat(k, " */");
                });
                return [h].concat(v).concat([g]).join(`
`);
              }
              var _, I, M;
              return [h].join(`
`);
            }(l, s);
            return l[2] ? "@media ".concat(l[2], "{").concat(u, "}") : u;
          }).join("");
        }, c.i = function(l, u) {
          typeof l == "string" && (l = [[null, l, ""]]);
          for (var d = {}, f = 0; f < this.length; f++) {
            var h = this[f][0];
            h != null && (d[h] = !0);
          }
          for (var m = 0; m < l.length; m++) {
            var g = l[m];
            g[0] != null && d[g[0]] || (u && !g[2] ? g[2] = u : u && (g[2] = "(".concat(g[2], ") and (").concat(u, ")")), c.push(g));
          }
        }, c;
      };
    }, function(i, a, o) {
      i.exports = function(s, c) {
        return typeof (s = s.__esModule ? s.default : s) != "string" ? s : (/^['"].*['"]$/.test(s) && (s = s.slice(1, -1)), /["'() \t\n]/.test(s) || c ? '"'.concat(s.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : s);
      };
    }, function(i, a) {
      i.exports = "data:font/ttf;base64,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";
    }, function(i, a) {
      i.exports = "data:font/woff;base64,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";
    }, function(i, a) {
      i.exports = "data:image/svg+xml;base64,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";
    }, function(i, a, o) {
      var s, c = {}, l = function() {
        return s === void 0 && (s = !!(window && document && document.all && !window.atob)), s;
      }, u = /* @__PURE__ */ function() {
        var y = {};
        return function(x) {
          if (y[x] === void 0) {
            var b = document.querySelector(x);
            if (window.HTMLIFrameElement && b instanceof window.HTMLIFrameElement) try {
              b = b.contentDocument.head;
            } catch {
              b = null;
            }
            y[x] = b;
          }
          return y[x];
        };
      }();
      function d(y, x) {
        for (var b = [], A = {}, w = 0; w < y.length; w++) {
          var O = y[w], P = x.base ? O[0] + x.base : O[0], E = { css: O[1], media: O[2], sourceMap: O[3] };
          A[P] ? A[P].parts.push(E) : b.push(A[P] = { id: P, parts: [E] });
        }
        return b;
      }
      function f(y, x) {
        for (var b = 0; b < y.length; b++) {
          var A = y[b], w = c[A.id], O = 0;
          if (w) {
            for (w.refs++; O < w.parts.length; O++) w.parts[O](A.parts[O]);
            for (; O < A.parts.length; O++) w.parts.push(k(A.parts[O], x));
          } else {
            for (var P = []; O < A.parts.length; O++) P.push(k(A.parts[O], x));
            c[A.id] = { id: A.id, refs: 1, parts: P };
          }
        }
      }
      function h(y) {
        var x = document.createElement("style");
        if (y.attributes.nonce === void 0) {
          var b = o.nc;
          b && (y.attributes.nonce = b);
        }
        if (Object.keys(y.attributes).forEach(function(w) {
          x.setAttribute(w, y.attributes[w]);
        }), typeof y.insert == "function") y.insert(x);
        else {
          var A = u(y.insert || "head");
          if (!A) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          A.appendChild(x);
        }
        return x;
      }
      var m, g = (m = [], function(y, x) {
        return m[y] = x, m.filter(Boolean).join(`
`);
      });
      function v(y, x, b, A) {
        var w = b ? "" : A.css;
        if (y.styleSheet) y.styleSheet.cssText = g(x, w);
        else {
          var O = document.createTextNode(w), P = y.childNodes;
          P[x] && y.removeChild(P[x]), P.length ? y.insertBefore(O, P[x]) : y.appendChild(O);
        }
      }
      function _(y, x, b) {
        var A = b.css, w = b.media, O = b.sourceMap;
        if (w && y.setAttribute("media", w), O && btoa && (A += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(O)))), " */")), y.styleSheet) y.styleSheet.cssText = A;
        else {
          for (; y.firstChild; ) y.removeChild(y.firstChild);
          y.appendChild(document.createTextNode(A));
        }
      }
      var I = null, M = 0;
      function k(y, x) {
        var b, A, w;
        if (x.singleton) {
          var O = M++;
          b = I || (I = h(x)), A = v.bind(null, b, O, !1), w = v.bind(null, b, O, !0);
        } else b = h(x), A = _.bind(null, b, x), w = function() {
          (function(P) {
            if (P.parentNode === null) return !1;
            P.parentNode.removeChild(P);
          })(b);
        };
        return A(y), function(P) {
          if (P) {
            if (P.css === y.css && P.media === y.media && P.sourceMap === y.sourceMap) return;
            A(y = P);
          } else w();
        };
      }
      i.exports = function(y, x) {
        (x = x || {}).attributes = typeof x.attributes == "object" ? x.attributes : {}, x.singleton || typeof x.singleton == "boolean" || (x.singleton = l());
        var b = d(y, x);
        return f(b, x), function(A) {
          for (var w = [], O = 0; O < b.length; O++) {
            var P = b[O], E = c[P.id];
            E && (E.refs--, w.push(E));
          }
          A && f(d(A, x), x);
          for (var C = 0; C < w.length; C++) {
            var T = w[C];
            if (T.refs === 0) {
              for (var D = 0; D < T.parts.length; D++) T.parts[D]();
              delete c[T.id];
            }
          }
        };
      };
    }, function(i, a, o) {
      o.r(a);
      var s = o(0), c = o(3);
      o(5);
      function l(E) {
        return s.createElement("div", { className: "loading-wrap", style: E.style }, s.createElement("div", { className: "circle-loading" }));
      }
      var u, d = o(1), f = o.n(d);
      function h(E, C) {
        return function(T) {
          if (Array.isArray(T)) return T;
        }(E) || function(T, D) {
          if (Symbol.iterator in Object(T) || Object.prototype.toString.call(T) === "[object Arguments]") {
            var z = [], F = !0, W = !1, L = void 0;
            try {
              for (var S, j = T[Symbol.iterator](); !(F = (S = j.next()).done) && (z.push(S.value), !D || z.length !== D); F = !0) ;
            } catch (Y) {
              W = !0, L = Y;
            } finally {
              try {
                F || j.return == null || j.return();
              } finally {
                if (W) throw L;
              }
            }
            return z;
          }
        }(E, C) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function m(E) {
        var C = s.useRef(!1), T = s.useRef({ x: 0, y: 0 }), D = h(s.useState({ x: 0, y: 0 }), 2), z = D[0], F = D[1];
        function W(K) {
          E.onResize();
        }
        function L(K) {
          K.button === 0 && E.visible && E.drag && (K.preventDefault(), K.stopPropagation(), C.current = !0, T.current = { x: K.nativeEvent.clientX, y: K.nativeEvent.clientY });
        }
        s.useEffect(function() {
          return function() {
            N(!0), Y(!0);
          };
        }, []), s.useEffect(function() {
          return Y(), function() {
            Y(!0);
          };
        }), s.useEffect(function() {
          return E.visible && E.drag && N(), !E.visible && E.drag && j(), function() {
            N(!0);
          };
        }, [E.drag, E.visible]), s.useEffect(function() {
          var K = z.x - T.current.x, U = z.y - T.current.y;
          T.current = { x: z.x, y: z.y }, E.onChangeImgState(E.width, E.height, E.top + U, E.left + K);
        }, [z]);
        var S = function(K) {
          C.current && F({ x: K.clientX, y: K.clientY });
        };
        function j(K) {
          C.current = !1;
        }
        function Y(K) {
          var U = "addEventListener";
          K && (U = "removeEventListener"), window[U]("resize", W, !1);
        }
        function N(K) {
          var U = "addEventListener";
          K && (U = "removeEventListener"), document[U]("click", j, !1), document[U]("mousemove", S, !1);
        }
        var X, G, q, $ = { width: "".concat(E.width, "px"), height: "".concat(E.height, "px"), transform: `
translateX(`.concat(E.left !== null ? E.left + "px" : "aoto", ") translateY(").concat(E.top, `px)
    rotate(`).concat(E.rotate, "deg) scaleX(").concat(E.scaleX, ") scaleY(").concat(E.scaleY, ")") }, Q = f()("".concat(E.prefixCls, "-image"), (X = { drag: E.drag }, G = "".concat(E.prefixCls, "-image-transition"), q = !C.current, G in X ? Object.defineProperty(X, G, { value: q, enumerable: !0, configurable: !0, writable: !0 }) : X[G] = q, X)), V = { zIndex: E.zIndex }, H = null;
        return E.imgSrc !== "" && (H = s.createElement("img", { className: Q, src: E.imgSrc, style: $, onMouseDown: L })), E.loading && (H = s.createElement("div", { style: { display: "flex", height: "".concat(window.innerHeight - 84, "px"), justifyContent: "center", alignItems: "center" } }, s.createElement(l, null))), s.createElement("div", { className: "".concat(E.prefixCls, "-canvas"), onMouseDown: function(K) {
          E.onCanvasMouseDown(K), L(K);
        }, style: V }, H);
      }
      function g(E) {
        var C = E.activeIndex, T = C === void 0 ? 0 : C, D = { marginLeft: "calc(50% - ".concat(T + 1, " * 31px)") };
        return s.createElement("div", { className: "".concat(E.prefixCls, "-navbar") }, s.createElement("ul", { className: "".concat(E.prefixCls, "-list ").concat(E.prefixCls, "-list-transition"), style: D }, E.images.map(function(z, F) {
          return s.createElement("li", { key: F, className: F === T ? "active" : "", onClick: function() {
            var W;
            T !== (W = F) && E.onChangeImg(W);
          } }, s.createElement("img", { src: z.src, alt: z.alt }));
        })));
      }
      function v(E) {
        return s.createElement("i", { className: "".concat("react-viewer-icon", " ").concat("react-viewer-icon", "-").concat(u[E.type]) });
      }
      (function(E) {
        E[E.zoomIn = 1] = "zoomIn", E[E.zoomOut = 2] = "zoomOut", E[E.prev = 3] = "prev", E[E.next = 4] = "next", E[E.rotateLeft = 5] = "rotateLeft", E[E.rotateRight = 6] = "rotateRight", E[E.reset = 7] = "reset", E[E.close = 8] = "close", E[E.scaleX = 9] = "scaleX", E[E.scaleY = 10] = "scaleY", E[E.download = 11] = "download";
      })(u || (u = {}));
      var _ = [{ key: "zoomIn", actionType: u.zoomIn }, { key: "zoomOut", actionType: u.zoomOut }, { key: "prev", actionType: u.prev }, { key: "reset", actionType: u.reset }, { key: "next", actionType: u.next }, { key: "rotateLeft", actionType: u.rotateLeft }, { key: "rotateRight", actionType: u.rotateRight }, { key: "scaleX", actionType: u.scaleX }, { key: "scaleY", actionType: u.scaleY }, { key: "download", actionType: u.download }];
      function I(E, C) {
        return E.filter(function(T) {
          return C.indexOf(T.key) < 0;
        });
      }
      function M(E) {
        function C(z) {
          var F = null;
          return u[z.actionType] !== void 0 && (F = s.createElement(v, { type: z.actionType })), z.render && (F = z.render), s.createElement("li", { key: z.key, className: "".concat(E.prefixCls, "-btn"), onClick: function() {
            (function(W) {
              E.onAction(W);
            })(z);
          }, "data-key": z.key }, F);
        }
        var T = E.attribute ? s.createElement("p", { className: "".concat(E.prefixCls, "-attribute") }, E.alt && "".concat(E.alt), E.noImgDetails || s.createElement("span", { className: "".concat(E.prefixCls, "-img-details") }, "(".concat(E.width, " x ").concat(E.height, ")")), E.showTotal && s.createElement("span", { className: "".concat(E.prefixCls, "-showTotal") }, "".concat(E.activeIndex + 1, " of ").concat(E.count))) : null, D = E.toolbars;
        return E.zoomable || (D = I(D, ["zoomIn", "zoomOut"])), E.changeable || (D = I(D, ["prev", "next"])), E.rotatable || (D = I(D, ["rotateLeft", "rotateRight"])), E.scalable || (D = I(D, ["scaleX", "scaleY"])), E.downloadable || (D = I(D, ["download"])), s.createElement("div", null, T, s.createElement("ul", { className: "".concat(E.prefixCls, "-toolbar") }, D.map(function(z) {
          return C(z);
        })));
      }
      function k(E, C, T) {
        return C in E ? Object.defineProperty(E, C, { value: T, enumerable: !0, configurable: !0, writable: !0 }) : E[C] = T, E;
      }
      function y(E, C) {
        return function(T) {
          if (Array.isArray(T)) return T;
        }(E) || function(T, D) {
          if (Symbol.iterator in Object(T) || Object.prototype.toString.call(T) === "[object Arguments]") {
            var z = [], F = !0, W = !1, L = void 0;
            try {
              for (var S, j = T[Symbol.iterator](); !(F = (S = j.next()).done) && (z.push(S.value), !D || z.length !== D); F = !0) ;
            } catch (Y) {
              W = !0, L = Y;
            } finally {
              try {
                F || j.return == null || j.return();
              } finally {
                if (W) throw L;
              }
            }
            return z;
          }
        }(E, C) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function x() {
        return (x = Object.assign || function(E) {
          for (var C = 1; C < arguments.length; C++) {
            var T = arguments[C];
            for (var D in T) Object.prototype.hasOwnProperty.call(T, D) && (E[D] = T[D]);
          }
          return E;
        }).apply(this, arguments);
      }
      function b() {
      }
      var A = { setVisible: "setVisible", setActiveIndex: "setActiveIndex", update: "update", clear: "clear" };
      function w(E, C) {
        return { type: E, payload: C || {} };
      }
      var O = function(E) {
        var C, T = E.visible, D = T !== void 0 && T, z = E.onClose, F = z === void 0 ? b : z, W = E.images, L = W === void 0 ? [] : W, S = E.activeIndex, j = S === void 0 ? 0 : S, Y = E.zIndex, N = Y === void 0 ? 1e3 : Y, X = E.drag, G = X === void 0 || X, q = E.attribute, $ = q === void 0 || q, Q = E.zoomable, V = Q === void 0 || Q, H = E.rotatable, K = H === void 0 || H, U = E.scalable, ee = U === void 0 || U, ce = E.onMaskClick, se = ce === void 0 ? b : ce, ne = E.changeable, re = ne === void 0 || ne, Me = E.customToolbar, Re = Me === void 0 ? function(Oe) {
          return Oe;
        } : Me, oe = E.zoomSpeed, de = oe === void 0 ? 0.05 : oe, ue = E.disableKeyboardSupport, me = ue !== void 0 && ue, Z = E.noResetZoomAfterChange, le = Z !== void 0 && Z, J = E.noLimitInitializationSize, ae = J !== void 0 && J, ge = E.defaultScale, be = ge === void 0 ? 1 : ge, we = E.loop, We = we === void 0 || we, ie = E.disableMouseZoom, ve = ie !== void 0 && ie, _e = E.downloadable, Ie = _e !== void 0 && _e, Pe = E.noImgDetails, Qe = Pe !== void 0 && Pe, et = E.noToolbar, _t = et !== void 0 && et, tr = E.showTotal, St = tr === void 0 || tr, $t = E.minScale, dn = $t === void 0 ? 0.1 : $t, mt = { visible: !1, visibleStart: !1, transitionEnd: !1, activeIndex: E.activeIndex, width: 0, height: 0, top: 15, left: null, rotate: 0, imageWidth: 0, imageHeight: 0, scaleX: be, scaleY: be, loading: !1, loadFailed: !1, startLoading: !1 };
        function Bn() {
          var Oe = window.innerWidth, Ze = window.innerHeight;
          return E.container && (Oe = E.container.offsetWidth, Ze = E.container.offsetHeight), { width: Oe, height: Ze };
        }
        var Dt = s.useRef(Bn()), Pt = 84, Ei = s.useRef(null), Fn = s.useRef(!1), Wa = s.useRef(0), qo = y(s.useReducer(function(Oe, Ze) {
          switch (Ze.type) {
            case A.setVisible:
              return x(x({}, Oe), { visible: Ze.payload.visible });
            case A.setActiveIndex:
              return x(x({}, Oe), { activeIndex: Ze.payload.index, startLoading: !0 });
            case A.update:
              return x(x({}, Oe), Ze.payload);
            case A.clear:
              return x(x({}, Oe), { width: 0, height: 0, scaleX: be, scaleY: be, rotate: 1, imageWidth: 0, imageHeight: 0, loadFailed: !1, top: 0, left: 0, loading: !1 });
          }
          return Oe;
        }, mt), 2), Be = qo[0], nn = qo[1];
        function Ha(Oe) {
          var Ze = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
          nn(w(A.update, { loading: !0, loadFailed: !1 }));
          var At = null;
          L.length > 0 && (At = L[Oe]);
          var Yt = !1, Qt = new Image();
          function Yn(ec, Va, Jo) {
            if (Oe === Wa.current) {
              var ia = ec, aa = Va;
              E.defaultSize && (ia = E.defaultSize.width, aa = E.defaultSize.height), At.defaultSize && (ia = At.defaultSize.width, aa = At.defaultSize.height);
              var Nr = y(Jl(ia, aa), 2), Or = Nr[0], Ko = Nr[1], tc = (Dt.current.width - Or) / 2, nc = (Dt.current.height - Ko - Pt) / 2, oa = be, sa = be;
              le && !Ze && (oa = Be.scaleX, sa = Be.scaleY), nn(w(A.update, { width: Or, height: Ko, left: tc, top: nc, imageWidth: ec, imageHeight: Va, loading: !1, rotate: 0, scaleX: oa, scaleY: sa, loadFailed: !Jo, startLoading: !1 }));
            }
          }
          Qt.onload = function() {
            Fn.current && (Yt || Yn(Qt.width, Qt.height, !0));
          }, Qt.onerror = function() {
            Fn.current && (E.defaultImg ? (nn(w(A.update, { loading: !1, loadFailed: !0, startLoading: !1 })), Yn(E.defaultImg.width || 0.5 * Dt.current.width, E.defaultImg.height || 0.5 * Dt.current.height, !1)) : nn(w(A.update, { loading: !1, loadFailed: !1, startLoading: !1 })));
          }, Qt.src = At.src, Qt.complete && (Yt = !0, Yn(Qt.width, Qt.height, !0));
        }
        function Jl(Oe, Ze) {
          var At = 0, Yt = 0, Qt = 0.8 * Dt.current.width, Yn = 0.8 * (Dt.current.height - Pt);
          return (Yt = (At = Math.min(Qt, Oe)) / Oe * Ze) > Yn && (At = (Yt = Yn) / Ze * Oe), ae && (At = Oe, Yt = Ze), [At, Yt];
        }
        function na(Oe) {
          if ((We || !(Oe >= L.length || Oe < 0)) && (Oe >= L.length && (Oe = 0), Oe < 0 && (Oe = L.length - 1), Oe !== Be.activeIndex)) {
            if (E.onChange) {
              var Ze = Ua(Oe);
              E.onChange(Ze, Oe);
            }
            nn(w(A.setActiveIndex, { index: Oe }));
          }
        }
        function Ua() {
          var Oe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0, Ze = { src: "", alt: "", downloadUrl: "" }, At = null;
          return At = Oe !== void 0 ? Oe : Be.activeIndex, L.length > 0 && At >= 0 && (Ze = L[At]), Ze;
        }
        function Kl() {
          var Oe = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
          nn(w(A.update, { rotate: Be.rotate + 90 * (Oe ? 1 : -1) }));
        }
        function mr(Oe) {
          switch (Oe) {
            case u.prev:
              na(Be.activeIndex - 1);
              break;
            case u.next:
              na(Be.activeIndex + 1);
              break;
            case u.zoomIn:
              var Ze = Xo();
              ra(Ze.x, Ze.y, 1, de);
              break;
            case u.zoomOut:
              var At = Xo();
              ra(At.x, At.y, -1, de);
              break;
            case u.rotateLeft:
              Kl();
              break;
            case u.rotateRight:
              Kl(!0);
              break;
            case u.reset:
              Ha(Be.activeIndex, !0);
              break;
            case u.scaleX:
              Qt = -1, nn(w(A.update, { scaleX: Be.scaleX * Qt }));
              break;
            case u.scaleY:
              (function(Yn) {
                nn(w(A.update, { scaleY: Be.scaleY * Yn }));
              })(-1);
              break;
            case u.download:
              (Yt = Ua()).downloadUrl && (E.downloadInNewWindow ? window.open(Yt.downloadUrl, "_blank") : location.href = Yt.downloadUrl);
          }
          var Yt, Qt;
        }
        function Ga() {
          var Oe = "addEventListener";
          arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && (Oe = "removeEventListener"), me || document[Oe]("keydown", Zl, !0), Ei.current && Ei.current[Oe]("wheel", bd, !1);
        }
        function Zl(Oe) {
          var Ze = !1;
          switch (Oe.keyCode || Oe.which || Oe.charCode) {
            case 27:
              F(), Ze = !0;
              break;
            case 37:
              Oe.ctrlKey ? mr(u.rotateLeft) : mr(u.prev), Ze = !0;
              break;
            case 39:
              Oe.ctrlKey ? mr(u.rotateRight) : mr(u.next), Ze = !0;
              break;
            case 38:
              mr(u.zoomIn), Ze = !0;
              break;
            case 40:
              mr(u.zoomOut), Ze = !0;
              break;
            case 49:
              Oe.ctrlKey && (Ha(Be.activeIndex), Ze = !0);
          }
          Ze && (Oe.preventDefault(), Oe.stopPropagation());
        }
        function bd(Oe) {
          if (!ve && !Be.loading) {
            Oe.preventDefault();
            var Ze = 0, At = Oe.deltaY;
            if ((Ze = At === 0 ? 0 : At > 0 ? -1 : 1) != 0) {
              var Yt = Oe.clientX, Qt = Oe.clientY;
              if (E.container) {
                var Yn = E.container.getBoundingClientRect();
                Yt -= Yn.left, Qt -= Yn.top;
              }
              ra(Yt, Qt, Ze, de);
            }
          }
        }
        function Xo() {
          return { x: Be.left + Be.width / 2, y: Be.top + Be.height / 2 };
        }
        function ra(Oe, Ze, At, Yt) {
          var Qt = Xo(), Yn = Oe - Qt.x, ec = Ze - Qt.y, Va = 0, Jo = 0, ia = 0, aa = 0, Nr = 0, Or = 0;
          if (Be.width === 0) {
            var Ko = y(Jl(Be.imageWidth, Be.imageHeight), 2), tc = Ko[0], nc = Ko[1];
            Jo = (Dt.current.width - tc) / 2, Va = (Dt.current.height - Pt - nc) / 2, ia = Be.width + tc, aa = Be.height + nc, Nr = Or = 1;
          } else {
            var oa = Be.scaleX > 0 ? 1 : -1, sa = Be.scaleY > 0 ? 1 : -1;
            Nr = Be.scaleX + Yt * At * oa, Or = Be.scaleY + Yt * At * sa, E.maxScale !== void 0 && (Math.abs(Nr) > E.maxScale && (Nr = E.maxScale * oa), Math.abs(Or) > E.maxScale && (Or = E.maxScale * sa)), Math.abs(Nr) < dn && (Nr = dn * oa), Math.abs(Or) < dn && (Or = dn * sa), Va = Be.top + -At * ec / Be.scaleX * Yt * oa, Jo = Be.left + -At * Yn / Be.scaleY * Yt * sa, ia = Be.width, aa = Be.height;
          }
          nn(w(A.update, { width: ia, scaleX: Nr, scaleY: Or, height: aa, top: Va, left: Jo, loading: !1 }));
        }
        s.useEffect(function() {
          return Fn.current = !0, function() {
            Fn.current = !1;
          };
        }, []), s.useEffect(function() {
          Dt.current = Bn();
        }, [E.container]), s.useEffect(function() {
          D && Fn.current && nn(w(A.setVisible, { visible: !0 }));
        }, [D]), s.useEffect(function() {
          return Ga(), function() {
            Ga(!0);
          };
        }), s.useEffect(function() {
          return D ? E.container || (document.body.style.overflow = "hidden", document.body.scrollHeight > document.body.clientHeight && (document.body.style.paddingRight = "15px")) : nn(w(A.clear, {})), function() {
            document.body.style.overflow = "", document.body.style.paddingRight = "";
          };
        }, [Be.visible]), s.useEffect(function() {
          D && nn(w(A.setActiveIndex, { index: j }));
        }, [j, D, L]), s.useEffect(function() {
          Be.startLoading && (Wa.current = Be.activeIndex, Ha(Be.activeIndex));
        }, [Be.startLoading, Be.activeIndex]);
        var $n = "react-viewer", rt = f()("".concat($n), "".concat($n, "-transition"), (k(C = {}, "".concat($n, "-inline"), E.container), k(C, E.className, E.className), C)), sn = { opacity: D && Be.visible ? 1 : 0, display: D || Be.visible ? "block" : "none" }, ki = { src: "", alt: "" };
        return D && Be.visible && !Be.loading && Be.activeIndex !== null && !Be.startLoading && (ki = Ua()), s.createElement("div", { className: rt, style: sn, onTransitionEnd: function() {
          D || nn(w(A.setVisible, { visible: !1 }));
        }, ref: Ei }, s.createElement("div", { className: "".concat($n, "-mask"), style: { zIndex: N } }), E.noClose || s.createElement("div", { className: "".concat($n, "-close ").concat($n, "-btn"), onClick: function() {
          F();
        }, style: { zIndex: N + 10 } }, s.createElement(v, { type: u.close })), s.createElement(m, { prefixCls: $n, imgSrc: Be.loadFailed && E.defaultImg.src || ki.src, visible: D, width: Be.width, height: Be.height, top: Be.top, left: Be.left, rotate: Be.rotate, onChangeImgState: function(Oe, Ze, At, Yt) {
          nn(w(A.update, { width: Oe, height: Ze, top: At, left: Yt }));
        }, onResize: function() {
          if (Dt.current = Bn(), D) {
            var Oe = (Dt.current.width - Be.width) / 2, Ze = (Dt.current.height - Be.height - Pt) / 2;
            nn(w(A.update, { left: Oe, top: Ze }));
          }
        }, zIndex: N + 5, scaleX: Be.scaleX, scaleY: Be.scaleY, loading: Be.loading, drag: G, container: E.container, onCanvasMouseDown: function(Oe) {
          se(Oe);
        } }), E.noFooter || s.createElement("div", { className: "".concat($n, "-footer"), style: { zIndex: N + 5 } }, _t || s.createElement(M, { prefixCls: $n, onAction: function(Oe) {
          if (mr(Oe.actionType), Oe.onClick) {
            var Ze = Ua();
            Oe.onClick(Ze);
          }
        }, alt: ki.alt, width: Be.imageWidth, height: Be.imageHeight, attribute: $, zoomable: V, rotatable: K, scalable: ee, changeable: re, downloadable: Ie, noImgDetails: Qe, toolbars: Re(_), activeIndex: Be.activeIndex, count: L.length, showTotal: St }), E.noNavbar || s.createElement(g, { prefixCls: $n, images: E.images, activeIndex: Be.activeIndex, onChangeImg: na })));
      };
      function P(E, C) {
        return function(T) {
          if (Array.isArray(T)) return T;
        }(E) || function(T, D) {
          if (Symbol.iterator in Object(T) || Object.prototype.toString.call(T) === "[object Arguments]") {
            var z = [], F = !0, W = !1, L = void 0;
            try {
              for (var S, j = T[Symbol.iterator](); !(F = (S = j.next()).done) && (z.push(S.value), !D || z.length !== D); F = !0) ;
            } catch (Y) {
              W = !0, L = Y;
            } finally {
              try {
                F || j.return == null || j.return();
              } finally {
                if (W) throw L;
              }
            }
            return z;
          }
        }(E, C) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      a.default = function(E) {
        var C = s.useRef(typeof document < "u" ? document.createElement("div") : null), T = P(s.useState(E.container), 2), D = T[0], z = T[1], F = P(s.useState(!1), 2), W = F[0], L = F[1];
        return s.useEffect(function() {
          document.body.appendChild(C.current);
        }, []), s.useEffect(function() {
          E.visible && !W && L(!0);
        }, [E.visible, W]), s.useEffect(function() {
          E.container ? z(E.container) : z(C.current);
        }, [E.container]), W ? c.createPortal(s.createElement(O, E), D) : null;
      };
    }]);
  });
})(UA);
var mT = UA.exports;
const gT = /* @__PURE__ */ vf(mT), yT = te.div`
  height: 100%;

  .react-viewer-image {
    border: ${({ theme: e }) => {
  var t;
  return `1px solid ${(t = e.palette) == null ? void 0 : t.secondary.main}`;
}};
  }
  .react-viewer-mask {
    background-color: #fff;
  }
`, xT = (e) => {
  const { data: t, height: n = 500 } = e, r = qt(null), [i, a] = Se(!1), o = Ee(() => `data:image;base64,${t}`, [t]);
  return He(() => {
    r.current && a(!0);
  }, [r.current]), /* @__PURE__ */ p(yT, { ref: r, children: i && /* @__PURE__ */ p(
    gT,
    {
      attribute: !1,
      visible: !0,
      container: r.current,
      images: [{ src: o }],
      noNavbar: !0,
      noClose: !0,
      customToolbar: (s) => s.filter((c) => ![3, 4, 7, 11].includes(c.actionType))
    }
  ) });
}, vT = te.div`
  //background: .;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 40px;
  top: 80px;
`, AT = te.div`
  padding: 6px 0;
  color: ${({ theme: e }) => e.palette.primary.main};
`, py = te.div`
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  :not(:last-of-type) {
    margin-right: 5px;
  }
  &:hover {
    opacity: 1;
    background-color: ${(e) => {
  var t;
  return Un(0.9, (t = e.theme.palette) == null ? void 0 : t.secondary.main);
}};
  }
  ${({ disabled: e, theme: t }) => {
  var n;
  return e && `
    .icon {
      color: ${(n = t.palette) == null ? void 0 : n.grey[400]}
    }
    &:hover {
      cursor: default;
      background-color: transparent;
    }
  `;
}}
`, bT = (e) => {
  const { scale: n, onChange: r } = e, i = (o) => {
    o.preventDefault();
    const s = n + 0.1;
    r(s);
  }, a = (o) => {
    const s = n - 0.1;
    s > 0.1 && r(s);
  };
  return /* @__PURE__ */ B(vT, { children: [
    /* @__PURE__ */ p(py, { onClick: i, children: /* @__PURE__ */ p(pe, { iconName: "zoomIn", color: "primary" }) }),
    /* @__PURE__ */ B(AT, { children: [
      parseInt(String(n * 100), 10),
      "%"
    ] }),
    /* @__PURE__ */ p(py, { onClick: a, children: /* @__PURE__ */ p(pe, { iconName: "zoomOut", color: "primary" }) })
  ] });
}, wT = te.div`
  position: relative;
  overflow: ${(e) => e.scroll ? "auto" : "hidden"};
  .react-pdf__Page__textContent,
  .react-pdf__Page__annotations {
    display: none;
  }
  .react-pdf__Page {
    display: flex;
    justify-content: space-around;
    background-color: transparent !important;
    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  }
  .react-pdf__Page__canvas {
    border-radius: 4px;
    box-shadow: ${({ theme: e }) => e.customShadows[3]};
    border: 1px solid
      ${({ theme: e }) => e.palette.borderColor.main};
  }
`, _T = te.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  align-content: center;
  text-transform: uppercase;
  font-weight: bold;
  height: 100%;
`, ST = te.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px 0;
`;
vE.GlobalWorkerOptions.workerSrc = "/assets/scripts/pdf.worker.min.mjs";
const GA = en((e) => {
  const { data: t, height: n = 500, linkDownload: r, scaleDefault: i, scroll: a } = e, [o, s] = Se(1), [c, l] = Se(i || 1);
  return /* @__PURE__ */ B(wT, { height: n, scroll: a, children: [
    /* @__PURE__ */ p(
      bE,
      {
        onLoadSuccess: (d) => {
          s(d.numPages);
        },
        file: r || `/api/documents/${t.id}/preview`,
        loading: /* @__PURE__ */ p(ST, { children: /* @__PURE__ */ p(yt, {}) }),
        children: Array.from({ length: o }).map((d, f) => /* @__PURE__ */ p(
          AE,
          {
            pageNumber: f + 1,
            scale: c,
            loading: ""
          },
          `page_${f + 1}`
        ))
      }
    ),
    /* @__PURE__ */ p(bT, { scale: c, onChange: l })
  ] });
}), kV = (e) => {
  const {
    data: t,
    height: n = 500,
    downloadMethod: r,
    remoteFile: i = !0,
    pdfLink: a
  } = e;
  if (!t.mediaType)
    return null;
  switch (t.mediaType) {
    case Zo.CODE:
      return /* @__PURE__ */ p(
        Nl,
        {
          data: t,
          height: n,
          containerStyles: { padding: 0 },
          enableDownload: !1,
          enableCopy: !0,
          remoteFile: i,
          downloadMethod: r,
          language: t.codeLanguage
        }
      );
    case Zo.CSV:
      return /* @__PURE__ */ p(
        HA,
        {
          data: t,
          height: n,
          downloadMethod: r
        }
      );
    case Zo.PDF:
      return /* @__PURE__ */ p(GA, { data: t, height: n, linkDownload: a });
    case Zo.IMAGE:
      return /* @__PURE__ */ p(xT, { data: t, height: n });
    case Zo.ARCHIVE:
    default:
      return /* @__PURE__ */ p(_T, { children: "Content of this file cannot be displayed" });
  }
}, CT = te.div`
  display: inline-flex;
  align-items: center;
  font-size: ${({ isHeader: e }) => e ? "24px" : "13px"};
  max-width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme: e }) => e.palette.textColor.primary};
  font-weight: ${({ isHeader: e }) => e ? 300 : 600};
`;
te(pe)`
  color: ${({ color: e }) => e};
  margin-right: 8px;
`;
const my = te.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
function ET(e) {
  const { id: t, published: n, name: r } = e, { name: i } = kT(e.dataNode);
  return {
    healthStatusTitle: MT(ur.GREEN),
    healthStatusColor: TT(ur.GREEN),
    id: t,
    tooltip: `${i}: ${r}`,
    name: `${r}`,
    published: n
  };
}
function kT(e) {
  const {
    id: t,
    name: n,
    /* healthStatus, */
    published: r
  } = e;
  return {
    // healthStatusTitle: getHealthStatusTitle(healthStatus),
    // healthStatusColor: getHealthStatusIconColor(healthStatus),
    id: t,
    name: n || "Not published",
    published: r
  };
}
function TT(e) {
  const { palette: t } = kr();
  switch (e) {
    case ur.GREEN:
      return t.success.main;
    case ur.RED:
    case ur.NOT_CONNECTED:
      return t.error.main;
    case ur.NOT_COLLECTED:
    case ur.AMBER:
      return t.warning.main;
    default:
      return t.grey[400];
  }
}
function MT(e) {
  switch (e) {
    case ur.GREEN:
      return "Online";
    case ur.RED:
    case ur.NOT_CONNECTED:
      return "Disconnected";
    case ur.NOT_COLLECTED:
      return "Not enough statistics";
    case ur.AMBER:
      return "Unstable";
    default:
      return "";
  }
}
const VA = en((e) => {
  const { dataSource: t, withTooltip: n = !0, isHeader: r } = e, { healthStatusTitle: i, healthStatusColor: a, name: o, tooltip: s } = ET(t);
  return /* @__PURE__ */ B(CT, { isHeader: r, children: [
    /* @__PURE__ */ p(pt, { text: i, width: "auto", color: "primary", children: /* @__PURE__ */ p(
      he,
      {
        sx: {
          backgroundColor: a,
          width: 10,
          height: 10,
          minWidth: 10,
          mr: 1,
          borderRadius: "50%",
          boxShadow: "inset -4px -4px 10px rgba(255,255,255,.4)",
          cursor: "pointer",
          transition: "300ms",
          ":hover": {
            filter: "brightness(90%)"
          }
        }
      }
    ) }),
    n ? /* @__PURE__ */ p(pt, { text: s, color: "primary", width: 150, children: /* @__PURE__ */ p(my, { children: o }) }) : /* @__PURE__ */ p(my, { children: o })
  ] });
});
function IT(e) {
  const { palette: t } = Kr();
  switch (e) {
    case Sn.FAILED:
    case Sn.DISMISSED:
    case Sn.PROCESSING_RESULTS_FAILED:
      return t.error.main;
    case Sn.PENDING:
    case Sn.PREPARING:
    case Sn.INITIAL:
    case Sn.AWAITING_APPROVAL:
    case Sn.AWAITING_PUBLISHING_APPROVAL:
    case Sn.CANCELING:
      return t.warning.main;
    case Sn.PUBLISHED:
      return t.success.main;
    case Sn.QUEUED:
    case Sn.PREPARING:
    case Sn.IN_PROGRESS:
    case Sn.PROCESSING_RESULTS:
      return t.info.main;
    case Sn.CANCELLED:
      return t.grey[400];
    default:
      return t.grey[400];
  }
}
const NT = en((e) => {
  const { status: t } = e;
  if (!t) return null;
  const n = IT(t.value);
  return /* @__PURE__ */ p(xm, { color: n, text: t.title, light: !0, align: "center" });
}), TV = () => {
  var t;
  const e = Kr();
  return /* @__PURE__ */ p(he, { sx: { margin: "10px auto", width: "100%", maxWidth: "1400px" }, children: /* @__PURE__ */ p(R, { container: !0, spacing: 1, direction: "column", children: /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
    ai,
    {
      animation: "wave",
      height: 300,
      width: "100%",
      sx: { bgcolor: Un(0.7, (t = e.palette) == null ? void 0 : t.secondary.main) }
    }
  ) }) }) });
}, MV = () => {
  var t, n, r, i, a, o;
  const e = Kr();
  return /* @__PURE__ */ p(he, { sx: { margin: "10px auto", width: "100%" }, children: /* @__PURE__ */ B(R, { container: !0, spacing: 2, direction: "row", flexWrap: "wrap", children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 3, children: /* @__PURE__ */ p(
      ai,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Un(0.7, (t = e.palette) == null ? void 0 : t.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 9, children: /* @__PURE__ */ p(
      ai,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Un(0.7, (n = e.palette) == null ? void 0 : n.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 3, children: /* @__PURE__ */ p(
      ai,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Un(0.7, (r = e.palette) == null ? void 0 : r.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 9, children: /* @__PURE__ */ p(
      ai,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Un(0.7, (i = e.palette) == null ? void 0 : i.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 2, children: /* @__PURE__ */ p(
      ai,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Un(0.7, (a = e.palette) == null ? void 0 : a.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 2, children: /* @__PURE__ */ p(
      ai,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Un(0.7, (o = e.palette) == null ? void 0 : o.secondary.main)
        }
      }
    ) })
  ] }) });
};
var Wh = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Sd, gy;
function OT() {
  if (gy) return Sd;
  gy = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Sd = i() ? Object.assign : function(a, o) {
    for (var s, c = r(a), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (c[d] = s[d]);
      if (e) {
        l = e(s);
        for (var f = 0; f < l.length; f++)
          n.call(s, l[f]) && (c[l[f]] = s[l[f]]);
      }
    }
    return c;
  }, Sd;
}
var Cd, yy;
function km() {
  if (yy) return Cd;
  yy = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Cd = e, Cd;
}
var Ed, xy;
function QA() {
  return xy || (xy = 1, Ed = Function.call.bind(Object.prototype.hasOwnProperty)), Ed;
}
var kd, vy;
function RT() {
  if (vy) return kd;
  vy = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = km(), n = {}, r = QA();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in a)
        if (r(a, u)) {
          var d;
          try {
            if (typeof a[u] != "function") {
              var f = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = a[u](o, u, c, s, null, t);
          } catch (m) {
            d = m;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, kd = i, kd;
}
var Td, Ay;
function DT() {
  if (Ay) return Td;
  Ay = 1;
  var e = Cm, t = OT(), n = km(), r = QA(), i = RT(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Td = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(S) {
      var j = S && (l && S[l] || S[u]);
      if (typeof j == "function")
        return j;
    }
    var f = "<<anonymous>>", h = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: I(),
      arrayOf: M,
      element: k(),
      elementType: y(),
      instanceOf: x,
      node: O(),
      objectOf: A,
      oneOf: b,
      oneOfType: w,
      shape: E,
      exact: C
    };
    function m(S, j) {
      return S === j ? S !== 0 || 1 / S === 1 / j : S !== S && j !== j;
    }
    function g(S, j) {
      this.message = S, this.data = j && typeof j == "object" ? j : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function v(S) {
      if (process.env.NODE_ENV !== "production")
        var j = {}, Y = 0;
      function N(G, q, $, Q, V, H, K) {
        if (Q = Q || f, H = H || $, K !== n) {
          if (c) {
            var U = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw U.name = "Invariant Violation", U;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ee = Q + ":" + $;
            !j[ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + H + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), j[ee] = !0, Y++);
          }
        }
        return q[$] == null ? G ? q[$] === null ? new g("The " + V + " `" + H + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new g("The " + V + " `" + H + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : S(q, $, Q, V, H);
      }
      var X = N.bind(null, !1);
      return X.isRequired = N.bind(null, !0), X;
    }
    function _(S) {
      function j(Y, N, X, G, q, $) {
        var Q = Y[N], V = z(Q);
        if (V !== S) {
          var H = F(Q);
          return new g(
            "Invalid " + G + " `" + q + "` of type " + ("`" + H + "` supplied to `" + X + "`, expected ") + ("`" + S + "`."),
            { expectedType: S }
          );
        }
        return null;
      }
      return v(j);
    }
    function I() {
      return v(o);
    }
    function M(S) {
      function j(Y, N, X, G, q) {
        if (typeof S != "function")
          return new g("Property `" + q + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var $ = Y[N];
        if (!Array.isArray($)) {
          var Q = z($);
          return new g("Invalid " + G + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + X + "`, expected an array."));
        }
        for (var V = 0; V < $.length; V++) {
          var H = S($, V, X, G, q + "[" + V + "]", n);
          if (H instanceof Error)
            return H;
        }
        return null;
      }
      return v(j);
    }
    function k() {
      function S(j, Y, N, X, G) {
        var q = j[Y];
        if (!s(q)) {
          var $ = z(q);
          return new g("Invalid " + X + " `" + G + "` of type " + ("`" + $ + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(S);
    }
    function y() {
      function S(j, Y, N, X, G) {
        var q = j[Y];
        if (!e.isValidElementType(q)) {
          var $ = z(q);
          return new g("Invalid " + X + " `" + G + "` of type " + ("`" + $ + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(S);
    }
    function x(S) {
      function j(Y, N, X, G, q) {
        if (!(Y[N] instanceof S)) {
          var $ = S.name || f, Q = L(Y[N]);
          return new g("Invalid " + G + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + X + "`, expected ") + ("instance of `" + $ + "`."));
        }
        return null;
      }
      return v(j);
    }
    function b(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function j(Y, N, X, G, q) {
        for (var $ = Y[N], Q = 0; Q < S.length; Q++)
          if (m($, S[Q]))
            return null;
        var V = JSON.stringify(S, function(K, U) {
          var ee = F(U);
          return ee === "symbol" ? String(U) : U;
        });
        return new g("Invalid " + G + " `" + q + "` of value `" + String($) + "` " + ("supplied to `" + X + "`, expected one of " + V + "."));
      }
      return v(j);
    }
    function A(S) {
      function j(Y, N, X, G, q) {
        if (typeof S != "function")
          return new g("Property `" + q + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var $ = Y[N], Q = z($);
        if (Q !== "object")
          return new g("Invalid " + G + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + X + "`, expected an object."));
        for (var V in $)
          if (r($, V)) {
            var H = S($, V, X, G, q + "." + V, n);
            if (H instanceof Error)
              return H;
          }
        return null;
      }
      return v(j);
    }
    function w(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var j = 0; j < S.length; j++) {
        var Y = S[j];
        if (typeof Y != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(Y) + " at index " + j + "."
          ), o;
      }
      function N(X, G, q, $, Q) {
        for (var V = [], H = 0; H < S.length; H++) {
          var K = S[H], U = K(X, G, q, $, Q, n);
          if (U == null)
            return null;
          U.data && r(U.data, "expectedType") && V.push(U.data.expectedType);
        }
        var ee = V.length > 0 ? ", expected one of type [" + V.join(", ") + "]" : "";
        return new g("Invalid " + $ + " `" + Q + "` supplied to " + ("`" + q + "`" + ee + "."));
      }
      return v(N);
    }
    function O() {
      function S(j, Y, N, X, G) {
        return T(j[Y]) ? null : new g("Invalid " + X + " `" + G + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return v(S);
    }
    function P(S, j, Y, N, X) {
      return new g(
        (S || "React class") + ": " + j + " type `" + Y + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function E(S) {
      function j(Y, N, X, G, q) {
        var $ = Y[N], Q = z($);
        if (Q !== "object")
          return new g("Invalid " + G + " `" + q + "` of type `" + Q + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var V in S) {
          var H = S[V];
          if (typeof H != "function")
            return P(X, G, q, V, F(H));
          var K = H($, V, X, G, q + "." + V, n);
          if (K)
            return K;
        }
        return null;
      }
      return v(j);
    }
    function C(S) {
      function j(Y, N, X, G, q) {
        var $ = Y[N], Q = z($);
        if (Q !== "object")
          return new g("Invalid " + G + " `" + q + "` of type `" + Q + "` " + ("supplied to `" + X + "`, expected `object`."));
        var V = t({}, Y[N], S);
        for (var H in V) {
          var K = S[H];
          if (r(S, H) && typeof K != "function")
            return P(X, G, q, H, F(K));
          if (!K)
            return new g(
              "Invalid " + G + " `" + q + "` key `" + H + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(Y[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(S), null, "  ")
            );
          var U = K($, H, X, G, q + "." + H, n);
          if (U)
            return U;
        }
        return null;
      }
      return v(j);
    }
    function T(S) {
      switch (typeof S) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !S;
        case "object":
          if (Array.isArray(S))
            return S.every(T);
          if (S === null || s(S))
            return !0;
          var j = d(S);
          if (j) {
            var Y = j.call(S), N;
            if (j !== S.entries) {
              for (; !(N = Y.next()).done; )
                if (!T(N.value))
                  return !1;
            } else
              for (; !(N = Y.next()).done; ) {
                var X = N.value;
                if (X && !T(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(S, j) {
      return S === "symbol" ? !0 : j ? j["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && j instanceof Symbol : !1;
    }
    function z(S) {
      var j = typeof S;
      return Array.isArray(S) ? "array" : S instanceof RegExp ? "object" : D(j, S) ? "symbol" : j;
    }
    function F(S) {
      if (typeof S > "u" || S === null)
        return "" + S;
      var j = z(S);
      if (j === "object") {
        if (S instanceof Date)
          return "date";
        if (S instanceof RegExp)
          return "regexp";
      }
      return j;
    }
    function W(S) {
      var j = F(S);
      switch (j) {
        case "array":
        case "object":
          return "an " + j;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + j;
        default:
          return j;
      }
    }
    function L(S) {
      return !S.constructor || !S.constructor.name ? f : S.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, Td;
}
var Md, by;
function PT() {
  if (by) return Md;
  by = 1;
  var e = km();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Md = function() {
    function r(o, s, c, l, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Md;
}
if (process.env.NODE_ENV !== "production") {
  var LT = Cm, zT = !0;
  Wh.exports = DT()(LT.isElement, zT);
} else
  Wh.exports = PT()();
var BT = Wh.exports;
const bt = /* @__PURE__ */ vf(BT);
function Fo(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      u.done ? a(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, [])).next());
  });
}
function $o(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, l[0] && (n = 0)), n; ) try {
      if (r = 1, i && (a = l[0] & 2 ? i.return : l[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, l[1])).done) return a;
      switch (i = 0, a && (l = [l[0] & 2, a.value]), l[0]) {
        case 0:
        case 1:
          a = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, i = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!a || l[1] > a[0] && l[1] < a[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = l;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(l);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = t.call(e, n);
    } catch (u) {
      l = [6, u], i = 0;
    } finally {
      r = a = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function wy(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) a.push(i.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}
function _y(e, t, n) {
  if (arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var FT = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Ol(e, t) {
  var n = $T(e);
  if (typeof n.path != "string") {
    var r = e.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: typeof t == "string" ? t : typeof r == "string" && r.length > 0 ? r : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return n;
}
function $T(e) {
  var t = e.name, n = t && t.lastIndexOf(".") !== -1;
  if (n && !e.type) {
    var r = t.split(".").pop().toLowerCase(), i = FT.get(r);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var YT = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function jT(e) {
  return Fo(this, void 0, void 0, function() {
    return $o(this, function(t) {
      return uu(e) && WT(e.dataTransfer) ? [2, VT(e.dataTransfer, e.type)] : HT(e) ? [2, UT(e)] : Array.isArray(e) && e.every(function(n) {
        return "getFile" in n && typeof n.getFile == "function";
      }) ? [2, GT(e)] : [2, []];
    });
  });
}
function WT(e) {
  return uu(e);
}
function HT(e) {
  return uu(e) && uu(e.target);
}
function uu(e) {
  return typeof e == "object" && e !== null;
}
function UT(e) {
  return Hh(e.target.files).map(function(t) {
    return Ol(t);
  });
}
function GT(e) {
  return Fo(this, void 0, void 0, function() {
    var t;
    return $o(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all(e.map(function(r) {
            return r.getFile();
          }))];
        case 1:
          return t = n.sent(), [2, t.map(function(r) {
            return Ol(r);
          })];
      }
    });
  });
}
function VT(e, t) {
  return Fo(this, void 0, void 0, function() {
    var n, r;
    return $o(this, function(i) {
      switch (i.label) {
        case 0:
          return e.items ? (n = Hh(e.items).filter(function(a) {
            return a.kind === "file";
          }), t !== "drop" ? [2, n] : [4, Promise.all(n.map(QT))]) : [3, 2];
        case 1:
          return r = i.sent(), [2, Sy(qA(r))];
        case 2:
          return [2, Sy(Hh(e.files).map(function(a) {
            return Ol(a);
          }))];
      }
    });
  });
}
function Sy(e) {
  return e.filter(function(t) {
    return YT.indexOf(t.name) === -1;
  });
}
function Hh(e) {
  if (e === null)
    return [];
  for (var t = [], n = 0; n < e.length; n++) {
    var r = e[n];
    t.push(r);
  }
  return t;
}
function QT(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Cy(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? XA(t) : Cy(e);
}
function qA(e) {
  return e.reduce(function(t, n) {
    return _y(_y([], wy(t), !1), wy(Array.isArray(n) ? qA(n) : [n]), !1);
  }, []);
}
function Cy(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var n = Ol(t);
  return Promise.resolve(n);
}
function qT(e) {
  return Fo(this, void 0, void 0, function() {
    return $o(this, function(t) {
      return [2, e.isDirectory ? XA(e) : XT(e)];
    });
  });
}
function XA(e) {
  var t = e.createReader();
  return new Promise(function(n, r) {
    var i = [];
    function a() {
      var o = this;
      t.readEntries(function(s) {
        return Fo(o, void 0, void 0, function() {
          var c, l, u;
          return $o(this, function(d) {
            switch (d.label) {
              case 0:
                if (s.length) return [3, 5];
                d.label = 1;
              case 1:
                return d.trys.push([1, 3, , 4]), [4, Promise.all(i)];
              case 2:
                return c = d.sent(), n(c), [3, 4];
              case 3:
                return l = d.sent(), r(l), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                u = Promise.all(s.map(qT)), i.push(u), a(), d.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(s) {
        r(s);
      });
    }
    a();
  });
}
function XT(e) {
  return Fo(this, void 0, void 0, function() {
    return $o(this, function(t) {
      return [2, new Promise(function(n, r) {
        e.file(function(i) {
          var a = Ol(i, e.fullPath);
          n(a);
        }, function(i) {
          r(i);
        });
      })];
    });
  });
}
var Id = function(e, t) {
  if (e && t) {
    var n = Array.isArray(t) ? t : t.split(",");
    if (n.length === 0)
      return !0;
    var r = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
    return n.some(function(o) {
      var s = o.trim().toLowerCase();
      return s.charAt(0) === "." ? r.toLowerCase().endsWith(s) : s.endsWith("/*") ? a === s.replace(/\/.*$/, "") : i === s;
    });
  }
  return !0;
};
function Ey(e) {
  return ZT(e) || KT(e) || KA(e) || JT();
}
function JT() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function KT(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ZT(e) {
  if (Array.isArray(e)) return Uh(e);
}
function ky(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ty(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ky(Object(n), !0).forEach(function(r) {
      JA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ky(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function JA(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Zs(e, t) {
  return nM(e) || tM(e, t) || KA(e, t) || eM();
}
function eM() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function KA(e, t) {
  if (e) {
    if (typeof e == "string") return Uh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Uh(e, t);
  }
}
function Uh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function tM(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0)
        ;
    } catch (c) {
      a = !0, s = c;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function nM(e) {
  if (Array.isArray(e)) return e;
}
var rM = typeof Id == "function" ? Id : Id.default, iM = "file-invalid-type", aM = "file-too-large", oM = "file-too-small", sM = "too-many-files", lM = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var n = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: iM,
    message: "File type must be ".concat(n)
  };
}, My = function(t) {
  return {
    code: aM,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Iy = function(t) {
  return {
    code: oM,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, cM = {
  code: sM,
  message: "Too many files"
};
function ZA(e, t) {
  var n = e.type === "application/x-moz-file" || rM(e, t);
  return [n, n ? null : lM(t)];
}
function eb(e, t, n) {
  if (pa(e.size))
    if (pa(t) && pa(n)) {
      if (e.size > n) return [!1, My(n)];
      if (e.size < t) return [!1, Iy(t)];
    } else {
      if (pa(t) && e.size < t) return [!1, Iy(t)];
      if (pa(n) && e.size > n) return [!1, My(n)];
    }
  return [!0, null];
}
function pa(e) {
  return e != null;
}
function uM(e) {
  var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, a = e.multiple, o = e.maxFiles, s = e.validator;
  return !a && t.length > 1 || a && o >= 1 && t.length > o ? !1 : t.every(function(c) {
    var l = ZA(c, n), u = Zs(l, 1), d = u[0], f = eb(c, r, i), h = Zs(f, 1), m = h[0], g = s ? s(c) : null;
    return d && m && !g;
  });
}
function fu(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function ac(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function Ny(e) {
  e.preventDefault();
}
function fM(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function dM(e) {
  return e.indexOf("Edge/") !== -1;
}
function hM() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return fM(e) || dM(e);
}
function Rr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)
      a[o - 1] = arguments[o];
    return t.some(function(s) {
      return !fu(r) && s && s.apply(void 0, [r].concat(a)), fu(r);
    });
  };
}
function pM() {
  return "showOpenFilePicker" in window;
}
function mM(e) {
  if (pa(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Zs(n, 2), i = r[0], a = r[1], o = !0;
      return tb(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), o = !1), (!Array.isArray(a) || !a.every(nb)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), o = !1), o;
    }).reduce(function(n, r) {
      var i = Zs(r, 2), a = i[0], o = i[1];
      return Ty(Ty({}, n), {}, JA({}, a, o));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function gM(e) {
  if (pa(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Zs(n, 2), i = r[0], a = r[1];
      return [].concat(Ey(t), [i], Ey(a));
    }, []).filter(function(t) {
      return tb(t) || nb(t);
    }).join(",");
}
function yM(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function xM(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function tb(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function nb(e) {
  return /^.*\.[\w]+$/.test(e);
}
var vM = ["children"], AM = ["open"], bM = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], wM = ["refKey", "onChange", "onClick"];
function _M(e) {
  return EM(e) || CM(e) || rb(e) || SM();
}
function SM() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function CM(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function EM(e) {
  if (Array.isArray(e)) return Gh(e);
}
function Nd(e, t) {
  return MM(e) || TM(e, t) || rb(e, t) || kM();
}
function kM() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rb(e, t) {
  if (e) {
    if (typeof e == "string") return Gh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gh(e, t);
  }
}
function Gh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function TM(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0)
        ;
    } catch (c) {
      a = !0, s = c;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function MM(e) {
  if (Array.isArray(e)) return e;
}
function Oy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Oy(Object(n), !0).forEach(function(r) {
      Vh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Oy(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Vh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function du(e, t) {
  if (e == null) return {};
  var n = IM(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function IM(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Tm = /* @__PURE__ */ pm(function(e, t) {
  var n = e.children, r = du(e, vM), i = ab(r), a = i.open, o = du(i, AM);
  return CC(t, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ Xe.createElement(EC, null, n(Lt(Lt({}, o), {}, {
    open: a
  })));
});
Tm.displayName = "Dropzone";
var ib = {
  disabled: !1,
  getFilesFromEvent: jT,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Tm.defaultProps = ib;
Tm.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: bt.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: bt.objectOf(bt.arrayOf(bt.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: bt.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: bt.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: bt.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: bt.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: bt.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: bt.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: bt.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: bt.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: bt.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: bt.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: bt.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: bt.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: bt.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: bt.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: bt.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: bt.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: bt.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: bt.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: bt.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: bt.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: bt.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: bt.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: bt.func
};
var Qh = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function ab() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Lt(Lt({}, ib), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, o = t.minSize, s = t.multiple, c = t.maxFiles, l = t.onDragEnter, u = t.onDragLeave, d = t.onDragOver, f = t.onDrop, h = t.onDropAccepted, m = t.onDropRejected, g = t.onFileDialogCancel, v = t.onFileDialogOpen, _ = t.useFsAccessApi, I = t.autoFocus, M = t.preventDropOnDocument, k = t.noClick, y = t.noKeyboard, x = t.noDrag, b = t.noDragEventsBubbling, A = t.onError, w = t.validator, O = Ee(function() {
    return gM(n);
  }, [n]), P = Ee(function() {
    return mM(n);
  }, [n]), E = Ee(function() {
    return typeof v == "function" ? v : Ry;
  }, [v]), C = Ee(function() {
    return typeof g == "function" ? g : Ry;
  }, [g]), T = qt(null), D = qt(null), z = qv(NM, Qh), F = Nd(z, 2), W = F[0], L = F[1], S = W.isFocused, j = W.isFileDialogActive, Y = qt(typeof window < "u" && window.isSecureContext && _ && pM()), N = function() {
    !Y.current && j && setTimeout(function() {
      if (D.current) {
        var le = D.current.files;
        le.length || (L({
          type: "closeDialog"
        }), C());
      }
    }, 300);
  };
  He(function() {
    return window.addEventListener("focus", N, !1), function() {
      window.removeEventListener("focus", N, !1);
    };
  }, [D, j, C, Y]);
  var X = qt([]), G = function(le) {
    T.current && T.current.contains(le.target) || (le.preventDefault(), X.current = []);
  };
  He(function() {
    return M && (document.addEventListener("dragover", Ny, !1), document.addEventListener("drop", G, !1)), function() {
      M && (document.removeEventListener("dragover", Ny), document.removeEventListener("drop", G));
    };
  }, [T, M]), He(function() {
    return !r && I && T.current && T.current.focus(), function() {
    };
  }, [T, I, r]);
  var q = Ge(function(Z) {
    A ? A(Z) : console.error(Z);
  }, [A]), $ = Ge(function(Z) {
    Z.preventDefault(), Z.persist(), oe(Z), X.current = [].concat(_M(X.current), [Z.target]), ac(Z) && Promise.resolve(i(Z)).then(function(le) {
      if (!(fu(Z) && !b)) {
        var J = le.length, ae = J > 0 && uM({
          files: le,
          accept: O,
          minSize: o,
          maxSize: a,
          multiple: s,
          maxFiles: c,
          validator: w
        }), ge = J > 0 && !ae;
        L({
          isDragAccept: ae,
          isDragReject: ge,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), l && l(Z);
      }
    }).catch(function(le) {
      return q(le);
    });
  }, [i, l, q, b, O, o, a, s, c, w]), Q = Ge(function(Z) {
    Z.preventDefault(), Z.persist(), oe(Z);
    var le = ac(Z);
    if (le && Z.dataTransfer)
      try {
        Z.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return le && d && d(Z), !1;
  }, [d, b]), V = Ge(function(Z) {
    Z.preventDefault(), Z.persist(), oe(Z);
    var le = X.current.filter(function(ae) {
      return T.current && T.current.contains(ae);
    }), J = le.indexOf(Z.target);
    J !== -1 && le.splice(J, 1), X.current = le, !(le.length > 0) && (L({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), ac(Z) && u && u(Z));
  }, [T, u, b]), H = Ge(function(Z, le) {
    var J = [], ae = [];
    Z.forEach(function(ge) {
      var be = ZA(ge, O), we = Nd(be, 2), We = we[0], ie = we[1], ve = eb(ge, o, a), _e = Nd(ve, 2), Ie = _e[0], Pe = _e[1], Qe = w ? w(ge) : null;
      if (We && Ie && !Qe)
        J.push(ge);
      else {
        var et = [ie, Pe];
        Qe && (et = et.concat(Qe)), ae.push({
          file: ge,
          errors: et.filter(function(_t) {
            return _t;
          })
        });
      }
    }), (!s && J.length > 1 || s && c >= 1 && J.length > c) && (J.forEach(function(ge) {
      ae.push({
        file: ge,
        errors: [cM]
      });
    }), J.splice(0)), L({
      acceptedFiles: J,
      fileRejections: ae,
      type: "setFiles"
    }), f && f(J, ae, le), ae.length > 0 && m && m(ae, le), J.length > 0 && h && h(J, le);
  }, [L, s, O, o, a, c, f, h, m, w]), K = Ge(function(Z) {
    Z.preventDefault(), Z.persist(), oe(Z), X.current = [], ac(Z) && Promise.resolve(i(Z)).then(function(le) {
      fu(Z) && !b || H(le, Z);
    }).catch(function(le) {
      return q(le);
    }), L({
      type: "reset"
    });
  }, [i, H, q, b]), U = Ge(function() {
    if (Y.current) {
      L({
        type: "openDialog"
      }), E();
      var Z = {
        multiple: s,
        types: P
      };
      window.showOpenFilePicker(Z).then(function(le) {
        return i(le);
      }).then(function(le) {
        H(le, null), L({
          type: "closeDialog"
        });
      }).catch(function(le) {
        yM(le) ? (C(le), L({
          type: "closeDialog"
        })) : xM(le) ? (Y.current = !1, D.current ? (D.current.value = null, D.current.click()) : q(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : q(le);
      });
      return;
    }
    D.current && (L({
      type: "openDialog"
    }), E(), D.current.value = null, D.current.click());
  }, [L, E, C, _, H, q, P, s]), ee = Ge(function(Z) {
    !T.current || !T.current.isEqualNode(Z.target) || (Z.key === " " || Z.key === "Enter" || Z.keyCode === 32 || Z.keyCode === 13) && (Z.preventDefault(), U());
  }, [T, U]), ce = Ge(function() {
    L({
      type: "focus"
    });
  }, []), se = Ge(function() {
    L({
      type: "blur"
    });
  }, []), ne = Ge(function() {
    k || (hM() ? setTimeout(U, 0) : U());
  }, [k, U]), re = function(le) {
    return r ? null : le;
  }, Me = function(le) {
    return y ? null : re(le);
  }, Re = function(le) {
    return x ? null : re(le);
  }, oe = function(le) {
    b && le.stopPropagation();
  }, de = Ee(function() {
    return function() {
      var Z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, le = Z.refKey, J = le === void 0 ? "ref" : le, ae = Z.role, ge = Z.onKeyDown, be = Z.onFocus, we = Z.onBlur, We = Z.onClick, ie = Z.onDragEnter, ve = Z.onDragOver, _e = Z.onDragLeave, Ie = Z.onDrop, Pe = du(Z, bM);
      return Lt(Lt(Vh({
        onKeyDown: Me(Rr(ge, ee)),
        onFocus: Me(Rr(be, ce)),
        onBlur: Me(Rr(we, se)),
        onClick: re(Rr(We, ne)),
        onDragEnter: Re(Rr(ie, $)),
        onDragOver: Re(Rr(ve, Q)),
        onDragLeave: Re(Rr(_e, V)),
        onDrop: Re(Rr(Ie, K)),
        role: typeof ae == "string" && ae !== "" ? ae : "presentation"
      }, J, T), !r && !y ? {
        tabIndex: 0
      } : {}), Pe);
    };
  }, [T, ee, ce, se, ne, $, Q, V, K, y, x, r]), ue = Ge(function(Z) {
    Z.stopPropagation();
  }, []), me = Ee(function() {
    return function() {
      var Z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, le = Z.refKey, J = le === void 0 ? "ref" : le, ae = Z.onChange, ge = Z.onClick, be = du(Z, wM), we = Vh({
        accept: O,
        multiple: s,
        type: "file",
        style: {
          display: "none"
        },
        onChange: re(Rr(ae, K)),
        onClick: re(Rr(ge, ue)),
        tabIndex: -1
      }, J, D);
      return Lt(Lt({}, we), be);
    };
  }, [D, n, s, K, r]);
  return Lt(Lt({}, W), {}, {
    isFocused: S && !r,
    getRootProps: de,
    getInputProps: me,
    rootRef: T,
    inputRef: D,
    open: re(U)
  });
}
function NM(e, t) {
  switch (t.type) {
    case "focus":
      return Lt(Lt({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Lt(Lt({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Lt(Lt({}, Qh), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Lt(Lt({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Lt(Lt({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Lt(Lt({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return Lt({}, Qh);
    default:
      return e;
  }
}
function Ry() {
}
const OM = te.div`
  margin: 16px;
  background: #fff;
  border: 1.5px dashed ${({ theme: e }) => e.palette.info.main + 60};
  border-radius: 2px;
  display: flex;
  color: ${({ theme: e }) => e.palette.grey[800]};
  align-items: center;
  justify-content: center;
  height: 150px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
`;
te.div`
  text-align: center;
  color: #8f8f8f;
  font-size: 12px;
  font-style: italic;
  margin-top: 0.5rem;
`;
const RM = te.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-weight: 400;
`, DM = te(qC)`
  height: 12px;
  border-radius: 2px;
  margin: 10px 0;
`, PM = te.span`
  font-weight: bold;
`, LM = (e) => {
  const { fileName: t, progress: n, fileNumber: r, amountFiles: i } = e;
  return /* @__PURE__ */ B(RM, { children: [
    /* @__PURE__ */ B("div", { children: [
      "Uploading file ",
      r,
      " of ",
      i,
      ":",
      " ",
      /* @__PURE__ */ p(PM, { children: t })
    ] }),
    /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(DM, { progress: n }) }),
    /* @__PURE__ */ B("div", { children: [
      n,
      " %"
    ] })
  ] });
};
function zM(e) {
  if (e)
    return e.reduce((t, n) => (t[n] = [], t), {});
}
const IV = (e) => {
  const {
    onDrop: t,
    onDropReject: n = () => {
    },
    acceptExt: r,
    freeUpload: i,
    textAvailableExt: a,
    maxSize: o = 50 * 1024 * 1024,
    placeholder: s = "filePlaceholder",
    uploadText: c
  } = e, [l, u] = Se(null), [d, f] = Se(null), h = async (k, y) => new Promise((x, b) => {
    const A = new FileReader();
    A.readAsArrayBuffer(k), A.onprogress = (w) => {
      if (w.lengthComputable) {
        const O = Math.round(w.loaded / w.total * 100);
        u({ ...y, progress: O });
      }
    }, A.onload = (w) => {
      u(null), x(w);
    }, A.onerror = (w) => {
      u(null), b(w);
    };
  }), m = Ge(async (k) => {
    f(k.length);
    for (let [y, x] of k.entries()) {
      const b = {
        fileName: x.name,
        progress: 0,
        fileNumber: y + 1
      };
      u(b), await h(x, b);
    }
    f(null), setTimeout(() => {
      t == null || t(k);
    }, 100);
  }, []), g = Ge((k) => {
    n == null || n(k);
  }, []), { getRootProps: v, getInputProps: _, isDragActive: I, isDragReject: M } = ab({
    onDrop: m,
    onDropRejected: g,
    accept: zM(
      i ? null : r || [
        "text/plain",
        "text/csv",
        "application/json",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ]
    ),
    maxSize: o
  });
  return /* @__PURE__ */ B(OM, { ...v(), className: "dropzone", children: [
    /* @__PURE__ */ p("input", { ..._() }),
    I ? /* @__PURE__ */ p("p", { children: "Drop the files here ..." }) : l ? /* @__PURE__ */ p(
      LM,
      {
        fileName: l.fileName,
        progress: l.progress,
        fileNumber: l.fileNumber,
        amountFiles: d
      }
    ) : /* @__PURE__ */ B("div", { children: [
      s && /* @__PURE__ */ p(he, { width: "100%", textAlign: "center", mb: 2, children: /* @__PURE__ */ p(
        XC,
        {
          name: s,
          sx: { fontSize: 46 }
        }
      ) }),
      /* @__PURE__ */ p(
        fe,
        {
          color: "textColor.label",
          fontSize: 14,
          fontWeight: 700,
          textAlign: "center",
          children: c || "Drag 'n' drop some files here, or click to select files"
        }
      ),
      /* @__PURE__ */ B(
        fe,
        {
          color: "textColor.label",
          fontSize: 14,
          fontWeight: 400,
          textAlign: "center",
          mt: 0.5,
          children: [
            /* @__PURE__ */ p("b", { children: "Formats: " }),
            a || "TXT, PDF, JSON, CSV, XLS/XLSX, DOC/DOCX, PPT/PPTX"
          ]
        }
      )
    ] })
  ] });
};
te.div`
  display: flex;
  background-color: #fff;
  flex-direction: column;
  margin-top: 16px;
  position: relative;

  .content-block__title {
    flex-grow: 1;
  }
`;
te.div`
  display: flex;
  font-weight: bold;
  flex-grow: 1;
`;
const BM = te.div`
  display: flex;
  background-color: ${({ theme: e }) => e.palette.info.main + 20};
  color: ${({ theme: e }) => e.palette.grey[800]};
  margin-left: 8px;
  padding: 0 6px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 20px;
  min-width: 8px;
  border-radius: 2px;
`;
te.div`
  display: flex;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  justify-content: space-between;
  margin: 0 16px;
`;
const Dy = te.div`
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  position: relative;
  max-width: 100%;
  align-items: center;
  font-size: 14px;
`;
te.div`
  min-width: 30px;
`;
const FM = te.div`
  /* display: flex;
  align-items: center; */
  text-align: center;
  flex-grow: 1;
  color: ${({ theme: e }) => e.palette.grey[400]};
  font-size: 14px;
  padding: 0;
`;
te.span`
  /* text-decoration: underline; */
  margin-left: -4px;
`;
te(
  Ra
)`
  padding-right: 0px;
  padding-left: 0px;
`;
const $M = te.span`
  margin-left: 8px;
`, YM = te.div`
  display: flex;
`, jM = (e) => {
  const {
    items: t = [],
    title: n,
    headerText: r = n,
    itemComponent: i,
    onRemove: a,
    primaryKey: o,
    emptyText: s = "There is no attachment",
    buttonText: c = "Delete all files",
    children: l
  } = e, u = t.length;
  Kr();
  const d = Ge(
    (h) => {
      h.stopPropagation(), t.forEach((m) => a(h, m));
    },
    [t]
  ), f = Ee(() => /* @__PURE__ */ B(YM, { children: [
    /* @__PURE__ */ p($M, { children: r }),
    /* @__PURE__ */ p(
      BM,
      {
        className: "items-cart__count-badge",
        count: u,
        children: u
      }
    )
  ] }), [r, u]);
  return /* @__PURE__ */ B(ze, { children: [
    /* @__PURE__ */ p(
      oA,
      {
        startIcon: /* @__PURE__ */ p(pe, { iconName: "uploadFiles", name: "Upload", fontSize: "small" }),
        title: f,
        children: /* @__PURE__ */ p(
          Te,
          {
            className: "items-cart__clear-btn",
            size: "small",
            variant: "text",
            onClick: d,
            disabled: !u,
            startIcon: /* @__PURE__ */ p(
              pe,
              {
                iconName: "delete",
                name: "Remove all",
                color: u ? "error" : void 0,
                sx: { fontSize: 16 }
              }
            ),
            children: c
          }
        )
      }
    ),
    l,
    u > 0 ? t.map((h, m) => /* @__PURE__ */ B(
      Dy,
      {
        className: "cart-item__container",
        children: [
          a && /* @__PURE__ */ p(
            Ks,
            {
              className: "cart-item__remove-btn",
              onClick: (g) => a(g, h),
              color: "error",
              children: /* @__PURE__ */ p(
                pe,
                {
                  iconName: "delete",
                  name: "Remove",
                  sx: { fontSize: "16px" }
                }
              )
            }
          ),
          i(h)
        ]
      },
      o ? h[o] : m
    )) : /* @__PURE__ */ p(Dy, { className: "cart-item__container", children: /* @__PURE__ */ p(FM, { children: s }) })
  ] });
}, NV = en(jM);
te.div`
  display: inline-flex;
  position: relative;
  overflow: hidden;
`;
te.div``;
const WM = te.div`
  display: flex;
  position: relative;
  overflow: hidden;
`, HM = te.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
`, UM = te.div`
  margin-left: 8px;
      overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  }
    
`, OV = en((e) => {
  const {
    file: t,
    onClick: n,
    disableIcon: r = !1,
    iconProps: i = {},
    containerProps: a = {},
    showMetaInfo: o = !1
  } = e, {
    size: s,
    iconName: c,
    className: l = ""
  } = i, { className: u, style: d = {} } = a;
  return Ee(() => (DC(t.name), c || "fileExt"), [t.name, c]), /* @__PURE__ */ p(
    he,
    {
      onClick: n,
      className: Lh("file-item__container", u),
      sx: {
        display: "inline-flex",
        position: "relative",
        overflow: "hidden",
        ...d
      },
      children: /* @__PURE__ */ p(WM, { className: "file-item__content", children: /* @__PURE__ */ p(HM, { className: "file-item__label-container", children: /* @__PURE__ */ p(
        UM,
        {
          title: t.name,
          className: "file-item__label-container",
          children: t.name
        }
      ) }) })
    }
  );
}), RV = te(yt)`
  align-self: center;
`, GM = te.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: #eff8fd96;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  z-index: 1000;
`, DV = te.div`
  position: absolute;
  width: calc(100vw);
  height: calc(100vh);
  top: 0;
  right: 0;
  background: #eff8fd96;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  z-index: 1000;
`, Sf = te.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden; /* Чтобы фон не мигал */
  flex-grow: 1;
  min-height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ background: e }) => e ? `url(${e})` : "none"};
    background-size: cover;
    background-position: center;
    opacity: 0;
    transition: opacity 0.8s ease-in-out;
    z-index: 2;
  }

  ${({ background: e }) => e && `
    &::before {
      opacity: 0.5; 
    }
  `}
`, VM = te.div`
  cursor: ${({ viewMode: e }) => e ? "default" : "pointer"};
  display: inline-flex;
`, PV = te("div")(({ theme: e }) => ({
  fontSize: 15,
  fontWeight: "bold",
  color: e == null ? void 0 : e.palette.textColor.header
})), LV = ({ isFavorite: e, onClick: t, size: n = 20, viewMode: r = !1 }) => {
  var c;
  const i = Ee(
    () => e ? "Remove from favorites" : "Mark as favorite",
    [e]
  ), a = Kr(), o = "#FCD733", s = (c = a.palette) == null ? void 0 : c.textColor.label;
  return /* @__PURE__ */ p(
    pt,
    {
      text: i,
      arrow: !0,
      color: "primary",
      placement: "bottom",
      disabled: r,
      children: /* @__PURE__ */ p(
        VM,
        {
          onClick: (l) => {
            l.stopPropagation(), t && !r && t();
          },
          viewMode: r,
          children: /* @__PURE__ */ p(
            JC,
            {
              selected: e,
              name: "favorite",
              size: n,
              color: e ? o : s
            }
          )
        }
      )
    }
  );
}, QM = ({
  isPrivate: e,
  onClick: t,
  viewMode: n,
  size: r = 18,
  tooltipText: i
}) => {
  const a = kr(), { t: o } = Da(), s = Ee(
    () => n ? void 0 : o(e ? "tooltips.mark_public" : "tooltips.mark_private"),
    [e]
  );
  return /* @__PURE__ */ p(pt, { text: s, arrow: !0, placement: "bottom", children: /* @__PURE__ */ p(
    he,
    {
      className: "access-status",
      onClick: (c) => {
        c.stopPropagation(), !n && t && t();
      },
      sx: {
        cursor: n ? "default" : "pointer",
        display: "inline-flex"
      },
      children: /* @__PURE__ */ p(
        pe,
        {
          iconName: e ? "private" : "public",
          sx: { color: a.palette.textColor.label, fontSize: r }
        }
      )
    }
  ) });
}, qM = te.div`
  color: #fff;
  font-size: 14px;
  div {
    font-weight: 500;
    white-space: nowrap;
  }
  span {
    font-size: 12px;
    display: ${({ hasTenant: e }) => e ? "inline-block" : "none"};
    white-space: nowrap;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`, XM = te.div`
  display: flex;
  align-items: center;
  color: #ffffff;
`;
te.div`
  line-height: 14px;

  svg {
    padding: 0 12px 0 24px;
    cursor: pointer;
    font-size: 18px;
  }
`;
const JM = te.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`, KM = te(sA)`
  width: 32px;
  height: 32px;
  font-size: 0.9rem;
  font-weight: 700;
  margin: 0 12px 0 16px;
  & {
    color: #ffffff;
  }
  background-color: ${({ theme: e }) => e.palette.grey[400]};
`, ZM = ({ onContextSwitch: e, currentUser: t, currentTenant: n }) => {
  var a;
  const r = Qi(), i = (o) => {
    r(e(o));
  };
  return /* @__PURE__ */ p(KC, { children: (a = t == null ? void 0 : t.tenants) == null ? void 0 : a.map((o, s) => {
    var l;
    const c = o.object.id === n.object.id;
    return /* @__PURE__ */ B(
      su,
      {
        className: "tenant-" + s,
        sx: (u) => ({
          backgroundColor: c ? u.palette.backgroundColor.main : "inherit",
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          py: 0.5,
          fontWeight: 400
        }),
        onClick: () => !c && i(o.object.id),
        children: [
          /* @__PURE__ */ p(
            R,
            {
              item: !0,
              sx: { fontSize: 14 },
              maxWidth: 300,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              children: (l = o.object) == null ? void 0 : l.title
            }
          ),
          c ? /* @__PURE__ */ p(
            pe,
            {
              iconName: "checkmark",
              sx: { width: 16, color: "success.dark", ml: 2 }
            }
          ) : /* @__PURE__ */ p(he, { sx: { width: "32px" } })
        ]
      },
      o.id
    );
  }) });
}, eI = ({
  anchorEl: e,
  open: t,
  onClose: n,
  onContextSwitch: r,
  currentUser: i,
  logout: a,
  showMenu: o
}) => {
  var l;
  const s = Kr(), c = Xe.useMemo(
    () => {
      var u;
      return (u = i.tenants) == null ? void 0 : u.find(
        (d) => d.object.id === i.activeTenant
      );
    },
    [i]
  );
  return /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ B(
    lA,
    {
      id: "user-menu",
      anchorEl: e,
      open: t,
      onClose: n,
      MenuListProps: {
        "aria-labelledby": "user-menu-button",
        role: "listbox"
      },
      slotProps: {
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            boxShadow: s.customShadows[1],
            mt: 1.5,
            minWidth: 200,
            ".MuiList-root": {
              py: 0
            }
          }
        }
      },
      transformOrigin: { horizontal: "center", vertical: "top" },
      anchorOrigin: { horizontal: "center", vertical: "bottom" },
      children: [
        ((l = i.tenants) == null ? void 0 : l.length) > 0 && o && [
          /* @__PURE__ */ p(
            su,
            {
              sx: {
                px: 2,
                py: 1,
                justifyContent: "space-between",
                color: "#56617A",
                fontSize: 14,
                fontWeight: 400,
                pointerEvents: "none"
              },
              className: "context-switch",
              disableRipple: !0,
              children: "Tenant"
            },
            "tenant-label"
          ),
          /* @__PURE__ */ p(
            ZM,
            {
              onContextSwitch: r,
              currentUser: i,
              currentTenant: c
            },
            "tenant-list"
          ),
          /* @__PURE__ */ p(Sa, { sx: { mx: 1, mt: 1 } }, "divider")
        ],
        /* @__PURE__ */ B(
          su,
          {
            sx: {
              px: 2,
              py: 1,
              justifyContent: "space-between",
              color: "#56617A",
              fontSize: 13,
              fontWeight: 400
            },
            className: "logout",
            onClick: a,
            children: [
              /* @__PURE__ */ p("div", { children: "Log Out" }),
              /* @__PURE__ */ p(pe, { iconName: "logout", sx: { width: 16, color: "secondary.main" } })
            ]
          }
        )
      ]
    }
  ) });
}, zV = ({ onLogout: e, onContextSwitch: t, showMenu: n = !1 }) => {
  var m, g, v, _, I;
  const r = Qi(), i = Rt(
    (M) => M.user.data
  ), [a, o] = Xe.useState(null), s = !!a, c = i.firstName && i.lastName ? `${i.firstName} ${i.lastName}` : i.email ? i.email : "", l = ((v = (g = (m = i == null ? void 0 : i.tenants) == null ? void 0 : m.find(
    (M) => {
      var k;
      return ((k = M.object) == null ? void 0 : k.id) === (i == null ? void 0 : i.activeTenant);
    }
  )) == null ? void 0 : g.object) == null ? void 0 : v.title) || "", u = () => {
    j0("RecordCountsDataSource"), r(e());
  }, d = (M) => (j0("RecordCountsDataSource"), t == null ? void 0 : t(M)), f = (M) => {
    o(M.currentTarget);
  }, h = () => {
    o(null);
  };
  return /* @__PURE__ */ B(ze, { children: [
    /* @__PURE__ */ p(XM, { children: /* @__PURE__ */ B(JM, { onClick: f, children: [
      /* @__PURE__ */ p(KM, { children: i.firstName || i.lastName ? (((_ = i.firstName) == null ? void 0 : _[0]) || "") + (((I = i.lastName) == null ? void 0 : I[0]) || "") : /* @__PURE__ */ p(pe, { iconName: "users", fontSize: "small" }) }),
      /* @__PURE__ */ B(qM, { hasTenant: n, children: [
        /* @__PURE__ */ p("div", { title: c, children: c }),
        /* @__PURE__ */ p("span", { title: l, children: l })
      ] }),
      /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
        he,
        {
          sx: {
            px: 2,
            svg: {
              width: 10,
              height: 5
            },
            transform: s ? "rotate(180deg)" : "rotate(0deg)",
            mt: s ? "2px" : "-2px",
            transition: "transform 200ms"
          },
          children: /* @__PURE__ */ p(pe, { iconName: "arrowDown", sx: { color: "white" } })
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p(
      eI,
      {
        onClose: h,
        open: s,
        anchorEl: a,
        onContextSwitch: d,
        currentUser: i,
        logout: u,
        showMenu: n
      }
    )
  ] });
}, tI = ({
  updateNote: e,
  note: t,
  onCancel: n,
  onSubmit: r,
  disabled: i
}) => /* @__PURE__ */ B(
  R,
  {
    item: !0,
    xs: 12,
    container: !0,
    flexWrap: "nowrap",
    spacing: 1,
    className: "invitation-decline-form",
    children: [
      /* @__PURE__ */ p(R, { item: !0, flex: 1, children: /* @__PURE__ */ p(
        _r,
        {
          size: "small",
          value: t,
          multiline: !0,
          placeholder: "Enter message...",
          fullWidth: !0,
          onChange: (a) => e(a.target.value),
          name: "invitation-decline-message",
          disabled: i
        }
      ) }),
      /* @__PURE__ */ B(R, { item: !0, display: "flex", children: [
        /* @__PURE__ */ p(pt, { text: "Submit", children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
          Te,
          {
            size: "small",
            sx: {
              minWidth: 26,
              height: 30,
              padding: 1,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            },
            variant: "outlined",
            onClick: r,
            name: "invitation-decline-accept",
            disabled: i,
            children: /* @__PURE__ */ p(pe, { iconName: "submit", color: "success", sx: { fontSize: 18 } })
          }
        ) }) }),
        /* @__PURE__ */ p(pt, { text: "Cancel", children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
          Te,
          {
            size: "small",
            sx: {
              minWidth: 26,
              padding: 1,
              height: 30,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              marginLeft: "-1px"
            },
            variant: "outlined",
            color: "primary",
            onClick: n,
            name: "invitation-decline-cancel",
            disabled: i,
            children: /* @__PURE__ */ p(pe, { iconName: "deactivate", color: "error", sx: { fontSize: 18 } })
          }
        ) }) })
      ] })
    ]
  }
), nI = te(R)`
  button {
    /* height: 22px; */
  }
  button:first-of-type {
    margin-right: 6px;
  }
`, rI = [
  Nt.LIBRARY_COHORT,
  Nt.LIBRARY_CONCEPT_SET,
  Nt.LIBRARY_CUSTOM_CODE,
  Nt.LIBRARY_FEATURE_ANALYSIS
], iI = [
  $e.LIBRARY_COHORT,
  $e.LIBRARY_CONCEPT_SET,
  $e.LIBRARY_FEATURE_ANALYSIS
];
function jn({
  item: e,
  invitationId: t,
  invitationType: n,
  affinity: r
}) {
  const i = function() {
    if (!e.type) return "#";
    const a = iI.includes(e.type) || (n ? rI.includes(n) : !1);
    switch (e.type) {
      case $e.ADMIN:
      case $e.PARTICIPANT:
      case $e.SUBMISSION:
      case $e.USER:
        return "#";
      case $e.ANALYSIS: {
        if (r) {
          const [o] = r;
          let s = `/${va[o.type]}`;
          return o.type === $e.STUDY && (s += `/${o == null ? void 0 : o.id}`), s += `/${va[$e.ANALYSIS]}/${e.id}`, n === Nt.SUBMISSION_PUBLISHING && (s += "/executions"), s;
        }
        return "#";
      }
      default:
        return `/${va[e.type]}` + (e.id ? `/${e.id}` : "") + (a ? `?from=LIBRARY&typePublish=INCOMING&id=${t}` : "");
    }
  }();
  switch (e.type) {
    case $e.ADMIN:
    case $e.PARTICIPANT:
    case $e.SUBMISSION:
    case $e.USER:
      return /* @__PURE__ */ p(
        fe,
        {
          color: "primary",
          component: "span",
          fontWeight: 500,
          fontSize: 14,
          children: e.name
        },
        t + e.type + e.id
      );
    case $e.ANALYSIS:
      return status === Ce.IN_PROGRESS ? /* @__PURE__ */ p(
        fe,
        {
          color: "primary",
          component: "span",
          fontWeight: 500,
          fontSize: 14,
          children: e.name
        },
        t + e.type + e.id
      ) : /* @__PURE__ */ p(Ls, { to: i, children: e.name }, t + e.type + e.id);
    default:
      return /* @__PURE__ */ p(Ls, { to: i, children: e.name }, t + e.type + e.id);
  }
}
const aI = ({
  invitation: e,
  onInvitationAccept: t,
  onInvitationDecline: n
}) => {
  const [r, i] = Se(""), [a, o] = Se(!1), [s, c] = Se(!1), [l, u] = Se(!1), d = Ee(() => {
    const { author: g, subject: v, activity: _, analysis: I, affinity: M } = e, k = I || v, y = [];
    switch (g && e.type !== Nt.SUBMISSION_PUBLISHING && y.push(
      /* @__PURE__ */ p(jn, { item: g, invitationId: e.id })
    ), e.type) {
      case Nt.STUDY_DATASOURCE:
        y.push(
          " has invited your data source ",
          /* @__PURE__ */ p(jn, { item: v, invitationId: e.id }),
          " to study ",
          /* @__PURE__ */ p(jn, { item: _, invitationId: e.id })
        );
        break;
      case Nt.STUDY_PARTICIPANT:
        y.push(
          " has invited you to join study ",
          /* @__PURE__ */ p(jn, { item: _, invitationId: e.id })
        );
        break;
      case Nt.WORKSPACE_DATASOURCE:
        y.push(
          " has invited your data source ",
          /* @__PURE__ */ p(jn, { item: v, invitationId: e.id }),
          " to workspace "
        );
        break;
      case Nt.LIBRARY_COHORT:
        y.push(
          " has requested to publish cohort ",
          /* @__PURE__ */ p(
            jn,
            {
              item: v,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case Nt.LIBRARY_FEATURE_ANALYSIS:
        y.push(
          " has requested to publish feature analysis ",
          /* @__PURE__ */ p(
            jn,
            {
              item: {
                ...k,
                type: $e.LIBRARY_FEATURE_ANALYSIS
              },
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case Nt.LIBRARY_CUSTOM_CODE:
        y.push(
          " has requested to publish custom code ",
          /* @__PURE__ */ p(
            jn,
            {
              item: v,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case Nt.LIBRARY_CONCEPT_SET:
        y.push(
          " has requested to publish concept set ",
          /* @__PURE__ */ p(
            jn,
            {
              item: v,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case Nt.SUBMISSION_EXECUTION:
        y.push(
          " requested to execute an ",
          /* @__PURE__ */ p(
            jn,
            {
              item: { ...I, type: $e.ANALYSIS },
              affinity: M,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " on ",
          /* @__PURE__ */ p(
            jn,
            {
              item: { ...v, type: $e.DATASOURCE },
              invitationId: e.id
            }
          )
        );
        break;
      case Nt.SUBMISSION_PUBLISHING:
        y.push(
          " The results of ",
          /* @__PURE__ */ p(
            jn,
            {
              item: { ...I, type: $e.ANALYSIS },
              affinity: M,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " on ",
          /* @__PURE__ */ p(
            jn,
            {
              item: { ...v, type: $e.DATASOURCE },
              invitationId: e.id
            }
          ),
          " are available to review and approval to publish "
        );
        break;
    }
    return y;
  }, [e]), f = Xe.useMemo(() => {
    switch (e.type) {
      case Nt.STUDY_DATASOURCE:
        return {
          accept: `/studies/datasource/invites/${e.id}/accept`,
          decline: `/studies/datasource/invites/${e.id}/dismiss`
        };
      case Nt.STUDY_PARTICIPANT:
        return {
          accept: `/studies/invites/${e.id}/accept`,
          decline: `/studies/invites/${e.id}/dismiss`
        };
      case Nt.WORKSPACE_DATASOURCE:
        return {
          accept: `/workspace/datasource/invites/${e.id}/accept`,
          decline: `/workspace/datasource/invites/${e.id}/dismiss`
        };
      case Nt.LIBRARY_COHORT:
        return {
          accept: `/library/cohort/invites/${e.id}/accept`,
          decline: `/library/cohort/invites/${e.id}/dismiss`
        };
      case Nt.LIBRARY_FEATURE_ANALYSIS:
        return {
          accept: `/library/feature-analyses/invites/${e.id}/accept`,
          decline: `/library/feature-analyses/invites/${e.id}/dismiss`
        };
      case Nt.LIBRARY_CONCEPT_SET:
        return {
          accept: `/library/concept-set/invites/${e.id}/accept`,
          decline: `/library/concept-set/invites/${e.id}/dismiss`
        };
      case Nt.SUBMISSION_EXECUTION:
        return {
          accept: `/submissions/${e.id}/approve`,
          decline: `/submissions/${e.id}/dismiss`
        };
      case Nt.LIBRARY_CUSTOM_CODE:
        return {
          accept: `/library/custom-code/invites/${e.id}/accept`,
          decline: `/library/custom-code/invites/${e.id}/dismiss`
        };
      case Nt.SUBMISSION_PUBLISHING:
        return {
          accept: `/submissions/${e.id}/approve-publishing`,
          decline: `/submissions/${e.id}/dismiss-publishing`
        };
    }
  }, [e]), h = () => {
    o(!0), t(f.accept);
  }, m = () => {
    u(!0);
  };
  return /* @__PURE__ */ p(
    R,
    {
      container: !0,
      item: !0,
      xs: 12,
      px: 2,
      py: 1,
      className: "list-item",
      sx: {
        "&:hover": {
          bgcolor: "backgroundColor.dark"
        }
      },
      children: /* @__PURE__ */ p(cA, { onClickAway: () => u(!1), children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ B(lb, { container: !0, className: "invitations-list-item ", children: [
        /* @__PURE__ */ B(R, { item: !0, zeroMinWidth: !0, xs: 12, mb: 1, children: [
          d,
          e.message ? ` with message: "${e.message}"` : ""
        ] }),
        /* @__PURE__ */ B(
          R,
          {
            item: !0,
            xs: 12,
            container: !0,
            spacing: 1,
            justifyContent: "space-between",
            alignItems: "center",
            mb: l ? 1 : 0,
            children: [
              /* @__PURE__ */ B(nI, { item: !0, children: [
                /* @__PURE__ */ p(
                  Te,
                  {
                    variant: "contained",
                    color: "success",
                    onClick: h,
                    disabled: a || s || l,
                    name: "accept-invitation",
                    startIcon: a ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: "submit" }),
                    children: "Accept"
                  }
                ),
                /* @__PURE__ */ p(
                  Te,
                  {
                    variant: "outlined",
                    onClick: m,
                    disabled: a || s || l,
                    name: "decline-invitation",
                    startIcon: s ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
                    children: "Reject"
                  }
                )
              ] }),
              /* @__PURE__ */ p(cb, { item: !0, children: Zv(e.timestamp) })
            ]
          }
        ),
        l && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
          tI,
          {
            note: r,
            updateNote: i,
            onCancel: () => u(!1),
            disabled: a || s,
            onSubmit: () => {
              c(!0), n(r, f.decline);
            }
          }
        ) })
      ] }) }) })
    }
  );
}, oI = ({
  showMore: e,
  invitations: t,
  size: n,
  onInvitationAccept: r,
  onInvitationDecline: i
}) => /* @__PURE__ */ B(ub, { container: !0, width: 500, className: "invitations-list-content", children: [
  t.slice(0, n).map((a) => /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
    aI,
    {
      invitation: a,
      onInvitationAccept: r,
      onInvitationDecline: i
    }
  ) }, a.id)),
  n < (t == null ? void 0 : t.length) && /* @__PURE__ */ p(R, { item: !0, xs: 12, textAlign: "right", px: 2, py: 1, children: /* @__PURE__ */ p(Te, { onClick: e, size: "small", variant: "text", children: "Show more" }) })
] }), Cf = te.div``, ob = te(R)`
  padding: 8px 8px 8px 16px;
  height: 42px;
  display: flex;
  background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  color: ${({ theme: e }) => e.palette.primary.main};
  font-size: 14px;
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  font-weight: bold;
`, sb = te(R)`
  padding: 16px;
  color: ${({ theme: e }) => e.palette.grey[500]};
  font-size: 13px;
  width: 450px;
  line-height: 30px;
  height: 66px;
`, Ef = te(
  pm(({ text: e, ...t }, n) => /* @__PURE__ */ p(Te, { ...t, ref: n, variant: "text", sx: { p: 0 }, children: /* @__PURE__ */ p(
    fe,
    {
      className: "button-text",
      component: "span",
      color: "inherit",
      fontSize: "inherit",
      children: e
    }
  ) })),
  {
    shouldForwardProp: (e) => e !== "hasNotifications" && e !== "count"
  }
)(({ theme: e, hasNotifications: t, count: n }) => `
  min-width: 50px;
  @media (min-width: 1000px) {
    min-width: 70px;
  }
  cursor: pointer;
  position: relative;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  cursor: pointer;
  border-radius: 6px;
  color: #ffffff;
  :hover {
    svg {
      * {
        color: #A0A8BA;
      }
    }
  }
  .start-icon {
    position: relative;
    margin: 0;
    margin-bottom: 4px;
    svg {
      font-size: 20px;
      font-weight: 500;
      width: 20px;
      height: 20px;
      * {
        color: #A0A8BA;
      }
    }
  }
  .button-text {
    font-size: 12px;
    line-height: 12px;
    width: 100%;

  }
  @media (max-width: 1000px) {
    .button-text {
      display: none;
    }
    .start-icon {
      margin-bottom:0
    }
  }
  &.Mui-disabled {
    color: #91a1b3;
    .MuiSvgIcon-root {
      fill: #7a8ea4;
    }
  }
`), lb = te(R)`
  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  border-radius: 2px;
  color: #424242;
`, Ls = te(wE)`
  color: ${({ theme: e }) => e.palette.primary.main};
  font-weight: 400;
  text-decoration: underline;
`, cb = te(R)`
  color: ${({ theme: e }) => e.palette.grey[500]};
  font-size: 12px;
`, ub = te(R)`
  > div:not(:last-child) {
    .list-item {
      border-bottom: 1px solid #45a8ff1c;
    }
    /* padding: 4px; */
  }
  .list-item {
    padding-bottom: 8px;
    &.active {
      background-color: #45a8ff14;
      border-bottom: 1px solid #3d9cf025;
    }
    &:hover {
      background-color: #45a8ff29;
    }
  }
`, BV = ({
  getList: e,
  accept: t,
  decline: n,
  getCount: r
}) => {
  var A;
  const i = Qi(), a = Kr(), o = Un(0.7, (A = a == null ? void 0 : a.palette) == null ? void 0 : A.primary.main), s = () => i(e()), c = () => i(r()), l = (w) => i(t(w)), u = (w, O) => i(n(w, O)), d = Rt(
    (w) => w.invitations.invitations
  ), f = Rt((w) => w.invitations.status), h = Rt((w) => w.invitations.count), m = 5, [g, v] = Xe.useState(null), [_, I] = Xe.useState(m), M = !!g, k = (w) => {
    v(w.currentTarget), s();
  }, y = () => {
    v(null), c();
  }, x = async (w) => {
    l(w);
  }, b = (w, O) => {
    u(w, O);
  };
  return Xe.useEffect(() => (c(), () => {
  }), [c]), gA(() => {
    f !== Ce.INITIAL && f !== Ce.IN_PROGRESS && f !== Ce.IN_PROGRESS_RELOAD && c();
  }, 15e3), /* @__PURE__ */ B(Cf, { children: [
    /* @__PURE__ */ p(pt, { text: "Invitations", children: /* @__PURE__ */ p(
      Ef,
      {
        onClick: k,
        hasNotifications: h > 0,
        count: h,
        startIcon: /* @__PURE__ */ p(
          gf,
          {
            badgeContent: h,
            color: "error",
            sx: {
              "& .MuiBadge-badge": {
                padding: "2px 4px",
                fontSize: 10,
                height: 14
              }
            },
            max: 999,
            children: /* @__PURE__ */ p(pe, { iconName: "invitation" })
          }
        ),
        text: "Invitations"
      }
    ) }),
    /* @__PURE__ */ p(
      fA,
      {
        id: "popover",
        anchorEl: g,
        open: M,
        onClose: y,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        sx: { ".MuiPaper-root": { mr: 3 } },
        children: /* @__PURE__ */ B(uA, { className: "invitations-list", children: [
          /* @__PURE__ */ B(
            ob,
            {
              container: !0,
              alignItems: "center",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ B(R, { item: !0, alignItems: "center", display: "flex", children: [
                  /* @__PURE__ */ p(
                    pe,
                    {
                      iconName: "invitation",
                      color: "primary",
                      sx: { fontSize: 16, color: o, pr: 1.5 }
                    }
                  ),
                  /* @__PURE__ */ p("div", { children: "Invitations" })
                ] }),
                /* @__PURE__ */ p(
                  Te,
                  {
                    sx: { minWidth: 30, p: 0 },
                    onClick: s,
                    className: "reload",
                    children: f === Ce.IN_PROGRESS || f === Ce.IN_PROGRESS_RELOAD ? /* @__PURE__ */ p(yt, { size: 14, color: "secondary" }) : /* @__PURE__ */ p(pe, { iconName: "reload", sx: { fontSize: 16, color: o } })
                  }
                )
              ]
            }
          ),
          f === Ce.IN_PROGRESS ? /* @__PURE__ */ p(he, { textAlign: "center", py: 2, width: 494, children: /* @__PURE__ */ p(yt, { size: 30, color: "secondary" }) }) : h > 0 ? /* @__PURE__ */ p(
            oI,
            {
              invitations: d,
              size: _,
              showMore: () => I((w) => w += m),
              onInvitationAccept: x,
              onInvitationDecline: b
            }
          ) : /* @__PURE__ */ p(sb, { item: !0, p: 2, children: "No invitations..." })
        ] })
      }
    )
  ] });
}, sI = {
  [$e.COHORT]: "cohorts",
  conceptset: "concept-sets",
  [$e.CONCEPT_SET]: "concept-sets"
}, lI = (e, t) => {
  switch (e) {
    case $e.WORKSPACE:
      return "workspace";
    case $e.STUDY:
      return `${va[$e.STUDY]}/${t}`;
    case $e.LIBRARY:
      return "library";
    default:
      return;
  }
}, cI = (e) => {
  for (const t of e) {
    if (typeof t == "string")
      continue;
    const [[n, r]] = Object.entries(t), [[i]] = Object.entries(r), a = lI(n, i);
    if (a)
      return a;
  }
}, Py = ({ title: e, keyId: t }) => /* @__PURE__ */ p(
  fe,
  {
    color: "primary",
    component: "span",
    fontWeight: 500,
    fontSize: 14,
    children: e
  },
  t
), uI = (e, t, n) => {
  if (!e || !(e != null && e.length)) return "";
  const r = cI(e);
  return e.map((i) => fI(i, t, r, n));
}, fI = (e, t, n, r) => {
  if (typeof e == "string")
    return e;
  if (e.analysis) {
    const [[i, a]] = Object.entries(e.analysis);
    let o = va[$e.ANALYSIS];
    if (e.study) {
      const [s] = Object.keys(e.study);
      o = `${va[$e.STUDY]}/${s}/` + o;
    } else
      o = "workspace/" + o;
    return /* @__PURE__ */ p("span", { onClick: r, children: /* @__PURE__ */ p(Ls, { to: `/${o}/${i}`, children: a }, t + i) }, "analysis-" + i);
  } else {
    const [[i, a]] = Object.entries(e), [[o, s]] = Object.entries(a), c = sI[i];
    if (c)
      return n ? /* @__PURE__ */ p("span", { onClick: r, children: /* @__PURE__ */ p(
        Ls,
        {
          to: `/${n}/${c}/${o}`,
          children: s
        },
        t + o
      ) }, i + o) : /* @__PURE__ */ p(Py, { title: s, keyId: i + o });
    const l = va[i];
    return i === $e.USER || i === $e.BUNDLE || i === $e.TENANT || i === $e.STUDY_TYPE || i === $e.SUBMISSION || i === $e.DATA_NODE ? /* @__PURE__ */ p(Py, { title: s, keyId: i + o }) : /* @__PURE__ */ p("span", { onClick: r, children: /* @__PURE__ */ p(Ls, { to: `/${l}/${o}`, children: s }, t + o) }, i + o);
  }
}, dI = en(
  ({ notification: e, onRead: t }) => {
    const n = e.read ? void 0 : () => t([e.id]);
    return /* @__PURE__ */ p(
      R,
      {
        container: !0,
        item: !0,
        xs: 12,
        px: 2,
        py: 1,
        className: "list-item " + (e.read ? "" : "active"),
        children: /* @__PURE__ */ B(lb, { container: !0, children: [
          /* @__PURE__ */ p(R, { item: !0, zeroMinWidth: !0, children: uI(e.message, e.id, n) }),
          /* @__PURE__ */ B(
            cb,
            {
              item: !0,
              xs: 12,
              textAlign: "right",
              display: "flex",
              justifyContent: "space-between",
              mt: 1,
              children: [
                /* @__PURE__ */ p(he, { children: Zv(e.timestamp) }),
                /* @__PURE__ */ p("div", { children: !e.read && /* @__PURE__ */ p(
                  Te,
                  {
                    variant: "text",
                    onClick: n,
                    size: "small",
                    sx: (r) => ({
                      ml: -0.5,
                      fontWeight: "normal",
                      color: r.palette.grey[600]
                    }),
                    startIcon: /* @__PURE__ */ p(pe, { iconName: "submit", sx: { fontSize: 12 } }),
                    children: "Mark as read"
                  }
                ) })
              ]
            }
          )
        ] })
      }
    );
  }
), hI = ({
  notifications: e,
  size: t,
  totalElements: n,
  showMore: r,
  onRead: i,
  status: a
}) => /* @__PURE__ */ B(ub, { container: !0, width: 450, className: "notifications-list-content", children: [
  e.map((o) => /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(dI, { notification: o, onRead: i }) }, o.id)),
  a === Ce.IN_PROGRESS_RELOAD && /* @__PURE__ */ p(he, { textAlign: "center", py: 2, width: 394, children: /* @__PURE__ */ p(yt, { size: 30, color: "secondary" }) }),
  t < n && /* @__PURE__ */ p(
    R,
    {
      item: !0,
      xs: 12,
      textAlign: "right",
      px: 2,
      py: 1,
      position: "sticky",
      bottom: 0,
      bgcolor: "white",
      children: /* @__PURE__ */ p(Te, { onClick: r, size: "small", variant: "text", children: "Show more" })
    }
  )
] }), FV = ({
  getNotifications: e,
  getNotificationsUnread: t,
  updateNotifications: n
}) => {
  var C;
  const r = Qi(), i = Kr(), a = Un(0.7, (C = i.palette) == null ? void 0 : C.primary.main), o = Rt(
    (T) => T.notifications.notifications
  ), s = Rt((T) => T.notifications.status), c = Rt(
    (T) => T.notifications.unreadStatus
  ), l = Rt(
    (T) => T.notifications.unreadNotificationsIds
  ), u = Rt(
    (T) => T.notifications.count
  ), d = Rt(
    (T) => T.notifications.totalElements
  ), f = 5, [h, m] = Xe.useState(null), [g, v] = Xe.useState(f), [_, I] = Se("All"), M = () => {
    c !== Ce.IN_PROGRESS && c !== Ce.IN_PROGRESS_RELOAD && r(t());
  }, k = () => {
    r(
      e({
        size: g,
        ..._ === "Unread" ? { read: !1 } : {}
      })
    );
  }, y = () => {
    M(), k();
  }, x = (T) => r(n(T)), b = () => {
    u && r(n(l));
  }, A = !!h, w = (T) => {
    m(T.currentTarget), k();
  }, O = async (T) => {
    x(T);
  }, P = () => {
    m(null);
  };
  Xe.useEffect(() => (M(), () => {
  }), []), gA(() => {
    c !== Ce.INITIAL && M();
  }, 15e3), He(() => {
    s !== Ce.INITIAL && s !== Ce.IN_PROGRESS && s !== Ce.IN_PROGRESS_RELOAD && k();
  }, [g]), He(() => {
    s !== Ce.INITIAL && s !== Ce.IN_PROGRESS && s !== Ce.IN_PROGRESS_RELOAD && k();
  }, [_]);
  const E = _ === "All" ? (o == null ? void 0 : o.length) > 0 : u > 0;
  return /* @__PURE__ */ B(Cf, { children: [
    /* @__PURE__ */ p(pt, { text: "Notifications", children: /* @__PURE__ */ p(
      Ef,
      {
        onClick: w,
        hasNotifications: u > 0,
        count: u,
        disableRipple: !0,
        startIcon: /* @__PURE__ */ p(
          gf,
          {
            badgeContent: u,
            color: "error",
            sx: {
              "& .MuiBadge-badge": {
                padding: "2px 4px",
                fontSize: 10,
                height: 14
              }
            },
            max: 999,
            children: /* @__PURE__ */ p(pe, { iconName: "notification" })
          }
        ),
        name: "notifications",
        text: "Notifications"
      }
    ) }),
    /* @__PURE__ */ p(
      fA,
      {
        id: "popover",
        anchorEl: h,
        open: A,
        onClose: P,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        sx: { ".MuiPaper-root": { mr: 2 } },
        children: /* @__PURE__ */ B(uA, { children: [
          /* @__PURE__ */ B(he, { position: "sticky", top: 0, bgcolor: "white", zIndex: 2, children: [
            /* @__PURE__ */ B(
              ob,
              {
                container: !0,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ B(R, { item: !0, alignItems: "center", display: "flex", children: [
                    /* @__PURE__ */ p(
                      pe,
                      {
                        iconName: "notification",
                        color: "primary",
                        sx: {
                          fontSize: 16,
                          color: a,
                          pr: 1.5
                        }
                      }
                    ),
                    /* @__PURE__ */ p("div", { children: "Notifications" })
                  ] }),
                  /* @__PURE__ */ p(Te, { sx: { minWidth: 30, p: 0 }, onClick: y, children: s === Ce.IN_PROGRESS || s === Ce.IN_PROGRESS_RELOAD ? /* @__PURE__ */ p(yt, { size: 14, color: "secondary" }) : /* @__PURE__ */ p(
                    pe,
                    {
                      iconName: "reload",
                      sx: {
                        fontSize: 16,
                        color: a
                      }
                    }
                  ) })
                ]
              }
            ),
            /* @__PURE__ */ B(he, { display: "flex", px: 1.5, py: 1, justifyContent: "space-between", children: [
              /* @__PURE__ */ p(he, { display: "flex", children: ["All", "Unread"].map((T) => /* @__PURE__ */ p(
                Te,
                {
                  size: "small",
                  sx: {
                    mr: 1,
                    minWidth: "auto",
                    borderRadius: 0.5,
                    px: 1,
                    ..._ === T ? {
                      bgcolor: "backgroundColor.dark"
                    } : {}
                  },
                  onClick: () => I(T),
                  children: T
                },
                T
              )) }),
              /* @__PURE__ */ p(
                Te,
                {
                  onClick: b,
                  variant: "text",
                  color: "info",
                  size: "small",
                  disabled: !u,
                  children: "Mark all as read"
                }
              )
            ] })
          ] }),
          s === Ce.IN_PROGRESS ? /* @__PURE__ */ p(he, { textAlign: "center", py: 2, width: 450, children: /* @__PURE__ */ p(yt, { size: 30, color: "secondary" }) }) : E ? /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
            hI,
            {
              notifications: o,
              totalElements: d,
              size: g,
              showMore: () => v((T) => T + f),
              onRead: O,
              status: s
            }
          ) }) : /* @__PURE__ */ p(sb, { item: !0, p: 2, children: "No notifications..." })
        ] })
      }
    )
  ] });
}, va = {
  [$e.STUDY]: "study-manager",
  [$e.USER]: "user",
  [$e.PARTICIPANT]: "user",
  [$e.DATASET]: "data-catalog",
  [$e.DATASOURCE]: "data-catalog",
  [$e.WORKSPACE]: "workspace",
  [$e.ADMIN]: "admin",
  [$e.LIBRARY]: "library",
  [$e.COHORT]: "cohort",
  [$e.CONCEPT_SET]: "concept_set",
  [$e.LIBRARY_CONCEPT_SET]: "library/concept-sets",
  [$e.CUSTOM_CODE]: "library/custom-code",
  [$e.CUSTOMCODE]: "library/custom-code",
  [$e.LIBRARY_COHORT]: "library/cohorts",
  [$e.LIBRARY_FEATURE_ANALYSIS]: "library/custom-features/publish-requests",
  [$e.ANALYSIS]: "analyses",
  [$e.SUBMISSION]: "",
  [$e.BUNDLE]: "",
  [$e.TENANT]: "",
  [$e.STUDY_TYPE]: "",
  [$e.DATA_NODE]: ""
}, pI = "transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease", Eo = "#333333", Mm = "#f4f5f7", mI = "#8a93a0", qh = "#f3f5f7", el = "#2f7fca", fb = "#246fb5", Pa = "#ffffff", Yi = "#eef1f5", db = "#b8c0ca", Xh = 2100, gI = te(he, {
  shouldForwardProp: (e) => e !== "open" && e !== "panelWidth" && e !== "panelHeight" && e !== "minPanelHeight" && e !== "overlayLeft" && e !== "overlayTop" && e !== "topOffset" && e !== "isOverlay"
})`
  position: fixed;
  top: ${({ overlayTop: e, topOffset: t, isOverlay: n }) => n ? `${e ?? t}px` : `${t}px`};
  left: ${({ overlayLeft: e, isOverlay: t }) => t ? `${e ?? 0}px` : "auto"};
  right: ${({ isOverlay: e }) => e ? "auto" : "0"};
  bottom: auto;
  width: ${({ panelWidth: e, isOverlay: t }) => t ? `${e}px` : `${e}px`};
  max-width: ${({ overlayLeft: e, isOverlay: t }) => t ? `calc(100vw - ${e ?? 0}px)` : "calc(100vw - 24px)"};
  height: ${({ panelHeight: e, topOffset: t, isOverlay: n }) => e ? `${e}px` : n ? `min(640px, calc(100vh - ${t + 24}px))` : `calc(100vh - ${t}px)`};
  min-height: ${({ isOverlay: e, minPanelHeight: t, overlayTop: n, topOffset: r }) => e ? `clamp(0px, calc(100vh - ${n ?? r}px), ${t}px)` : "0"};
  max-height: ${({ overlayTop: e, topOffset: t, isOverlay: n }) => n ? `calc(100vh - ${e ?? t}px)` : "none"};
  background: ${Pa};
  color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette.text) == null ? void 0 : t.primary) || "#202124";
}};
  border: ${({ isOverlay: e }) => e ? `1px solid ${Yi}` : "none"};
  border-left: ${({ isOverlay: e }) => e ? `1px solid ${Yi}` : "1px solid #f1f3f6"};
  border-radius: ${({ isOverlay: e }) => e ? "12px" : "0"};
  box-shadow: ${({ open: e, isOverlay: t }) => e ? t ? "0 16px 42px rgba(12, 17, 27, 0.16)" : "-8px 0 22px rgba(12, 17, 27, 0.08)" : "none"};
  display: flex;
  flex-direction: column;
  transform: translateX(
    ${({ open: e, isOverlay: t }) => e ? "0" : t ? "18px" : "100%"}
  );
  opacity: ${({ open: e, isOverlay: t }) => t && !e ? 0 : 1};
  pointer-events: ${({ open: e }) => e ? "auto" : "none"};
  transition: ${pI};
  z-index: ${Xh};
  overflow: hidden;

  @media (max-width: 600px) {
    right: ${({ isOverlay: e }) => e ? "auto" : "0"};
    bottom: auto;
    width: ${({ panelWidth: e }) => `${e}px`};
    height: ${({ panelHeight: e, topOffset: t, isOverlay: n }) => e ? `${e}px` : n ? `min(620px, calc(100vh - ${t + 24}px))` : `calc(100vh - ${t}px)`};
    max-height: ${({ overlayTop: e, topOffset: t, isOverlay: n }) => n ? `calc(100vh - ${e ?? t}px)` : "none"};
    border-radius: ${({ isOverlay: e }) => e ? "10px" : "0"};
  }

  && {
    color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette.text) == null ? void 0 : t.primary) || "#0d1b40";
}};
  }

  & :where(*) {
    color: inherit;
  }

  && .MuiSvgIcon-root,
  && .MuiSvgIcon-root :where(*) {
    color: inherit;
  }

  &:before {
    content: '';
    display: ${({ isOverlay: e }) => e ? "none" : "block"};
    position: absolute;
    inset: 0 auto 0 0;
    width: 3px;
    background: #f7f8fa;
    border-right: 1px solid #f1f3f6;
    box-shadow: none;
    pointer-events: none;
    z-index: 3;
  }
`;
te(he)`
  min-height: 30px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 6px;
  box-sizing: border-box;
  color: #2f3a4c;
  background: #eef2f7;
  border: 1px solid #dce2eb;
  border-radius: 7px;
`;
te("span", {
  shouldForwardProp: (e) => e !== "active"
})`
  color: ${({ active: e }) => e ? "#12233d" : "#697589"} !important;
  font-size: 11px;
  line-height: 14px;
  font-weight: ${({ active: e }) => e ? 700 : 600};
  white-space: nowrap;

  @media (max-width: 420px) {
    display: none;
  }
`;
const oc = te("div", {
  shouldForwardProp: (e) => e !== "placement"
})`
  position: absolute;
  top: ${({ placement: e = "left" }) => e === "bottom" ? "auto" : "0"};
  right: ${({ placement: e = "left" }) => e === "right" ? "0" : "auto"};
  bottom: ${({ placement: e = "left" }) => e === "bottom" ? "0" : "auto"};
  left: ${({ placement: e = "left" }) => e === "right" ? "auto" : "0"};
  width: ${({ placement: e = "left" }) => e === "top" || e === "bottom" ? "100%" : "20px"};
  height: ${({ placement: e = "left" }) => e === "top" || e === "bottom" ? "20px" : "100%"};
  cursor: ${({ placement: e = "left" }) => e === "top" || e === "bottom" ? "ns-resize" : "ew-resize"};
  touch-action: none;
  z-index: 20;

  &:before {
    content: '';
    position: absolute;
    top: ${({ placement: e = "left" }) => e === "bottom" ? "auto" : "0"};
    right: ${({ placement: e = "left" }) => e === "right" ? "0" : "auto"};
    bottom: ${({ placement: e = "left" }) => e === "bottom" ? "0" : "auto"};
    left: ${({ placement: e = "left" }) => e === "right" ? "auto" : "0"};
    width: ${({ placement: e = "left" }) => e === "top" || e === "bottom" ? "100%" : "2px"};
    height: ${({ placement: e = "left" }) => e === "top" || e === "bottom" ? "2px" : "100%"};
    background: ${db};
    opacity: 0;
    transition: background 120ms ease, opacity 120ms ease;
  }

  &:hover:before,
  &:active:before {
    opacity: 1;
    background: #0d1b40;
  }

  @media (max-width: 900px) {
    display: none;
  }
`, sc = te("div", {
  shouldForwardProp: (e) => e !== "placement"
})`
  position: absolute;
  top: ${({ placement: e = "top-left" }) => e === "bottom-left" || e === "bottom-right" ? "auto" : "0"};
  right: ${({ placement: e = "top-left" }) => e === "top-right" || e === "bottom-right" ? "0" : "auto"};
  bottom: ${({ placement: e = "top-left" }) => e === "bottom-left" || e === "bottom-right" ? "0" : "auto"};
  left: ${({ placement: e = "top-left" }) => e === "top-right" || e === "bottom-right" ? "auto" : "0"};
  width: 28px;
  height: 28px;
  cursor: ${({ placement: e = "top-left" }) => e === "top-right" || e === "bottom-left" ? "nesw-resize" : "nwse-resize"};
  touch-action: none;
  z-index: 21;

  &:before,
  &:after {
    content: '';
    position: absolute;
    background: ${db};
    opacity: 0;
    transition: opacity 120ms ease;
  }

  &:before {
    top: 0;
    right: ${({ placement: e = "top-left" }) => e === "top-right" || e === "bottom-right" ? "0" : "auto"};
    left: ${({ placement: e = "top-left" }) => e === "top-right" || e === "bottom-right" ? "auto" : "0"};
    width: 2px;
    height: 28px;
  }

  &:after {
    top: ${({ placement: e = "top-left" }) => e === "bottom-left" || e === "bottom-right" ? "auto" : "0"};
    right: ${({ placement: e = "top-left" }) => e === "top-right" || e === "bottom-right" ? "0" : "auto"};
    bottom: ${({ placement: e = "top-left" }) => e === "bottom-left" || e === "bottom-right" ? "0" : "auto"};
    left: ${({ placement: e = "top-left" }) => e === "top-right" || e === "bottom-right" ? "auto" : "0"};
    width: 28px;
    height: 2px;
  }

  &:hover:before,
  &:hover:after,
  &:active:before,
  &:active:after {
    opacity: 1;
  }

  @media (max-width: 900px) {
    display: none;
  }
`, yI = te(he, {
  shouldForwardProp: (e) => e !== "isOverlay"
})`
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  direction: ${({ isOverlay: e }) => e ? "ltr" : "rtl"};
  scrollbar-width: thin;
  scrollbar-color: #dfe4ea transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #dfe4ea;
    border-radius: 8px;
  }
`, xI = te(he)`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  direction: ltr;
`, vI = te(he)`
  // pinned to the top of ChatScrollArea so the title and the drag handle stay
  // reachable while a long answer scrolls underneath
  position: sticky;
  top: 0;
  z-index: 2;
  flex: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: ${Pa};
`, AI = te(he, {
  shouldForwardProp: (e) => e !== "isOverlay"
})`
  height: 64px;
  min-height: 64px;
  padding: 18px 24px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: ${({ isOverlay: e }) => e ? "grab" : "default"};

  &:active {
    cursor: ${({ isOverlay: e }) => e ? "grabbing" : "default"};
  }
`, bI = te(he)`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 16px;
  font-weight: 700;
`, wI = te(he)`
  display: flex;
  align-items: center;
  gap: 10px;
`, Hc = te(Ra)`
  && {
    color: ${Eo} !important;
  }

  width: 26px;
  height: 26px;
  padding: 4px;
  border-radius: 50%;

  &:hover {
    background-color: ${Mm};
  }

  &.MuiIconButton-root .MuiSvgIcon-root,
  &.MuiIconButton-root .MuiSvgIcon-root svg,
  &.MuiIconButton-root .MuiSvgIcon-root svg * {
    color: ${Eo} !important;
  }

  &.MuiIconButton-root .MuiSvgIcon-root svg[stroke],
  &.MuiIconButton-root .MuiSvgIcon-root svg[stroke] * {
    fill: none;
    stroke: currentColor !important;
  }

  &.MuiIconButton-root .MuiSvgIcon-root svg [stroke] {
    fill: none;
    stroke: currentColor !important;
  }

  & > svg {
    width: 18px;
    height: 18px;
    color: inherit;
    stroke-width: 2;
  }
`;
te(he)`
  height: 48px;
  min-height: 48px;
  padding: 0 12px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;

  & .MuiIconButton-root {
    width: 28px;
    height: 28px;
    padding: 3px;
  }
`;
te(he)`
  display: flex;
  align-items: center;
  gap: 18px;
`;
const _I = te.span`
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${Eo} !important;
  font-size: 0;
  line-height: 0;

  &:before {
    content: '';
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: currentColor;
    box-shadow: 0 -6px 0 currentColor, 0 6px 0 currentColor;
  }
`, SI = te(Hc)`
  && {
    width: 26px;
    height: 26px;
    padding: 4px;
    color: ${Eo} !important;
    background-color: transparent;
    border-radius: 50%;
  }

  &.MuiIconButton-root .MuiSvgIcon-root,
  &.MuiIconButton-root .MuiSvgIcon-root svg,
  &.MuiIconButton-root .MuiSvgIcon-root svg * {
    color: ${Eo} !important;
  }

  &.MuiIconButton-root .MuiSvgIcon-root svg[stroke],
  &.MuiIconButton-root .MuiSvgIcon-root svg[stroke] * {
    fill: none;
    stroke: currentColor !important;
  }

  &:hover {
    background-color: ${Mm};
  }
`, CI = te(he)`
  flex: 1;
  min-height: 0;
  padding: 0 24px 16px;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${Pa};
  display: flex;
  flex-direction: column;
`, EI = te(he)`
  margin-top: auto;
  margin-bottom: 12px;
  color: #202124;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
`;
te(he)`
  flex: 1;
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #1c2637;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  letter-spacing: 0;

  @media (max-height: 720px) {
    font-size: 20px;
    line-height: 24px;
    min-height: 72px;
  }
`;
const kI = te(he)`
  white-space: normal;

  & > *:first-of-type {
    margin-top: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }

  p {
    margin: 0 0 8px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 12px 0 6px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.35;
  }

  ul,
  ol {
    margin: 0 0 8px;
    padding-left: 18px;
  }

  li {
    margin: 2px 0;
  }

  li > p {
    margin: 0;
  }

  strong {
    font-weight: 700;
  }

  a {
    color: ${el};
    text-decoration: underline;
  }

  code {
    padding: 1px 4px;
    border-radius: 4px;
    background: ${qh};
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  pre {
    margin: 0 0 8px;
    padding: 8px 10px;
    border-radius: 8px;
    background: ${qh};
    overflow-x: auto;

    code {
      padding: 0;
      background: none;
      white-space: pre;
    }
  }

  blockquote {
    margin: 0 0 8px;
    padding-left: 10px;
    border-left: 2px solid ${Yi};
    color: #5c6470;
  }

  hr {
    margin: 12px 0;
    border: 0;
    border-top: 1px solid ${Yi};
  }
`, TI = te(he)`
  margin: 0 0 8px;
  max-width: 100%;
  overflow-x: auto;
`, MI = te.table`
  border-collapse: collapse;
  font-size: 12px;
  line-height: 1.35;

  th,
  td {
    padding: 5px 8px;
    border: 1px solid ${Yi};
    vertical-align: top;
  }

  th {
    background: ${qh};
    font-weight: 700;
    white-space: nowrap;
  }

  tbody tr:nth-of-type(even) td {
    background: #fafbfc;
  }

  p {
    margin: 0;
  }
`, II = te(he)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`, NI = te(he)`
  display: flex;
  align-items: center;
  gap: 2px;
  margin: -4px 0 8px 2px;
`, OI = te(Ra)`
  && {
    color: ${mI} !important;
  }

  width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 6px;

  &:hover {
    background-color: ${Mm};

    && {
      color: ${Eo} !important;
    }
  }

  & > svg {
    width: 15px;
    height: 15px;
    color: inherit;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
  }
`, Ly = te(he, {
  shouldForwardProp: (e) => e !== "role"
})`
  max-width: 88%;
  width: fit-content;
  margin: ${({ role: e }) => e === "user" ? "0 0 8px auto" : "0 auto 8px 0"};
  padding: 8px 12px;
  border-radius: ${({ role: e }) => e === "user" ? "10px 10px 4px 10px" : "10px 10px 10px 4px"};
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.4;
  font-size: 13px;
  && {
    color: ${({ role: e, theme: t }) => {
  var n;
  return e === "user" ? "#ffffff" : ((n = t.palette.text) == null ? void 0 : n.primary) || "#202124";
}};
  }

  & :where(*) {
    color: inherit;
  }

  background: ${({ role: e, theme: t }) => e === "user" ? el : Pa};
  border: ${({ role: e, theme: t }) => {
  var n;
  return e === "assistant" ? `1px solid ${((n = t.palette.borderColor) == null ? void 0 : n.main) || "#edf0f4"}` : "none";
}};
  box-shadow: ${({ role: e, theme: t }) => {
  var n;
  return e === "assistant" ? ((n = t.shadows) == null ? void 0 : n[1]) || "0 2px 10px rgba(20, 24, 31, 0.06)" : "0 2px 10px rgba(47, 127, 202, 0.16)";
}};
`, RI = te(he)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding-bottom: 20px;
`, DI = te.button`
  width: fit-content;
  max-width: 100%;
  min-height: 34px;
  padding: 7px 12px;
  border: 0;
  border-radius: 8px;
  background: #f2f5f8;
  color: #202124;
  text-align: left;
  font-family: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
  font-size: 13px;
  line-height: 18px;
  cursor: pointer;
  white-space: normal;
  word-break: normal;
  box-shadow: inset 0 0 0 1px rgba(226, 231, 237, 0.55);
  transition: background 140ms ease, box-shadow 140ms ease, transform 140ms ease;

  &:hover {
    background: #eaf0f6;
    box-shadow: inset 0 0 0 1px rgba(210, 218, 228, 0.75);
  }
`, PI = te(he)`
  padding: 0 24px 20px;
  background: ${Pa};
`, LI = te.form`
  position: relative;
  display: flex;
  align-items: center;
`, zI = te.textarea`
  flex: 1;
  width: 100%;
  min-width: 0;
  max-height: 112px;
  min-height: 40px;
  resize: none;
  border: 0;
  border-radius: 10px;
  padding: 10px 52px 10px 14px;
  box-sizing: border-box;
  font-family: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette.text) == null ? void 0 : t.primary) || "#202124";
}};
  background: #f3f5f7;
  box-shadow: inset 0 0 0 1px rgba(234, 238, 243, 0.95);

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px rgba(47, 127, 202, 0.28),
      0 0 0 4px rgba(47, 127, 202, 0.08);
  }

  &::placeholder {
    color: #9aa3ad;
    opacity: 1;
  }
`, BI = te(Te)`
  position: absolute;
  right: 6px;
  top: 50%;
  min-width: 30px;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 50%;
  transform: translateY(-50%);

  && {
    background: ${el};
    color: #ffffff;
  }

  &:hover {
    background: ${fb};
  }

  && .MuiSvgIcon-root,
  && .MuiSvgIcon-root svg,
  && .MuiSvgIcon-root svg * {
    color: #ffffff !important;
  }

  &.Mui-disabled {
    background: #dfe5ee;
    color: #ffffff;
  }
`, FI = te(he)`
  width: fit-content;
  margin: 0 auto 8px 0;
  padding: 10px 14px;
  border-radius: 10px 10px 10px 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${Pa};
  border: 1px solid ${Yi};
  box-shadow: 0 2px 10px rgba(20, 24, 31, 0.06);

  & span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #9aa4b2;
    animation: prometheus-ai-typing 1.2s infinite ease-in-out;
  }

  & span:nth-of-type(2) {
    animation-delay: 0.2s;
  }

  & span:nth-of-type(3) {
    animation-delay: 0.4s;
  }

  @keyframes prometheus-ai-typing {
    0%,
    60%,
    100% {
      opacity: 0.3;
      transform: translateY(0);
    }
    30% {
      opacity: 1;
      transform: translateY(-3px);
    }
  }
`, $I = te(he)`
  width: 100%;
  margin: 0 0 8px 0;
  padding: 14px;
  border-radius: 12px;
  background: #f7f9fc;
  border: 1px solid ${Yi};
  box-shadow: 0 2px 10px rgba(20, 24, 31, 0.06);
`, YI = te(he)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #202124;
  font-size: 13px;
  font-weight: 700;
`, jI = te.code`
  padding: 2px 6px;
  border-radius: 6px;
  background: #e6ecf5;
  color: #2f4a66;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
`, WI = te(he)`
  color: #202124;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
`, zy = te(he)`
  margin-top: 4px;
  color: #5a6472;
  font-size: 12px;
  line-height: 17px;
`, HI = te.pre`
  margin: 8px 0 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: #eef2f7;
  color: #34404f;
  font-size: 12px;
  line-height: 16px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
`, UI = te(he)`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`, GI = te(he, {
  shouldForwardProp: (e) => e !== "op"
})`
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  background: ${Pa};
  border: 1px solid ${Yi};
  font-size: 12px;
  line-height: 16px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;

  & b {
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: 0.04em;
    color: ${({ op: e }) => e === "remove" ? "#c0392b" : e === "add" ? "#1e874b" : "#2f4a66"};
  }

  & span {
    color: #5a6472;
    word-break: break-word;
  }
`, VI = te(he)`
  margin-top: 12px;
  display: flex;
  gap: 8px;
`, By = te(Te, {
  shouldForwardProp: (e) => e !== "tone"
})`
  && {
    flex: 1;
    min-height: 34px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    text-transform: none;
    box-shadow: none;
    background: ${({ tone: e }) => e === "approve" ? el : "#ffffff"};
    color: ${({ tone: e }) => e === "approve" ? "#ffffff" : "#5a6472"};
    border: 1px solid
      ${({ tone: e }) => e === "approve" ? el : "#d5dce6"};
  }

  &:hover {
    background: ${({ tone: e }) => e === "approve" ? fb : "#f2f5f8"};
    box-shadow: none;
  }

  &.Mui-disabled {
    opacity: 0.6;
  }
`;
function QI(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const qI = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, XI = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, JI = {};
function Fy(e, t) {
  return (JI.jsx ? XI : qI).test(e);
}
const KI = /[ \t\n\f\r]/g;
function ZI(e) {
  return typeof e == "object" ? e.type === "text" ? $y(e.value) : !1 : $y(e);
}
function $y(e) {
  return e.replace(KI, "") === "";
}
class Rl {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Rl.prototype.normal = {};
Rl.prototype.property = {};
Rl.prototype.space = void 0;
function hb(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new Rl(n, r, t);
}
function Jh(e) {
  return e.toLowerCase();
}
class zn {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
zn.prototype.attribute = "";
zn.prototype.booleanish = !1;
zn.prototype.boolean = !1;
zn.prototype.commaOrSpaceSeparated = !1;
zn.prototype.commaSeparated = !1;
zn.prototype.defined = !1;
zn.prototype.mustUseProperty = !1;
zn.prototype.number = !1;
zn.prototype.overloadedBoolean = !1;
zn.prototype.property = "";
zn.prototype.spaceSeparated = !1;
zn.prototype.space = void 0;
let eN = 0;
const Je = La(), Ht = La(), Kh = La(), xe = La(), Ct = La(), ho = La(), Wn = La();
function La() {
  return 2 ** ++eN;
}
const Zh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Je,
  booleanish: Ht,
  commaOrSpaceSeparated: Wn,
  commaSeparated: ho,
  number: xe,
  overloadedBoolean: Kh,
  spaceSeparated: Ct
}, Symbol.toStringTag, { value: "Module" })), Od = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Zh)
);
class Im extends zn {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), Yy(this, "space", i), typeof r == "number")
      for (; ++a < Od.length; ) {
        const o = Od[a];
        Yy(this, Od[a], (r & Zh[o]) === Zh[o]);
      }
  }
}
Im.prototype.defined = !0;
function Yy(e, t, n) {
  n && (e[t] = n);
}
function Yo(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const a = new Im(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[Jh(r)] = r, n[Jh(a.attribute)] = r;
  }
  return new Rl(t, n, e.space);
}
const pb = Yo({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ht,
    ariaAutoComplete: null,
    ariaBusy: Ht,
    ariaChecked: Ht,
    ariaColCount: xe,
    ariaColIndex: xe,
    ariaColSpan: xe,
    ariaControls: Ct,
    ariaCurrent: null,
    ariaDescribedBy: Ct,
    ariaDetails: null,
    ariaDisabled: Ht,
    ariaDropEffect: Ct,
    ariaErrorMessage: null,
    ariaExpanded: Ht,
    ariaFlowTo: Ct,
    ariaGrabbed: Ht,
    ariaHasPopup: null,
    ariaHidden: Ht,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Ct,
    ariaLevel: xe,
    ariaLive: null,
    ariaModal: Ht,
    ariaMultiLine: Ht,
    ariaMultiSelectable: Ht,
    ariaOrientation: null,
    ariaOwns: Ct,
    ariaPlaceholder: null,
    ariaPosInSet: xe,
    ariaPressed: Ht,
    ariaReadOnly: Ht,
    ariaRelevant: null,
    ariaRequired: Ht,
    ariaRoleDescription: Ct,
    ariaRowCount: xe,
    ariaRowIndex: xe,
    ariaRowSpan: xe,
    ariaSelected: Ht,
    ariaSetSize: xe,
    ariaSort: null,
    ariaValueMax: xe,
    ariaValueMin: xe,
    ariaValueNow: xe,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function mb(e, t) {
  return t in e ? e[t] : t;
}
function gb(e, t) {
  return mb(e, t.toLowerCase());
}
const tN = Yo({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ho,
    acceptCharset: Ct,
    accessKey: Ct,
    action: null,
    allow: null,
    allowFullScreen: Je,
    allowPaymentRequest: Je,
    allowUserMedia: Je,
    alt: null,
    as: null,
    async: Je,
    autoCapitalize: null,
    autoComplete: Ct,
    autoFocus: Je,
    autoPlay: Je,
    blocking: Ct,
    capture: null,
    charSet: null,
    checked: Je,
    cite: null,
    className: Ct,
    cols: xe,
    colSpan: null,
    content: null,
    contentEditable: Ht,
    controls: Je,
    controlsList: Ct,
    coords: xe | ho,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Je,
    defer: Je,
    dir: null,
    dirName: null,
    disabled: Je,
    download: Kh,
    draggable: Ht,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Je,
    formTarget: null,
    headers: Ct,
    height: xe,
    hidden: Kh,
    high: xe,
    href: null,
    hrefLang: null,
    htmlFor: Ct,
    httpEquiv: Ct,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Je,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Je,
    itemId: null,
    itemProp: Ct,
    itemRef: Ct,
    itemScope: Je,
    itemType: Ct,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Je,
    low: xe,
    manifest: null,
    max: null,
    maxLength: xe,
    media: null,
    method: null,
    min: null,
    minLength: xe,
    multiple: Je,
    muted: Je,
    name: null,
    nonce: null,
    noModule: Je,
    noValidate: Je,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Je,
    optimum: xe,
    pattern: null,
    ping: Ct,
    placeholder: null,
    playsInline: Je,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Je,
    referrerPolicy: null,
    rel: Ct,
    required: Je,
    reversed: Je,
    rows: xe,
    rowSpan: xe,
    sandbox: Ct,
    scope: null,
    scoped: Je,
    seamless: Je,
    selected: Je,
    shadowRootClonable: Je,
    shadowRootDelegatesFocus: Je,
    shadowRootMode: null,
    shape: null,
    size: xe,
    sizes: null,
    slot: null,
    span: xe,
    spellCheck: Ht,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: xe,
    step: null,
    style: null,
    tabIndex: xe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Je,
    useMap: null,
    value: Ht,
    width: xe,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Ct,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: xe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: xe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Je,
    // Lists. Use CSS to reduce space between items instead
    declare: Je,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: xe,
    // `<img>` and `<object>`
    leftMargin: xe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: xe,
    // `<body>`
    marginWidth: xe,
    // `<body>`
    noResize: Je,
    // `<frame>`
    noHref: Je,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Je,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Je,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: xe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ht,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: xe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: xe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Je,
    disableRemotePlayback: Je,
    prefix: null,
    property: null,
    results: xe,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: gb
}), nN = Yo({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Wn,
    accentHeight: xe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: xe,
    amplitude: xe,
    arabicForm: null,
    ascent: xe,
    attributeName: null,
    attributeType: null,
    azimuth: xe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: xe,
    by: null,
    calcMode: null,
    capHeight: xe,
    className: Ct,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: xe,
    diffuseConstant: xe,
    direction: null,
    display: null,
    dur: null,
    divisor: xe,
    dominantBaseline: null,
    download: Je,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: xe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: xe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: xe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ho,
    g2: ho,
    glyphName: ho,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: xe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: xe,
    horizOriginX: xe,
    horizOriginY: xe,
    id: null,
    ideographic: xe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: xe,
    k: xe,
    k1: xe,
    k2: xe,
    k3: xe,
    k4: xe,
    kernelMatrix: Wn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: xe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: xe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: xe,
    overlineThickness: xe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: xe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Ct,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: xe,
    pointsAtY: xe,
    pointsAtZ: xe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Wn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Wn,
    rev: Wn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Wn,
    requiredFeatures: Wn,
    requiredFonts: Wn,
    requiredFormats: Wn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: xe,
    specularExponent: xe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: xe,
    strikethroughThickness: xe,
    string: null,
    stroke: null,
    strokeDashArray: Wn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: xe,
    strokeOpacity: xe,
    strokeWidth: null,
    style: null,
    surfaceScale: xe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Wn,
    tabIndex: xe,
    tableValues: null,
    target: null,
    targetX: xe,
    targetY: xe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Wn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: xe,
    underlineThickness: xe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: xe,
    values: null,
    vAlphabetic: xe,
    vMathematical: xe,
    vectorEffect: null,
    vHanging: xe,
    vIdeographic: xe,
    version: null,
    vertAdvY: xe,
    vertOriginX: xe,
    vertOriginY: xe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: xe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: mb
}), yb = Yo({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), xb = Yo({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: gb
}), vb = Yo({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), rN = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, iN = /[A-Z]/g, jy = /-[a-z]/g, aN = /^data[-\w.:]+$/i;
function oN(e, t) {
  const n = Jh(t);
  let r = t, i = zn;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && aN.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(jy, lN);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!jy.test(a)) {
        let o = a.replace(iN, sN);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = Im;
  }
  return new i(r, t);
}
function sN(e) {
  return "-" + e.toLowerCase();
}
function lN(e) {
  return e.charAt(1).toUpperCase();
}
const cN = hb([pb, tN, yb, xb, vb], "html"), Nm = hb([pb, nN, yb, xb, vb], "svg");
function uN(e) {
  return e.join(" ").trim();
}
var Om = {}, Wy = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, fN = /\n/g, dN = /^\s*/, hN = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, pN = /^:\s*/, mN = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, gN = /^[;\s]*/, yN = /^\s+|\s+$/g, xN = `
`, Hy = "/", Uy = "*", ma = "", vN = "comment", AN = "declaration", bN = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(m) {
    var g = m.match(fN);
    g && (n += g.length);
    var v = m.lastIndexOf(xN);
    r = ~v ? m.length - v : r + m.length;
  }
  function a() {
    var m = { line: n, column: r };
    return function(g) {
      return g.position = new o(m), l(), g;
    };
  }
  function o(m) {
    this.start = m, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function s(m) {
    var g = new Error(
      t.source + ":" + n + ":" + r + ": " + m
    );
    if (g.reason = m, g.filename = t.source, g.line = n, g.column = r, g.source = e, !t.silent) throw g;
  }
  function c(m) {
    var g = m.exec(e);
    if (g) {
      var v = g[0];
      return i(v), e = e.slice(v.length), g;
    }
  }
  function l() {
    c(dN);
  }
  function u(m) {
    var g;
    for (m = m || []; g = d(); )
      g !== !1 && m.push(g);
    return m;
  }
  function d() {
    var m = a();
    if (!(Hy != e.charAt(0) || Uy != e.charAt(1))) {
      for (var g = 2; ma != e.charAt(g) && (Uy != e.charAt(g) || Hy != e.charAt(g + 1)); )
        ++g;
      if (g += 2, ma === e.charAt(g - 1))
        return s("End of comment missing");
      var v = e.slice(2, g - 2);
      return r += 2, i(v), e = e.slice(g), r += 2, m({
        type: vN,
        comment: v
      });
    }
  }
  function f() {
    var m = a(), g = c(hN);
    if (g) {
      if (d(), !c(pN)) return s("property missing ':'");
      var v = c(mN), _ = m({
        type: AN,
        property: Gy(g[0].replace(Wy, ma)),
        value: v ? Gy(v[0].replace(Wy, ma)) : ma
      });
      return c(gN), _;
    }
  }
  function h() {
    var m = [];
    u(m);
    for (var g; g = f(); )
      g !== !1 && (m.push(g), u(m));
    return m;
  }
  return l(), h();
};
function Gy(e) {
  return e ? e.replace(yN, ma) : ma;
}
var wN = Ca && Ca.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Om, "__esModule", { value: !0 });
Om.default = SN;
var _N = wN(bN);
function SN(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, _N.default)(e), i = typeof t == "function";
  return r.forEach(function(a) {
    if (a.type === "declaration") {
      var o = a.property, s = a.value;
      i ? t(o, s, a) : s && (n = n || {}, n[o] = s);
    }
  }), n;
}
var kf = {};
Object.defineProperty(kf, "__esModule", { value: !0 });
kf.camelCase = void 0;
var CN = /^--[a-zA-Z0-9_-]+$/, EN = /-([a-z])/g, kN = /^[^-]+$/, TN = /^-(webkit|moz|ms|o|khtml)-/, MN = /^-(ms)-/, IN = function(e) {
  return !e || kN.test(e) || CN.test(e);
}, NN = function(e, t) {
  return t.toUpperCase();
}, Vy = function(e, t) {
  return "".concat(t, "-");
}, ON = function(e, t) {
  return t === void 0 && (t = {}), IN(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(MN, Vy) : e = e.replace(TN, Vy), e.replace(EN, NN));
};
kf.camelCase = ON;
var RN = Ca && Ca.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, DN = RN(Om), PN = kf;
function ep(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, DN.default)(e, function(r, i) {
    r && i && (n[(0, PN.camelCase)(r, t)] = i);
  }), n;
}
ep.default = ep;
var LN = ep;
const zN = /* @__PURE__ */ vf(LN), Ab = bb("end"), Rm = bb("start");
function bb(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function BN(e) {
  const t = Rm(e), n = Ab(e);
  if (t && n)
    return { start: t, end: n };
}
function zs(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Qy(e.position) : "start" in e || "end" in e ? Qy(e) : "line" in e || "column" in e ? tp(e) : "";
}
function tp(e) {
  return qy(e && e.line) + ":" + qy(e && e.column);
}
function Qy(e) {
  return tp(e && e.start) + "-" + tp(e && e.end);
}
function qy(e) {
  return e && typeof e == "number" ? e : 1;
}
class bn extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", a = {}, o = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? i = t : !a.cause && t && (o = !0, i = t.message, a.cause = t), !a.ruleId && !a.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? a.ruleId = r : (a.source = r.slice(0, c), a.ruleId = r.slice(c + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const c = a.ancestors[a.ancestors.length - 1];
      c && (a.place = c.position);
    }
    const s = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = s ? s.line : void 0, this.name = zs(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
bn.prototype.file = "";
bn.prototype.name = "";
bn.prototype.reason = "";
bn.prototype.message = "";
bn.prototype.stack = "";
bn.prototype.column = void 0;
bn.prototype.line = void 0;
bn.prototype.ancestors = void 0;
bn.prototype.cause = void 0;
bn.prototype.fatal = void 0;
bn.prototype.place = void 0;
bn.prototype.ruleId = void 0;
bn.prototype.source = void 0;
const Dm = {}.hasOwnProperty, FN = /* @__PURE__ */ new Map(), $N = /[A-Z]/g, YN = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), jN = /* @__PURE__ */ new Set(["td", "th"]), wb = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function WN(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = JN(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = XN(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? Nm : cN,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, a = _b(i, e, void 0);
  return a && typeof a != "string" ? a : i.create(
    e,
    i.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function _b(e, t, n) {
  if (t.type === "element")
    return HN(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return UN(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return VN(e, t, n);
  if (t.type === "mdxjsEsm")
    return GN(e, t);
  if (t.type === "root")
    return QN(e, t, n);
  if (t.type === "text")
    return qN(e, t);
}
function HN(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = Nm, e.schema = i), e.ancestors.push(t);
  const a = Cb(e, t.tagName, !1), o = KN(e, t);
  let s = Lm(e, t);
  return YN.has(t.tagName) && (s = s.filter(function(c) {
    return typeof c == "string" ? !ZI(c) : !0;
  })), Sb(e, o, a, t), Pm(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function UN(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  tl(e, t.position);
}
function GN(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  tl(e, t.position);
}
function VN(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = Nm, e.schema = i), e.ancestors.push(t);
  const a = t.name === null ? e.Fragment : Cb(e, t.name, !0), o = ZN(e, t), s = Lm(e, t);
  return Sb(e, o, a, t), Pm(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function QN(e, t, n) {
  const r = {};
  return Pm(r, Lm(e, t)), e.create(t, e.Fragment, r, n);
}
function qN(e, t) {
  return t.value;
}
function Sb(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function Pm(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function XN(e, t, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children) ? n : t;
    return s ? l(a, o, s) : l(a, o);
  }
}
function JN(e, t) {
  return n;
  function n(r, i, a, o) {
    const s = Array.isArray(a.children), c = Rm(r);
    return t(
      i,
      a,
      o,
      s,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function KN(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && Dm.call(t.properties, i)) {
      const a = eO(e, i, t.properties[i]);
      if (a) {
        const [o, s] = a;
        e.tableCellAlignToStyle && o === "align" && typeof s == "string" && jN.has(t.tagName) ? r = s : n[o] = s;
      }
    }
  if (r) {
    const a = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    a[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function ZN(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const a = r.data.estree.body[0];
        a.type;
        const o = a.expression;
        o.type;
        const s = o.properties[0];
        s.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(s.argument)
        );
      } else
        tl(e, t.position);
    else {
      const i = r.name;
      let a;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const s = r.value.data.estree.body[0];
          s.type, a = e.evaluater.evaluateExpression(s.expression);
        } else
          tl(e, t.position);
      else
        a = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      a;
    }
  return n;
}
function Lm(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : FN;
  for (; ++r < t.children.length; ) {
    const a = t.children[r];
    let o;
    if (e.passKeys) {
      const c = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (c) {
        const l = i.get(c) || 0;
        o = c + "-" + l, i.set(c, l + 1);
      }
    }
    const s = _b(e, a, o);
    s !== void 0 && n.push(s);
  }
  return n;
}
function eO(e, t, n) {
  const r = oN(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? QI(n) : uN(n)), r.property === "style") {
      let i = typeof n == "object" ? n : tO(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = nO(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? rN[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function tO(e, t) {
  try {
    return zN(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new bn("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = wb + "#cannot-parse-style-attribute", i;
  }
}
function Cb(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let a = -1, o;
    for (; ++a < i.length; ) {
      const s = Fy(i[a]) ? { type: "Identifier", name: i[a] } : { type: "Literal", value: i[a] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: s,
        computed: !!(a && s.type === "Literal"),
        optional: !1
      } : s;
    }
    r = o;
  } else
    r = Fy(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return Dm.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  tl(e);
}
function tl(e, t) {
  const n = new bn(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = wb + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function nO(e) {
  const t = {};
  let n;
  for (n in e)
    Dm.call(e, n) && (t[rO(n)] = e[n]);
  return t;
}
function rO(e) {
  let t = e.replace($N, iO);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function iO(e) {
  return "-" + e.toLowerCase();
}
const Rd = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, aO = {};
function oO(e, t) {
  const n = aO, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Eb(e, r, i);
}
function Eb(e, t, n) {
  if (sO(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Xy(e.children, t, n);
  }
  return Array.isArray(e) ? Xy(e, t, n) : "";
}
function Xy(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Eb(e[i], t, n);
  return r.join("");
}
function sO(e) {
  return !!(e && typeof e == "object");
}
const Jy = document.createElement("i");
function zm(e) {
  const t = "&" + e + ";";
  Jy.innerHTML = t;
  const n = Jy.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function Vr(e, t, n, r) {
  const i = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); a < r.length; )
      o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function sr(e, t) {
  return e.length > 0 ? (Vr(e, e.length, 0, t), e) : t;
}
const Ky = {}.hasOwnProperty;
function lO(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    cO(t, e[n]);
  return t;
}
function cO(e, t) {
  let n;
  for (n in t) {
    const i = (Ky.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let o;
    if (a)
      for (o in a) {
        Ky.call(i, o) || (i[o] = []);
        const s = a[o];
        uO(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function uO(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Vr(e, 0, 0, r);
}
function kb(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function po(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const $r = qi(/[A-Za-z]/), Xn = qi(/[\dA-Za-z]/), fO = qi(/[#-'*+\--9=?A-Z^-~]/);
function np(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const rp = qi(/\d/), dO = qi(/[\dA-Fa-f]/), hO = qi(/[!-/:-@[-`{-~]/);
function Ve(e) {
  return e !== null && e < -2;
}
function Dn(e) {
  return e !== null && (e < 0 || e === 32);
}
function ut(e) {
  return e === -2 || e === -1 || e === 32;
}
const pO = qi(new RegExp("\\p{P}|\\p{S}", "u")), mO = qi(/\s/);
function qi(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function jo(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const a = e.charCodeAt(n);
    let o = "";
    if (a === 37 && Xn(e.charCodeAt(n + 1)) && Xn(e.charCodeAt(n + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const s = e.charCodeAt(n + 1);
      a < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(a, s), i = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function kt(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(c) {
    return ut(c) ? (e.enter(n), s(c)) : t(c);
  }
  function s(c) {
    return ut(c) && a++ < i ? (e.consume(c), s) : (e.exit(n), t(c));
  }
}
const gO = {
  tokenize: yO
};
function yO(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), kt(e, t, "linePrefix");
  }
  function i(s) {
    return e.enter("paragraph"), a(s);
  }
  function a(s) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, o(s);
  }
  function o(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return Ve(s) ? (e.consume(s), e.exit("chunkText"), a) : (e.consume(s), o);
  }
}
const xO = {
  tokenize: vO
}, Zy = {
  tokenize: AO
};
function vO(e) {
  const t = this, n = [];
  let r = 0, i, a, o;
  return s;
  function s(M) {
    if (r < n.length) {
      const k = n[r];
      return t.containerState = k[1], e.attempt(k[0].continuation, c, l)(M);
    }
    return l(M);
  }
  function c(M) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && I();
      const k = t.events.length;
      let y = k, x;
      for (; y--; )
        if (t.events[y][0] === "exit" && t.events[y][1].type === "chunkFlow") {
          x = t.events[y][1].end;
          break;
        }
      _(r);
      let b = k;
      for (; b < t.events.length; )
        t.events[b][1].end = {
          ...x
        }, b++;
      return Vr(t.events, y + 1, 0, t.events.slice(k)), t.events.length = b, l(M);
    }
    return s(M);
  }
  function l(M) {
    if (r === n.length) {
      if (!i)
        return f(M);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return m(M);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Zy, u, d)(M);
  }
  function u(M) {
    return i && I(), _(r), f(M);
  }
  function d(M) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, m(M);
  }
  function f(M) {
    return t.containerState = {}, e.attempt(Zy, h, m)(M);
  }
  function h(M) {
    return r++, n.push([t.currentConstruct, t.containerState]), f(M);
  }
  function m(M) {
    if (M === null) {
      i && I(), _(0), e.consume(M);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: a
    }), g(M);
  }
  function g(M) {
    if (M === null) {
      v(e.exit("chunkFlow"), !0), _(0), e.consume(M);
      return;
    }
    return Ve(M) ? (e.consume(M), v(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(M), g);
  }
  function v(M, k) {
    const y = t.sliceStream(M);
    if (k && y.push(null), M.previous = a, a && (a.next = M), a = M, i.defineSkip(M.start), i.write(y), t.parser.lazy[M.start.line]) {
      let x = i.events.length;
      for (; x--; )
        if (
          // The token starts before the line ending…
          i.events[x][1].start.offset < o && // …and either is not ended yet…
          (!i.events[x][1].end || // …or ends after it.
          i.events[x][1].end.offset > o)
        )
          return;
      const b = t.events.length;
      let A = b, w, O;
      for (; A--; )
        if (t.events[A][0] === "exit" && t.events[A][1].type === "chunkFlow") {
          if (w) {
            O = t.events[A][1].end;
            break;
          }
          w = !0;
        }
      for (_(r), x = b; x < t.events.length; )
        t.events[x][1].end = {
          ...O
        }, x++;
      Vr(t.events, A + 1, 0, t.events.slice(b)), t.events.length = x;
    }
  }
  function _(M) {
    let k = n.length;
    for (; k-- > M; ) {
      const y = n[k];
      t.containerState = y[1], y[0].exit.call(t, e);
    }
    n.length = M;
  }
  function I() {
    i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function AO(e, t, n) {
  return kt(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function e1(e) {
  if (e === null || Dn(e) || mO(e))
    return 1;
  if (pO(e))
    return 2;
}
function Bm(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (t = a(t, n), r.push(a));
  }
  return t;
}
const ip = {
  name: "attention",
  resolveAll: bO,
  tokenize: wO
};
function bO(e, t) {
  let n = -1, r, i, a, o, s, c, l, u;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = {
            ...e[r][1].end
          }, f = {
            ...e[n][1].start
          };
          t1(d, -c), t1(f, c), o = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: {
              ...e[r][1].end
            }
          }, s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: f
          }, a = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...s.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...s.end
          }, l = [], e[r][1].end.offset - e[r][1].start.offset && (l = sr(l, [["enter", e[r][1], t], ["exit", e[r][1], t]])), l = sr(l, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["enter", a, t]]), l = sr(l, Bm(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), l = sr(l, [["exit", a, t], ["enter", s, t], ["exit", s, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (u = 2, l = sr(l, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : u = 0, Vr(e, r - 1, n - r + 3, l), n = r + l.length - u - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function wO(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = e1(r);
  let a;
  return o;
  function o(c) {
    return a = c, e.enter("attentionSequence"), s(c);
  }
  function s(c) {
    if (c === a)
      return e.consume(c), s;
    const l = e.exit("attentionSequence"), u = e1(c), d = !u || u === 2 && i || n.includes(c), f = !i || i === 2 && u || n.includes(r);
    return l._open = !!(a === 42 ? d : d && (i || !f)), l._close = !!(a === 42 ? f : f && (u || !d)), t(c);
  }
}
function t1(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const _O = {
  name: "autolink",
  tokenize: SO
};
function SO(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(h) {
    return $r(h) ? (e.consume(h), o) : h === 64 ? n(h) : l(h);
  }
  function o(h) {
    return h === 43 || h === 45 || h === 46 || Xn(h) ? (r = 1, s(h)) : l(h);
  }
  function s(h) {
    return h === 58 ? (e.consume(h), r = 0, c) : (h === 43 || h === 45 || h === 46 || Xn(h)) && r++ < 32 ? (e.consume(h), s) : (r = 0, l(h));
  }
  function c(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || np(h) ? n(h) : (e.consume(h), c);
  }
  function l(h) {
    return h === 64 ? (e.consume(h), u) : fO(h) ? (e.consume(h), l) : n(h);
  }
  function u(h) {
    return Xn(h) ? d(h) : n(h);
  }
  function d(h) {
    return h === 46 ? (e.consume(h), r = 0, u) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(h);
  }
  function f(h) {
    if ((h === 45 || Xn(h)) && r++ < 63) {
      const m = h === 45 ? f : d;
      return e.consume(h), m;
    }
    return n(h);
  }
}
const Tf = {
  partial: !0,
  tokenize: CO
};
function CO(e, t, n) {
  return r;
  function r(a) {
    return ut(a) ? kt(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || Ve(a) ? t(a) : n(a);
  }
}
const Tb = {
  continuation: {
    tokenize: kO
  },
  exit: TO,
  name: "blockQuote",
  tokenize: EO
};
function EO(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return n(o);
  }
  function a(o) {
    return ut(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function kO(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return ut(o) ? kt(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : a(o);
  }
  function a(o) {
    return e.attempt(Tb, t, n)(o);
  }
}
function TO(e) {
  e.exit("blockQuote");
}
const Mb = {
  name: "characterEscape",
  tokenize: MO
};
function MO(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return hO(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const Ib = {
  name: "characterReference",
  tokenize: IO
};
function IO(e, t, n) {
  const r = this;
  let i = 0, a, o;
  return s;
  function s(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), c;
  }
  function c(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), a = 31, o = Xn, u(d));
  }
  function l(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = dO, u) : (e.enter("characterReferenceValue"), a = 7, o = rp, u(d));
  }
  function u(d) {
    if (d === 59 && i) {
      const f = e.exit("characterReferenceValue");
      return o === Xn && !zm(r.sliceSerialize(f)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(d) && i++ < a ? (e.consume(d), u) : n(d);
  }
}
const n1 = {
  partial: !0,
  tokenize: OO
}, r1 = {
  concrete: !0,
  name: "codeFenced",
  tokenize: NO
};
function NO(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: y
  };
  let a = 0, o = 0, s;
  return c;
  function c(x) {
    return l(x);
  }
  function l(x) {
    const b = r.events[r.events.length - 1];
    return a = b && b[1].type === "linePrefix" ? b[2].sliceSerialize(b[1], !0).length : 0, s = x, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(x);
  }
  function u(x) {
    return x === s ? (o++, e.consume(x), u) : o < 3 ? n(x) : (e.exit("codeFencedFenceSequence"), ut(x) ? kt(e, d, "whitespace")(x) : d(x));
  }
  function d(x) {
    return x === null || Ve(x) ? (e.exit("codeFencedFence"), r.interrupt ? t(x) : e.check(n1, g, k)(x)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(x));
  }
  function f(x) {
    return x === null || Ve(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(x)) : ut(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), kt(e, h, "whitespace")(x)) : x === 96 && x === s ? n(x) : (e.consume(x), f);
  }
  function h(x) {
    return x === null || Ve(x) ? d(x) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), m(x));
  }
  function m(x) {
    return x === null || Ve(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(x)) : x === 96 && x === s ? n(x) : (e.consume(x), m);
  }
  function g(x) {
    return e.attempt(i, k, v)(x);
  }
  function v(x) {
    return e.enter("lineEnding"), e.consume(x), e.exit("lineEnding"), _;
  }
  function _(x) {
    return a > 0 && ut(x) ? kt(e, I, "linePrefix", a + 1)(x) : I(x);
  }
  function I(x) {
    return x === null || Ve(x) ? e.check(n1, g, k)(x) : (e.enter("codeFlowValue"), M(x));
  }
  function M(x) {
    return x === null || Ve(x) ? (e.exit("codeFlowValue"), I(x)) : (e.consume(x), M);
  }
  function k(x) {
    return e.exit("codeFenced"), t(x);
  }
  function y(x, b, A) {
    let w = 0;
    return O;
    function O(D) {
      return x.enter("lineEnding"), x.consume(D), x.exit("lineEnding"), P;
    }
    function P(D) {
      return x.enter("codeFencedFence"), ut(D) ? kt(x, E, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : E(D);
    }
    function E(D) {
      return D === s ? (x.enter("codeFencedFenceSequence"), C(D)) : A(D);
    }
    function C(D) {
      return D === s ? (w++, x.consume(D), C) : w >= o ? (x.exit("codeFencedFenceSequence"), ut(D) ? kt(x, T, "whitespace")(D) : T(D)) : A(D);
    }
    function T(D) {
      return D === null || Ve(D) ? (x.exit("codeFencedFence"), b(D)) : A(D);
    }
  }
}
function OO(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const Dd = {
  name: "codeIndented",
  tokenize: DO
}, RO = {
  partial: !0,
  tokenize: PO
};
function DO(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("codeIndented"), kt(e, a, "linePrefix", 5)(l);
  }
  function a(l) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? o(l) : n(l);
  }
  function o(l) {
    return l === null ? c(l) : Ve(l) ? e.attempt(RO, o, c)(l) : (e.enter("codeFlowValue"), s(l));
  }
  function s(l) {
    return l === null || Ve(l) ? (e.exit("codeFlowValue"), o(l)) : (e.consume(l), s);
  }
  function c(l) {
    return e.exit("codeIndented"), t(l);
  }
}
function PO(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : Ve(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : kt(e, a, "linePrefix", 5)(o);
  }
  function a(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : Ve(o) ? i(o) : n(o);
  }
}
const LO = {
  name: "codeText",
  previous: BO,
  resolve: zO,
  tokenize: FO
};
function zO(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function BO(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function FO(e, t, n) {
  let r = 0, i, a;
  return o;
  function o(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(d);
  }
  function s(d) {
    return d === 96 ? (e.consume(d), r++, s) : (e.exit("codeTextSequence"), c(d));
  }
  function c(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), c) : d === 96 ? (a = e.enter("codeTextSequence"), i = 0, u(d)) : Ve(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), c) : (e.enter("codeTextData"), l(d));
  }
  function l(d) {
    return d === null || d === 32 || d === 96 || Ve(d) ? (e.exit("codeTextData"), c(d)) : (e.consume(d), l);
  }
  function u(d) {
    return d === 96 ? (e.consume(d), i++, u) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (a.type = "codeTextData", l(d));
  }
}
class $O {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const a = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && rs(this.left, r), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), rs(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), rs(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        rs(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        rs(this.left, n.reverse());
      }
  }
}
function rs(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Nb(e) {
  const t = {};
  let n = -1, r, i, a, o, s, c, l;
  const u = new $O(e);
  for (; ++n < u.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, a = 0, a < c.length && c[a][1].type === "lineEndingBlank" && (a += 2), a < c.length && c[a][1].type === "content"))
      for (; ++a < c.length && c[a][1].type !== "content"; )
        c[a][1].type === "chunkText" && (c[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, YO(u, n)), n = t[n], l = !0);
    else if (r[1]._container) {
      for (a = n, i = void 0; a--; )
        if (o = u.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...u.get(i)[1].start
      }, s = u.slice(i, n), s.unshift(r), u.splice(i, n - i + 1, s));
    }
  }
  return Vr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !l;
}
function YO(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const a = [];
  let o = n._tokenizer;
  o || (o = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const s = o.events, c = [], l = {};
  let u, d, f = -1, h = n, m = 0, g = 0;
  const v = [g];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    a.push(i), h._tokenizer || (u = r.sliceStream(h), h.next || u.push(null), d && o.defineSkip(h.start), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = n; ++f < s.length; )
    // Find a void token that includes a break.
    s[f][0] === "exit" && s[f - 1][0] === "enter" && s[f][1].type === s[f - 1][1].type && s[f][1].start.line !== s[f][1].end.line && (g = f + 1, v.push(g), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (o.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : v.pop(), f = v.length; f--; ) {
    const _ = s.slice(v[f], v[f + 1]), I = a.pop();
    c.push([I, I + _.length - 1]), e.splice(I, 2, _);
  }
  for (c.reverse(), f = -1; ++f < c.length; )
    l[m + c[f][0]] = m + c[f][1], m += c[f][1] - c[f][0] - 1;
  return l;
}
const jO = {
  resolve: HO,
  tokenize: UO
}, WO = {
  partial: !0,
  tokenize: GO
};
function HO(e) {
  return Nb(e), e;
}
function UO(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? a(s) : Ve(s) ? e.check(WO, o, a)(s) : (e.consume(s), i);
  }
  function a(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function o(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function GO(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), kt(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || Ve(o))
      return n(o);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function Ob(e, t, n, r, i, a, o, s, c) {
  const l = c || Number.POSITIVE_INFINITY;
  let u = 0;
  return d;
  function d(_) {
    return _ === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(_), e.exit(a), f) : _ === null || _ === 32 || _ === 41 || np(_) ? n(_) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), g(_));
  }
  function f(_) {
    return _ === 62 ? (e.enter(a), e.consume(_), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), h(_));
  }
  function h(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(s), f(_)) : _ === null || _ === 60 || Ve(_) ? n(_) : (e.consume(_), _ === 92 ? m : h);
  }
  function m(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), h) : h(_);
  }
  function g(_) {
    return !u && (_ === null || _ === 41 || Dn(_)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(_)) : u < l && _ === 40 ? (e.consume(_), u++, g) : _ === 41 ? (e.consume(_), u--, g) : _ === null || _ === 32 || _ === 40 || np(_) ? n(_) : (e.consume(_), _ === 92 ? v : g);
  }
  function v(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), g) : g(_);
  }
}
function Rb(e, t, n, r, i, a) {
  const o = this;
  let s = 0, c;
  return l;
  function l(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(a), u;
  }
  function u(h) {
    return s > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(h) : h === 93 ? (e.exit(a), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : Ve(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || Ve(h) || s++ > 999 ? (e.exit("chunkString"), u(h)) : (e.consume(h), c || (c = !ut(h)), h === 92 ? f : d);
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), s++, d) : d(h);
  }
}
function Db(e, t, n, r, i, a) {
  let o;
  return s;
  function s(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(r), e.enter(i), e.consume(f), e.exit(i), o = f === 40 ? 41 : f, c) : n(f);
  }
  function c(f) {
    return f === o ? (e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : (e.enter(a), l(f));
  }
  function l(f) {
    return f === o ? (e.exit(a), c(o)) : f === null ? n(f) : Ve(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), kt(e, l, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(f));
  }
  function u(f) {
    return f === o || f === null || Ve(f) ? (e.exit("chunkString"), l(f)) : (e.consume(f), f === 92 ? d : u);
  }
  function d(f) {
    return f === o || f === 92 ? (e.consume(f), u) : u(f);
  }
}
function Bs(e, t) {
  let n;
  return r;
  function r(i) {
    return Ve(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : ut(i) ? kt(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const VO = {
  name: "definition",
  tokenize: qO
}, QO = {
  partial: !0,
  tokenize: XO
};
function qO(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(h) {
    return e.enter("definition"), o(h);
  }
  function o(h) {
    return Rb.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function s(h) {
    return i = po(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), c) : n(h);
  }
  function c(h) {
    return Dn(h) ? Bs(e, l)(h) : l(h);
  }
  function l(h) {
    return Ob(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function u(h) {
    return e.attempt(QO, d, d)(h);
  }
  function d(h) {
    return ut(h) ? kt(e, f, "whitespace")(h) : f(h);
  }
  function f(h) {
    return h === null || Ve(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function XO(e, t, n) {
  return r;
  function r(s) {
    return Dn(s) ? Bs(e, i)(s) : n(s);
  }
  function i(s) {
    return Db(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(s);
  }
  function a(s) {
    return ut(s) ? kt(e, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || Ve(s) ? t(s) : n(s);
  }
}
const JO = {
  name: "hardBreakEscape",
  tokenize: KO
};
function KO(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return Ve(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const ZO = {
  name: "headingAtx",
  resolve: eR,
  tokenize: tR
};
function eR(e, t) {
  let n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Vr(e, r, n - r + 1, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]])), e;
}
function tR(e, t, n) {
  let r = 0;
  return i;
  function i(u) {
    return e.enter("atxHeading"), a(u);
  }
  function a(u) {
    return e.enter("atxHeadingSequence"), o(u);
  }
  function o(u) {
    return u === 35 && r++ < 6 ? (e.consume(u), o) : u === null || Dn(u) ? (e.exit("atxHeadingSequence"), s(u)) : n(u);
  }
  function s(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), c(u)) : u === null || Ve(u) ? (e.exit("atxHeading"), t(u)) : ut(u) ? kt(e, s, "whitespace")(u) : (e.enter("atxHeadingText"), l(u));
  }
  function c(u) {
    return u === 35 ? (e.consume(u), c) : (e.exit("atxHeadingSequence"), s(u));
  }
  function l(u) {
    return u === null || u === 35 || Dn(u) ? (e.exit("atxHeadingText"), s(u)) : (e.consume(u), l);
  }
}
const nR = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], i1 = ["pre", "script", "style", "textarea"], rR = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: oR,
  tokenize: sR
}, iR = {
  partial: !0,
  tokenize: cR
}, aR = {
  partial: !0,
  tokenize: lR
};
function oR(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function sR(e, t, n) {
  const r = this;
  let i, a, o, s, c;
  return l;
  function l(N) {
    return u(N);
  }
  function u(N) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(N), d;
  }
  function d(N) {
    return N === 33 ? (e.consume(N), f) : N === 47 ? (e.consume(N), a = !0, g) : N === 63 ? (e.consume(N), i = 3, r.interrupt ? t : S) : $r(N) ? (e.consume(N), o = String.fromCharCode(N), v) : n(N);
  }
  function f(N) {
    return N === 45 ? (e.consume(N), i = 2, h) : N === 91 ? (e.consume(N), i = 5, s = 0, m) : $r(N) ? (e.consume(N), i = 4, r.interrupt ? t : S) : n(N);
  }
  function h(N) {
    return N === 45 ? (e.consume(N), r.interrupt ? t : S) : n(N);
  }
  function m(N) {
    const X = "CDATA[";
    return N === X.charCodeAt(s++) ? (e.consume(N), s === X.length ? r.interrupt ? t : E : m) : n(N);
  }
  function g(N) {
    return $r(N) ? (e.consume(N), o = String.fromCharCode(N), v) : n(N);
  }
  function v(N) {
    if (N === null || N === 47 || N === 62 || Dn(N)) {
      const X = N === 47, G = o.toLowerCase();
      return !X && !a && i1.includes(G) ? (i = 1, r.interrupt ? t(N) : E(N)) : nR.includes(o.toLowerCase()) ? (i = 6, X ? (e.consume(N), _) : r.interrupt ? t(N) : E(N)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(N) : a ? I(N) : M(N));
    }
    return N === 45 || Xn(N) ? (e.consume(N), o += String.fromCharCode(N), v) : n(N);
  }
  function _(N) {
    return N === 62 ? (e.consume(N), r.interrupt ? t : E) : n(N);
  }
  function I(N) {
    return ut(N) ? (e.consume(N), I) : O(N);
  }
  function M(N) {
    return N === 47 ? (e.consume(N), O) : N === 58 || N === 95 || $r(N) ? (e.consume(N), k) : ut(N) ? (e.consume(N), M) : O(N);
  }
  function k(N) {
    return N === 45 || N === 46 || N === 58 || N === 95 || Xn(N) ? (e.consume(N), k) : y(N);
  }
  function y(N) {
    return N === 61 ? (e.consume(N), x) : ut(N) ? (e.consume(N), y) : M(N);
  }
  function x(N) {
    return N === null || N === 60 || N === 61 || N === 62 || N === 96 ? n(N) : N === 34 || N === 39 ? (e.consume(N), c = N, b) : ut(N) ? (e.consume(N), x) : A(N);
  }
  function b(N) {
    return N === c ? (e.consume(N), c = null, w) : N === null || Ve(N) ? n(N) : (e.consume(N), b);
  }
  function A(N) {
    return N === null || N === 34 || N === 39 || N === 47 || N === 60 || N === 61 || N === 62 || N === 96 || Dn(N) ? y(N) : (e.consume(N), A);
  }
  function w(N) {
    return N === 47 || N === 62 || ut(N) ? M(N) : n(N);
  }
  function O(N) {
    return N === 62 ? (e.consume(N), P) : n(N);
  }
  function P(N) {
    return N === null || Ve(N) ? E(N) : ut(N) ? (e.consume(N), P) : n(N);
  }
  function E(N) {
    return N === 45 && i === 2 ? (e.consume(N), z) : N === 60 && i === 1 ? (e.consume(N), F) : N === 62 && i === 4 ? (e.consume(N), j) : N === 63 && i === 3 ? (e.consume(N), S) : N === 93 && i === 5 ? (e.consume(N), L) : Ve(N) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(iR, Y, C)(N)) : N === null || Ve(N) ? (e.exit("htmlFlowData"), C(N)) : (e.consume(N), E);
  }
  function C(N) {
    return e.check(aR, T, Y)(N);
  }
  function T(N) {
    return e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), D;
  }
  function D(N) {
    return N === null || Ve(N) ? C(N) : (e.enter("htmlFlowData"), E(N));
  }
  function z(N) {
    return N === 45 ? (e.consume(N), S) : E(N);
  }
  function F(N) {
    return N === 47 ? (e.consume(N), o = "", W) : E(N);
  }
  function W(N) {
    if (N === 62) {
      const X = o.toLowerCase();
      return i1.includes(X) ? (e.consume(N), j) : E(N);
    }
    return $r(N) && o.length < 8 ? (e.consume(N), o += String.fromCharCode(N), W) : E(N);
  }
  function L(N) {
    return N === 93 ? (e.consume(N), S) : E(N);
  }
  function S(N) {
    return N === 62 ? (e.consume(N), j) : N === 45 && i === 2 ? (e.consume(N), S) : E(N);
  }
  function j(N) {
    return N === null || Ve(N) ? (e.exit("htmlFlowData"), Y(N)) : (e.consume(N), j);
  }
  function Y(N) {
    return e.exit("htmlFlow"), t(N);
  }
}
function lR(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return Ve(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : n(o);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function cR(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Tf, t, n);
  }
}
const uR = {
  name: "htmlText",
  tokenize: fR
};
function fR(e, t, n) {
  const r = this;
  let i, a, o;
  return s;
  function s(S) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(S), c;
  }
  function c(S) {
    return S === 33 ? (e.consume(S), l) : S === 47 ? (e.consume(S), y) : S === 63 ? (e.consume(S), M) : $r(S) ? (e.consume(S), A) : n(S);
  }
  function l(S) {
    return S === 45 ? (e.consume(S), u) : S === 91 ? (e.consume(S), a = 0, m) : $r(S) ? (e.consume(S), I) : n(S);
  }
  function u(S) {
    return S === 45 ? (e.consume(S), h) : n(S);
  }
  function d(S) {
    return S === null ? n(S) : S === 45 ? (e.consume(S), f) : Ve(S) ? (o = d, F(S)) : (e.consume(S), d);
  }
  function f(S) {
    return S === 45 ? (e.consume(S), h) : d(S);
  }
  function h(S) {
    return S === 62 ? z(S) : S === 45 ? f(S) : d(S);
  }
  function m(S) {
    const j = "CDATA[";
    return S === j.charCodeAt(a++) ? (e.consume(S), a === j.length ? g : m) : n(S);
  }
  function g(S) {
    return S === null ? n(S) : S === 93 ? (e.consume(S), v) : Ve(S) ? (o = g, F(S)) : (e.consume(S), g);
  }
  function v(S) {
    return S === 93 ? (e.consume(S), _) : g(S);
  }
  function _(S) {
    return S === 62 ? z(S) : S === 93 ? (e.consume(S), _) : g(S);
  }
  function I(S) {
    return S === null || S === 62 ? z(S) : Ve(S) ? (o = I, F(S)) : (e.consume(S), I);
  }
  function M(S) {
    return S === null ? n(S) : S === 63 ? (e.consume(S), k) : Ve(S) ? (o = M, F(S)) : (e.consume(S), M);
  }
  function k(S) {
    return S === 62 ? z(S) : M(S);
  }
  function y(S) {
    return $r(S) ? (e.consume(S), x) : n(S);
  }
  function x(S) {
    return S === 45 || Xn(S) ? (e.consume(S), x) : b(S);
  }
  function b(S) {
    return Ve(S) ? (o = b, F(S)) : ut(S) ? (e.consume(S), b) : z(S);
  }
  function A(S) {
    return S === 45 || Xn(S) ? (e.consume(S), A) : S === 47 || S === 62 || Dn(S) ? w(S) : n(S);
  }
  function w(S) {
    return S === 47 ? (e.consume(S), z) : S === 58 || S === 95 || $r(S) ? (e.consume(S), O) : Ve(S) ? (o = w, F(S)) : ut(S) ? (e.consume(S), w) : z(S);
  }
  function O(S) {
    return S === 45 || S === 46 || S === 58 || S === 95 || Xn(S) ? (e.consume(S), O) : P(S);
  }
  function P(S) {
    return S === 61 ? (e.consume(S), E) : Ve(S) ? (o = P, F(S)) : ut(S) ? (e.consume(S), P) : w(S);
  }
  function E(S) {
    return S === null || S === 60 || S === 61 || S === 62 || S === 96 ? n(S) : S === 34 || S === 39 ? (e.consume(S), i = S, C) : Ve(S) ? (o = E, F(S)) : ut(S) ? (e.consume(S), E) : (e.consume(S), T);
  }
  function C(S) {
    return S === i ? (e.consume(S), i = void 0, D) : S === null ? n(S) : Ve(S) ? (o = C, F(S)) : (e.consume(S), C);
  }
  function T(S) {
    return S === null || S === 34 || S === 39 || S === 60 || S === 61 || S === 96 ? n(S) : S === 47 || S === 62 || Dn(S) ? w(S) : (e.consume(S), T);
  }
  function D(S) {
    return S === 47 || S === 62 || Dn(S) ? w(S) : n(S);
  }
  function z(S) {
    return S === 62 ? (e.consume(S), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(S);
  }
  function F(S) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), W;
  }
  function W(S) {
    return ut(S) ? kt(e, L, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(S) : L(S);
  }
  function L(S) {
    return e.enter("htmlTextData"), o(S);
  }
}
const Fm = {
  name: "labelEnd",
  resolveAll: mR,
  resolveTo: gR,
  tokenize: yR
}, dR = {
  tokenize: xR
}, hR = {
  tokenize: vR
}, pR = {
  tokenize: AR
};
function mR(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && Vr(e, 0, e.length, n), e;
}
function gR(e, t) {
  let n = e.length, r = 0, i, a, o, s;
  for (; n--; )
    if (i = e[n][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = n);
  const c = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, l = {
    type: "label",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[a + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return s = [["enter", c, t], ["enter", l, t]], s = sr(s, e.slice(a + 1, a + r + 3)), s = sr(s, [["enter", u, t]]), s = sr(s, Bm(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), t)), s = sr(s, [["exit", u, t], e[o - 2], e[o - 1], ["exit", l, t]]), s = sr(s, e.slice(o + 1)), s = sr(s, [["exit", c, t]]), Vr(e, a, e.length, s), e;
}
function yR(e, t, n) {
  const r = this;
  let i = r.events.length, a, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return s;
  function s(f) {
    return a ? a._inactive ? d(f) : (o = r.parser.defined.includes(po(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(f);
  }
  function c(f) {
    return f === 40 ? e.attempt(dR, u, o ? u : d)(f) : f === 91 ? e.attempt(hR, u, o ? l : d)(f) : o ? u(f) : d(f);
  }
  function l(f) {
    return e.attempt(pR, u, d)(f);
  }
  function u(f) {
    return t(f);
  }
  function d(f) {
    return a._balanced = !0, n(f);
  }
}
function xR(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return Dn(d) ? Bs(e, a)(d) : a(d);
  }
  function a(d) {
    return d === 41 ? u(d) : Ob(e, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function o(d) {
    return Dn(d) ? Bs(e, c)(d) : u(d);
  }
  function s(d) {
    return n(d);
  }
  function c(d) {
    return d === 34 || d === 39 || d === 40 ? Db(e, l, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : u(d);
  }
  function l(d) {
    return Dn(d) ? Bs(e, u)(d) : u(d);
  }
  function u(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function vR(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return Rb.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(s);
  }
  function a(s) {
    return r.parser.defined.includes(po(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(s) : n(s);
  }
  function o(s) {
    return n(s);
  }
}
function AR(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const bR = {
  name: "labelStartImage",
  resolveAll: Fm.resolveAll,
  tokenize: wR
};
function wR(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), a;
  }
  function a(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), o) : n(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const _R = {
  name: "labelStartLink",
  resolveAll: Fm.resolveAll,
  tokenize: SR
};
function SR(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const Pd = {
  name: "lineEnding",
  tokenize: CR
};
function CR(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), kt(e, t, "linePrefix");
  }
}
const Uc = {
  name: "thematicBreak",
  tokenize: ER
};
function ER(e, t, n) {
  let r = 0, i;
  return a;
  function a(l) {
    return e.enter("thematicBreak"), o(l);
  }
  function o(l) {
    return i = l, s(l);
  }
  function s(l) {
    return l === i ? (e.enter("thematicBreakSequence"), c(l)) : r >= 3 && (l === null || Ve(l)) ? (e.exit("thematicBreak"), t(l)) : n(l);
  }
  function c(l) {
    return l === i ? (e.consume(l), r++, c) : (e.exit("thematicBreakSequence"), ut(l) ? kt(e, s, "whitespace")(l) : s(l));
  }
}
const On = {
  continuation: {
    tokenize: IR
  },
  exit: OR,
  name: "list",
  tokenize: MR
}, kR = {
  partial: !0,
  tokenize: RR
}, TR = {
  partial: !0,
  tokenize: NR
};
function MR(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return s;
  function s(h) {
    const m = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (m === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : rp(h)) {
      if (r.containerState.type || (r.containerState.type = m, e.enter(m, {
        _container: !0
      })), m === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(Uc, n, l)(h) : l(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(h);
    }
    return n(h);
  }
  function c(h) {
    return rp(h) && ++o < 10 ? (e.consume(h), c) : (!r.interrupt || o < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), l(h)) : n(h);
  }
  function l(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      Tf,
      // Can’t be empty when interrupting.
      r.interrupt ? n : u,
      e.attempt(kR, f, d)
    );
  }
  function u(h) {
    return r.containerState.initialBlankLine = !0, a++, f(h);
  }
  function d(h) {
    return ut(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), f) : n(h);
  }
  function f(h) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function IR(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Tf, i, a);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, kt(e, t, "listItemIndent", r.containerState.size + 1)(s);
  }
  function a(s) {
    return r.containerState.furtherBlankLines || !ut(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(TR, t, o)(s));
  }
  function o(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, kt(e, e.attempt(On, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s);
  }
}
function NR(e, t, n) {
  const r = this;
  return kt(e, i, "listItemIndent", r.containerState.size + 1);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(a) : n(a);
  }
}
function OR(e) {
  e.exit(this.containerState.type);
}
function RR(e, t, n) {
  const r = this;
  return kt(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return !ut(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const a1 = {
  name: "setextUnderline",
  resolveTo: DR,
  tokenize: PR
};
function DR(e, t) {
  let n = e.length, r, i, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[a][1].end
  }) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function PR(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(l) {
    let u = r.events.length, d;
    for (; u--; )
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        d = r.events[u][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = l, o(l)) : n(l);
  }
  function o(l) {
    return e.enter("setextHeadingLineSequence"), s(l);
  }
  function s(l) {
    return l === i ? (e.consume(l), s) : (e.exit("setextHeadingLineSequence"), ut(l) ? kt(e, c, "lineSuffix")(l) : c(l));
  }
  function c(l) {
    return l === null || Ve(l) ? (e.exit("setextHeadingLine"), t(l)) : n(l);
  }
}
const LR = {
  tokenize: zR
};
function zR(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Tf,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, kt(e, e.attempt(this.parser.constructs.flow, i, e.attempt(jO, i)), "linePrefix"))
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const BR = {
  resolveAll: Lb()
}, FR = Pb("string"), $R = Pb("text");
function Pb(e) {
  return {
    resolveAll: Lb(e === "text" ? YR : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], a = n.attempt(i, o, s);
    return o;
    function o(u) {
      return l(u) ? a(u) : s(u);
    }
    function s(u) {
      if (u === null) {
        n.consume(u);
        return;
      }
      return n.enter("data"), n.consume(u), c;
    }
    function c(u) {
      return l(u) ? (n.exit("data"), a(u)) : (n.consume(u), c);
    }
    function l(u) {
      if (u === null)
        return !0;
      const d = i[u];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const h = d[f];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Lb(e) {
  return t;
  function t(n, r) {
    let i = -1, a;
    for (; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function YR(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let a = i.length, o = -1, s = 0, c;
      for (; a--; ) {
        const l = i[a];
        if (typeof l == "string") {
          for (o = l.length; l.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o) break;
          o = -1;
        } else if (l === -2)
          c = !0, s++;
        else if (l !== -1) {
          a++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (s = 0), s) {
        const l = {
          type: n === e.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: a ? o : r.start._bufferIndex + o,
            _index: r.start._index + a,
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...l.start
        }, r.start.offset === r.end.offset ? Object.assign(r, l) : (e.splice(n, 0, ["enter", l, t], ["exit", l, t]), n += 2);
      }
      n++;
    }
  return e;
}
const jR = {
  42: On,
  43: On,
  45: On,
  48: On,
  49: On,
  50: On,
  51: On,
  52: On,
  53: On,
  54: On,
  55: On,
  56: On,
  57: On,
  62: Tb
}, WR = {
  91: VO
}, HR = {
  [-2]: Dd,
  [-1]: Dd,
  32: Dd
}, UR = {
  35: ZO,
  42: Uc,
  45: [a1, Uc],
  60: rR,
  61: a1,
  95: Uc,
  96: r1,
  126: r1
}, GR = {
  38: Ib,
  92: Mb
}, VR = {
  [-5]: Pd,
  [-4]: Pd,
  [-3]: Pd,
  33: bR,
  38: Ib,
  42: ip,
  60: [_O, uR],
  91: _R,
  92: [JO, Mb],
  93: Fm,
  95: ip,
  96: LO
}, QR = {
  null: [ip, BR]
}, qR = {
  null: [42, 95]
}, XR = {
  null: []
}, JR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: qR,
  contentInitial: WR,
  disable: XR,
  document: jR,
  flow: UR,
  flowInitial: HR,
  insideSpan: QR,
  string: GR,
  text: VR
}, Symbol.toStringTag, { value: "Module" }));
function KR(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, a = [];
  let o = [], s = [];
  const c = {
    attempt: b(y),
    check: b(x),
    consume: I,
    enter: M,
    exit: k,
    interrupt: b(x, {
      interrupt: !0
    })
  }, l = {
    code: null,
    containerState: {},
    defineSkip: g,
    events: [],
    now: m,
    parser: e,
    previous: null,
    sliceSerialize: f,
    sliceStream: h,
    write: d
  };
  let u = t.tokenize.call(l, c);
  return t.resolveAll && a.push(t), l;
  function d(P) {
    return o = sr(o, P), v(), o[o.length - 1] !== null ? [] : (A(t, 0), l.events = Bm(a, l.events, l), l.events);
  }
  function f(P, E) {
    return eD(h(P), E);
  }
  function h(P) {
    return ZR(o, P);
  }
  function m() {
    const {
      _bufferIndex: P,
      _index: E,
      line: C,
      column: T,
      offset: D
    } = r;
    return {
      _bufferIndex: P,
      _index: E,
      line: C,
      column: T,
      offset: D
    };
  }
  function g(P) {
    i[P.line] = P.column, O();
  }
  function v() {
    let P;
    for (; r._index < o.length; ) {
      const E = o[r._index];
      if (typeof E == "string")
        for (P = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === P && r._bufferIndex < E.length; )
          _(E.charCodeAt(r._bufferIndex));
      else
        _(E);
    }
  }
  function _(P) {
    u = u(P);
  }
  function I(P) {
    Ve(P) ? (r.line++, r.column = 1, r.offset += P === -3 ? 2 : 1, O()) : P !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = P;
  }
  function M(P, E) {
    const C = E || {};
    return C.type = P, C.start = m(), l.events.push(["enter", C, l]), s.push(C), C;
  }
  function k(P) {
    const E = s.pop();
    return E.end = m(), l.events.push(["exit", E, l]), E;
  }
  function y(P, E) {
    A(P, E.from);
  }
  function x(P, E) {
    E.restore();
  }
  function b(P, E) {
    return C;
    function C(T, D, z) {
      let F, W, L, S;
      return Array.isArray(T) ? (
        /* c8 ignore next 1 */
        Y(T)
      ) : "tokenize" in T ? (
        // Looks like a construct.
        Y([
          /** @type {Construct} */
          T
        ])
      ) : j(T);
      function j(q) {
        return $;
        function $(Q) {
          const V = Q !== null && q[Q], H = Q !== null && q.null, K = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(V) ? V : V ? [V] : [],
            ...Array.isArray(H) ? H : H ? [H] : []
          ];
          return Y(K)(Q);
        }
      }
      function Y(q) {
        return F = q, W = 0, q.length === 0 ? z : N(q[W]);
      }
      function N(q) {
        return $;
        function $(Q) {
          return S = w(), L = q, q.partial || (l.currentConstruct = q), q.name && l.parser.constructs.disable.null.includes(q.name) ? G() : q.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            E ? Object.assign(Object.create(l), E) : l,
            c,
            X,
            G
          )(Q);
        }
      }
      function X(q) {
        return P(L, S), D;
      }
      function G(q) {
        return S.restore(), ++W < F.length ? N(F[W]) : z;
      }
    }
  }
  function A(P, E) {
    P.resolveAll && !a.includes(P) && a.push(P), P.resolve && Vr(l.events, E, l.events.length - E, P.resolve(l.events.slice(E), l)), P.resolveTo && (l.events = P.resolveTo(l.events, l));
  }
  function w() {
    const P = m(), E = l.previous, C = l.currentConstruct, T = l.events.length, D = Array.from(s);
    return {
      from: T,
      restore: z
    };
    function z() {
      r = P, l.previous = E, l.currentConstruct = C, l.events.length = T, s = D, O();
    }
  }
  function O() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function ZR(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex;
  let o;
  if (n === i)
    o = [e[n].slice(r, a)];
  else {
    if (o = e.slice(n, i), r > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(r) : o.shift();
    }
    a > 0 && o.push(e[i].slice(0, a));
  }
  return o;
}
function eD(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const a = e[n];
    let o;
    if (typeof a == "string")
      o = a;
    else switch (a) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(a);
    }
    i = a === -2, r.push(o);
  }
  return r.join("");
}
function tD(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      lO([JR, ...(e || {}).extensions || []])
    ),
    content: i(gO),
    defined: [],
    document: i(xO),
    flow: i(LR),
    lazy: {},
    string: i(FR),
    text: i($R)
  };
  return r;
  function i(a) {
    return o;
    function o(s) {
      return KR(r, a, s);
    }
  }
}
function nD(e) {
  for (; !Nb(e); )
    ;
  return e;
}
const o1 = /[\0\t\n\r]/g;
function rD() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(a, o, s) {
    const c = [];
    let l, u, d, f, h;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), d = 0, t = "", n && (a.charCodeAt(0) === 65279 && d++, n = void 0); d < a.length; ) {
      if (o1.lastIndex = d, l = o1.exec(a), f = l && l.index !== void 0 ? l.index : a.length, h = a.charCodeAt(f), !l) {
        t = a.slice(d);
        break;
      }
      if (h === 10 && d === f && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), d < f && (c.push(a.slice(d, f)), e += f - d), h) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, c.push(-2); e++ < u; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = f + 1;
    }
    return s && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const iD = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function aD(e) {
  return e.replace(iD, oD);
}
function oD(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), a = i === 120 || i === 88;
    return kb(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return zm(n) || e;
}
const zb = {}.hasOwnProperty;
function sD(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), lD(n)(nD(tD(n).document().write(rD()(e, t, !0))));
}
function lD(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(Re),
      autolinkProtocol: w,
      autolinkEmail: w,
      atxHeading: a(se),
      blockQuote: a(H),
      characterEscape: w,
      characterReference: w,
      codeFenced: a(K),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a(K, o),
      codeText: a(U, o),
      codeTextData: w,
      data: w,
      codeFlowValue: w,
      definition: a(ee),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(ce),
      hardBreakEscape: a(ne),
      hardBreakTrailing: a(ne),
      htmlFlow: a(re, o),
      htmlFlowData: w,
      htmlText: a(re, o),
      htmlTextData: w,
      image: a(Me),
      label: o,
      link: a(Re),
      listItem: a(de),
      listItemValue: f,
      listOrdered: a(oe, d),
      listUnordered: a(oe),
      paragraph: a(ue),
      reference: N,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(se),
      strong: a(me),
      thematicBreak: a(le)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: y,
      autolink: c(),
      autolinkEmail: V,
      autolinkProtocol: Q,
      blockQuote: c(),
      characterEscapeValue: O,
      characterReferenceMarkerHexadecimal: G,
      characterReferenceMarkerNumeric: G,
      characterReferenceValue: q,
      characterReference: $,
      codeFenced: c(v),
      codeFencedFence: g,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: m,
      codeFlowValue: O,
      codeIndented: c(_),
      codeText: c(D),
      codeTextData: O,
      data: O,
      definition: c(),
      definitionDestinationString: k,
      definitionLabelString: I,
      definitionTitleString: M,
      emphasis: c(),
      hardBreakEscape: c(E),
      hardBreakTrailing: c(E),
      htmlFlow: c(C),
      htmlFlowData: O,
      htmlText: c(T),
      htmlTextData: O,
      image: c(F),
      label: L,
      labelText: W,
      lineEnding: P,
      link: c(z),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: X,
      resourceDestinationString: S,
      resourceTitleString: j,
      resource: Y,
      setextHeading: c(A),
      setextHeadingLineSequence: b,
      setextHeadingText: x,
      strong: c(),
      thematicBreak: c()
    }
  };
  Bb(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(J) {
    let ae = {
      type: "root",
      children: []
    };
    const ge = {
      stack: [ae],
      tokenStack: [],
      config: t,
      enter: s,
      exit: l,
      buffer: o,
      resume: u,
      data: n
    }, be = [];
    let we = -1;
    for (; ++we < J.length; )
      if (J[we][1].type === "listOrdered" || J[we][1].type === "listUnordered")
        if (J[we][0] === "enter")
          be.push(we);
        else {
          const We = be.pop();
          we = i(J, We, we);
        }
    for (we = -1; ++we < J.length; ) {
      const We = t[J[we][0]];
      zb.call(We, J[we][1].type) && We[J[we][1].type].call(Object.assign({
        sliceSerialize: J[we][2].sliceSerialize
      }, ge), J[we][1]);
    }
    if (ge.tokenStack.length > 0) {
      const We = ge.tokenStack[ge.tokenStack.length - 1];
      (We[1] || s1).call(ge, void 0, We[0]);
    }
    for (ae.position = {
      start: Ti(J.length > 0 ? J[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Ti(J.length > 0 ? J[J.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, we = -1; ++we < t.transforms.length; )
      ae = t.transforms[we](ae) || ae;
    return ae;
  }
  function i(J, ae, ge) {
    let be = ae - 1, we = -1, We = !1, ie, ve, _e, Ie;
    for (; ++be <= ge; ) {
      const Pe = J[be];
      switch (Pe[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Pe[0] === "enter" ? we++ : we--, Ie = void 0;
          break;
        }
        case "lineEndingBlank": {
          Pe[0] === "enter" && (ie && !Ie && !we && !_e && (_e = be), Ie = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Ie = void 0;
      }
      if (!we && Pe[0] === "enter" && Pe[1].type === "listItemPrefix" || we === -1 && Pe[0] === "exit" && (Pe[1].type === "listUnordered" || Pe[1].type === "listOrdered")) {
        if (ie) {
          let Qe = be;
          for (ve = void 0; Qe--; ) {
            const et = J[Qe];
            if (et[1].type === "lineEnding" || et[1].type === "lineEndingBlank") {
              if (et[0] === "exit") continue;
              ve && (J[ve][1].type = "lineEndingBlank", We = !0), et[1].type = "lineEnding", ve = Qe;
            } else if (!(et[1].type === "linePrefix" || et[1].type === "blockQuotePrefix" || et[1].type === "blockQuotePrefixWhitespace" || et[1].type === "blockQuoteMarker" || et[1].type === "listItemIndent")) break;
          }
          _e && (!ve || _e < ve) && (ie._spread = !0), ie.end = Object.assign({}, ve ? J[ve][1].start : Pe[1].end), J.splice(ve || be, 0, ["exit", ie, Pe[2]]), be++, ge++;
        }
        if (Pe[1].type === "listItemPrefix") {
          const Qe = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Pe[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          ie = Qe, J.splice(be, 0, ["enter", Qe, Pe[2]]), be++, ge++, _e = void 0, Ie = !0;
        }
      }
    }
    return J[ae][1]._spread = We, ge;
  }
  function a(J, ae) {
    return ge;
    function ge(be) {
      s.call(this, J(be), be), ae && ae.call(this, be);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(J, ae, ge) {
    this.stack[this.stack.length - 1].children.push(J), this.stack.push(J), this.tokenStack.push([ae, ge || void 0]), J.position = {
      start: Ti(ae.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(J) {
    return ae;
    function ae(ge) {
      J && J.call(this, ge), l.call(this, ge);
    }
  }
  function l(J, ae) {
    const ge = this.stack.pop(), be = this.tokenStack.pop();
    if (be)
      be[0].type !== J.type && (ae ? ae.call(this, J, be[0]) : (be[1] || s1).call(this, J, be[0]));
    else throw new Error("Cannot close `" + J.type + "` (" + zs({
      start: J.start,
      end: J.end
    }) + "): it’s not open");
    ge.position.end = Ti(J.end);
  }
  function u() {
    return oO(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(J) {
    if (this.data.expectingFirstListItemValue) {
      const ae = this.stack[this.stack.length - 2];
      ae.start = Number.parseInt(this.sliceSerialize(J), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.lang = J;
  }
  function m() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.meta = J;
  }
  function g() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function v() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = J.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = J.replace(/(\r?\n|\r)$/g, "");
  }
  function I(J) {
    const ae = this.resume(), ge = this.stack[this.stack.length - 1];
    ge.label = ae, ge.identifier = po(this.sliceSerialize(J)).toLowerCase();
  }
  function M() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.title = J;
  }
  function k() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.url = J;
  }
  function y(J) {
    const ae = this.stack[this.stack.length - 1];
    if (!ae.depth) {
      const ge = this.sliceSerialize(J).length;
      ae.depth = ge;
    }
  }
  function x() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function b(J) {
    const ae = this.stack[this.stack.length - 1];
    ae.depth = this.sliceSerialize(J).codePointAt(0) === 61 ? 1 : 2;
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function w(J) {
    const ge = this.stack[this.stack.length - 1].children;
    let be = ge[ge.length - 1];
    (!be || be.type !== "text") && (be = Z(), be.position = {
      start: Ti(J.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ge.push(be)), this.stack.push(be);
  }
  function O(J) {
    const ae = this.stack.pop();
    ae.value += this.sliceSerialize(J), ae.position.end = Ti(J.end);
  }
  function P(J) {
    const ae = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ge = ae.children[ae.children.length - 1];
      ge.position.end = Ti(J.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(ae.type) && (w.call(this, J), O.call(this, J));
  }
  function E() {
    this.data.atHardBreak = !0;
  }
  function C() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = J;
  }
  function T() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = J;
  }
  function D() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = J;
  }
  function z() {
    const J = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ae = this.data.referenceType || "shortcut";
      J.type += "Reference", J.referenceType = ae, delete J.url, delete J.title;
    } else
      delete J.identifier, delete J.label;
    this.data.referenceType = void 0;
  }
  function F() {
    const J = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ae = this.data.referenceType || "shortcut";
      J.type += "Reference", J.referenceType = ae, delete J.url, delete J.title;
    } else
      delete J.identifier, delete J.label;
    this.data.referenceType = void 0;
  }
  function W(J) {
    const ae = this.sliceSerialize(J), ge = this.stack[this.stack.length - 2];
    ge.label = aD(ae), ge.identifier = po(ae).toLowerCase();
  }
  function L() {
    const J = this.stack[this.stack.length - 1], ae = this.resume(), ge = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ge.type === "link") {
      const be = J.children;
      ge.children = be;
    } else
      ge.alt = ae;
  }
  function S() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.url = J;
  }
  function j() {
    const J = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.title = J;
  }
  function Y() {
    this.data.inReference = void 0;
  }
  function N() {
    this.data.referenceType = "collapsed";
  }
  function X(J) {
    const ae = this.resume(), ge = this.stack[this.stack.length - 1];
    ge.label = ae, ge.identifier = po(this.sliceSerialize(J)).toLowerCase(), this.data.referenceType = "full";
  }
  function G(J) {
    this.data.characterReferenceType = J.type;
  }
  function q(J) {
    const ae = this.sliceSerialize(J), ge = this.data.characterReferenceType;
    let be;
    ge ? (be = kb(ae, ge === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : be = zm(ae);
    const we = this.stack[this.stack.length - 1];
    we.value += be;
  }
  function $(J) {
    const ae = this.stack.pop();
    ae.position.end = Ti(J.end);
  }
  function Q(J) {
    O.call(this, J);
    const ae = this.stack[this.stack.length - 1];
    ae.url = this.sliceSerialize(J);
  }
  function V(J) {
    O.call(this, J);
    const ae = this.stack[this.stack.length - 1];
    ae.url = "mailto:" + this.sliceSerialize(J);
  }
  function H() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function K() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function U() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ee() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ce() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ne() {
    return {
      type: "break"
    };
  }
  function re() {
    return {
      type: "html",
      value: ""
    };
  }
  function Me() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function oe(J) {
    return {
      type: "list",
      ordered: J.type === "listOrdered",
      start: null,
      spread: J._spread,
      children: []
    };
  }
  function de(J) {
    return {
      type: "listItem",
      spread: J._spread,
      checked: null,
      children: []
    };
  }
  function ue() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function me() {
    return {
      type: "strong",
      children: []
    };
  }
  function Z() {
    return {
      type: "text",
      value: ""
    };
  }
  function le() {
    return {
      type: "thematicBreak"
    };
  }
}
function Ti(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Bb(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Bb(e, r) : cD(e, r);
  }
}
function cD(e, t) {
  let n;
  for (n in t)
    if (zb.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function s1(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + zs({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + zs({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + zs({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function uD(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return sD(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function fD(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function dD(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function hD(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function pD(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function mD(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function gD(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = jo(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let o, s = e.footnoteCounts.get(r);
  s === void 0 ? (s = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, s += 1, e.footnoteCounts.set(r, s);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, c);
  const l = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, l), e.applyData(t, l);
}
function yD(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function xD(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Fb(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function vD(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Fb(e, t);
  const i = { src: jo(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function AD(e, t) {
  const n = { src: jo(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function bD(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function wD(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Fb(e, t);
  const i = { href: jo(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function _D(e, t) {
  const n = { href: jo(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function SD(e, t, n) {
  const r = e.all(t), i = n ? CD(n) : $b(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const u = r[0];
    let d;
    u && u.type === "element" && u.tagName === "p" ? d = u : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const u = r[s];
    (i || s !== 0 || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !i ? o.push(...u.children) : o.push(u);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` });
  const l = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, l), e.applyData(t, l);
}
function CD(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = $b(n[r]);
  }
  return t;
}
function $b(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function ED(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function kD(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function TD(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function MD(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ID(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = Rm(t.children[1]), c = Ab(t.children[t.children.length - 1]);
    s && c && (o.position = { start: s, end: c }), i.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function ND(e, t, n) {
  const r = n ? n.children : void 0, a = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, s = o ? o.length : t.children.length;
  let c = -1;
  const l = [];
  for (; ++c < s; ) {
    const d = t.children[c], f = {}, h = o ? o[c] : void 0;
    h && (f.align = h);
    let m = { type: "element", tagName: a, properties: f, children: [] };
    d && (m.children = e.all(d), e.patch(d, m), m = e.applyData(d, m)), l.push(m);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(t, u), e.applyData(t, u);
}
function OD(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const l1 = 9, c1 = 32;
function RD(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const a = [];
  for (; r; )
    a.push(
      u1(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return a.push(u1(t.slice(i), i > 0, !1)), a.join("");
}
function u1(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let a = e.codePointAt(r);
    for (; a === l1 || a === c1; )
      r++, a = e.codePointAt(r);
  }
  if (n) {
    let a = e.codePointAt(i - 1);
    for (; a === l1 || a === c1; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function DD(e, t) {
  const n = { type: "text", value: RD(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function PD(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const LD = {
  blockquote: fD,
  break: dD,
  code: hD,
  delete: pD,
  emphasis: mD,
  footnoteReference: gD,
  heading: yD,
  html: xD,
  imageReference: vD,
  image: AD,
  inlineCode: bD,
  linkReference: wD,
  link: _D,
  listItem: SD,
  list: ED,
  paragraph: kD,
  // @ts-expect-error: root is different, but hard to type.
  root: TD,
  strong: MD,
  table: ID,
  tableCell: OD,
  tableRow: ND,
  text: DD,
  thematicBreak: PD,
  toml: lc,
  yaml: lc,
  definition: lc,
  footnoteDefinition: lc
};
function lc() {
}
const Yb = -1, Mf = 0, Fs = 1, hu = 2, $m = 3, Ym = 4, jm = 5, Wm = 6, jb = 7, Wb = 8, f1 = typeof self == "object" ? self : globalThis, zD = (e, t) => {
  const n = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, o] = t[i];
    switch (a) {
      case Mf:
      case Yb:
        return n(o, i);
      case Fs: {
        const s = n([], i);
        for (const c of o)
          s.push(r(c));
        return s;
      }
      case hu: {
        const s = n({}, i);
        for (const [c, l] of o)
          s[r(c)] = r(l);
        return s;
      }
      case $m:
        return n(new Date(o), i);
      case Ym: {
        const { source: s, flags: c } = o;
        return n(new RegExp(s, c), i);
      }
      case jm: {
        const s = n(/* @__PURE__ */ new Map(), i);
        for (const [c, l] of o)
          s.set(r(c), r(l));
        return s;
      }
      case Wm: {
        const s = n(/* @__PURE__ */ new Set(), i);
        for (const c of o)
          s.add(r(c));
        return s;
      }
      case jb: {
        const { name: s, message: c } = o;
        return n(new f1[s](c), i);
      }
      case Wb:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: s } = new Uint8Array(o);
        return n(new DataView(s), o);
      }
    }
    return n(new f1[a](o), i);
  };
  return r;
}, d1 = (e) => zD(/* @__PURE__ */ new Map(), e)(0), Qa = "", { toString: BD } = {}, { keys: FD } = Object, is = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [Mf, t];
  const n = BD.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Fs, Qa];
    case "Object":
      return [hu, Qa];
    case "Date":
      return [$m, Qa];
    case "RegExp":
      return [Ym, Qa];
    case "Map":
      return [jm, Qa];
    case "Set":
      return [Wm, Qa];
    case "DataView":
      return [Fs, n];
  }
  return n.includes("Array") ? [Fs, n] : n.includes("Error") ? [jb, n] : [hu, n];
}, cc = ([e, t]) => e === Mf && (t === "function" || t === "symbol"), $D = (e, t, n, r) => {
  const i = (o, s) => {
    const c = r.push(o) - 1;
    return n.set(s, c), c;
  }, a = (o) => {
    if (n.has(o))
      return n.get(o);
    let [s, c] = is(o);
    switch (s) {
      case Mf: {
        let u = o;
        switch (c) {
          case "bigint":
            s = Wb, u = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            u = null;
            break;
          case "undefined":
            return i([Yb], o);
        }
        return i([s, u], o);
      }
      case Fs: {
        if (c) {
          let f = o;
          return c === "DataView" ? f = new Uint8Array(o.buffer) : c === "ArrayBuffer" && (f = new Uint8Array(o)), i([c, [...f]], o);
        }
        const u = [], d = i([s, u], o);
        for (const f of o)
          u.push(a(f));
        return d;
      }
      case hu: {
        if (c)
          switch (c) {
            case "BigInt":
              return i([c, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([c, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return a(o.toJSON());
        const u = [], d = i([s, u], o);
        for (const f of FD(o))
          (e || !cc(is(o[f]))) && u.push([a(f), a(o[f])]);
        return d;
      }
      case $m:
        return i([s, o.toISOString()], o);
      case Ym: {
        const { source: u, flags: d } = o;
        return i([s, { source: u, flags: d }], o);
      }
      case jm: {
        const u = [], d = i([s, u], o);
        for (const [f, h] of o)
          (e || !(cc(is(f)) || cc(is(h)))) && u.push([a(f), a(h)]);
        return d;
      }
      case Wm: {
        const u = [], d = i([s, u], o);
        for (const f of o)
          (e || !cc(is(f))) && u.push(a(f));
        return d;
      }
    }
    const { message: l } = o;
    return i([s, { name: c, message: l }], o);
  };
  return a;
}, h1 = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return $D(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, pu = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? d1(h1(e, t)) : structuredClone(e)
) : (e, t) => d1(h1(e, t));
function YD(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function jD(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function WD(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || YD, r = e.options.footnoteBackLabel || jD, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const l = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!l)
      continue;
    const u = e.all(l), d = String(l.identifier).toUpperCase(), f = jo(d.toLowerCase());
    let h = 0;
    const m = [], g = e.footnoteCounts.get(d);
    for (; g !== void 0 && ++h <= g; ) {
      m.length > 0 && m.push({ type: "text", value: " " });
      let I = typeof n == "string" ? n : n(c, h);
      typeof I == "string" && (I = { type: "text", value: I }), m.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + f + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(I) ? I : [I]
      });
    }
    const v = u[u.length - 1];
    if (v && v.type === "element" && v.tagName === "p") {
      const I = v.children[v.children.length - 1];
      I && I.type === "text" ? I.value += " " : v.children.push({ type: "text", value: " " }), v.children.push(...m);
    } else
      u.push(...m);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + f },
      children: e.wrap(u, !0)
    };
    e.patch(l, _), s.push(_);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...pu(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Hb = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return VD;
    if (typeof e == "function")
      return If(e);
    if (typeof e == "object")
      return Array.isArray(e) ? HD(e) : UD(e);
    if (typeof e == "string")
      return GD(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function HD(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Hb(e[n]);
  return If(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, i)) return !0;
    return !1;
  }
}
function UD(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return If(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let a;
    for (a in e)
      if (i[a] !== t[a]) return !1;
    return !0;
  }
}
function GD(e) {
  return If(t);
  function t(n) {
    return n && n.type === e;
  }
}
function If(e) {
  return t;
  function t(n, r, i) {
    return !!(QD(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function VD() {
  return !0;
}
function QD(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Ub = [], qD = !0, p1 = !1, XD = "skip";
function JD(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const a = Hb(i), o = r ? -1 : 1;
  s(e, void 0, [])();
  function s(c, l, u) {
    const d = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof d.type == "string") {
      const h = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (c.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let h = Ub, m, g, v;
      if ((!t || a(c, l, u[u.length - 1] || void 0)) && (h = KD(n(c, u)), h[0] === p1))
        return h;
      if ("children" in c && c.children) {
        const _ = (
          /** @type {UnistParent} */
          c
        );
        if (_.children && h[0] !== XD)
          for (g = (r ? _.children.length : -1) + o, v = u.concat(_); g > -1 && g < _.children.length; ) {
            const I = _.children[g];
            if (m = s(I, g, v)(), m[0] === p1)
              return m;
            g = typeof m[1] == "number" ? m[1] : g + o;
          }
      }
      return h;
    }
  }
}
function KD(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [qD, e] : e == null ? Ub : [e];
}
function Gb(e, t, n, r) {
  let i, a, o;
  typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), JD(e, a, s, i);
  function s(c, l) {
    const u = l[l.length - 1], d = u ? u.children.indexOf(c) : void 0;
    return o(c, d, u);
  }
}
const ap = {}.hasOwnProperty, ZD = {};
function eP(e, t) {
  const n = t || ZD, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...LD, ...n.handlers }, s = {
    all: l,
    applyData: nP,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: c,
    options: n,
    patch: tP,
    wrap: iP
  };
  return Gb(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const d = u.type === "definition" ? r : i, f = String(u.identifier).toUpperCase();
      d.has(f) || d.set(f, u);
    }
  }), s;
  function c(u, d) {
    const f = u.type, h = s.handlers[f];
    if (ap.call(s.handlers, f) && h)
      return h(s, u, d);
    if (s.options.passThrough && s.options.passThrough.includes(f)) {
      if ("children" in u) {
        const { children: g, ...v } = u, _ = pu(v);
        return _.children = s.all(u), _;
      }
      return pu(u);
    }
    return (s.options.unknownHandler || rP)(s, u, d);
  }
  function l(u) {
    const d = [];
    if ("children" in u) {
      const f = u.children;
      let h = -1;
      for (; ++h < f.length; ) {
        const m = s.one(f[h], u);
        if (m) {
          if (h && f[h - 1].type === "break" && (!Array.isArray(m) && m.type === "text" && (m.value = m1(m.value)), !Array.isArray(m) && m.type === "element")) {
            const g = m.children[0];
            g && g.type === "text" && (g.value = m1(g.value));
          }
          Array.isArray(m) ? d.push(...m) : d.push(m);
        }
      }
    }
    return d;
  }
}
function tP(e, t) {
  e.position && (t.position = BN(e));
}
function nP(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && a && Object.assign(n.properties, pu(a)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function rP(e, t) {
  const n = t.data || {}, r = "value" in t && !(ap.call(n, "hProperties") || ap.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function iP(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function m1(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function g1(e, t) {
  const n = eP(e, t), r = n.one(e, void 0), i = WD(n), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function aP(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      g1(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      g1(n, { file: r, ...e || t })
    );
  };
}
function y1(e) {
  if (e)
    throw e;
}
var Gc = Object.prototype.hasOwnProperty, Vb = Object.prototype.toString, x1 = Object.defineProperty, v1 = Object.getOwnPropertyDescriptor, A1 = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Vb.call(t) === "[object Array]";
}, b1 = function(t) {
  if (!t || Vb.call(t) !== "[object Object]")
    return !1;
  var n = Gc.call(t, "constructor"), r = t.constructor && t.constructor.prototype && Gc.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || Gc.call(t, i);
}, w1 = function(t, n) {
  x1 && n.name === "__proto__" ? x1(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, _1 = function(t, n) {
  if (n === "__proto__")
    if (Gc.call(t, n)) {
      if (v1)
        return v1(t, n).value;
    } else return;
  return t[n];
}, oP = function e() {
  var t, n, r, i, a, o, s = arguments[0], c = 1, l = arguments.length, u = !1;
  for (typeof s == "boolean" && (u = s, s = arguments[1] || {}, c = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); c < l; ++c)
    if (t = arguments[c], t != null)
      for (n in t)
        r = _1(s, n), i = _1(t, n), s !== i && (u && i && (b1(i) || (a = A1(i))) ? (a ? (a = !1, o = r && A1(r) ? r : []) : o = r && b1(r) ? r : {}, w1(s, { name: n, newValue: e(u, o, i) })) : typeof i < "u" && w1(s, { name: n, newValue: i }));
  return s;
};
const Ld = /* @__PURE__ */ vf(oP);
function op(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function sP() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let a = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...i);
    function s(c, ...l) {
      const u = e[++a];
      let d = -1;
      if (c) {
        o(c);
        return;
      }
      for (; ++d < i.length; )
        (l[d] === null || l[d] === void 0) && (l[d] = i[d]);
      i = l, u ? lP(u, s)(...l) : o(null, ...l);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function lP(e, t) {
  let n;
  return r;
  function r(...o) {
    const s = e.length > o.length;
    let c;
    s && o.push(i);
    try {
      c = e.apply(this, o);
    } catch (l) {
      const u = (
        /** @type {Error} */
        l
      );
      if (s && n)
        throw u;
      return i(u);
    }
    s || (c && c.then && typeof c.then == "function" ? c.then(a, i) : c instanceof Error ? i(c) : a(c));
  }
  function i(o, ...s) {
    n || (n = !0, t(o, ...s));
  }
  function a(o) {
    i(null, o);
  }
}
const Pr = { basename: cP, dirname: uP, extname: fP, join: dP, sep: "/" };
function cP(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Dl(e);
  let n = 0, r = -1, i = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          n = i + 1;
          break;
        }
      } else r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, s = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        n = i + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function uP(e) {
  if (Dl(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function fP(e) {
  Dl(e);
  let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
  for (; t--; ) {
    const s = e.codePointAt(t);
    if (s === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), s === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function dP(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Dl(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : hP(n);
}
function hP(e) {
  Dl(e);
  const t = e.codePointAt(0) === 47;
  let n = pP(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function pP(e, t) {
  let n = "", r = 0, i = -1, a = 0, o = -1, s, c;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      s = e.codePointAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (c = n.lastIndexOf("/"), c !== n.length - 1) {
              c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = o, a = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
      i = o, a = 0;
    } else s === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function Dl(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const mP = { cwd: gP };
function gP() {
  return "/";
}
function sp(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function yP(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!sp(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return xP(e);
}
function xP(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const zd = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Qb {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? sp(t) ? n = { path: t } : typeof t == "string" || vP(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : mP.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < zd.length; ) {
      const a = zd[r];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let i;
    for (i in n)
      zd.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Pr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Fd(t, "basename"), Bd(t, "basename"), this.path = Pr.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Pr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    S1(this.basename, "dirname"), this.path = Pr.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Pr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (Bd(t, "extname"), S1(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Pr.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    sp(t) && (t = yP(t)), Fd(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Pr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Fd(t, "stem"), Bd(t, "stem"), this.path = Pr.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new bn(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function Bd(e, t) {
  if (e && e.includes(Pr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Pr.sep + "`"
    );
}
function Fd(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function S1(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function vP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const AP = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, r), a;
  }
), bP = {}.hasOwnProperty;
class Hm extends AP {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = sP();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Hm()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Ld(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (jd("data", this.frozen), this.namespace[t] = n, this) : bP.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (jd("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = uc(t), r = this.parser || this.Parser;
    return $d("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), $d("process", this.parser || this.Parser), Yd("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(a, o) {
      const s = uc(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(s)
      );
      r.run(c, s, function(u, d, f) {
        if (u || !d || !f)
          return l(u);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), m = r.stringify(h, f);
        SP(m) ? f.value = m : f.result = m, l(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function l(u, d) {
        u || !d ? o(u) : a ? a(d) : n(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), $d("processSync", this.parser || this.Parser), Yd("processSync", this.compiler || this.Compiler), this.process(t, i), E1("processSync", "process", n), r;
    function i(a, o) {
      n = !0, y1(a), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    C1(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const c = uc(n);
      i.run(t, c, l);
      function l(u, d, f) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        u ? s(u) : o ? o(h) : r(void 0, h, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, a), E1("runSync", "run", r), i;
    function a(o, s) {
      y1(o), i = s, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = uc(n), i = this.compiler || this.Compiler;
    return Yd("stringify", i), C1(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (jd("use", this.frozen), t != null) if (typeof t == "function")
      c(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? s(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(l) {
      if (typeof l == "function")
        c(l, []);
      else if (typeof l == "object")
        if (Array.isArray(l)) {
          const [u, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            l
          );
          c(u, d);
        } else
          o(l);
      else
        throw new TypeError("Expected usable value, not `" + l + "`");
    }
    function o(l) {
      if (!("plugins" in l) && !("settings" in l))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(l.plugins), l.settings && (i.settings = Ld(!0, i.settings, l.settings));
    }
    function s(l) {
      let u = -1;
      if (l != null) if (Array.isArray(l))
        for (; ++u < l.length; ) {
          const d = l[u];
          a(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + l + "`");
    }
    function c(l, u) {
      let d = -1, f = -1;
      for (; ++d < r.length; )
        if (r[d][0] === l) {
          f = d;
          break;
        }
      if (f === -1)
        r.push([l, ...u]);
      else if (u.length > 0) {
        let [h, ...m] = u;
        const g = r[f][1];
        op(g) && op(h) && (h = Ld(!0, g, h)), r[f] = [l, h, ...m];
      }
    }
  }
}
const wP = new Hm().freeze();
function $d(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Yd(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function jd(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function C1(e) {
  if (!op(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function E1(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function uc(e) {
  return _P(e) ? e : new Qb(e);
}
function _P(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function SP(e) {
  return typeof e == "string" || CP(e);
}
function CP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const EP = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", k1 = [], T1 = { allowDangerousHtml: !0 }, kP = /^(https?|ircs?|mailto|xmpp)$/i, TP = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Um(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, a = e.components, o = e.disallowedElements, s = e.rehypePlugins || k1, c = e.remarkPlugins || k1, l = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...T1 } : T1, u = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || MP, h = wP().use(uD).use(c).use(aP, l).use(s), m = new Qb();
  typeof r == "string" && (m.value = r);
  for (const I of TP)
    Object.hasOwn(e, I.from) && ("" + I.from + (I.to ? "use `" + I.to + "` instead" : "remove it") + EP + I.id, void 0);
  const g = h.parse(m);
  let v = h.runSync(g, m);
  return i && (v = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      v.type === "root" ? v.children : [v]
    )
  }), Gb(v, _), WN(v, {
    Fragment: Li.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: a,
    ignoreInvalidStyle: !0,
    jsx: Li.jsx,
    jsxs: Li.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function _(I, M, k) {
    if (I.type === "raw" && k && typeof M == "number")
      return u ? k.children.splice(M, 1) : k.children[M] = { type: "text", value: I.value }, M;
    if (I.type === "element") {
      let y;
      for (y in Rd)
        if (Object.hasOwn(Rd, y) && Object.hasOwn(I.properties, y)) {
          const x = I.properties[y], b = Rd[y];
          (b === null || b.includes(I.tagName)) && (I.properties[y] = f(String(x || ""), y, I));
        }
    }
    if (I.type === "element") {
      let y = t ? !t.includes(I.tagName) : o ? o.includes(I.tagName) : !1;
      if (!y && n && typeof M == "number" && (y = !n(I, M, k)), y && k && typeof M == "number")
        return d && I.children ? k.children.splice(M, 1, ...I.children) : k.children.splice(M, 1), M;
    }
  }
}
function MP(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    kP.test(e.slice(0, t)) ? e : ""
  );
}
const IP = /^:?-+:?$/, Wd = (e) => {
  const t = [];
  let n = "";
  for (let r = 0; r < e.length; r += 1) {
    const i = e[r];
    i === "\\" && e[r + 1] === "|" ? (n += "|", r += 1) : i === "|" ? (t.push(n), n = "") : n += i;
  }
  return t.push(n), t.length && t[0].trim() === "" && t.shift(), t.length && t[t.length - 1].trim() === "" && t.pop(), t.map((r) => r.trim());
}, NP = (e) => e.length > 0 && e.every((t) => IP.test(t)), OP = (e) => {
  const t = e.startsWith(":"), n = e.endsWith(":");
  return t && n ? "center" : n ? "right" : "left";
}, RP = (e) => {
  const t = e.split(`
`), n = [];
  let r = [];
  const i = () => {
    r.length && (n.push({ kind: "markdown", text: r.join(`
`) }), r = []);
  };
  for (let a = 0; a < t.length; a += 1) {
    const o = t[a], s = t[a + 1], c = o.includes("|") ? Wd(o) : [], l = s && s.includes("-") ? Wd(s) : [];
    if (c.length > 0 && c.length === l.length && NP(l)) {
      const u = [];
      let d = a + 2;
      for (; d < t.length && t[d].includes("|"); )
        u.push(Wd(t[d])), d += 1;
      i(), n.push({
        kind: "table",
        header: c,
        rows: u,
        align: l.map(OP)
      }), a = d - 1;
      continue;
    }
    r.push(o);
  }
  return i(), n;
}, M1 = ({ text: e }) => e ? /* @__PURE__ */ p(Um, { children: e }) : null, DP = ({ text: e }) => {
  const t = Xe.useMemo(() => RP(e), [e]);
  return /* @__PURE__ */ p(kI, { children: t.map(
    (n, r) => n.kind === "markdown" ? /* @__PURE__ */ p(Um, { children: n.text }, r) : /* @__PURE__ */ p(TI, { children: /* @__PURE__ */ B(MI, { children: [
      /* @__PURE__ */ p("thead", { children: /* @__PURE__ */ p("tr", { children: n.header.map((i, a) => /* @__PURE__ */ p(
        "th",
        {
          style: { textAlign: n.align[a] },
          children: /* @__PURE__ */ p(M1, { text: i })
        },
        a
      )) }) }),
      /* @__PURE__ */ p("tbody", { children: n.rows.map((i, a) => /* @__PURE__ */ p("tr", { children: n.header.map((o, s) => /* @__PURE__ */ p(
        "td",
        {
          style: { textAlign: n.align[s] },
          children: /* @__PURE__ */ p(M1, { text: i[s] ?? "" })
        },
        s
      )) }, a)) })
    ] }) }, r)
  ) });
}, Gm = "/aichat", PP = (e) => un.post(`${Gm}/chat`, e), LP = (e, t = !0) => un.post(`${Gm}/chat/${e}/approve?approved=${t}`), zP = (e) => un.get(`${Gm}/proposals/${e}`), I1 = (e, t) => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
  role: e,
  text: t
}), BP = 25, FP = 120, $P = 2, YP = (e) => {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" ? t : {};
  } catch {
    return {};
  }
}, jP = ({
  conceptSetId: e = null
} = {}) => {
  const { enqueueSnackbar: t } = Zr(), [n, r] = Se([]), [i, a] = Se(!1), [o, s] = Se(!1), [c, l] = Se(null), [u, d] = Se(e), f = qt(null), h = qt(e), m = qt(null), g = Ge(() => {
    m.current !== null && (clearInterval(m.current), m.current = null), s(!1);
  }, []);
  He(() => g, [g]);
  const v = Ge(
    (A) => {
      g();
      const w = I1("assistant", "");
      r((E) => [...E, w]);
      const O = Math.max(
        $P,
        Math.ceil(A.length / FP)
      );
      let P = 0;
      s(!0), m.current = setInterval(() => {
        P = Math.min(A.length, P + O);
        const E = A.slice(0, P);
        r(
          (C) => C.map((T) => T.id === w.id ? { ...T, text: E } : T)
        ), P >= A.length && g();
      }, BP);
    },
    [g]
  ), _ = Ge(
    (A) => {
      t({
        message: PC(A),
        variant: "error"
      });
    },
    [t]
  ), I = Ge(
    async (A) => {
      if (f.current = A.sessionId, A.activeConceptSetId && (h.current = A.activeConceptSetId, d(A.activeConceptSetId)), A.pendingApproval) {
        const { tool: w, arguments: O } = A.pendingApproval, P = YP(O);
        if (l({
          tool: w,
          args: P,
          rawArguments: O,
          proposal: null,
          loadingProposal: w === "applyProposal"
        }), w === "applyProposal" && typeof P.proposalId == "string")
          try {
            const E = await zP(P.proposalId);
            l(
              (C) => C && { ...C, proposal: E, loadingProposal: !1 }
            );
          } catch {
            l(
              (E) => E && { ...E, loadingProposal: !1 }
            );
          }
        return;
      }
      l(null), A.reply && v(A.reply);
    },
    [v]
  ), M = Ge(
    async (A) => {
      const w = A.trim();
      if (!(!w || i || o)) {
        r((O) => [...O, I1("user", w)]), a(!0);
        try {
          const O = await PP({
            sessionId: f.current,
            conceptSetId: h.current,
            message: w
          });
          await I(O);
        } catch (O) {
          _(O);
        } finally {
          a(!1);
        }
      }
    },
    [I, _, i, o]
  ), k = Ge(
    async (A) => {
      const w = f.current;
      if (!(!w || !c || i)) {
        l(null), a(!0);
        try {
          const O = await LP(w, A);
          await I(O);
        } catch (O) {
          _(O);
        } finally {
          a(!1);
        }
      }
    },
    [I, _, c, i]
  ), y = Ge(() => k(!0), [k]), x = Ge(() => k(!1), [k]), b = Ge(() => {
    g(), f.current = null, h.current = e, d(e), r([]), l(null), a(!1);
  }, [e, g]);
  return {
    messages: n,
    sending: i,
    streaming: o,
    pendingApproval: c,
    activeConceptSetId: u,
    sendMessage: M,
    approve: y,
    reject: x,
    reset: b
  };
}, N1 = 480, mo = 340, WP = 640, Hd = 640, lp = 440, Ud = "--prometheus-ai-chat-width", HP = [
  "Find OMOP concepts for type 2 diabetes",
  "Look up ICD-10 codes E11.9 and E11.65",
  "Which aspirin concepts have the most patient records?"
], UP = (e) => /* @__PURE__ */ B(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-expand-icon lucide-expand",
    ...e,
    children: [
      /* @__PURE__ */ p("path", { d: "m15 15 6 6" }),
      /* @__PURE__ */ p("path", { d: "m15 9 6-6" }),
      /* @__PURE__ */ p("path", { d: "M21 16v5h-5" }),
      /* @__PURE__ */ p("path", { d: "M21 8V3h-5" }),
      /* @__PURE__ */ p("path", { d: "M3 16v5h5" }),
      /* @__PURE__ */ p("path", { d: "m3 21 6-6" }),
      /* @__PURE__ */ p("path", { d: "M3 8V3h5" }),
      /* @__PURE__ */ p("path", { d: "M9 9 3 3" })
    ]
  }
), GP = (e) => /* @__PURE__ */ B(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-minimize-icon lucide-minimize",
    ...e,
    children: [
      /* @__PURE__ */ p("path", { d: "M8 3v3a2 2 0 0 1-2 2H3" }),
      /* @__PURE__ */ p("path", { d: "M21 8h-3a2 2 0 0 1-2-2V3" }),
      /* @__PURE__ */ p("path", { d: "M3 16h3a2 2 0 0 1 2 2v3" }),
      /* @__PURE__ */ p("path", { d: "M16 21v-3a2 2 0 0 1 2-2h3" })
    ]
  }
), VP = (e) => /* @__PURE__ */ B(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-copy-icon lucide-copy",
    ...e,
    children: [
      /* @__PURE__ */ p("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }),
      /* @__PURE__ */ p("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
    ]
  }
), QP = (e) => /* @__PURE__ */ B(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...e,
    children: [
      /* @__PURE__ */ p("path", { d: "M18 6 6 18" }),
      /* @__PURE__ */ p("path", { d: "m6 6 12 12" })
    ]
  }
), Vc = (e, t = !1, n) => {
  if (typeof window > "u" || !t)
    return Math.min(WP, Math.max(mo, e));
  const r = n ?? window.innerWidth;
  return Math.min(
    Math.max(mo, r),
    Math.max(mo, e)
  );
}, qP = (e) => {
  if (typeof window > "u") return N1;
  const t = Number(window.localStorage.getItem(`${e}:width`));
  return Number.isFinite(t) ? Vc(t, !0) : N1;
}, cp = (e) => typeof window > "u" ? lp : Math.min(
  lp,
  Math.max(0, window.innerHeight - e)
), up = (e, t) => {
  const n = cp(t);
  if (typeof window > "u")
    return Math.max(n, e);
  const r = Math.max(n, window.innerHeight - t);
  return Math.min(r, Math.max(n, e));
}, XP = (e, t) => {
  if (typeof window > "u") return null;
  const n = Number(
    window.localStorage.getItem(`${e}:height:${t}`)
  );
  return Number.isFinite(n) ? up(n, 0) : null;
}, fc = (e, t, n) => typeof window > "u" ? { left: 0, top: n } : {
  left: Math.max(24, window.innerWidth - e - 24),
  top: Math.max(n, window.innerHeight - t - 24)
}, dc = (e, t, n, r) => typeof window > "u" ? e : {
  left: Math.min(
    Math.max(0, e.left),
    Math.max(0, window.innerWidth - t)
  ),
  top: Math.min(
    Math.max(r, e.top),
    Math.max(r, window.innerHeight - n)
  )
}, JP = (e) => e === "left" || e === "top-left" || e === "bottom-left", KP = (e) => e === "right" || e === "top-right" || e === "bottom-right", ZP = (e) => e === "top" || e === "top-left" || e === "top-right", eL = (e) => e === "bottom" || e === "bottom-left" || e === "bottom-right", $V = ({
  mode: e = "overlay",
  title: t = "Assistant",
  overlayTitle: n = "Assistant",
  tooltipText: r = "Assistant",
  buttonText: i = "Assistant",
  buttonName: a = "assistant",
  topOffset: o = 60,
  storageKey: s = "prometheus-ai-chat",
  conceptSetId: c = null
}) => {
  var We;
  const {
    messages: l,
    sending: u,
    streaming: d,
    pendingApproval: f,
    sendMessage: h,
    approve: m,
    reject: g,
    reset: v
  } = jP({ conceptSetId: c }), [_, I] = Se(!1), [M, k] = Se(e), [y, x] = Se(
    () => qP(s)
  ), [b, A] = Se(
    () => XP(s, "overlay")
  ), [w, O] = Se(null), [P, E] = Se(o), [C, T] = Se(""), [D, z] = Se(null), [F, W] = Se(null), L = qt(null), S = kC(), j = qt(null), Y = qt(null), N = qt(null), X = `${a}-menu-button-${S}`, G = `${a}-menu-${S}`, q = M === "overlay", $ = q ? n : t, Q = q ? b : null, V = q ? y : Vc(y), H = typeof window > "u" ? Hd : Math.min(
    Hd,
    Math.max(
      cp(o),
      window.innerHeight - o - 24
    )
  ), K = q ? up(Q ?? H, o) : H, U = dc(
    w ?? fc(
      V,
      K,
      o
    ),
    V,
    K,
    o
  );
  He(() => {
    k(e);
  }, [e]), He(() => {
    typeof window < "u" && window.localStorage.setItem(`${s}:width`, String(y));
  }, [y, s]), He(() => {
    typeof window < "u" && b && window.localStorage.setItem(
      `${s}:height:overlay`,
      String(b)
    );
  }, [b, s]), He(() => {
    if (typeof window > "u") return;
    const ie = () => {
      E(Math.max(o - window.scrollY, 0));
    };
    return ie(), window.addEventListener("scroll", ie, { passive: !0 }), () => window.removeEventListener("scroll", ie);
  }, [o]), He(() => {
    if (!q || typeof window > "u") return;
    const ie = () => {
      O(
        (ve) => dc(
          ve ?? fc(
            V,
            K,
            o
          ),
          V,
          K,
          o
        )
      );
    };
    return ie(), window.addEventListener("resize", ie), () => window.removeEventListener("resize", ie);
  }, [K, V, q, o]), He(() => {
    M !== "sidebar" || typeof document > "u" || document.documentElement.style.setProperty(
      Ud,
      _ ? `${V}px` : "0px"
    );
  }, [M, V, _]), He(() => () => {
    typeof document < "u" && document.documentElement.style.setProperty(
      Ud,
      "0px"
    );
  }, []), He(() => {
    M === "sidebar" || typeof document > "u" || document.documentElement.style.setProperty(Ud, "0px");
  }, [M]), He(() => {
    var ie;
    _ && ((ie = j.current) == null || ie.scrollIntoView({ block: "end" }));
  }, [l, u, f, _]), He(() => {
    _ || z(null);
  }, [_]);
  const ee = Ge(() => Q || (typeof window > "u" ? Hd : q ? K : window.innerHeight - P), [K, q, Q, P]), ce = Ge(
    (ie) => {
      const ve = Y.current;
      if (!ve) return;
      if (!q) {
        const Bn = ve.left + ve.width, Dt = Math.min(ie.clientX, Bn - mo), Pt = Bn - Dt;
        x(Vc(Pt));
        return;
      }
      const _e = typeof window > "u" ? ve.width : window.innerWidth, Ie = typeof window > "u" ? ve.height : window.innerHeight, Pe = ve.left + ve.width, Qe = ve.top + ve.height, et = cp(o);
      let _t = ve.left, tr = ve.top, St = Pe, $t = Qe;
      JP(ve.direction) && (_t = Math.min(
        Math.max(0, ie.clientX),
        Pe - mo
      )), KP(ve.direction) && (St = Math.max(
        Math.min(_e, ie.clientX),
        ve.left + mo
      )), ZP(ve.direction) && (tr = Math.min(
        Math.max(o, ie.clientY),
        Qe - et
      )), eL(ve.direction) && ($t = Math.max(
        Math.min(Ie, ie.clientY),
        ve.top + et
      ));
      const dn = Vc(St - _t, !0, _e), mt = up($t - tr, o);
      x(dn), A(mt), O(
        dc(
          { left: _t, top: tr },
          dn,
          mt,
          o
        )
      );
    },
    [q, o]
  ), se = Ge(() => {
    Y.current = null, window.removeEventListener("pointermove", ce);
  }, [ce]), ne = (ie, ve) => {
    ie.preventDefault();
    const _e = typeof window > "u" ? 0 : window.innerWidth - V;
    Y.current = {
      x: ie.clientX,
      y: ie.clientY,
      width: V,
      height: ee(),
      left: q ? U.left : _e,
      top: q ? U.top : P,
      direction: ve
    }, window.addEventListener("pointermove", ce), window.addEventListener("pointerup", se, { once: !0 });
  };
  He(() => () => {
    window.removeEventListener("pointermove", ce), window.removeEventListener("pointerup", se);
  }, [ce, se]);
  const re = Ge(
    (ie) => {
      const ve = N.current;
      if (!ve) return;
      const _e = {
        left: ve.left + ie.clientX - ve.x,
        top: ve.top + ie.clientY - ve.y
      };
      O(
        dc(
          _e,
          V,
          K,
          o
        )
      );
    },
    [K, V, o]
  ), Me = Ge(() => {
    N.current = null, window.removeEventListener("pointermove", re);
  }, [re]), Re = (ie) => {
    q && (ie.target.closest("button") || (ie.preventDefault(), N.current = {
      x: ie.clientX,
      y: ie.clientY,
      left: U.left,
      top: U.top
    }, window.addEventListener("pointermove", re), window.addEventListener("pointerup", Me, { once: !0 })));
  };
  He(() => () => {
    window.removeEventListener("pointermove", re), window.removeEventListener("pointerup", Me);
  }, [re, Me]);
  const oe = (ie) => {
    ie == null || ie.preventDefault();
    const ve = C.trim();
    !ve || u || d || f || (h(ve), T(""));
  };
  He(() => () => {
    L.current && clearTimeout(L.current);
  }, []);
  const de = async (ie, ve) => {
    try {
      await navigator.clipboard.writeText(ve);
    } catch {
      return;
    }
    L.current && clearTimeout(L.current), W(ie), L.current = setTimeout(() => W(null), 1500);
  }, ue = (ie) => {
    z(ie.currentTarget);
  }, me = () => {
    z(null);
  }, Z = () => {
    v(), T(""), me();
  }, le = () => {
    me(), k((ie) => {
      const ve = ie === "sidebar" ? "overlay" : "sidebar";
      return ve === "overlay" && O(
        fc(
          V,
          K,
          o
        )
      ), ve;
    });
  }, J = () => {
    !_ && q && O(
      fc(
        V,
        K,
        o
      )
    ), I((ie) => !ie);
  }, ae = (ie) => {
    ie.key === "Enter" && !ie.shiftKey && (ie.preventDefault(), oe());
  }, ge = l.length > 0, be = !!D, we = /* @__PURE__ */ B(
    gI,
    {
      open: _,
      panelWidth: V,
      panelHeight: q ? K : Q,
      minPanelHeight: lp,
      overlayLeft: q ? U.left : null,
      overlayTop: q ? U.top : null,
      topOffset: q ? o : P,
      isOverlay: q,
      role: "complementary",
      "aria-label": $,
      children: [
        /* @__PURE__ */ p(
          oc,
          {
            placement: "left",
            onPointerDown: (ie) => ne(ie, "left")
          }
        ),
        q && /* @__PURE__ */ B(ze, { children: [
          /* @__PURE__ */ p(
            oc,
            {
              placement: "right",
              onPointerDown: (ie) => ne(ie, "right")
            }
          ),
          /* @__PURE__ */ p(
            oc,
            {
              placement: "top",
              onPointerDown: (ie) => ne(ie, "top")
            }
          ),
          /* @__PURE__ */ p(
            oc,
            {
              placement: "bottom",
              onPointerDown: (ie) => ne(ie, "bottom")
            }
          ),
          /* @__PURE__ */ p(
            sc,
            {
              placement: "top-left",
              onPointerDown: (ie) => ne(ie, "top-left")
            }
          ),
          /* @__PURE__ */ p(
            sc,
            {
              placement: "top-right",
              onPointerDown: (ie) => ne(ie, "top-right")
            }
          ),
          /* @__PURE__ */ p(
            sc,
            {
              placement: "bottom-left",
              onPointerDown: (ie) => ne(ie, "bottom-left")
            }
          ),
          /* @__PURE__ */ p(
            sc,
            {
              placement: "bottom-right",
              onPointerDown: (ie) => ne(ie, "bottom-right")
            }
          )
        ] }),
        /* @__PURE__ */ p(yI, { isOverlay: q, children: /* @__PURE__ */ B(xI, { children: [
          /* @__PURE__ */ p(vI, { children: /* @__PURE__ */ B(AI, { isOverlay: q, onPointerDown: Re, children: [
            /* @__PURE__ */ p(bI, { children: /* @__PURE__ */ p(fe, { fontSize: 16, fontWeight: 700, noWrap: !0, children: $ }) }),
            /* @__PURE__ */ B(wI, { children: [
              /* @__PURE__ */ p(
                Hc,
                {
                  "aria-label": q ? "Dock chat as sidebar" : "Open chat as overlay",
                  onClick: le,
                  children: q ? /* @__PURE__ */ p(UP, {}) : /* @__PURE__ */ p(GP, {})
                }
              ),
              /* @__PURE__ */ p(SI, { "aria-label": "New chat", onClick: v, children: /* @__PURE__ */ p(pe, { iconName: "squarePen", sx: { fontSize: 18 } }) }),
              /* @__PURE__ */ p(
                Hc,
                {
                  id: X,
                  "aria-label": "Open chat menu",
                  "aria-controls": be ? G : void 0,
                  "aria-haspopup": "true",
                  "aria-expanded": be ? "true" : void 0,
                  onClick: ue,
                  children: /* @__PURE__ */ p(_I, { "aria-hidden": "true", children: "..." })
                }
              ),
              /* @__PURE__ */ p(
                lA,
                {
                  id: G,
                  anchorEl: D,
                  open: be,
                  onClose: me,
                  MenuListProps: {
                    "aria-labelledby": X
                  },
                  anchorOrigin: { horizontal: "right", vertical: "bottom" },
                  transformOrigin: { horizontal: "right", vertical: "top" },
                  slotProps: {
                    root: {
                      sx: {
                        zIndex: Xh + 1
                      }
                    },
                    paper: {
                      elevation: 0,
                      sx: {
                        mt: 0.75,
                        minWidth: 152,
                        border: "1px solid #eceff3",
                        borderRadius: "8px",
                        boxShadow: "0 10px 24px rgba(20, 24, 31, 0.12)"
                      }
                    }
                  },
                  children: /* @__PURE__ */ B(
                    su,
                    {
                      onClick: Z,
                      sx: { gap: 1, fontSize: 12, minHeight: 32 },
                      children: [
                        /* @__PURE__ */ p(pe, { iconName: "delete", sx: { fontSize: 14 } }),
                        "Delete chat"
                      ]
                    }
                  )
                }
              ),
              /* @__PURE__ */ p(
                Hc,
                {
                  "aria-label": "Close chat sidebar",
                  onClick: () => I(!1),
                  children: /* @__PURE__ */ p(QP, {})
                }
              )
            ] })
          ] }) }),
          /* @__PURE__ */ B(CI, { children: [
            !ge && /* @__PURE__ */ B(ze, { children: [
              /* @__PURE__ */ p(EI, { children: "Common Requests" }),
              /* @__PURE__ */ p(RI, { children: HP.map((ie) => /* @__PURE__ */ p(
                DI,
                {
                  type: "button",
                  onClick: () => T(ie),
                  children: ie
                },
                ie
              )) })
            ] }),
            l.map((ie, ve) => {
              if (ie.role !== "assistant")
                return /* @__PURE__ */ p(Ly, { role: ie.role, children: ie.text }, ie.id);
              const _e = d && ve === l.length - 1;
              return /* @__PURE__ */ B(II, { children: [
                /* @__PURE__ */ p(Ly, { role: ie.role, children: /* @__PURE__ */ p(DP, { text: ie.text }) }),
                !_e && !!ie.text && /* @__PURE__ */ p(NI, { children: /* @__PURE__ */ p(
                  pt,
                  {
                    text: F === ie.id ? "Copied" : "Copy",
                    popperProps: {
                      sx: { zIndex: Xh + 1 }
                    },
                    children: /* @__PURE__ */ p(
                      OI,
                      {
                        "aria-label": "Copy reply",
                        onClick: () => de(ie.id, ie.text),
                        children: /* @__PURE__ */ p(VP, {})
                      }
                    )
                  }
                ) })
              ] }, ie.id);
            }),
            f && /* @__PURE__ */ B($I, { role: "group", "aria-label": "Approval required", children: [
              /* @__PURE__ */ B(YI, { children: [
                /* @__PURE__ */ p(pe, { iconName: "aiStars", sx: { fontSize: 16 } }),
                /* @__PURE__ */ p("span", { children: "Approval required" }),
                /* @__PURE__ */ p(jI, { children: f.tool })
              ] }),
              f.proposal ? /* @__PURE__ */ B(ze, { children: [
                /* @__PURE__ */ p(WI, { children: f.proposal.summary }),
                f.proposal.reason && /* @__PURE__ */ p(zy, { children: f.proposal.reason }),
                ((We = f.proposal.delta) == null ? void 0 : We.length) > 0 && /* @__PURE__ */ p(UI, { children: f.proposal.delta.map((ie, ve) => /* @__PURE__ */ B(
                  GI,
                  {
                    op: ie.op,
                    children: [
                      /* @__PURE__ */ p("b", { children: ie.op }),
                      /* @__PURE__ */ p("span", { children: ie.path })
                    ]
                  },
                  `${ie.op}-${ie.path}-${ve}`
                )) })
              ] }) : f.loadingProposal ? /* @__PURE__ */ p(zy, { children: "Loading the proposed change…" }) : /* @__PURE__ */ p(HI, { children: JSON.stringify(f.args, null, 2) }),
              /* @__PURE__ */ B(VI, { children: [
                /* @__PURE__ */ p(
                  By,
                  {
                    type: "button",
                    tone: "reject",
                    onClick: g,
                    disabled: u,
                    children: "Reject"
                  }
                ),
                /* @__PURE__ */ p(
                  By,
                  {
                    type: "button",
                    tone: "approve",
                    variant: "contained",
                    onClick: m,
                    disabled: u,
                    children: "Approve"
                  }
                )
              ] })
            ] }),
            u && /* @__PURE__ */ B(FI, { "aria-label": "Assistant is working", role: "status", children: [
              /* @__PURE__ */ p("span", {}),
              /* @__PURE__ */ p("span", {}),
              /* @__PURE__ */ p("span", {})
            ] }),
            /* @__PURE__ */ p("div", { ref: j })
          ] }),
          /* @__PURE__ */ p(PI, { children: /* @__PURE__ */ B(LI, { onSubmit: oe, children: [
            /* @__PURE__ */ p(
              zI,
              {
                "aria-label": `Message ${$}`,
                placeholder: f ? "Approve or reject the pending action to continue" : `Message ${$}`,
                value: C,
                rows: 1,
                disabled: u || d || !!f,
                onChange: (ie) => T(ie.target.value),
                onKeyDown: ae
              }
            ),
            /* @__PURE__ */ p(
              BI,
              {
                type: "submit",
                variant: "contained",
                "aria-label": "Send message",
                disabled: u || d || !!f || !C.trim(),
                children: /* @__PURE__ */ p(pe, { iconName: "send", sx: { fontSize: 16 } })
              }
            )
          ] }) })
        ] }) })
      ]
    }
  );
  return /* @__PURE__ */ B(ze, { children: [
    /* @__PURE__ */ p(Cf, { children: /* @__PURE__ */ p(pt, { text: r, children: /* @__PURE__ */ p(
      Ef,
      {
        onClick: J,
        hasNotifications: _,
        count: 0,
        disableRipple: !0,
        startIcon: /* @__PURE__ */ p(
          gf,
          {
            variant: "dot",
            color: "primary",
            invisible: !_,
            sx: {
              "& .MuiBadge-badge": {
                height: 10,
                minWidth: 10,
                backgroundColor: "#4da3ff",
                border: "2px solid #ffffff",
                boxShadow: "0 0 0 1px rgba(77, 163, 255, 0.45)"
              }
            },
            children: /* @__PURE__ */ p(pe, { iconName: "aiStars" })
          }
        ),
        name: a,
        text: i
      }
    ) }) }),
    /* @__PURE__ */ p(ZC, { children: we })
  ] });
}, tL = {
  CONCEPT_CLASS_ID: "Class",
  CONCEPT_CODE: "Code",
  CONCEPT_ID: "ID",
  CONCEPT_NAME: "Name",
  DOMAIN_ID: "Domain",
  DISTANCE: "Distance",
  INVALID_REASON: "Invalid reason",
  INVALID_REASON_CAPTION: "Invalid reason",
  STANDARD_CONCEPT: "Standard concept",
  STANDARD_CONCEPT_CAPTION: "Standard concept (caption)",
  VOCABULARY_ID: "Vocabulary",
  RECORD_COUNT: "Record count",
  DESCENDANT_RECORD_COUNT: "Descendant record count",
  PERSON_COUNT: "Person count",
  DESCENDANT_PERSON_COUNT: "Descendant person count"
};
function nL(e, t) {
  const n = Object.values(t).map((r) => r == null ? void 0 : r[e]);
  return new Set(n).size > 1;
}
function rL(e, t = !1) {
  const n = {}, r = [];
  return e.forEach((a) => {
    const o = a.id + a.versionId;
    Object.values(a.items || {}).forEach((s) => {
      const c = s.conceptId;
      n[c] || (n[c] = {}), n[c][o] = s;
    }), r.push(o);
  }), Object.entries(n).map(([a, o]) => {
    var u;
    const s = [
      "excluded",
      "mapped",
      "descendants",
      "hierarchy"
    ], c = Object.fromEntries(
      s.map((d) => [d, nL(d, o)])
    );
    Object.values(c).some(Boolean);
    const l = {};
    for (const d of r) {
      const f = o[d], h = !f, m = Object.fromEntries(
        s.map((g) => {
          const v = c[g] && Object.values(o).some(
            (_) => (_ == null ? void 0 : _[g]) !== (f == null ? void 0 : f[g])
          );
          return [g, v];
        })
      );
      l[d] = {
        ...f ?? {},
        _diff: m,
        _missing: h,
        _entireConceptMissing: h
      };
    }
    return {
      conceptId: Number(a),
      concept: ((u = Object.values(o)[0]) == null ? void 0 : u.concept) ?? {},
      perSetData: l,
      differences: c,
      hasDiff: Object.values(l).some((d) => {
        let f = { ...Object.values(l)[0] }, h = { ...d };
        return delete f.id, delete h.id, delete f.concept, delete h.concept, !Qs(f, h);
      })
    };
  }).filter((a) => t ? a == null ? void 0 : a.hasDiff : a);
}
const iL = [
  {
    attribute: "Container",
    source: "conceptSetIds",
    getValue: (e, t) => e[t].typeContainer ?? "N/A"
  },
  {
    attribute: "Version ordinal",
    source: "conceptSets",
    getValue: (e, t) => {
      var n, r;
      return ((n = e[t]) == null ? void 0 : n.ordinal) ?? ((r = e[t].modified) == null ? void 0 : r.ordinal);
    }
  },
  {
    attribute: "Modified date",
    source: "conceptSets",
    getValue: (e, t) => {
      var n, r;
      return (n = e[t].modified) != null && n.timestamp ? Kn((r = e[t].modified) == null ? void 0 : r.timestamp) : "-";
    }
  },
  {
    attribute: "Is latest version",
    source: "conceptSets",
    getValue: (e, t) => {
      const n = e[t];
      return n.versionId === n.latest ? "Yes" : "No";
    }
  },
  {
    attribute: "Expression items",
    source: "conceptSets",
    getValue: (e, t) => Object.keys(e[t].items || {}).length
  },
  {
    attribute: "Included concepts",
    source: "includedConceptsCounts",
    getValue: (e, t) => e[t] ?? 0
  },
  {
    attribute: "Included source codes",
    source: "includedSourceCodesCounts",
    getValue: (e, t) => e[t] ?? 0
  },
  {
    attribute: "Metadata",
    source: "metadataCounts",
    getValue: (e, t) => e[t] ?? 0
  }
];
function qb(e, t) {
  return JSON.stringify(e) === JSON.stringify(t);
}
function aL(e, t = [], n = [], r = [], i = !1, a) {
  if (!e.length) return [];
  const o = {
    conceptSets: e,
    includedConceptsCounts: t,
    includedSourceCodesCounts: n,
    metadataCounts: r,
    conceptSetIds: a
  }, s = [];
  for (const c of iL) {
    const l = o[c.source], u = e.map(
      (m, g) => c.getValue(l, g)
    ), d = u[0], f = u.some((m) => !qb(m, d));
    if (i && !f)
      continue;
    const h = {
      attribute: c.attribute,
      hasDiff: f
      // in this case we only count of whole row has diff
    };
    e.forEach((m, g) => {
      const v = `${m.id}${m.versionId}`, _ = u[g];
      h[v] = { value: _, hasDiff: f };
    }), s.push(h);
  }
  return console.log(s), s;
}
function oL(e, t, n = !1) {
  const r = [], i = /* @__PURE__ */ new Set(), a = [];
  e.forEach((o, s) => {
    var c;
    a[s] = 0;
    for (const l of o.content || []) {
      const u = ((c = l.attribute) == null ? void 0 : c.name) ?? "";
      u.startsWith("ai-") || (i.add(u), a[s]++);
    }
  });
  for (const o of i) {
    const s = e.map((d, f) => {
      var v, _;
      const h = (d.content || []).filter(
        (I) => {
          var M;
          return ((M = I.attribute) == null ? void 0 : M.name) === o;
        }
      );
      if (h.length === 0) return;
      if (((v = h[0].attribute) == null ? void 0 : v.type) === "ENUM_MULTI")
        return h.map((I) => {
          var M;
          return (M = I.attributeOption) == null ? void 0 : M.value;
        }).sort().join(", ");
      const g = h[0];
      return ((_ = g.attributeOption) == null ? void 0 : _.value) || g.value || "—";
    }), c = s[0], l = s.some((d) => !qb(d, c));
    if (n && !l) continue;
    const u = { attribute: o, hasDiff: l };
    t.forEach((d, f) => {
      u[d.id + d.versionId] = {
        value: s[f],
        hasDiff: l,
        isMissing: s[f] == null
      };
    }), r.push(u);
  }
  return { rows: r, counts: a };
}
function O1(e, t, n = !1) {
  const r = {};
  e.forEach((o, s) => {
    var u;
    const c = o.id + o.versionId;
    (((u = t == null ? void 0 : t[s]) == null ? void 0 : u.content) || []).forEach((d) => {
      const f = d.CONCEPT_ID;
      r[f] || (r[f] = {}), r[f][c] = d;
    });
  });
  const i = e.map((o) => o.id + o.versionId);
  return Object.entries(r).map(([o, s]) => {
    const c = Number(o), l = i.map(
      (f) => !!s[f]
    ), u = new Set(l).size > 1;
    if (n && !u) return null;
    const d = {};
    for (const f of i)
      d[f] = {
        present: !!s[f]
      };
    return {
      conceptId: c,
      concept: Object.values(s)[0],
      perSetData: d,
      isDifferent: u
    };
  }).filter(Boolean);
}
const Vm = "#faf1c880", Xb = "#ffed9480", sL = "#f4cf71", Nf = "#fcdada80", Qm = (e) => ({ getValue: t, row: n }) => {
  const r = t() || {}, i = n.original.hasDiff || n.original.isDifferent;
  return /* @__PURE__ */ p(
    pt,
    {
      text: e ? /* @__PURE__ */ p(he, { children: Object.keys(n.original.concept).map((a) => /* @__PURE__ */ B(he, { sx: { mb: 0.5 }, children: [
        /* @__PURE__ */ B("strong", { children: [
          tL[a],
          ":"
        ] }),
        " ",
        n.original.concept[a] || "—"
      ] }, a)) }) : "",
      color: "primary",
      width: "auto",
      children: /* @__PURE__ */ p(
        he,
        {
          sx: {
            display: "flex",
            backgroundColor: i ? Xb : "transparent",
            pl: 1.5,
            ...i ? {
              "::before": {
                content: "''",
                display: "inline-block",
                width: "6px",
                height: "100%",
                backgroundColor: sL,
                position: "absolute",
                left: 0
              }
            } : {}
          },
          children: r
        }
      )
    }
  );
}, lL = [
  {
    id: "id",
    header: "Id",
    accessorKey: "concept.CONCEPT_ID",
    enableColumnFilter: !1,
    size: 180,
    enableResizing: !1,
    enableHiding: !1,
    cell: Qm(!0)
  }
], hc = (e, t, n, r, i) => ({
  id: `${e}___${n + r}`,
  header: () => /* @__PURE__ */ p(
    pt,
    {
      text: /* @__PURE__ */ B(ze, { children: [
        /* @__PURE__ */ p(he, { sx: { paddingBottom: "4px", fontWeight: "bold" }, children: t }),
        /* @__PURE__ */ p(he, { component: "text", sx: { whiteSpace: "pre-line" }, children: i })
      ] }),
      placement: "top",
      children: /* @__PURE__ */ p(eE, { iconName: t, width: 20, sx: { mr: 0.5 } })
    }
  ),
  accessorFn: (a) => {
    var u, d;
    const o = (u = a.perSetData) == null ? void 0 : u[n + r], s = o == null ? void 0 : o[e];
    o == null || o._missing;
    const c = o == null ? void 0 : o._entireConceptMissing, l = ((d = o == null ? void 0 : o._diff) == null ? void 0 : d[e]) === !0;
    return {
      value: s,
      highlight: c ? "red" : l ? "yellow" : null
    };
  },
  cell: ({ getValue: a }) => {
    const { value: o, highlight: s } = a();
    return /* @__PURE__ */ B(
      he,
      {
        sx: {
          backgroundColor: s === "red" ? Nf : s === "yellow" ? Vm : "transparent",
          textAlign: "center",
          lineHeight: "40px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        children: [
          o === !0 && /* @__PURE__ */ p(
            Ph,
            {
              iconName: "check",
              fontSize: "small",
              sx: { fontSize: 18, overflow: "hidden", pt: 0.25 }
            }
          ),
          o === !1 && /* @__PURE__ */ p(
            Ph,
            {
              iconName: "border",
              fontSize: "small",
              sx: { fontSize: 18, overflow: "hidden", pt: 0.25 }
            }
          ),
          o === void 0 && "—"
        ]
      }
    );
  },
  enableResizing: !1,
  meta: { align: "center", headerAlign: "center" },
  size: 45,
  enableSorting: !1
});
function cL(e) {
  const t = [...lL];
  return t.splice(
    1,
    0,
    ...e.map((n) => ({
      header: () => /* @__PURE__ */ p(
        he,
        {
          alignItems: "center",
          width: "100%",
          whiteSpace: "nowrap",
          flexGrow: 1,
          maxHeight: 36,
          overflow: "hidden",
          py: 0.5,
          textOverflow: "ellipsis",
          title: n.name,
          children: n.name
        }
      ),
      id: n.id + n.versionId,
      enableResizing: !1,
      size: 180,
      maxSize: 180,
      meta: { align: "center", headerAlign: "center" },
      columns: [
        hc(
          "excluded",
          "Exclude",
          n.id,
          n.versionId,
          `Marks the concept to be explicitly excluded from the concept Set.
It is possible to exclude a whole sub-trees of concepts by combining Exclude and Descendants/Hierarchy options.
Overrides the implicit inclusion of concepts from Descendants option.`
        ),
        hc(
          "descendants",
          "Descendants",
          n.id,
          n.versionId,
          `Includes child concepts from the standard hierarchy, utilizing OMOP CDM relation table data.
Option is available only for standard and classification concepts.`
        ),
        hc(
          "mapped",
          "Mapped",
          n.id,
          n.versionId,
          `Includes additional non-standard concepts, that this concept has a 'Maps to' relationship with.
If the concept is not mapped to any other concepts with 'Maps to' relationship, it will be excluded from the final list.
Option is available only for standard and classification concepts.`
        ),
        hc(
          "hierarchy",
          "Hierarchy",
          n.id,
          n.versionId,
          `Includes child concepts from the native hierarchy of source data, utilizing OMOP CDM relation table data.
Work same way as Descendants, but for non-standard concepts.
Option is available only for non-standard concepts.`
        )
      ]
    }))
  ), t;
}
function uL(e) {
  switch (e.typeContainer) {
    case Ae.LIBRARY:
      return `/library/concept-sets/${e.id}`;
    case Ae.WORKSPACE:
      return `/workspace/concept-sets/${e.id}`;
    case Ae.STUDY:
      return `/study-manager/${e.parentId}/concept-sets/${e.id}`;
    default:
      return null;
  }
}
function R1(e, t, n = "0") {
  const r = [
    {
      id: "attribute",
      header: "Name",
      accessorKey: "attribute",
      enableSorting: !1,
      size: 180,
      maxSize: 180,
      enableResizing: !1,
      cell: Qm(!1)
    }
  ];
  for (const i of e)
    r.push({
      id: i.id + i.versionId,
      header: () => /* @__PURE__ */ p(pt, { text: "Navigate to Consept Set", placement: "top", children: /* @__PURE__ */ B(
        he,
        {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          children: [
            /* @__PURE__ */ p(he, { flexGrow: 1, title: i.name, maxWidth: "calc(100% - 20px)", children: /* @__PURE__ */ p(AA, { to: uL(i), children: /* @__PURE__ */ p(
              he,
              {
                whiteSpace: "nowrap",
                maxHeight: 36,
                overflow: "hidden",
                py: 0.5,
                textOverflow: "ellipsis",
                title: i.name,
                children: i.name
              }
            ) }) }),
            t && /* @__PURE__ */ p(
              pe,
              {
                iconName: "close",
                sx: { ml: 1, cursor: "pointer", fontSize: 12 },
                onClick: () => {
                  t({ id: i.id, versionId: i.versionId });
                }
              }
            )
          ]
        }
      ) }),
      accessorKey: i.id + i.versionId,
      enableSorting: !1,
      size: 180,
      enableResizing: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: ({ getValue: a }) => {
        const { value: o, hasDiff: s, isMissing: c } = a() || {};
        return /* @__PURE__ */ p(
          he,
          {
            sx: {
              backgroundColor: s ? c ? Nf : Vm : "transparent",
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: o ?? n
          }
        );
      }
    });
  return r;
}
function fL(e) {
  return [
    {
      id: "id",
      header: "Id",
      accessorKey: "concept.CONCEPT_ID",
      enableColumnFilter: !1,
      size: 180,
      enableResizing: !1,
      enableHiding: !1,
      cell: Qm(!0)
    },
    ...e.map((n) => dL(n))
  ];
}
const dL = (e) => ({
  id: `presence___${e.id + e.versionId}`,
  header: () => /* @__PURE__ */ p(he, { whiteSpace: "wrap", children: e.name }),
  accessorKey: `perSetData.${e.id + e.versionId}.present`,
  enableResizing: !1,
  cell: ({ getValue: t, row: n }) => {
    var a;
    const r = !t(), i = (a = n.original) == null ? void 0 : a.isDifferent;
    return /* @__PURE__ */ p(
      he,
      {
        sx: {
          backgroundColor: i ? r ? Nf : Vm : "transparent",
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        children: t() ? /* @__PURE__ */ p(
          Ph,
          {
            iconName: "check",
            sx: { fontSize: 18, overflow: "hidden", pt: 0.25 }
          }
        ) : "—"
      }
    );
  },
  meta: { align: "center", headerAlign: "center" },
  size: 180,
  disableSorting: !0
}), hL = (e) => [
  {
    value: Lr.EXPRESSION,
    title: "Expression",
    onTabClick: e
  },
  {
    value: Lr.INCLUDED_CONCEPTS,
    title: "Included Concepts",
    onTabClick: e
  },
  {
    value: Lr.INCLUDED_SOURCE_CODES,
    title: "Included Source Codes",
    onTabClick: e
  }
], pL = (e) => ({
  [e.breakpoints.up("xs")]: { padding: "14px 8px" },
  [e.breakpoints.up("lg")]: { padding: "14px 12px" },
  [e.breakpoints.up("xl")]: { padding: "14px" }
}), mL = te("div", {
  shouldForwardProp: (e) => e !== "secondary" && e !== "hasRightTabs"
})(
  ({
    theme: e,
    secondary: t,
    hasRightTabs: n
  }) => ({
    position: "relative",
    display: "flex",
    justifyContent: n ? "space-between" : "flex-start",
    alignItems: "stretch",
    padding: 0,
    minWidth: 0,
    ".tabs-group": {
      display: "flex",
      alignItems: "stretch",
      minWidth: 0
    },
    ".tabs-group-left": {
      flexShrink: 1,
      overflow: "hidden"
    },
    ".tabs-group-right": {
      flexShrink: 0,
      marginLeft: "auto",
      gap: t ? 12 : 16
    },
    ".tab-tooltip-wrapper": {
      display: "inline-flex",
      alignItems: "stretch"
    },
    ".tab": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      fontSize: t ? 14 : 16,
      fontWeight: 400,
      textAlign: "center",
      color: e.palette.textColor.primary,
      opacity: 0.8,
      cursor: "pointer",
      overflowX: "hidden",
      padding: "14px 12px",
      // default
      ...pL(e),
      ".tab-wrapper": {
        display: "flex",
        flex: 1,
        alignItems: "center",
        minWidth: 0
      },
      ".tab-title": {
        flex: 1,
        minWidth: 0,
        overflowX: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      "::after": {
        content: "''",
        position: "absolute",
        bottom: 0,
        left: "50%",
        height: 4,
        width: "0",
        backgroundColor: e.palette.info.main,
        transition: "300ms",
        transform: "translateX(-50%, 0)"
      },
      "&.active": {
        fontWeight: 700,
        "::after": {
          left: 0,
          width: "100%",
          transform: "none"
        },
        ".tab-count": {
          fontWeight: 700
        }
      },
      "&.tab-icon-only": {
        flex: "0 0 auto",
        overflow: "visible",
        padding: t ? "12px 10px" : "14px 12px",
        minWidth: t ? 42 : 46,
        justifyContent: "center",
        gap: 6,
        ".tab-wrapper": {
          flex: "0 0 auto"
        },
        ".tab-wrapper .tab-title": {
          display: "none"
        },
        ".tab-count": {
          marginLeft: 0
        },
        "&::after": {
          height: 0
        },
        "&.active": {
          opacity: 1
        },
        "&:focus, &:focus-visible": {
          outline: "none",
          boxShadow: "none"
        }
      }
    },
    ".tabs-group .tab:not(:last-of-type)": {
      marginRight: t ? 0 : "12px"
    }
  })
), Of = (e) => {
  const { tabs: t, active: n, withRouting: r, end: i = !1, secondary: a = !1 } = e, o = t.filter((l) => l.align !== "right"), s = t.filter((l) => l.align === "right"), c = (l, u) => {
    const d = l.tooltipText || mu(l.title) || gL(l), f = typeof d == "string" ? d : mu(l.title), h = (I) => l.iconName ? /* @__PURE__ */ p(
      pe,
      {
        iconName: l.iconName,
        sx: {
          fontSize: l.iconOnly ? 20 : a ? 16 : 18,
          mr: l.iconOnly ? 0 : 0.75,
          color: l.iconOnly ? I ? "textColor.primary" : "black.light" : I ? "black.main" : "black.light"
        }
      }
    ) : null, m = Lh(
      l != null && l.iconName ? "tab-title-with-icon" : "",
      typeof l.title == "string" ? "tab-title" : ""
    ), g = l.iconOnly ? Xv(l.title) ? TC(l.title, {
      hideTitle: !0
    }) : null : l.title, v = (I) => Lh("tab", l.iconOnly ? "tab-icon-only" : "", I && "active"), _ = r ? /* @__PURE__ */ p(
      AA,
      {
        end: i || l.end,
        to: { pathname: l.value, search: location == null ? void 0 : location.search },
        className: ({ isActive: I }) => v(I),
        title: l.iconOnly ? void 0 : f,
        children: ({ isActive: I }) => /* @__PURE__ */ B(ze, { children: [
          h(I),
          /* @__PURE__ */ p("div", { className: m, children: g })
        ] })
      },
      u
    ) : /* @__PURE__ */ B(
      "a",
      {
        className: v(n === l.value),
        onClick: () => l.onTabClick(l.value),
        title: l.iconOnly ? void 0 : f,
        children: [
          h(n === l.value),
          /* @__PURE__ */ p("div", { className: m, children: g })
        ]
      },
      u
    );
    return l.iconOnly ? /* @__PURE__ */ p(
      tE,
      {
        title: d,
        placement: "top",
        arrow: !0,
        enterDelay: 100,
        enterNextDelay: 100,
        leaveDelay: 0,
        disableInteractive: !0,
        slotProps: {
          popper: {
            sx: {
              [`& .${G0.tooltip}`]: {
                mb: "6px !important",
                px: 1.25,
                py: 0.5,
                borderRadius: "5px",
                backgroundColor: "#7d88a6",
                color: "#ffffff",
                boxShadow: "none",
                fontSize: 14,
                lineHeight: "18px",
                fontWeight: 400
              },
              [`& .${G0.arrow}`]: {
                color: "#7d88a6"
              }
            }
          }
        },
        children: /* @__PURE__ */ p("span", { className: "tab-tooltip-wrapper", children: _ })
      },
      u
    ) : _;
  };
  return /* @__PURE__ */ B(mL, { secondary: a, hasRightTabs: s.length > 0, children: [
    /* @__PURE__ */ p("div", { className: "tabs-group tabs-group-left", children: o.map((l, u) => c(l, u)) }),
    s.length > 0 && /* @__PURE__ */ p("div", { className: "tabs-group tabs-group-right", children: s.map((l, u) => c(l, u)) })
  ] });
};
function mu(e) {
  if (typeof e == "string" || typeof e == "number") return String(e);
  if (Array.isArray(e)) return e.map(mu).join("");
  if (Xv(e)) {
    if (typeof e.props.title == "string")
      return e.props.title;
    if (e.props.children)
      return mu(e.props.children);
  }
  return "";
}
function gL(e) {
  const t = (e.id || e.value || "").replace(/^\/+|\/+$/g, "");
  return {
    versions: "Versions",
    versioning: "Versions",
    messages: "Messages",
    "meta-attributes": "Metadata",
    "ai-meta-attributes": "Generative AI",
    usage: "Used In",
    statistics: "Utilization Statistics",
    "ai-suggested": "External Publications (AI)"
  }[t] || t;
}
const D1 = ({
  text: e,
  color: t
}) => /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", p: 1.5, children: [
  /* @__PURE__ */ p(
    he,
    {
      sx: {
        backgroundColor: t,
        width: 14,
        height: 14,
        borderRadius: "2px",
        boxShadow: "inset -3px -3px 6px rgba(255,255,255,.4)",
        cursor: "pointer",
        transition: "300ms",
        position: "relative",
        filter: "brightness(96%)",
        ":hover": {
          filter: "brightness(90%)"
        }
      }
    }
  ),
  /* @__PURE__ */ B(fe, { variant: "subtitle2", ml: 0.5, children: [
    "— ",
    e
  ] })
] }), yL = te.div``, xL = te.span`
  margin-right: 8px;
  font-weight: bold;
  font-size: 14px;
`, vL = (e) => {
  const { title: t, count: n, loading: r = !1 } = e;
  return /* @__PURE__ */ B(yL, { children: [
    /* @__PURE__ */ p(xL, { children: t }),
    NE(n) && n >= 0 && /* @__PURE__ */ p(Wc, { className: "all-counter", dense: !0, children: r ? /* @__PURE__ */ p(yt, { size: 12, sx: { opacity: 0.6 } }) : n })
  ] });
}, AL = () => {
  const e = Qi(), t = qt(null), n = qt(null), r = qt(null), i = Rt(
    (W) => W.compare.data.conceptSets
  ), a = Rt((W) => W.compare.data), o = Rt(
    (W) => {
      var L;
      return (L = W.compare.ids) == null ? void 0 : L.conceptSets;
    }
  ), s = Rt((W) => W.compare.status), c = Rt((W) => W.compare.metadata), [l, u] = Se(!1), [d, f] = Se(Lr.EXPRESSION), [h, m] = Se(!1), g = Rt(
    (W) => W.compare.counts.includedConceptsCounts
  ), v = Rt(
    (W) => W.compare.counts.includedSourceCodesCounts
  ), _ = (W) => {
    e(CE("conceptSets", W));
  }, I = () => {
    i.forEach((W) => _(W));
  }, M = Ee(
    () => cL(i),
    [i]
  ), k = Ee(
    () => fL(i),
    [i]
  ), y = Ee(
    () => R1(i, null, "—"),
    [i]
  ), x = Ee(
    () => R1(
      i.map((W, L) => ({
        ...W,
        ...o[L]
      })),
      _
    ),
    [i, o, _]
  ), b = Ee(
    () => oL(c.conceptSets, i, l),
    [c.conceptSets, i, l]
  ), A = Ee(
    () => aL(
      i,
      g,
      v,
      b.counts,
      l,
      o
    ),
    [
      i,
      g,
      v,
      l,
      b,
      o
    ]
  ), w = Ee(
    () => rL(i, l),
    [i, l]
  ), O = Ee(
    () => O1(
      i,
      a.includedConcepts,
      l
    ),
    [i, l, a.includedConcepts]
  ), P = Ee(
    () => O1(
      i,
      a.includedSourceCodes,
      l
    ),
    [i, l, a.includedSourceCodes]
  ), E = Ee(() => hL(f), []);
  He(() => {
    i.length == 1 && u(!1);
  }, [i]);
  const C = i.length > 0, T = C && A.length > 0, D = C && b.rows.length > 0, z = C && w.length > 0, F = (...W) => (L) => {
    h || (m(!0), W.forEach((S) => {
      S.current && (S.current.scrollLeft = L.target.scrollLeft);
    }), requestAnimationFrame(() => {
      m(!1);
    }));
  };
  return He(() => {
    switch (d) {
      case Lr.INCLUDED_CONCEPTS:
        e(J0("included"));
        break;
      case Lr.INCLUDED_SOURCE_CODES:
        e(J0("included-source-code"));
        break;
    }
  }, [d]), He(() => {
    e(SE());
  }, []), /* @__PURE__ */ p(R, { container: !0, p: 2, className: "compare-container", children: /* @__PURE__ */ B(R, { container: !0, spacing: 1, sx: {}, children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ p(
      Fr,
      {
        outlined: !0,
        elevated: !0,
        size: "dense",
        title: /* @__PURE__ */ B(
          he,
          {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 0.5,
            mx: -1,
            children: [
              /* @__PURE__ */ B("label", { children: [
                /* @__PURE__ */ p(
                  aA,
                  {
                    name: "onlyDifferent",
                    onChange: () => {
                      u(!l);
                    },
                    disabled: i.length <= 1,
                    checked: l,
                    size: "small"
                  }
                ),
                /* @__PURE__ */ p(fe, { sx: { ml: 1 }, variant: "caption", children: "Show only different items" })
              ] }),
              C && /* @__PURE__ */ p(
                qe,
                {
                  color: "error",
                  title: "Clear all",
                  onClick: I,
                  iconName: "delete",
                  noCollapse: !0
                }
              )
            ]
          }
        ),
        children: /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ p(D1, { color: Xb, text: "Row has differences" }),
          /* @__PURE__ */ p(D1, { color: Nf, text: "Missing item" })
        ] })
      }
    ) }),
    C ? /* @__PURE__ */ B(ze, { children: [
      /* @__PURE__ */ p(R, { item: !0, xs: 12, className: "no-group", children: T && /* @__PURE__ */ p(
        Fr,
        {
          outlined: !0,
          elevated: !0,
          collapsible: !0,
          title: /* @__PURE__ */ p(
            vL,
            {
              title: "General",
              count: i.length
            }
          ),
          size: "dense",
          children: /* @__PURE__ */ p(
            ha,
            {
              variant: "uncontrolled",
              hideSettings: !0,
              hidePagination: !0,
              columns: x,
              data: A,
              onScroll: F(
                n,
                r
              ),
              ref: t,
              pinnedColumns: { left: ["attribute"] }
            }
          )
        }
      ) }),
      /* @__PURE__ */ p(R, { item: !0, xs: 12, className: "no-group", children: D && /* @__PURE__ */ p(
        Fr,
        {
          outlined: !0,
          elevated: !0,
          collapsible: !0,
          title: "Metadata",
          size: "dense",
          children: /* @__PURE__ */ p(
            ha,
            {
              variant: "uncontrolled",
              hideSettings: !0,
              hidePagination: !0,
              columns: y,
              data: b.rows,
              onScroll: F(
                n,
                t
              ),
              ref: r,
              pinnedColumns: { left: ["attribute"] }
            }
          )
        }
      ) }),
      z && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
        Fr,
        {
          outlined: !0,
          elevated: !0,
          collapsible: !0,
          title: "Items",
          size: "dense",
          children: /* @__PURE__ */ B(R, { item: !0, container: !0, children: [
            /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
              /* @__PURE__ */ p(
                Of,
                {
                  tabs: E,
                  active: d,
                  secondary: !0
                }
              ),
              /* @__PURE__ */ p(Sa, {})
            ] }),
            /* @__PURE__ */ B(
              R,
              {
                item: !0,
                xs: 12,
                className: d != Lr.EXPRESSION ? "no-group" : "",
                children: [
                  d == Lr.EXPRESSION && /* @__PURE__ */ p(
                    ha,
                    {
                      variant: "uncontrolled",
                      hideSettings: !0,
                      columns: M,
                      data: w,
                      withDuplicates: !0,
                      loading: s.conceptSets === Ce.IN_PROGRESS,
                      ref: n,
                      onScroll: F(
                        r,
                        t
                      ),
                      pinnedColumns: { left: ["id"] }
                    }
                  ),
                  d == Lr.INCLUDED_CONCEPTS && /* @__PURE__ */ p(
                    ha,
                    {
                      variant: "uncontrolled",
                      hideSettings: !0,
                      columns: k,
                      data: O,
                      withDuplicates: !0,
                      loading: s.includedConcepts === Ce.IN_PROGRESS,
                      ref: n,
                      onScroll: F(
                        r,
                        t
                      ),
                      pinnedColumns: { left: ["id"] }
                    }
                  ),
                  d == Lr.INCLUDED_SOURCE_CODES && /* @__PURE__ */ p(
                    ha,
                    {
                      variant: "uncontrolled",
                      hideSettings: !0,
                      columns: k,
                      data: P,
                      withDuplicates: !0,
                      loading: s.includedSourceCodes === Ce.IN_PROGRESS,
                      ref: n,
                      onScroll: F(
                        r,
                        t
                      ),
                      pinnedColumns: { left: ["id"] }
                    }
                  )
                ]
              }
            )
          ] })
        }
      ) })
    ] }) : /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(Fr, { outlined: !0, elevated: !0, title: "No data", size: "dense", children: /* @__PURE__ */ p(fe, { variant: "body2", p: 2, children: "Please select at least one concept set for comparison" }) }) })
  ] }) });
}, YV = ({}) => {
  const { openModal: e, closeModal: t } = zo(bm), r = Rt((o) => o.compare.ids).conceptSets, i = r == null ? void 0 : r.length;
  return /* @__PURE__ */ p(Cf, { children: /* @__PURE__ */ p(pt, { text: "Compare", children: /* @__PURE__ */ p(
    Ef,
    {
      onClick: () => {
        e(() => /* @__PURE__ */ p(AL, {}), "Compare", {
          closeOnClickOutside: !0,
          width: i * 180 + 300 + "px",
          onClose: t
        });
      },
      hasNotifications: i > 0,
      count: i,
      disabled: i < 1,
      startIcon: /* @__PURE__ */ p(
        gf,
        {
          badgeContent: i,
          color: "error",
          sx: {
            "& .MuiBadge-badge": {
              padding: "2px 4px",
              fontSize: 10,
              height: 14
            }
          },
          max: 999,
          children: /* @__PURE__ */ p(pe, { iconName: "compare" })
        }
      ),
      text: "Compare"
    }
  ) }) });
}, bL = te.div`
  /* padding: 10px 0; */
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[400];
}};
  font-size: 14px;
`, jV = ({ children: e, isInsert: t }) => {
  const n = Ee(() => t ? `No ${e} available` : e, [e]);
  return /* @__PURE__ */ p(bL, { children: n });
};
function wL(e) {
  switch (e) {
    case wt.ANALYSIS_SUBMISSION:
      return "green";
    case wt.ANALYSIS:
      return "blue";
    case wt.COHORT:
      return "purple";
    case wt.CONCEPT_SET:
      return "teal";
    case wt.CUSTOM_CODE:
      return "green";
  }
}
const Jb = (e) => {
  if (Array.isArray(e))
    return e.some(Jb);
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    return t === "yes" || t === "true";
  }
  return !1;
}, Xi = ({
  value: e,
  cell: t,
  size: n = 26,
  renderValue: r,
  row: i
}) => {
  var d, f, h, m;
  const a = e || (r == null ? void 0 : r()), o = wL(a), s = (n - n * 0.56) / 2, c = n * 0.55, l = (h = (f = (d = i == null ? void 0 : i.original) == null ? void 0 : d.values) == null ? void 0 : f.find(
    (g) => LC(g == null ? void 0 : g.fieldName)
  )) == null ? void 0 : h.value, u = (a === wt.COHORT || a === wt.CONCEPT_SET) && (Array.isArray(l) ? l.includes("Yes") : (m = l == null ? void 0 : l.includes) == null ? void 0 : m.call(l, "Yes"));
  return Jb(l), /* @__PURE__ */ p(pt, { text: u ? "AI generated" : "", children: /* @__PURE__ */ B(
    he,
    {
      sx: {
        display: t ? "block" : "inline-block",
        backgroundColor: o + ".light",
        padding: s < 1 ? 2 : s + "px",
        width: n,
        height: n,
        borderRadius: "50%",
        boxSizing: "border-box",
        position: "relative",
        m: t ? -0.5 : 0
      },
      children: [
        /* @__PURE__ */ p(
          pe,
          {
            iconName: a,
            sx: {
              fontSize: c,
              color: o + ".main"
            }
          }
        ),
        u && /* @__PURE__ */ p(
          pe,
          {
            iconName: "aiStars",
            sx: {
              fontSize: 18,
              position: "absolute",
              bottom: 10,
              right: -10,
              // left: -8,
              // top: -4,
              color: o + ".main"
            }
          }
        )
      ]
    }
  ) });
}, _L = te.div`
  font-size: 13px;
  .date {
    white-space: nowrap;
  }
  .time {
    color: ${({ theme: e }) => e.palette.textColor.label};
  }
`, ji = (e) => {
  var r;
  const t = e.value || ((r = e.renderValue) == null ? void 0 : r.call(e)), n = (() => {
    try {
      return Kn(t);
    } catch (i) {
      return console.error("WRONG DATE TIME FORMAT, value:", t, i), null;
    }
  })();
  return /* @__PURE__ */ p(_L, { children: n ? /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p("div", { className: "date", children: n }) }) : "-" });
}, SL = te.div`
  justify-content: flex-end;
  display: flex;
  margin: -4px;
  > *:not(:last-child) {
    margin-right: 6px;
  }
`, CL = ({
  onEdit: e,
  onView: t,
  onRemove: n,
  withConfirmation: r,
  entityType: i,
  entityName: a,
  children: o
}) => {
  const { t: s } = Da(), c = Xe.useMemo(
    () => `${s("tables.cells.confirm_message_action", {
      entityType: i || "this item"
    })} ${a || ""}?`,
    [a, i]
  );
  return /* @__PURE__ */ B(SL, { children: [
    o,
    t && /* @__PURE__ */ p(aT, { onView: t }),
    e && /* @__PURE__ */ p(iT, { onEdit: e }),
    n && /* @__PURE__ */ p(
      oT,
      {
        onRemove: n,
        withConfirmation: r,
        confirmationMessage: c
      }
    )
  ] });
}, EL = te("div")(({ theme: e }) => ({
  fontWeight: 700
})), kL = te("div")(({ theme: e }) => ({
  color: e.palette.textColor.label,
  fontSize: 12
})), TL = {
  [wt.ANALYSIS]: "Analysis",
  [wt.COHORT]: "Cohort",
  [wt.CONCEPT_SET]: "Concept set",
  [wt.ANALYSIS_SUBMISSION]: "Analysis execution"
}, P1 = {
  [wt.ANALYSIS]: "analyses",
  [wt.COHORT]: "cohorts",
  [wt.CONCEPT_SET]: "concept-sets",
  [wt.ANALYSIS_SUBMISSION]: "analyses"
}, ML = ({
  value: e,
  row: t
}) => {
  var i, a;
  const n = (i = t.original) == null ? void 0 : i.type, r = (a = t.original) == null ? void 0 : a.entityType;
  return /* @__PURE__ */ B("div", { children: [
    /* @__PURE__ */ p(EL, { children: e }),
    /* @__PURE__ */ B(kL, { children: [
      r ? TL[r] : "",
      " ",
      n ? " - " + mm[n] : ""
    ] })
  ] });
}, IL = te("span")(({ theme: e }) => ({
  fontWeight: 500,
  color: e.palette.text.primary
})), fp = ({ value: e, renderValue: t }) => /* @__PURE__ */ p(IL, { children: e || (t == null ? void 0 : t()) }), WV = ({ value: e, renderValue: t }) => {
  const n = e || (t == null ? void 0 : t()), r = (n == null ? void 0 : n.length) - 1;
  return Array.isArray(n) ? n != null && n.length ? /* @__PURE__ */ p(
    pt,
    {
      text: r && n ? n.map((i, a) => /* @__PURE__ */ p("div", { children: i }, i + a)) : "",
      children: /* @__PURE__ */ B(he, { component: "span", children: [
        n[0],
        !!r && /* @__PURE__ */ B(
          he,
          {
            sx: (i) => ({
              backgroundColor: $i(0.9, i.palette.grey[800]),
              borderRadius: "2px",
              color: i.palette.textColor.primary,
              fontSize: 12,
              p: "3px 4px",
              display: "inline-flex",
              height: 20,
              boxSizing: "border-box",
              ml: 1
            }),
            children: [
              "+ ",
              r
            ]
          }
        )
      ] })
    }
  ) : /* @__PURE__ */ p(ze, { children: "-" }) : (console.error("WRONG DATA TYPE PROVIDED FOR <ListCell>"), /* @__PURE__ */ p(ze, { children: "-" }));
}, L1 = ({
  value: e,
  renderValue: t
}) => {
  const n = e || (t == null ? void 0 : t());
  return /* @__PURE__ */ p(ze, { children: n != null && n.user ? `${n.user.firstName} ${n.user.lastName}` : n });
}, NL = ({ onChange: e, value: t = "", item: n, aliases: r = [] }) => {
  var d;
  const [i, a] = Se(t), o = ((d = r == null ? void 0 : r.filter((f) => f === i)) == null ? void 0 : d.length) < 2, s = !i, c = s || !o, l = s ? "Alias should not be empty" : o ? "" : "Alias should be unique", u = (f) => {
    f == null || f.preventDefault(), i && t !== i && e({ ...n, alias: i });
  };
  return /* @__PURE__ */ p(cA, { onClickAway: u, children: /* @__PURE__ */ p("form", { onSubmit: u, action: "", children: /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", mr: 1, children: [
      /* @__PURE__ */ p(fe, { variant: "subtitle2", sx: { opacity: 0.7, mr: 0.75 }, children: "Alias" }),
      /* @__PURE__ */ p(pt, { text: "Alias/Variable name for each target cohort", children: /* @__PURE__ */ p(pe, { iconName: "info", sx: { fontSize: 14, color: "#9FA8BD" } }) })
    ] }),
    /* @__PURE__ */ p(pt, { text: l, show: c, placement: "right", children: /* @__PURE__ */ p(
      _r,
      {
        value: i || "",
        name: "alias",
        onClick: (f) => f.preventDefault(),
        onChange: (f) => {
          a(f.target.value);
        },
        sx: { width: 250 },
        InputProps: { error: c }
      }
    ) })
  ] }) }) });
}, HV = ({ hasAlias: e, entityType: t, ...n }) => {
  const {
    value: r,
    row: {
      original: { versionOrdinal: i, shortcut: a }
    },
    onChange: o,
    aliases: s = []
  } = n;
  return /* @__PURE__ */ B(
    he,
    {
      display: { lg: "flex", xs: "block" },
      justifyContent: "space-between",
      alignItems: "center",
      my: { xs: 0.5, lg: 0 },
      sx: { minHeight: "28px" },
      children: [
        /* @__PURE__ */ B(
          he,
          {
            display: "flex",
            alignItems: "center",
            sx: {
              maxWidth: { lg: "calc(100% - 320px)" },
              "& *:first-child": {
                mr: 1.5
              }
            },
            children: [
              /* @__PURE__ */ p(Xi, { value: t, size: 26 }),
              /* @__PURE__ */ p(
                fe,
                {
                  variant: "h3",
                  fontSize: 14,
                  sx: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  },
                  children: r
                }
              ),
              i ? /* @__PURE__ */ B(
                fe,
                {
                  sx: { ml: 1, fontWeight: 400 },
                  variant: "subtitle1",
                  component: "i",
                  children: [
                    "( ",
                    a ? `ID: ${a}, ` : "",
                    "Version: ",
                    i,
                    " )"
                  ]
                }
              ) : ""
            ]
          }
        ),
        e && /* @__PURE__ */ p(he, { mt: { lg: 0, xs: 1.5 }, children: /* @__PURE__ */ p(
          NL,
          {
            value: n.row.original.alias,
            item: n.row.original,
            onChange: o,
            aliases: s
          }
        ) })
      ]
    }
  );
}, UV = (e) => {
  var i, a, o, s, c, l;
  const t = e.value || e.getValue(), n = `${((a = (i = t.user) == null ? void 0 : i.firstName) == null ? void 0 : a[0]) || ""}${((s = (o = t.user) == null ? void 0 : o.lastName) == null ? void 0 : s[0]) || ""}`, r = `${((c = t.user) == null ? void 0 : c.firstName) || ""} ${((l = t.user) == null ? void 0 : l.lastName) || ""}`;
  return /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", maxWidth: "100%", children: [
    /* @__PURE__ */ p(
      sA,
      {
        sx: (u) => ({
          fontSize: 12,
          width: 30,
          height: 30,
          // fontWeight: 'bold',
          backgroundColor: u.palette.secondary.main,
          color: u.palette.primary.main
          // my: -0.5,
        }),
        children: n
      }
    ),
    /* @__PURE__ */ p(
      he,
      {
        ml: 1,
        fontWeight: "bold",
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        title: r,
        children: r
      }
    )
  ] });
}, GV = ({
  value: e,
  row: { original: t }
}) => {
  const n = kr(), r = Ee(() => (t == null ? void 0 : t.diff) > 0 ? n.palette.success.main : (t == null ? void 0 : t.diff) < 0 ? n.palette.error.main : n.palette.grey[500], [t == null ? void 0 : t.diff]);
  return /* @__PURE__ */ p(he, { my: -0.5, display: "flex", alignItems: "center", children: /* @__PURE__ */ p(_A, { width: 300, height: 30, data: e, children: /* @__PURE__ */ p(
    SA,
    {
      dataKey: "count",
      stroke: r,
      strokeWidth: 1.5,
      type: "linear",
      dot: { strokeWidth: 0, r: 0 }
    }
  ) }) });
}, OL = (e) => ({
  header: "",
  id: "icon",
  size: 40,
  minSize: 40,
  enableResizing: !1,
  enableSorting: !1,
  accessorKey: "type",
  enableHiding: !1,
  meta: { columnType: "action" },
  ...e || {}
}), Kb = (e) => ({
  header: "Id",
  accessorKey: "shortcut",
  id: "shortcut",
  size: 65,
  minSize: 65,
  maxSize: 100,
  ...e || {}
}), qm = (e) => ({
  id: "name",
  // old
  Header: "Name",
  accessor: "name",
  minWidth: 100,
  maxWidth: 1e3,
  width: "80%",
  isCropped: !0,
  Cell: fp,
  // new
  header: "Name",
  accessorKey: "name",
  size: 500,
  minSize: 200,
  maxSize: 800,
  cell: fp,
  ...e || {}
}), Xm = (e) => ({
  Header: "Updated",
  header: "Updated",
  id: "modified.timestamp",
  accessorKey: "modified.timestamp",
  accessor: "modified.timestamp",
  cell: ji,
  Cell: ji,
  isCropped: !0,
  enableResizing: !1,
  size: 152,
  maxSize: 152,
  maxWidth: 152,
  ...e || {}
}), Jm = (e) => ({
  Header: "Created",
  header: "Created",
  accessorKey: "created.timestamp",
  accessor: "created.timestamp",
  id: "created.timestamp",
  Cell: ji,
  cell: ji,
  isCropped: !0,
  enableResizing: !1,
  size: 152,
  maxSize: 152,
  maxWidth: 152,
  ...e || {}
}), VV = (e) => ({
  Header: "Date",
  header: "Date",
  accessorKey: "timestamp",
  accessor: "timestamp",
  id: "timestamp",
  Cell: ji,
  cell: ji,
  isCropped: !0,
  enableResizing: !1,
  size: 152,
  maxSize: 152,
  maxWidth: 152,
  meta: {
    minWidth: 152,
    maxWidth: 152
  },
  ...e || {}
}), Km = (e) => ({
  Header: "Author",
  header: "Author",
  id: "created.user.name",
  accessorKey: "created.user.name",
  accessor: "created.user.name",
  Cell: L1,
  cell: L1,
  size: 152,
  minSize: 60,
  maxSize: 300,
  ...e || {}
}), RL = {
  columns: [
    Kb(),
    qm(),
    Jm(),
    Xm(),
    Km()
  ],
  entityBreadcrumbs: (e) => {
    const t = [], { rootTitle: n, parentTitle: r, title: i, rootPath: a, parentId: o, path: s } = e;
    return n && (t[0] = {
      name: n,
      path: `${a}`
    }), o && (t[1] = {
      name: r,
      path: `${a}/${o}`
    }), n !== i && (o ? t[2] = {
      name: i,
      path: s
    } : t[1] = {
      name: i,
      path: s
    }), t;
  }
}, z1 = (e, t) => {
  var r;
  const n = localStorage.getItem(e) ? JSON.parse(localStorage.getItem(e)) : {
    filters: {},
    pageSize: 15,
    sort: null,
    columns: t || {
      shortcut: !1,
      "created.timestamp": !1
    }
  };
  return {
    ...n,
    columns: n.columns && ((r = Object.keys(n.columns)) != null && r.length) ? n.columns : t
  };
}, DL = (e, t) => ({
  storage: z1(e, t),
  setStorage: (r, i) => {
    const a = z1(e, t);
    localStorage.setItem(
      e,
      JSON.stringify({
        ...a,
        [r]: i
      })
    );
  }
}), QV = ({
  children: e
}) => /* @__PURE__ */ p(
  R,
  {
    item: !0,
    xs: 12,
    sx: (t) => ({
      boxShadow: t.customShadows[2],
      background: "#ffffff",
      zIndex: 4,
      px: 6
    }),
    children: e
  }
), qV = ({
  children: e
}) => /* @__PURE__ */ p(
  R,
  {
    item: !0,
    xs: 12,
    sx: (t) => ({
      minHeight: "inherit",
      // backgroundColor: theme.palette.backgroundColor.dark,
      display: "flex",
      flexDirection: "column"
    }),
    children: e
  }
), XV = ({ children: e }) => /* @__PURE__ */ p(R, { container: !0, flexGrow: 1, className: "base-entity-content", children: e }), JV = (e) => {
  const {
    addButtonText: t,
    onAddClick: n,
    status: r,
    actions: i,
    isEmpty: a,
    listName: o,
    children: s,
    emptyTableText: c,
    viewMode: l,
    loadingSkeleton: u
  } = e, d = Xe.useMemo(
    () => !!(!i || Bc(i)[Fc.CREATE] || !l),
    [i]
  );
  return /* @__PURE__ */ p(ze, { children: r === Ce.IN_PROGRESS || r === Ce.IN_PROGRESS_RELOAD ? /* @__PURE__ */ p(
    R,
    {
      container: !0,
      py: 2,
      px: 3,
      alignContent: "space-between",
      minHeight: "calc(300px - 45px)",
      children: u || /* @__PURE__ */ p(R, { container: !0, pt: 10, justifyContent: "space-around", children: /* @__PURE__ */ p(yt, { size: 60, thickness: 6, color: "secondary" }) })
    }
  ) : (r === Ce.SUCCESS || r === Ce.ERROR) && a ? /* @__PURE__ */ p(R, { container: !0, pt: 2, children: /* @__PURE__ */ p(
    nE,
    {
      addButtonText: d && t ? t : void 0,
      onAdd: d && n ? n : void 0,
      size: "small",
      buttonName: o,
      noDataText: c
    }
  ) }) : /* @__PURE__ */ B(
    R,
    {
      container: !0,
      py: 2,
      px: 3,
      alignContent: "space-between",
      minHeight: "calc(300px - 45px)",
      children: [
        s,
        r === Ce.SUCCESS && d && /* @__PURE__ */ p(R, { item: !0, xs: 12, textAlign: "right", mt: 1, children: /* @__PURE__ */ p(
          Te,
          {
            onClick: n,
            className: "create-" + o,
            size: "small",
            startIcon: /* @__PURE__ */ p(pe, { iconName: "add" }),
            color: "info",
            children: t
          }
        ) })
      ]
    }
  ) });
}, KV = ({
  children: e
}) => /* @__PURE__ */ p(
  R,
  {
    item: !0,
    xs: 12,
    sx: (t) => ({
      // boxShadow: theme.customShadows[2],
      background: "#ffffff",
      zIndex: 3
      // px: 6,
    }),
    className: "nested-entity-wrapper",
    children: e
  }
), Zm = ({
  children: e
}) => /* @__PURE__ */ p(R, { item: !0, xs: 12, bgcolor: "backgroundColor.dark", p: 1, borderRadius: 1, children: e }), ZV = ({ children: e, onButtonClick: t }) => /* @__PURE__ */ p(Zm, { children: /* @__PURE__ */ B(dr, { children: [
  t && /* @__PURE__ */ p(R, { item: !0, xs: 12, px: 2, pt: 2, children: /* @__PURE__ */ B(
    Te,
    {
      onClick: t,
      variant: "contained",
      size: "small",
      color: "info",
      sx: { px: 2 },
      children: [
        "Export to ",
        ">"
      ]
    }
  ) }),
  /* @__PURE__ */ p(R, { item: !0, xs: 12, container: !0, p: 2, sx: { width: "100%" }, children: /* @__PURE__ */ p(R, { item: !0, xs: 12, children: e }) })
] }) }), PL = ({
  value: e,
  statusHints: t,
  disabled: n = !1,
  onSubmit: r
}) => {
  var s;
  const i = W0(e), a = U0.map((c) => ({
    ...c,
    component: /* @__PURE__ */ p(
      xm,
      {
        text: c.name,
        color: W0(c.id),
        light: !0,
        align: "center",
        iconSize: 6
      }
    ),
    message: t[c.id],
    disabled: t[c.id] !== void 0
  })), o = U0.find((c) => c.id === e);
  return /* @__PURE__ */ p(
    pt,
    {
      text: n ? void 0 : "Change Status",
      arrow: !0,
      placement: "bottom",
      children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
        dA,
        {
          variant: "contained",
          title: o.name,
          sx: {
            fontSize: 13,
            fontWeight: 700,
            pointerEvents: n ? "none" : "auto",
            borderRadius: "2px",
            backgroundColor: V0(0.95, i),
            color: i,
            ".start-icon.MuiButton-iconSizeMedium svg, svg": {
              fontSize: 18
            },
            "&.MuiButton-containedPrimary:hover": {
              backgroundColor: V0(0.9, i),
              color: i
            },
            px: 1.5
          },
          onClick: (c) => {
            r(c.id);
          },
          startIcon: /* @__PURE__ */ p(
            rE,
            {
              name: (s = o.id) == null ? void 0 : s.toLowerCase()
            }
          ),
          endIcon: n ? /* @__PURE__ */ p(ze, {}) : /* @__PURE__ */ p(pe, { iconName: "chevronFilled", fontSize: "small" }),
          options: a,
          tooltipPlacement: "right"
        }
      ) })
    }
  );
}, eQ = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  AdditionalActions: r,
  actions: i,
  alerts: a
}) => {
  const o = kr(), s = !i.update || i["consent.accept"], c = (u, d) => {
    n({ ...e, [u]: d });
  }, l = bA("study-manager/:id", location.pathname);
  return /* @__PURE__ */ B(ze, { children: [
    /* @__PURE__ */ p(
      R,
      {
        item: !0,
        xs: 12,
        mx: -5,
        mt: a ? 1 : 0,
        height: a ? "100%" : "0px",
        sx: { transition: "all 1000ms" },
        children: a
      }
    ),
    /* @__PURE__ */ B(R, { container: !0, py: 1, alignItems: "center", className: "study-base-info", children: [
      /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
        PL,
        {
          value: e.status,
          statusHints: e.unavailableStatusHints,
          disabled: s,
          onSubmit: (u) => {
            c("status", u);
          }
        }
      ) }),
      /* @__PURE__ */ p(R, { item: !0, ml: 1, display: "inline-flex", children: /* @__PURE__ */ p(
        QM,
        {
          isPrivate: e.privacy,
          size: 20,
          onClick: () => {
            c("privacy", !e.privacy);
          },
          viewMode: s
        }
      ) }),
      /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, ml: 0.5, children: /* @__PURE__ */ p(
        Kt,
        {
          size: "large",
          name: "study-title",
          value: e.title,
          fullWidth: !0,
          color: o.palette.textColor.primary,
          onSubmit: function(u) {
            c("title", u);
          },
          disabled: s,
          required: !0
        }
      ) }),
      !!l && /* @__PURE__ */ B(ze, { children: [
        r && /* @__PURE__ */ p(R, { item: !0, ml: 1, className: "study-base-info__actions-additional", children: r }),
        !s && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            name: "study-delete",
            tooltipText: "Delete Study",
            noExpand: !0
          }
        ) })
      ] })
    ] })
  ] });
}, LL = ({
  onClick: e,
  size: t,
  children: n,
  iconName: r,
  tooltipText: i = "",
  id: a,
  name: o,
  className: s
}) => /* @__PURE__ */ p(pt, { text: i, children: /* @__PURE__ */ p(
  Te,
  {
    id: a,
    name: o,
    className: s,
    color: "info",
    variant: "contained",
    onClick: e,
    size: t,
    startIcon: /* @__PURE__ */ p(pe, { iconName: r }),
    children: n
  }
) }), zL = ({
  onClick: e,
  size: t,
  children: n,
  iconName: r,
  tooltipText: i = "",
  id: a,
  name: o,
  disabled: s = !1,
  isLoading: c = !1,
  sx: l
}) => /* @__PURE__ */ p(pt, { text: i, children: /* @__PURE__ */ p(
  Te,
  {
    id: a,
    name: o,
    color: "info",
    onClick: e,
    variant: "outlined",
    size: t,
    disabled: s,
    startIcon: c ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: r }),
    sx: (u) => ({
      fontSize: { small: 14, medium: 16 }[t] || 14,
      px: 1.5,
      fontWeight: 700,
      borderColor: u.palette.borderColor.main
    }),
    children: n
  }
) }), Pl = ({
  onVersionRevert: e,
  onVersionSave: t,
  viewMode: n
}) => /* @__PURE__ */ B(ze, { children: [
  /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
    zL,
    {
      size: "small",
      iconName: "reload",
      name: "version-revert",
      onClick: () => {
        e();
      },
      tooltipText: "Back to current version",
      children: "Back to current version"
    }
  ) }),
  !n && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
    LL,
    {
      size: "small",
      iconName: "submit",
      name: "version-apply",
      tooltipText: "Restore version",
      onClick: () => {
        t();
      },
      children: "Restore version"
    }
  ) })
] });
function eg(e, t, n, r) {
  const { showDialog: i, hideDialog: a } = zo(Am);
  let o = _E(({ currentLocation: f, nextLocation: h }) => {
    const m = r ? !(r != null && r.some((g) => bA(g, h.pathname))) : !0;
    return e && f.pathname !== h.pathname && m;
  });
  const s = qt(o);
  He(() => {
    s.current = o;
  }, [o]);
  const c = Ge(() => {
    const f = s.current;
    f.state === "blocked" && f.reset();
  }, []), l = Ge(() => {
    const f = s.current;
    f.state === "blocked" && f.proceed();
  }, []), u = (f, h) => i(Em, {
    onSubmit: f,
    onDecline: h,
    onClose: a,
    text: /* @__PURE__ */ B(R, { container: !0, children: [
      /* @__PURE__ */ B(
        R,
        {
          item: !0,
          xs: 12,
          sx: {
            fontSize: 18,
            display: "flex",
            justifyContent: "space-between"
          },
          children: [
            /* @__PURE__ */ p(R, { item: !0, children: "Unsaved changes" }),
            /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
              Ra,
              {
                onClick: () => {
                  a == null || a(), c();
                },
                size: "small",
                children: /* @__PURE__ */ p(pe, { iconName: "close", sx: { fontSize: 16 } })
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
        /* @__PURE__ */ p(Sa, { sx: { my: 1 } }),
        "Would you like to save ",
        /* @__PURE__ */ p("b", { children: t }),
        " changes?"
      ] })
    ] }),
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    variant: "error"
  });
  function d(f) {
    return function() {
      e ? u(
        async () => {
          await (n == null ? void 0 : n()), f == null || f();
        },
        () => {
          f == null || f();
        }
      ) : f == null || f();
    };
  }
  return He(() => {
    o.state === "blocked" && u(
      () => {
        l(), n == null || n();
      },
      () => {
        l();
      }
    );
  }, [o.state, l]), He(() => () => {
    c();
  }, [c]), {
    beforeLeave: d
  };
}
const tQ = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onAnalysisSubmit: i,
  onSave: a,
  onCopy: o,
  AdditionalActions: s,
  AnalysisIcon: c,
  disableSave: l,
  versionPreview: u,
  onVersionRevert: d,
  onVersionSave: f,
  viewMode: h,
  onExport: m,
  canExecute: g,
  executionMessages: v = []
}) => {
  var k, y;
  const _ = kr();
  Tr();
  const I = (x, b) => {
    const A = { ...e, [x]: b };
    if (r) {
      r(A);
      return;
    }
    n == null || n(A);
  }, { beforeLeave: M } = eg(!l, "Analysis", a, [
    "/workspace/analyses/:id/*",
    "/study-manager/:id/analyses/:id/*"
  ]);
  return /* @__PURE__ */ B(R, { container: !0, pb: 1, pt: 2, spacing: 1, className: "analysis-base-info", children: [
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      c && /* @__PURE__ */ p(
        R,
        {
          item: !0,
          mr: 1.5,
          display: "flex",
          className: "analysis-base-info__icon",
          children: c
        }
      ),
      /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, sx: { minWidth: 0, flexBasis: 0 }, children: /* @__PURE__ */ p(
        Kt,
        {
          name: "analysis-title",
          size: "medium",
          value: e == null ? void 0 : e.title,
          fullWidth: !0,
          color: _.palette.textColor.primary,
          onSubmit: function(x) {
            I("title", x);
          },
          submitOnClickOutside: !0,
          showActions: !1,
          disabled: h,
          required: !0
        }
      ) }),
      s && /* @__PURE__ */ p(R, { item: !0, ml: 1, className: "analysis-base-info__actions-additional", children: s }),
      u ? /* @__PURE__ */ p(
        Pl,
        {
          onVersionRevert: d,
          onVersionSave: f,
          viewMode: h
        }
      ) : /* @__PURE__ */ B(ze, { children: [
        !h && /* @__PURE__ */ B(ze, { children: [
          /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            qe,
            {
              color: "error",
              iconName: "delete",
              onClick: t,
              tooltipText: "Delete",
              title: "Delete",
              name: "analysis-delete",
              noExpand: !0
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            qe,
            {
              color: "primary",
              iconName: "copy",
              onClick: M(() => {
                o(e.id);
              }),
              name: "analysis-copy",
              tooltipText: "Copy",
              title: "Copy"
            }
          ) })
        ] }),
        ![ya.CUSTOM, ya.STRATEGUS].includes(
          e == null ? void 0 : e.type
        ) && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "export",
            onClick: M(m),
            tooltipText: "Export",
            title: "Export",
            name: "analysis-export"
          }
        ) }),
        !h && (e == null ? void 0 : e.type) !== ya.STRATEGUS && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "success",
            iconName: "save",
            tooltipText: "Save",
            title: "Save",
            disabled: l,
            onClick: a,
            name: "analysis-save-design"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: !u && !h && /* @__PURE__ */ p(
          pt,
          {
            text: v != null && v.length ? /* @__PURE__ */ B(fe, { fontSize: 12, color: "white", children: [
              "Please fill in all required information before running the analysis:",
              v.map((x, b) => /* @__PURE__ */ p("li", { children: x }, "error" + b))
            ] }) : "Execute",
            children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
              Te,
              {
                color: "info",
                variant: "contained",
                disabled: !g,
                onClick: M(i),
                name: "analysis-execute",
                startIcon: /* @__PURE__ */ p(pe, { iconName: "submit" }),
                children: "Execute"
              }
            ) })
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, container: !0, children: /* @__PURE__ */ B(R, { item: !0, flexGrow: 1, display: "flex", children: [
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: mm[e == null ? void 0 : e.type] })
      ] }),
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(
          fe,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Modified date:"
          }
        ),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn(e.modified.timestamp) })
      ] }),
      /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ B(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: [
          (k = e == null ? void 0 : e.created) == null ? void 0 : k.user.firstName,
          " ",
          (y = e == null ? void 0 : e.created) == null ? void 0 : y.user.lastName
        ] })
      ] })
    ] }) }),
    !((h || u) && !(e != null && e.description)) && /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
      Kt,
      {
        name: "analysis-description",
        size: "small",
        value: e == null ? void 0 : e.description,
        fullWidth: !0,
        color: _.palette.textColor.secondary,
        placeholder: "Add description...",
        maxRows: 2,
        onSubmit: function(x) {
          I("description", x);
        },
        submitOnClickOutside: !0,
        showActions: !1,
        disabled: h
      }
    ) })
  ] });
}, BL = (e) => {
  const t = e.map((n) => jC.find((r) => r.id === n)).filter(Boolean);
  return (t == null ? void 0 : t.length) > 0 ? [
    {
      id: null,
      name: "Use in Analysis",
      desc: "",
      endGroup: !0
    },
    ...t
  ] : [];
}, FL = (e) => {
  const { onClickExtraActions: t, analysisTypes: n } = e, r = Rt((s) => s.user), { original: i, status: a } = dE({
    preloadAnalysisTypes: n,
    analyses: [],
    tenantId: r.data.activeTenant
  }), o = Ee(() => BL(i || []), [i]);
  return /* @__PURE__ */ p(
    dA,
    {
      variant: "contained",
      color: "info",
      options: o,
      onClick: t,
      title: /* @__PURE__ */ p("span", { className: "use-in-analysis__compact-label", children: "Use in analysis" }),
      name: "use-in-analysis",
      closeOnSelect: !0,
      preventOverflow: !0,
      sx: {
        minWidth: { xs: 30, xl: 130 },
        width: { xs: 30, xl: "auto" },
        px: { xs: 0, xl: 1.5 },
        ".use-in-analysis__compact-label": {
          display: { xs: "none", xl: "inline" }
        },
        ".start-icon": {
          m: { xs: 0, xl: "0 8px 0 -4px" }
        }
      },
      iconComponent: (s) => s.value ? /* @__PURE__ */ p(hA, { ...s }) : /* @__PURE__ */ p(Xi, { value: wt.ANALYSIS }),
      disabled: [Ce.INITIAL, Ce.IN_PROGRESS].includes(a) || o.length === 0,
      startIcon: /* @__PURE__ */ p(pe, { iconName: "add", sx: { "&.MuiSvgIcon-root": { fontSize: 16 } } })
    }
  );
}, nQ = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onGenerate: i,
  onCopy: a,
  AdditionalActions: o,
  versionPreview: s,
  onVersionRevert: c,
  onVersionSave: l,
  onPublish: u,
  backToListPath: d,
  viewMode: f,
  disableSave: h,
  onClickExtraActions: m,
  onExport: g,
  analysisTypes: v,
  libraryMode: _,
  shareable: I,
  onShare: M,
  onArchive: k,
  nameError: y
}) => {
  const x = kr();
  Tr();
  const b = (w, O) => {
    const P = { ...e, [w]: O };
    if (r) {
      r(P);
      return;
    }
    n(P);
  };
  eg(
    !h && !f,
    "Cohort",
    () => n(e),
    ["/workspace/cohorts/:id/*", "/study-manager/:id/cohorts/:id/*"]
  );
  const A = f && !_ || s;
  return /* @__PURE__ */ B(R, { container: !0, pb: 1, pt: 2, spacing: 1, className: "cohort-base-info", children: [
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      e.terminated && /* @__PURE__ */ p(R, { item: !0, mr: 1.5, children: /* @__PURE__ */ p(he, { display: "flex", children: /* @__PURE__ */ p(
        Ra,
        {
          color: "warning",
          onClick: () => {
          },
          sx: (w) => ({
            backgroundColor: $i(0.8, w.palette.grey[500]),
            p: 0,
            my: -1,
            minWidth: 110,
            height: 26,
            fontSize: 14,
            borderRadius: 1,
            pointerEvents: "none",
            color: w.palette.grey[600],
            cursor: "default"
          }),
          children: /* @__PURE__ */ B(
            he,
            {
              className: "archived-icon",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              flexWrap: "nowrap",
              children: [
                /* @__PURE__ */ p(
                  pe,
                  {
                    iconName: "terminated",
                    sx: (w) => ({
                      color: w.palette.grey[500],
                      fontSize: 18,
                      mr: 1
                    })
                  }
                ),
                /* @__PURE__ */ p("div", { children: "Archived" })
              ]
            }
          )
        }
      ) }) }),
      /* @__PURE__ */ p(R, { item: !0, mr: 1.5, display: "flex", className: "analysis-base-info__icon", children: /* @__PURE__ */ p(Xi, { value: wt.COHORT, size: 32 }) }),
      /* @__PURE__ */ B(R, { item: !0, flexGrow: 1, sx: { minWidth: 0, flexBasis: 0 }, children: [
        /* @__PURE__ */ p(
          Kt,
          {
            size: "medium",
            value: e.name,
            fullWidth: !0,
            color: x.palette.textColor.primary,
            onSubmit: function(w) {
              b("name", w);
            },
            submitOnClickOutside: !0,
            showActions: !1,
            disabled: A,
            name: "cohort-name",
            required: !0
          }
        ),
        y && /* @__PURE__ */ p(fe, { variant: "caption", color: "error.main", children: y })
      ] }),
      o && /* @__PURE__ */ p(R, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: o }),
      s ? /* @__PURE__ */ p(
        Pl,
        {
          onVersionRevert: c,
          onVersionSave: l,
          viewMode: f
        }
      ) : f ? /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        qe,
        {
          color: "primary",
          iconName: "export",
          onClick: g,
          tooltipText: "Export",
          title: "Export",
          name: "cohort-export"
        }
      ) }) }) : /* @__PURE__ */ B(ze, { children: [
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "success",
            iconName: "save",
            disabled: h,
            title: "Save",
            tooltipText: "Save",
            name: "cohort-save",
            onClick: () => {
              n(e);
            }
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "copy",
            onClick: () => {
              a(e.id);
            },
            tooltipText: "Copy",
            title: "Copy",
            name: "cohort-copy"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "export",
            onClick: g,
            tooltipText: "Export",
            title: "Export",
            name: "cohort-export"
          }
        ) }),
        i && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "stars",
            onClick: i,
            tooltipText: "Regenerate",
            title: "Regenerate",
            name: "cohort-regenerate"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "publish",
            onClick: u,
            tooltipText: "Publish",
            title: "Publish",
            name: "cohort-publish"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            title: "Delete",
            tooltipText: "Delete",
            name: "cohort-delete",
            noExpand: !0
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          FL,
          {
            onClickExtraActions: m,
            analysisTypes: v
          }
        ) })
      ] }),
      k && !s && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        qe,
        {
          color: "primary",
          iconName: "terminated",
          onClick: k,
          tooltipText: "Archive",
          title: "Archive",
          name: "cohort-archive"
        }
      ) }),
      I && /* @__PURE__ */ p(R, { item: !0, m: 1, children: /* @__PURE__ */ p(
        Te,
        {
          onClick: M,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ p(pe, { iconName: "share" }),
          className: "share-cohort",
          children: "Share"
        }
      ) })
    ] }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Cohort" })
      ] }),
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !(A && !e.description) && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Kt,
      {
        value: e.description,
        onSubmit: (w) => b("description", w),
        submitOnClickOutside: !0,
        showActions: !1,
        color: x.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: f ? "..." : "Add description...",
        disabled: A,
        name: "cohort-description",
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, $L = ({ value: e, getValue: t, size: n = 24, ...r }) => {
  const i = e || (t == null ? void 0 : t()), a = Qi(), o = Rt((s) => s.images.images[i]);
  return He(() => {
    o || a(EE(i));
  }, [i]), o != null && o.image ? /* @__PURE__ */ p(iE, { image: o.image, size: n }) : /* @__PURE__ */ p(pe, { iconName: "imagePlaceholder", sx: { fontSize: n, opacity: 0.4 } });
}, rQ = ({
  entity: e,
  onInvite: t,
  actions: n
}) => {
  const r = Ee(
    () => !(!(e != null && e.actions) || n != null && n[lE.UPDATE]),
    [n]
  ), i = Rt(
    (a) => {
      var o;
      return (o = a.images.images[e == null ? void 0 : e.id]) == null ? void 0 : o.image;
    }
  );
  return /* @__PURE__ */ B(R, { container: !0, py: 1.5, pb: 2, alignItems: "center", pt: 2, children: [
    i && /* @__PURE__ */ p($L, { value: e.id, size: 45 }),
    /* @__PURE__ */ B(R, { item: !0, flexGrow: 1, alignItems: "center", ml: i ? 3 : 0, children: [
      /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", pb: 1.5, children: [
        /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, children: /* @__PURE__ */ p(VA, { dataSource: e, isHeader: !0 }) }),
        !r && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            onClick: t,
            iconName: "add",
            color: "success",
            name: "invite-to-study",
            title: "Invite to study",
            noCollapse: !0
          }
        ) })
      ] }),
      /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, spacing: 2, children: [
        /* @__PURE__ */ B(R, { item: !0, children: [
          /* @__PURE__ */ p(
            fe,
            {
              variant: "subtitle2",
              component: "label",
              sx: { mr: 0.5 },
              children: "Created date:"
            }
          ),
          /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn(e.created.timestamp) })
        ] }),
        /* @__PURE__ */ B(R, { item: !0, children: [
          /* @__PURE__ */ p(
            fe,
            {
              variant: "subtitle2",
              component: "label",
              sx: { mr: 0.5 },
              children: "Updated date:"
            }
          ),
          /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn(e.modified.timestamp) })
        ] })
      ] }) })
    ] })
  ] });
}, iQ = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onCopy: i,
  AdditionalActions: a,
  versionPreview: o,
  onVersionRevert: s,
  onVersionSave: c,
  onPublish: l,
  backToListPath: u,
  viewMode: d,
  disableSave: f,
  onExport: h,
  onClickExtraActions: m,
  libraryMode: g,
  shareable: v,
  onShare: _,
  onGenerate: I,
  onCompare: M,
  onArchive: k,
  saveInProgress: y,
  isCompareLoading: x,
  onSuggest: b,
  suggestionStatus: A,
  nameError: w,
  saveOnlyActions: O = !1
}) => {
  const P = kr(), { beforeLeave: E } = eg(
    !f,
    "Concept Set",
    () => n(e),
    ["/workspace/concept-sets/:id/*", "/study-manager/:id/concept-sets/:id/*"]
  ), C = (D, z) => {
    const F = { ...e, [D]: z };
    if (r) {
      r(F);
      return;
    }
    n(F);
  }, T = d && !g || o;
  return /* @__PURE__ */ B(R, { container: !0, pb: 1, pt: 2, spacing: 1, className: "concept-set-base-info", children: [
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(R, { item: !0, mr: 1.5, display: "flex", className: "analysis-base-info__icon", children: /* @__PURE__ */ p(Xi, { value: wt.CONCEPT_SET, size: 32 }) }),
      /* @__PURE__ */ B(R, { item: !0, flexGrow: 1, sx: { minWidth: 0, flexBasis: 0 }, children: [
        /* @__PURE__ */ p(
          Kt,
          {
            size: "medium",
            name: "concept-set-name",
            value: e.name,
            fullWidth: !0,
            color: P.palette.textColor.primary,
            onSubmit: function(D) {
              C("name", D);
            },
            submitOnClickOutside: !0,
            showActions: !1,
            disabled: T,
            required: !0
          }
        ),
        w && /* @__PURE__ */ p(fe, { variant: "caption", color: "error.main", children: w })
      ] }),
      a && /* @__PURE__ */ p(
        R,
        {
          item: !0,
          ml: 1,
          className: "concept-set-base-info__actions-additional",
          children: a
        }
      ),
      o ? /* @__PURE__ */ B(ze, { children: [
        " ",
        M && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "compare",
            size: "small",
            disabled: x,
            onClick: M,
            tooltipText: "Compare",
            loading: x,
            title: "Compare",
            name: "concept-set-compare"
          }
        ) }),
        /* @__PURE__ */ p(
          Pl,
          {
            onVersionRevert: s,
            onVersionSave: c,
            viewMode: d
          }
        )
      ] }) : d ? /* @__PURE__ */ B(ze, { children: [
        M && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "compare",
            disabled: x,
            onClick: M,
            tooltipText: "Compare",
            loading: x,
            title: "Compare",
            name: "concept-set-compare"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "export",
            onClick: h,
            tooltipText: "Export",
            title: "Export"
          }
        ) })
      ] }) : /* @__PURE__ */ B(ze, { children: [
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "success",
            disabled: f,
            iconName: "save",
            tooltipText: "Save",
            title: "Save",
            loading: y === Ce.IN_PROGRESS,
            name: "concept-set-save",
            onClick: () => {
              n(e);
            }
          }
        ) }),
        !O && /* @__PURE__ */ B(ze, { children: [
          /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            qe,
            {
              color: "primary",
              iconName: "copy",
              onClick: E(() => {
                i(e.id);
              }),
              tooltipText: "Copy",
              title: "Copy",
              name: "concept-set-copy"
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            qe,
            {
              color: "primary",
              disabled: !f,
              iconName: "export",
              onClick: E(h),
              tooltipText: "Export",
              title: "Export",
              name: "concept-set-export"
            }
          ) }),
          (I || b) && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            aE,
            {
              color: "primary",
              title: "AI",
              iconName: "stars",
              tooltipText: "AI features",
              placement: "bottom-start",
              onItemClick: (D) => {
                switch (D.id) {
                  case "regenerate":
                    I == null || I();
                    break;
                  case "suggest":
                    b == null || b();
                    break;
                }
              },
              options: [
                ...I ? [
                  {
                    name: "Regenerate",
                    id: "regenerate"
                  }
                ] : [],
                ...b ? [
                  {
                    name: "Suggest",
                    id: "suggest",
                    disabled: A === X0.IN_PROGRESS,
                    message: A === X0.IN_PROGRESS ? "Suggestion in progress" : ""
                  }
                ] : []
              ]
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            qe,
            {
              color: "primary",
              iconName: "publish",
              onClick: E(l),
              tooltipText: "Publish",
              title: "Publish",
              name: "concept-set-publish"
            }
          ) }),
          M && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            qe,
            {
              color: "primary",
              iconName: "compare",
              disabled: x,
              onClick: M,
              tooltipText: "Compare",
              loading: x,
              title: "Compare",
              name: "concept-set-compare"
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            qe,
            {
              color: "error",
              iconName: "delete",
              onClick: t,
              title: "Delete",
              tooltipText: "Delete",
              name: "concept-set-delete",
              noExpand: !0
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Te,
            {
              startIcon: /* @__PURE__ */ p(pe, { iconName: "add" }),
              variant: "contained",
              color: "info",
              name: "create-cohort",
              title: "Use in Cohort",
              sx: {
                minWidth: { xs: 30, xl: 122 },
                width: { xs: 30, xl: "auto" },
                px: { xs: 0, xl: 1.5 },
                ".base-info__compact-button-label": {
                  display: { xs: "none", xl: "inline" }
                },
                ".start-icon": {
                  m: { xs: 0, xl: "0 8px 0 -4px" }
                }
              },
              onClick: () => {
                m(e);
              },
              children: /* @__PURE__ */ p("span", { className: "base-info__compact-button-label", children: "Use in Cohort" })
            }
          ) })
        ] })
      ] }),
      k && !o && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        qe,
        {
          color: "primary",
          iconName: "terminated",
          onClick: k,
          tooltipText: "Archive",
          title: "Archive",
          name: "concept-set-archive"
        }
      ) }),
      v && !O && /* @__PURE__ */ p(R, { item: !0, m: 1, children: /* @__PURE__ */ p(
        Te,
        {
          onClick: _,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ p(pe, { iconName: "share" }),
          className: "share-cohort",
          children: "Share"
        }
      ) })
    ] }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Concept set" })
      ] }),
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !(T && !e.description) && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Kt,
      {
        name: "concept-set-description",
        value: e.description,
        onSubmit: (D) => C("description", D),
        submitOnClickOutside: !0,
        showActions: !1,
        color: P.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: d ? "..." : "Add description...",
        disabled: T,
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, aQ = ({ entity: e, AdditionalActions: t, AnalysisIcon: n, submission: r }) => {
  var o, s;
  const i = kr(), a = Tr();
  return /* @__PURE__ */ B(
    R,
    {
      container: !0,
      pb: 1,
      pt: 2,
      spacing: 1,
      className: "analysis-results-base-info",
      children: [
        /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
          r && /* @__PURE__ */ p(R, { item: !0, mr: 1.5, display: "flex", children: /* @__PURE__ */ p(NT, { status: r.status }) }),
          n && /* @__PURE__ */ p(R, { item: !0, mr: 1.5, display: "flex", children: n }),
          /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
            Kt,
            {
              size: "medium",
              value: e == null ? void 0 : e.title,
              fullWidth: !0,
              color: i.palette.textColor.primary,
              onSubmit: function() {
              },
              disabled: !0,
              required: !0
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, ml: 0.5, children: /* @__PURE__ */ B(Te, { size: "small", color: "info", onClick: () => a(".."), children: [
            "<",
            " Back to Analysis results"
          ] }) }),
          t && /* @__PURE__ */ p(R, { item: !0, ml: 1, children: t })
        ] }),
        /* @__PURE__ */ p(R, { item: !0, xs: 12, container: !0, justifyContent: "space-between", children: /* @__PURE__ */ B(R, { item: !0, flexGrow: 1, display: "flex", flexWrap: "wrap", children: [
          /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              fe,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: "Type:"
              }
            ),
            /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: mm[e == null ? void 0 : e.type] })
          ] }),
          /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              fe,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: "ID:"
              }
            ),
            /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
          ] }),
          /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              fe,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: "Author:"
              }
            ),
            /* @__PURE__ */ B(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: [
              (o = e == null ? void 0 : e.created) == null ? void 0 : o.user.firstName,
              " ",
              (s = e == null ? void 0 : e.created) == null ? void 0 : s.user.lastName
            ] })
          ] }),
          r && /* @__PURE__ */ B(ze, { children: [
            /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
              /* @__PURE__ */ p(
                fe,
                {
                  variant: "subtitle2",
                  component: "label",
                  sx: { mr: 0.5 },
                  children: "Submitted at:"
                }
              ),
              /* @__PURE__ */ p(
                fe,
                {
                  variant: "subtitle2",
                  component: "span",
                  fontWeight: 700,
                  children: Kn(r.created.timestamp)
                }
              )
            ] }),
            /* @__PURE__ */ B(R, { item: !0, children: [
              /* @__PURE__ */ p(
                fe,
                {
                  variant: "subtitle2",
                  component: "label",
                  sx: { mr: 0.5 },
                  children: "Data source:"
                }
              ),
              /* @__PURE__ */ p(
                fe,
                {
                  variant: "subtitle2",
                  component: "span",
                  fontWeight: 700,
                  sx: {
                    div: {
                      color: "textColor.secondary"
                    }
                  },
                  children: /* @__PURE__ */ p(
                    VA,
                    {
                      isHeader: !1,
                      dataSource: r.dataSource
                    }
                  )
                }
              )
            ] })
          ] })
        ] }) }),
        (e == null ? void 0 : e.description) && /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
          Kt,
          {
            size: "small",
            value: e == null ? void 0 : e.description,
            fullWidth: !0,
            color: i.palette.textColor.secondary,
            placeholder: "Add description...",
            maxRows: 2,
            onSubmit: () => {
            },
            disabled: !0
          }
        ) })
      ]
    }
  );
}, oQ = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onCopy: i,
  AdditionalActions: a,
  versionPreview: o,
  onVersionRevert: s,
  onVersionSave: c,
  onPublish: l,
  backToListPath: u,
  viewMode: d,
  disableSave: f,
  onExport: h
}) => {
  const m = kr(), g = (e == null ? void 0 : e.shortcut) || (e == null ? void 0 : e.id), v = (_, I) => {
    const M = { ...e, [_]: I };
    if (r) {
      r(M);
      return;
    }
    n(M);
  };
  return /* @__PURE__ */ B(R, { container: !0, pb: 1, pt: 2, spacing: 1, className: "cohort-base-info", children: [
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(
        R,
        {
          item: !0,
          mr: 1.5,
          display: "flex",
          className: "analysis-base-info__icon",
          children: /* @__PURE__ */ p(Xi, { value: wt.ANALYSIS, size: 32 })
        }
      ),
      /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
        Kt,
        {
          size: "medium",
          value: e.name,
          fullWidth: !0,
          color: m.palette.textColor.primary,
          onSubmit: function(_) {
            v("name", _);
          },
          submitOnClickOutside: !0,
          showActions: !1,
          disabled: d || o,
          name: "cohort-name",
          required: !0
        }
      ) }),
      a && /* @__PURE__ */ p(R, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: a }),
      o ? /* @__PURE__ */ p(
        Pl,
        {
          onVersionRevert: s,
          onVersionSave: c,
          viewMode: d
        }
      ) : d ? /* @__PURE__ */ p(ze, {}) : /* @__PURE__ */ B(ze, { children: [
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            tooltipText: "Delete",
            title: "Delete",
            name: "cohort-delete",
            noExpand: !0
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "copy",
            onClick: () => {
              i(e.id);
            },
            tooltipText: "Copy",
            title: "Copy",
            name: "cohort-copy"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "export",
            onClick: h,
            tooltipText: "Export",
            title: "Export",
            name: "cohort-export"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "publish",
            onClick: l,
            tooltipText: "Publish",
            title: "Publish",
            name: "cohort-publish"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "success",
            iconName: "save",
            disabled: f,
            tooltipText: "Save",
            title: "Save",
            name: "cohort-save",
            onClick: () => {
              n(e);
            }
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Feature analysis" })
      ] }),
      g && /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(
          fe,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "ID:"
          }
        ),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: g })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(
          fe,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Modified date:"
          }
        ),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(
          fe,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Author:"
          }
        ),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !((d || o) && !e.description) && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Kt,
      {
        value: e.description,
        onSubmit: (_) => v("description", _),
        submitOnClickOutside: !0,
        showActions: !1,
        color: m.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: d ? "..." : "Add description...",
        disabled: d || o,
        name: "cohort-description",
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, sQ = ({
  entity: e,
  onSubmit: t,
  onDelete: n,
  onPublish: r
}) => {
  var c, l, u;
  const { t: i } = Da(), a = Tr(), o = Kr(), s = (d, f) => {
    t({ ...e, [d]: f });
  };
  return /* @__PURE__ */ B(R, { container: !0, py: 1.5, pb: 2, alignItems: "center", spacing: 0.5, children: [
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
        Kt,
        {
          size: "medium",
          value: e == null ? void 0 : e.name,
          fullWidth: !0,
          color: o.palette.textColor.primary,
          onSubmit: function(d) {
            s("name", d);
          },
          name: "database-name",
          required: !0
        }
      ) }),
      /* @__PURE__ */ B(R, { item: !0, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ B(Te, { size: "small", color: "info", onClick: () => a(".."), children: [
          "<",
          " ",
          i("modules.administration.databases.back_database")
        ] }) }),
        /* @__PURE__ */ B(
          R,
          {
            item: !0,
            mx: 1,
            sx: {
              ".status-tag": {
                height: 24,
                lineHeight: "24px",
                mx: 0
              }
            },
            children: [
              ((c = e == null ? void 0 : e.published) == null ? void 0 : c.length) > 0 ? /* @__PURE__ */ p(
                xm,
                {
                  text: i("statuses.published"),
                  color: "success",
                  align: "center",
                  light: !0
                }
              ) : /* @__PURE__ */ p(
                Te,
                {
                  size: "small",
                  onClick: (d) => {
                    d.stopPropagation(), r == null || r();
                  },
                  color: "info",
                  variant: "outlined",
                  startIcon: /* @__PURE__ */ p(pe, { iconName: "publish" }),
                  sx: {
                    px: 2,
                    py: 0.25,
                    borderRadius: 0.5,
                    fontSize: 12,
                    minWidth: 98
                  },
                  children: i("buttons.publish")
                }
              ),
              " "
            ]
          }
        ),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "error",
            iconName: "delete",
            onClick: n,
            tooltipText: i("tooltips.delete"),
            name: "analysis-delete",
            noExpand: !0
          }
        ) })
      ] })
    ] }),
    " ",
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      R,
      {
        item: !0,
        xs: 12,
        container: !0,
        justifyContent: "space-between",
        alignItems: "center",
        children: /* @__PURE__ */ B(R, { item: !0, flexGrow: 1, display: "flex", children: [
          /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              fe,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: i("forms.created_date")
              }
            ),
            /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn((l = e == null ? void 0 : e.created) == null ? void 0 : l.timestamp) })
          ] }),
          /* @__PURE__ */ B(R, { item: !0, children: [
            /* @__PURE__ */ p(
              fe,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: i("forms.updated_date")
              }
            ),
            /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn((u = e == null ? void 0 : e.modified) == null ? void 0 : u.timestamp) })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, mx: -1, children: /* @__PURE__ */ p(
      Kt,
      {
        size: "small",
        value: e == null ? void 0 : e.description,
        fullWidth: !0,
        color: o.palette.textColor.primary,
        onSubmit: function(d) {
          s("description", d);
        },
        name: "database-description",
        multiline: !0,
        maxRows: 3
      }
    ) })
  ] });
}, lQ = ({ entity: e, updateEntity: t }) => {
  const [n, r] = Se(!1), [i, a] = Se(
    e || {
      url: "",
      token: ""
    }
  );
  return He(() => {
    a(
      e || {
        url: "",
        token: ""
      }
    );
  }, [e]), /* @__PURE__ */ p(R, { container: !0, pt: 2.5, pb: 1.5, alignItems: "center", px: 1, children: /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "flex-start", children: [
    /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, pr: 2, children: /* @__PURE__ */ B(R, { container: !0, spacing: 0.5, children: [
      /* @__PURE__ */ B(
        R,
        {
          item: !0,
          xs: 8,
          alignItems: "center",
          display: "flex",
          minHeight: 40,
          children: [
            /* @__PURE__ */ p(
              fe,
              {
                variant: "subtitle1",
                component: "label",
                sx: { mr: 1, whiteSpace: "nowrap", minWidth: 90 },
                children: "ATHENA URL"
              }
            ),
            /* @__PURE__ */ p(
              _r,
              {
                value: i.url,
                fullWidth: !0,
                onChange: (o) => {
                  a((s) => ({ ...s, url: o.target.value }));
                },
                disabled: !n,
                placeholder: "ATHENA URL...",
                sx: n ? void 0 : {
                  ".Mui-disabled": {
                    color: "rgba(0, 0, 0, 0.87)",
                    "-webkit-text-fill-color": "rgba(0, 0, 0, 0.87)"
                  },
                  ".input-root:hover .input-notched-outline, .input-notched-outline": {
                    borderWidth: "0",
                    border: "none"
                  }
                }
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ B(
        R,
        {
          item: !0,
          xs: 8,
          alignItems: "center",
          display: "flex",
          minHeight: 40,
          children: [
            /* @__PURE__ */ p(
              fe,
              {
                variant: "subtitle1",
                component: "label",
                sx: { mr: 1, whiteSpace: "nowrap", minWidth: 90 },
                children: "ATHENA token"
              }
            ),
            /* @__PURE__ */ p(
              _r,
              {
                value: i.token,
                type: "password",
                fullWidth: !0,
                onChange: (o) => {
                  a((s) => ({ ...s, token: o.target.value }));
                },
                disabled: !n,
                placeholder: "***********",
                sx: n ? void 0 : {
                  ".Mui-disabled": {
                    color: "rgba(0, 0, 0, 0.87)",
                    "-webkit-text-fill-color": "rgba(0, 0, 0, 0.87)"
                  },
                  ".input-root:hover .input-notched-outline, .input-notched-outline": {
                    borderWidth: "0",
                    border: "none"
                  }
                }
              }
            )
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ p(R, { item: !0, display: "flex", justifyContent: "flex-end", minWidth: 64, children: n ? /* @__PURE__ */ B(ze, { children: [
      /* @__PURE__ */ p(R, { item: !0, mr: 1, children: /* @__PURE__ */ p(
        qe,
        {
          onClick: function() {
            t(i), r(!1);
          },
          color: "success",
          iconName: "submit",
          tooltipText: "Submit",
          title: "Submit",
          name: "submit"
        }
      ) }),
      /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
        qe,
        {
          onClick: function() {
            r(!1);
          },
          color: "error",
          iconName: "deactivate",
          tooltipText: "Cancel",
          title: "Cancel",
          name: "cancel"
        }
      ) })
    ] }) : /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
      qe,
      {
        onClick: function() {
          r(!0);
        },
        color: "info",
        iconName: "edit",
        tooltipText: "Edit",
        title: "Edit",
        name: "edit"
      }
    ) }) })
  ] }) });
}, cQ = ({
  entity: e = {},
  onDelete: t,
  onSubmit: n,
  onCopy: r,
  AdditionalActions: i,
  versionPreview: a,
  onVersionRevert: o,
  onVersionSave: s,
  onPublish: c,
  backToListPath: l,
  viewMode: u,
  libraryMode: d,
  disableSave: f,
  onExport: h
}) => {
  const m = kr();
  Tr();
  const g = (v, _) => {
    n({ ...e, [v]: _ });
  };
  return /* @__PURE__ */ B(R, { container: !0, pb: 1, pt: 2, spacing: 1, className: "cohort-base-info", children: [
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(R, { item: !0, mr: 1.5, display: "flex", className: "analysis-base-info__icon", children: /* @__PURE__ */ p(Xi, { value: wt.CUSTOM_CODE, size: 32 }) }),
      /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, ml: -1, mr: 1.5, children: /* @__PURE__ */ p(
        Kt,
        {
          size: "medium",
          value: e == null ? void 0 : e.title,
          fullWidth: !0,
          color: m.palette.textColor.primary,
          onSubmit: function(v) {
            g("title", v);
          },
          disabled: u && !d || a,
          name: "cohort-name",
          required: !0,
          showActions: !1,
          submitOnClickOutside: !0
        }
      ) }),
      i && /* @__PURE__ */ p(R, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: i }),
      a ? /* @__PURE__ */ p(
        Pl,
        {
          onVersionRevert: o,
          onVersionSave: s,
          viewMode: u
        }
      ) : u ? /* @__PURE__ */ p(ze, {}) : /* @__PURE__ */ B(ze, { children: [
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            tooltipText: "Delete",
            title: "Delete",
            name: "cohort-delete",
            noExpand: !0
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "copy",
            onClick: () => {
              r(e.id);
            },
            tooltipText: "Copy",
            title: "Copy",
            name: "cohort-copy"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "export",
            onClick: h,
            tooltipText: "Export",
            title: "Export",
            name: "cohort-export"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "primary",
            iconName: "publish",
            onClick: c,
            tooltipText: "Publish",
            title: "Publish",
            name: "cohort-publish"
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          qe,
          {
            color: "success",
            iconName: "save",
            disabled: f,
            tooltipText: "Save",
            title: "Save",
            name: "cohort-save",
            onClick: () => {
              n(e);
            }
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ B(R, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Custom code" })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: Kn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ B(R, { item: !0, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ p(fe, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !((u && !d || a) && !e.description) && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Kt,
      {
        value: e.description,
        onSubmit: (v) => g("description", v),
        color: m.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: u && !d ? "..." : "Add description...",
        disabled: u && !d || a,
        name: "cohort-description",
        showActions: !1,
        submitOnClickOutside: !0,
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
};
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Zb;
function ke() {
  return Zb.apply(null, arguments);
}
function YL(e) {
  Zb = e;
}
function Sr(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Aa(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function ot(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function tg(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (ot(e, t))
      return !1;
  return !0;
}
function Rn(e) {
  return e === void 0;
}
function xi(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Ll(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function ew(e, t) {
  var n = [], r, i = e.length;
  for (r = 0; r < i; ++r)
    n.push(t(e[r], r));
  return n;
}
function Oi(e, t) {
  for (var n in t)
    ot(t, n) && (e[n] = t[n]);
  return ot(t, "toString") && (e.toString = t.toString), ot(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function ei(e, t, n, r) {
  return Sw(e, t, n, r, !0).utc();
}
function jL() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Ke(e) {
  return e._pf == null && (e._pf = jL()), e._pf;
}
var dp;
Array.prototype.some ? dp = Array.prototype.some : dp = function(e) {
  var t = Object(this), n = t.length >>> 0, r;
  for (r = 0; r < n; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function ng(e) {
  if (e._isValid == null) {
    var t = Ke(e), n = dp.call(t.parsedDateParts, function(i) {
      return i != null;
    }), r = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
    if (e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = r;
    else
      return r;
  }
  return e._isValid;
}
function Rf(e) {
  var t = ei(NaN);
  return e != null ? Oi(Ke(t), e) : Ke(t).userInvalidated = !0, t;
}
var B1 = ke.momentProperties = [], Gd = !1;
function rg(e, t) {
  var n, r, i, a = B1.length;
  if (Rn(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Rn(t._i) || (e._i = t._i), Rn(t._f) || (e._f = t._f), Rn(t._l) || (e._l = t._l), Rn(t._strict) || (e._strict = t._strict), Rn(t._tzm) || (e._tzm = t._tzm), Rn(t._isUTC) || (e._isUTC = t._isUTC), Rn(t._offset) || (e._offset = t._offset), Rn(t._pf) || (e._pf = Ke(t)), Rn(t._locale) || (e._locale = t._locale), a > 0)
    for (n = 0; n < a; n++)
      r = B1[n], i = t[r], Rn(i) || (e[r] = i);
  return e;
}
function zl(e) {
  rg(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Gd === !1 && (Gd = !0, ke.updateOffset(this), Gd = !1);
}
function Cr(e) {
  return e instanceof zl || e != null && e._isAMomentObject != null;
}
function tw(e) {
  ke.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function hr(e, t) {
  var n = !0;
  return Oi(function() {
    if (ke.deprecationHandler != null && ke.deprecationHandler(null, e), n) {
      var r = [], i, a, o, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (i = "", typeof arguments[a] == "object") {
          i += `
[` + a + "] ";
          for (o in arguments[0])
            ot(arguments[0], o) && (i += o + ": " + arguments[0][o] + ", ");
          i = i.slice(0, -2);
        } else
          i = arguments[a];
        r.push(i);
      }
      tw(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var F1 = {};
function nw(e, t) {
  ke.deprecationHandler != null && ke.deprecationHandler(e, t), F1[e] || (tw(t), F1[e] = !0);
}
ke.suppressDeprecationWarnings = !1;
ke.deprecationHandler = null;
function ti(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function WL(e) {
  var t, n;
  for (n in e)
    ot(e, n) && (t = e[n], ti(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function hp(e, t) {
  var n = Oi({}, e), r;
  for (r in t)
    ot(t, r) && (Aa(e[r]) && Aa(t[r]) ? (n[r] = {}, Oi(n[r], e[r]), Oi(n[r], t[r])) : t[r] != null ? n[r] = t[r] : delete n[r]);
  for (r in e)
    ot(e, r) && !ot(t, r) && Aa(e[r]) && (n[r] = Oi({}, n[r]));
  return n;
}
function ig(e) {
  e != null && this.set(e);
}
var pp;
Object.keys ? pp = Object.keys : pp = function(e) {
  var t, n = [];
  for (t in e)
    ot(e, t) && n.push(t);
  return n;
};
var HL = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function UL(e, t, n) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return ti(r) ? r.call(t, n) : r;
}
function Qr(e, t, n) {
  var r = "" + Math.abs(e), i = t - r.length, a = e >= 0;
  return (a ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + r;
}
var ag = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, pc = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Vd = {}, go = {};
function je(e, t, n, r) {
  var i = r;
  typeof r == "string" && (i = function() {
    return this[r]();
  }), e && (go[e] = i), t && (go[t[0]] = function() {
    return Qr(i.apply(this, arguments), t[1], t[2]);
  }), n && (go[n] = function() {
    return this.localeData().ordinal(
      i.apply(this, arguments),
      e
    );
  });
}
function GL(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function VL(e) {
  var t = e.match(ag), n, r;
  for (n = 0, r = t.length; n < r; n++)
    go[t[n]] ? t[n] = go[t[n]] : t[n] = GL(t[n]);
  return function(i) {
    var a = "", o;
    for (o = 0; o < r; o++)
      a += ti(t[o]) ? t[o].call(i, e) : t[o];
    return a;
  };
}
function Qc(e, t) {
  return e.isValid() ? (t = rw(t, e.localeData()), Vd[t] = Vd[t] || VL(t), Vd[t](e)) : e.localeData().invalidDate();
}
function rw(e, t) {
  var n = 5;
  function r(i) {
    return t.longDateFormat(i) || i;
  }
  for (pc.lastIndex = 0; n >= 0 && pc.test(e); )
    e = e.replace(
      pc,
      r
    ), pc.lastIndex = 0, n -= 1;
  return e;
}
var QL = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function qL(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(ag).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var XL = "Invalid date";
function JL() {
  return this._invalidDate;
}
var KL = "%d", ZL = /\d{1,2}/;
function e4(e) {
  return this._ordinal.replace("%d", e);
}
var t4 = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function n4(e, t, n, r) {
  var i = this._relativeTime[n];
  return ti(i) ? i(e, t, n, r) : i.replace(/%d/i, e);
}
function r4(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return ti(n) ? n(t) : n.replace(/%s/i, t);
}
var $s = {};
function wn(e, t) {
  var n = e.toLowerCase();
  $s[n] = $s[n + "s"] = $s[t] = e;
}
function pr(e) {
  return typeof e == "string" ? $s[e] || $s[e.toLowerCase()] : void 0;
}
function og(e) {
  var t = {}, n, r;
  for (r in e)
    ot(e, r) && (n = pr(r), n && (t[n] = e[r]));
  return t;
}
var iw = {};
function _n(e, t) {
  iw[e] = t;
}
function i4(e) {
  var t = [], n;
  for (n in e)
    ot(e, n) && t.push({ unit: n, priority: iw[n] });
  return t.sort(function(r, i) {
    return r.priority - i.priority;
  }), t;
}
function Df(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function lr(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function nt(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = lr(t)), n;
}
function Wo(e, t) {
  return function(n) {
    return n != null ? (aw(this, e, n), ke.updateOffset(this, t), this) : gu(this, e);
  };
}
function gu(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function aw(e, t, n) {
  e.isValid() && !isNaN(n) && (t === "FullYear" && Df(e.year()) && e.month() === 1 && e.date() === 29 ? (n = nt(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    n,
    e.month(),
    $f(n, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
}
function a4(e) {
  return e = pr(e), ti(this[e]) ? this[e]() : this;
}
function o4(e, t) {
  if (typeof e == "object") {
    e = og(e);
    var n = i4(e), r, i = n.length;
    for (r = 0; r < i; r++)
      this[n[r].unit](e[n[r].unit]);
  } else if (e = pr(e), ti(this[e]))
    return this[e](t);
  return this;
}
var ow = /\d/, er = /\d\d/, sw = /\d{3}/, sg = /\d{4}/, Pf = /[+-]?\d{6}/, It = /\d\d?/, lw = /\d\d\d\d?/, cw = /\d\d\d\d\d\d?/, Lf = /\d{1,3}/, lg = /\d{1,4}/, zf = /[+-]?\d{1,6}/, Ho = /\d+/, Bf = /[+-]?\d+/, s4 = /Z|[+-]\d\d:?\d\d/gi, Ff = /Z|[+-]\d\d(?::?\d\d)?/gi, l4 = /[+-]?\d+(\.\d{1,3})?/, Bl = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, yu;
yu = {};
function Ne(e, t, n) {
  yu[e] = ti(t) ? t : function(r, i) {
    return r && n ? n : t;
  };
}
function c4(e, t) {
  return ot(yu, e) ? yu[e](t._strict, t._locale) : new RegExp(u4(e));
}
function u4(e) {
  return Gn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, r, i, a) {
        return n || r || i || a;
      }
    )
  );
}
function Gn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var mp = {};
function vt(e, t) {
  var n, r = t, i;
  for (typeof e == "string" && (e = [e]), xi(t) && (r = function(a, o) {
    o[t] = nt(a);
  }), i = e.length, n = 0; n < i; n++)
    mp[e[n]] = r;
}
function Fl(e, t) {
  vt(e, function(n, r, i, a) {
    i._w = i._w || {}, t(n, i._w, i, a);
  });
}
function f4(e, t, n) {
  t != null && ot(mp, e) && mp[e](t, n._a, n, e);
}
var An = 0, fi = 1, Yr = 2, Xt = 3, vr = 4, di = 5, xa = 6, d4 = 7, h4 = 8;
function p4(e, t) {
  return (e % t + t) % t;
}
var jt;
Array.prototype.indexOf ? jt = Array.prototype.indexOf : jt = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function $f(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = p4(t, 12);
  return e += (t - n) / 12, n === 1 ? Df(e) ? 29 : 28 : 31 - n % 7 % 2;
}
je("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
je("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
je("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
wn("month", "M");
_n("month", 8);
Ne("M", It);
Ne("MM", It, er);
Ne("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Ne("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
vt(["M", "MM"], function(e, t) {
  t[fi] = nt(e) - 1;
});
vt(["MMM", "MMMM"], function(e, t, n, r) {
  var i = n._locale.monthsParse(e, r, n._strict);
  i != null ? t[fi] = i : Ke(n).invalidMonth = e;
});
var m4 = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), uw = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), fw = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, g4 = Bl, y4 = Bl;
function x4(e, t) {
  return e ? Sr(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || fw).test(t) ? "format" : "standalone"][e.month()] : Sr(this._months) ? this._months : this._months.standalone;
}
function v4(e, t) {
  return e ? Sr(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[fw.test(t) ? "format" : "standalone"][e.month()] : Sr(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function A4(e, t, n) {
  var r, i, a, o = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      a = ei([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (i = jt.call(this._shortMonthsParse, o), i !== -1 ? i : null) : (i = jt.call(this._longMonthsParse, o), i !== -1 ? i : null) : t === "MMM" ? (i = jt.call(this._shortMonthsParse, o), i !== -1 ? i : (i = jt.call(this._longMonthsParse, o), i !== -1 ? i : null)) : (i = jt.call(this._longMonthsParse, o), i !== -1 ? i : (i = jt.call(this._shortMonthsParse, o), i !== -1 ? i : null));
}
function b4(e, t, n) {
  var r, i, a;
  if (this._monthsParseExact)
    return A4.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (i = ei([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(i, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(i, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[r] && (a = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (n && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!n && this._monthsParse[r].test(e))
      return r;
  }
}
function dw(e, t) {
  var n;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = nt(t);
    else if (t = e.localeData().monthsParse(t), !xi(t))
      return e;
  }
  return n = Math.min(e.date(), $f(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
}
function hw(e) {
  return e != null ? (dw(this, e), ke.updateOffset(this, !0), this) : gu(this, "Month");
}
function w4() {
  return $f(this.year(), this.month());
}
function _4(e) {
  return this._monthsParseExact ? (ot(this, "_monthsRegex") || pw.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (ot(this, "_monthsShortRegex") || (this._monthsShortRegex = g4), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function S4(e) {
  return this._monthsParseExact ? (ot(this, "_monthsRegex") || pw.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (ot(this, "_monthsRegex") || (this._monthsRegex = y4), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function pw() {
  function e(o, s) {
    return s.length - o.length;
  }
  var t = [], n = [], r = [], i, a;
  for (i = 0; i < 12; i++)
    a = ei([2e3, i]), t.push(this.monthsShort(a, "")), n.push(this.months(a, "")), r.push(this.months(a, "")), r.push(this.monthsShort(a, ""));
  for (t.sort(e), n.sort(e), r.sort(e), i = 0; i < 12; i++)
    t[i] = Gn(t[i]), n[i] = Gn(n[i]);
  for (i = 0; i < 24; i++)
    r[i] = Gn(r[i]);
  this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
je("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Qr(e, 4) : "+" + e;
});
je(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
je(0, ["YYYY", 4], 0, "year");
je(0, ["YYYYY", 5], 0, "year");
je(0, ["YYYYYY", 6, !0], 0, "year");
wn("year", "y");
_n("year", 1);
Ne("Y", Bf);
Ne("YY", It, er);
Ne("YYYY", lg, sg);
Ne("YYYYY", zf, Pf);
Ne("YYYYYY", zf, Pf);
vt(["YYYYY", "YYYYYY"], An);
vt("YYYY", function(e, t) {
  t[An] = e.length === 2 ? ke.parseTwoDigitYear(e) : nt(e);
});
vt("YY", function(e, t) {
  t[An] = ke.parseTwoDigitYear(e);
});
vt("Y", function(e, t) {
  t[An] = parseInt(e, 10);
});
function Ys(e) {
  return Df(e) ? 366 : 365;
}
ke.parseTwoDigitYear = function(e) {
  return nt(e) + (nt(e) > 68 ? 1900 : 2e3);
};
var mw = Wo("FullYear", !0);
function C4() {
  return Df(this.year());
}
function E4(e, t, n, r, i, a, o) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, r, i, a, o), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, r, i, a, o), s;
}
function nl(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function xu(e, t, n) {
  var r = 7 + t - n, i = (7 + nl(e, 0, r).getUTCDay() - t) % 7;
  return -i + r - 1;
}
function gw(e, t, n, r, i) {
  var a = (7 + n - r) % 7, o = xu(e, r, i), s = 1 + 7 * (t - 1) + a + o, c, l;
  return s <= 0 ? (c = e - 1, l = Ys(c) + s) : s > Ys(e) ? (c = e + 1, l = s - Ys(e)) : (c = e, l = s), {
    year: c,
    dayOfYear: l
  };
}
function rl(e, t, n) {
  var r = xu(e.year(), t, n), i = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, a, o;
  return i < 1 ? (o = e.year() - 1, a = i + gi(o, t, n)) : i > gi(e.year(), t, n) ? (a = i - gi(e.year(), t, n), o = e.year() + 1) : (o = e.year(), a = i), {
    week: a,
    year: o
  };
}
function gi(e, t, n) {
  var r = xu(e, t, n), i = xu(e + 1, t, n);
  return (Ys(e) - r + i) / 7;
}
je("w", ["ww", 2], "wo", "week");
je("W", ["WW", 2], "Wo", "isoWeek");
wn("week", "w");
wn("isoWeek", "W");
_n("week", 5);
_n("isoWeek", 5);
Ne("w", It);
Ne("ww", It, er);
Ne("W", It);
Ne("WW", It, er);
Fl(
  ["w", "ww", "W", "WW"],
  function(e, t, n, r) {
    t[r.substr(0, 1)] = nt(e);
  }
);
function k4(e) {
  return rl(e, this._week.dow, this._week.doy).week;
}
var T4 = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function M4() {
  return this._week.dow;
}
function I4() {
  return this._week.doy;
}
function N4(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function O4(e) {
  var t = rl(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
je("d", 0, "do", "day");
je("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
je("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
je("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
je("e", 0, 0, "weekday");
je("E", 0, 0, "isoWeekday");
wn("day", "d");
wn("weekday", "e");
wn("isoWeekday", "E");
_n("day", 11);
_n("weekday", 11);
_n("isoWeekday", 11);
Ne("d", It);
Ne("e", It);
Ne("E", It);
Ne("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Ne("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Ne("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Fl(["dd", "ddd", "dddd"], function(e, t, n, r) {
  var i = n._locale.weekdaysParse(e, r, n._strict);
  i != null ? t.d = i : Ke(n).invalidWeekday = e;
});
Fl(["d", "e", "E"], function(e, t, n, r) {
  t[r] = nt(e);
});
function R4(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function D4(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function cg(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var P4 = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), yw = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), L4 = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), z4 = Bl, B4 = Bl, F4 = Bl;
function $4(e, t) {
  var n = Sr(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? cg(n, this._week.dow) : e ? n[e.day()] : n;
}
function Y4(e) {
  return e === !0 ? cg(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function j4(e) {
  return e === !0 ? cg(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function W4(e, t, n) {
  var r, i, a, o = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      a = ei([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (i = jt.call(this._weekdaysParse, o), i !== -1 ? i : null) : t === "ddd" ? (i = jt.call(this._shortWeekdaysParse, o), i !== -1 ? i : null) : (i = jt.call(this._minWeekdaysParse, o), i !== -1 ? i : null) : t === "dddd" ? (i = jt.call(this._weekdaysParse, o), i !== -1 || (i = jt.call(this._shortWeekdaysParse, o), i !== -1) ? i : (i = jt.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : t === "ddd" ? (i = jt.call(this._shortWeekdaysParse, o), i !== -1 || (i = jt.call(this._weekdaysParse, o), i !== -1) ? i : (i = jt.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : (i = jt.call(this._minWeekdaysParse, o), i !== -1 || (i = jt.call(this._weekdaysParse, o), i !== -1) ? i : (i = jt.call(this._shortWeekdaysParse, o), i !== -1 ? i : null));
}
function H4(e, t, n) {
  var r, i, a;
  if (this._weekdaysParseExact)
    return W4.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (i = ei([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (a = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (n && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (n && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!n && this._weekdaysParse[r].test(e))
      return r;
  }
}
function U4(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = R4(e, this.localeData()), this.add(e - t, "d")) : t;
}
function G4(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function V4(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = D4(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Q4(e) {
  return this._weekdaysParseExact ? (ot(this, "_weekdaysRegex") || ug.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (ot(this, "_weekdaysRegex") || (this._weekdaysRegex = z4), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function q4(e) {
  return this._weekdaysParseExact ? (ot(this, "_weekdaysRegex") || ug.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (ot(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = B4), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function X4(e) {
  return this._weekdaysParseExact ? (ot(this, "_weekdaysRegex") || ug.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (ot(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = F4), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function ug() {
  function e(u, d) {
    return d.length - u.length;
  }
  var t = [], n = [], r = [], i = [], a, o, s, c, l;
  for (a = 0; a < 7; a++)
    o = ei([2e3, 1]).day(a), s = Gn(this.weekdaysMin(o, "")), c = Gn(this.weekdaysShort(o, "")), l = Gn(this.weekdays(o, "")), t.push(s), n.push(c), r.push(l), i.push(s), i.push(c), i.push(l);
  t.sort(e), n.sort(e), r.sort(e), i.sort(e), this._weekdaysRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function fg() {
  return this.hours() % 12 || 12;
}
function J4() {
  return this.hours() || 24;
}
je("H", ["HH", 2], 0, "hour");
je("h", ["hh", 2], 0, fg);
je("k", ["kk", 2], 0, J4);
je("hmm", 0, 0, function() {
  return "" + fg.apply(this) + Qr(this.minutes(), 2);
});
je("hmmss", 0, 0, function() {
  return "" + fg.apply(this) + Qr(this.minutes(), 2) + Qr(this.seconds(), 2);
});
je("Hmm", 0, 0, function() {
  return "" + this.hours() + Qr(this.minutes(), 2);
});
je("Hmmss", 0, 0, function() {
  return "" + this.hours() + Qr(this.minutes(), 2) + Qr(this.seconds(), 2);
});
function xw(e, t) {
  je(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
xw("a", !0);
xw("A", !1);
wn("hour", "h");
_n("hour", 13);
function vw(e, t) {
  return t._meridiemParse;
}
Ne("a", vw);
Ne("A", vw);
Ne("H", It);
Ne("h", It);
Ne("k", It);
Ne("HH", It, er);
Ne("hh", It, er);
Ne("kk", It, er);
Ne("hmm", lw);
Ne("hmmss", cw);
Ne("Hmm", lw);
Ne("Hmmss", cw);
vt(["H", "HH"], Xt);
vt(["k", "kk"], function(e, t, n) {
  var r = nt(e);
  t[Xt] = r === 24 ? 0 : r;
});
vt(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
vt(["h", "hh"], function(e, t, n) {
  t[Xt] = nt(e), Ke(n).bigHour = !0;
});
vt("hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Xt] = nt(e.substr(0, r)), t[vr] = nt(e.substr(r)), Ke(n).bigHour = !0;
});
vt("hmmss", function(e, t, n) {
  var r = e.length - 4, i = e.length - 2;
  t[Xt] = nt(e.substr(0, r)), t[vr] = nt(e.substr(r, 2)), t[di] = nt(e.substr(i)), Ke(n).bigHour = !0;
});
vt("Hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Xt] = nt(e.substr(0, r)), t[vr] = nt(e.substr(r));
});
vt("Hmmss", function(e, t, n) {
  var r = e.length - 4, i = e.length - 2;
  t[Xt] = nt(e.substr(0, r)), t[vr] = nt(e.substr(r, 2)), t[di] = nt(e.substr(i));
});
function K4(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Z4 = /[ap]\.?m?\.?/i, e5 = Wo("Hours", !0);
function t5(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var Aw = {
  calendar: HL,
  longDateFormat: QL,
  invalidDate: XL,
  ordinal: KL,
  dayOfMonthOrdinalParse: ZL,
  relativeTime: t4,
  months: m4,
  monthsShort: uw,
  week: T4,
  weekdays: P4,
  weekdaysMin: L4,
  weekdaysShort: yw,
  meridiemParse: Z4
}, Ot = {}, as = {}, il;
function n5(e, t) {
  var n, r = Math.min(e.length, t.length);
  for (n = 0; n < r; n += 1)
    if (e[n] !== t[n])
      return n;
  return r;
}
function $1(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function r5(e) {
  for (var t = 0, n, r, i, a; t < e.length; ) {
    for (a = $1(e[t]).split("-"), n = a.length, r = $1(e[t + 1]), r = r ? r.split("-") : null; n > 0; ) {
      if (i = Yf(a.slice(0, n).join("-")), i)
        return i;
      if (r && r.length >= n && n5(a, r) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return il;
}
function i5(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Yf(e) {
  var t = null, n;
  if (Ot[e] === void 0 && typeof module < "u" && module && module.exports && i5(e))
    try {
      t = il._abbr, n = require, n("./locale/" + e), zi(t);
    } catch {
      Ot[e] = null;
    }
  return Ot[e];
}
function zi(e, t) {
  var n;
  return e && (Rn(t) ? n = _i(e) : n = dg(e, t), n ? il = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), il._abbr;
}
function dg(e, t) {
  if (t !== null) {
    var n, r = Aw;
    if (t.abbr = e, Ot[e] != null)
      nw(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = Ot[e]._config;
    else if (t.parentLocale != null)
      if (Ot[t.parentLocale] != null)
        r = Ot[t.parentLocale]._config;
      else if (n = Yf(t.parentLocale), n != null)
        r = n._config;
      else
        return as[t.parentLocale] || (as[t.parentLocale] = []), as[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return Ot[e] = new ig(hp(r, t)), as[e] && as[e].forEach(function(i) {
      dg(i.name, i.config);
    }), zi(e), Ot[e];
  } else
    return delete Ot[e], null;
}
function a5(e, t) {
  if (t != null) {
    var n, r, i = Aw;
    Ot[e] != null && Ot[e].parentLocale != null ? Ot[e].set(hp(Ot[e]._config, t)) : (r = Yf(e), r != null && (i = r._config), t = hp(i, t), r == null && (t.abbr = e), n = new ig(t), n.parentLocale = Ot[e], Ot[e] = n), zi(e);
  } else
    Ot[e] != null && (Ot[e].parentLocale != null ? (Ot[e] = Ot[e].parentLocale, e === zi() && zi(e)) : Ot[e] != null && delete Ot[e]);
  return Ot[e];
}
function _i(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return il;
  if (!Sr(e)) {
    if (t = Yf(e), t)
      return t;
    e = [e];
  }
  return r5(e);
}
function o5() {
  return pp(Ot);
}
function hg(e) {
  var t, n = e._a;
  return n && Ke(e).overflow === -2 && (t = n[fi] < 0 || n[fi] > 11 ? fi : n[Yr] < 1 || n[Yr] > $f(n[An], n[fi]) ? Yr : n[Xt] < 0 || n[Xt] > 24 || n[Xt] === 24 && (n[vr] !== 0 || n[di] !== 0 || n[xa] !== 0) ? Xt : n[vr] < 0 || n[vr] > 59 ? vr : n[di] < 0 || n[di] > 59 ? di : n[xa] < 0 || n[xa] > 999 ? xa : -1, Ke(e)._overflowDayOfYear && (t < An || t > Yr) && (t = Yr), Ke(e)._overflowWeeks && t === -1 && (t = d4), Ke(e)._overflowWeekday && t === -1 && (t = h4), Ke(e).overflow = t), e;
}
var s5 = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, l5 = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, c5 = /Z|[+-]\d\d(?::?\d\d)?/, mc = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Qd = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], u5 = /^\/?Date\((-?\d+)/i, f5 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, d5 = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function bw(e) {
  var t, n, r = e._i, i = s5.exec(r) || l5.exec(r), a, o, s, c, l = mc.length, u = Qd.length;
  if (i) {
    for (Ke(e).iso = !0, t = 0, n = l; t < n; t++)
      if (mc[t][1].exec(i[1])) {
        o = mc[t][0], a = mc[t][2] !== !1;
        break;
      }
    if (o == null) {
      e._isValid = !1;
      return;
    }
    if (i[3]) {
      for (t = 0, n = u; t < n; t++)
        if (Qd[t][1].exec(i[3])) {
          s = (i[2] || " ") + Qd[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (i[4])
      if (c5.exec(i[4]))
        c = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = o + (s || "") + (c || ""), mg(e);
  } else
    e._isValid = !1;
}
function h5(e, t, n, r, i, a) {
  var o = [
    p5(e),
    uw.indexOf(t),
    parseInt(n, 10),
    parseInt(r, 10),
    parseInt(i, 10)
  ];
  return a && o.push(parseInt(a, 10)), o;
}
function p5(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function m5(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function g5(e, t, n) {
  if (e) {
    var r = yw.indexOf(e), i = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== i)
      return Ke(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function y5(e, t, n) {
  if (e)
    return d5[e];
  if (t)
    return 0;
  var r = parseInt(n, 10), i = r % 100, a = (r - i) / 100;
  return a * 60 + i;
}
function ww(e) {
  var t = f5.exec(m5(e._i)), n;
  if (t) {
    if (n = h5(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !g5(t[1], n, e))
      return;
    e._a = n, e._tzm = y5(t[8], t[9], t[10]), e._d = nl.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Ke(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function x5(e) {
  var t = u5.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (bw(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (ww(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : ke.createFromInputFallback(e);
}
ke.createFromInputFallback = hr(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function ro(e, t, n) {
  return e ?? t ?? n;
}
function v5(e) {
  var t = new Date(ke.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function pg(e) {
  var t, n, r = [], i, a, o;
  if (!e._d) {
    for (i = v5(e), e._w && e._a[Yr] == null && e._a[fi] == null && A5(e), e._dayOfYear != null && (o = ro(e._a[An], i[An]), (e._dayOfYear > Ys(o) || e._dayOfYear === 0) && (Ke(e)._overflowDayOfYear = !0), n = nl(o, 0, e._dayOfYear), e._a[fi] = n.getUTCMonth(), e._a[Yr] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = i[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Xt] === 24 && e._a[vr] === 0 && e._a[di] === 0 && e._a[xa] === 0 && (e._nextDay = !0, e._a[Xt] = 0), e._d = (e._useUTC ? nl : E4).apply(
      null,
      r
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Xt] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (Ke(e).weekdayMismatch = !0);
  }
}
function A5(e) {
  var t, n, r, i, a, o, s, c, l;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, o = 4, n = ro(
    t.GG,
    e._a[An],
    rl(Mt(), 1, 4).year
  ), r = ro(t.W, 1), i = ro(t.E, 1), (i < 1 || i > 7) && (c = !0)) : (a = e._locale._week.dow, o = e._locale._week.doy, l = rl(Mt(), a, o), n = ro(t.gg, e._a[An], l.year), r = ro(t.w, l.week), t.d != null ? (i = t.d, (i < 0 || i > 6) && (c = !0)) : t.e != null ? (i = t.e + a, (t.e < 0 || t.e > 6) && (c = !0)) : i = a), r < 1 || r > gi(n, a, o) ? Ke(e)._overflowWeeks = !0 : c != null ? Ke(e)._overflowWeekday = !0 : (s = gw(n, r, i, a, o), e._a[An] = s.year, e._dayOfYear = s.dayOfYear);
}
ke.ISO_8601 = function() {
};
ke.RFC_2822 = function() {
};
function mg(e) {
  if (e._f === ke.ISO_8601) {
    bw(e);
    return;
  }
  if (e._f === ke.RFC_2822) {
    ww(e);
    return;
  }
  e._a = [], Ke(e).empty = !0;
  var t = "" + e._i, n, r, i, a, o, s = t.length, c = 0, l, u;
  for (i = rw(e._f, e._locale).match(ag) || [], u = i.length, n = 0; n < u; n++)
    a = i[n], r = (t.match(c4(a, e)) || [])[0], r && (o = t.substr(0, t.indexOf(r)), o.length > 0 && Ke(e).unusedInput.push(o), t = t.slice(
      t.indexOf(r) + r.length
    ), c += r.length), go[a] ? (r ? Ke(e).empty = !1 : Ke(e).unusedTokens.push(a), f4(a, r, e)) : e._strict && !r && Ke(e).unusedTokens.push(a);
  Ke(e).charsLeftOver = s - c, t.length > 0 && Ke(e).unusedInput.push(t), e._a[Xt] <= 12 && Ke(e).bigHour === !0 && e._a[Xt] > 0 && (Ke(e).bigHour = void 0), Ke(e).parsedDateParts = e._a.slice(0), Ke(e).meridiem = e._meridiem, e._a[Xt] = b5(
    e._locale,
    e._a[Xt],
    e._meridiem
  ), l = Ke(e).era, l !== null && (e._a[An] = e._locale.erasConvertYear(l, e._a[An])), pg(e), hg(e);
}
function b5(e, t, n) {
  var r;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (r = e.isPM(n), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function w5(e) {
  var t, n, r, i, a, o, s = !1, c = e._f.length;
  if (c === 0) {
    Ke(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < c; i++)
    a = 0, o = !1, t = rg({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[i], mg(t), ng(t) && (o = !0), a += Ke(t).charsLeftOver, a += Ke(t).unusedTokens.length * 10, Ke(t).score = a, s ? a < r && (r = a, n = t) : (r == null || a < r || o) && (r = a, n = t, o && (s = !0));
  Oi(e, n || t);
}
function _5(e) {
  if (!e._d) {
    var t = og(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = ew(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), pg(e);
  }
}
function S5(e) {
  var t = new zl(hg(_w(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function _w(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || _i(e._l), t === null || n === void 0 && t === "" ? Rf({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), Cr(t) ? new zl(hg(t)) : (Ll(t) ? e._d = t : Sr(n) ? w5(e) : n ? mg(e) : C5(e), ng(e) || (e._d = null), e));
}
function C5(e) {
  var t = e._i;
  Rn(t) ? e._d = new Date(ke.now()) : Ll(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? x5(e) : Sr(t) ? (e._a = ew(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), pg(e)) : Aa(t) ? _5(e) : xi(t) ? e._d = new Date(t) : ke.createFromInputFallback(e);
}
function Sw(e, t, n, r, i) {
  var a = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (n === !0 || n === !1) && (r = n, n = void 0), (Aa(e) && tg(e) || Sr(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = i, a._l = n, a._i = e, a._f = t, a._strict = r, S5(a);
}
function Mt(e, t, n, r) {
  return Sw(e, t, n, r, !1);
}
var E5 = hr(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Mt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Rf();
  }
), k5 = hr(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Mt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Rf();
  }
);
function Cw(e, t) {
  var n, r;
  if (t.length === 1 && Sr(t[0]) && (t = t[0]), !t.length)
    return Mt();
  for (n = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](n)) && (n = t[r]);
  return n;
}
function T5() {
  var e = [].slice.call(arguments, 0);
  return Cw("isBefore", e);
}
function M5() {
  var e = [].slice.call(arguments, 0);
  return Cw("isAfter", e);
}
var I5 = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, os = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function N5(e) {
  var t, n = !1, r, i = os.length;
  for (t in e)
    if (ot(e, t) && !(jt.call(os, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < i; ++r)
    if (e[os[r]]) {
      if (n)
        return !1;
      parseFloat(e[os[r]]) !== nt(e[os[r]]) && (n = !0);
    }
  return !0;
}
function O5() {
  return this._isValid;
}
function R5() {
  return Mr(NaN);
}
function jf(e) {
  var t = og(e), n = t.year || 0, r = t.quarter || 0, i = t.month || 0, a = t.week || t.isoWeek || 0, o = t.day || 0, s = t.hour || 0, c = t.minute || 0, l = t.second || 0, u = t.millisecond || 0;
  this._isValid = N5(t), this._milliseconds = +u + l * 1e3 + // 1000
  c * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +o + a * 7, this._months = +i + r * 3 + n * 12, this._data = {}, this._locale = _i(), this._bubble();
}
function qc(e) {
  return e instanceof jf;
}
function gp(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function D5(e, t, n) {
  var r = Math.min(e.length, t.length), i = Math.abs(e.length - t.length), a = 0, o;
  for (o = 0; o < r; o++)
    nt(e[o]) !== nt(t[o]) && a++;
  return a + i;
}
function Ew(e, t) {
  je(e, 0, 0, function() {
    var n = this.utcOffset(), r = "+";
    return n < 0 && (n = -n, r = "-"), r + Qr(~~(n / 60), 2) + t + Qr(~~n % 60, 2);
  });
}
Ew("Z", ":");
Ew("ZZ", "");
Ne("Z", Ff);
Ne("ZZ", Ff);
vt(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = gg(Ff, e);
});
var P5 = /([\+\-]|\d\d)/gi;
function gg(e, t) {
  var n = (t || "").match(e), r, i, a;
  return n === null ? null : (r = n[n.length - 1] || [], i = (r + "").match(P5) || ["-", 0, 0], a = +(i[1] * 60) + nt(i[2]), a === 0 ? 0 : i[0] === "+" ? a : -a);
}
function yg(e, t) {
  var n, r;
  return t._isUTC ? (n = t.clone(), r = (Cr(e) || Ll(e) ? e.valueOf() : Mt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), ke.updateOffset(n, !1), n) : Mt(e).local();
}
function yp(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
ke.updateOffset = function() {
};
function L5(e, t, n) {
  var r = this._offset || 0, i;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = gg(Ff, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (i = yp(this)), this._offset = e, this._isUTC = !0, i != null && this.add(i, "m"), r !== e && (!t || this._changeInProgress ? Mw(
      this,
      Mr(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, ke.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : yp(this);
}
function z5(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function B5(e) {
  return this.utcOffset(0, e);
}
function F5(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(yp(this), "m")), this;
}
function $5() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = gg(s4, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Y5(e) {
  return this.isValid() ? (e = e ? Mt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function j5() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function W5() {
  if (!Rn(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return rg(e, this), e = _w(e), e._a ? (t = e._isUTC ? ei(e._a) : Mt(e._a), this._isDSTShifted = this.isValid() && D5(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function H5() {
  return this.isValid() ? !this._isUTC : !1;
}
function U5() {
  return this.isValid() ? this._isUTC : !1;
}
function kw() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var G5 = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, V5 = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Mr(e, t) {
  var n = e, r = null, i, a, o;
  return qc(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : xi(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (r = G5.exec(e)) ? (i = r[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: nt(r[Yr]) * i,
    h: nt(r[Xt]) * i,
    m: nt(r[vr]) * i,
    s: nt(r[di]) * i,
    ms: nt(gp(r[xa] * 1e3)) * i
    // the millisecond decimal point is included in the match
  }) : (r = V5.exec(e)) ? (i = r[1] === "-" ? -1 : 1, n = {
    y: la(r[2], i),
    M: la(r[3], i),
    w: la(r[4], i),
    d: la(r[5], i),
    h: la(r[6], i),
    m: la(r[7], i),
    s: la(r[8], i)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (o = Q5(
    Mt(n.from),
    Mt(n.to)
  ), n = {}, n.ms = o.milliseconds, n.M = o.months), a = new jf(n), qc(e) && ot(e, "_locale") && (a._locale = e._locale), qc(e) && ot(e, "_isValid") && (a._isValid = e._isValid), a;
}
Mr.fn = jf.prototype;
Mr.invalid = R5;
function la(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function Y1(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function Q5(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = yg(t, e), e.isBefore(t) ? n = Y1(e, t) : (n = Y1(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function Tw(e, t) {
  return function(n, r) {
    var i, a;
    return r !== null && !isNaN(+r) && (nw(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = n, n = r, r = a), i = Mr(n, r), Mw(this, i, e), this;
  };
}
function Mw(e, t, n, r) {
  var i = t._milliseconds, a = gp(t._days), o = gp(t._months);
  e.isValid() && (r = r ?? !0, o && dw(e, gu(e, "Month") + o * n), a && aw(e, "Date", gu(e, "Date") + a * n), i && e._d.setTime(e._d.valueOf() + i * n), r && ke.updateOffset(e, a || o));
}
var q5 = Tw(1, "add"), X5 = Tw(-1, "subtract");
function Iw(e) {
  return typeof e == "string" || e instanceof String;
}
function J5(e) {
  return Cr(e) || Ll(e) || Iw(e) || xi(e) || Z5(e) || K5(e) || e === null || e === void 0;
}
function K5(e) {
  var t = Aa(e) && !tg(e), n = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, a, o = r.length;
  for (i = 0; i < o; i += 1)
    a = r[i], n = n || ot(e, a);
  return t && n;
}
function Z5(e) {
  var t = Sr(e), n = !1;
  return t && (n = e.filter(function(r) {
    return !xi(r) && Iw(e);
  }).length === 0), t && n;
}
function e3(e) {
  var t = Aa(e) && !tg(e), n = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, a;
  for (i = 0; i < r.length; i += 1)
    a = r[i], n = n || ot(e, a);
  return t && n;
}
function t3(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function n3(e, t) {
  arguments.length === 1 && (arguments[0] ? J5(arguments[0]) ? (e = arguments[0], t = void 0) : e3(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || Mt(), r = yg(n, this).startOf("day"), i = ke.calendarFormat(this, r) || "sameElse", a = t && (ti(t[i]) ? t[i].call(this, n) : t[i]);
  return this.format(
    a || this.localeData().calendar(i, this, Mt(n))
  );
}
function r3() {
  return new zl(this);
}
function i3(e, t) {
  var n = Cr(e) ? e : Mt(e);
  return this.isValid() && n.isValid() ? (t = pr(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function a3(e, t) {
  var n = Cr(e) ? e : Mt(e);
  return this.isValid() && n.isValid() ? (t = pr(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function o3(e, t, n, r) {
  var i = Cr(e) ? e : Mt(e), a = Cr(t) ? t : Mt(t);
  return this.isValid() && i.isValid() && a.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(i, n) : !this.isBefore(i, n)) && (r[1] === ")" ? this.isBefore(a, n) : !this.isAfter(a, n))) : !1;
}
function s3(e, t) {
  var n = Cr(e) ? e : Mt(e), r;
  return this.isValid() && n.isValid() ? (t = pr(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function l3(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function c3(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function u3(e, t, n) {
  var r, i, a;
  if (!this.isValid())
    return NaN;
  if (r = yg(e, this), !r.isValid())
    return NaN;
  switch (i = (r.utcOffset() - this.utcOffset()) * 6e4, t = pr(t), t) {
    case "year":
      a = Xc(this, r) / 12;
      break;
    case "month":
      a = Xc(this, r);
      break;
    case "quarter":
      a = Xc(this, r) / 3;
      break;
    case "second":
      a = (this - r) / 1e3;
      break;
    case "minute":
      a = (this - r) / 6e4;
      break;
    case "hour":
      a = (this - r) / 36e5;
      break;
    case "day":
      a = (this - r - i) / 864e5;
      break;
    case "week":
      a = (this - r - i) / 6048e5;
      break;
    default:
      a = this - r;
  }
  return n ? a : lr(a);
}
function Xc(e, t) {
  if (e.date() < t.date())
    return -Xc(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(n, "months"), i, a;
  return t - r < 0 ? (i = e.clone().add(n - 1, "months"), a = (t - r) / (r - i)) : (i = e.clone().add(n + 1, "months"), a = (t - r) / (i - r)), -(n + a) || 0;
}
ke.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ke.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function f3() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function d3(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? Qc(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ti(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Qc(n, "Z")) : Qc(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function h3() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, r, i, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(n + r + i + a);
}
function p3(e) {
  e || (e = this.isUtc() ? ke.defaultFormatUtc : ke.defaultFormat);
  var t = Qc(this, e);
  return this.localeData().postformat(t);
}
function m3(e, t) {
  return this.isValid() && (Cr(e) && e.isValid() || Mt(e).isValid()) ? Mr({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function g3(e) {
  return this.from(Mt(), e);
}
function y3(e, t) {
  return this.isValid() && (Cr(e) && e.isValid() || Mt(e).isValid()) ? Mr({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function x3(e) {
  return this.to(Mt(), e);
}
function Nw(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = _i(e), t != null && (this._locale = t), this);
}
var Ow = hr(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Rw() {
  return this._locale;
}
var vu = 1e3, yo = 60 * vu, Au = 60 * yo, Dw = (365 * 400 + 97) * 24 * Au;
function xo(e, t) {
  return (e % t + t) % t;
}
function Pw(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - Dw : new Date(e, t, n).valueOf();
}
function Lw(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - Dw : Date.UTC(e, t, n);
}
function v3(e) {
  var t, n;
  if (e = pr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Lw : Pw, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= xo(
        t + (this._isUTC ? 0 : this.utcOffset() * yo),
        Au
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= xo(t, yo);
      break;
    case "second":
      t = this._d.valueOf(), t -= xo(t, vu);
      break;
  }
  return this._d.setTime(t), ke.updateOffset(this, !0), this;
}
function A3(e) {
  var t, n;
  if (e = pr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Lw : Pw, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Au - xo(
        t + (this._isUTC ? 0 : this.utcOffset() * yo),
        Au
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += yo - xo(t, yo) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += vu - xo(t, vu) - 1;
      break;
  }
  return this._d.setTime(t), ke.updateOffset(this, !0), this;
}
function b3() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function w3() {
  return Math.floor(this.valueOf() / 1e3);
}
function _3() {
  return new Date(this.valueOf());
}
function S3() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function C3() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function E3() {
  return this.isValid() ? this.toISOString() : null;
}
function k3() {
  return ng(this);
}
function T3() {
  return Oi({}, Ke(this));
}
function M3() {
  return Ke(this).overflow;
}
function I3() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
je("N", 0, 0, "eraAbbr");
je("NN", 0, 0, "eraAbbr");
je("NNN", 0, 0, "eraAbbr");
je("NNNN", 0, 0, "eraName");
je("NNNNN", 0, 0, "eraNarrow");
je("y", ["y", 1], "yo", "eraYear");
je("y", ["yy", 2], 0, "eraYear");
je("y", ["yyy", 3], 0, "eraYear");
je("y", ["yyyy", 4], 0, "eraYear");
Ne("N", xg);
Ne("NN", xg);
Ne("NNN", xg);
Ne("NNNN", Y3);
Ne("NNNNN", j3);
vt(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, r) {
    var i = n._locale.erasParse(e, r, n._strict);
    i ? Ke(n).era = i : Ke(n).invalidEra = e;
  }
);
Ne("y", Ho);
Ne("yy", Ho);
Ne("yyy", Ho);
Ne("yyyy", Ho);
Ne("yo", W3);
vt(["y", "yy", "yyy", "yyyy"], An);
vt(["yo"], function(e, t, n, r) {
  var i;
  n._locale._eraYearOrdinalRegex && (i = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[An] = n._locale.eraYearOrdinalParse(e, i) : t[An] = parseInt(e, 10);
});
function N3(e, t) {
  var n, r, i, a = this._eras || _i("en")._eras;
  for (n = 0, r = a.length; n < r; ++n) {
    switch (typeof a[n].since) {
      case "string":
        i = ke(a[n].since).startOf("day"), a[n].since = i.valueOf();
        break;
    }
    switch (typeof a[n].until) {
      case "undefined":
        a[n].until = 1 / 0;
        break;
      case "string":
        i = ke(a[n].until).startOf("day").valueOf(), a[n].until = i.valueOf();
        break;
    }
  }
  return a;
}
function O3(e, t, n) {
  var r, i, a = this.eras(), o, s, c;
  for (e = e.toUpperCase(), r = 0, i = a.length; r < i; ++r)
    if (o = a[r].name.toUpperCase(), s = a[r].abbr.toUpperCase(), c = a[r].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[r];
          break;
        case "NNNN":
          if (o === e)
            return a[r];
          break;
        case "NNNNN":
          if (c === e)
            return a[r];
          break;
      }
    else if ([o, s, c].indexOf(e) >= 0)
      return a[r];
}
function R3(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? ke(e.since).year() : ke(e.since).year() + (t - e.offset) * n;
}
function D3() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].name;
  return "";
}
function P3() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].narrow;
  return "";
}
function L3() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].abbr;
  return "";
}
function z3() {
  var e, t, n, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (n = i[e].since <= i[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return (this.year() - ke(i[e].since).year()) * n + i[e].offset;
  return this.year();
}
function B3(e) {
  return ot(this, "_erasNameRegex") || vg.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function F3(e) {
  return ot(this, "_erasAbbrRegex") || vg.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function $3(e) {
  return ot(this, "_erasNarrowRegex") || vg.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function xg(e, t) {
  return t.erasAbbrRegex(e);
}
function Y3(e, t) {
  return t.erasNameRegex(e);
}
function j3(e, t) {
  return t.erasNarrowRegex(e);
}
function W3(e, t) {
  return t._eraYearOrdinalRegex || Ho;
}
function vg() {
  var e = [], t = [], n = [], r = [], i, a, o = this.eras();
  for (i = 0, a = o.length; i < a; ++i)
    t.push(Gn(o[i].name)), e.push(Gn(o[i].abbr)), n.push(Gn(o[i].narrow)), r.push(Gn(o[i].name)), r.push(Gn(o[i].abbr)), r.push(Gn(o[i].narrow));
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
je(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
je(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Wf(e, t) {
  je(0, [e, e.length], 0, t);
}
Wf("gggg", "weekYear");
Wf("ggggg", "weekYear");
Wf("GGGG", "isoWeekYear");
Wf("GGGGG", "isoWeekYear");
wn("weekYear", "gg");
wn("isoWeekYear", "GG");
_n("weekYear", 1);
_n("isoWeekYear", 1);
Ne("G", Bf);
Ne("g", Bf);
Ne("GG", It, er);
Ne("gg", It, er);
Ne("GGGG", lg, sg);
Ne("gggg", lg, sg);
Ne("GGGGG", zf, Pf);
Ne("ggggg", zf, Pf);
Fl(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, r) {
    t[r.substr(0, 2)] = nt(e);
  }
);
Fl(["gg", "GG"], function(e, t, n, r) {
  t[r] = ke.parseTwoDigitYear(e);
});
function H3(e) {
  return zw.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function U3(e) {
  return zw.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function G3() {
  return gi(this.year(), 1, 4);
}
function V3() {
  return gi(this.isoWeekYear(), 1, 4);
}
function Q3() {
  var e = this.localeData()._week;
  return gi(this.year(), e.dow, e.doy);
}
function q3() {
  var e = this.localeData()._week;
  return gi(this.weekYear(), e.dow, e.doy);
}
function zw(e, t, n, r, i) {
  var a;
  return e == null ? rl(this, r, i).year : (a = gi(e, r, i), t > a && (t = a), X3.call(this, e, t, n, r, i));
}
function X3(e, t, n, r, i) {
  var a = gw(e, t, n, r, i), o = nl(a.year, 0, a.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
je("Q", 0, "Qo", "quarter");
wn("quarter", "Q");
_n("quarter", 7);
Ne("Q", ow);
vt("Q", function(e, t) {
  t[fi] = (nt(e) - 1) * 3;
});
function J3(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
je("D", ["DD", 2], "Do", "date");
wn("date", "D");
_n("date", 9);
Ne("D", It);
Ne("DD", It, er);
Ne("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
vt(["D", "DD"], Yr);
vt("Do", function(e, t) {
  t[Yr] = nt(e.match(It)[0]);
});
var Bw = Wo("Date", !0);
je("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
wn("dayOfYear", "DDD");
_n("dayOfYear", 4);
Ne("DDD", Lf);
Ne("DDDD", sw);
vt(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = nt(e);
});
function K3(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
je("m", ["mm", 2], 0, "minute");
wn("minute", "m");
_n("minute", 14);
Ne("m", It);
Ne("mm", It, er);
vt(["m", "mm"], vr);
var Z3 = Wo("Minutes", !1);
je("s", ["ss", 2], 0, "second");
wn("second", "s");
_n("second", 15);
Ne("s", It);
Ne("ss", It, er);
vt(["s", "ss"], di);
var ez = Wo("Seconds", !1);
je("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
je(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
je(0, ["SSS", 3], 0, "millisecond");
je(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
je(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
je(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
je(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
je(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
je(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
wn("millisecond", "ms");
_n("millisecond", 16);
Ne("S", Lf, ow);
Ne("SS", Lf, er);
Ne("SSS", Lf, sw);
var Ri, Fw;
for (Ri = "SSSS"; Ri.length <= 9; Ri += "S")
  Ne(Ri, Ho);
function tz(e, t) {
  t[xa] = nt(("0." + e) * 1e3);
}
for (Ri = "S"; Ri.length <= 9; Ri += "S")
  vt(Ri, tz);
Fw = Wo("Milliseconds", !1);
je("z", 0, 0, "zoneAbbr");
je("zz", 0, 0, "zoneName");
function nz() {
  return this._isUTC ? "UTC" : "";
}
function rz() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var ye = zl.prototype;
ye.add = q5;
ye.calendar = n3;
ye.clone = r3;
ye.diff = u3;
ye.endOf = A3;
ye.format = p3;
ye.from = m3;
ye.fromNow = g3;
ye.to = y3;
ye.toNow = x3;
ye.get = a4;
ye.invalidAt = M3;
ye.isAfter = i3;
ye.isBefore = a3;
ye.isBetween = o3;
ye.isSame = s3;
ye.isSameOrAfter = l3;
ye.isSameOrBefore = c3;
ye.isValid = k3;
ye.lang = Ow;
ye.locale = Nw;
ye.localeData = Rw;
ye.max = k5;
ye.min = E5;
ye.parsingFlags = T3;
ye.set = o4;
ye.startOf = v3;
ye.subtract = X5;
ye.toArray = S3;
ye.toObject = C3;
ye.toDate = _3;
ye.toISOString = d3;
ye.inspect = h3;
typeof Symbol < "u" && Symbol.for != null && (ye[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
ye.toJSON = E3;
ye.toString = f3;
ye.unix = w3;
ye.valueOf = b3;
ye.creationData = I3;
ye.eraName = D3;
ye.eraNarrow = P3;
ye.eraAbbr = L3;
ye.eraYear = z3;
ye.year = mw;
ye.isLeapYear = C4;
ye.weekYear = H3;
ye.isoWeekYear = U3;
ye.quarter = ye.quarters = J3;
ye.month = hw;
ye.daysInMonth = w4;
ye.week = ye.weeks = N4;
ye.isoWeek = ye.isoWeeks = O4;
ye.weeksInYear = Q3;
ye.weeksInWeekYear = q3;
ye.isoWeeksInYear = G3;
ye.isoWeeksInISOWeekYear = V3;
ye.date = Bw;
ye.day = ye.days = U4;
ye.weekday = G4;
ye.isoWeekday = V4;
ye.dayOfYear = K3;
ye.hour = ye.hours = e5;
ye.minute = ye.minutes = Z3;
ye.second = ye.seconds = ez;
ye.millisecond = ye.milliseconds = Fw;
ye.utcOffset = L5;
ye.utc = B5;
ye.local = F5;
ye.parseZone = $5;
ye.hasAlignedHourOffset = Y5;
ye.isDST = j5;
ye.isLocal = H5;
ye.isUtcOffset = U5;
ye.isUtc = kw;
ye.isUTC = kw;
ye.zoneAbbr = nz;
ye.zoneName = rz;
ye.dates = hr(
  "dates accessor is deprecated. Use date instead.",
  Bw
);
ye.months = hr(
  "months accessor is deprecated. Use month instead",
  hw
);
ye.years = hr(
  "years accessor is deprecated. Use year instead",
  mw
);
ye.zone = hr(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  z5
);
ye.isDSTShifted = hr(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  W5
);
function iz(e) {
  return Mt(e * 1e3);
}
function az() {
  return Mt.apply(null, arguments).parseZone();
}
function $w(e) {
  return e;
}
var st = ig.prototype;
st.calendar = UL;
st.longDateFormat = qL;
st.invalidDate = JL;
st.ordinal = e4;
st.preparse = $w;
st.postformat = $w;
st.relativeTime = n4;
st.pastFuture = r4;
st.set = WL;
st.eras = N3;
st.erasParse = O3;
st.erasConvertYear = R3;
st.erasAbbrRegex = F3;
st.erasNameRegex = B3;
st.erasNarrowRegex = $3;
st.months = x4;
st.monthsShort = v4;
st.monthsParse = b4;
st.monthsRegex = S4;
st.monthsShortRegex = _4;
st.week = k4;
st.firstDayOfYear = I4;
st.firstDayOfWeek = M4;
st.weekdays = $4;
st.weekdaysMin = j4;
st.weekdaysShort = Y4;
st.weekdaysParse = H4;
st.weekdaysRegex = Q4;
st.weekdaysShortRegex = q4;
st.weekdaysMinRegex = X4;
st.isPM = K4;
st.meridiem = t5;
function bu(e, t, n, r) {
  var i = _i(), a = ei().set(r, t);
  return i[n](a, e);
}
function Yw(e, t, n) {
  if (xi(e) && (t = e, e = void 0), e = e || "", t != null)
    return bu(e, t, n, "month");
  var r, i = [];
  for (r = 0; r < 12; r++)
    i[r] = bu(e, r, n, "month");
  return i;
}
function Ag(e, t, n, r) {
  typeof e == "boolean" ? (xi(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, xi(t) && (n = t, t = void 0), t = t || "");
  var i = _i(), a = e ? i._week.dow : 0, o, s = [];
  if (n != null)
    return bu(t, (n + a) % 7, r, "day");
  for (o = 0; o < 7; o++)
    s[o] = bu(t, (o + a) % 7, r, "day");
  return s;
}
function oz(e, t) {
  return Yw(e, t, "months");
}
function sz(e, t) {
  return Yw(e, t, "monthsShort");
}
function lz(e, t, n) {
  return Ag(e, t, n, "weekdays");
}
function cz(e, t, n) {
  return Ag(e, t, n, "weekdaysShort");
}
function uz(e, t, n) {
  return Ag(e, t, n, "weekdaysMin");
}
zi("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = nt(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
ke.lang = hr(
  "moment.lang is deprecated. Use moment.locale instead.",
  zi
);
ke.langData = hr(
  "moment.langData is deprecated. Use moment.localeData instead.",
  _i
);
var ni = Math.abs;
function fz() {
  var e = this._data;
  return this._milliseconds = ni(this._milliseconds), this._days = ni(this._days), this._months = ni(this._months), e.milliseconds = ni(e.milliseconds), e.seconds = ni(e.seconds), e.minutes = ni(e.minutes), e.hours = ni(e.hours), e.months = ni(e.months), e.years = ni(e.years), this;
}
function jw(e, t, n, r) {
  var i = Mr(t, n);
  return e._milliseconds += r * i._milliseconds, e._days += r * i._days, e._months += r * i._months, e._bubble();
}
function dz(e, t) {
  return jw(this, e, t, 1);
}
function hz(e, t) {
  return jw(this, e, t, -1);
}
function j1(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function pz() {
  var e = this._milliseconds, t = this._days, n = this._months, r = this._data, i, a, o, s, c;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += j1(xp(n) + t) * 864e5, t = 0, n = 0), r.milliseconds = e % 1e3, i = lr(e / 1e3), r.seconds = i % 60, a = lr(i / 60), r.minutes = a % 60, o = lr(a / 60), r.hours = o % 24, t += lr(o / 24), c = lr(Ww(t)), n += c, t -= j1(xp(c)), s = lr(n / 12), n %= 12, r.days = t, r.months = n, r.years = s, this;
}
function Ww(e) {
  return e * 4800 / 146097;
}
function xp(e) {
  return e * 146097 / 4800;
}
function mz(e) {
  if (!this.isValid())
    return NaN;
  var t, n, r = this._milliseconds;
  if (e = pr(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, n = this._months + Ww(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(xp(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function gz() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + nt(this._months / 12) * 31536e6 : NaN;
}
function Si(e) {
  return function() {
    return this.as(e);
  };
}
var yz = Si("ms"), xz = Si("s"), vz = Si("m"), Az = Si("h"), bz = Si("d"), wz = Si("w"), _z = Si("M"), Sz = Si("Q"), Cz = Si("y");
function Ez() {
  return Mr(this);
}
function kz(e) {
  return e = pr(e), this.isValid() ? this[e + "s"]() : NaN;
}
function za(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Tz = za("milliseconds"), Mz = za("seconds"), Iz = za("minutes"), Nz = za("hours"), Oz = za("days"), Rz = za("months"), Dz = za("years");
function Pz() {
  return lr(this.days() / 7);
}
var ii = Math.round, ao = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Lz(e, t, n, r, i) {
  return i.relativeTime(t || 1, !!n, e, r);
}
function zz(e, t, n, r) {
  var i = Mr(e).abs(), a = ii(i.as("s")), o = ii(i.as("m")), s = ii(i.as("h")), c = ii(i.as("d")), l = ii(i.as("M")), u = ii(i.as("w")), d = ii(i.as("y")), f = a <= n.ss && ["s", a] || a < n.s && ["ss", a] || o <= 1 && ["m"] || o < n.m && ["mm", o] || s <= 1 && ["h"] || s < n.h && ["hh", s] || c <= 1 && ["d"] || c < n.d && ["dd", c];
  return n.w != null && (f = f || u <= 1 && ["w"] || u < n.w && ["ww", u]), f = f || l <= 1 && ["M"] || l < n.M && ["MM", l] || d <= 1 && ["y"] || ["yy", d], f[2] = t, f[3] = +e > 0, f[4] = r, Lz.apply(null, f);
}
function Bz(e) {
  return e === void 0 ? ii : typeof e == "function" ? (ii = e, !0) : !1;
}
function Fz(e, t) {
  return ao[e] === void 0 ? !1 : t === void 0 ? ao[e] : (ao[e] = t, e === "s" && (ao.ss = t - 1), !0);
}
function $z(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, r = ao, i, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (r = Object.assign({}, ao, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), i = this.localeData(), a = zz(this, !n, r, i), n && (a = i.pastFuture(+this, a)), i.postformat(a);
}
var qd = Math.abs;
function qa(e) {
  return (e > 0) - (e < 0) || +e;
}
function Hf() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = qd(this._milliseconds) / 1e3, t = qd(this._days), n = qd(this._months), r, i, a, o, s = this.asSeconds(), c, l, u, d;
  return s ? (r = lr(e / 60), i = lr(r / 60), e %= 60, r %= 60, a = lr(n / 12), n %= 12, o = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", c = s < 0 ? "-" : "", l = qa(this._months) !== qa(s) ? "-" : "", u = qa(this._days) !== qa(s) ? "-" : "", d = qa(this._milliseconds) !== qa(s) ? "-" : "", c + "P" + (a ? l + a + "Y" : "") + (n ? l + n + "M" : "") + (t ? u + t + "D" : "") + (i || r || e ? "T" : "") + (i ? d + i + "H" : "") + (r ? d + r + "M" : "") + (e ? d + o + "S" : "")) : "P0D";
}
var at = jf.prototype;
at.isValid = O5;
at.abs = fz;
at.add = dz;
at.subtract = hz;
at.as = mz;
at.asMilliseconds = yz;
at.asSeconds = xz;
at.asMinutes = vz;
at.asHours = Az;
at.asDays = bz;
at.asWeeks = wz;
at.asMonths = _z;
at.asQuarters = Sz;
at.asYears = Cz;
at.valueOf = gz;
at._bubble = pz;
at.clone = Ez;
at.get = kz;
at.milliseconds = Tz;
at.seconds = Mz;
at.minutes = Iz;
at.hours = Nz;
at.days = Oz;
at.weeks = Pz;
at.months = Rz;
at.years = Dz;
at.humanize = $z;
at.toISOString = Hf;
at.toString = Hf;
at.toJSON = Hf;
at.locale = Nw;
at.localeData = Rw;
at.toIsoString = hr(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Hf
);
at.lang = Ow;
je("X", 0, 0, "unix");
je("x", 0, 0, "valueOf");
Ne("x", Bf);
Ne("X", l4);
vt("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
vt("x", function(e, t, n) {
  n._d = new Date(nt(e));
});
//! moment.js
ke.version = "2.29.4";
YL(Mt);
ke.fn = ye;
ke.min = T5;
ke.max = M5;
ke.now = I5;
ke.utc = ei;
ke.unix = iz;
ke.months = oz;
ke.isDate = Ll;
ke.locale = zi;
ke.invalid = Rf;
ke.duration = Mr;
ke.isMoment = Cr;
ke.weekdays = lz;
ke.parseZone = az;
ke.localeData = _i;
ke.isDuration = qc;
ke.monthsShort = sz;
ke.weekdaysMin = uz;
ke.defineLocale = dg;
ke.updateLocale = a5;
ke.locales = o5;
ke.weekdaysShort = cz;
ke.normalizeUnits = pr;
ke.relativeTimeRounding = Bz;
ke.relativeTimeThreshold = Fz;
ke.calendarFormat = t3;
ke.prototype = ye;
ke.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const uQ = ({
  entity: e,
  studyTypes: t,
  onSubmit: n,
  actions: r
}) => {
  var u, d, f, h;
  const i = kr(), a = !r.update || r["consent.accept"], { settings: o } = Rt(
    (m) => m.user.data
  ), s = (d = (u = o == null ? void 0 : o.features) == null ? void 0 : u.studyId) == null ? void 0 : d.enabled, c = (h = (f = o == null ? void 0 : o.features) == null ? void 0 : f.studyId) == null ? void 0 : h.fieldLabel, l = (m, g) => {
    n({ ...e, [m]: g });
  };
  return /* @__PURE__ */ B(R, { container: !0, spacing: 2, item: !0, xs: 12, children: [
    /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, spacing: 2, children: [
      /* @__PURE__ */ B(R, { item: !0, md: 6, xl: 3, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle1", component: "label", children: "Type" }),
        /* @__PURE__ */ p(
          oE,
          {
            value: e.type,
            className: "",
            id: "study-type",
            options: t,
            placeholder: "Select type...",
            isOptionEqualToValue: (m, g) => m.id == g.id,
            getOptionLabel: (m) => m.name,
            size: "small",
            onSubmit: (m) => l("type", m),
            disableClearable: !0,
            color: "textColor.secondary",
            sx: {
              ml: -1
            },
            disabled: !0
          }
        )
      ] }),
      /* @__PURE__ */ B(R, { item: !0, md: 6, xl: 3, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle1", component: "label", children: s ? c : "Study ID" }),
        /* @__PURE__ */ p(
          Kt,
          {
            color: i.palette.textColor.primary,
            disabled: s,
            onSubmit: (m) => l("studyId", m),
            value: e.studyId
          }
        )
      ] }),
      /* @__PURE__ */ B(R, { item: !0, md: 6, xl: 3, container: !0, children: [
        /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(fe, { variant: "subtitle1", component: "label", children: [
          "Start ",
          "/",
          " End date"
        ] }) }),
        /* @__PURE__ */ B(
          R,
          {
            item: !0,
            xs: 12,
            container: !0,
            flexWrap: "wrap",
            ml: -1,
            justifyContent: "flex-start",
            alignItems: "center",
            children: [
              /* @__PURE__ */ p(R, { item: !0, mr: 0.5, children: /* @__PURE__ */ p(
                Q0,
                {
                  name: "study-start-date",
                  value: e.startDate,
                  maxDate: e.endDate ? ke(e.endDate) : null,
                  submitErrorMessage: "Start Date cannot be later than End Date",
                  disabled: a,
                  onSubmit: (m) => l("startDate", m),
                  label: "Start Date"
                }
              ) }),
              "-",
              /* @__PURE__ */ p(R, { item: !0, ml: 0.5, children: /* @__PURE__ */ p(
                Q0,
                {
                  name: "study-end-date",
                  value: e.endDate,
                  minDate: e.startDate ? ke(e.startDate) : null,
                  submitErrorMessage: "End Date cannot be earlier than Start Date",
                  disabled: a,
                  onSubmit: (m) => l("endDate", m),
                  label: "End Date"
                }
              ) })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ B(R, { item: !0, md: 6, xl: 3, children: [
        /* @__PURE__ */ p(fe, { variant: "subtitle1", component: "label", children: "Author" }),
        /* @__PURE__ */ B(fe, { variant: "body2", py: 0.5, children: [
          e.created.user.firstName,
          " ",
          e.created.user.lastName
        ] })
      ] })
    ] }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(Sa, { flexItem: !0, orientation: "horizontal", sx: { width: "100%" } }) }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
      /* @__PURE__ */ p(fe, { variant: "subtitle1", component: "label", children: "Study objective" }),
      /* @__PURE__ */ p(
        Kt,
        {
          name: "study-objective",
          value: e.description,
          onSubmit: (m) => l("description", m),
          color: i.palette.textColor.secondary,
          multiline: !0,
          fullWidth: !0,
          placeholder: a ? "..." : "Add study objective...",
          disabled: a,
          sx: {
            ml: -1,
            width: "calc(100% + 16px)"
          }
        }
      )
    ] }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(Sa, { flexItem: !0, orientation: "horizontal", sx: { width: "100%" } }) })
  ] });
}, bg = te.div`
  display: inline-block;
  width: 28px;
  min-width: 28px;
  height: 28px;
  padding: 5px;
  position: relative;
  text-align: center;
  border-radius: 50%;
  color: ${({ theme: e, color: t }) => e.palette.info.main};
  background-color: ${({ theme: e }) => Un(0.8, e.palette.info.main)};
  transition: 300ms;
  /* margin-left: 12px; */
  box-sizing: border-box;
  /* line-height: 32px; */
  /* cursor: pointer; */
  ::after {
    content: 'i';
    display: inline-block;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    padding: 1px;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    /* bottom: 1px; */
    position: absolute;
    top: 5px;
    left: 5px;
    border: 2px solid
      ${({ theme: e }) => e.palette.info.main};
  }
  /* :hover {
    background-color: ${({ theme: e }) => Un(0.6, e.palette.info.main)};
  } */
`, fQ = () => /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(
  R,
  {
    container: !0,
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    pb: 2,
    alignItems: "center",
    children: [
      /* @__PURE__ */ p(R, { item: !0, pr: 2, children: /* @__PURE__ */ p(bg, {}) }),
      /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(fe, { variant: "body2", children: "Your personal workspace is accessible by you only. Use it as a canvas to design and experiment with various assets to be shared and used in collaborative studies." }) })
    ]
  }
) }), Yz = ({
  iconName: e,
  title: t,
  onImport: n,
  onCreate: r,
  importButtonName: i,
  createButtonName: a,
  canImport: o,
  canCreate: s,
  count: c,
  customButtons: l
}) => /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
  R,
  {
    container: !0,
    mt: 2,
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    minHeight: 54,
    boxSizing: "border-box",
    children: /* @__PURE__ */ B(R, { item: !0, xs: 12, container: !0, spacing: 2, pb: 1.5, alignItems: "center", children: [
      /* @__PURE__ */ p(R, { item: !0, children: [
        "study",
        "workspace",
        "dataCatalog",
        "library",
        "admin",
        "vocabulary"
      ].includes(e) ? /* @__PURE__ */ p(
        yf,
        {
          iconName: `${e}`,
          sx: {
            width: "40px",
            height: "40px",
            color: "backgroundColor.icon"
          }
        }
      ) : /* @__PURE__ */ p(
        R,
        {
          item: !0,
          sx: (u) => ({
            backgroundColor: $i(
              0.8,
              u.palette.info.main
            ),
            borderRadius: "50%",
            padding: 1,
            width: 40,
            height: 40,
            color: "text.secondary"
          }),
          children: /* @__PURE__ */ p(pe, { iconName: "list" })
        }
      ) }),
      /* @__PURE__ */ B(R, { item: !0, flexGrow: 1, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ p(fe, { variant: "h1", children: t }),
        c != null && /* @__PURE__ */ p(
          he,
          {
            sx: (u) => ({
              backgroundColor: $i(
                0.9,
                u.palette.info.main
              ),
              borderRadius: "2px",
              color: u.palette.textColor.primary,
              fontSize: 12,
              p: "5px",
              display: "inline-flex",
              height: 23,
              boxSizing: "border-box",
              ml: 2
            }),
            children: c
          }
        )
      ] }),
      /* @__PURE__ */ B(R, { item: !0, children: [
        l,
        o && /* @__PURE__ */ p(
          Te,
          {
            onClick: n,
            variant: "outlined",
            color: "secondary",
            startIcon: /* @__PURE__ */ p(pe, { iconName: "import" }),
            className: "import-entity",
            children: i || "Import"
          }
        ),
        s && /* @__PURE__ */ p(
          Te,
          {
            onClick: r,
            variant: "contained",
            color: "info",
            startIcon: /* @__PURE__ */ p(pe, { iconName: "add" }),
            className: "create-entity",
            children: a || "Create"
          }
        )
      ] })
    ] })
  }
) }), Hw = ({
  iconName: e,
  title: t,
  titleExtra: n,
  onImport: r,
  onCreate: i,
  importButtonName: a,
  createButtonName: o,
  canImport: s,
  canCreate: c,
  customButtons: l,
  count: u,
  dense: d = !1
}) => /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
  R,
  {
    container: !0,
    mt: d ? 1 : 2,
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    minHeight: 44,
    boxSizing: "border-box",
    className: "secondary-header",
    children: /* @__PURE__ */ B(
      R,
      {
        item: !0,
        xs: 12,
        container: !0,
        spacing: 2,
        pb: d ? 1 : 1.5,
        alignItems: "center",
        children: [
          e && /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
            R,
            {
              item: !0,
              sx: (f) => ({
                backgroundColor: $i(0.8, f.palette.info.main),
                borderRadius: "50%",
                padding: 0.5,
                width: 30,
                height: 30,
                color: "text.secondary"
              }),
              children: /* @__PURE__ */ p(pe, { iconName: e, sx: { fontSize: 22 } })
            }
          ) }),
          /* @__PURE__ */ B(
            R,
            {
              item: !0,
              flexGrow: 1,
              alignContent: "center",
              display: "flex",
              alignItems: "center",
              children: [
                /* @__PURE__ */ p(
                  fe,
                  {
                    variant: d ? "h3" : "h2",
                    className: "secondary-header-title",
                    children: t
                  }
                ),
                n && /* @__PURE__ */ p(he, { ml: 2, display: "flex", alignItems: "center", children: n }),
                u != null && /* @__PURE__ */ p(
                  he,
                  {
                    sx: (f) => ({
                      backgroundColor: $i(0.9, f.palette.info.main),
                      borderRadius: "2px",
                      color: f.palette.textColor.primary,
                      fontSize: 12,
                      py: "5px",
                      px: "6px",
                      display: "inline-flex",
                      height: 23,
                      boxSizing: "border-box",
                      ml: 2
                    }),
                    children: u
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ B(R, { item: !0, className: "secondary-header-actions", children: [
            l,
            s && /* @__PURE__ */ p(
              Te,
              {
                onClick: r,
                variant: "outlined",
                color: "secondary",
                startIcon: /* @__PURE__ */ p(pe, { iconName: "import" }),
                name: "import",
                className: "import-" + e,
                children: a || "Import"
              }
            ),
            c && /* @__PURE__ */ p(
              Te,
              {
                onClick: i,
                variant: "contained",
                color: "info",
                startIcon: /* @__PURE__ */ p(pe, { iconName: "add" }),
                className: "create-" + e,
                name: "create",
                children: o || "Create"
              }
            )
          ] })
        ]
      }
    )
  }
) }), jz = ({
  iconName: e,
  title: t,
  onImport: n,
  onCreate: r,
  onGenerate: i,
  importButtonName: a,
  createButtonName: o,
  canImport: s,
  canCreate: c,
  canGenerate: l,
  customButtons: u,
  dense: d = !1
}) => /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
  R,
  {
    container: !0,
    mt: d ? 1 : 3,
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    minHeight: 44,
    boxSizing: "border-box",
    className: "secondary-header",
    children: /* @__PURE__ */ B(
      R,
      {
        item: !0,
        xs: 12,
        container: !0,
        spacing: 2,
        pb: d ? 1 : 1.5,
        alignItems: "center",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ B(
            R,
            {
              item: !0,
              flexGrow: 1,
              alignContent: "center",
              display: "flex",
              alignItems: "center",
              maxWidth: "70%",
              children: [
                /* @__PURE__ */ p(R, { item: !0, mr: 2, children: /* @__PURE__ */ p(bg, {}) }),
                /* @__PURE__ */ p(fe, { variant: "body2", className: "secondary-header-title", children: t })
              ]
            }
          ),
          /* @__PURE__ */ B(
            R,
            {
              item: !0,
              className: "secondary-header-actions",
              flexWrap: "nowrap",
              display: "flex",
              alignItems: "center",
              children: [
                u,
                l && c && /* @__PURE__ */ p(
                  Te,
                  {
                    onClick: i,
                    variant: "outlined",
                    startIcon: (
                      // not ideal, need to think about it later
                      /* @__PURE__ */ p(pe, { sx: { fontSize: "16px !important" }, iconName: "stars" })
                    ),
                    name: "stars",
                    sx: {
                      mr: 2,
                      whiteSpace: "nowrap"
                    },
                    className: "stars-" + e,
                    children: "Generate"
                  }
                ),
                s && /* @__PURE__ */ p(
                  Te,
                  {
                    onClick: n,
                    variant: "outlined",
                    startIcon: /* @__PURE__ */ p(pe, { iconName: "import" }),
                    name: "import",
                    sx: {
                      mr: 2,
                      whiteSpace: "nowrap"
                    },
                    className: "import-" + e,
                    children: a || "Import"
                  }
                ),
                c && /* @__PURE__ */ p(
                  Te,
                  {
                    onClick: r,
                    variant: "contained",
                    color: "info",
                    startIcon: /* @__PURE__ */ p(pe, { iconName: "add" }),
                    className: "create-" + e,
                    name: "create",
                    sx: {
                      whiteSpace: "nowrap"
                    },
                    children: o || "Create"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  }
) }), dQ = (e) => {
  var $n;
  const t = Tr(), n = Qi(), r = Rt(
    (rt) => rt.user.data
  ), {
    isImport: i,
    isCreate: a = !1,
    onImport: o,
    onCreate: s,
    onGenerate: c,
    onExport: l,
    moduleConfig: u,
    listConfig: d,
    allowDelete: f,
    isEnableMetadata: h,
    tileComponent: m,
    onRowClick: g,
    disableRowClick: v = !1,
    reloadId: _,
    isSilentReload: I,
    variant: M = "secondary",
    hiddenColumns: k,
    uniqName: y,
    dense: x,
    removeId: b,
    deleteSuccessMessage: A,
    exportFilteredResultsEnabled: w = !1,
    viewMode: O = !1,
    pinnedColumns: P = {
      left: ["icon", "typeIcon", "shortcut", "title", "name"],
      right: ["actions"]
    },
    renderRowActions: E
  } = e, { enqueueSnackbar: C } = Zr(), [T, D] = wA(), [z, F] = Xe.useState(!0), W = T.get("fullSearch");
  if (!u)
    return /* @__PURE__ */ p(Sf, { children: /* @__PURE__ */ p(yt, { size: 70 }) });
  const {
    addButtonTitle: L,
    tableTitle: S,
    moduleDescription: j,
    importButtonTitle: Y,
    getCols: N,
    loadingMessage: X,
    rowId: G,
    listInitialSort: q,
    createCrudMethod: $,
    createFiltersPanel: Q,
    createSortingMethod: V,
    metadataFilter: H,
    iconName: K,
    extendedSearchParam: U = "search-scope",
    extendedSearchEnabled: ee,
    extendedSearchOptions: ce = ["basic", "meta"]
  } = d, {
    rootSettings: { rootPath: se, rootTitle: ne },
    config: re,
    path: Me,
    name: Re,
    title: oe
  } = u, de = `${(re == null ? void 0 : re.typeContainer) || ""}${(re == null ? void 0 : re.parentId) || ""}${r.activeTenant}${y || ""}${Re}`, { data: ue } = yA(H, !1, !0), me = Xe.useMemo(() => zC(ue, !0).reduce(
    (rt, sn) => (BC(sn.header) || (rt[sn.id] = !1), rt),
    {}
  ), [ue]), Z = DL(de, {
    ...k,
    ...me
  }), { entityBreadcrumbs: le, columns: J } = RL, ae = Xe.useMemo(
    () => (S || "entity").toLocaleLowerCase().replace(" ", "-"),
    []
  ), ge = Xe.useMemo(() => $(re == null ? void 0 : re.typeContainer, re == null ? void 0 : re.parentId), [re == null ? void 0 : re.parentId]), be = Xe.useMemo(() => Q(re == null ? void 0 : re.typeContainer, re == null ? void 0 : re.parentId), [re == null ? void 0 : re.parentId]), we = Xe.useMemo(() => V(re == null ? void 0 : re.typeContainer), [re == null ? void 0 : re.parentId]), {
    data: { tableData: We, filtersData: ie },
    filters: ve,
    allowedSorting: _e,
    actions: Ie,
    pageCount: Pe,
    pageSize: Qe,
    getEntity: et,
    totalElements: _t,
    numberOfElements: tr,
    removeEntity: St,
    updateFilters: $t,
    setPageSize: dn,
    status: mt,
    error: Bn
  } = xA(
    {
      get: ge.fetch,
      remove: ge.remove,
      getFilters: be.getFilters,
      getSorting: we
    },
    _,
    I,
    {
      ...Z.storage,
      // we can probably set this params as default in requests??
      filters: {
        ...ee ? { [U]: ce } : {},
        ...Z.storage.filters
      }
    }
  ), { otherFilters: Dt, searchFilter: Pt } = eA(ie), Ei = Dt.length > 0, Fn = ($n = Pt == null ? void 0 : Pt.options) == null ? void 0 : $n.map((rt) => rt.value), Wa = Xe.useMemo(() => JSON.stringify(ve), [ve]);
  Xe.useEffect(() => {
    n(
      kE(
        le({
          title: oe,
          path: Me,
          rootPath: se,
          rootTitle: ne,
          parentTitle: re == null ? void 0 : re.parentTitle,
          parentId: re == null ? void 0 : re.parentId
        })
      )
    );
  }, []), Xe.useEffect(() => {
    W && $t({ "filter.search": [W || ""] }), F(!1);
  }, [W]), Xe.useEffect(() => {
    mt === Ce.SUCCESS && (re != null && re.typeContainer) && [Ae.STUDY, Ae.WORKSPACE].some(
      (rt) => rt === re.typeContainer
    ) && n(TE(re.typeContainer, re.parentId));
  }, [mt, re == null ? void 0 : re.typeContainer, re == null ? void 0 : re.parentId]);
  const qo = {
    [Ae.LIBRARY]: "Library",
    [Ae.STUDY]: "Studies",
    [Ae.WORKSPACE]: "Workspace"
  };
  Xe.useEffect(() => {
    document.title = `Prometheus ${re != null && re.typeContainer ? "- " + qo[re.typeContainer] : ""} - ${S}`;
  }, [re == null ? void 0 : re.typeContainer]);
  const Be = (rt) => {
    g ? g(rt) : t(`${rt.original[G]}`);
  }, nn = Xe.useCallback(
    async (rt) => {
      const sn = await St(rt == null ? void 0 : rt[b || "id"]);
      sn && A && C({
        message: A(rt),
        variant: "success"
      }), sn === !1 && A && C({
        message: "Unable to delete item.",
        variant: "error"
      });
    },
    [A, C, St, b]
  ), Ha = Object.entries(ve).some(
    ([rt, sn]) => rt !== "search-scope" && (sn == null ? void 0 : sn.length) > 0
  ), Jl = ee ? {
    extendedSearchEnabled: ee,
    extendedSearchValue: Qs(
      ve[U],
      Fn
    ),
    toggleExtendedSearch: (rt = !1, sn) => {
      bd({
        [U]: rt ? Fn : ce,
        [Pt == null ? void 0 : Pt.name]: sn
      });
    }
  } : {}, na = typeof E == "function", Ua = {
    header: "",
    accessorKey: "actions",
    enableSorting: !1,
    enableResizing: !1,
    enableHiding: !1,
    // Wider when it also hosts extra row actions so both buttons sit together.
    size: na ? 90 : 42,
    maxSize: na ? 90 : 42,
    meta: {
      columnType: "action"
    },
    cell: (rt) => {
      const sn = Xe.useMemo(
        () => Bc(rt.row.original.actions),
        [rt.row.original.actions]
      ), ki = !!((re == null ? void 0 : re.typeContainer) !== Ae.STUDY || sn[Fc.UPDATE]);
      return /* @__PURE__ */ p(ze, { children: ki ? /* @__PURE__ */ p(
        CL,
        {
          onRemove: f ? () => nn(rt.row.original) : null,
          withConfirmation: !0,
          entityName: rt.row.original.title || rt.row.original.name,
          children: E == null ? void 0 : E(rt.row.original)
        }
      ) : /* @__PURE__ */ p(ze, {}) });
    }
  }, Kl = Xe.useMemo(
    () => [
      ...FC(
        (d == null ? void 0 : d.cols) || (N == null ? void 0 : N({ metaAttributes: ue })) || J,
        _e
      ),
      ...f || na ? [Ua] : []
    ],
    [_e, ue, nn, E]
  ), mr = Xe.useMemo(
    () => !O && (Bc(Ie)[Fc.CREATE] || a),
    [Ie, O]
  ), Ga = Xe.useMemo(
    () => !O && (Bc(Ie)[Fc.IMPORT] || !1),
    [Ie, O]
  ), Zl = (rt, sn) => {
    const ki = { [rt]: sn };
    $t(ki), Z == null || Z.setStorage("filters", {
      ...ve,
      ...ki
    });
  }, bd = (rt) => {
    $t(rt), Z == null || Z.setStorage("filters", {
      ...ve,
      ...rt
    });
  }, Xo = () => {
    l(ve);
  };
  if (mt === Ce.ERROR)
    return /* @__PURE__ */ p(R, { container: !0, p: 6, children: /* @__PURE__ */ p(KU, { ...Bn.response, noAction: !0 }) });
  const ra = /* @__PURE__ */ p(
    Te,
    {
      onClick: Xo,
      variant: "outlined",
      color: "primary",
      size: "small",
      startIcon: /* @__PURE__ */ p(pe, { iconName: "export" }),
      children: "Export"
    }
  );
  return /* @__PURE__ */ B(
    R,
    {
      container: !0,
      px: x ? 0 : 6,
      flexDirection: "column",
      sx: { backgroundColor: "common.white", flexGrow: 1 },
      minHeight: "100%",
      children: [
        M !== "no-header" && /* @__PURE__ */ B(ze, { children: [
          M === "primary" && /* @__PURE__ */ p(
            Yz,
            {
              iconName: K,
              title: S,
              canImport: i && Ga,
              canCreate: s && mr,
              importButtonName: Y,
              createButtonName: L,
              onCreate: s,
              onImport: o,
              count: _t,
              customButtons: w && ra
            }
          ),
          M === "secondary" && /* @__PURE__ */ p(
            Hw,
            {
              title: S,
              canImport: i && Ga,
              canCreate: s && mr,
              importButtonName: Y,
              createButtonName: L,
              onCreate: s,
              onImport: o,
              count: _t,
              customButtons: w && ra
            }
          ),
          M === "description" && /* @__PURE__ */ p(
            jz,
            {
              title: j,
              canImport: i && Ga,
              canCreate: s && mr,
              canGenerate: !!c,
              importButtonName: Y,
              createButtonName: L,
              onCreate: s,
              onImport: o,
              onGenerate: c,
              customButtons: w && ra
            }
          )
        ] }),
        /* @__PURE__ */ p(R, { container: !0, className: "table-" + ae, my: 2, children: /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(R, { container: !0, flexWrap: "nowrap", children: /* @__PURE__ */ p(
          R,
          {
            item: !0,
            maxWidth: "100%",
            flexGrow: 1,
            sx: { overflowX: "auto" },
            className: "table-data-" + ae,
            children: !z && /* @__PURE__ */ p(
              ha,
              {
                showFilterToggle: Ei,
                variant: "controlled",
                noDataText: Ha ? "The result listing is empty because of the filter you applied" : d.noDataMessage || "No data currently available",
                data: We,
                columns: Kl,
                pageCount: Pe,
                pageSize: Qe,
                resetPaginationKey: Wa,
                persistSettings: Z == null ? void 0 : Z.setStorage,
                loading: I ? mt === Ce.IN_PROGRESS : mt === Ce.IN_PROGRESS || mt === Ce.IN_PROGRESS_RELOAD,
                isInitial: mt === Ce.INITIAL,
                loadingMessage: X,
                onRowClick: v ? void 0 : Be,
                fetchData: et,
                totalElements: _t,
                defaultSorting: (Z == null ? void 0 : Z.storage.sort) || q,
                columnVisibility: Z == null ? void 0 : Z.storage.columns,
                pinnedColumns: P,
                hasFilters: Ha,
                searchComponent: Pt && /* @__PURE__ */ p(
                  pA,
                  {
                    ...Pt,
                    value: ve == null ? void 0 : ve[Pt == null ? void 0 : Pt.name],
                    onChange: (rt) => Zl(Pt == null ? void 0 : Pt.name, rt),
                    ...Jl
                  }
                ),
                children: Ei && /* @__PURE__ */ p(
                  ym,
                  {
                    showLabel: !0,
                    filters: Dt,
                    value: ve,
                    onChange: Zl,
                    isLoading: mt === Ce.IN_PROGRESS,
                    isReloading: mt === Ce.IN_PROGRESS_RELOAD
                  }
                )
              }
            )
          }
        ) }) }) })
      ]
    }
  );
}, Wz = te(Fr)`
  .collapsible-content-block__title {
    line-height: 30px;
    padding: 0 10px;
    /* height: 40px; */
    .collapsible-content-block__title-text {
      font-size: 14px;
      line-height: 24px;
    }
  }
  .collapsible-block__content-container {
    padding: 10px;
  }
`, hQ = (e) => {
  const {
    item: t,
    updateSection: n,
    onCancelSectionName: r,
    copySection: i,
    removeSection: a,
    exportSection: o,
    children: s,
    viewMode: c,
    index: l,
    defaultState: u = !1,
    isExport: d,
    nameError: f,
    titleMeta: h,
    hideBody: m = !1,
    bodyViewMode: g = !1,
    disableNameEdit: v = !1,
    titleAddon: _,
    onEdit: I,
    hideCopyAction: M = !1,
    hideEditAction: k = !1
  } = e, y = m || v, x = c || g, b = !!t.description || !x;
  return /* @__PURE__ */ p(
    Wz,
    {
      collapsible: !m,
      defaultState: u,
      className: "section-block-" + l,
      outlined: !0,
      size: "dense",
      title: /* @__PURE__ */ B(
        R,
        {
          item: !0,
          className: "section-block-title",
          display: "flex",
          alignItems: "center",
          minHeight: "36px",
          children: [
            l + 1,
            ".",
            " ",
            /* @__PURE__ */ B(
              he,
              {
                minWidth: y ? "auto" : "50%",
                maxWidth: y ? "fit-content" : void 0,
                ml: 0.5,
                pt: f ? "5px" : 0,
                sx: {
                  ".input-root": {
                    border: "1px solid",
                    borderColor: f ? "error.main" : "transparent"
                  },
                  ".editable-component-actions": {
                    right: "-74px",
                    left: "auto",
                    top: "16px",
                    bottom: "auto",
                    transform: "translateY(-50%)"
                  }
                },
                children: [
                  y ? /* @__PURE__ */ p(
                    fe,
                    {
                      component: "span",
                      sx: {
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        color: "textColor.secondary",
                        whiteSpace: "nowrap"
                      },
                      children: t.name
                    }
                  ) : /* @__PURE__ */ p(
                    Kt,
                    {
                      value: t.name,
                      fullWidth: !0,
                      onCancel: () => {
                        r == null || r(l);
                      },
                      onSubmit: (A) => n(l, "name", A),
                      placeholder: "Enter name...",
                      disabled: c || v,
                      color: "primary",
                      submitOnClickOutside: !0,
                      activateOnClick: !0,
                      showActions: !1
                    }
                  ),
                  f && /* @__PURE__ */ p(fe, { color: "error.main", variant: "caption", display: "block", children: f })
                ]
              }
            ),
            h,
            _ && /* @__PURE__ */ p(
              he,
              {
                display: "inline-flex",
                alignItems: "center",
                ml: m ? "20px" : 1.5,
                children: _
              }
            )
          ]
        }
      ),
      actions: c ? /* @__PURE__ */ p(ze, {}) : /* @__PURE__ */ B(
        he,
        {
          minHeight: 30,
          py: 0.5,
          className: "section-block-actions",
          display: "flex",
          children: [
            I && !k && /* @__PURE__ */ p(he, { pr: 1, display: "inline-flex", children: /* @__PURE__ */ p(
              qe,
              {
                onClick: (A) => {
                  A.stopPropagation(), I == null || I(t, l);
                },
                name: "editItem",
                noExpand: !0,
                iconName: "edit",
                color: "primary"
              }
            ) }),
            d && /* @__PURE__ */ p(he, { pr: 1, display: "inline-flex", children: /* @__PURE__ */ p(
              qe,
              {
                onClick: (A) => {
                  A.stopPropagation(), o(l, t.name);
                },
                name: "exportItem",
                noExpand: !0,
                iconName: "export",
                color: "primary"
              }
            ) }),
            !M && /* @__PURE__ */ p(he, { pr: 1, display: "inline-flex", children: /* @__PURE__ */ p(
              qe,
              {
                onClick: (A) => {
                  A.stopPropagation(), i(l);
                },
                name: "copyItem",
                noExpand: !0,
                iconName: "copy",
                color: "primary"
              }
            ) }),
            /* @__PURE__ */ p(he, { display: "inline-flex", children: /* @__PURE__ */ p(
              qe,
              {
                onClick: (A) => {
                  A.stopPropagation(), a(l);
                },
                name: "deleteItem",
                color: "error",
                iconName: "delete",
                noExpand: !0
              }
            ) })
          ]
        }
      ),
      children: !m && /* @__PURE__ */ B(R, { container: !0, spacing: x && !t.description ? 0 : 1, children: [
        b && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: x ? /* @__PURE__ */ p(
          fe,
          {
            sx: {
              color: "textColor.secondary",
              fontSize: 14,
              lineHeight: "20px",
              whiteSpace: "pre-wrap"
            },
            children: t.description
          }
        ) : /* @__PURE__ */ p(
          Kt,
          {
            type: "text",
            value: t.description,
            placeholder: "Enter description...",
            size: "small",
            name: "description",
            fullWidth: !0,
            id: t.uuid + "description",
            onCancel: () => {
            },
            onSubmit: (A) => n(l, "description", A),
            disabled: c || g,
            color: "primary",
            submitOnClickOutside: !0,
            showActions: !1
          }
        ) }),
        /* @__PURE__ */ p(R, { item: !0, xs: 12, children: s })
      ] })
    },
    t.uuid
  );
}, Hz = (e) => {
  const { getCurrentVersion: t, currentViewVersion: n } = e;
  return n ? /* @__PURE__ */ p(ze, { children: "Viewing now" }) : /* @__PURE__ */ p(
    Te,
    {
      onClick: t,
      size: "small",
      color: "primary",
      variant: "outlined",
      children: "Preview"
    }
  );
}, Uz = {
  createCols: (e, t) => [
    {
      Header: "Version",
      accessor: "versionNumber",
      id: "version",
      maxWidth: 50,
      isCropped: !0
    },
    {
      Header: "Author",
      accessor: "author",
      id: "author"
    },
    {
      Header: "Created",
      accessor: "timestamp",
      id: "timestamp",
      Cell: ji,
      isCropped: !0,
      minWidth: 140,
      maxWidth: 140
    },
    {
      Header: "Preview",
      accessor: "preview",
      width: "5%",
      minWidth: 82,
      Cell: ({ value: n }) => /* @__PURE__ */ p(ze, { children: n && /* @__PURE__ */ p(
        Hz,
        {
          currentViewVersion: t === n,
          getCurrentVersion: () => e(n)
        }
      ) })
    }
  ]
}, Gz = en((e) => {
  const { onClose: t } = e, [n, r] = Se();
  return /* @__PURE__ */ p(R, { container: !0, p: 2, children: /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ B(R, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: "message", textLabel: "Comment", children: /* @__PURE__ */ p(
      _r,
      {
        type: "text",
        value: n || "",
        minRows: 2,
        maxRows: 4,
        multiline: !0,
        size: "medium",
        onChange: (a) => r(a.target.value),
        fullWidth: !0,
        name: "message"
      }
    ) }) }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, textAlign: "right", children: [
      /* @__PURE__ */ p(
        Te,
        {
          variant: "outlined",
          onClick: t,
          startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Te,
        {
          onClick: async () => {
          },
          variant: "contained",
          color: "success",
          name: "save",
          sx: { ml: 1 },
          startIcon: /* @__PURE__ */ p(pe, { iconName: "submit" }),
          children: "Save"
        }
      )
    ] })
  ] }) }) });
}), pQ = (e) => {
  const t = Tr(), { openModal: n, closeModal: r } = zo(bm), {
    data: i,
    setPreviewEntity: a,
    path: o,
    makeCopy: s,
    apiMethods: c,
    originVersionId: l
  } = e, { createCols: u } = Uz, d = i.revertVersionId || i.versionId, {
    isStartHook: f,
    versions: h,
    currentVersion: m,
    isLoading: g,
    getCurrentVersion: v,
    copyVersion: _,
    totalElements: I
  } = hE(
    i.id,
    i.versionId,
    c.getList,
    c.getCurrent,
    s,
    l
  ), M = () => {
    n(() => /* @__PURE__ */ p(Gz, { onClose: r }), "Add comment", {
      closeOnClickOutside: !0,
      width: "700px",
      onClose: r
    });
  }, k = Ee(() => u(
    v,
    d,
    _,
    l,
    M
  ), [v, d, _, l]);
  return He(() => {
    m && (a(m), t(`/${o}/${i.id}`));
  }, [m]), /* @__PURE__ */ p(Fr, { outlined: !0, elevated: !0, children: /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    Ml,
    {
      columns: k,
      data: h,
      isLoading: g || !f,
      loadingMessage: "",
      totalElements: I,
      enableSorting: !0,
      enablePagination: !0,
      showColumnToggle: !0
    }
  ) }) });
}, mQ = (e) => {
  const { makeCopy: t } = e;
  return /* @__PURE__ */ p(Te, { onClick: t, size: "small", color: "primary", variant: "outlined", children: "Make a copy" });
}, Vz = te(R, {
  shouldForwardProp: (e) => e !== "width"
})`
  &.visible {
    transition: 0.5s;
    bottom: 0;
  }
  transition-delay: 0.5s;
  transition: 0.5s;
  bottom: -54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  position: fixed;
  z-index: 3;
  right: 0;
  background-color: #fff;
  min-height: 54px;
  height: auto;
  /* opacity: 0.85; */
  box-shadow: ${({ theme: e }) => e.customShadows[0]};
  width: ${(e) => e.width ? e.width : "75vw"};
  ${(e) => [e.theme.breakpoints.down("md")] + ` {
    width: 100%;
  }`}
`, Qz = te.div`
  font-size: 12px;
`, qz = (e) => {
  const {
    selectedConceptsCount: t,
    buttonText: n,
    onAdd: r,
    onClear: i,
    width: a,
    className: o = "",
    disabled: s,
    startContent: c,
    buttonStartIcon: l
  } = e;
  return /* @__PURE__ */ B(
    Vz,
    {
      item: !0,
      xs: 12,
      px: 2,
      py: 1,
      className: (t > 0 && "visible " || " ") + o,
      width: a || "100%",
      children: [
        /* @__PURE__ */ p(R, { item: !0, display: "flex", alignItems: "center", minWidth: 0, children: c }),
        /* @__PURE__ */ B(R, { item: !0, display: "flex", alignItems: "center", columnGap: 1.5, children: [
          /* @__PURE__ */ B(Qz, { children: [
            "Selected items: ",
            t
          ] }),
          /* @__PURE__ */ p(
            Te,
            {
              variant: "text",
              sx: {
                textDecoration: "underline",
                "&.MuiButton-root": { fontSize: 12, fontWeight: 400 }
              },
              onClick: i,
              startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
              disabled: t < 1,
              children: "Clear all selected"
            }
          ),
          /* @__PURE__ */ p(
            Te,
            {
              onClick: r,
              disabled: t < 1 || s,
              name: "add-to-concept-set",
              variant: "contained",
              color: "success",
              startIcon: l === void 0 ? /* @__PURE__ */ p(
                pe,
                {
                  iconName: "add",
                  className: "icon-button",
                  sx: { fontSize: 16 }
                }
              ) : l,
              children: /* @__PURE__ */ p("span", { children: n || "Add" })
            }
          )
        ] })
      ]
    }
  );
};
var Uw = { exports: {} }, Xz = "4.13.0";
function Ba(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function wg(e) {
  return e.length === 1 && (e = Jz(e)), {
    left: function(t, n, r, i) {
      for (r == null && (r = 0), i == null && (i = t.length); r < i; ) {
        var a = r + i >>> 1;
        e(t[a], n) < 0 ? r = a + 1 : i = a;
      }
      return r;
    },
    right: function(t, n, r, i) {
      for (r == null && (r = 0), i == null && (i = t.length); r < i; ) {
        var a = r + i >>> 1;
        e(t[a], n) > 0 ? i = a : r = a + 1;
      }
      return r;
    }
  };
}
function Jz(e) {
  return function(t, n) {
    return Ba(e(t), n);
  };
}
var Gw = wg(Ba), Ea = Gw.right, Kz = Gw.left;
function Zz(e, t) {
  t == null && (t = Vw);
  for (var n = 0, r = e.length - 1, i = e[0], a = new Array(r < 0 ? 0 : r); n < r; ) a[n] = t(i, i = e[++n]);
  return a;
}
function Vw(e, t) {
  return [e, t];
}
function e6(e, t, n) {
  var r = e.length, i = t.length, a = new Array(r * i), o, s, c, l;
  for (n == null && (n = Vw), o = c = 0; o < r; ++o)
    for (l = e[o], s = 0; s < i; ++s, ++c)
      a[c] = n(l, t[s]);
  return a;
}
function t6(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Wi(e) {
  return e === null ? NaN : +e;
}
function Qw(e, t) {
  var n = e.length, r = 0, i = -1, a = 0, o, s, c = 0;
  if (t == null)
    for (; ++i < n; )
      isNaN(o = Wi(e[i])) || (s = o - a, a += s / ++r, c += s * (o - a));
  else
    for (; ++i < n; )
      isNaN(o = Wi(t(e[i], i, e))) || (s = o - a, a += s / ++r, c += s * (o - a));
  if (r > 1) return c / (r - 1);
}
function qw(e, t) {
  var n = Qw(e, t);
  return n && Math.sqrt(n);
}
function Xw(e, t) {
  var n = e.length, r = -1, i, a, o;
  if (t == null) {
    for (; ++r < n; )
      if ((i = e[r]) != null && i >= i)
        for (a = o = i; ++r < n; )
          (i = e[r]) != null && (a > i && (a = i), o < i && (o = i));
  } else
    for (; ++r < n; )
      if ((i = t(e[r], r, e)) != null && i >= i)
        for (a = o = i; ++r < n; )
          (i = t(e[r], r, e)) != null && (a > i && (a = i), o < i && (o = i));
  return [a, o];
}
var Jw = Array.prototype, n6 = Jw.slice, r6 = Jw.map;
function gc(e) {
  return function() {
    return e;
  };
}
function i6(e) {
  return e;
}
function Ar(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = e + r * n;
  return a;
}
var vp = Math.sqrt(50), Ap = Math.sqrt(10), bp = Math.sqrt(2);
function _g(e, t, n) {
  var r, i = -1, a, o, s;
  if (t = +t, e = +e, n = +n, e === t && n > 0) return [e];
  if ((r = t < e) && (a = e, e = t, t = a), (s = js(e, t, n)) === 0 || !isFinite(s)) return [];
  if (s > 0)
    for (e = Math.ceil(e / s), t = Math.floor(t / s), o = new Array(a = Math.ceil(t - e + 1)); ++i < a; ) o[i] = (e + i) * s;
  else
    for (e = Math.floor(e * s), t = Math.ceil(t * s), o = new Array(a = Math.ceil(e - t + 1)); ++i < a; ) o[i] = (e - i) / s;
  return r && o.reverse(), o;
}
function js(e, t, n) {
  var r = (t - e) / Math.max(0, n), i = Math.floor(Math.log(r) / Math.LN10), a = r / Math.pow(10, i);
  return i >= 0 ? (a >= vp ? 10 : a >= Ap ? 5 : a >= bp ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= vp ? 10 : a >= Ap ? 5 : a >= bp ? 2 : 1);
}
function al(e, t, n) {
  var r = Math.abs(t - e) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), a = r / i;
  return a >= vp ? i *= 10 : a >= Ap ? i *= 5 : a >= bp && (i *= 2), t < e ? -i : i;
}
function Kw(e) {
  return Math.ceil(Math.log(e.length) / Math.LN2) + 1;
}
function a6() {
  var e = i6, t = Xw, n = Kw;
  function r(i) {
    var a, o = i.length, s, c = new Array(o);
    for (a = 0; a < o; ++a)
      c[a] = e(i[a], a, i);
    var l = t(c), u = l[0], d = l[1], f = n(c, u, d);
    Array.isArray(f) || (f = al(u, d, f), f = Ar(Math.ceil(u / f) * f, Math.floor(d / f) * f, f));
    for (var h = f.length; f[0] <= u; ) f.shift(), --h;
    for (; f[h - 1] > d; ) f.pop(), --h;
    var m = new Array(h + 1), g;
    for (a = 0; a <= h; ++a)
      g = m[a] = [], g.x0 = a > 0 ? f[a - 1] : u, g.x1 = a < h ? f[a] : d;
    for (a = 0; a < o; ++a)
      s = c[a], u <= s && s <= d && m[Ea(f, s, 0, h)].push(i[a]);
    return m;
  }
  return r.value = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : gc(i), r) : e;
  }, r.domain = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : gc([i[0], i[1]]), r) : t;
  }, r.thresholds = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : Array.isArray(i) ? gc(n6.call(i)) : gc(i), r) : n;
  }, r;
}
function ol(e, t, n) {
  if (n == null && (n = Wi), !!(r = e.length)) {
    if ((t = +t) <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, a = Math.floor(i), o = +n(e[a], a, e), s = +n(e[a + 1], a + 1, e);
    return o + (s - o) * (i - a);
  }
}
function o6(e, t, n) {
  return e = r6.call(e, Wi).sort(Ba), Math.ceil((n - t) / (2 * (ol(e, 0.75) - ol(e, 0.25)) * Math.pow(e.length, -1 / 3)));
}
function s6(e, t, n) {
  return Math.ceil((n - t) / (3.5 * qw(e) * Math.pow(e.length, -1 / 3)));
}
function l6(e, t) {
  var n = e.length, r = -1, i, a;
  if (t == null) {
    for (; ++r < n; )
      if ((i = e[r]) != null && i >= i)
        for (a = i; ++r < n; )
          (i = e[r]) != null && i > a && (a = i);
  } else
    for (; ++r < n; )
      if ((i = t(e[r], r, e)) != null && i >= i)
        for (a = i; ++r < n; )
          (i = t(e[r], r, e)) != null && i > a && (a = i);
  return a;
}
function c6(e, t) {
  var n = e.length, r = n, i = -1, a, o = 0;
  if (t == null)
    for (; ++i < n; )
      isNaN(a = Wi(e[i])) ? --r : o += a;
  else
    for (; ++i < n; )
      isNaN(a = Wi(t(e[i], i, e))) ? --r : o += a;
  if (r) return o / r;
}
function u6(e, t) {
  var n = e.length, r = -1, i, a = [];
  if (t == null)
    for (; ++r < n; )
      isNaN(i = Wi(e[r])) || a.push(i);
  else
    for (; ++r < n; )
      isNaN(i = Wi(t(e[r], r, e))) || a.push(i);
  return ol(a.sort(Ba), 0.5);
}
function Sg(e) {
  for (var t = e.length, n, r = -1, i = 0, a, o; ++r < t; ) i += e[r].length;
  for (a = new Array(i); --t >= 0; )
    for (o = e[t], n = o.length; --n >= 0; )
      a[--i] = o[n];
  return a;
}
function Zw(e, t) {
  var n = e.length, r = -1, i, a;
  if (t == null) {
    for (; ++r < n; )
      if ((i = e[r]) != null && i >= i)
        for (a = i; ++r < n; )
          (i = e[r]) != null && a > i && (a = i);
  } else
    for (; ++r < n; )
      if ((i = t(e[r], r, e)) != null && i >= i)
        for (a = i; ++r < n; )
          (i = t(e[r], r, e)) != null && a > i && (a = i);
  return a;
}
function f6(e, t) {
  for (var n = t.length, r = new Array(n); n--; ) r[n] = e[t[n]];
  return r;
}
function d6(e, t) {
  if (n = e.length) {
    var n, r = 0, i = 0, a, o = e[i];
    for (t == null && (t = Ba); ++r < n; )
      (t(a = e[r], o) < 0 || t(o, o) !== 0) && (o = a, i = r);
    if (t(o, o) === 0) return i;
  }
}
function h6(e, t, n) {
  for (var r = (n ?? e.length) - (t = t == null ? 0 : +t), i, a; r; )
    a = Math.random() * r-- | 0, i = e[r + t], e[r + t] = e[a + t], e[a + t] = i;
  return e;
}
function p6(e, t) {
  var n = e.length, r = -1, i, a = 0;
  if (t == null)
    for (; ++r < n; )
      (i = +e[r]) && (a += i);
  else
    for (; ++r < n; )
      (i = +t(e[r], r, e)) && (a += i);
  return a;
}
function e_(e) {
  if (!(a = e.length)) return [];
  for (var t = -1, n = Zw(e, m6), r = new Array(n); ++t < n; )
    for (var i = -1, a, o = r[t] = new Array(a); ++i < a; )
      o[i] = e[i][t];
  return r;
}
function m6(e) {
  return e.length;
}
function g6() {
  return e_(arguments);
}
var Xd = Array.prototype.slice;
function y6(e) {
  return e;
}
var Jc = 1, Kc = 2, wp = 3, vs = 4, W1 = 1e-6;
function x6(e) {
  return "translate(" + (e + 0.5) + ",0)";
}
function v6(e) {
  return "translate(0," + (e + 0.5) + ")";
}
function A6(e) {
  return function(t) {
    return +e(t);
  };
}
function b6(e) {
  var t = Math.max(0, e.bandwidth() - 1) / 2;
  return e.round() && (t = Math.round(t)), function(n) {
    return +e(n) + t;
  };
}
function w6() {
  return !this.__axis;
}
function Uf(e, t) {
  var n = [], r = null, i = null, a = 6, o = 6, s = 3, c = e === Jc || e === vs ? -1 : 1, l = e === vs || e === Kc ? "x" : "y", u = e === Jc || e === wp ? x6 : v6;
  function d(f) {
    var h = r ?? (t.ticks ? t.ticks.apply(t, n) : t.domain()), m = i ?? (t.tickFormat ? t.tickFormat.apply(t, n) : y6), g = Math.max(a, 0) + s, v = t.range(), _ = +v[0] + 0.5, I = +v[v.length - 1] + 0.5, M = (t.bandwidth ? b6 : A6)(t.copy()), k = f.selection ? f.selection() : f, y = k.selectAll(".domain").data([null]), x = k.selectAll(".tick").data(h, t).order(), b = x.exit(), A = x.enter().append("g").attr("class", "tick"), w = x.select("line"), O = x.select("text");
    y = y.merge(y.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000")), x = x.merge(A), w = w.merge(A.append("line").attr("stroke", "#000").attr(l + "2", c * a)), O = O.merge(A.append("text").attr("fill", "#000").attr(l, c * g).attr("dy", e === Jc ? "0em" : e === wp ? "0.71em" : "0.32em")), f !== k && (y = y.transition(f), x = x.transition(f), w = w.transition(f), O = O.transition(f), b = b.transition(f).attr("opacity", W1).attr("transform", function(P) {
      return isFinite(P = M(P)) ? u(P) : this.getAttribute("transform");
    }), A.attr("opacity", W1).attr("transform", function(P) {
      var E = this.parentNode.__axis;
      return u(E && isFinite(E = E(P)) ? E : M(P));
    })), b.remove(), y.attr("d", e === vs || e == Kc ? "M" + c * o + "," + _ + "H0.5V" + I + "H" + c * o : "M" + _ + "," + c * o + "V0.5H" + I + "V" + c * o), x.attr("opacity", 1).attr("transform", function(P) {
      return u(M(P));
    }), w.attr(l + "2", c * a), O.attr(l, c * g).text(m), k.filter(w6).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", e === Kc ? "start" : e === vs ? "end" : "middle"), k.each(function() {
      this.__axis = M;
    });
  }
  return d.scale = function(f) {
    return arguments.length ? (t = f, d) : t;
  }, d.ticks = function() {
    return n = Xd.call(arguments), d;
  }, d.tickArguments = function(f) {
    return arguments.length ? (n = f == null ? [] : Xd.call(f), d) : n.slice();
  }, d.tickValues = function(f) {
    return arguments.length ? (r = f == null ? null : Xd.call(f), d) : r && r.slice();
  }, d.tickFormat = function(f) {
    return arguments.length ? (i = f, d) : i;
  }, d.tickSize = function(f) {
    return arguments.length ? (a = o = +f, d) : a;
  }, d.tickSizeInner = function(f) {
    return arguments.length ? (a = +f, d) : a;
  }, d.tickSizeOuter = function(f) {
    return arguments.length ? (o = +f, d) : o;
  }, d.tickPadding = function(f) {
    return arguments.length ? (s = +f, d) : s;
  }, d;
}
function _6(e) {
  return Uf(Jc, e);
}
function S6(e) {
  return Uf(Kc, e);
}
function t_(e) {
  return Uf(wp, e);
}
function C6(e) {
  return Uf(vs, e);
}
var E6 = { value: function() {
} };
function Ji() {
  for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
    if (!(r = arguments[e] + "") || r in n) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new Zc(n);
}
function Zc(e) {
  this._ = e;
}
function k6(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !t.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
Zc.prototype = Ji.prototype = {
  constructor: Zc,
  on: function(e, t) {
    var n = this._, r = k6(e + "", n), i, a = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++a < o; ) if ((i = (e = r[a]).type) && (i = T6(n[i], e.name))) return i;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++a < o; )
      if (i = (e = r[a]).type) n[i] = H1(n[i], e.name, t);
      else if (t == null) for (i in n) n[i] = H1(n[i], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t) e[n] = t[n].slice();
    return new Zc(e);
  },
  call: function(e, t) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, a; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (a = this._[e], r = 0, i = a.length; r < i; ++r) a[r].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var r = this._[e], i = 0, a = r.length; i < a; ++i) r[i].value.apply(t, n);
  }
};
function T6(e, t) {
  for (var n = 0, r = e.length, i; n < r; ++n)
    if ((i = e[n]).name === t)
      return i.value;
}
function H1(e, t, n) {
  for (var r = 0, i = e.length; r < i; ++r)
    if (e[r].name === t) {
      e[r] = E6, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var _p = "http://www.w3.org/1999/xhtml";
const Sp = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: _p,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function $l(e) {
  var t = e += "", n = t.indexOf(":");
  return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), Sp.hasOwnProperty(t) ? { space: Sp[t], local: e } : e;
}
function M6(e) {
  return function() {
    var t = this.ownerDocument, n = this.namespaceURI;
    return n === _p && t.documentElement.namespaceURI === _p ? t.createElement(e) : t.createElementNS(n, e);
  };
}
function I6(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function Gf(e) {
  var t = $l(e);
  return (t.local ? I6 : M6)(t);
}
function N6() {
}
function Vf(e) {
  return e == null ? N6 : function() {
    return this.querySelector(e);
  };
}
function O6(e) {
  typeof e != "function" && (e = Vf(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, s = r[i] = new Array(o), c, l, u = 0; u < o; ++u)
      (c = a[u]) && (l = e.call(c, c.__data__, u, a)) && ("__data__" in c && (l.__data__ = c.__data__), s[u] = l);
  return new Mn(r, this._parents);
}
function R6() {
  return [];
}
function Cg(e) {
  return e == null ? R6 : function() {
    return this.querySelectorAll(e);
  };
}
function D6(e) {
  typeof e != "function" && (e = Cg(e));
  for (var t = this._groups, n = t.length, r = [], i = [], a = 0; a < n; ++a)
    for (var o = t[a], s = o.length, c, l = 0; l < s; ++l)
      (c = o[l]) && (r.push(e.call(c, c.__data__, l, o)), i.push(c));
  return new Mn(r, i);
}
var n_ = function(e) {
  return function() {
    return this.matches(e);
  };
};
if (typeof document < "u") {
  var ss = document.documentElement;
  if (!ss.matches) {
    var P6 = ss.webkitMatchesSelector || ss.msMatchesSelector || ss.mozMatchesSelector || ss.oMatchesSelector;
    n_ = function(e) {
      return function() {
        return P6.call(this, e);
      };
    };
  }
}
const Eg = n_;
function L6(e) {
  typeof e != "function" && (e = Eg(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l)
      (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
  return new Mn(r, this._parents);
}
function r_(e) {
  return new Array(e.length);
}
function z6() {
  return new Mn(this._enter || this._groups.map(r_), this._parents);
}
function wu(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
wu.prototype = {
  constructor: wu,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function B6(e) {
  return function() {
    return e;
  };
}
var U1 = "$";
function F6(e, t, n, r, i, a) {
  for (var o = 0, s, c = t.length, l = a.length; o < l; ++o)
    (s = t[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new wu(e, a[o]);
  for (; o < c; ++o)
    (s = t[o]) && (i[o] = s);
}
function $6(e, t, n, r, i, a, o) {
  var s, c, l = {}, u = t.length, d = a.length, f = new Array(u), h;
  for (s = 0; s < u; ++s)
    (c = t[s]) && (f[s] = h = U1 + o.call(c, c.__data__, s, t), h in l ? i[s] = c : l[h] = c);
  for (s = 0; s < d; ++s)
    h = U1 + o.call(e, a[s], s, a), (c = l[h]) ? (r[s] = c, c.__data__ = a[s], l[h] = null) : n[s] = new wu(e, a[s]);
  for (s = 0; s < u; ++s)
    (c = t[s]) && l[f[s]] === c && (i[s] = c);
}
function Y6(e, t) {
  if (!e)
    return h = new Array(this.size()), l = -1, this.each(function(x) {
      h[++l] = x;
    }), h;
  var n = t ? $6 : F6, r = this._parents, i = this._groups;
  typeof e != "function" && (e = B6(e));
  for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), l = 0; l < a; ++l) {
    var u = r[l], d = i[l], f = d.length, h = e.call(u, u && u.__data__, l, r), m = h.length, g = s[l] = new Array(m), v = o[l] = new Array(m), _ = c[l] = new Array(f);
    n(u, d, g, v, _, h, t);
    for (var I = 0, M = 0, k, y; I < m; ++I)
      if (k = g[I]) {
        for (I >= M && (M = I + 1); !(y = v[M]) && ++M < m; ) ;
        k._next = y || null;
      }
  }
  return o = new Mn(o, r), o._enter = s, o._exit = c, o;
}
function j6() {
  return new Mn(this._exit || this._groups.map(r_), this._parents);
}
function W6(e) {
  for (var t = this._groups, n = e._groups, r = t.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var c = t[s], l = n[s], u = c.length, d = o[s] = new Array(u), f, h = 0; h < u; ++h)
      (f = c[h] || l[h]) && (d[h] = f);
  for (; s < r; ++s)
    o[s] = t[s];
  return new Mn(o, this._parents);
}
function H6() {
  for (var e = this._groups, t = -1, n = e.length; ++t < n; )
    for (var r = e[t], i = r.length - 1, a = r[i], o; --i >= 0; )
      (o = r[i]) && (a && a !== o.nextSibling && a.parentNode.insertBefore(o, a), a = o);
  return this;
}
function U6(e) {
  e || (e = G6);
  function t(d, f) {
    return d && f ? e(d.__data__, f.__data__) : !d - !f;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
    for (var o = n[a], s = o.length, c = i[a] = new Array(s), l, u = 0; u < s; ++u)
      (l = o[u]) && (c[u] = l);
    c.sort(t);
  }
  return new Mn(i, this._parents).order();
}
function G6(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function V6() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function Q6() {
  var e = new Array(this.size()), t = -1;
  return this.each(function() {
    e[++t] = this;
  }), e;
}
function q6() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], i = 0, a = r.length; i < a; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function X6() {
  var e = 0;
  return this.each(function() {
    ++e;
  }), e;
}
function J6() {
  return !this.node();
}
function K6(e) {
  for (var t = this._groups, n = 0, r = t.length; n < r; ++n)
    for (var i = t[n], a = 0, o = i.length, s; a < o; ++a)
      (s = i[a]) && e.call(s, s.__data__, a, i);
  return this;
}
function Z6(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function eB(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function tB(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function nB(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function rB(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function iB(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function aB(e, t) {
  var n = $l(e);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((t == null ? n.local ? eB : Z6 : typeof t == "function" ? n.local ? iB : rB : n.local ? nB : tB)(n, t));
}
function kg(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function oB(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function sB(e, t, n) {
  return function() {
    this.style.setProperty(e, t, n);
  };
}
function lB(e, t, n) {
  return function() {
    var r = t.apply(this, arguments);
    r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
  };
}
function cB(e, t, n) {
  return arguments.length > 1 ? this.each((t == null ? oB : typeof t == "function" ? lB : sB)(e, t, n ?? "")) : ka(this.node(), e);
}
function ka(e, t) {
  return e.style.getPropertyValue(t) || kg(e).getComputedStyle(e, null).getPropertyValue(t);
}
function uB(e) {
  return function() {
    delete this[e];
  };
}
function fB(e, t) {
  return function() {
    this[e] = t;
  };
}
function dB(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function hB(e, t) {
  return arguments.length > 1 ? this.each((t == null ? uB : typeof t == "function" ? dB : fB)(e, t)) : this.node()[e];
}
function i_(e) {
  return e.trim().split(/^|\s+/);
}
function Tg(e) {
  return e.classList || new a_(e);
}
function a_(e) {
  this._node = e, this._names = i_(e.getAttribute("class") || "");
}
a_.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function o_(e, t) {
  for (var n = Tg(e), r = -1, i = t.length; ++r < i; ) n.add(t[r]);
}
function s_(e, t) {
  for (var n = Tg(e), r = -1, i = t.length; ++r < i; ) n.remove(t[r]);
}
function pB(e) {
  return function() {
    o_(this, e);
  };
}
function mB(e) {
  return function() {
    s_(this, e);
  };
}
function gB(e, t) {
  return function() {
    (t.apply(this, arguments) ? o_ : s_)(this, e);
  };
}
function yB(e, t) {
  var n = i_(e + "");
  if (arguments.length < 2) {
    for (var r = Tg(this.node()), i = -1, a = n.length; ++i < a; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? gB : t ? pB : mB)(n, t));
}
function xB() {
  this.textContent = "";
}
function vB(e) {
  return function() {
    this.textContent = e;
  };
}
function AB(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function bB(e) {
  return arguments.length ? this.each(e == null ? xB : (typeof e == "function" ? AB : vB)(e)) : this.node().textContent;
}
function wB() {
  this.innerHTML = "";
}
function _B(e) {
  return function() {
    this.innerHTML = e;
  };
}
function SB(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function CB(e) {
  return arguments.length ? this.each(e == null ? wB : (typeof e == "function" ? SB : _B)(e)) : this.node().innerHTML;
}
function EB() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function kB() {
  return this.each(EB);
}
function TB() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function MB() {
  return this.each(TB);
}
function IB(e) {
  var t = typeof e == "function" ? e : Gf(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function NB() {
  return null;
}
function OB(e, t) {
  var n = typeof e == "function" ? e : Gf(e), r = t == null ? NB : typeof t == "function" ? t : Vf(t);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function RB() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function DB() {
  return this.each(RB);
}
function PB() {
  return this.parentNode.insertBefore(this.cloneNode(!1), this.nextSibling);
}
function LB() {
  return this.parentNode.insertBefore(this.cloneNode(!0), this.nextSibling);
}
function zB(e) {
  return this.select(e ? LB : PB);
}
function BB(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
var l_ = {}, De = null;
if (typeof document < "u") {
  var FB = document.documentElement;
  "onmouseenter" in FB || (l_ = { mouseenter: "mouseover", mouseleave: "mouseout" });
}
function $B(e, t, n) {
  return e = c_(e, t, n), function(r) {
    var i = r.relatedTarget;
    (!i || i !== this && !(i.compareDocumentPosition(this) & 8)) && e.call(this, r);
  };
}
function c_(e, t, n) {
  return function(r) {
    var i = De;
    De = r;
    try {
      e.call(this, this.__data__, t, n);
    } finally {
      De = i;
    }
  };
}
function YB(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var n = "", r = t.indexOf(".");
    return r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), { type: t, name: n };
  });
}
function jB(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var n = 0, r = -1, i = t.length, a; n < i; ++n)
        a = t[n], (!e.type || a.type === e.type) && a.name === e.name ? this.removeEventListener(a.type, a.listener, a.capture) : t[++r] = a;
      ++r ? t.length = r : delete this.__on;
    }
  };
}
function WB(e, t, n) {
  var r = l_.hasOwnProperty(e.type) ? $B : c_;
  return function(i, a, o) {
    var s = this.__on, c, l = r(t, a, o);
    if (s) {
      for (var u = 0, d = s.length; u < d; ++u)
        if ((c = s[u]).type === e.type && c.name === e.name) {
          this.removeEventListener(c.type, c.listener, c.capture), this.addEventListener(c.type, c.listener = l, c.capture = n), c.value = t;
          return;
        }
    }
    this.addEventListener(e.type, l, n), c = { type: e.type, name: e.name, value: t, listener: l, capture: n }, s ? s.push(c) : this.__on = [c];
  };
}
function HB(e, t, n) {
  var r = YB(e + ""), i, a = r.length, o;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var c = 0, l = s.length, u; c < l; ++c)
        for (i = 0, u = s[c]; i < a; ++i)
          if ((o = r[i]).type === u.type && o.name === u.name)
            return u.value;
    }
    return;
  }
  for (s = t ? WB : jB, n == null && (n = !1), i = 0; i < a; ++i) this.each(s(r[i], t, n));
  return this;
}
function sl(e, t, n, r) {
  var i = De;
  e.sourceEvent = De, De = e;
  try {
    return t.apply(n, r);
  } finally {
    De = i;
  }
}
function u_(e, t, n) {
  var r = kg(e), i = r.CustomEvent;
  typeof i == "function" ? i = new i(t, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(t, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(t, !1, !1)), e.dispatchEvent(i);
}
function UB(e, t) {
  return function() {
    return u_(this, e, t);
  };
}
function GB(e, t) {
  return function() {
    return u_(this, e, t.apply(this, arguments));
  };
}
function VB(e, t) {
  return this.each((typeof t == "function" ? GB : UB)(e, t));
}
var Mg = [null];
function Mn(e, t) {
  this._groups = e, this._parents = t;
}
function Fa() {
  return new Mn([[document.documentElement]], Mg);
}
Mn.prototype = Fa.prototype = {
  constructor: Mn,
  select: O6,
  selectAll: D6,
  filter: L6,
  data: Y6,
  enter: z6,
  exit: j6,
  merge: W6,
  order: H6,
  sort: U6,
  call: V6,
  nodes: Q6,
  node: q6,
  size: X6,
  empty: J6,
  each: K6,
  attr: aB,
  style: cB,
  property: hB,
  classed: yB,
  text: bB,
  html: CB,
  raise: kB,
  lower: MB,
  append: IB,
  insert: OB,
  remove: DB,
  clone: zB,
  datum: BB,
  on: HB,
  dispatch: VB
};
function Vt(e) {
  return typeof e == "string" ? new Mn([[document.querySelector(e)]], [document.documentElement]) : new Mn([[e]], Mg);
}
function QB(e) {
  return Vt(Gf(e).call(document.documentElement));
}
var qB = 0;
function f_() {
  return new Cp();
}
function Cp() {
  this._ = "@" + (++qB).toString(36);
}
Cp.prototype = f_.prototype = {
  constructor: Cp,
  get: function(e) {
    for (var t = this._; !(t in e); ) if (!(e = e.parentNode)) return;
    return e[t];
  },
  set: function(e, t) {
    return e[this._] = t;
  },
  remove: function(e) {
    return this._ in e && delete e[this._];
  },
  toString: function() {
    return this._;
  }
};
function Ig() {
  for (var e = De, t; t = e.sourceEvent; ) e = t;
  return e;
}
function Qf(e, t) {
  var n = e.ownerSVGElement || e;
  if (n.createSVGPoint) {
    var r = n.createSVGPoint();
    return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
  }
  var i = e.getBoundingClientRect();
  return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
}
function Di(e) {
  var t = Ig();
  return t.changedTouches && (t = t.changedTouches[0]), Qf(e, t);
}
function XB(e) {
  return typeof e == "string" ? new Mn([document.querySelectorAll(e)], [document.documentElement]) : new Mn([e ?? []], Mg);
}
function _u(e, t, n) {
  arguments.length < 3 && (n = t, t = Ig().changedTouches);
  for (var r = 0, i = t ? t.length : 0, a; r < i; ++r)
    if ((a = t[r]).identifier === n)
      return Qf(e, a);
  return null;
}
function JB(e, t) {
  t == null && (t = Ig().touches);
  for (var n = 0, r = t ? t.length : 0, i = new Array(r); n < r; ++n)
    i[n] = Qf(e, t[n]);
  return i;
}
function Jd() {
  De.stopImmediatePropagation();
}
function vo() {
  De.preventDefault(), De.stopImmediatePropagation();
}
function qf(e) {
  var t = e.document.documentElement, n = Vt(e).on("dragstart.drag", vo, !0);
  "onselectstart" in t ? n.on("selectstart.drag", vo, !0) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function Xf(e, t) {
  var n = e.document.documentElement, r = Vt(e).on("dragstart.drag", null);
  t && (r.on("click.drag", vo, !0), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
function yc(e) {
  return function() {
    return e;
  };
}
function Ep(e, t, n, r, i, a, o, s, c, l) {
  this.target = e, this.type = t, this.subject = n, this.identifier = r, this.active = i, this.x = a, this.y = o, this.dx = s, this.dy = c, this._ = l;
}
Ep.prototype.on = function() {
  var e = this._.on.apply(this._, arguments);
  return e === this._ ? this : e;
};
function KB() {
  return !De.button;
}
function ZB() {
  return this.parentNode;
}
function e8(e) {
  return e ?? { x: De.x, y: De.y };
}
function t8() {
  return "ontouchstart" in this;
}
function n8() {
  var e = KB, t = ZB, n = e8, r = t8, i = {}, a = Ji("start", "drag", "end"), o = 0, s, c, l, u, d = 0;
  function f(k) {
    k.on("mousedown.drag", h).filter(r).on("touchstart.drag", v).on("touchmove.drag", _).on("touchend.drag touchcancel.drag", I).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function h() {
    if (!(u || !e.apply(this, arguments))) {
      var k = M("mouse", t.apply(this, arguments), Di, this, arguments);
      k && (Vt(De.view).on("mousemove.drag", m, !0).on("mouseup.drag", g, !0), qf(De.view), Jd(), l = !1, s = De.clientX, c = De.clientY, k("start"));
    }
  }
  function m() {
    if (vo(), !l) {
      var k = De.clientX - s, y = De.clientY - c;
      l = k * k + y * y > d;
    }
    i.mouse("drag");
  }
  function g() {
    Vt(De.view).on("mousemove.drag mouseup.drag", null), Xf(De.view, l), vo(), i.mouse("end");
  }
  function v() {
    if (e.apply(this, arguments)) {
      var k = De.changedTouches, y = t.apply(this, arguments), x = k.length, b, A;
      for (b = 0; b < x; ++b)
        (A = M(k[b].identifier, y, _u, this, arguments)) && (Jd(), A("start"));
    }
  }
  function _() {
    var k = De.changedTouches, y = k.length, x, b;
    for (x = 0; x < y; ++x)
      (b = i[k[x].identifier]) && (vo(), b("drag"));
  }
  function I() {
    var k = De.changedTouches, y = k.length, x, b;
    for (u && clearTimeout(u), u = setTimeout(function() {
      u = null;
    }, 500), x = 0; x < y; ++x)
      (b = i[k[x].identifier]) && (Jd(), b("end"));
  }
  function M(k, y, x, b, A) {
    var w = x(y, k), O, P, E, C = a.copy();
    if (sl(new Ep(f, "beforestart", O, k, o, w[0], w[1], 0, 0, C), function() {
      return (De.subject = O = n.apply(b, A)) == null ? !1 : (P = O.x - w[0] || 0, E = O.y - w[1] || 0, !0);
    }))
      return function T(D) {
        var z = w, F;
        switch (D) {
          case "start":
            i[k] = T, F = o++;
            break;
          case "end":
            delete i[k], --o;
          case "drag":
            w = x(y, k), F = o;
            break;
        }
        sl(new Ep(f, D, O, k, F, w[0] + P, w[1] + E, w[0] - z[0], w[1] - z[1], C), C.apply, C, [D, b, A]);
      };
  }
  return f.filter = function(k) {
    return arguments.length ? (e = typeof k == "function" ? k : yc(!!k), f) : e;
  }, f.container = function(k) {
    return arguments.length ? (t = typeof k == "function" ? k : yc(k), f) : t;
  }, f.subject = function(k) {
    return arguments.length ? (n = typeof k == "function" ? k : yc(k), f) : n;
  }, f.touchable = function(k) {
    return arguments.length ? (r = typeof k == "function" ? k : yc(!!k), f) : r;
  }, f.on = function() {
    var k = a.on.apply(a, arguments);
    return k === a ? f : k;
  }, f.clickDistance = function(k) {
    return arguments.length ? (d = (k = +k) * k, f) : Math.sqrt(d);
  }, f;
}
function Uo(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function Yl(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Ki() {
}
var Ta = 0.7, ko = 1 / Ta, Ao = "\\s*([+-]?\\d+)\\s*", ll = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", Gr = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", r8 = /^#([0-9a-f]{3})$/, i8 = /^#([0-9a-f]{6})$/, a8 = new RegExp("^rgb\\(" + [Ao, Ao, Ao] + "\\)$"), o8 = new RegExp("^rgb\\(" + [Gr, Gr, Gr] + "\\)$"), s8 = new RegExp("^rgba\\(" + [Ao, Ao, Ao, ll] + "\\)$"), l8 = new RegExp("^rgba\\(" + [Gr, Gr, Gr, ll] + "\\)$"), c8 = new RegExp("^hsl\\(" + [ll, Gr, Gr] + "\\)$"), u8 = new RegExp("^hsla\\(" + [ll, Gr, Gr, ll] + "\\)$"), G1 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Uo(Ki, Hi, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});
function Hi(e) {
  var t;
  return e = (e + "").trim().toLowerCase(), (t = r8.exec(e)) ? (t = parseInt(t[1], 16), new cn(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1)) : (t = i8.exec(e)) ? V1(parseInt(t[1], 16)) : (t = a8.exec(e)) ? new cn(t[1], t[2], t[3], 1) : (t = o8.exec(e)) ? new cn(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = s8.exec(e)) ? Q1(t[1], t[2], t[3], t[4]) : (t = l8.exec(e)) ? Q1(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = c8.exec(e)) ? q1(t[1], t[2] / 100, t[3] / 100, 1) : (t = u8.exec(e)) ? q1(t[1], t[2] / 100, t[3] / 100, t[4]) : G1.hasOwnProperty(e) ? V1(G1[e]) : e === "transparent" ? new cn(NaN, NaN, NaN, 0) : null;
}
function V1(e) {
  return new cn(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Q1(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new cn(e, t, n, r);
}
function Ng(e) {
  return e instanceof Ki || (e = Hi(e)), e ? (e = e.rgb(), new cn(e.r, e.g, e.b, e.opacity)) : new cn();
}
function cl(e, t, n, r) {
  return arguments.length === 1 ? Ng(e) : new cn(e, t, n, r ?? 1);
}
function cn(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Uo(cn, cl, Yl(Ki, {
  brighter: function(e) {
    return e = e == null ? ko : Math.pow(ko, e), new cn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Ta : Math.pow(Ta, e), new cn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
  },
  toString: function() {
    var e = this.opacity;
    return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
  }
}));
function q1(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new jr(e, t, n, r);
}
function f8(e) {
  if (e instanceof jr) return new jr(e.h, e.s, e.l, e.opacity);
  if (e instanceof Ki || (e = Hi(e)), !e) return new jr();
  if (e instanceof jr) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, c = (a + i) / 2;
  return s ? (t === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - t) / s + 2 : o = (t - n) / s + 4, s /= c < 0.5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new jr(o, s, c, e.opacity);
}
function Su(e, t, n, r) {
  return arguments.length === 1 ? f8(e) : new jr(e, t, n, r ?? 1);
}
function jr(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Uo(jr, Su, Yl(Ki, {
  brighter: function(e) {
    return e = e == null ? ko : Math.pow(ko, e), new jr(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Ta : Math.pow(Ta, e), new jr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new cn(
      Kd(e >= 240 ? e - 240 : e + 120, i, r),
      Kd(e, i, r),
      Kd(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  }
}));
function Kd(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
var d_ = Math.PI / 180, h_ = 180 / Math.PI, Cu = 18, p_ = 0.95047, m_ = 1, g_ = 1.08883, y_ = 4 / 29, bo = 6 / 29, x_ = 3 * bo * bo, d8 = bo * bo * bo;
function Og(e) {
  if (e instanceof hi) return new hi(e.l, e.a, e.b, e.opacity);
  if (e instanceof Bi) {
    var t = e.h * d_;
    return new hi(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
  }
  e instanceof cn || (e = Ng(e));
  var n = nh(e.r), r = nh(e.g), i = nh(e.b), a = Zd((0.4124564 * n + 0.3575761 * r + 0.1804375 * i) / p_), o = Zd((0.2126729 * n + 0.7151522 * r + 0.072175 * i) / m_), s = Zd((0.0193339 * n + 0.119192 * r + 0.9503041 * i) / g_);
  return new hi(116 * o - 16, 500 * (a - o), 200 * (o - s), e.opacity);
}
function Eu(e, t, n, r) {
  return arguments.length === 1 ? Og(e) : new hi(e, t, n, r ?? 1);
}
function hi(e, t, n, r) {
  this.l = +e, this.a = +t, this.b = +n, this.opacity = +r;
}
Uo(hi, Eu, Yl(Ki, {
  brighter: function(e) {
    return new hi(this.l + Cu * (e ?? 1), this.a, this.b, this.opacity);
  },
  darker: function(e) {
    return new hi(this.l - Cu * (e ?? 1), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var e = (this.l + 16) / 116, t = isNaN(this.a) ? e : e + this.a / 500, n = isNaN(this.b) ? e : e - this.b / 200;
    return e = m_ * eh(e), t = p_ * eh(t), n = g_ * eh(n), new cn(
      th(3.2404542 * t - 1.5371385 * e - 0.4985314 * n),
      // D65 -> sRGB
      th(-0.969266 * t + 1.8760108 * e + 0.041556 * n),
      th(0.0556434 * t - 0.2040259 * e + 1.0572252 * n),
      this.opacity
    );
  }
}));
function Zd(e) {
  return e > d8 ? Math.pow(e, 1 / 3) : e / x_ + y_;
}
function eh(e) {
  return e > bo ? e * e * e : x_ * (e - y_);
}
function th(e) {
  return 255 * (e <= 31308e-7 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055);
}
function nh(e) {
  return (e /= 255) <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
}
function h8(e) {
  if (e instanceof Bi) return new Bi(e.h, e.c, e.l, e.opacity);
  e instanceof hi || (e = Og(e));
  var t = Math.atan2(e.b, e.a) * h_;
  return new Bi(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
}
function ku(e, t, n, r) {
  return arguments.length === 1 ? h8(e) : new Bi(e, t, n, r ?? 1);
}
function Bi(e, t, n, r) {
  this.h = +e, this.c = +t, this.l = +n, this.opacity = +r;
}
Uo(Bi, ku, Yl(Ki, {
  brighter: function(e) {
    return new Bi(this.h, this.c, this.l + Cu * (e ?? 1), this.opacity);
  },
  darker: function(e) {
    return new Bi(this.h, this.c, this.l - Cu * (e ?? 1), this.opacity);
  },
  rgb: function() {
    return Og(this).rgb();
  }
}));
var v_ = -0.14861, Rg = 1.78277, Dg = -0.29227, Jf = -0.90649, ul = 1.97294, X1 = ul * Jf, J1 = ul * Rg, K1 = Rg * Dg - Jf * v_;
function p8(e) {
  if (e instanceof ba) return new ba(e.h, e.s, e.l, e.opacity);
  e instanceof cn || (e = Ng(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = (K1 * r + X1 * t - J1 * n) / (K1 + X1 - J1), a = r - i, o = (ul * (n - i) - Dg * a) / Jf, s = Math.sqrt(o * o + a * a) / (ul * i * (1 - i)), c = s ? Math.atan2(o, a) * h_ - 120 : NaN;
  return new ba(c < 0 ? c + 360 : c, s, i, e.opacity);
}
function Er(e, t, n, r) {
  return arguments.length === 1 ? p8(e) : new ba(e, t, n, r ?? 1);
}
function ba(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Uo(ba, Er, Yl(Ki, {
  brighter: function(e) {
    return e = e == null ? ko : Math.pow(ko, e), new ba(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Ta : Math.pow(Ta, e), new ba(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * d_, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), i = Math.sin(e);
    return new cn(
      255 * (t + n * (v_ * r + Rg * i)),
      255 * (t + n * (Dg * r + Jf * i)),
      255 * (t + n * (ul * r)),
      this.opacity
    );
  }
}));
function A_(e, t, n, r, i) {
  var a = e * e, o = a * e;
  return ((1 - 3 * e + 3 * a - o) * t + (4 - 6 * a + 3 * o) * n + (1 + 3 * e + 3 * a - 3 * o) * r + o * i) / 6;
}
function b_(e) {
  var t = e.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), i = e[r], a = e[r + 1], o = r > 0 ? e[r - 1] : 2 * i - a, s = r < t - 1 ? e[r + 2] : 2 * a - i;
    return A_((n - r / t) * t, o, i, a, s);
  };
}
function w_(e) {
  var t = e.length;
  return function(n) {
    var r = Math.floor(((n %= 1) < 0 ? ++n : n) * t), i = e[(r + t - 1) % t], a = e[r % t], o = e[(r + 1) % t], s = e[(r + 2) % t];
    return A_((n - r / t) * t, i, a, o, s);
  };
}
function Kf(e) {
  return function() {
    return e;
  };
}
function __(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function m8(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Pg(e, t) {
  var n = t - e;
  return n ? __(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Kf(isNaN(e) ? t : e);
}
function g8(e) {
  return (e = +e) == 1 ? on : function(t, n) {
    return n - t ? m8(t, n, e) : Kf(isNaN(t) ? n : t);
  };
}
function on(e, t) {
  var n = t - e;
  return n ? __(e, n) : Kf(isNaN(e) ? t : e);
}
const fl = function e(t) {
  var n = g8(t);
  function r(i, a) {
    var o = n((i = cl(i)).r, (a = cl(a)).r), s = n(i.g, a.g), c = n(i.b, a.b), l = on(i.opacity, a.opacity);
    return function(u) {
      return i.r = o(u), i.g = s(u), i.b = c(u), i.opacity = l(u), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function S_(e) {
  return function(t) {
    var n = t.length, r = new Array(n), i = new Array(n), a = new Array(n), o, s;
    for (o = 0; o < n; ++o)
      s = cl(t[o]), r[o] = s.r || 0, i[o] = s.g || 0, a[o] = s.b || 0;
    return r = e(r), i = e(i), a = e(a), s.opacity = 1, function(c) {
      return s.r = r(c), s.g = i(c), s.b = a(c), s + "";
    };
  };
}
var y8 = S_(b_), x8 = S_(w_);
function C_(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = jl(e[o], t[o]);
  for (; o < n; ++o) a[o] = t[o];
  return function(s) {
    for (o = 0; o < r; ++o) a[o] = i[o](s);
    return a;
  };
}
function E_(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t -= e, function(r) {
    return n.setTime(e + t * r), n;
  };
}
function Vn(e, t) {
  return e = +e, t -= e, function(n) {
    return e + t * n;
  };
}
function k_(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = jl(e[i], t[i]) : r[i] = t[i];
  return function(a) {
    for (i in n) r[i] = n[i](a);
    return r;
  };
}
var kp = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, rh = new RegExp(kp.source, "g");
function v8(e) {
  return function() {
    return e;
  };
}
function A8(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Lg(e, t) {
  var n = kp.lastIndex = rh.lastIndex = 0, r, i, a, o = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (r = kp.exec(e)) && (i = rh.exec(t)); )
    (a = i.index) > n && (a = t.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, c.push({ i: o, x: Vn(r, i) })), n = rh.lastIndex;
  return n < t.length && (a = t.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? c[0] ? A8(c[0].x) : v8(t) : (t = c.length, function(l) {
    for (var u = 0, d; u < t; ++u) s[(d = c[u]).i] = d.x(l);
    return s.join("");
  });
}
function jl(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? Kf(t) : (n === "number" ? Vn : n === "string" ? (r = Hi(t)) ? (t = r, fl) : Lg : t instanceof Hi ? fl : t instanceof Date ? E_ : Array.isArray(t) ? C_ : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? k_ : Vn)(e, t);
}
function T_(e, t) {
  return e = +e, t -= e, function(n) {
    return Math.round(e + t * n);
  };
}
var Z1 = 180 / Math.PI, Tp = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function M_(e, t, n, r, i, a) {
  var o, s, c;
  return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (c = e * n + t * r) && (n -= e * c, r -= t * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), e * r < t * n && (e = -e, t = -t, c = -c, o = -o), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(t, e) * Z1,
    skewX: Math.atan(c) * Z1,
    scaleX: o,
    scaleY: s
  };
}
var ls, ih, ex, xc;
function b8(e) {
  return e === "none" ? Tp : (ls || (ls = document.createElement("DIV"), ih = document.documentElement, ex = document.defaultView), ls.style.transform = e, e = ex.getComputedStyle(ih.appendChild(ls), null).getPropertyValue("transform"), ih.removeChild(ls), e = e.slice(7, -1).split(","), M_(+e[0], +e[1], +e[2], +e[3], +e[4], +e[5]));
}
function w8(e) {
  return e == null || (xc || (xc = document.createElementNS("http://www.w3.org/2000/svg", "g")), xc.setAttribute("transform", e), !(e = xc.transform.baseVal.consolidate())) ? Tp : (e = e.matrix, M_(e.a, e.b, e.c, e.d, e.e, e.f));
}
function I_(e, t, n, r) {
  function i(l) {
    return l.length ? l.pop() + " " : "";
  }
  function a(l, u, d, f, h, m) {
    if (l !== d || u !== f) {
      var g = h.push("translate(", null, t, null, n);
      m.push({ i: g - 4, x: Vn(l, d) }, { i: g - 2, x: Vn(u, f) });
    } else (d || f) && h.push("translate(" + d + t + f + n);
  }
  function o(l, u, d, f) {
    l !== u ? (l - u > 180 ? u += 360 : u - l > 180 && (l += 360), f.push({ i: d.push(i(d) + "rotate(", null, r) - 2, x: Vn(l, u) })) : u && d.push(i(d) + "rotate(" + u + r);
  }
  function s(l, u, d, f) {
    l !== u ? f.push({ i: d.push(i(d) + "skewX(", null, r) - 2, x: Vn(l, u) }) : u && d.push(i(d) + "skewX(" + u + r);
  }
  function c(l, u, d, f, h, m) {
    if (l !== d || u !== f) {
      var g = h.push(i(h) + "scale(", null, ",", null, ")");
      m.push({ i: g - 4, x: Vn(l, d) }, { i: g - 2, x: Vn(u, f) });
    } else (d !== 1 || f !== 1) && h.push(i(h) + "scale(" + d + "," + f + ")");
  }
  return function(l, u) {
    var d = [], f = [];
    return l = e(l), u = e(u), a(l.translateX, l.translateY, u.translateX, u.translateY, d, f), o(l.rotate, u.rotate, d, f), s(l.skewX, u.skewX, d, f), c(l.scaleX, l.scaleY, u.scaleX, u.scaleY, d, f), l = u = null, function(h) {
      for (var m = -1, g = f.length, v; ++m < g; ) d[(v = f[m]).i] = v.x(h);
      return d.join("");
    };
  };
}
var N_ = I_(b8, "px, ", "px)", "deg)"), O_ = I_(w8, ", ", ")", ")"), cs = Math.SQRT2, ah = 2, tx = 4, _8 = 1e-12;
function nx(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function S8(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function C8(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
function R_(e, t) {
  var n = e[0], r = e[1], i = e[2], a = t[0], o = t[1], s = t[2], c = a - n, l = o - r, u = c * c + l * l, d, f;
  if (u < _8)
    f = Math.log(s / i) / cs, d = function(I) {
      return [
        n + I * c,
        r + I * l,
        i * Math.exp(cs * I * f)
      ];
    };
  else {
    var h = Math.sqrt(u), m = (s * s - i * i + tx * u) / (2 * i * ah * h), g = (s * s - i * i - tx * u) / (2 * s * ah * h), v = Math.log(Math.sqrt(m * m + 1) - m), _ = Math.log(Math.sqrt(g * g + 1) - g);
    f = (_ - v) / cs, d = function(I) {
      var M = I * f, k = nx(v), y = i / (ah * h) * (k * C8(cs * M + v) - S8(v));
      return [
        n + y * c,
        r + y * l,
        i * k / nx(cs * M + v)
      ];
    };
  }
  return d.duration = f * 1e3, d;
}
function D_(e) {
  return function(t, n) {
    var r = e((t = Su(t)).h, (n = Su(n)).h), i = on(t.s, n.s), a = on(t.l, n.l), o = on(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.s = i(s), t.l = a(s), t.opacity = o(s), t + "";
    };
  };
}
const E8 = D_(Pg);
var k8 = D_(on);
function T8(e, t) {
  var n = on((e = Eu(e)).l, (t = Eu(t)).l), r = on(e.a, t.a), i = on(e.b, t.b), a = on(e.opacity, t.opacity);
  return function(o) {
    return e.l = n(o), e.a = r(o), e.b = i(o), e.opacity = a(o), e + "";
  };
}
function P_(e) {
  return function(t, n) {
    var r = e((t = ku(t)).h, (n = ku(n)).h), i = on(t.c, n.c), a = on(t.l, n.l), o = on(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.c = i(s), t.l = a(s), t.opacity = o(s), t + "";
    };
  };
}
const M8 = P_(Pg);
var I8 = P_(on);
function L_(e) {
  return function t(n) {
    n = +n;
    function r(i, a) {
      var o = e((i = Er(i)).h, (a = Er(a)).h), s = on(i.s, a.s), c = on(i.l, a.l), l = on(i.opacity, a.opacity);
      return function(u) {
        return i.h = o(u), i.s = s(u), i.l = c(Math.pow(u, n)), i.opacity = l(u), i + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
const N8 = L_(Pg);
var Zf = L_(on);
function O8(e, t) {
  for (var n = new Array(t), r = 0; r < t; ++r) n[r] = e(r / (t - 1));
  return n;
}
var To = 0, As = 0, us = 0, z_ = 1e3, Tu, bs, Mu = 0, Ma = 0, ed = 0, dl = typeof performance == "object" && performance.now ? performance : Date, B_ = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function Go() {
  return Ma || (B_(R8), Ma = dl.now() + ed);
}
function R8() {
  Ma = 0;
}
function hl() {
  this._call = this._time = this._next = null;
}
hl.prototype = td.prototype = {
  constructor: hl,
  restart: function(e, t, n) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    n = (n == null ? Go() : +n) + (t == null ? 0 : +t), !this._next && bs !== this && (bs ? bs._next = this : Tu = this, bs = this), this._call = e, this._time = n, Mp();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Mp());
  }
};
function td(e, t, n) {
  var r = new hl();
  return r.restart(e, t, n), r;
}
function F_() {
  Go(), ++To;
  for (var e = Tu, t; e; )
    (t = Ma - e._time) >= 0 && e._call.call(null, t), e = e._next;
  --To;
}
function rx() {
  Ma = (Mu = dl.now()) + ed, To = As = 0;
  try {
    F_();
  } finally {
    To = 0, P8(), Ma = 0;
  }
}
function D8() {
  var e = dl.now(), t = e - Mu;
  t > z_ && (ed -= t, Mu = e);
}
function P8() {
  for (var e, t = Tu, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : Tu = n);
  bs = e, Mp(r);
}
function Mp(e) {
  if (!To) {
    As && (As = clearTimeout(As));
    var t = e - Ma;
    t > 24 ? (e < 1 / 0 && (As = setTimeout(rx, e - dl.now() - ed)), us && (us = clearInterval(us))) : (us || (Mu = dl.now(), us = setInterval(D8, z_)), To = 1, B_(rx));
  }
}
function Ip(e, t, n) {
  var r = new hl();
  return t = t == null ? 0 : +t, r.restart(function(i) {
    r.stop(), e(i + t);
  }, t, n), r;
}
function L8(e, t, n) {
  var r = new hl(), i = t;
  return t == null ? (r.restart(e, t, n), r) : (t = +t, n = n == null ? Go() : +n, r.restart(function a(o) {
    o += i, r.restart(a, i += t, n), e(o);
  }, t, n), r);
}
var z8 = Ji("start", "end", "interrupt"), B8 = [], $_ = 0, Np = 1, Iu = 2, oh = 3, ix = 4, Op = 5, eu = 6;
function nd(e, t, n, r, i, a) {
  var o = e.__transition;
  if (!o) e.__transition = {};
  else if (n in o) return;
  F8(e, n, {
    name: t,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: z8,
    tween: B8,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: $_
  });
}
function zg(e, t) {
  var n = Ir(e, t);
  if (n.state > $_) throw new Error("too late; already scheduled");
  return n;
}
function $a(e, t) {
  var n = Ir(e, t);
  if (n.state > Iu) throw new Error("too late; already started");
  return n;
}
function Ir(e, t) {
  var n = e.__transition;
  if (!n || !(n = n[t])) throw new Error("transition not found");
  return n;
}
function F8(e, t, n) {
  var r = e.__transition, i;
  r[t] = n, n.timer = td(a, 0, n.time);
  function a(l) {
    n.state = Np, n.timer.restart(o, n.delay, n.time), n.delay <= l && o(l - n.delay);
  }
  function o(l) {
    var u, d, f, h;
    if (n.state !== Np) return c();
    for (u in r)
      if (h = r[u], h.name === n.name) {
        if (h.state === oh) return Ip(o);
        h.state === ix ? (h.state = eu, h.timer.stop(), h.on.call("interrupt", e, e.__data__, h.index, h.group), delete r[u]) : +u < t && (h.state = eu, h.timer.stop(), delete r[u]);
      }
    if (Ip(function() {
      n.state === oh && (n.state = ix, n.timer.restart(s, n.delay, n.time), s(l));
    }), n.state = Iu, n.on.call("start", e, e.__data__, n.index, n.group), n.state === Iu) {
      for (n.state = oh, i = new Array(f = n.tween.length), u = 0, d = -1; u < f; ++u)
        (h = n.tween[u].value.call(e, e.__data__, n.index, n.group)) && (i[++d] = h);
      i.length = d + 1;
    }
  }
  function s(l) {
    for (var u = l < n.duration ? n.ease.call(null, l / n.duration) : (n.timer.restart(c), n.state = Op, 1), d = -1, f = i.length; ++d < f; )
      i[d].call(null, u);
    n.state === Op && (n.on.call("end", e, e.__data__, n.index, n.group), c());
  }
  function c() {
    n.state = eu, n.timer.stop(), delete r[t];
    for (var l in r) return;
    delete e.__transition;
  }
}
function wa(e, t) {
  var n = e.__transition, r, i, a = !0, o;
  if (n) {
    t = t == null ? null : t + "";
    for (o in n) {
      if ((r = n[o]).name !== t) {
        a = !1;
        continue;
      }
      i = r.state > Iu && r.state < Op, r.state = eu, r.timer.stop(), i && r.on.call("interrupt", e, e.__data__, r.index, r.group), delete n[o];
    }
    a && delete e.__transition;
  }
}
function $8(e) {
  return this.each(function() {
    wa(this, e);
  });
}
function Y8(e, t) {
  var n, r;
  return function() {
    var i = $a(this, e), a = i.tween;
    if (a !== n) {
      r = n = a;
      for (var o = 0, s = r.length; o < s; ++o)
        if (r[o].name === t) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function j8(e, t, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var a = $a(this, e), o = a.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var s = { name: t, value: n }, c = 0, l = i.length; c < l; ++c)
        if (i[c].name === t) {
          i[c] = s;
          break;
        }
      c === l && i.push(s);
    }
    a.tween = i;
  };
}
function W8(e, t) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var r = Ir(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i)
      if ((o = r[i]).name === e)
        return o.value;
    return null;
  }
  return this.each((t == null ? Y8 : j8)(n, e, t));
}
function Bg(e, t, n) {
  var r = e._id;
  return e.each(function() {
    var i = $a(this, r);
    (i.value || (i.value = {}))[t] = n.apply(this, arguments);
  }), function(i) {
    return Ir(i, r).value[t];
  };
}
function Y_(e, t) {
  var n;
  return (typeof t == "number" ? Vn : t instanceof Hi ? fl : (n = Hi(t)) ? (t = n, fl) : Lg)(e, t);
}
function H8(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function U8(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function G8(e, t, n) {
  var r, i;
  return function() {
    var a = this.getAttribute(e);
    return a === n ? null : a === r ? i : i = t(r = a, n);
  };
}
function V8(e, t, n) {
  var r, i;
  return function() {
    var a = this.getAttributeNS(e.space, e.local);
    return a === n ? null : a === r ? i : i = t(r = a, n);
  };
}
function Q8(e, t, n) {
  var r, i, a;
  return function() {
    var o, s = n(this);
    return s == null ? void this.removeAttribute(e) : (o = this.getAttribute(e), o === s ? null : o === r && s === i ? a : a = t(r = o, i = s));
  };
}
function q8(e, t, n) {
  var r, i, a;
  return function() {
    var o, s = n(this);
    return s == null ? void this.removeAttributeNS(e.space, e.local) : (o = this.getAttributeNS(e.space, e.local), o === s ? null : o === r && s === i ? a : a = t(r = o, i = s));
  };
}
function X8(e, t) {
  var n = $l(e), r = n === "transform" ? O_ : Y_;
  return this.attrTween(e, typeof t == "function" ? (n.local ? q8 : Q8)(n, r, Bg(this, "attr." + e, t)) : t == null ? (n.local ? U8 : H8)(n) : (n.local ? V8 : G8)(n, r, t + ""));
}
function J8(e, t) {
  function n() {
    var r = this, i = t.apply(r, arguments);
    return i && function(a) {
      r.setAttributeNS(e.space, e.local, i(a));
    };
  }
  return n._value = t, n;
}
function K8(e, t) {
  function n() {
    var r = this, i = t.apply(r, arguments);
    return i && function(a) {
      r.setAttribute(e, i(a));
    };
  }
  return n._value = t, n;
}
function Z8(e, t) {
  var n = "attr." + e;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  var r = $l(e);
  return this.tween(n, (r.local ? J8 : K8)(r, t));
}
function eF(e, t) {
  return function() {
    zg(this, e).delay = +t.apply(this, arguments);
  };
}
function tF(e, t) {
  return t = +t, function() {
    zg(this, e).delay = t;
  };
}
function nF(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? eF : tF)(t, e)) : Ir(this.node(), t).delay;
}
function rF(e, t) {
  return function() {
    $a(this, e).duration = +t.apply(this, arguments);
  };
}
function iF(e, t) {
  return t = +t, function() {
    $a(this, e).duration = t;
  };
}
function aF(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? rF : iF)(t, e)) : Ir(this.node(), t).duration;
}
function oF(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    $a(this, e).ease = t;
  };
}
function sF(e) {
  var t = this._id;
  return arguments.length ? this.each(oF(t, e)) : Ir(this.node(), t).ease;
}
function lF(e) {
  typeof e != "function" && (e = Eg(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l)
      (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
  return new qr(r, this._parents, this._name, this._id);
}
function cF(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, n = e._groups, r = t.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var c = t[s], l = n[s], u = c.length, d = o[s] = new Array(u), f, h = 0; h < u; ++h)
      (f = c[h] || l[h]) && (d[h] = f);
  for (; s < r; ++s)
    o[s] = t[s];
  return new qr(o, this._parents, this._name, this._id);
}
function uF(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var n = t.indexOf(".");
    return n >= 0 && (t = t.slice(0, n)), !t || t === "start";
  });
}
function fF(e, t, n) {
  var r, i, a = uF(t) ? zg : $a;
  return function() {
    var o = a(this, e), s = o.on;
    s !== r && (i = (r = s).copy()).on(t, n), o.on = i;
  };
}
function dF(e, t) {
  var n = this._id;
  return arguments.length < 2 ? Ir(this.node(), n).on.on(e) : this.each(fF(n, e, t));
}
function hF(e) {
  return function() {
    var t = this.parentNode;
    for (var n in this.__transition) if (+n !== e) return;
    t && t.removeChild(this);
  };
}
function pF() {
  return this.on("end.remove", hF(this._id));
}
function mF(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Vf(e));
  for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o)
    for (var s = r[o], c = s.length, l = a[o] = new Array(c), u, d, f = 0; f < c; ++f)
      (u = s[f]) && (d = e.call(u, u.__data__, f, s)) && ("__data__" in u && (d.__data__ = u.__data__), l[f] = d, nd(l[f], t, n, f, l, Ir(u, n)));
  return new qr(a, this._parents, t, n);
}
function gF(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Cg(e));
  for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s)
    for (var c = r[s], l = c.length, u, d = 0; d < l; ++d)
      if (u = c[d]) {
        for (var f = e.call(u, u.__data__, d, c), h, m = Ir(u, n), g = 0, v = f.length; g < v; ++g)
          (h = f[g]) && nd(h, t, n, g, f, m);
        a.push(f), o.push(u);
      }
  return new qr(a, o, t, n);
}
var yF = Fa.prototype.constructor;
function xF() {
  return new yF(this._groups, this._parents);
}
function vF(e, t) {
  var n, r, i;
  return function() {
    var a = ka(this, e), o = (this.style.removeProperty(e), ka(this, e));
    return a === o ? null : a === n && o === r ? i : i = t(n = a, r = o);
  };
}
function AF(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function bF(e, t, n) {
  var r, i;
  return function() {
    var a = ka(this, e);
    return a === n ? null : a === r ? i : i = t(r = a, n);
  };
}
function wF(e, t, n) {
  var r, i, a;
  return function() {
    var o = ka(this, e), s = n(this);
    return s == null && (s = (this.style.removeProperty(e), ka(this, e))), o === s ? null : o === r && s === i ? a : a = t(r = o, i = s);
  };
}
function _F(e, t, n) {
  var r = (e += "") == "transform" ? N_ : Y_;
  return t == null ? this.styleTween(e, vF(e, r)).on("end.style." + e, AF(e)) : this.styleTween(e, typeof t == "function" ? wF(e, r, Bg(this, "style." + e, t)) : bF(e, r, t + ""), n);
}
function SF(e, t, n) {
  function r() {
    var i = this, a = t.apply(i, arguments);
    return a && function(o) {
      i.style.setProperty(e, a(o), n);
    };
  }
  return r._value = t, r;
}
function CF(e, t, n) {
  var r = "style." + (e += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (t == null) return this.tween(r, null);
  if (typeof t != "function") throw new Error();
  return this.tween(r, SF(e, t, n ?? ""));
}
function EF(e) {
  return function() {
    this.textContent = e;
  };
}
function kF(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function TF(e) {
  return this.tween("text", typeof e == "function" ? kF(Bg(this, "text", e)) : EF(e == null ? "" : e + ""));
}
function MF() {
  for (var e = this._name, t = this._id, n = W_(), r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, c, l = 0; l < s; ++l)
      if (c = o[l]) {
        var u = Ir(c, t);
        nd(c, e, n, l, o, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new qr(r, this._parents, e, n);
}
var IF = 0;
function qr(e, t, n, r) {
  this._groups = e, this._parents = t, this._name = n, this._id = r;
}
function j_(e) {
  return Fa().transition(e);
}
function W_() {
  return ++IF;
}
var Xa = Fa.prototype;
qr.prototype = j_.prototype = {
  constructor: qr,
  select: mF,
  selectAll: gF,
  filter: lF,
  merge: cF,
  selection: xF,
  transition: MF,
  call: Xa.call,
  nodes: Xa.nodes,
  node: Xa.node,
  size: Xa.size,
  empty: Xa.empty,
  each: Xa.each,
  on: dF,
  attr: X8,
  attrTween: Z8,
  style: _F,
  styleTween: CF,
  text: TF,
  remove: pF,
  tween: W8,
  delay: nF,
  duration: aF,
  ease: sF
};
function NF(e) {
  return +e;
}
function OF(e) {
  return e * e;
}
function RF(e) {
  return e * (2 - e);
}
function ax(e) {
  return ((e *= 2) <= 1 ? e * e : --e * (2 - e) + 1) / 2;
}
function DF(e) {
  return e * e * e;
}
function PF(e) {
  return --e * e * e + 1;
}
function Rp(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var Fg = 3, LF = function e(t) {
  t = +t;
  function n(r) {
    return Math.pow(r, t);
  }
  return n.exponent = e, n;
}(Fg), zF = function e(t) {
  t = +t;
  function n(r) {
    return 1 - Math.pow(1 - r, t);
  }
  return n.exponent = e, n;
}(Fg), ox = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, t) : 2 - Math.pow(2 - r, t)) / 2;
  }
  return n.exponent = e, n;
}(Fg), H_ = Math.PI, U_ = H_ / 2;
function BF(e) {
  return 1 - Math.cos(e * U_);
}
function FF(e) {
  return Math.sin(e * U_);
}
function sx(e) {
  return (1 - Math.cos(H_ * e)) / 2;
}
function $F(e) {
  return Math.pow(2, 10 * e - 10);
}
function YF(e) {
  return 1 - Math.pow(2, -10 * e);
}
function lx(e) {
  return ((e *= 2) <= 1 ? Math.pow(2, 10 * e - 10) : 2 - Math.pow(2, 10 - 10 * e)) / 2;
}
function jF(e) {
  return 1 - Math.sqrt(1 - e * e);
}
function WF(e) {
  return Math.sqrt(1 - --e * e);
}
function cx(e) {
  return ((e *= 2) <= 1 ? 1 - Math.sqrt(1 - e * e) : Math.sqrt(1 - (e -= 2) * e) + 1) / 2;
}
var Dp = 4 / 11, HF = 6 / 11, UF = 8 / 11, GF = 3 / 4, VF = 9 / 11, QF = 10 / 11, qF = 15 / 16, XF = 21 / 22, JF = 63 / 64, vc = 1 / Dp / Dp;
function KF(e) {
  return 1 - pl(1 - e);
}
function pl(e) {
  return (e = +e) < Dp ? vc * e * e : e < UF ? vc * (e -= HF) * e + GF : e < QF ? vc * (e -= VF) * e + qF : vc * (e -= XF) * e + JF;
}
function ZF(e) {
  return ((e *= 2) <= 1 ? 1 - pl(1 - e) : pl(e - 1) + 1) / 2;
}
var $g = 1.70158, e$ = function e(t) {
  t = +t;
  function n(r) {
    return r * r * ((t + 1) * r - t);
  }
  return n.overshoot = e, n;
}($g), t$ = function e(t) {
  t = +t;
  function n(r) {
    return --r * r * ((t + 1) * r + t) + 1;
  }
  return n.overshoot = e, n;
}($g), ux = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) < 1 ? r * r * ((t + 1) * r - t) : (r -= 2) * r * ((t + 1) * r + t) + 2) / 2;
  }
  return n.overshoot = e, n;
}($g), Mo = 2 * Math.PI, Yg = 1, jg = 0.3, n$ = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= Mo);
  function i(a) {
    return t * Math.pow(2, 10 * --a) * Math.sin((r - a) / n);
  }
  return i.amplitude = function(a) {
    return e(a, n * Mo);
  }, i.period = function(a) {
    return e(t, a);
  }, i;
}(Yg, jg), fx = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= Mo);
  function i(a) {
    return 1 - t * Math.pow(2, -10 * (a = +a)) * Math.sin((a + r) / n);
  }
  return i.amplitude = function(a) {
    return e(a, n * Mo);
  }, i.period = function(a) {
    return e(t, a);
  }, i;
}(Yg, jg), r$ = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= Mo);
  function i(a) {
    return ((a = a * 2 - 1) < 0 ? t * Math.pow(2, 10 * a) * Math.sin((r - a) / n) : 2 - t * Math.pow(2, -10 * a) * Math.sin((r + a) / n)) / 2;
  }
  return i.amplitude = function(a) {
    return e(a, n * Mo);
  }, i.period = function(a) {
    return e(t, a);
  }, i;
}(Yg, jg), Pp = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Rp
};
function i$(e, t) {
  for (var n; !(n = e.__transition) || !(n = n[t]); )
    if (!(e = e.parentNode))
      return Pp.time = Go(), Pp;
  return n;
}
function a$(e) {
  var t, n;
  e instanceof qr ? (t = e._id, e = e._name) : (t = W_(), (n = Pp).time = Go(), e = e == null ? null : e + "");
  for (var r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, c, l = 0; l < s; ++l)
      (c = o[l]) && nd(c, e, t, l, o, n || i$(c, t));
  return new qr(r, this._parents, e, t);
}
Fa.prototype.interrupt = $8;
Fa.prototype.transition = a$;
var o$ = [null];
function s$(e, t) {
  var n = e.__transition, r, i;
  if (n) {
    t = t == null ? null : t + "";
    for (i in n)
      if ((r = n[i]).state > Np && r.name === t)
        return new qr([[e]], o$, t, +i);
  }
  return null;
}
function dx(e) {
  return function() {
    return e;
  };
}
function l$(e, t, n) {
  this.target = e, this.type = t, this.selection = n;
}
function hx() {
  De.stopImmediatePropagation();
}
function Ac() {
  De.preventDefault(), De.stopImmediatePropagation();
}
var px = {}, sh = { name: "space" }, Ja = { name: "handle" }, Ka = { name: "center" }, tu = {
  name: "x",
  handles: ["e", "w"].map(ml),
  input: function(e, t) {
    return e && [[e[0], t[0][1]], [e[1], t[1][1]]];
  },
  output: function(e) {
    return e && [e[0][0], e[1][0]];
  }
}, nu = {
  name: "y",
  handles: ["n", "s"].map(ml),
  input: function(e, t) {
    return e && [[t[0][0], e[0]], [t[1][0], e[1]]];
  },
  output: function(e) {
    return e && [e[0][1], e[1][1]];
  }
}, c$ = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(ml),
  input: function(e) {
    return e;
  },
  output: function(e) {
    return e;
  }
}, ri = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
}, mx = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
}, gx = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
}, u$ = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
}, f$ = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function ml(e) {
  return { type: e };
}
function d$() {
  return !De.button;
}
function h$() {
  var e = this.ownerSVGElement || this;
  return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
}
function lh(e) {
  for (; !e.__brush; ) if (!(e = e.parentNode)) return;
  return e.__brush;
}
function ch(e) {
  return e[0][0] === e[1][0] || e[0][1] === e[1][1];
}
function p$(e) {
  var t = e.__brush;
  return t ? t.dim.output(t.selection) : null;
}
function m$() {
  return Wg(tu);
}
function g$() {
  return Wg(nu);
}
function y$() {
  return Wg(c$);
}
function Wg(e) {
  var t = h$, n = d$, r = Ji(o, "start", "brush", "end"), i = 6, a;
  function o(f) {
    var h = f.property("__brush", d).selectAll(".overlay").data([ml("overlay")]);
    h.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", ri.overlay).merge(h).each(function() {
      var g = lh(this).extent;
      Vt(this).attr("x", g[0][0]).attr("y", g[0][1]).attr("width", g[1][0] - g[0][0]).attr("height", g[1][1] - g[0][1]);
    }), f.selectAll(".selection").data([ml("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", ri.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var m = f.selectAll(".handle").data(e.handles, function(g) {
      return g.type;
    });
    m.exit().remove(), m.enter().append("rect").attr("class", function(g) {
      return "handle handle--" + g.type;
    }).attr("cursor", function(g) {
      return ri[g.type];
    }), f.each(s).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", u);
  }
  o.move = function(f, h) {
    f.selection ? f.on("start.brush", function() {
      c(this, arguments).beforestart().start();
    }).on("interrupt.brush end.brush", function() {
      c(this, arguments).end();
    }).tween("brush", function() {
      var m = this, g = m.__brush, v = c(m, arguments), _ = g.selection, I = e.input(typeof h == "function" ? h.apply(this, arguments) : h, g.extent), M = jl(_, I);
      function k(y) {
        g.selection = y === 1 && ch(I) ? null : M(y), s.call(m), v.brush();
      }
      return _ && I ? k : k(1);
    }) : f.each(function() {
      var m = this, g = arguments, v = m.__brush, _ = e.input(typeof h == "function" ? h.apply(m, g) : h, v.extent), I = c(m, g).beforestart();
      wa(m), v.selection = _ == null || ch(_) ? null : _, s.call(m), I.start().brush().end();
    });
  };
  function s() {
    var f = Vt(this), h = lh(this).selection;
    h ? (f.selectAll(".selection").style("display", null).attr("x", h[0][0]).attr("y", h[0][1]).attr("width", h[1][0] - h[0][0]).attr("height", h[1][1] - h[0][1]), f.selectAll(".handle").style("display", null).attr("x", function(m) {
      return m.type[m.type.length - 1] === "e" ? h[1][0] - i / 2 : h[0][0] - i / 2;
    }).attr("y", function(m) {
      return m.type[0] === "s" ? h[1][1] - i / 2 : h[0][1] - i / 2;
    }).attr("width", function(m) {
      return m.type === "n" || m.type === "s" ? h[1][0] - h[0][0] + i : i;
    }).attr("height", function(m) {
      return m.type === "e" || m.type === "w" ? h[1][1] - h[0][1] + i : i;
    })) : f.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
  }
  function c(f, h) {
    return f.__brush.emitter || new l(f, h);
  }
  function l(f, h) {
    this.that = f, this.args = h, this.state = f.__brush, this.active = 0;
  }
  l.prototype = {
    beforestart: function() {
      return ++this.active === 1 && (this.state.emitter = this, this.starting = !0), this;
    },
    start: function() {
      return this.starting && (this.starting = !1, this.emit("start")), this;
    },
    brush: function() {
      return this.emit("brush"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.state.emitter, this.emit("end")), this;
    },
    emit: function(f) {
      sl(new l$(o, f, e.output(this.state.selection)), r.apply, r, [f, this.that, this.args]);
    }
  };
  function u() {
    if (De.touches) {
      if (De.changedTouches.length < De.touches.length) return Ac();
    } else if (a) return;
    if (!n.apply(this, arguments)) return;
    var f = this, h = De.target.__data__.type, m = (De.metaKey ? h = "overlay" : h) === "selection" ? px : De.altKey ? Ka : Ja, g = e === nu ? null : u$[h], v = e === tu ? null : f$[h], _ = lh(f), I = _.extent, M = _.selection, k = I[0][0], y, x, b = I[0][1], A, w, O = I[1][0], P, E, C = I[1][1], T, D, z, F, W, L = g && v && De.shiftKey, S, j, Y = Di(f), N = Y, X = c(f, arguments).beforestart();
    h === "overlay" ? _.selection = M = [
      [y = e === nu ? k : Y[0], A = e === tu ? b : Y[1]],
      [P = e === nu ? O : y, T = e === tu ? C : A]
    ] : (y = M[0][0], A = M[0][1], P = M[1][0], T = M[1][1]), x = y, w = A, E = P, D = T;
    var G = Vt(f).attr("pointer-events", "none"), q = G.selectAll(".overlay").attr("cursor", ri[h]);
    if (De.touches)
      G.on("touchmove.brush", Q, !0).on("touchend.brush touchcancel.brush", H, !0);
    else {
      var $ = Vt(De.view).on("keydown.brush", K, !0).on("keyup.brush", U, !0).on("mousemove.brush", Q, !0).on("mouseup.brush", H, !0);
      qf(De.view);
    }
    hx(), wa(f), s.call(f), X.start();
    function Q() {
      var ee = Di(f);
      L && !S && !j && (Math.abs(ee[0] - N[0]) > Math.abs(ee[1] - N[1]) ? j = !0 : S = !0), N = ee, W = !0, Ac(), V();
    }
    function V() {
      var ee;
      switch (z = N[0] - Y[0], F = N[1] - Y[1], m) {
        case sh:
        case px: {
          g && (z = Math.max(k - y, Math.min(O - P, z)), x = y + z, E = P + z), v && (F = Math.max(b - A, Math.min(C - T, F)), w = A + F, D = T + F);
          break;
        }
        case Ja: {
          g < 0 ? (z = Math.max(k - y, Math.min(O - y, z)), x = y + z, E = P) : g > 0 && (z = Math.max(k - P, Math.min(O - P, z)), x = y, E = P + z), v < 0 ? (F = Math.max(b - A, Math.min(C - A, F)), w = A + F, D = T) : v > 0 && (F = Math.max(b - T, Math.min(C - T, F)), w = A, D = T + F);
          break;
        }
        case Ka: {
          g && (x = Math.max(k, Math.min(O, y - z * g)), E = Math.max(k, Math.min(O, P + z * g))), v && (w = Math.max(b, Math.min(C, A - F * v)), D = Math.max(b, Math.min(C, T + F * v)));
          break;
        }
      }
      E < x && (g *= -1, ee = y, y = P, P = ee, ee = x, x = E, E = ee, h in mx && q.attr("cursor", ri[h = mx[h]])), D < w && (v *= -1, ee = A, A = T, T = ee, ee = w, w = D, D = ee, h in gx && q.attr("cursor", ri[h = gx[h]])), _.selection && (M = _.selection), S && (x = M[0][0], E = M[1][0]), j && (w = M[0][1], D = M[1][1]), (M[0][0] !== x || M[0][1] !== w || M[1][0] !== E || M[1][1] !== D) && (_.selection = [[x, w], [E, D]], s.call(f), X.brush());
    }
    function H() {
      if (hx(), De.touches) {
        if (De.touches.length) return;
        a && clearTimeout(a), a = setTimeout(function() {
          a = null;
        }, 500), G.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else
        Xf(De.view, W), $.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      G.attr("pointer-events", "all"), q.attr("cursor", ri.overlay), _.selection && (M = _.selection), ch(M) && (_.selection = null, s.call(f)), X.end();
    }
    function K() {
      switch (De.keyCode) {
        case 16: {
          L = g && v;
          break;
        }
        case 18: {
          m === Ja && (g && (P = E - z * g, y = x + z * g), v && (T = D - F * v, A = w + F * v), m = Ka, V());
          break;
        }
        case 32: {
          (m === Ja || m === Ka) && (g < 0 ? P = E - z : g > 0 && (y = x - z), v < 0 ? T = D - F : v > 0 && (A = w - F), m = sh, q.attr("cursor", ri.selection), V());
          break;
        }
        default:
          return;
      }
      Ac();
    }
    function U() {
      switch (De.keyCode) {
        case 16: {
          L && (S = j = L = !1, V());
          break;
        }
        case 18: {
          m === Ka && (g < 0 ? P = E : g > 0 && (y = x), v < 0 ? T = D : v > 0 && (A = w), m = Ja, V());
          break;
        }
        case 32: {
          m === sh && (De.altKey ? (g && (P = E - z * g, y = x + z * g), v && (T = D - F * v, A = w + F * v), m = Ka) : (g < 0 ? P = E : g > 0 && (y = x), v < 0 ? T = D : v > 0 && (A = w), m = Ja), q.attr("cursor", ri[h]), V());
          break;
        }
        default:
          return;
      }
      Ac();
    }
  }
  function d() {
    var f = this.__brush || { selection: null };
    return f.extent = t.apply(this, arguments), f.dim = e, f;
  }
  return o.extent = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : dx([[+f[0][0], +f[0][1]], [+f[1][0], +f[1][1]]]), o) : t;
  }, o.filter = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : dx(!!f), o) : n;
  }, o.handleSize = function(f) {
    return arguments.length ? (i = +f, o) : i;
  }, o.on = function() {
    var f = r.on.apply(r, arguments);
    return f === r ? o : f;
  }, o;
}
var yx = Math.cos, xx = Math.sin, G_ = Math.PI, bc = G_ / 2, vx = G_ * 2, Ax = Math.max;
function x$(e) {
  return function(t, n) {
    return e(
      t.source.value + t.target.value,
      n.source.value + n.target.value
    );
  };
}
function v$() {
  var e = 0, t = null, n = null, r = null;
  function i(a) {
    var o = a.length, s = [], c = Ar(o), l = [], u = [], d = u.groups = new Array(o), f = new Array(o * o), h, m, g, v, _, I;
    for (h = 0, _ = -1; ++_ < o; ) {
      for (m = 0, I = -1; ++I < o; )
        m += a[_][I];
      s.push(m), l.push(Ar(o)), h += m;
    }
    for (t && c.sort(function(O, P) {
      return t(s[O], s[P]);
    }), n && l.forEach(function(O, P) {
      O.sort(function(E, C) {
        return n(a[P][E], a[P][C]);
      });
    }), h = Ax(0, vx - e * o) / h, v = h ? e : vx / o, m = 0, _ = -1; ++_ < o; ) {
      for (g = m, I = -1; ++I < o; ) {
        var M = c[_], k = l[M][I], y = a[M][k], x = m, b = m += y * h;
        f[k * o + M] = {
          index: M,
          subindex: k,
          startAngle: x,
          endAngle: b,
          value: y
        };
      }
      d[M] = {
        index: M,
        startAngle: g,
        endAngle: m,
        value: s[M]
      }, m += v;
    }
    for (_ = -1; ++_ < o; )
      for (I = _ - 1; ++I < o; ) {
        var A = f[I * o + _], w = f[_ * o + I];
        (A.value || w.value) && u.push(A.value < w.value ? { source: w, target: A } : { source: A, target: w });
      }
    return r ? u.sort(r) : u;
  }
  return i.padAngle = function(a) {
    return arguments.length ? (e = Ax(0, a), i) : e;
  }, i.sortGroups = function(a) {
    return arguments.length ? (t = a, i) : t;
  }, i.sortSubgroups = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.sortChords = function(a) {
    return arguments.length ? (a == null ? r = null : (r = x$(a))._ = a, i) : r && r._;
  }, i;
}
var A$ = Array.prototype.slice;
function uh(e) {
  return function() {
    return e;
  };
}
var Lp = Math.PI, zp = 2 * Lp, fa = 1e-6, b$ = zp - fa;
function Bp() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function Zi() {
  return new Bp();
}
Bp.prototype = Zi.prototype = {
  constructor: Bp,
  moveTo: function(e, t) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(e, t) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function(e, t, n, r) {
    this._ += "Q" + +e + "," + +t + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(e, t, n, r, i, a) {
    this._ += "C" + +e + "," + +t + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
  },
  arcTo: function(e, t, n, r, i) {
    e = +e, t = +t, n = +n, r = +r, i = +i;
    var a = this._x1, o = this._y1, s = n - e, c = r - t, l = a - e, u = o - t, d = l * l + u * u;
    if (i < 0) throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);
    else if (d > fa) if (!(Math.abs(u * s - c * l) > fa) || !i)
      this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
    else {
      var f = n - a, h = r - o, m = s * s + c * c, g = f * f + h * h, v = Math.sqrt(m), _ = Math.sqrt(d), I = i * Math.tan((Lp - Math.acos((m + d - g) / (2 * v * _))) / 2), M = I / _, k = I / v;
      Math.abs(M - 1) > fa && (this._ += "L" + (e + M * l) + "," + (t + M * u)), this._ += "A" + i + "," + i + ",0,0," + +(u * f > l * h) + "," + (this._x1 = e + k * s) + "," + (this._y1 = t + k * c);
    }
  },
  arc: function(e, t, n, r, i, a) {
    e = +e, t = +t, n = +n;
    var o = n * Math.cos(r), s = n * Math.sin(r), c = e + o, l = t + s, u = 1 ^ a, d = a ? r - i : i - r;
    if (n < 0) throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + c + "," + l : (Math.abs(this._x1 - c) > fa || Math.abs(this._y1 - l) > fa) && (this._ += "L" + c + "," + l), n && (d < 0 && (d = d % zp + zp), d > b$ ? this._ += "A" + n + "," + n + ",0,1," + u + "," + (e - o) + "," + (t - s) + "A" + n + "," + n + ",0,1," + u + "," + (this._x1 = c) + "," + (this._y1 = l) : d > fa && (this._ += "A" + n + "," + n + ",0," + +(d >= Lp) + "," + u + "," + (this._x1 = e + n * Math.cos(i)) + "," + (this._y1 = t + n * Math.sin(i))));
  },
  rect: function(e, t, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function w$(e) {
  return e.source;
}
function _$(e) {
  return e.target;
}
function S$(e) {
  return e.radius;
}
function C$(e) {
  return e.startAngle;
}
function E$(e) {
  return e.endAngle;
}
function k$() {
  var e = w$, t = _$, n = S$, r = C$, i = E$, a = null;
  function o() {
    var s, c = A$.call(arguments), l = e.apply(this, c), u = t.apply(this, c), d = +n.apply(this, (c[0] = l, c)), f = r.apply(this, c) - bc, h = i.apply(this, c) - bc, m = d * yx(f), g = d * xx(f), v = +n.apply(this, (c[0] = u, c)), _ = r.apply(this, c) - bc, I = i.apply(this, c) - bc;
    if (a || (a = s = Zi()), a.moveTo(m, g), a.arc(0, 0, d, f, h), (f !== _ || h !== I) && (a.quadraticCurveTo(0, 0, v * yx(_), v * xx(_)), a.arc(0, 0, v, _, I)), a.quadraticCurveTo(0, 0, m, g), a.closePath(), s) return a = null, s + "" || null;
  }
  return o.radius = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : uh(+s), o) : n;
  }, o.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : uh(+s), o) : r;
  }, o.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : uh(+s), o) : i;
  }, o.source = function(s) {
    return arguments.length ? (e = s, o) : e;
  }, o.target = function(s) {
    return arguments.length ? (t = s, o) : t;
  }, o.context = function(s) {
    return arguments.length ? (a = s ?? null, o) : a;
  }, o;
}
var ar = "$";
function Nu() {
}
Nu.prototype = Xr.prototype = {
  constructor: Nu,
  has: function(e) {
    return ar + e in this;
  },
  get: function(e) {
    return this[ar + e];
  },
  set: function(e, t) {
    return this[ar + e] = t, this;
  },
  remove: function(e) {
    var t = ar + e;
    return t in this && delete this[t];
  },
  clear: function() {
    for (var e in this) e[0] === ar && delete this[e];
  },
  keys: function() {
    var e = [];
    for (var t in this) t[0] === ar && e.push(t.slice(1));
    return e;
  },
  values: function() {
    var e = [];
    for (var t in this) t[0] === ar && e.push(this[t]);
    return e;
  },
  entries: function() {
    var e = [];
    for (var t in this) t[0] === ar && e.push({ key: t.slice(1), value: this[t] });
    return e;
  },
  size: function() {
    var e = 0;
    for (var t in this) t[0] === ar && ++e;
    return e;
  },
  empty: function() {
    for (var e in this) if (e[0] === ar) return !1;
    return !0;
  },
  each: function(e) {
    for (var t in this) t[0] === ar && e(this[t], t.slice(1), this);
  }
};
function Xr(e, t) {
  var n = new Nu();
  if (e instanceof Nu) e.each(function(s, c) {
    n.set(c, s);
  });
  else if (Array.isArray(e)) {
    var r = -1, i = e.length, a;
    if (t == null) for (; ++r < i; ) n.set(r, e[r]);
    else for (; ++r < i; ) n.set(t(a = e[r], r, e), a);
  } else if (e) for (var o in e) n.set(o, e[o]);
  return n;
}
function T$() {
  var e = [], t = [], n, r, i;
  function a(s, c, l, u) {
    if (c >= e.length)
      return n != null && s.sort(n), r != null ? r(s) : s;
    for (var d = -1, f = s.length, h = e[c++], m, g, v = Xr(), _, I = l(); ++d < f; )
      (_ = v.get(m = h(g = s[d]) + "")) ? _.push(g) : v.set(m, [g]);
    return v.each(function(M, k) {
      u(I, k, a(M, c, l, u));
    }), I;
  }
  function o(s, c) {
    if (++c > e.length) return s;
    var l, u = t[c - 1];
    return r != null && c >= e.length ? l = s.entries() : (l = [], s.each(function(d, f) {
      l.push({ key: f, values: o(d, c) });
    })), u != null ? l.sort(function(d, f) {
      return u(d.key, f.key);
    }) : l;
  }
  return i = {
    object: function(s) {
      return a(s, 0, M$, I$);
    },
    map: function(s) {
      return a(s, 0, bx, wx);
    },
    entries: function(s) {
      return o(a(s, 0, bx, wx), 0);
    },
    key: function(s) {
      return e.push(s), i;
    },
    sortKeys: function(s) {
      return t[e.length - 1] = s, i;
    },
    sortValues: function(s) {
      return n = s, i;
    },
    rollup: function(s) {
      return r = s, i;
    }
  };
}
function M$() {
  return {};
}
function I$(e, t, n) {
  e[t] = n;
}
function bx() {
  return Xr();
}
function wx(e, t, n) {
  e.set(t, n);
}
function Ou() {
}
var ca = Xr.prototype;
Ou.prototype = V_.prototype = {
  constructor: Ou,
  has: ca.has,
  add: function(e) {
    return e += "", this[ar + e] = e, this;
  },
  remove: ca.remove,
  clear: ca.clear,
  values: ca.keys,
  size: ca.size,
  empty: ca.empty,
  each: ca.each
};
function V_(e, t) {
  var n = new Ou();
  if (e instanceof Ou) e.each(function(a) {
    n.add(a);
  });
  else if (e) {
    var r = -1, i = e.length;
    if (t == null) for (; ++r < i; ) n.add(e[r]);
    else for (; ++r < i; ) n.add(t(e[r], r, e));
  }
  return n;
}
function N$(e) {
  var t = [];
  for (var n in e) t.push(n);
  return t;
}
function O$(e) {
  var t = [];
  for (var n in e) t.push(e[n]);
  return t;
}
function R$(e) {
  var t = [];
  for (var n in e) t.push({ key: n, value: e[n] });
  return t;
}
var _x = {}, fh = {}, dh = 34, fs = 10, hh = 13;
function Q_(e) {
  return new Function("d", "return {" + e.map(function(t, n) {
    return JSON.stringify(t) + ": d[" + n + "]";
  }).join(",") + "}");
}
function D$(e, t) {
  var n = Q_(e);
  return function(r, i) {
    return t(n(r), i, e);
  };
}
function P$(e) {
  var t = /* @__PURE__ */ Object.create(null), n = [];
  return e.forEach(function(r) {
    for (var i in r)
      i in t || n.push(t[i] = i);
  }), n;
}
function Hg(e) {
  var t = new RegExp('["' + e + `
\r]`), n = e.charCodeAt(0);
  function r(l, u) {
    var d, f, h = i(l, function(m, g) {
      if (d) return d(m, g - 1);
      f = m, d = u ? D$(m, u) : Q_(m);
    });
    return h.columns = f || [], h;
  }
  function i(l, u) {
    var d = [], f = l.length, h = 0, m = 0, g, v = f <= 0, _ = !1;
    l.charCodeAt(f - 1) === fs && --f, l.charCodeAt(f - 1) === hh && --f;
    function I() {
      if (v) return fh;
      if (_) return _ = !1, _x;
      var k, y = h, x;
      if (l.charCodeAt(y) === dh) {
        for (; h++ < f && l.charCodeAt(h) !== dh || l.charCodeAt(++h) === dh; ) ;
        return (k = h) >= f ? v = !0 : (x = l.charCodeAt(h++)) === fs ? _ = !0 : x === hh && (_ = !0, l.charCodeAt(h) === fs && ++h), l.slice(y + 1, k - 1).replace(/""/g, '"');
      }
      for (; h < f; ) {
        if ((x = l.charCodeAt(k = h++)) === fs) _ = !0;
        else if (x === hh)
          _ = !0, l.charCodeAt(h) === fs && ++h;
        else if (x !== n) continue;
        return l.slice(y, k);
      }
      return v = !0, l.slice(y, f);
    }
    for (; (g = I()) !== fh; ) {
      for (var M = []; g !== _x && g !== fh; ) M.push(g), g = I();
      u && (M = u(M, m++)) == null || d.push(M);
    }
    return d;
  }
  function a(l, u) {
    return u == null && (u = P$(l)), [u.map(c).join(e)].concat(l.map(function(d) {
      return u.map(function(f) {
        return c(d[f]);
      }).join(e);
    })).join(`
`);
  }
  function o(l) {
    return l.map(s).join(`
`);
  }
  function s(l) {
    return l.map(c).join(e);
  }
  function c(l) {
    return l == null ? "" : t.test(l += "") ? '"' + l.replace(/"/g, '""') + '"' : l;
  }
  return {
    parse: r,
    parseRows: i,
    format: a,
    formatRows: o
  };
}
var rd = Hg(","), q_ = rd.parse, L$ = rd.parseRows, z$ = rd.format, B$ = rd.formatRows, id = Hg("	"), X_ = id.parse, F$ = id.parseRows, $$ = id.format, Y$ = id.formatRows;
function j$(e, t) {
  var n;
  e == null && (e = 0), t == null && (t = 0);
  function r() {
    var i, a = n.length, o, s = 0, c = 0;
    for (i = 0; i < a; ++i)
      o = n[i], s += o.x, c += o.y;
    for (s = s / a - e, c = c / a - t, i = 0; i < a; ++i)
      o = n[i], o.x -= s, o.y -= c;
  }
  return r.initialize = function(i) {
    n = i;
  }, r.x = function(i) {
    return arguments.length ? (e = +i, r) : e;
  }, r.y = function(i) {
    return arguments.length ? (t = +i, r) : t;
  }, r;
}
function Jt(e) {
  return function() {
    return e;
  };
}
function Pi() {
  return (Math.random() - 0.5) * 1e-6;
}
function W$(e) {
  var t = +this._x.call(null, e), n = +this._y.call(null, e);
  return J_(this.cover(t, n), t, n, e);
}
function J_(e, t, n, r) {
  if (isNaN(t) || isNaN(n)) return e;
  var i, a = e._root, o = { data: r }, s = e._x0, c = e._y0, l = e._x1, u = e._y1, d, f, h, m, g, v, _, I;
  if (!a) return e._root = o, e;
  for (; a.length; )
    if ((g = t >= (d = (s + l) / 2)) ? s = d : l = d, (v = n >= (f = (c + u) / 2)) ? c = f : u = f, i = a, !(a = a[_ = v << 1 | g])) return i[_] = o, e;
  if (h = +e._x.call(null, a.data), m = +e._y.call(null, a.data), t === h && n === m) return o.next = a, i ? i[_] = o : e._root = o, e;
  do
    i = i ? i[_] = new Array(4) : e._root = new Array(4), (g = t >= (d = (s + l) / 2)) ? s = d : l = d, (v = n >= (f = (c + u) / 2)) ? c = f : u = f;
  while ((_ = v << 1 | g) === (I = (m >= f) << 1 | h >= d));
  return i[I] = a, i[_] = o, e;
}
function H$(e) {
  var t, n, r = e.length, i, a, o = new Array(r), s = new Array(r), c = 1 / 0, l = 1 / 0, u = -1 / 0, d = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(i = +this._x.call(null, t = e[n])) || isNaN(a = +this._y.call(null, t)) || (o[n] = i, s[n] = a, i < c && (c = i), i > u && (u = i), a < l && (l = a), a > d && (d = a));
  for (u < c && (c = this._x0, u = this._x1), d < l && (l = this._y0, d = this._y1), this.cover(c, l).cover(u, d), n = 0; n < r; ++n)
    J_(this, o[n], s[n], e[n]);
  return this;
}
function U$(e, t) {
  if (isNaN(e = +e) || isNaN(t = +t)) return this;
  var n = this._x0, r = this._y0, i = this._x1, a = this._y1;
  if (isNaN(n))
    i = (n = Math.floor(e)) + 1, a = (r = Math.floor(t)) + 1;
  else if (n > e || e > i || r > t || t > a) {
    var o = i - n, s = this._root, c, l;
    switch (l = (t < (r + a) / 2) << 1 | e < (n + i) / 2) {
      case 0: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, i = n + o, a = r + o, e > i || t > a);
        break;
      }
      case 1: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, n = i - o, a = r + o, n > e || t > a);
        break;
      }
      case 2: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, i = n + o, r = a - o, e > i || r > t);
        break;
      }
      case 3: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, n = i - o, r = a - o, n > e || r > t);
        break;
      }
    }
    this._root && this._root.length && (this._root = s);
  } else return this;
  return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this;
}
function G$() {
  var e = [];
  return this.visit(function(t) {
    if (!t.length) do
      e.push(t.data);
    while (t = t.next);
  }), e;
}
function V$(e) {
  return arguments.length ? this.cover(+e[0][0], +e[0][1]).cover(+e[1][0], +e[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Tn(e, t, n, r, i) {
  this.node = e, this.x0 = t, this.y0 = n, this.x1 = r, this.y1 = i;
}
function Q$(e, t, n) {
  var r, i = this._x0, a = this._y0, o, s, c, l, u = this._x1, d = this._y1, f = [], h = this._root, m, g;
  for (h && f.push(new Tn(h, i, a, u, d)), n == null ? n = 1 / 0 : (i = e - n, a = t - n, u = e + n, d = t + n, n *= n); m = f.pop(); )
    if (!(!(h = m.node) || (o = m.x0) > u || (s = m.y0) > d || (c = m.x1) < i || (l = m.y1) < a))
      if (h.length) {
        var v = (o + c) / 2, _ = (s + l) / 2;
        f.push(
          new Tn(h[3], v, _, c, l),
          new Tn(h[2], o, _, v, l),
          new Tn(h[1], v, s, c, _),
          new Tn(h[0], o, s, v, _)
        ), (g = (t >= _) << 1 | e >= v) && (m = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - g], f[f.length - 1 - g] = m);
      } else {
        var I = e - +this._x.call(null, h.data), M = t - +this._y.call(null, h.data), k = I * I + M * M;
        if (k < n) {
          var y = Math.sqrt(n = k);
          i = e - y, a = t - y, u = e + y, d = t + y, r = h.data;
        }
      }
  return r;
}
function q$(e) {
  if (isNaN(u = +this._x.call(null, e)) || isNaN(d = +this._y.call(null, e))) return this;
  var t, n = this._root, r, i, a, o = this._x0, s = this._y0, c = this._x1, l = this._y1, u, d, f, h, m, g, v, _;
  if (!n) return this;
  if (n.length) for (; ; ) {
    if ((m = u >= (f = (o + c) / 2)) ? o = f : c = f, (g = d >= (h = (s + l) / 2)) ? s = h : l = h, t = n, !(n = n[v = g << 1 | m])) return this;
    if (!n.length) break;
    (t[v + 1 & 3] || t[v + 2 & 3] || t[v + 3 & 3]) && (r = t, _ = v);
  }
  for (; n.data !== e; ) if (i = n, !(n = n.next)) return this;
  return (a = n.next) && delete n.next, i ? (a ? i.next = a : delete i.next, this) : t ? (a ? t[v] = a : delete t[v], (n = t[0] || t[1] || t[2] || t[3]) && n === (t[3] || t[2] || t[1] || t[0]) && !n.length && (r ? r[_] = n : this._root = n), this) : (this._root = a, this);
}
function X$(e) {
  for (var t = 0, n = e.length; t < n; ++t) this.remove(e[t]);
  return this;
}
function J$() {
  return this._root;
}
function K$() {
  var e = 0;
  return this.visit(function(t) {
    if (!t.length) do
      ++e;
    while (t = t.next);
  }), e;
}
function Z$(e) {
  var t = [], n, r = this._root, i, a, o, s, c;
  for (r && t.push(new Tn(r, this._x0, this._y0, this._x1, this._y1)); n = t.pop(); )
    if (!e(r = n.node, a = n.x0, o = n.y0, s = n.x1, c = n.y1) && r.length) {
      var l = (a + s) / 2, u = (o + c) / 2;
      (i = r[3]) && t.push(new Tn(i, l, u, s, c)), (i = r[2]) && t.push(new Tn(i, a, u, l, c)), (i = r[1]) && t.push(new Tn(i, l, o, s, u)), (i = r[0]) && t.push(new Tn(i, a, o, l, u));
    }
  return this;
}
function eY(e) {
  var t = [], n = [], r;
  for (this._root && t.push(new Tn(this._root, this._x0, this._y0, this._x1, this._y1)); r = t.pop(); ) {
    var i = r.node;
    if (i.length) {
      var a, o = r.x0, s = r.y0, c = r.x1, l = r.y1, u = (o + c) / 2, d = (s + l) / 2;
      (a = i[0]) && t.push(new Tn(a, o, s, u, d)), (a = i[1]) && t.push(new Tn(a, u, s, c, d)), (a = i[2]) && t.push(new Tn(a, o, d, u, l)), (a = i[3]) && t.push(new Tn(a, u, d, c, l));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    e(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function tY(e) {
  return e[0];
}
function nY(e) {
  return arguments.length ? (this._x = e, this) : this._x;
}
function rY(e) {
  return e[1];
}
function iY(e) {
  return arguments.length ? (this._y = e, this) : this._y;
}
function ad(e, t, n) {
  var r = new Ug(t ?? tY, n ?? rY, NaN, NaN, NaN, NaN);
  return e == null ? r : r.addAll(e);
}
function Ug(e, t, n, r, i, a) {
  this._x = e, this._y = t, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this._root = void 0;
}
function Sx(e) {
  for (var t = { data: e.data }, n = t; e = e.next; ) n = n.next = { data: e.data };
  return t;
}
var Nn = ad.prototype = Ug.prototype;
Nn.copy = function() {
  var e = new Ug(this._x, this._y, this._x0, this._y0, this._x1, this._y1), t = this._root, n, r;
  if (!t) return e;
  if (!t.length) return e._root = Sx(t), e;
  for (n = [{ source: t, target: e._root = new Array(4) }]; t = n.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = t.source[i]) && (r.length ? n.push({ source: r, target: t.target[i] = new Array(4) }) : t.target[i] = Sx(r));
  return e;
};
Nn.add = W$;
Nn.addAll = H$;
Nn.cover = U$;
Nn.data = G$;
Nn.extent = V$;
Nn.find = Q$;
Nn.remove = q$;
Nn.removeAll = X$;
Nn.root = J$;
Nn.size = K$;
Nn.visit = Z$;
Nn.visitAfter = eY;
Nn.x = nY;
Nn.y = iY;
function aY(e) {
  return e.x + e.vx;
}
function oY(e) {
  return e.y + e.vy;
}
function sY(e) {
  var t, n, r = 1, i = 1;
  typeof e != "function" && (e = Jt(e == null ? 1 : +e));
  function a() {
    for (var c, l = t.length, u, d, f, h, m, g, v = 0; v < i; ++v)
      for (u = ad(t, aY, oY).visitAfter(o), c = 0; c < l; ++c)
        d = t[c], m = n[d.index], g = m * m, f = d.x + d.vx, h = d.y + d.vy, u.visit(_);
    function _(I, M, k, y, x) {
      var b = I.data, A = I.r, w = m + A;
      if (b) {
        if (b.index > d.index) {
          var O = f - b.x - b.vx, P = h - b.y - b.vy, E = O * O + P * P;
          E < w * w && (O === 0 && (O = Pi(), E += O * O), P === 0 && (P = Pi(), E += P * P), E = (w - (E = Math.sqrt(E))) / E * r, d.vx += (O *= E) * (w = (A *= A) / (g + A)), d.vy += (P *= E) * w, b.vx -= O * (w = 1 - w), b.vy -= P * w);
        }
        return;
      }
      return M > f + w || y < f - w || k > h + w || x < h - w;
    }
  }
  function o(c) {
    if (c.data) return c.r = n[c.data.index];
    for (var l = c.r = 0; l < 4; ++l)
      c[l] && c[l].r > c.r && (c.r = c[l].r);
  }
  function s() {
    if (t) {
      var c, l = t.length, u;
      for (n = new Array(l), c = 0; c < l; ++c) u = t[c], n[u.index] = +e(u, c, t);
    }
  }
  return a.initialize = function(c) {
    t = c, s();
  }, a.iterations = function(c) {
    return arguments.length ? (i = +c, a) : i;
  }, a.strength = function(c) {
    return arguments.length ? (r = +c, a) : r;
  }, a.radius = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Jt(+c), s(), a) : e;
  }, a;
}
function lY(e) {
  return e.index;
}
function Cx(e, t) {
  var n = e.get(t);
  if (!n) throw new Error("missing: " + t);
  return n;
}
function cY(e) {
  var t = lY, n = u, r, i = Jt(30), a, o, s, c, l = 1;
  e == null && (e = []);
  function u(g) {
    return 1 / Math.min(s[g.source.index], s[g.target.index]);
  }
  function d(g) {
    for (var v = 0, _ = e.length; v < l; ++v)
      for (var I = 0, M, k, y, x, b, A, w; I < _; ++I)
        M = e[I], k = M.source, y = M.target, x = y.x + y.vx - k.x - k.vx || Pi(), b = y.y + y.vy - k.y - k.vy || Pi(), A = Math.sqrt(x * x + b * b), A = (A - a[I]) / A * g * r[I], x *= A, b *= A, y.vx -= x * (w = c[I]), y.vy -= b * w, k.vx += x * (w = 1 - w), k.vy += b * w;
  }
  function f() {
    if (o) {
      var g, v = o.length, _ = e.length, I = Xr(o, t), M;
      for (g = 0, s = new Array(v); g < _; ++g)
        M = e[g], M.index = g, typeof M.source != "object" && (M.source = Cx(I, M.source)), typeof M.target != "object" && (M.target = Cx(I, M.target)), s[M.source.index] = (s[M.source.index] || 0) + 1, s[M.target.index] = (s[M.target.index] || 0) + 1;
      for (g = 0, c = new Array(_); g < _; ++g)
        M = e[g], c[g] = s[M.source.index] / (s[M.source.index] + s[M.target.index]);
      r = new Array(_), h(), a = new Array(_), m();
    }
  }
  function h() {
    if (o)
      for (var g = 0, v = e.length; g < v; ++g)
        r[g] = +n(e[g], g, e);
  }
  function m() {
    if (o)
      for (var g = 0, v = e.length; g < v; ++g)
        a[g] = +i(e[g], g, e);
  }
  return d.initialize = function(g) {
    o = g, f();
  }, d.links = function(g) {
    return arguments.length ? (e = g, f(), d) : e;
  }, d.id = function(g) {
    return arguments.length ? (t = g, d) : t;
  }, d.iterations = function(g) {
    return arguments.length ? (l = +g, d) : l;
  }, d.strength = function(g) {
    return arguments.length ? (n = typeof g == "function" ? g : Jt(+g), h(), d) : n;
  }, d.distance = function(g) {
    return arguments.length ? (i = typeof g == "function" ? g : Jt(+g), m(), d) : i;
  }, d;
}
function uY(e) {
  return e.x;
}
function fY(e) {
  return e.y;
}
var dY = 10, hY = Math.PI * (3 - Math.sqrt(5));
function pY(e) {
  var t, n = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), a = 0, o = 0.6, s = Xr(), c = td(u), l = Ji("tick", "end");
  e == null && (e = []);
  function u() {
    d(), l.call("tick", t), n < r && (c.stop(), l.call("end", t));
  }
  function d() {
    var m, g = e.length, v;
    for (n += (a - n) * i, s.each(function(_) {
      _(n);
    }), m = 0; m < g; ++m)
      v = e[m], v.fx == null ? v.x += v.vx *= o : (v.x = v.fx, v.vx = 0), v.fy == null ? v.y += v.vy *= o : (v.y = v.fy, v.vy = 0);
  }
  function f() {
    for (var m = 0, g = e.length, v; m < g; ++m) {
      if (v = e[m], v.index = m, isNaN(v.x) || isNaN(v.y)) {
        var _ = dY * Math.sqrt(m), I = m * hY;
        v.x = _ * Math.cos(I), v.y = _ * Math.sin(I);
      }
      (isNaN(v.vx) || isNaN(v.vy)) && (v.vx = v.vy = 0);
    }
  }
  function h(m) {
    return m.initialize && m.initialize(e), m;
  }
  return f(), t = {
    tick: d,
    restart: function() {
      return c.restart(u), t;
    },
    stop: function() {
      return c.stop(), t;
    },
    nodes: function(m) {
      return arguments.length ? (e = m, f(), s.each(h), t) : e;
    },
    alpha: function(m) {
      return arguments.length ? (n = +m, t) : n;
    },
    alphaMin: function(m) {
      return arguments.length ? (r = +m, t) : r;
    },
    alphaDecay: function(m) {
      return arguments.length ? (i = +m, t) : +i;
    },
    alphaTarget: function(m) {
      return arguments.length ? (a = +m, t) : a;
    },
    velocityDecay: function(m) {
      return arguments.length ? (o = 1 - m, t) : 1 - o;
    },
    force: function(m, g) {
      return arguments.length > 1 ? (g == null ? s.remove(m) : s.set(m, h(g)), t) : s.get(m);
    },
    find: function(m, g, v) {
      var _ = 0, I = e.length, M, k, y, x, b;
      for (v == null ? v = 1 / 0 : v *= v, _ = 0; _ < I; ++_)
        x = e[_], M = m - x.x, k = g - x.y, y = M * M + k * k, y < v && (b = x, v = y);
      return b;
    },
    on: function(m, g) {
      return arguments.length > 1 ? (l.on(m, g), t) : l.on(m);
    }
  };
}
function mY() {
  var e, t, n, r = Jt(-30), i, a = 1, o = 1 / 0, s = 0.81;
  function c(f) {
    var h, m = e.length, g = ad(e, uY, fY).visitAfter(u);
    for (n = f, h = 0; h < m; ++h) t = e[h], g.visit(d);
  }
  function l() {
    if (e) {
      var f, h = e.length, m;
      for (i = new Array(h), f = 0; f < h; ++f) m = e[f], i[m.index] = +r(m, f, e);
    }
  }
  function u(f) {
    var h = 0, m, g, v = 0, _, I, M;
    if (f.length) {
      for (_ = I = M = 0; M < 4; ++M)
        (m = f[M]) && (g = Math.abs(m.value)) && (h += m.value, v += g, _ += g * m.x, I += g * m.y);
      f.x = _ / v, f.y = I / v;
    } else {
      m = f, m.x = m.data.x, m.y = m.data.y;
      do
        h += i[m.data.index];
      while (m = m.next);
    }
    f.value = h;
  }
  function d(f, h, m, g) {
    if (!f.value) return !0;
    var v = f.x - t.x, _ = f.y - t.y, I = g - h, M = v * v + _ * _;
    if (I * I / s < M)
      return M < o && (v === 0 && (v = Pi(), M += v * v), _ === 0 && (_ = Pi(), M += _ * _), M < a && (M = Math.sqrt(a * M)), t.vx += v * f.value * n / M, t.vy += _ * f.value * n / M), !0;
    if (f.length || M >= o) return;
    (f.data !== t || f.next) && (v === 0 && (v = Pi(), M += v * v), _ === 0 && (_ = Pi(), M += _ * _), M < a && (M = Math.sqrt(a * M)));
    do
      f.data !== t && (I = i[f.data.index] * n / M, t.vx += v * I, t.vy += _ * I);
    while (f = f.next);
  }
  return c.initialize = function(f) {
    e = f, l();
  }, c.strength = function(f) {
    return arguments.length ? (r = typeof f == "function" ? f : Jt(+f), l(), c) : r;
  }, c.distanceMin = function(f) {
    return arguments.length ? (a = f * f, c) : Math.sqrt(a);
  }, c.distanceMax = function(f) {
    return arguments.length ? (o = f * f, c) : Math.sqrt(o);
  }, c.theta = function(f) {
    return arguments.length ? (s = f * f, c) : Math.sqrt(s);
  }, c;
}
function gY(e, t, n) {
  var r, i = Jt(0.1), a, o;
  typeof e != "function" && (e = Jt(+e)), t == null && (t = 0), n == null && (n = 0);
  function s(l) {
    for (var u = 0, d = r.length; u < d; ++u) {
      var f = r[u], h = f.x - t || 1e-6, m = f.y - n || 1e-6, g = Math.sqrt(h * h + m * m), v = (o[u] - g) * a[u] * l / g;
      f.vx += h * v, f.vy += m * v;
    }
  }
  function c() {
    if (r) {
      var l, u = r.length;
      for (a = new Array(u), o = new Array(u), l = 0; l < u; ++l)
        o[l] = +e(r[l], l, r), a[l] = isNaN(o[l]) ? 0 : +i(r[l], l, r);
    }
  }
  return s.initialize = function(l) {
    r = l, c();
  }, s.strength = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : Jt(+l), c(), s) : i;
  }, s.radius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Jt(+l), c(), s) : e;
  }, s.x = function(l) {
    return arguments.length ? (t = +l, s) : t;
  }, s.y = function(l) {
    return arguments.length ? (n = +l, s) : n;
  }, s;
}
function yY(e) {
  var t = Jt(0.1), n, r, i;
  typeof e != "function" && (e = Jt(e == null ? 0 : +e));
  function a(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vx += (i[c] - u.x) * r[c] * s;
  }
  function o() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return a.initialize = function(s) {
    n = s, o();
  }, a.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Jt(+s), o(), a) : t;
  }, a.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Jt(+s), o(), a) : e;
  }, a;
}
function xY(e) {
  var t = Jt(0.1), n, r, i;
  typeof e != "function" && (e = Jt(e == null ? 0 : +e));
  function a(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vy += (i[c] - u.y) * r[c] * s;
  }
  function o() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return a.initialize = function(s) {
    n = s, o();
  }, a.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Jt(+s), o(), a) : t;
  }, a.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Jt(+s), o(), a) : e;
  }, a;
}
function Ru(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function Io(e) {
  return e = Ru(Math.abs(e)), e ? e[1] : NaN;
}
function vY(e, t) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(n.substring(i -= s, i + s)), !((c += s + 1) > r)); )
      s = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function AY(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
function bY(e, t) {
  e = e.toPrecision(t);
  e: for (var n = e.length, r = 1, i = -1, a; r < n; ++r)
    switch (e[r]) {
      case ".":
        i = a = r;
        break;
      case "0":
        i === 0 && (i = r), a = r;
        break;
      case "e":
        break e;
      default:
        i > 0 && (i = 0);
        break;
    }
  return i > 0 ? e.slice(0, i) + e.slice(a + 1) : e;
}
var K_;
function wY(e, t) {
  var n = Ru(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], a = i - (K_ = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + Ru(e, Math.max(0, t + a - 1))[0];
}
function Ex(e, t) {
  var n = Ru(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Z_ = {
  "": bY,
  "%": function(e, t) {
    return (e * 100).toFixed(t);
  },
  b: function(e) {
    return Math.round(e).toString(2);
  },
  c: function(e) {
    return e + "";
  },
  d: function(e) {
    return Math.round(e).toString(10);
  },
  e: function(e, t) {
    return e.toExponential(t);
  },
  f: function(e, t) {
    return e.toFixed(t);
  },
  g: function(e, t) {
    return e.toPrecision(t);
  },
  o: function(e) {
    return Math.round(e).toString(8);
  },
  p: function(e, t) {
    return Ex(e * 100, t);
  },
  r: Ex,
  s: wY,
  X: function(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function(e) {
    return Math.round(e).toString(16);
  }
};
var _Y = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
function gl(e) {
  return new Gg(e);
}
gl.prototype = Gg.prototype;
function Gg(e) {
  if (!(t = _Y.exec(e))) throw new Error("invalid format: " + e);
  var t, n = t[1] || " ", r = t[2] || ">", i = t[3] || "-", a = t[4] || "", o = !!t[5], s = t[6] && +t[6], c = !!t[7], l = t[8] && +t[8].slice(1), u = t[9] || "";
  u === "n" ? (c = !0, u = "g") : Z_[u] || (u = ""), (o || n === "0" && r === "=") && (o = !0, n = "0", r = "="), this.fill = n, this.align = r, this.sign = i, this.symbol = a, this.zero = o, this.width = s, this.comma = c, this.precision = l, this.type = u;
}
Gg.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + this.type;
};
function kx(e) {
  return e;
}
var Tx = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function eS(e) {
  var t = e.grouping && e.thousands ? vY(e.grouping, e.thousands) : kx, n = e.currency, r = e.decimal, i = e.numerals ? AY(e.numerals) : kx, a = e.percent || "%";
  function o(c) {
    c = gl(c);
    var l = c.fill, u = c.align, d = c.sign, f = c.symbol, h = c.zero, m = c.width, g = c.comma, v = c.precision, _ = c.type, I = f === "$" ? n[0] : f === "#" && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "", M = f === "$" ? n[1] : /[%p]/.test(_) ? a : "", k = Z_[_], y = !_ || /[defgprs%]/.test(_);
    v = v == null ? _ ? 6 : 12 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function x(b) {
      var A = I, w = M, O, P, E;
      if (_ === "c")
        w = k(b) + w, b = "";
      else {
        b = +b;
        var C = b < 0;
        if (b = k(Math.abs(b), v), C && +b == 0 && (C = !1), A = (C ? d === "(" ? d : "-" : d === "-" || d === "(" ? "" : d) + A, w = (_ === "s" ? Tx[8 + K_ / 3] : "") + w + (C && d === "(" ? ")" : ""), y) {
          for (O = -1, P = b.length; ++O < P; )
            if (E = b.charCodeAt(O), 48 > E || E > 57) {
              w = (E === 46 ? r + b.slice(O + 1) : b.slice(O)) + w, b = b.slice(0, O);
              break;
            }
        }
      }
      g && !h && (b = t(b, 1 / 0));
      var T = A.length + b.length + w.length, D = T < m ? new Array(m - T + 1).join(l) : "";
      switch (g && h && (b = t(D + b, D.length ? m - w.length : 1 / 0), D = ""), u) {
        case "<":
          b = A + b + w + D;
          break;
        case "=":
          b = A + D + b + w;
          break;
        case "^":
          b = D.slice(0, T = D.length >> 1) + A + b + w + D.slice(T);
          break;
        default:
          b = D + A + b + w;
          break;
      }
      return i(b);
    }
    return x.toString = function() {
      return c + "";
    }, x;
  }
  function s(c, l) {
    var u = o((c = gl(c), c.type = "f", c)), d = Math.max(-8, Math.min(8, Math.floor(Io(l) / 3))) * 3, f = Math.pow(10, -d), h = Tx[8 + d / 3];
    return function(m) {
      return u(f * m) + h;
    };
  }
  return {
    format: o,
    formatPrefix: s
  };
}
var wc, od, Vg;
tS({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function tS(e) {
  return wc = eS(e), od = wc.format, Vg = wc.formatPrefix, wc;
}
function nS(e) {
  return Math.max(0, -Io(Math.abs(e)));
}
function rS(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Io(t) / 3))) * 3 - Io(Math.abs(e)));
}
function iS(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Io(t) - Io(e)) + 1;
}
function ea() {
  return new Du();
}
function Du() {
  this.reset();
}
Du.prototype = {
  constructor: Du,
  reset: function() {
    this.s = // rounded value
    this.t = 0;
  },
  add: function(e) {
    Mx(_c, e, this.t), Mx(this, _c.s, this.s), this.s ? this.t += _c.t : this.s = _c.t;
  },
  valueOf: function() {
    return this.s;
  }
};
var _c = new Du();
function Mx(e, t, n) {
  var r = e.s = t + n, i = r - t, a = r - i;
  e.t = t - a + (n - i);
}
var Ye = 1e-6, Ix = 1e-12, it = Math.PI, Gt = it / 2, Pu = it / 4, Ln = it * 2, Tt = 180 / it, Ue = it / 180, ft = Math.abs, Vo = Math.atan, In = Math.atan2, Fe = Math.cos, Sc = Math.ceil, aS = Math.exp, Lu = Math.log, ph = Math.pow, Le = Math.sin, yl = Math.sign || function(e) {
  return e > 0 ? 1 : e < 0 ? -1 : 0;
}, Zt = Math.sqrt, Qg = Math.tan;
function oS(e) {
  return e > 1 ? 0 : e < -1 ? it : Math.acos(e);
}
function Zn(e) {
  return e > 1 ? Gt : e < -1 ? -Gt : Math.asin(e);
}
function Nx(e) {
  return (e = Le(e / 2)) * e;
}
function zt() {
}
function zu(e, t) {
  e && Rx.hasOwnProperty(e.type) && Rx[e.type](e, t);
}
var Ox = {
  Feature: function(e, t) {
    zu(e.geometry, t);
  },
  FeatureCollection: function(e, t) {
    for (var n = e.features, r = -1, i = n.length; ++r < i; ) zu(n[r].geometry, t);
  }
}, Rx = {
  Sphere: function(e, t) {
    t.sphere();
  },
  Point: function(e, t) {
    e = e.coordinates, t.point(e[0], e[1], e[2]);
  },
  MultiPoint: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) e = n[r], t.point(e[0], e[1], e[2]);
  },
  LineString: function(e, t) {
    Fp(e.coordinates, t, 0);
  },
  MultiLineString: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) Fp(n[r], t, 0);
  },
  Polygon: function(e, t) {
    Dx(e.coordinates, t);
  },
  MultiPolygon: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) Dx(n[r], t);
  },
  GeometryCollection: function(e, t) {
    for (var n = e.geometries, r = -1, i = n.length; ++r < i; ) zu(n[r], t);
  }
};
function Fp(e, t, n) {
  var r = -1, i = e.length - n, a;
  for (t.lineStart(); ++r < i; ) a = e[r], t.point(a[0], a[1], a[2]);
  t.lineEnd();
}
function Dx(e, t) {
  var n = -1, r = e.length;
  for (t.polygonStart(); ++n < r; ) Fp(e[n], t, 1);
  t.polygonEnd();
}
function yr(e, t) {
  e && Ox.hasOwnProperty(e.type) ? Ox[e.type](e, t) : zu(e, t);
}
var Bu = ea(), Fu = ea(), sS, lS, $p, Yp, jp, Jr = {
  point: zt,
  lineStart: zt,
  lineEnd: zt,
  polygonStart: function() {
    Bu.reset(), Jr.lineStart = SY, Jr.lineEnd = CY;
  },
  polygonEnd: function() {
    var e = +Bu;
    Fu.add(e < 0 ? Ln + e : e), this.lineStart = this.lineEnd = this.point = zt;
  },
  sphere: function() {
    Fu.add(Ln);
  }
};
function SY() {
  Jr.point = EY;
}
function CY() {
  cS(sS, lS);
}
function EY(e, t) {
  Jr.point = cS, sS = e, lS = t, e *= Ue, t *= Ue, $p = e, Yp = Fe(t = t / 2 + Pu), jp = Le(t);
}
function cS(e, t) {
  e *= Ue, t *= Ue, t = t / 2 + Pu;
  var n = e - $p, r = n >= 0 ? 1 : -1, i = r * n, a = Fe(t), o = Le(t), s = jp * o, c = Yp * a + s * Fe(i), l = s * r * Le(i);
  Bu.add(In(l, c)), $p = e, Yp = a, jp = o;
}
function kY(e) {
  return Fu.reset(), yr(e, Jr), Fu * 2;
}
function $u(e) {
  return [In(e[1], e[0]), Zn(e[2])];
}
function Ia(e) {
  var t = e[0], n = e[1], r = Fe(n);
  return [r * Fe(t), r * Le(t), Le(n)];
}
function Cc(e, t) {
  return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
}
function No(e, t) {
  return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
}
function mh(e, t) {
  e[0] += t[0], e[1] += t[1], e[2] += t[2];
}
function Ec(e, t) {
  return [e[0] * t, e[1] * t, e[2] * t];
}
function Yu(e) {
  var t = Zt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
  e[0] /= t, e[1] /= t, e[2] /= t;
}
var Ft, Qn, Wt, cr, da, uS, fS, wo, Ws = ea(), Ii, vi, oi = {
  point: Wp,
  lineStart: Px,
  lineEnd: Lx,
  polygonStart: function() {
    oi.point = hS, oi.lineStart = TY, oi.lineEnd = MY, Ws.reset(), Jr.polygonStart();
  },
  polygonEnd: function() {
    Jr.polygonEnd(), oi.point = Wp, oi.lineStart = Px, oi.lineEnd = Lx, Bu < 0 ? (Ft = -(Wt = 180), Qn = -(cr = 90)) : Ws > Ye ? cr = 90 : Ws < -Ye && (Qn = -90), vi[0] = Ft, vi[1] = Wt;
  }
};
function Wp(e, t) {
  Ii.push(vi = [Ft = e, Wt = e]), t < Qn && (Qn = t), t > cr && (cr = t);
}
function dS(e, t) {
  var n = Ia([e * Ue, t * Ue]);
  if (wo) {
    var r = No(wo, n), i = [r[1], -r[0], 0], a = No(i, r);
    Yu(a), a = $u(a);
    var o = e - da, s = o > 0 ? 1 : -1, c = a[0] * Tt * s, l, u = ft(o) > 180;
    u ^ (s * da < c && c < s * e) ? (l = a[1] * Tt, l > cr && (cr = l)) : (c = (c + 360) % 360 - 180, u ^ (s * da < c && c < s * e) ? (l = -a[1] * Tt, l < Qn && (Qn = l)) : (t < Qn && (Qn = t), t > cr && (cr = t))), u ? e < da ? Hn(Ft, e) > Hn(Ft, Wt) && (Wt = e) : Hn(e, Wt) > Hn(Ft, Wt) && (Ft = e) : Wt >= Ft ? (e < Ft && (Ft = e), e > Wt && (Wt = e)) : e > da ? Hn(Ft, e) > Hn(Ft, Wt) && (Wt = e) : Hn(e, Wt) > Hn(Ft, Wt) && (Ft = e);
  } else
    Ii.push(vi = [Ft = e, Wt = e]);
  t < Qn && (Qn = t), t > cr && (cr = t), wo = n, da = e;
}
function Px() {
  oi.point = dS;
}
function Lx() {
  vi[0] = Ft, vi[1] = Wt, oi.point = Wp, wo = null;
}
function hS(e, t) {
  if (wo) {
    var n = e - da;
    Ws.add(ft(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
  } else
    uS = e, fS = t;
  Jr.point(e, t), dS(e, t);
}
function TY() {
  Jr.lineStart();
}
function MY() {
  hS(uS, fS), Jr.lineEnd(), ft(Ws) > Ye && (Ft = -(Wt = 180)), vi[0] = Ft, vi[1] = Wt, wo = null;
}
function Hn(e, t) {
  return (t -= e) < 0 ? t + 360 : t;
}
function IY(e, t) {
  return e[0] - t[0];
}
function zx(e, t) {
  return e[0] <= e[1] ? e[0] <= t && t <= e[1] : t < e[0] || e[1] < t;
}
function NY(e) {
  var t, n, r, i, a, o, s;
  if (cr = Wt = -(Ft = Qn = 1 / 0), Ii = [], yr(e, oi), n = Ii.length) {
    for (Ii.sort(IY), t = 1, r = Ii[0], a = [r]; t < n; ++t)
      i = Ii[t], zx(r, i[0]) || zx(r, i[1]) ? (Hn(r[0], i[1]) > Hn(r[0], r[1]) && (r[1] = i[1]), Hn(i[0], r[1]) > Hn(r[0], r[1]) && (r[0] = i[0])) : a.push(r = i);
    for (o = -1 / 0, n = a.length - 1, t = 0, r = a[n]; t <= n; r = i, ++t)
      i = a[t], (s = Hn(r[1], i[0])) > o && (o = s, Ft = i[0], Wt = r[1]);
  }
  return Ii = vi = null, Ft === 1 / 0 || Qn === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[Ft, Qn], [Wt, cr]];
}
var ws, ju, Wu, Hu, Uu, Gu, Vu, Qu, Hp, Up, Gp, pS, mS, Cn, En, kn, br = {
  sphere: zt,
  point: qg,
  lineStart: Bx,
  lineEnd: Fx,
  polygonStart: function() {
    br.lineStart = DY, br.lineEnd = PY;
  },
  polygonEnd: function() {
    br.lineStart = Bx, br.lineEnd = Fx;
  }
};
function qg(e, t) {
  e *= Ue, t *= Ue;
  var n = Fe(t);
  Wl(n * Fe(e), n * Le(e), Le(t));
}
function Wl(e, t, n) {
  ++ws, Wu += (e - Wu) / ws, Hu += (t - Hu) / ws, Uu += (n - Uu) / ws;
}
function Bx() {
  br.point = OY;
}
function OY(e, t) {
  e *= Ue, t *= Ue;
  var n = Fe(t);
  Cn = n * Fe(e), En = n * Le(e), kn = Le(t), br.point = RY, Wl(Cn, En, kn);
}
function RY(e, t) {
  e *= Ue, t *= Ue;
  var n = Fe(t), r = n * Fe(e), i = n * Le(e), a = Le(t), o = In(Zt((o = En * a - kn * i) * o + (o = kn * r - Cn * a) * o + (o = Cn * i - En * r) * o), Cn * r + En * i + kn * a);
  ju += o, Gu += o * (Cn + (Cn = r)), Vu += o * (En + (En = i)), Qu += o * (kn + (kn = a)), Wl(Cn, En, kn);
}
function Fx() {
  br.point = qg;
}
function DY() {
  br.point = LY;
}
function PY() {
  gS(pS, mS), br.point = qg;
}
function LY(e, t) {
  pS = e, mS = t, e *= Ue, t *= Ue, br.point = gS;
  var n = Fe(t);
  Cn = n * Fe(e), En = n * Le(e), kn = Le(t), Wl(Cn, En, kn);
}
function gS(e, t) {
  e *= Ue, t *= Ue;
  var n = Fe(t), r = n * Fe(e), i = n * Le(e), a = Le(t), o = En * a - kn * i, s = kn * r - Cn * a, c = Cn * i - En * r, l = Zt(o * o + s * s + c * c), u = Zn(l), d = l && -u / l;
  Hp += d * o, Up += d * s, Gp += d * c, ju += u, Gu += u * (Cn + (Cn = r)), Vu += u * (En + (En = i)), Qu += u * (kn + (kn = a)), Wl(Cn, En, kn);
}
function zY(e) {
  ws = ju = Wu = Hu = Uu = Gu = Vu = Qu = Hp = Up = Gp = 0, yr(e, br);
  var t = Hp, n = Up, r = Gp, i = t * t + n * n + r * r;
  return i < Ix && (t = Gu, n = Vu, r = Qu, ju < Ye && (t = Wu, n = Hu, r = Uu), i = t * t + n * n + r * r, i < Ix) ? [NaN, NaN] : [In(n, t) * Tt, Zn(r / Zt(i)) * Tt];
}
function Za(e) {
  return function() {
    return e;
  };
}
function yS(e, t) {
  function n(r, i) {
    return r = e(r, i), t(r[0], r[1]);
  }
  return e.invert && t.invert && (n.invert = function(r, i) {
    return r = t.invert(r, i), r && e.invert(r[0], r[1]);
  }), n;
}
function Vp(e, t) {
  return [e > it ? e - Ln : e < -it ? e + Ln : e, t];
}
Vp.invert = Vp;
function Xg(e, t, n) {
  return (e %= Ln) ? t || n ? yS(Yx(e), jx(t, n)) : Yx(e) : t || n ? jx(t, n) : Vp;
}
function $x(e) {
  return function(t, n) {
    return t += e, [t > it ? t - Ln : t < -it ? t + Ln : t, n];
  };
}
function Yx(e) {
  var t = $x(e);
  return t.invert = $x(-e), t;
}
function jx(e, t) {
  var n = Fe(e), r = Le(e), i = Fe(t), a = Le(t);
  function o(s, c) {
    var l = Fe(c), u = Fe(s) * l, d = Le(s) * l, f = Le(c), h = f * n + u * r;
    return [
      In(d * i - h * a, u * n - f * r),
      Zn(h * i + d * a)
    ];
  }
  return o.invert = function(s, c) {
    var l = Fe(c), u = Fe(s) * l, d = Le(s) * l, f = Le(c), h = f * i - d * a;
    return [
      In(d * i + f * a, u * n + h * r),
      Zn(h * n - u * r)
    ];
  }, o;
}
function xS(e) {
  e = Xg(e[0] * Ue, e[1] * Ue, e.length > 2 ? e[2] * Ue : 0);
  function t(n) {
    return n = e(n[0] * Ue, n[1] * Ue), n[0] *= Tt, n[1] *= Tt, n;
  }
  return t.invert = function(n) {
    return n = e.invert(n[0] * Ue, n[1] * Ue), n[0] *= Tt, n[1] *= Tt, n;
  }, t;
}
function vS(e, t, n, r, i, a) {
  if (n) {
    var o = Fe(t), s = Le(t), c = r * n;
    i == null ? (i = t + r * Ln, a = t - c / 2) : (i = Wx(o, i), a = Wx(o, a), (r > 0 ? i < a : i > a) && (i += r * Ln));
    for (var l, u = i; r > 0 ? u > a : u < a; u -= c)
      l = $u([o, -s * Fe(u), -s * Le(u)]), e.point(l[0], l[1]);
  }
}
function Wx(e, t) {
  t = Ia(t), t[0] -= e, Yu(t);
  var n = oS(-t[1]);
  return ((-t[2] < 0 ? -n : n) + Ln - Ye) % Ln;
}
function BY() {
  var e = Za([0, 0]), t = Za(90), n = Za(6), r, i, a = { point: o };
  function o(c, l) {
    r.push(c = i(c, l)), c[0] *= Tt, c[1] *= Tt;
  }
  function s() {
    var c = e.apply(this, arguments), l = t.apply(this, arguments) * Ue, u = n.apply(this, arguments) * Ue;
    return r = [], i = Xg(-c[0] * Ue, -c[1] * Ue, 0).invert, vS(a, l, u, 1), c = { type: "Polygon", coordinates: [r] }, r = i = null, c;
  }
  return s.center = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Za([+c[0], +c[1]]), s) : e;
  }, s.radius = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Za(+c), s) : t;
  }, s.precision = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Za(+c), s) : n;
  }, s;
}
function AS() {
  var e = [], t;
  return {
    point: function(n, r) {
      t.push([n, r]);
    },
    lineStart: function() {
      e.push(t = []);
    },
    lineEnd: zt,
    rejoin: function() {
      e.length > 1 && e.push(e.pop().concat(e.shift()));
    },
    result: function() {
      var n = e;
      return e = [], t = null, n;
    }
  };
}
function ru(e, t) {
  return ft(e[0] - t[0]) < Ye && ft(e[1] - t[1]) < Ye;
}
function kc(e, t, n, r) {
  this.x = e, this.z = t, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
}
function bS(e, t, n, r, i) {
  var a = [], o = [], s, c;
  if (e.forEach(function(m) {
    if (!((g = m.length - 1) <= 0)) {
      var g, v = m[0], _ = m[g], I;
      if (ru(v, _)) {
        for (i.lineStart(), s = 0; s < g; ++s) i.point((v = m[s])[0], v[1]);
        i.lineEnd();
        return;
      }
      a.push(I = new kc(v, m, null, !0)), o.push(I.o = new kc(v, null, I, !1)), a.push(I = new kc(_, m, null, !1)), o.push(I.o = new kc(_, null, I, !0));
    }
  }), !!a.length) {
    for (o.sort(t), Hx(a), Hx(o), s = 0, c = o.length; s < c; ++s)
      o[s].e = n = !n;
    for (var l = a[0], u, d; ; ) {
      for (var f = l, h = !0; f.v; ) if ((f = f.n) === l) return;
      u = f.z, i.lineStart();
      do {
        if (f.v = f.o.v = !0, f.e) {
          if (h)
            for (s = 0, c = u.length; s < c; ++s) i.point((d = u[s])[0], d[1]);
          else
            r(f.x, f.n.x, 1, i);
          f = f.n;
        } else {
          if (h)
            for (u = f.p.z, s = u.length - 1; s >= 0; --s) i.point((d = u[s])[0], d[1]);
          else
            r(f.x, f.p.x, -1, i);
          f = f.p;
        }
        f = f.o, u = f.z, h = !h;
      } while (!f.v);
      i.lineEnd();
    }
  }
}
function Hx(e) {
  if (t = e.length) {
    for (var t, n = 0, r = e[0], i; ++n < t; )
      r.n = i = e[n], i.p = r, r = i;
    r.n = i = e[0], i.p = r;
  }
}
var gh = ea();
function wS(e, t) {
  var n = t[0], r = t[1], i = [Le(n), -Fe(n), 0], a = 0, o = 0;
  gh.reset();
  for (var s = 0, c = e.length; s < c; ++s)
    if (u = (l = e[s]).length)
      for (var l, u, d = l[u - 1], f = d[0], h = d[1] / 2 + Pu, m = Le(h), g = Fe(h), v = 0; v < u; ++v, f = I, m = k, g = y, d = _) {
        var _ = l[v], I = _[0], M = _[1] / 2 + Pu, k = Le(M), y = Fe(M), x = I - f, b = x >= 0 ? 1 : -1, A = b * x, w = A > it, O = m * k;
        if (gh.add(In(O * b * Le(A), g * y + O * Fe(A))), a += w ? x + b * Ln : x, w ^ f >= n ^ I >= n) {
          var P = No(Ia(d), Ia(_));
          Yu(P);
          var E = No(i, P);
          Yu(E);
          var C = (w ^ x >= 0 ? -1 : 1) * Zn(E[2]);
          (r > C || r === C && (P[0] || P[1])) && (o += w ^ x >= 0 ? 1 : -1);
        }
      }
  return (a < -Ye || a < Ye && gh < -Ye) ^ o & 1;
}
function _S(e, t, n, r) {
  return function(i) {
    var a = t(i), o = AS(), s = t(o), c = !1, l, u, d, f = {
      point: h,
      lineStart: g,
      lineEnd: v,
      polygonStart: function() {
        f.point = _, f.lineStart = I, f.lineEnd = M, u = [], l = [];
      },
      polygonEnd: function() {
        f.point = h, f.lineStart = g, f.lineEnd = v, u = Sg(u);
        var k = wS(l, r);
        u.length ? (c || (i.polygonStart(), c = !0), bS(u, $Y, k, n, i)) : k && (c || (i.polygonStart(), c = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), c && (i.polygonEnd(), c = !1), u = l = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function h(k, y) {
      e(k, y) && i.point(k, y);
    }
    function m(k, y) {
      a.point(k, y);
    }
    function g() {
      f.point = m, a.lineStart();
    }
    function v() {
      f.point = h, a.lineEnd();
    }
    function _(k, y) {
      d.push([k, y]), s.point(k, y);
    }
    function I() {
      s.lineStart(), d = [];
    }
    function M() {
      _(d[0][0], d[0][1]), s.lineEnd();
      var k = s.clean(), y = o.result(), x, b = y.length, A, w, O;
      if (d.pop(), l.push(d), d = null, !!b) {
        if (k & 1) {
          if (w = y[0], (A = w.length - 1) > 0) {
            for (c || (i.polygonStart(), c = !0), i.lineStart(), x = 0; x < A; ++x) i.point((O = w[x])[0], O[1]);
            i.lineEnd();
          }
          return;
        }
        b > 1 && k & 2 && y.push(y.pop().concat(y.shift())), u.push(y.filter(FY));
      }
    }
    return f;
  };
}
function FY(e) {
  return e.length > 1;
}
function $Y(e, t) {
  return ((e = e.x)[0] < 0 ? e[1] - Gt - Ye : Gt - e[1]) - ((t = t.x)[0] < 0 ? t[1] - Gt - Ye : Gt - t[1]);
}
const Qp = _S(
  function() {
    return !0;
  },
  YY,
  WY,
  [-it, -Gt]
);
function YY(e) {
  var t = NaN, n = NaN, r = NaN, i;
  return {
    lineStart: function() {
      e.lineStart(), i = 1;
    },
    point: function(a, o) {
      var s = a > 0 ? it : -it, c = ft(a - t);
      ft(c - it) < Ye ? (e.point(t, n = (n + o) / 2 > 0 ? Gt : -Gt), e.point(r, n), e.lineEnd(), e.lineStart(), e.point(s, n), e.point(a, n), i = 0) : r !== s && c >= it && (ft(t - r) < Ye && (t -= r * Ye), ft(a - s) < Ye && (a -= s * Ye), n = jY(t, n, a, o), e.point(r, n), e.lineEnd(), e.lineStart(), e.point(s, n), i = 0), e.point(t = a, n = o), r = s;
    },
    lineEnd: function() {
      e.lineEnd(), t = n = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function jY(e, t, n, r) {
  var i, a, o = Le(e - n);
  return ft(o) > Ye ? Vo((Le(t) * (a = Fe(r)) * Le(n) - Le(r) * (i = Fe(t)) * Le(e)) / (i * a * o)) : (t + r) / 2;
}
function WY(e, t, n, r) {
  var i;
  if (e == null)
    i = n * Gt, r.point(-it, i), r.point(0, i), r.point(it, i), r.point(it, 0), r.point(it, -i), r.point(0, -i), r.point(-it, -i), r.point(-it, 0), r.point(-it, i);
  else if (ft(e[0] - t[0]) > Ye) {
    var a = e[0] < t[0] ? it : -it;
    i = n * a / 2, r.point(-a, i), r.point(0, i), r.point(a, i);
  } else
    r.point(t[0], t[1]);
}
function SS(e) {
  var t = Fe(e), n = 6 * Ue, r = t > 0, i = ft(t) > Ye;
  function a(u, d, f, h) {
    vS(h, e, n, f, u, d);
  }
  function o(u, d) {
    return Fe(u) * Fe(d) > t;
  }
  function s(u) {
    var d, f, h, m, g;
    return {
      lineStart: function() {
        m = h = !1, g = 1;
      },
      point: function(v, _) {
        var I = [v, _], M, k = o(v, _), y = r ? k ? 0 : l(v, _) : k ? l(v + (v < 0 ? it : -it), _) : 0;
        if (!d && (m = h = k) && u.lineStart(), k !== h && (M = c(d, I), (!M || ru(d, M) || ru(I, M)) && (I[0] += Ye, I[1] += Ye, k = o(I[0], I[1]))), k !== h)
          g = 0, k ? (u.lineStart(), M = c(I, d), u.point(M[0], M[1])) : (M = c(d, I), u.point(M[0], M[1]), u.lineEnd()), d = M;
        else if (i && d && r ^ k) {
          var x;
          !(y & f) && (x = c(I, d, !0)) && (g = 0, r ? (u.lineStart(), u.point(x[0][0], x[0][1]), u.point(x[1][0], x[1][1]), u.lineEnd()) : (u.point(x[1][0], x[1][1]), u.lineEnd(), u.lineStart(), u.point(x[0][0], x[0][1])));
        }
        k && (!d || !ru(d, I)) && u.point(I[0], I[1]), d = I, h = k, f = y;
      },
      lineEnd: function() {
        h && u.lineEnd(), d = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return g | (m && h) << 1;
      }
    };
  }
  function c(u, d, f) {
    var h = Ia(u), m = Ia(d), g = [1, 0, 0], v = No(h, m), _ = Cc(v, v), I = v[0], M = _ - I * I;
    if (!M) return !f && u;
    var k = t * _ / M, y = -t * I / M, x = No(g, v), b = Ec(g, k), A = Ec(v, y);
    mh(b, A);
    var w = x, O = Cc(b, w), P = Cc(w, w), E = O * O - P * (Cc(b, b) - 1);
    if (!(E < 0)) {
      var C = Zt(E), T = Ec(w, (-O - C) / P);
      if (mh(T, b), T = $u(T), !f) return T;
      var D = u[0], z = d[0], F = u[1], W = d[1], L;
      z < D && (L = D, D = z, z = L);
      var S = z - D, j = ft(S - it) < Ye, Y = j || S < Ye;
      if (!j && W < F && (L = F, F = W, W = L), Y ? j ? F + W > 0 ^ T[1] < (ft(T[0] - D) < Ye ? F : W) : F <= T[1] && T[1] <= W : S > it ^ (D <= T[0] && T[0] <= z)) {
        var N = Ec(w, (-O + C) / P);
        return mh(N, b), [T, $u(N)];
      }
    }
  }
  function l(u, d) {
    var f = r ? e : it - e, h = 0;
    return u < -f ? h |= 1 : u > f && (h |= 2), d < -f ? h |= 4 : d > f && (h |= 8), h;
  }
  return _S(o, s, a, r ? [0, -e] : [-it, e - it]);
}
function HY(e, t, n, r, i, a) {
  var o = e[0], s = e[1], c = t[0], l = t[1], u = 0, d = 1, f = c - o, h = l - s, m;
  if (m = n - o, !(!f && m > 0)) {
    if (m /= f, f < 0) {
      if (m < u) return;
      m < d && (d = m);
    } else if (f > 0) {
      if (m > d) return;
      m > u && (u = m);
    }
    if (m = i - o, !(!f && m < 0)) {
      if (m /= f, f < 0) {
        if (m > d) return;
        m > u && (u = m);
      } else if (f > 0) {
        if (m < u) return;
        m < d && (d = m);
      }
      if (m = r - s, !(!h && m > 0)) {
        if (m /= h, h < 0) {
          if (m < u) return;
          m < d && (d = m);
        } else if (h > 0) {
          if (m > d) return;
          m > u && (u = m);
        }
        if (m = a - s, !(!h && m < 0)) {
          if (m /= h, h < 0) {
            if (m > d) return;
            m > u && (u = m);
          } else if (h > 0) {
            if (m < u) return;
            m < d && (d = m);
          }
          return u > 0 && (e[0] = o + u * f, e[1] = s + u * h), d < 1 && (t[0] = o + d * f, t[1] = s + d * h), !0;
        }
      }
    }
  }
}
var _s = 1e9, Tc = -_s;
function sd(e, t, n, r) {
  function i(l, u) {
    return e <= l && l <= n && t <= u && u <= r;
  }
  function a(l, u, d, f) {
    var h = 0, m = 0;
    if (l == null || (h = o(l, d)) !== (m = o(u, d)) || c(l, u) < 0 ^ d > 0)
      do
        f.point(h === 0 || h === 3 ? e : n, h > 1 ? r : t);
      while ((h = (h + d + 4) % 4) !== m);
    else
      f.point(u[0], u[1]);
  }
  function o(l, u) {
    return ft(l[0] - e) < Ye ? u > 0 ? 0 : 3 : ft(l[0] - n) < Ye ? u > 0 ? 2 : 1 : ft(l[1] - t) < Ye ? u > 0 ? 1 : 0 : u > 0 ? 3 : 2;
  }
  function s(l, u) {
    return c(l.x, u.x);
  }
  function c(l, u) {
    var d = o(l, 1), f = o(u, 1);
    return d !== f ? d - f : d === 0 ? u[1] - l[1] : d === 1 ? l[0] - u[0] : d === 2 ? l[1] - u[1] : u[0] - l[0];
  }
  return function(l) {
    var u = l, d = AS(), f, h, m, g, v, _, I, M, k, y, x, b = {
      point: A,
      lineStart: E,
      lineEnd: C,
      polygonStart: O,
      polygonEnd: P
    };
    function A(D, z) {
      i(D, z) && u.point(D, z);
    }
    function w() {
      for (var D = 0, z = 0, F = h.length; z < F; ++z)
        for (var W = h[z], L = 1, S = W.length, j = W[0], Y, N, X = j[0], G = j[1]; L < S; ++L)
          Y = X, N = G, j = W[L], X = j[0], G = j[1], N <= r ? G > r && (X - Y) * (r - N) > (G - N) * (e - Y) && ++D : G <= r && (X - Y) * (r - N) < (G - N) * (e - Y) && --D;
      return D;
    }
    function O() {
      u = d, f = [], h = [], x = !0;
    }
    function P() {
      var D = w(), z = x && D, F = (f = Sg(f)).length;
      (z || F) && (l.polygonStart(), z && (l.lineStart(), a(null, null, 1, l), l.lineEnd()), F && bS(f, s, D, a, l), l.polygonEnd()), u = l, f = h = m = null;
    }
    function E() {
      b.point = T, h && h.push(m = []), y = !0, k = !1, I = M = NaN;
    }
    function C() {
      f && (T(g, v), _ && k && d.rejoin(), f.push(d.result())), b.point = A, k && u.lineEnd();
    }
    function T(D, z) {
      var F = i(D, z);
      if (h && m.push([D, z]), y)
        g = D, v = z, _ = F, y = !1, F && (u.lineStart(), u.point(D, z));
      else if (F && k) u.point(D, z);
      else {
        var W = [I = Math.max(Tc, Math.min(_s, I)), M = Math.max(Tc, Math.min(_s, M))], L = [D = Math.max(Tc, Math.min(_s, D)), z = Math.max(Tc, Math.min(_s, z))];
        HY(W, L, e, t, n, r) ? (k || (u.lineStart(), u.point(W[0], W[1])), u.point(L[0], L[1]), F || u.lineEnd(), x = !1) : F && (u.lineStart(), u.point(D, z), x = !1);
      }
      I = D, M = z, k = F;
    }
    return b;
  };
}
function UY() {
  var e = 0, t = 0, n = 960, r = 500, i, a, o;
  return o = {
    stream: function(s) {
      return i && a === s ? i : i = sd(e, t, n, r)(a = s);
    },
    extent: function(s) {
      return arguments.length ? (e = +s[0][0], t = +s[0][1], n = +s[1][0], r = +s[1][1], i = a = null, o) : [[e, t], [n, r]];
    }
  };
}
var qp = ea(), Xp, iu, au, Oo = {
  sphere: zt,
  point: zt,
  lineStart: GY,
  lineEnd: zt,
  polygonStart: zt,
  polygonEnd: zt
};
function GY() {
  Oo.point = QY, Oo.lineEnd = VY;
}
function VY() {
  Oo.point = Oo.lineEnd = zt;
}
function QY(e, t) {
  e *= Ue, t *= Ue, Xp = e, iu = Le(t), au = Fe(t), Oo.point = qY;
}
function qY(e, t) {
  e *= Ue, t *= Ue;
  var n = Le(t), r = Fe(t), i = ft(e - Xp), a = Fe(i), o = Le(i), s = r * o, c = au * n - iu * r * a, l = iu * n + au * r * a;
  qp.add(In(Zt(s * s + c * c), l)), Xp = e, iu = n, au = r;
}
function CS(e) {
  return qp.reset(), yr(e, Oo), +qp;
}
var Jp = [null, null], XY = { type: "LineString", coordinates: Jp };
function Hs(e, t) {
  return Jp[0] = e, Jp[1] = t, CS(XY);
}
var Ux = {
  Feature: function(e, t) {
    return qu(e.geometry, t);
  },
  FeatureCollection: function(e, t) {
    for (var n = e.features, r = -1, i = n.length; ++r < i; ) if (qu(n[r].geometry, t)) return !0;
    return !1;
  }
}, Gx = {
  Sphere: function() {
    return !0;
  },
  Point: function(e, t) {
    return Vx(e.coordinates, t);
  },
  MultiPoint: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) if (Vx(n[r], t)) return !0;
    return !1;
  },
  LineString: function(e, t) {
    return Qx(e.coordinates, t);
  },
  MultiLineString: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) if (Qx(n[r], t)) return !0;
    return !1;
  },
  Polygon: function(e, t) {
    return qx(e.coordinates, t);
  },
  MultiPolygon: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) if (qx(n[r], t)) return !0;
    return !1;
  },
  GeometryCollection: function(e, t) {
    for (var n = e.geometries, r = -1, i = n.length; ++r < i; ) if (qu(n[r], t)) return !0;
    return !1;
  }
};
function qu(e, t) {
  return e && Gx.hasOwnProperty(e.type) ? Gx[e.type](e, t) : !1;
}
function Vx(e, t) {
  return Hs(e, t) === 0;
}
function Qx(e, t) {
  var n = Hs(e[0], e[1]), r = Hs(e[0], t), i = Hs(t, e[1]);
  return r + i <= n + Ye;
}
function qx(e, t) {
  return !!wS(e.map(JY), ES(t));
}
function JY(e) {
  return e = e.map(ES), e.pop(), e;
}
function ES(e) {
  return [e[0] * Ue, e[1] * Ue];
}
function KY(e, t) {
  return (e && Ux.hasOwnProperty(e.type) ? Ux[e.type] : qu)(e, t);
}
function Xx(e, t, n) {
  var r = Ar(e, t - Ye, n).concat(t);
  return function(i) {
    return r.map(function(a) {
      return [i, a];
    });
  };
}
function Jx(e, t, n) {
  var r = Ar(e, t - Ye, n).concat(t);
  return function(i) {
    return r.map(function(a) {
      return [a, i];
    });
  };
}
function kS() {
  var e, t, n, r, i, a, o, s, c = 10, l = c, u = 90, d = 360, f, h, m, g, v = 2.5;
  function _() {
    return { type: "MultiLineString", coordinates: I() };
  }
  function I() {
    return Ar(Sc(r / u) * u, n, u).map(m).concat(Ar(Sc(s / d) * d, o, d).map(g)).concat(Ar(Sc(t / c) * c, e, c).filter(function(M) {
      return ft(M % u) > Ye;
    }).map(f)).concat(Ar(Sc(a / l) * l, i, l).filter(function(M) {
      return ft(M % d) > Ye;
    }).map(h));
  }
  return _.lines = function() {
    return I().map(function(M) {
      return { type: "LineString", coordinates: M };
    });
  }, _.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        m(r).concat(
          g(o).slice(1),
          m(n).reverse().slice(1),
          g(s).reverse().slice(1)
        )
      ]
    };
  }, _.extent = function(M) {
    return arguments.length ? _.extentMajor(M).extentMinor(M) : _.extentMinor();
  }, _.extentMajor = function(M) {
    return arguments.length ? (r = +M[0][0], n = +M[1][0], s = +M[0][1], o = +M[1][1], r > n && (M = r, r = n, n = M), s > o && (M = s, s = o, o = M), _.precision(v)) : [[r, s], [n, o]];
  }, _.extentMinor = function(M) {
    return arguments.length ? (t = +M[0][0], e = +M[1][0], a = +M[0][1], i = +M[1][1], t > e && (M = t, t = e, e = M), a > i && (M = a, a = i, i = M), _.precision(v)) : [[t, a], [e, i]];
  }, _.step = function(M) {
    return arguments.length ? _.stepMajor(M).stepMinor(M) : _.stepMinor();
  }, _.stepMajor = function(M) {
    return arguments.length ? (u = +M[0], d = +M[1], _) : [u, d];
  }, _.stepMinor = function(M) {
    return arguments.length ? (c = +M[0], l = +M[1], _) : [c, l];
  }, _.precision = function(M) {
    return arguments.length ? (v = +M, f = Xx(a, i, 90), h = Jx(t, e, v), m = Xx(s, o, 90), g = Jx(r, n, v), _) : v;
  }, _.extentMajor([[-180, -90 + Ye], [180, 90 - Ye]]).extentMinor([[-180, -80 - Ye], [180, 80 + Ye]]);
}
function ZY() {
  return kS()();
}
function ej(e, t) {
  var n = e[0] * Ue, r = e[1] * Ue, i = t[0] * Ue, a = t[1] * Ue, o = Fe(r), s = Le(r), c = Fe(a), l = Le(a), u = o * Fe(n), d = o * Le(n), f = c * Fe(i), h = c * Le(i), m = 2 * Zn(Zt(Nx(a - r) + o * c * Nx(i - n))), g = Le(m), v = m ? function(_) {
    var I = Le(_ *= m) / g, M = Le(m - _) / g, k = M * u + I * f, y = M * d + I * h, x = M * s + I * l;
    return [
      In(y, k) * Tt,
      In(x, Zt(k * k + y * y)) * Tt
    ];
  } : function() {
    return [n * Tt, r * Tt];
  };
  return v.distance = m, v;
}
function _a(e) {
  return e;
}
var yh = ea(), Kp = ea(), TS, MS, Zp, em, ci = {
  point: zt,
  lineStart: zt,
  lineEnd: zt,
  polygonStart: function() {
    ci.lineStart = tj, ci.lineEnd = rj;
  },
  polygonEnd: function() {
    ci.lineStart = ci.lineEnd = ci.point = zt, yh.add(ft(Kp)), Kp.reset();
  },
  result: function() {
    var e = yh / 2;
    return yh.reset(), e;
  }
};
function tj() {
  ci.point = nj;
}
function nj(e, t) {
  ci.point = IS, TS = Zp = e, MS = em = t;
}
function IS(e, t) {
  Kp.add(em * e - Zp * t), Zp = e, em = t;
}
function rj() {
  IS(TS, MS);
}
var Ro = 1 / 0, Xu = Ro, xl = -Ro, Ju = xl, Ku = {
  point: ij,
  lineStart: zt,
  lineEnd: zt,
  polygonStart: zt,
  polygonEnd: zt,
  result: function() {
    var e = [[Ro, Xu], [xl, Ju]];
    return xl = Ju = -(Xu = Ro = 1 / 0), e;
  }
};
function ij(e, t) {
  e < Ro && (Ro = e), e > xl && (xl = e), t < Xu && (Xu = t), t > Ju && (Ju = t);
}
var tm = 0, nm = 0, Ss = 0, Zu = 0, ef = 0, oo = 0, rm = 0, im = 0, Cs = 0, NS, OS, Wr, Hr, fr = {
  point: Na,
  lineStart: Kx,
  lineEnd: Zx,
  polygonStart: function() {
    fr.lineStart = sj, fr.lineEnd = lj;
  },
  polygonEnd: function() {
    fr.point = Na, fr.lineStart = Kx, fr.lineEnd = Zx;
  },
  result: function() {
    var e = Cs ? [rm / Cs, im / Cs] : oo ? [Zu / oo, ef / oo] : Ss ? [tm / Ss, nm / Ss] : [NaN, NaN];
    return tm = nm = Ss = Zu = ef = oo = rm = im = Cs = 0, e;
  }
};
function Na(e, t) {
  tm += e, nm += t, ++Ss;
}
function Kx() {
  fr.point = aj;
}
function aj(e, t) {
  fr.point = oj, Na(Wr = e, Hr = t);
}
function oj(e, t) {
  var n = e - Wr, r = t - Hr, i = Zt(n * n + r * r);
  Zu += i * (Wr + e) / 2, ef += i * (Hr + t) / 2, oo += i, Na(Wr = e, Hr = t);
}
function Zx() {
  fr.point = Na;
}
function sj() {
  fr.point = cj;
}
function lj() {
  RS(NS, OS);
}
function cj(e, t) {
  fr.point = RS, Na(NS = Wr = e, OS = Hr = t);
}
function RS(e, t) {
  var n = e - Wr, r = t - Hr, i = Zt(n * n + r * r);
  Zu += i * (Wr + e) / 2, ef += i * (Hr + t) / 2, oo += i, i = Hr * e - Wr * t, rm += i * (Wr + e), im += i * (Hr + t), Cs += i * 3, Na(Wr = e, Hr = t);
}
function DS(e) {
  this._context = e;
}
DS.prototype = {
  _radius: 4.5,
  pointRadius: function(e) {
    return this._radius = e, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(e, t) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(e, t), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(e, t);
        break;
      }
      default: {
        this._context.moveTo(e + this._radius, t), this._context.arc(e, t, this._radius, 0, Ln);
        break;
      }
    }
  },
  result: zt
};
var am = ea(), xh, PS, LS, Es, ks, vl = {
  point: zt,
  lineStart: function() {
    vl.point = uj;
  },
  lineEnd: function() {
    xh && zS(PS, LS), vl.point = zt;
  },
  polygonStart: function() {
    xh = !0;
  },
  polygonEnd: function() {
    xh = null;
  },
  result: function() {
    var e = +am;
    return am.reset(), e;
  }
};
function uj(e, t) {
  vl.point = zS, PS = Es = e, LS = ks = t;
}
function zS(e, t) {
  Es -= e, ks -= t, am.add(Zt(Es * Es + ks * ks)), Es = e, ks = t;
}
function BS() {
  this._string = [];
}
BS.prototype = {
  _radius: 4.5,
  _circle: ev(4.5),
  pointRadius: function(e) {
    return (e = +e) !== this._radius && (this._radius = e, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(e, t) {
    switch (this._point) {
      case 0: {
        this._string.push("M", e, ",", t), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", e, ",", t);
        break;
      }
      default: {
        this._circle == null && (this._circle = ev(this._radius)), this._string.push("M", e, ",", t, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var e = this._string.join("");
      return this._string = [], e;
    } else
      return null;
  }
};
function ev(e) {
  return "m0," + e + "a" + e + "," + e + " 0 1,1 0," + -2 * e + "a" + e + "," + e + " 0 1,1 0," + 2 * e + "z";
}
function fj(e, t) {
  var n = 4.5, r, i;
  function a(o) {
    return o && (typeof n == "function" && i.pointRadius(+n.apply(this, arguments)), yr(o, r(i))), i.result();
  }
  return a.area = function(o) {
    return yr(o, r(ci)), ci.result();
  }, a.measure = function(o) {
    return yr(o, r(vl)), vl.result();
  }, a.bounds = function(o) {
    return yr(o, r(Ku)), Ku.result();
  }, a.centroid = function(o) {
    return yr(o, r(fr)), fr.result();
  }, a.projection = function(o) {
    return arguments.length ? (r = o == null ? (e = null, _a) : (e = o).stream, a) : e;
  }, a.context = function(o) {
    return arguments.length ? (i = o == null ? (t = null, new BS()) : new DS(t = o), typeof n != "function" && i.pointRadius(n), a) : t;
  }, a.pointRadius = function(o) {
    return arguments.length ? (n = typeof o == "function" ? o : (i.pointRadius(+o), +o), a) : n;
  }, a.projection(e).context(t);
}
function dj(e) {
  return {
    stream: Hl(e)
  };
}
function Hl(e) {
  return function(t) {
    var n = new om();
    for (var r in e) n[r] = e[r];
    return n.stream = t, n;
  };
}
function om() {
}
om.prototype = {
  constructor: om,
  point: function(e, t) {
    this.stream.point(e, t);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function Jg(e, t, n) {
  var r = e.clipExtent && e.clipExtent();
  return e.scale(150).translate([0, 0]), r != null && e.clipExtent(null), yr(n, e.stream(Ku)), t(Ku.result()), r != null && e.clipExtent(r), e;
}
function ld(e, t, n) {
  return Jg(e, function(r) {
    var i = t[1][0] - t[0][0], a = t[1][1] - t[0][1], o = Math.min(i / (r[1][0] - r[0][0]), a / (r[1][1] - r[0][1])), s = +t[0][0] + (i - o * (r[1][0] + r[0][0])) / 2, c = +t[0][1] + (a - o * (r[1][1] + r[0][1])) / 2;
    e.scale(150 * o).translate([s, c]);
  }, n);
}
function Kg(e, t, n) {
  return ld(e, [[0, 0], t], n);
}
function Zg(e, t, n) {
  return Jg(e, function(r) {
    var i = +t, a = i / (r[1][0] - r[0][0]), o = (i - a * (r[1][0] + r[0][0])) / 2, s = -a * r[0][1];
    e.scale(150 * a).translate([o, s]);
  }, n);
}
function e0(e, t, n) {
  return Jg(e, function(r) {
    var i = +t, a = i / (r[1][1] - r[0][1]), o = -a * r[0][0], s = (i - a * (r[1][1] + r[0][1])) / 2;
    e.scale(150 * a).translate([o, s]);
  }, n);
}
var tv = 16, hj = Fe(30 * Ue);
function nv(e, t) {
  return +t ? mj(e, t) : pj(e);
}
function pj(e) {
  return Hl({
    point: function(t, n) {
      t = e(t, n), this.stream.point(t[0], t[1]);
    }
  });
}
function mj(e, t) {
  function n(r, i, a, o, s, c, l, u, d, f, h, m, g, v) {
    var _ = l - r, I = u - i, M = _ * _ + I * I;
    if (M > 4 * t && g--) {
      var k = o + f, y = s + h, x = c + m, b = Zt(k * k + y * y + x * x), A = Zn(x /= b), w = ft(ft(x) - 1) < Ye || ft(a - d) < Ye ? (a + d) / 2 : In(y, k), O = e(w, A), P = O[0], E = O[1], C = P - r, T = E - i, D = I * C - _ * T;
      (D * D / M > t || ft((_ * C + I * T) / M - 0.5) > 0.3 || o * f + s * h + c * m < hj) && (n(r, i, a, o, s, c, P, E, w, k /= b, y /= b, x, g, v), v.point(P, E), n(P, E, w, k, y, x, l, u, d, f, h, m, g, v));
    }
  }
  return function(r) {
    var i, a, o, s, c, l, u, d, f, h, m, g, v = {
      point: _,
      lineStart: I,
      lineEnd: k,
      polygonStart: function() {
        r.polygonStart(), v.lineStart = y;
      },
      polygonEnd: function() {
        r.polygonEnd(), v.lineStart = I;
      }
    };
    function _(A, w) {
      A = e(A, w), r.point(A[0], A[1]);
    }
    function I() {
      d = NaN, v.point = M, r.lineStart();
    }
    function M(A, w) {
      var O = Ia([A, w]), P = e(A, w);
      n(d, f, u, h, m, g, d = P[0], f = P[1], u = A, h = O[0], m = O[1], g = O[2], tv, r), r.point(d, f);
    }
    function k() {
      v.point = _, r.lineEnd();
    }
    function y() {
      I(), v.point = x, v.lineEnd = b;
    }
    function x(A, w) {
      M(i = A, w), a = d, o = f, s = h, c = m, l = g, v.point = M;
    }
    function b() {
      n(d, f, u, h, m, g, a, o, i, s, c, l, tv, r), v.lineEnd = k, k();
    }
    return v;
  };
}
var gj = Hl({
  point: function(e, t) {
    this.stream.point(e * Ue, t * Ue);
  }
});
function yj(e) {
  return Hl({
    point: function(t, n) {
      var r = e(t, n);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function Ci(e) {
  return t0(function() {
    return e;
  })();
}
function t0(e) {
  var t, n = 150, r = 480, i = 250, a, o, s = 0, c = 0, l = 0, u = 0, d = 0, f, h, m = null, g = Qp, v = null, _, I, M, k = _a, y = 0.5, x = nv(P, y), b, A;
  function w(T) {
    return T = h(T[0] * Ue, T[1] * Ue), [T[0] * n + a, o - T[1] * n];
  }
  function O(T) {
    return T = h.invert((T[0] - a) / n, (o - T[1]) / n), T && [T[0] * Tt, T[1] * Tt];
  }
  function P(T, D) {
    return T = t(T, D), [T[0] * n + a, o - T[1] * n];
  }
  w.stream = function(T) {
    return b && A === T ? b : b = gj(yj(f)(g(x(k(A = T)))));
  }, w.preclip = function(T) {
    return arguments.length ? (g = T, m = void 0, C()) : g;
  }, w.postclip = function(T) {
    return arguments.length ? (k = T, v = _ = I = M = null, C()) : k;
  }, w.clipAngle = function(T) {
    return arguments.length ? (g = +T ? SS(m = T * Ue) : (m = null, Qp), C()) : m * Tt;
  }, w.clipExtent = function(T) {
    return arguments.length ? (k = T == null ? (v = _ = I = M = null, _a) : sd(v = +T[0][0], _ = +T[0][1], I = +T[1][0], M = +T[1][1]), C()) : v == null ? null : [[v, _], [I, M]];
  }, w.scale = function(T) {
    return arguments.length ? (n = +T, E()) : n;
  }, w.translate = function(T) {
    return arguments.length ? (r = +T[0], i = +T[1], E()) : [r, i];
  }, w.center = function(T) {
    return arguments.length ? (s = T[0] % 360 * Ue, c = T[1] % 360 * Ue, E()) : [s * Tt, c * Tt];
  }, w.rotate = function(T) {
    return arguments.length ? (l = T[0] % 360 * Ue, u = T[1] % 360 * Ue, d = T.length > 2 ? T[2] % 360 * Ue : 0, E()) : [l * Tt, u * Tt, d * Tt];
  }, w.precision = function(T) {
    return arguments.length ? (x = nv(P, y = T * T), C()) : Zt(y);
  }, w.fitExtent = function(T, D) {
    return ld(w, T, D);
  }, w.fitSize = function(T, D) {
    return Kg(w, T, D);
  }, w.fitWidth = function(T, D) {
    return Zg(w, T, D);
  }, w.fitHeight = function(T, D) {
    return e0(w, T, D);
  };
  function E() {
    h = yS(f = Xg(l, u, d), t);
    var T = t(s, c);
    return a = r - T[0] * n, o = i + T[1] * n, C();
  }
  function C() {
    return b = A = null, w;
  }
  return function() {
    return t = e.apply(this, arguments), w.invert = t.invert && O, E();
  };
}
function n0(e) {
  var t = 0, n = it / 3, r = t0(e), i = r(t, n);
  return i.parallels = function(a) {
    return arguments.length ? r(t = a[0] * Ue, n = a[1] * Ue) : [t * Tt, n * Tt];
  }, i;
}
function xj(e) {
  var t = Fe(e);
  function n(r, i) {
    return [r * t, Le(i) / t];
  }
  return n.invert = function(r, i) {
    return [r / t, Zn(i * t)];
  }, n;
}
function FS(e, t) {
  var n = Le(e), r = (n + Le(t)) / 2;
  if (ft(r) < Ye) return xj(e);
  var i = 1 + n * (2 * r - n), a = Zt(i) / r;
  function o(s, c) {
    var l = Zt(i - 2 * r * Le(c)) / r;
    return [l * Le(s *= r), a - l * Fe(s)];
  }
  return o.invert = function(s, c) {
    var l = a - c;
    return [In(s, ft(l)) / r * yl(l), Zn((i - (s * s + l * l) * r * r) / (2 * r))];
  }, o;
}
function tf() {
  return n0(FS).scale(155.424).center([0, 33.6442]);
}
function $S() {
  return tf().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function vj(e) {
  var t = e.length;
  return {
    point: function(n, r) {
      for (var i = -1; ++i < t; ) e[i].point(n, r);
    },
    sphere: function() {
      for (var n = -1; ++n < t; ) e[n].sphere();
    },
    lineStart: function() {
      for (var n = -1; ++n < t; ) e[n].lineStart();
    },
    lineEnd: function() {
      for (var n = -1; ++n < t; ) e[n].lineEnd();
    },
    polygonStart: function() {
      for (var n = -1; ++n < t; ) e[n].polygonStart();
    },
    polygonEnd: function() {
      for (var n = -1; ++n < t; ) e[n].polygonEnd();
    }
  };
}
function Aj() {
  var e, t, n = $S(), r, i = tf().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), a, o = tf().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), s, c, l = { point: function(f, h) {
    c = [f, h];
  } };
  function u(f) {
    var h = f[0], m = f[1];
    return c = null, r.point(h, m), c || (a.point(h, m), c) || (s.point(h, m), c);
  }
  u.invert = function(f) {
    var h = n.scale(), m = n.translate(), g = (f[0] - m[0]) / h, v = (f[1] - m[1]) / h;
    return (v >= 0.12 && v < 0.234 && g >= -0.425 && g < -0.214 ? i : v >= 0.166 && v < 0.234 && g >= -0.214 && g < -0.115 ? o : n).invert(f);
  }, u.stream = function(f) {
    return e && t === f ? e : e = vj([n.stream(t = f), i.stream(f), o.stream(f)]);
  }, u.precision = function(f) {
    return arguments.length ? (n.precision(f), i.precision(f), o.precision(f), d()) : n.precision();
  }, u.scale = function(f) {
    return arguments.length ? (n.scale(f), i.scale(f * 0.35), o.scale(f), u.translate(n.translate())) : n.scale();
  }, u.translate = function(f) {
    if (!arguments.length) return n.translate();
    var h = n.scale(), m = +f[0], g = +f[1];
    return r = n.translate(f).clipExtent([[m - 0.455 * h, g - 0.238 * h], [m + 0.455 * h, g + 0.238 * h]]).stream(l), a = i.translate([m - 0.307 * h, g + 0.201 * h]).clipExtent([[m - 0.425 * h + Ye, g + 0.12 * h + Ye], [m - 0.214 * h - Ye, g + 0.234 * h - Ye]]).stream(l), s = o.translate([m - 0.205 * h, g + 0.212 * h]).clipExtent([[m - 0.214 * h + Ye, g + 0.166 * h + Ye], [m - 0.115 * h - Ye, g + 0.234 * h - Ye]]).stream(l), d();
  }, u.fitExtent = function(f, h) {
    return ld(u, f, h);
  }, u.fitSize = function(f, h) {
    return Kg(u, f, h);
  }, u.fitWidth = function(f, h) {
    return Zg(u, f, h);
  }, u.fitHeight = function(f, h) {
    return e0(u, f, h);
  };
  function d() {
    return e = t = null, u;
  }
  return u.scale(1070);
}
function YS(e) {
  return function(t, n) {
    var r = Fe(t), i = Fe(n), a = e(r * i);
    return [
      a * i * Le(t),
      a * Le(n)
    ];
  };
}
function Ul(e) {
  return function(t, n) {
    var r = Zt(t * t + n * n), i = e(r), a = Le(i), o = Fe(i);
    return [
      In(t * a, r * o),
      Zn(r && n * a / r)
    ];
  };
}
var r0 = YS(function(e) {
  return Zt(2 / (1 + e));
});
r0.invert = Ul(function(e) {
  return 2 * Zn(e / 2);
});
function bj() {
  return Ci(r0).scale(124.75).clipAngle(180 - 1e-3);
}
var i0 = YS(function(e) {
  return (e = oS(e)) && e / Le(e);
});
i0.invert = Ul(function(e) {
  return e;
});
function wj() {
  return Ci(i0).scale(79.4188).clipAngle(180 - 1e-3);
}
function Gl(e, t) {
  return [e, Lu(Qg((Gt + t) / 2))];
}
Gl.invert = function(e, t) {
  return [e, 2 * Vo(aS(t)) - Gt];
};
function _j() {
  return jS(Gl).scale(961 / Ln);
}
function jS(e) {
  var t = Ci(e), n = t.center, r = t.scale, i = t.translate, a = t.clipExtent, o = null, s, c, l;
  t.scale = function(d) {
    return arguments.length ? (r(d), u()) : r();
  }, t.translate = function(d) {
    return arguments.length ? (i(d), u()) : i();
  }, t.center = function(d) {
    return arguments.length ? (n(d), u()) : n();
  }, t.clipExtent = function(d) {
    return arguments.length ? (d == null ? o = s = c = l = null : (o = +d[0][0], s = +d[0][1], c = +d[1][0], l = +d[1][1]), u()) : o == null ? null : [[o, s], [c, l]];
  };
  function u() {
    var d = it * r(), f = t(xS(t.rotate()).invert([0, 0]));
    return a(o == null ? [[f[0] - d, f[1] - d], [f[0] + d, f[1] + d]] : e === Gl ? [[Math.max(f[0] - d, o), s], [Math.min(f[0] + d, c), l]] : [[o, Math.max(f[1] - d, s)], [c, Math.min(f[1] + d, l)]]);
  }
  return u();
}
function Mc(e) {
  return Qg((Gt + e) / 2);
}
function WS(e, t) {
  var n = Fe(e), r = e === t ? Le(e) : Lu(n / Fe(t)) / Lu(Mc(t) / Mc(e)), i = n * ph(Mc(e), r) / r;
  if (!r) return Gl;
  function a(o, s) {
    i > 0 ? s < -Gt + Ye && (s = -Gt + Ye) : s > Gt - Ye && (s = Gt - Ye);
    var c = i / ph(Mc(s), r);
    return [c * Le(r * o), i - c * Fe(r * o)];
  }
  return a.invert = function(o, s) {
    var c = i - s, l = yl(r) * Zt(o * o + c * c);
    return [In(o, ft(c)) / r * yl(c), 2 * Vo(ph(i / l, 1 / r)) - Gt];
  }, a;
}
function Sj() {
  return n0(WS).scale(109.5).parallels([30, 30]);
}
function Al(e, t) {
  return [e, t];
}
Al.invert = Al;
function Cj() {
  return Ci(Al).scale(152.63);
}
function HS(e, t) {
  var n = Fe(e), r = e === t ? Le(e) : (n - Fe(t)) / (t - e), i = n / r + e;
  if (ft(r) < Ye) return Al;
  function a(o, s) {
    var c = i - s, l = r * o;
    return [c * Le(l), i - c * Fe(l)];
  }
  return a.invert = function(o, s) {
    var c = i - s;
    return [In(o, ft(c)) / r * yl(c), i - yl(r) * Zt(o * o + c * c)];
  }, a;
}
function Ej() {
  return n0(HS).scale(131.154).center([0, 13.9389]);
}
function a0(e, t) {
  var n = Fe(t), r = Fe(e) * n;
  return [n * Le(e) / r, Le(t) / r];
}
a0.invert = Ul(Vo);
function kj() {
  return Ci(a0).scale(144.049).clipAngle(60);
}
function Ic(e, t, n, r) {
  return e === 1 && t === 1 && n === 0 && r === 0 ? _a : Hl({
    point: function(i, a) {
      this.stream.point(i * e + n, a * t + r);
    }
  });
}
function Tj() {
  var e = 1, t = 0, n = 0, r = 1, i = 1, a = _a, o = null, s, c, l, u = _a, d, f, h;
  function m() {
    return d = f = null, h;
  }
  return h = {
    stream: function(g) {
      return d && f === g ? d : d = a(u(f = g));
    },
    postclip: function(g) {
      return arguments.length ? (u = g, o = s = c = l = null, m()) : u;
    },
    clipExtent: function(g) {
      return arguments.length ? (u = g == null ? (o = s = c = l = null, _a) : sd(o = +g[0][0], s = +g[0][1], c = +g[1][0], l = +g[1][1]), m()) : o == null ? null : [[o, s], [c, l]];
    },
    scale: function(g) {
      return arguments.length ? (a = Ic((e = +g) * r, e * i, t, n), m()) : e;
    },
    translate: function(g) {
      return arguments.length ? (a = Ic(e * r, e * i, t = +g[0], n = +g[1]), m()) : [t, n];
    },
    reflectX: function(g) {
      return arguments.length ? (a = Ic(e * (r = g ? -1 : 1), e * i, t, n), m()) : r < 0;
    },
    reflectY: function(g) {
      return arguments.length ? (a = Ic(e * r, e * (i = g ? -1 : 1), t, n), m()) : i < 0;
    },
    fitExtent: function(g, v) {
      return ld(h, g, v);
    },
    fitSize: function(g, v) {
      return Kg(h, g, v);
    },
    fitWidth: function(g, v) {
      return Zg(h, g, v);
    },
    fitHeight: function(g, v) {
      return e0(h, g, v);
    }
  };
}
function o0(e, t) {
  var n = t * t, r = n * n;
  return [
    e * (0.8707 - 0.131979 * n + r * (-0.013791 + r * (3971e-6 * n - 1529e-6 * r))),
    t * (1.007226 + n * (0.015085 + r * (-0.044475 + 0.028874 * n - 5916e-6 * r)))
  ];
}
o0.invert = function(e, t) {
  var n = t, r = 25, i;
  do {
    var a = n * n, o = a * a;
    n -= i = (n * (1.007226 + a * (0.015085 + o * (-0.044475 + 0.028874 * a - 5916e-6 * o))) - t) / (1.007226 + a * (0.015085 * 3 + o * (-0.044475 * 7 + 0.028874 * 9 * a - 5916e-6 * 11 * o)));
  } while (ft(i) > Ye && --r > 0);
  return [
    e / (0.8707 + (a = n * n) * (-0.131979 + a * (-0.013791 + a * a * a * (3971e-6 - 1529e-6 * a)))),
    n
  ];
};
function Mj() {
  return Ci(o0).scale(175.295);
}
function s0(e, t) {
  return [Fe(t) * Le(e), Le(t)];
}
s0.invert = Ul(Zn);
function Ij() {
  return Ci(s0).scale(249.5).clipAngle(90 + Ye);
}
function l0(e, t) {
  var n = Fe(t), r = 1 + Fe(e) * n;
  return [n * Le(e) / r, Le(t) / r];
}
l0.invert = Ul(function(e) {
  return 2 * Vo(e);
});
function Nj() {
  return Ci(l0).scale(250).clipAngle(142);
}
function c0(e, t) {
  return [Lu(Qg((Gt + t) / 2)), -e];
}
c0.invert = function(e, t) {
  return [-t, 2 * Vo(aS(e)) - Gt];
};
function Oj() {
  var e = jS(c0), t = e.center, n = e.rotate;
  return e.center = function(r) {
    return arguments.length ? t([-r[1], r[0]]) : (r = t(), [r[1], -r[0]]);
  }, e.rotate = function(r) {
    return arguments.length ? n([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = n(), [r[0], r[1], r[2] - 90]);
  }, n([0, 0, 90]).scale(159.155);
}
function Rj(e, t) {
  return e.parent === t.parent ? 1 : 2;
}
function Dj(e) {
  return e.reduce(Pj, 0) / e.length;
}
function Pj(e, t) {
  return e + t.x;
}
function Lj(e) {
  return 1 + e.reduce(zj, 0);
}
function zj(e, t) {
  return Math.max(e, t.y);
}
function Bj(e) {
  for (var t; t = e.children; ) e = t[0];
  return e;
}
function Fj(e) {
  for (var t; t = e.children; ) e = t[t.length - 1];
  return e;
}
function $j() {
  var e = Rj, t = 1, n = 1, r = !1;
  function i(a) {
    var o, s = 0;
    a.eachAfter(function(f) {
      var h = f.children;
      h ? (f.x = Dj(h), f.y = Lj(h)) : (f.x = o ? s += e(f, o) : 0, f.y = 0, o = f);
    });
    var c = Bj(a), l = Fj(a), u = c.x - e(c, l) / 2, d = l.x + e(l, c) / 2;
    return a.eachAfter(r ? function(f) {
      f.x = (f.x - a.x) * t, f.y = (a.y - f.y) * n;
    } : function(f) {
      f.x = (f.x - u) / (d - u) * t, f.y = (1 - (a.y ? f.y / a.y : 1)) * n;
    });
  }
  return i.separation = function(a) {
    return arguments.length ? (e = a, i) : e;
  }, i.size = function(a) {
    return arguments.length ? (r = !1, t = +a[0], n = +a[1], i) : r ? null : [t, n];
  }, i.nodeSize = function(a) {
    return arguments.length ? (r = !0, t = +a[0], n = +a[1], i) : r ? [t, n] : null;
  }, i;
}
function Yj(e) {
  var t = 0, n = e.children, r = n && n.length;
  if (!r) t = 1;
  else for (; --r >= 0; ) t += n[r].value;
  e.value = t;
}
function jj() {
  return this.eachAfter(Yj);
}
function Wj(e) {
  var t = this, n, r = [t], i, a, o;
  do
    for (n = r.reverse(), r = []; t = n.pop(); )
      if (e(t), i = t.children, i) for (a = 0, o = i.length; a < o; ++a)
        r.push(i[a]);
  while (r.length);
  return this;
}
function Hj(e) {
  for (var t = this, n = [t], r, i; t = n.pop(); )
    if (e(t), r = t.children, r) for (i = r.length - 1; i >= 0; --i)
      n.push(r[i]);
  return this;
}
function Uj(e) {
  for (var t = this, n = [t], r = [], i, a, o; t = n.pop(); )
    if (r.push(t), i = t.children, i) for (a = 0, o = i.length; a < o; ++a)
      n.push(i[a]);
  for (; t = r.pop(); )
    e(t);
  return this;
}
function Gj(e) {
  return this.eachAfter(function(t) {
    for (var n = +e(t.data) || 0, r = t.children, i = r && r.length; --i >= 0; ) n += r[i].value;
    t.value = n;
  });
}
function Vj(e) {
  return this.eachBefore(function(t) {
    t.children && t.children.sort(e);
  });
}
function Qj(e) {
  for (var t = this, n = qj(t, e), r = [t]; t !== n; )
    t = t.parent, r.push(t);
  for (var i = r.length; e !== n; )
    r.splice(i, 0, e), e = e.parent;
  return r;
}
function qj(e, t) {
  if (e === t) return e;
  var n = e.ancestors(), r = t.ancestors(), i = null;
  for (e = n.pop(), t = r.pop(); e === t; )
    i = e, e = n.pop(), t = r.pop();
  return i;
}
function Xj() {
  for (var e = this, t = [e]; e = e.parent; )
    t.push(e);
  return t;
}
function Jj() {
  var e = [];
  return this.each(function(t) {
    e.push(t);
  }), e;
}
function Kj() {
  var e = [];
  return this.eachBefore(function(t) {
    t.children || e.push(t);
  }), e;
}
function Zj() {
  var e = this, t = [];
  return e.each(function(n) {
    n !== e && t.push({ source: n.parent, target: n });
  }), t;
}
function cd(e, t) {
  var n = new Do(e), r = +e.value && (n.value = e.value), i, a = [n], o, s, c, l;
  for (t == null && (t = t7); i = a.pop(); )
    if (r && (i.value = +i.data.value), (s = t(i.data)) && (l = s.length))
      for (i.children = new Array(l), c = l - 1; c >= 0; --c)
        a.push(o = i.children[c] = new Do(s[c])), o.parent = i, o.depth = i.depth + 1;
  return n.eachBefore(US);
}
function e7() {
  return cd(this).eachBefore(n7);
}
function t7(e) {
  return e.children;
}
function n7(e) {
  e.data = e.data.data;
}
function US(e) {
  var t = 0;
  do
    e.height = t;
  while ((e = e.parent) && e.height < ++t);
}
function Do(e) {
  this.data = e, this.depth = this.height = 0, this.parent = null;
}
Do.prototype = cd.prototype = {
  constructor: Do,
  count: jj,
  each: Wj,
  eachAfter: Uj,
  eachBefore: Hj,
  sum: Gj,
  sort: Vj,
  path: Qj,
  ancestors: Xj,
  descendants: Jj,
  leaves: Kj,
  links: Zj,
  copy: e7
};
var r7 = Array.prototype.slice;
function i7(e) {
  for (var t = e.length, n, r; t; )
    r = Math.random() * t-- | 0, n = e[t], e[t] = e[r], e[r] = n;
  return e;
}
function GS(e) {
  for (var t = 0, n = (e = i7(r7.call(e))).length, r = [], i, a; t < n; )
    i = e[t], a && VS(a, i) ? ++t : (a = o7(r = a7(r, i)), t = 0);
  return a;
}
function a7(e, t) {
  var n, r;
  if (vh(t, e)) return [t];
  for (n = 0; n < e.length; ++n)
    if (Nc(t, e[n]) && vh(Ts(e[n], t), e))
      return [e[n], t];
  for (n = 0; n < e.length - 1; ++n)
    for (r = n + 1; r < e.length; ++r)
      if (Nc(Ts(e[n], e[r]), t) && Nc(Ts(e[n], t), e[r]) && Nc(Ts(e[r], t), e[n]) && vh(QS(e[n], e[r], t), e))
        return [e[n], e[r], t];
  throw new Error();
}
function Nc(e, t) {
  var n = e.r - t.r, r = t.x - e.x, i = t.y - e.y;
  return n < 0 || n * n < r * r + i * i;
}
function VS(e, t) {
  var n = e.r - t.r + 1e-6, r = t.x - e.x, i = t.y - e.y;
  return n > 0 && n * n > r * r + i * i;
}
function vh(e, t) {
  for (var n = 0; n < t.length; ++n)
    if (!VS(e, t[n]))
      return !1;
  return !0;
}
function o7(e) {
  switch (e.length) {
    case 1:
      return s7(e[0]);
    case 2:
      return Ts(e[0], e[1]);
    case 3:
      return QS(e[0], e[1], e[2]);
  }
}
function s7(e) {
  return {
    x: e.x,
    y: e.y,
    r: e.r
  };
}
function Ts(e, t) {
  var n = e.x, r = e.y, i = e.r, a = t.x, o = t.y, s = t.r, c = a - n, l = o - r, u = s - i, d = Math.sqrt(c * c + l * l);
  return {
    x: (n + a + c / d * u) / 2,
    y: (r + o + l / d * u) / 2,
    r: (d + i + s) / 2
  };
}
function QS(e, t, n) {
  var r = e.x, i = e.y, a = e.r, o = t.x, s = t.y, c = t.r, l = n.x, u = n.y, d = n.r, f = r - o, h = r - l, m = i - s, g = i - u, v = c - a, _ = d - a, I = r * r + i * i - a * a, M = I - o * o - s * s + c * c, k = I - l * l - u * u + d * d, y = h * m - f * g, x = (m * k - g * M) / (y * 2) - r, b = (g * v - m * _) / y, A = (h * M - f * k) / (y * 2) - i, w = (f * _ - h * v) / y, O = b * b + w * w - 1, P = 2 * (a + x * b + A * w), E = x * x + A * A - a * a, C = -(O ? (P + Math.sqrt(P * P - 4 * O * E)) / (2 * O) : E / P);
  return {
    x: r + x + b * C,
    y: i + A + w * C,
    r: C
  };
}
function rv(e, t, n) {
  var r = e.x, i = e.y, a = t.r + n.r, o = e.r + n.r, s = t.x - r, c = t.y - i, l = s * s + c * c;
  if (l) {
    var u = 0.5 + ((o *= o) - (a *= a)) / (2 * l), d = Math.sqrt(Math.max(0, 2 * a * (o + l) - (o -= l) * o - a * a)) / (2 * l);
    n.x = r + u * s + d * c, n.y = i + u * c - d * s;
  } else
    n.x = r + o, n.y = i;
}
function iv(e, t) {
  var n = t.x - e.x, r = t.y - e.y, i = e.r + t.r;
  return i * i - 1e-6 > n * n + r * r;
}
function av(e) {
  var t = e._, n = e.next._, r = t.r + n.r, i = (t.x * n.r + n.x * t.r) / r, a = (t.y * n.r + n.y * t.r) / r;
  return i * i + a * a;
}
function Oc(e) {
  this._ = e, this.next = null, this.previous = null;
}
function qS(e) {
  if (!(i = e.length)) return 0;
  var t, n, r, i, a, o, s, c, l, u, d;
  if (t = e[0], t.x = 0, t.y = 0, !(i > 1)) return t.r;
  if (n = e[1], t.x = -n.r, n.x = t.r, n.y = 0, !(i > 2)) return t.r + n.r;
  rv(n, t, r = e[2]), t = new Oc(t), n = new Oc(n), r = new Oc(r), t.next = r.previous = n, n.next = t.previous = r, r.next = n.previous = t;
  e: for (s = 3; s < i; ++s) {
    rv(t._, n._, r = e[s]), r = new Oc(r), c = n.next, l = t.previous, u = n._.r, d = t._.r;
    do
      if (u <= d) {
        if (iv(c._, r._)) {
          n = c, t.next = n, n.previous = t, --s;
          continue e;
        }
        u += c._.r, c = c.next;
      } else {
        if (iv(l._, r._)) {
          t = l, t.next = n, n.previous = t, --s;
          continue e;
        }
        d += l._.r, l = l.previous;
      }
    while (c !== l.next);
    for (r.previous = t, r.next = n, t.next = n.previous = n = r, a = av(t); (r = r.next) !== n; )
      (o = av(r)) < a && (t = r, a = o);
    n = t.next;
  }
  for (t = [n._], r = n; (r = r.next) !== n; ) t.push(r._);
  for (r = GS(t), s = 0; s < i; ++s) t = e[s], t.x -= r.x, t.y -= r.y;
  return r.r;
}
function l7(e) {
  return qS(e), e;
}
function c7(e) {
  return e == null ? null : nf(e);
}
function nf(e) {
  if (typeof e != "function") throw new Error();
  return e;
}
function ga() {
  return 0;
}
function io(e) {
  return function() {
    return e;
  };
}
function u7(e) {
  return Math.sqrt(e.value);
}
function f7() {
  var e = null, t = 1, n = 1, r = ga;
  function i(a) {
    return a.x = t / 2, a.y = n / 2, e ? a.eachBefore(ov(e)).eachAfter(Ah(r, 0.5)).eachBefore(sv(1)) : a.eachBefore(ov(u7)).eachAfter(Ah(ga, 1)).eachAfter(Ah(r, a.r / Math.min(t, n))).eachBefore(sv(Math.min(t, n) / (2 * a.r))), a;
  }
  return i.radius = function(a) {
    return arguments.length ? (e = c7(a), i) : e;
  }, i.size = function(a) {
    return arguments.length ? (t = +a[0], n = +a[1], i) : [t, n];
  }, i.padding = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : io(+a), i) : r;
  }, i;
}
function ov(e) {
  return function(t) {
    t.children || (t.r = Math.max(0, +e(t) || 0));
  };
}
function Ah(e, t) {
  return function(n) {
    if (r = n.children) {
      var r, i, a = r.length, o = e(n) * t || 0, s;
      if (o) for (i = 0; i < a; ++i) r[i].r += o;
      if (s = qS(r), o) for (i = 0; i < a; ++i) r[i].r -= o;
      n.r = s + o;
    }
  };
}
function sv(e) {
  return function(t) {
    var n = t.parent;
    t.r *= e, n && (t.x = n.x + e * t.x, t.y = n.y + e * t.y);
  };
}
function XS(e) {
  e.x0 = Math.round(e.x0), e.y0 = Math.round(e.y0), e.x1 = Math.round(e.x1), e.y1 = Math.round(e.y1);
}
function Vl(e, t, n, r, i) {
  for (var a = e.children, o, s = -1, c = a.length, l = e.value && (r - t) / e.value; ++s < c; )
    o = a[s], o.y0 = n, o.y1 = i, o.x0 = t, o.x1 = t += o.value * l;
}
function d7() {
  var e = 1, t = 1, n = 0, r = !1;
  function i(o) {
    var s = o.height + 1;
    return o.x0 = o.y0 = n, o.x1 = e, o.y1 = t / s, o.eachBefore(a(t, s)), r && o.eachBefore(XS), o;
  }
  function a(o, s) {
    return function(c) {
      c.children && Vl(c, c.x0, o * (c.depth + 1) / s, c.x1, o * (c.depth + 2) / s);
      var l = c.x0, u = c.y0, d = c.x1 - n, f = c.y1 - n;
      d < l && (l = d = (l + d) / 2), f < u && (u = f = (u + f) / 2), c.x0 = l, c.y0 = u, c.x1 = d, c.y1 = f;
    };
  }
  return i.round = function(o) {
    return arguments.length ? (r = !!o, i) : r;
  }, i.size = function(o) {
    return arguments.length ? (e = +o[0], t = +o[1], i) : [e, t];
  }, i.padding = function(o) {
    return arguments.length ? (n = +o, i) : n;
  }, i;
}
var lv = "$", h7 = { depth: -1 }, cv = {};
function p7(e) {
  return e.id;
}
function m7(e) {
  return e.parentId;
}
function g7() {
  var e = p7, t = m7;
  function n(r) {
    var i, a, o = r.length, s, c, l, u = new Array(o), d, f, h = {};
    for (a = 0; a < o; ++a)
      i = r[a], l = u[a] = new Do(i), (d = e(i, a, r)) != null && (d += "") && (f = lv + (l.id = d), h[f] = f in h ? cv : l);
    for (a = 0; a < o; ++a)
      if (l = u[a], d = t(r[a], a, r), d == null || !(d += "")) {
        if (s) throw new Error("multiple roots");
        s = l;
      } else {
        if (c = h[lv + d], !c) throw new Error("missing: " + d);
        if (c === cv) throw new Error("ambiguous: " + d);
        c.children ? c.children.push(l) : c.children = [l], l.parent = c;
      }
    if (!s) throw new Error("no root");
    if (s.parent = h7, s.eachBefore(function(m) {
      m.depth = m.parent.depth + 1, --o;
    }).eachBefore(US), s.parent = null, o > 0) throw new Error("cycle");
    return s;
  }
  return n.id = function(r) {
    return arguments.length ? (e = nf(r), n) : e;
  }, n.parentId = function(r) {
    return arguments.length ? (t = nf(r), n) : t;
  }, n;
}
function y7(e, t) {
  return e.parent === t.parent ? 1 : 2;
}
function bh(e) {
  var t = e.children;
  return t ? t[0] : e.t;
}
function wh(e) {
  var t = e.children;
  return t ? t[t.length - 1] : e.t;
}
function x7(e, t, n) {
  var r = n / (t.i - e.i);
  t.c -= r, t.s += n, e.c += r, t.z += n, t.m += n;
}
function v7(e) {
  for (var t = 0, n = 0, r = e.children, i = r.length, a; --i >= 0; )
    a = r[i], a.z += t, a.m += t, t += a.s + (n += a.c);
}
function A7(e, t, n) {
  return e.a.parent === t.parent ? e.a : n;
}
function ou(e, t) {
  this._ = e, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = t;
}
ou.prototype = Object.create(Do.prototype);
function b7(e) {
  for (var t = new ou(e, 0), n, r = [t], i, a, o, s; n = r.pop(); )
    if (a = n._.children)
      for (n.children = new Array(s = a.length), o = s - 1; o >= 0; --o)
        r.push(i = n.children[o] = new ou(a[o], o)), i.parent = n;
  return (t.parent = new ou(null, 0)).children = [t], t;
}
function w7() {
  var e = y7, t = 1, n = 1, r = null;
  function i(l) {
    var u = b7(l);
    if (u.eachAfter(a), u.parent.m = -u.z, u.eachBefore(o), r) l.eachBefore(c);
    else {
      var d = l, f = l, h = l;
      l.eachBefore(function(I) {
        I.x < d.x && (d = I), I.x > f.x && (f = I), I.depth > h.depth && (h = I);
      });
      var m = d === f ? 1 : e(d, f) / 2, g = m - d.x, v = t / (f.x + m + g), _ = n / (h.depth || 1);
      l.eachBefore(function(I) {
        I.x = (I.x + g) * v, I.y = I.depth * _;
      });
    }
    return l;
  }
  function a(l) {
    var u = l.children, d = l.parent.children, f = l.i ? d[l.i - 1] : null;
    if (u) {
      v7(l);
      var h = (u[0].z + u[u.length - 1].z) / 2;
      f ? (l.z = f.z + e(l._, f._), l.m = l.z - h) : l.z = h;
    } else f && (l.z = f.z + e(l._, f._));
    l.parent.A = s(l, f, l.parent.A || d[0]);
  }
  function o(l) {
    l._.x = l.z + l.parent.m, l.m += l.parent.m;
  }
  function s(l, u, d) {
    if (u) {
      for (var f = l, h = l, m = u, g = f.parent.children[0], v = f.m, _ = h.m, I = m.m, M = g.m, k; m = wh(m), f = bh(f), m && f; )
        g = bh(g), h = wh(h), h.a = l, k = m.z + I - f.z - v + e(m._, f._), k > 0 && (x7(A7(m, l, d), l, k), v += k, _ += k), I += m.m, v += f.m, M += g.m, _ += h.m;
      m && !wh(h) && (h.t = m, h.m += I - _), f && !bh(g) && (g.t = f, g.m += v - M, d = l);
    }
    return d;
  }
  function c(l) {
    l.x *= t, l.y = l.depth * n;
  }
  return i.separation = function(l) {
    return arguments.length ? (e = l, i) : e;
  }, i.size = function(l) {
    return arguments.length ? (r = !1, t = +l[0], n = +l[1], i) : r ? null : [t, n];
  }, i.nodeSize = function(l) {
    return arguments.length ? (r = !0, t = +l[0], n = +l[1], i) : r ? [t, n] : null;
  }, i;
}
function ud(e, t, n, r, i) {
  for (var a = e.children, o, s = -1, c = a.length, l = e.value && (i - n) / e.value; ++s < c; )
    o = a[s], o.x0 = t, o.x1 = r, o.y0 = n, o.y1 = n += o.value * l;
}
var JS = (1 + Math.sqrt(5)) / 2;
function KS(e, t, n, r, i, a) {
  for (var o = [], s = t.children, c, l, u = 0, d = 0, f = s.length, h, m, g = t.value, v, _, I, M, k, y, x; u < f; ) {
    h = i - n, m = a - r;
    do
      v = s[d++].value;
    while (!v && d < f);
    for (_ = I = v, y = Math.max(m / h, h / m) / (g * e), x = v * v * y, k = Math.max(I / x, x / _); d < f; ++d) {
      if (v += l = s[d].value, l < _ && (_ = l), l > I && (I = l), x = v * v * y, M = Math.max(I / x, x / _), M > k) {
        v -= l;
        break;
      }
      k = M;
    }
    o.push(c = { value: v, dice: h < m, children: s.slice(u, d) }), c.dice ? Vl(c, n, r, i, g ? r += m * v / g : a) : ud(c, n, r, g ? n += h * v / g : i, a), g -= v, u = d;
  }
  return o;
}
const ZS = function e(t) {
  function n(r, i, a, o, s) {
    KS(t, r, i, a, o, s);
  }
  return n.ratio = function(r) {
    return e((r = +r) > 1 ? r : 1);
  }, n;
}(JS);
function e2() {
  var e = ZS, t = !1, n = 1, r = 1, i = [0], a = ga, o = ga, s = ga, c = ga, l = ga;
  function u(f) {
    return f.x0 = f.y0 = 0, f.x1 = n, f.y1 = r, f.eachBefore(d), i = [0], t && f.eachBefore(XS), f;
  }
  function d(f) {
    var h = i[f.depth], m = f.x0 + h, g = f.y0 + h, v = f.x1 - h, _ = f.y1 - h;
    v < m && (m = v = (m + v) / 2), _ < g && (g = _ = (g + _) / 2), f.x0 = m, f.y0 = g, f.x1 = v, f.y1 = _, f.children && (h = i[f.depth + 1] = a(f) / 2, m += l(f) - h, g += o(f) - h, v -= s(f) - h, _ -= c(f) - h, v < m && (m = v = (m + v) / 2), _ < g && (g = _ = (g + _) / 2), e(f, m, g, v, _));
  }
  return u.round = function(f) {
    return arguments.length ? (t = !!f, u) : t;
  }, u.size = function(f) {
    return arguments.length ? (n = +f[0], r = +f[1], u) : [n, r];
  }, u.tile = function(f) {
    return arguments.length ? (e = nf(f), u) : e;
  }, u.padding = function(f) {
    return arguments.length ? u.paddingInner(f).paddingOuter(f) : u.paddingInner();
  }, u.paddingInner = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : io(+f), u) : a;
  }, u.paddingOuter = function(f) {
    return arguments.length ? u.paddingTop(f).paddingRight(f).paddingBottom(f).paddingLeft(f) : u.paddingTop();
  }, u.paddingTop = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : io(+f), u) : o;
  }, u.paddingRight = function(f) {
    return arguments.length ? (s = typeof f == "function" ? f : io(+f), u) : s;
  }, u.paddingBottom = function(f) {
    return arguments.length ? (c = typeof f == "function" ? f : io(+f), u) : c;
  }, u.paddingLeft = function(f) {
    return arguments.length ? (l = typeof f == "function" ? f : io(+f), u) : l;
  }, u;
}
function _7(e, t, n, r, i) {
  var a = e.children, o, s = a.length, c, l = new Array(s + 1);
  for (l[0] = c = o = 0; o < s; ++o)
    l[o + 1] = c += a[o].value;
  u(0, s, e.value, t, n, r, i);
  function u(d, f, h, m, g, v, _) {
    if (d >= f - 1) {
      var I = a[d];
      I.x0 = m, I.y0 = g, I.x1 = v, I.y1 = _;
      return;
    }
    for (var M = l[d], k = h / 2 + M, y = d + 1, x = f - 1; y < x; ) {
      var b = y + x >>> 1;
      l[b] < k ? y = b + 1 : x = b;
    }
    k - l[y - 1] < l[y] - k && d + 1 < y && --y;
    var A = l[y] - M, w = h - A;
    if (v - m > _ - g) {
      var O = (m * w + v * A) / h;
      u(d, y, A, m, g, O, _), u(y, f, w, O, g, v, _);
    } else {
      var P = (g * w + _ * A) / h;
      u(d, y, A, m, g, v, P), u(y, f, w, m, P, v, _);
    }
  }
}
function S7(e, t, n, r, i) {
  (e.depth & 1 ? ud : Vl)(e, t, n, r, i);
}
const C7 = function e(t) {
  function n(r, i, a, o, s) {
    if ((c = r._squarify) && c.ratio === t)
      for (var c, l, u, d, f = -1, h, m = c.length, g = r.value; ++f < m; ) {
        for (l = c[f], u = l.children, d = l.value = 0, h = u.length; d < h; ++d) l.value += u[d].value;
        l.dice ? Vl(l, i, a, o, a += (s - a) * l.value / g) : ud(l, i, a, i += (o - i) * l.value / g, s), g -= l.value;
      }
    else
      r._squarify = c = KS(t, r, i, a, o, s), c.ratio = t;
  }
  return n.ratio = function(r) {
    return e((r = +r) > 1 ? r : 1);
  }, n;
}(JS);
function E7(e) {
  for (var t = -1, n = e.length, r, i = e[n - 1], a = 0; ++t < n; )
    r = i, i = e[t], a += r[1] * i[0] - r[0] * i[1];
  return a / 2;
}
function k7(e) {
  for (var t = -1, n = e.length, r = 0, i = 0, a, o = e[n - 1], s, c = 0; ++t < n; )
    a = o, o = e[t], c += s = a[0] * o[1] - o[0] * a[1], r += (a[0] + o[0]) * s, i += (a[1] + o[1]) * s;
  return c *= 3, [r / c, i / c];
}
function T7(e, t, n) {
  return (t[0] - e[0]) * (n[1] - e[1]) - (t[1] - e[1]) * (n[0] - e[0]);
}
function M7(e, t) {
  return e[0] - t[0] || e[1] - t[1];
}
function uv(e) {
  for (var t = e.length, n = [0, 1], r = 2, i = 2; i < t; ++i) {
    for (; r > 1 && T7(e[n[r - 2]], e[n[r - 1]], e[i]) <= 0; ) --r;
    n[r++] = i;
  }
  return n.slice(0, r);
}
function I7(e) {
  if ((n = e.length) < 3) return null;
  var t, n, r = new Array(n), i = new Array(n);
  for (t = 0; t < n; ++t) r[t] = [+e[t][0], +e[t][1], t];
  for (r.sort(M7), t = 0; t < n; ++t) i[t] = [r[t][0], -r[t][1]];
  var a = uv(r), o = uv(i), s = o[0] === a[0], c = o[o.length - 1] === a[a.length - 1], l = [];
  for (t = a.length - 1; t >= 0; --t) l.push(e[r[a[t]][2]]);
  for (t = +s; t < o.length - c; ++t) l.push(e[r[o[t]][2]]);
  return l;
}
function N7(e, t) {
  for (var n = e.length, r = e[n - 1], i = t[0], a = t[1], o = r[0], s = r[1], c, l, u = !1, d = 0; d < n; ++d)
    r = e[d], c = r[0], l = r[1], l > a != s > a && i < (o - c) * (a - l) / (s - l) + c && (u = !u), o = c, s = l;
  return u;
}
function O7(e) {
  for (var t = -1, n = e.length, r = e[n - 1], i, a, o = r[0], s = r[1], c = 0; ++t < n; )
    i = o, a = s, r = e[t], o = r[0], s = r[1], i -= o, a -= s, c += Math.sqrt(i * i + a * a);
  return c;
}
var R7 = [].slice, D7 = {};
function sm(e) {
  this._size = e, this._call = this._error = null, this._tasks = [], this._data = [], this._waiting = this._active = this._ended = this._start = 0;
}
sm.prototype = n2.prototype = {
  constructor: sm,
  defer: function(e) {
    if (typeof e != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = R7.call(arguments, 1);
    return t.push(e), ++this._waiting, this._tasks.push(t), t2(this), this;
  },
  abort: function() {
    return this._error == null && u0(this, new Error("abort")), this;
  },
  await: function(e) {
    if (typeof e != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = function(t, n) {
      e.apply(null, [t].concat(n));
    }, rf(this), this;
  },
  awaitAll: function(e) {
    if (typeof e != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = e, rf(this), this;
  }
};
function t2(e) {
  if (!e._start)
    try {
      P7(e);
    } catch (t) {
      if (e._tasks[e._ended + e._active - 1]) u0(e, t);
      else if (!e._data) throw t;
    }
}
function P7(e) {
  for (; e._start = e._waiting && e._active < e._size; ) {
    var t = e._ended + e._active, n = e._tasks[t], r = n.length - 1, i = n[r];
    n[r] = L7(e, t), --e._waiting, ++e._active, n = i.apply(null, n), e._tasks[t] && (e._tasks[t] = n || D7);
  }
}
function L7(e, t) {
  return function(n, r) {
    e._tasks[t] && (--e._active, ++e._ended, e._tasks[t] = null, e._error == null && (n != null ? u0(e, n) : (e._data[t] = r, e._waiting ? t2(e) : rf(e))));
  };
}
function u0(e, t) {
  var n = e._tasks.length, r;
  for (e._error = t, e._data = void 0, e._waiting = NaN; --n >= 0; )
    if ((r = e._tasks[n]) && (e._tasks[n] = null, r.abort))
      try {
        r.abort();
      } catch {
      }
  e._active = NaN, rf(e);
}
function rf(e) {
  if (!e._active && e._call) {
    var t = e._data;
    e._data = void 0, e._call(e._error, t);
  }
}
function n2(e) {
  if (e == null) e = 1 / 0;
  else if (!((e = +e) >= 1)) throw new Error("invalid concurrency");
  return new sm(e);
}
function Qo() {
  return Math.random();
}
const z7 = function e(t) {
  function n(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, arguments.length === 1 ? (i = r, r = 0) : i -= r, function() {
      return t() * i + r;
    };
  }
  return n.source = e, n;
}(Qo), r2 = function e(t) {
  function n(r, i) {
    var a, o;
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      var s;
      if (a != null) s = a, a = null;
      else do
        a = t() * 2 - 1, s = t() * 2 - 1, o = a * a + s * s;
      while (!o || o > 1);
      return r + i * s * Math.sqrt(-2 * Math.log(o) / o);
    };
  }
  return n.source = e, n;
}(Qo), B7 = function e(t) {
  function n() {
    var r = r2.source(t).apply(this, arguments);
    return function() {
      return Math.exp(r());
    };
  }
  return n.source = e, n;
}(Qo), i2 = function e(t) {
  function n(r) {
    return function() {
      for (var i = 0, a = 0; a < r; ++a) i += t();
      return i;
    };
  }
  return n.source = e, n;
}(Qo), F7 = function e(t) {
  function n(r) {
    var i = i2.source(t)(r);
    return function() {
      return i() / r;
    };
  }
  return n.source = e, n;
}(Qo), $7 = function e(t) {
  function n(r) {
    return function() {
      return -Math.log(1 - t()) / r;
    };
  }
  return n.source = e, n;
}(Qo);
function f0(e, t) {
  var n, r = Ji("beforesend", "progress", "load", "error"), i, a = Xr(), o = new XMLHttpRequest(), s = null, c = null, l, u, d = 0;
  typeof XDomainRequest < "u" && !("withCredentials" in o) && /^(http(s)?:)?\/\//.test(e) && (o = new XDomainRequest()), "onload" in o ? o.onload = o.onerror = o.ontimeout = f : o.onreadystatechange = function(h) {
    o.readyState > 3 && f(h);
  };
  function f(h) {
    var m = o.status, g;
    if (!m && j7(o) || m >= 200 && m < 300 || m === 304) {
      if (l)
        try {
          g = l.call(n, o);
        } catch (v) {
          r.call("error", n, v);
          return;
        }
      else
        g = o;
      r.call("load", n, g);
    } else
      r.call("error", n, h);
  }
  if (o.onprogress = function(h) {
    r.call("progress", n, h);
  }, n = {
    header: function(h, m) {
      return h = (h + "").toLowerCase(), arguments.length < 2 ? a.get(h) : (m == null ? a.remove(h) : a.set(h, m + ""), n);
    },
    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(h) {
      return arguments.length ? (i = h == null ? null : h + "", n) : i;
    },
    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(h) {
      return arguments.length ? (u = h, n) : u;
    },
    timeout: function(h) {
      return arguments.length ? (d = +h, n) : d;
    },
    user: function(h) {
      return arguments.length < 1 ? s : (s = h == null ? null : h + "", n);
    },
    password: function(h) {
      return arguments.length < 1 ? c : (c = h == null ? null : h + "", n);
    },
    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(h) {
      return l = h, n;
    },
    // Alias for send("GET", …).
    get: function(h, m) {
      return n.send("GET", h, m);
    },
    // Alias for send("POST", …).
    post: function(h, m) {
      return n.send("POST", h, m);
    },
    // If callback is non-null, it will be used for error and load events.
    send: function(h, m, g) {
      return o.open(h, e, !0, s, c), i != null && !a.has("accept") && a.set("accept", i + ",*/*"), o.setRequestHeader && a.each(function(v, _) {
        o.setRequestHeader(_, v);
      }), i != null && o.overrideMimeType && o.overrideMimeType(i), u != null && (o.responseType = u), d > 0 && (o.timeout = d), g == null && typeof m == "function" && (g = m, m = null), g != null && g.length === 1 && (g = Y7(g)), g != null && n.on("error", g).on("load", function(v) {
        g(null, v);
      }), r.call("beforesend", n, o), o.send(m ?? null), n;
    },
    abort: function() {
      return o.abort(), n;
    },
    on: function() {
      var h = r.on.apply(r, arguments);
      return h === r ? n : h;
    }
  }, t != null) {
    if (typeof t != "function") throw new Error("invalid callback: " + t);
    return n.get(t);
  }
  return n;
}
function Y7(e) {
  return function(t, n) {
    e(t == null ? n : null);
  };
}
function j7(e) {
  var t = e.responseType;
  return t && t !== "text" ? e.response : e.responseText;
}
function fd(e, t) {
  return function(n, r) {
    var i = f0(n).mimeType(e).response(t);
    if (r != null) {
      if (typeof r != "function") throw new Error("invalid callback: " + r);
      return i.get(r);
    }
    return i;
  };
}
const W7 = fd("text/html", function(e) {
  return document.createRange().createContextualFragment(e.responseText);
}), H7 = fd("application/json", function(e) {
  return JSON.parse(e.responseText);
}), U7 = fd("text/plain", function(e) {
  return e.responseText;
}), G7 = fd("application/xml", function(e) {
  var t = e.responseXML;
  if (!t) throw new Error("parse error");
  return t;
});
function a2(e, t) {
  return function(n, r, i) {
    arguments.length < 3 && (i = r, r = null);
    var a = f0(n).mimeType(e);
    return a.row = function(o) {
      return arguments.length ? a.response(V7(t, r = o)) : r;
    }, a.row(r), i ? a.get(i) : a;
  };
}
function V7(e, t) {
  return function(n) {
    return e(n.responseText, t);
  };
}
const Q7 = a2("text/csv", q_), q7 = a2("text/tab-separated-values", X_);
var o2 = Array.prototype, d0 = o2.map, Ui = o2.slice, lm = { name: "implicit" };
function h0(e) {
  var t = Xr(), n = [], r = lm;
  e = e == null ? [] : Ui.call(e);
  function i(a) {
    var o = a + "", s = t.get(o);
    if (!s) {
      if (r !== lm) return r;
      t.set(o, s = n.push(a));
    }
    return e[(s - 1) % e.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return n.slice();
    n = [], t = Xr();
    for (var o = -1, s = a.length, c, l; ++o < s; ) t.has(l = (c = a[o]) + "") || t.set(l, n.push(c));
    return i;
  }, i.range = function(a) {
    return arguments.length ? (e = Ui.call(a), i) : e.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return h0().domain(n).range(e).unknown(r);
  }, i;
}
function p0() {
  var e = h0().unknown(void 0), t = e.domain, n = e.range, r = [0, 1], i, a, o = !1, s = 0, c = 0, l = 0.5;
  delete e.unknown;
  function u() {
    var d = t().length, f = r[1] < r[0], h = r[f - 0], m = r[1 - f];
    i = (m - h) / Math.max(1, d - s + c * 2), o && (i = Math.floor(i)), h += (m - h - i * (d - s)) * l, a = i * (1 - s), o && (h = Math.round(h), a = Math.round(a));
    var g = Ar(d).map(function(v) {
      return h + i * v;
    });
    return n(f ? g.reverse() : g);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), u()) : t();
  }, e.range = function(d) {
    return arguments.length ? (r = [+d[0], +d[1]], u()) : r.slice();
  }, e.rangeRound = function(d) {
    return r = [+d[0], +d[1]], o = !0, u();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return i;
  }, e.round = function(d) {
    return arguments.length ? (o = !!d, u()) : o;
  }, e.padding = function(d) {
    return arguments.length ? (s = c = Math.max(0, Math.min(1, d)), u()) : s;
  }, e.paddingInner = function(d) {
    return arguments.length ? (s = Math.max(0, Math.min(1, d)), u()) : s;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (c = Math.max(0, Math.min(1, d)), u()) : c;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), u()) : l;
  }, e.copy = function() {
    return p0().domain(t()).range(r).round(o).paddingInner(s).paddingOuter(c).align(l);
  }, u();
}
function s2(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return s2(t());
  }, e;
}
function X7() {
  return s2(p0().paddingInner(1));
}
function m0(e) {
  return function() {
    return e;
  };
}
function l2(e) {
  return +e;
}
var fv = [0, 1];
function g0(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : m0(t);
}
function J7(e) {
  return function(t, n) {
    var r = e(t = +t, n = +n);
    return function(i) {
      return i <= t ? 0 : i >= n ? 1 : r(i);
    };
  };
}
function K7(e) {
  return function(t, n) {
    var r = e(t = +t, n = +n);
    return function(i) {
      return i <= 0 ? t : i >= 1 ? n : r(i);
    };
  };
}
function Z7(e, t, n, r) {
  var i = e[0], a = e[1], o = t[0], s = t[1];
  return a < i ? (i = n(a, i), o = r(s, o)) : (i = n(i, a), o = r(o, s)), function(c) {
    return o(i(c));
  };
}
function e9(e, t, n, r) {
  var i = Math.min(e.length, t.length) - 1, a = new Array(i), o = new Array(i), s = -1;
  for (e[i] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++s < i; )
    a[s] = n(e[s], e[s + 1]), o[s] = r(t[s], t[s + 1]);
  return function(c) {
    var l = Ea(e, c, 1, i) - 1;
    return o[l](a[l](c));
  };
}
function dd(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp());
}
function hd(e, t) {
  var n = fv, r = fv, i = jl, a = !1, o, s, c;
  function l() {
    return o = Math.min(n.length, r.length) > 2 ? e9 : Z7, s = c = null, u;
  }
  function u(d) {
    return (s || (s = o(n, r, a ? J7(e) : e, i)))(+d);
  }
  return u.invert = function(d) {
    return (c || (c = o(r, n, g0, a ? K7(t) : t)))(+d);
  }, u.domain = function(d) {
    return arguments.length ? (n = d0.call(d, l2), l()) : n.slice();
  }, u.range = function(d) {
    return arguments.length ? (r = Ui.call(d), l()) : r.slice();
  }, u.rangeRound = function(d) {
    return r = Ui.call(d), i = T_, l();
  }, u.clamp = function(d) {
    return arguments.length ? (a = !!d, l()) : a;
  }, u.interpolate = function(d) {
    return arguments.length ? (i = d, l()) : i;
  }, l();
}
function t9(e, t, n) {
  var r = e[0], i = e[e.length - 1], a = al(r, i, t ?? 10), o;
  switch (n = gl(n ?? ",f"), n.type) {
    case "s": {
      var s = Math.max(Math.abs(r), Math.abs(i));
      return n.precision == null && !isNaN(o = rS(a, s)) && (n.precision = o), Vg(n, s);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(o = iS(a, Math.max(Math.abs(r), Math.abs(i)))) && (n.precision = o - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(o = nS(a)) && (n.precision = o - (n.type === "%") * 2);
      break;
    }
  }
  return od(n);
}
function Ql(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return _g(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    return t9(t(), n, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, a = r.length - 1, o = r[i], s = r[a], c;
    return s < o && (c = o, o = s, s = c, c = i, i = a, a = c), c = js(o, s, n), c > 0 ? (o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c, c = js(o, s, n)) : c < 0 && (o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c, c = js(o, s, n)), c > 0 ? (r[i] = Math.floor(o / c) * c, r[a] = Math.ceil(s / c) * c, t(r)) : c < 0 && (r[i] = Math.ceil(o * c) / c, r[a] = Math.floor(s * c) / c, t(r)), e;
  }, e;
}
function bl() {
  var e = hd(g0, Vn);
  return e.copy = function() {
    return dd(e, bl());
  }, Ql(e);
}
function c2() {
  var e = [0, 1];
  function t(n) {
    return +n;
  }
  return t.invert = t, t.domain = t.range = function(n) {
    return arguments.length ? (e = d0.call(n, l2), t) : e.slice();
  }, t.copy = function() {
    return c2().domain(e);
  }, Ql(t);
}
function u2(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], a = e[r], o;
  return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), e[n] = t.floor(i), e[r] = t.ceil(a), e;
}
function n9(e, t) {
  return (t = Math.log(t / e)) ? function(n) {
    return Math.log(n / e) / t;
  } : m0(t);
}
function r9(e, t) {
  return e < 0 ? function(n) {
    return -Math.pow(-t, n) * Math.pow(-e, 1 - n);
  } : function(n) {
    return Math.pow(t, n) * Math.pow(e, 1 - n);
  };
}
function i9(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function dv(e) {
  return e === 10 ? i9 : e === Math.E ? Math.exp : function(t) {
    return Math.pow(e, t);
  };
}
function hv(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), function(t) {
    return Math.log(t) / e;
  });
}
function pv(e) {
  return function(t) {
    return -e(-t);
  };
}
function f2() {
  var e = hd(n9, r9).domain([1, 10]), t = e.domain, n = 10, r = hv(10), i = dv(10);
  function a() {
    return r = hv(n), i = dv(n), t()[0] < 0 && (r = pv(r), i = pv(i)), e;
  }
  return e.base = function(o) {
    return arguments.length ? (n = +o, a()) : n;
  }, e.domain = function(o) {
    return arguments.length ? (t(o), a()) : t();
  }, e.ticks = function(o) {
    var s = t(), c = s[0], l = s[s.length - 1], u;
    (u = l < c) && (d = c, c = l, l = d);
    var d = r(c), f = r(l), h, m, g, v = o == null ? 10 : +o, _ = [];
    if (!(n % 1) && f - d < v) {
      if (d = Math.round(d) - 1, f = Math.round(f) + 1, c > 0) {
        for (; d < f; ++d)
          for (m = 1, h = i(d); m < n; ++m)
            if (g = h * m, !(g < c)) {
              if (g > l) break;
              _.push(g);
            }
      } else for (; d < f; ++d)
        for (m = n - 1, h = i(d); m >= 1; --m)
          if (g = h * m, !(g < c)) {
            if (g > l) break;
            _.push(g);
          }
    } else
      _ = _g(d, f, Math.min(f - d, v)).map(i);
    return u ? _.reverse() : _;
  }, e.tickFormat = function(o, s) {
    if (s == null && (s = n === 10 ? ".0e" : ","), typeof s != "function" && (s = od(s)), o === 1 / 0) return s;
    o == null && (o = 10);
    var c = Math.max(1, n * o / e.ticks().length);
    return function(l) {
      var u = l / i(Math.round(r(l)));
      return u * n < n - 0.5 && (u *= n), u <= c ? s(l) : "";
    };
  }, e.nice = function() {
    return t(u2(t(), {
      floor: function(o) {
        return i(Math.floor(r(o)));
      },
      ceil: function(o) {
        return i(Math.ceil(r(o)));
      }
    }));
  }, e.copy = function() {
    return dd(e, f2().base(n));
  }, e;
}
function eo(e, t) {
  return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
}
function y0() {
  var e = 1, t = hd(r, i), n = t.domain;
  function r(a, o) {
    return (o = eo(o, e) - (a = eo(a, e))) ? function(s) {
      return (eo(s, e) - a) / o;
    } : m0(o);
  }
  function i(a, o) {
    return o = eo(o, e) - (a = eo(a, e)), function(s) {
      return eo(a + o * s, 1 / e);
    };
  }
  return t.exponent = function(a) {
    return arguments.length ? (e = +a, n(n())) : e;
  }, t.copy = function() {
    return dd(t, y0().exponent(e));
  }, Ql(t);
}
function a9() {
  return y0().exponent(0.5);
}
function d2() {
  var e = [], t = [], n = [];
  function r() {
    var a = 0, o = Math.max(1, t.length);
    for (n = new Array(o - 1); ++a < o; ) n[a - 1] = ol(e, a / o);
    return i;
  }
  function i(a) {
    if (!isNaN(a = +a)) return t[Ea(n, a)];
  }
  return i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return o < 0 ? [NaN, NaN] : [
      o > 0 ? n[o - 1] : e[0],
      o < n.length ? n[o] : e[e.length - 1]
    ];
  }, i.domain = function(a) {
    if (!arguments.length) return e.slice();
    e = [];
    for (var o = 0, s = a.length, c; o < s; ++o) c = a[o], c != null && !isNaN(c = +c) && e.push(c);
    return e.sort(Ba), r();
  }, i.range = function(a) {
    return arguments.length ? (t = Ui.call(a), r()) : t.slice();
  }, i.quantiles = function() {
    return n.slice();
  }, i.copy = function() {
    return d2().domain(e).range(t);
  }, i;
}
function h2() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1];
  function a(s) {
    if (s <= s) return i[Ea(r, s, 0, n)];
  }
  function o() {
    var s = -1;
    for (r = new Array(n); ++s < n; ) r[s] = ((s + 1) * t - (s - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(s) {
    return arguments.length ? (e = +s[0], t = +s[1], o()) : [e, t];
  }, a.range = function(s) {
    return arguments.length ? (n = (i = Ui.call(s)).length - 1, o()) : i.slice();
  }, a.invertExtent = function(s) {
    var c = i.indexOf(s);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, r[0]] : c >= n ? [r[n - 1], t] : [r[c - 1], r[c]];
  }, a.copy = function() {
    return h2().domain([e, t]).range(i);
  }, Ql(a);
}
function p2() {
  var e = [0.5], t = [0, 1], n = 1;
  function r(i) {
    if (i <= i) return t[Ea(e, i, 0, n)];
  }
  return r.domain = function(i) {
    return arguments.length ? (e = Ui.call(i), n = Math.min(e.length, t.length - 1), r) : e.slice();
  }, r.range = function(i) {
    return arguments.length ? (t = Ui.call(i), n = Math.min(e.length, t.length - 1), r) : t.slice();
  }, r.invertExtent = function(i) {
    var a = t.indexOf(i);
    return [e[a - 1], e[a]];
  }, r.copy = function() {
    return p2().domain(e).range(t);
  }, r;
}
var _h = /* @__PURE__ */ new Date(), Sh = /* @__PURE__ */ new Date();
function tn(e, t, n, r) {
  function i(a) {
    return e(a = /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = i, i.ceil = function(a) {
    return e(a = new Date(a - 1)), t(a, 1), e(a), a;
  }, i.round = function(a) {
    var o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = function(a, o) {
    return t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a;
  }, i.range = function(a, o, s) {
    var c = [], l;
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return c;
    do
      c.push(l = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (l < a && a < o);
    return c;
  }, i.filter = function(a) {
    return tn(function(o) {
      if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
    }, function(o, s) {
      if (o >= o)
        if (s < 0) for (; ++s <= 0; )
          for (; t(o, -1), !a(o); )
            ;
        else for (; --s >= 0; )
          for (; t(o, 1), !a(o); )
            ;
    });
  }, n && (i.count = function(a, o) {
    return _h.setTime(+a), Sh.setTime(+o), e(_h), e(Sh), Math.floor(n(_h, Sh));
  }, i.every = function(a) {
    return a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? function(o) {
      return r(o) % a === 0;
    } : function(o) {
      return i.count(0, o) % a === 0;
    }) : i;
  }), i;
}
var Oa = tn(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
Oa.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? tn(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, n) {
    t.setTime(+t + n * e);
  }, function(t, n) {
    return (n - t) / e;
  }) : Oa;
};
var mv = Oa.range, Rc = 1e3, pi = 6e4, Ni = 36e5, m2 = 864e5, g2 = 6048e5, wl = tn(function(e) {
  e.setTime(Math.floor(e / Rc) * Rc);
}, function(e, t) {
  e.setTime(+e + t * Rc);
}, function(e, t) {
  return (t - e) / Rc;
}, function(e) {
  return e.getUTCSeconds();
}), gv = wl.range, x0 = tn(function(e) {
  e.setTime(Math.floor(e / pi) * pi);
}, function(e, t) {
  e.setTime(+e + t * pi);
}, function(e, t) {
  return (t - e) / pi;
}, function(e) {
  return e.getMinutes();
}), o9 = x0.range, v0 = tn(function(e) {
  var t = e.getTimezoneOffset() * pi % Ni;
  t < 0 && (t += Ni), e.setTime(Math.floor((+e - t) / Ni) * Ni + t);
}, function(e, t) {
  e.setTime(+e + t * Ni);
}, function(e, t) {
  return (t - e) / Ni;
}, function(e) {
  return e.getHours();
}), s9 = v0.range, ql = tn(function(e) {
  e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * pi) / m2;
}, function(e) {
  return e.getDate() - 1;
}), l9 = ql.range;
function Ya(e) {
  return tn(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * pi) / g2;
  });
}
var _l = Ya(0), Sl = Ya(1), y2 = Ya(2), x2 = Ya(3), Us = Ya(4), v2 = Ya(5), A2 = Ya(6), yv = _l.range, c9 = Sl.range, u9 = y2.range, f9 = x2.range, d9 = Us.range, h9 = v2.range, p9 = A2.range, A0 = tn(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
}), m9 = A0.range, Ai = tn(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
Ai.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : tn(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
var g9 = Ai.range, b0 = tn(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * pi);
}, function(e, t) {
  return (t - e) / pi;
}, function(e) {
  return e.getUTCMinutes();
}), y9 = b0.range, w0 = tn(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * Ni);
}, function(e, t) {
  return (t - e) / Ni;
}, function(e) {
  return e.getUTCHours();
}), x9 = w0.range, Xl = tn(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / m2;
}, function(e) {
  return e.getUTCDate() - 1;
}), v9 = Xl.range;
function ja(e) {
  return tn(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / g2;
  });
}
var Cl = ja(0), El = ja(1), b2 = ja(2), w2 = ja(3), Gs = ja(4), _2 = ja(5), S2 = ja(6), xv = Cl.range, A9 = El.range, b9 = b2.range, w9 = w2.range, _9 = Gs.range, S9 = _2.range, C9 = S2.range, _0 = tn(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
}), E9 = _0.range, bi = tn(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
bi.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : tn(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
var k9 = bi.range;
function T9(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Dc(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function ds(e) {
  return { y: e, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0 };
}
function C2(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, a = e.days, o = e.shortDays, s = e.months, c = e.shortMonths, l = hs(i), u = ps(i), d = hs(a), f = ps(a), h = hs(o), m = ps(o), g = hs(s), v = ps(s), _ = hs(c), I = ps(c), M = {
    a: F,
    A: W,
    b: L,
    B: S,
    c: null,
    d: wv,
    e: wv,
    f: K9,
    H: q9,
    I: X9,
    j: J9,
    L: E2,
    m: Z9,
    M: eW,
    p: j,
    Q: Cv,
    s: Ev,
    S: tW,
    u: nW,
    U: rW,
    V: iW,
    w: aW,
    W: oW,
    x: null,
    X: null,
    y: sW,
    Y: lW,
    Z: cW,
    "%": Sv
  }, k = {
    a: Y,
    A: N,
    b: X,
    B: G,
    c: null,
    d: _v,
    e: _v,
    f: hW,
    H: uW,
    I: fW,
    j: dW,
    L: k2,
    m: pW,
    M: mW,
    p: q,
    Q: Cv,
    s: Ev,
    S: gW,
    u: yW,
    U: xW,
    V: vW,
    w: AW,
    W: bW,
    x: null,
    X: null,
    y: wW,
    Y: _W,
    Z: SW,
    "%": Sv
  }, y = {
    a: O,
    A: P,
    b: E,
    B: C,
    c: T,
    d: Av,
    e: Av,
    f: U9,
    H: bv,
    I: bv,
    j: Y9,
    L: H9,
    m: $9,
    M: j9,
    p: w,
    Q: V9,
    s: Q9,
    S: W9,
    u: R9,
    U: D9,
    V: P9,
    w: O9,
    W: L9,
    x: D,
    X: z,
    y: B9,
    Y: z9,
    Z: F9,
    "%": G9
  };
  M.x = x(n, M), M.X = x(r, M), M.c = x(t, M), k.x = x(n, k), k.X = x(r, k), k.c = x(t, k);
  function x($, Q) {
    return function(V) {
      var H = [], K = -1, U = 0, ee = $.length, ce, se, ne;
      for (V instanceof Date || (V = /* @__PURE__ */ new Date(+V)); ++K < ee; )
        $.charCodeAt(K) === 37 && (H.push($.slice(U, K)), (se = vv[ce = $.charAt(++K)]) != null ? ce = $.charAt(++K) : se = ce === "e" ? " " : "0", (ne = Q[ce]) && (ce = ne(V, se)), H.push(ce), U = K + 1);
      return H.push($.slice(U, K)), H.join("");
    };
  }
  function b($, Q) {
    return function(V) {
      var H = ds(1900), K = A(H, $, V += "", 0), U, ee;
      if (K != V.length) return null;
      if ("Q" in H) return new Date(H.Q);
      if ("p" in H && (H.H = H.H % 12 + H.p * 12), "V" in H) {
        if (H.V < 1 || H.V > 53) return null;
        "w" in H || (H.w = 1), "Z" in H ? (U = Dc(ds(H.y)), ee = U.getUTCDay(), U = ee > 4 || ee === 0 ? El.ceil(U) : El(U), U = Xl.offset(U, (H.V - 1) * 7), H.y = U.getUTCFullYear(), H.m = U.getUTCMonth(), H.d = U.getUTCDate() + (H.w + 6) % 7) : (U = Q(ds(H.y)), ee = U.getDay(), U = ee > 4 || ee === 0 ? Sl.ceil(U) : Sl(U), U = ql.offset(U, (H.V - 1) * 7), H.y = U.getFullYear(), H.m = U.getMonth(), H.d = U.getDate() + (H.w + 6) % 7);
      } else ("W" in H || "U" in H) && ("w" in H || (H.w = "u" in H ? H.u % 7 : "W" in H ? 1 : 0), ee = "Z" in H ? Dc(ds(H.y)).getUTCDay() : Q(ds(H.y)).getDay(), H.m = 0, H.d = "W" in H ? (H.w + 6) % 7 + H.W * 7 - (ee + 5) % 7 : H.w + H.U * 7 - (ee + 6) % 7);
      return "Z" in H ? (H.H += H.Z / 100 | 0, H.M += H.Z % 100, Dc(H)) : Q(H);
    };
  }
  function A($, Q, V, H) {
    for (var K = 0, U = Q.length, ee = V.length, ce, se; K < U; ) {
      if (H >= ee) return -1;
      if (ce = Q.charCodeAt(K++), ce === 37) {
        if (ce = Q.charAt(K++), se = y[ce in vv ? Q.charAt(K++) : ce], !se || (H = se($, V, H)) < 0) return -1;
      } else if (ce != V.charCodeAt(H++))
        return -1;
    }
    return H;
  }
  function w($, Q, V) {
    var H = l.exec(Q.slice(V));
    return H ? ($.p = u[H[0].toLowerCase()], V + H[0].length) : -1;
  }
  function O($, Q, V) {
    var H = h.exec(Q.slice(V));
    return H ? ($.w = m[H[0].toLowerCase()], V + H[0].length) : -1;
  }
  function P($, Q, V) {
    var H = d.exec(Q.slice(V));
    return H ? ($.w = f[H[0].toLowerCase()], V + H[0].length) : -1;
  }
  function E($, Q, V) {
    var H = _.exec(Q.slice(V));
    return H ? ($.m = I[H[0].toLowerCase()], V + H[0].length) : -1;
  }
  function C($, Q, V) {
    var H = g.exec(Q.slice(V));
    return H ? ($.m = v[H[0].toLowerCase()], V + H[0].length) : -1;
  }
  function T($, Q, V) {
    return A($, t, Q, V);
  }
  function D($, Q, V) {
    return A($, n, Q, V);
  }
  function z($, Q, V) {
    return A($, r, Q, V);
  }
  function F($) {
    return o[$.getDay()];
  }
  function W($) {
    return a[$.getDay()];
  }
  function L($) {
    return c[$.getMonth()];
  }
  function S($) {
    return s[$.getMonth()];
  }
  function j($) {
    return i[+($.getHours() >= 12)];
  }
  function Y($) {
    return o[$.getUTCDay()];
  }
  function N($) {
    return a[$.getUTCDay()];
  }
  function X($) {
    return c[$.getUTCMonth()];
  }
  function G($) {
    return s[$.getUTCMonth()];
  }
  function q($) {
    return i[+($.getUTCHours() >= 12)];
  }
  return {
    format: function($) {
      var Q = x($ += "", M);
      return Q.toString = function() {
        return $;
      }, Q;
    },
    parse: function($) {
      var Q = b($ += "", T9);
      return Q.toString = function() {
        return $;
      }, Q;
    },
    utcFormat: function($) {
      var Q = x($ += "", k);
      return Q.toString = function() {
        return $;
      }, Q;
    },
    utcParse: function($) {
      var Q = b($, Dc);
      return Q.toString = function() {
        return $;
      }, Q;
    }
  };
}
var vv = { "-": "", _: " ", 0: "0" }, fn = /^\s*\d+/, M9 = /^%/, I9 = /[\\^$*+?|[\]().{}]/g;
function xt(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", a = i.length;
  return r + (a < n ? new Array(n - a + 1).join(t) + i : i);
}
function N9(e) {
  return e.replace(I9, "\\$&");
}
function hs(e) {
  return new RegExp("^(?:" + e.map(N9).join("|") + ")", "i");
}
function ps(e) {
  for (var t = {}, n = -1, r = e.length; ++n < r; ) t[e[n].toLowerCase()] = n;
  return t;
}
function O9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function R9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function D9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function P9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function L9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function z9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function B9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function F9(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function $9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function Av(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function Y9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function bv(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function j9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function W9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function H9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function U9(e, t, n) {
  var r = fn.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function G9(e, t, n) {
  var r = M9.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function V9(e, t, n) {
  var r = fn.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function Q9(e, t, n) {
  var r = fn.exec(t.slice(n));
  return r ? (e.Q = +r[0] * 1e3, n + r[0].length) : -1;
}
function wv(e, t) {
  return xt(e.getDate(), t, 2);
}
function q9(e, t) {
  return xt(e.getHours(), t, 2);
}
function X9(e, t) {
  return xt(e.getHours() % 12 || 12, t, 2);
}
function J9(e, t) {
  return xt(1 + ql.count(Ai(e), e), t, 3);
}
function E2(e, t) {
  return xt(e.getMilliseconds(), t, 3);
}
function K9(e, t) {
  return E2(e, t) + "000";
}
function Z9(e, t) {
  return xt(e.getMonth() + 1, t, 2);
}
function eW(e, t) {
  return xt(e.getMinutes(), t, 2);
}
function tW(e, t) {
  return xt(e.getSeconds(), t, 2);
}
function nW(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function rW(e, t) {
  return xt(_l.count(Ai(e), e), t, 2);
}
function iW(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Us(e) : Us.ceil(e), xt(Us.count(Ai(e), e) + (Ai(e).getDay() === 4), t, 2);
}
function aW(e) {
  return e.getDay();
}
function oW(e, t) {
  return xt(Sl.count(Ai(e), e), t, 2);
}
function sW(e, t) {
  return xt(e.getFullYear() % 100, t, 2);
}
function lW(e, t) {
  return xt(e.getFullYear() % 1e4, t, 4);
}
function cW(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + xt(t / 60 | 0, "0", 2) + xt(t % 60, "0", 2);
}
function _v(e, t) {
  return xt(e.getUTCDate(), t, 2);
}
function uW(e, t) {
  return xt(e.getUTCHours(), t, 2);
}
function fW(e, t) {
  return xt(e.getUTCHours() % 12 || 12, t, 2);
}
function dW(e, t) {
  return xt(1 + Xl.count(bi(e), e), t, 3);
}
function k2(e, t) {
  return xt(e.getUTCMilliseconds(), t, 3);
}
function hW(e, t) {
  return k2(e, t) + "000";
}
function pW(e, t) {
  return xt(e.getUTCMonth() + 1, t, 2);
}
function mW(e, t) {
  return xt(e.getUTCMinutes(), t, 2);
}
function gW(e, t) {
  return xt(e.getUTCSeconds(), t, 2);
}
function yW(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function xW(e, t) {
  return xt(Cl.count(bi(e), e), t, 2);
}
function vW(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Gs(e) : Gs.ceil(e), xt(Gs.count(bi(e), e) + (bi(e).getUTCDay() === 4), t, 2);
}
function AW(e) {
  return e.getUTCDay();
}
function bW(e, t) {
  return xt(El.count(bi(e), e), t, 2);
}
function wW(e, t) {
  return xt(e.getUTCFullYear() % 100, t, 2);
}
function _W(e, t) {
  return xt(e.getUTCFullYear() % 1e4, t, 4);
}
function SW() {
  return "+0000";
}
function Sv() {
  return "%";
}
function Cv(e) {
  return +e;
}
function Ev(e) {
  return Math.floor(+e / 1e3);
}
var to, S0, T2, pd, C0;
M2({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function M2(e) {
  return to = C2(e), S0 = to.format, T2 = to.parse, pd = to.utcFormat, C0 = to.utcParse, to;
}
var I2 = "%Y-%m-%dT%H:%M:%S.%LZ";
function CW(e) {
  return e.toISOString();
}
var EW = Date.prototype.toISOString ? CW : pd(I2);
function kW(e) {
  var t = new Date(e);
  return isNaN(t) ? null : t;
}
var TW = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? kW : C0(I2), Ms = 1e3, Is = Ms * 60, Ns = Is * 60, kl = Ns * 24, MW = kl * 7, kv = kl * 30, Ch = kl * 365;
function IW(e) {
  return new Date(e);
}
function NW(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function E0(e, t, n, r, i, a, o, s, c) {
  var l = hd(g0, Vn), u = l.invert, d = l.domain, f = c(".%L"), h = c(":%S"), m = c("%I:%M"), g = c("%I %p"), v = c("%a %d"), _ = c("%b %d"), I = c("%B"), M = c("%Y"), k = [
    [o, 1, Ms],
    [o, 5, 5 * Ms],
    [o, 15, 15 * Ms],
    [o, 30, 30 * Ms],
    [a, 1, Is],
    [a, 5, 5 * Is],
    [a, 15, 15 * Is],
    [a, 30, 30 * Is],
    [i, 1, Ns],
    [i, 3, 3 * Ns],
    [i, 6, 6 * Ns],
    [i, 12, 12 * Ns],
    [r, 1, kl],
    [r, 2, 2 * kl],
    [n, 1, MW],
    [t, 1, kv],
    [t, 3, 3 * kv],
    [e, 1, Ch]
  ];
  function y(b) {
    return (o(b) < b ? f : a(b) < b ? h : i(b) < b ? m : r(b) < b ? g : t(b) < b ? n(b) < b ? v : _ : e(b) < b ? I : M)(b);
  }
  function x(b, A, w, O) {
    if (b == null && (b = 10), typeof b == "number") {
      var P = Math.abs(w - A) / b, E = wg(function(C) {
        return C[2];
      }).right(k, P);
      E === k.length ? (O = al(A / Ch, w / Ch, b), b = e) : E ? (E = k[P / k[E - 1][2] < k[E][2] / P ? E - 1 : E], O = E[1], b = E[0]) : (O = Math.max(al(A, w, b), 1), b = s);
    }
    return O == null ? b : b.every(O);
  }
  return l.invert = function(b) {
    return new Date(u(b));
  }, l.domain = function(b) {
    return arguments.length ? d(d0.call(b, NW)) : d().map(IW);
  }, l.ticks = function(b, A) {
    var w = d(), O = w[0], P = w[w.length - 1], E = P < O, C;
    return E && (C = O, O = P, P = C), C = x(b, O, P, A), C = C ? C.range(O, P + 1) : [], E ? C.reverse() : C;
  }, l.tickFormat = function(b, A) {
    return A == null ? y : c(A);
  }, l.nice = function(b, A) {
    var w = d();
    return (b = x(b, w[0], w[w.length - 1], A)) ? d(u2(w, b)) : l;
  }, l.copy = function() {
    return dd(l, E0(e, t, n, r, i, a, o, s, c));
  }, l;
}
function OW() {
  return E0(Ai, A0, _l, ql, v0, x0, wl, Oa, S0).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]);
}
function RW() {
  return E0(bi, _0, Cl, Xl, w0, b0, wl, Oa, pd).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]);
}
function ta(e) {
  return e.match(/.{6}/g).map(function(t) {
    return "#" + t;
  });
}
const DW = ta("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), PW = ta("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"), LW = ta("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"), zW = ta("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"), BW = Zf(Er(300, 0.5, 0), Er(-240, 0.5, 1));
var FW = Zf(Er(-100, 0.75, 0.35), Er(80, 1.5, 0.8)), $W = Zf(Er(260, 0.75, 0.35), Er(80, 1.5, 0.8)), Pc = Er();
function YW(e) {
  (e < 0 || e > 1) && (e -= Math.floor(e));
  var t = Math.abs(e - 0.5);
  return Pc.h = 360 * e - 100, Pc.s = 1.5 - 1.5 * t, Pc.l = 0.8 - 0.9 * t, Pc + "";
}
function md(e) {
  var t = e.length;
  return function(n) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
  };
}
const jW = md(ta("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var WW = md(ta("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), HW = md(ta("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), UW = md(ta("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function N2(e) {
  var t = 0, n = 1, r = !1;
  function i(a) {
    var o = (a - t) / (n - t);
    return e(r ? Math.max(0, Math.min(1, o)) : o);
  }
  return i.domain = function(a) {
    return arguments.length ? (t = +a[0], n = +a[1], i) : [t, n];
  }, i.clamp = function(a) {
    return arguments.length ? (r = !!a, i) : r;
  }, i.interpolator = function(a) {
    return arguments.length ? (e = a, i) : e;
  }, i.copy = function() {
    return N2(e).domain([t, n]).clamp(r);
  }, Ql(i);
}
function tt(e) {
  return function() {
    return e;
  };
}
var Tv = Math.abs, mn = Math.atan2, ua = Math.cos, GW = Math.max, Eh = Math.min, Dr = Math.sin, so = Math.sqrt, yn = 1e-12, Gi = Math.PI, af = Gi / 2, Fi = 2 * Gi;
function VW(e) {
  return e > 1 ? 0 : e < -1 ? Gi : Math.acos(e);
}
function Mv(e) {
  return e >= 1 ? af : e <= -1 ? -af : Math.asin(e);
}
function QW(e) {
  return e.innerRadius;
}
function qW(e) {
  return e.outerRadius;
}
function XW(e) {
  return e.startAngle;
}
function JW(e) {
  return e.endAngle;
}
function KW(e) {
  return e && e.padAngle;
}
function ZW(e, t, n, r, i, a, o, s) {
  var c = n - e, l = r - t, u = o - i, d = s - a, f = (u * (t - a) - d * (e - i)) / (d * c - u * l);
  return [e + f * c, t + f * l];
}
function Lc(e, t, n, r, i, a, o) {
  var s = e - n, c = t - r, l = (o ? a : -a) / so(s * s + c * c), u = l * c, d = -l * s, f = e + u, h = t + d, m = n + u, g = r + d, v = (f + m) / 2, _ = (h + g) / 2, I = m - f, M = g - h, k = I * I + M * M, y = i - a, x = f * g - m * h, b = (M < 0 ? -1 : 1) * so(GW(0, y * y * k - x * x)), A = (x * M - I * b) / k, w = (-x * I - M * b) / k, O = (x * M + I * b) / k, P = (-x * I + M * b) / k, E = A - v, C = w - _, T = O - v, D = P - _;
  return E * E + C * C > T * T + D * D && (A = O, w = P), {
    cx: A,
    cy: w,
    x01: -u,
    y01: -d,
    x11: A * (i / y - 1),
    y11: w * (i / y - 1)
  };
}
function eH() {
  var e = QW, t = qW, n = tt(0), r = null, i = XW, a = JW, o = KW, s = null;
  function c() {
    var l, u, d = +e.apply(this, arguments), f = +t.apply(this, arguments), h = i.apply(this, arguments) - af, m = a.apply(this, arguments) - af, g = Tv(m - h), v = m > h;
    if (s || (s = l = Zi()), f < d && (u = f, f = d, d = u), !(f > yn)) s.moveTo(0, 0);
    else if (g > Fi - yn)
      s.moveTo(f * ua(h), f * Dr(h)), s.arc(0, 0, f, h, m, !v), d > yn && (s.moveTo(d * ua(m), d * Dr(m)), s.arc(0, 0, d, m, h, v));
    else {
      var _ = h, I = m, M = h, k = m, y = g, x = g, b = o.apply(this, arguments) / 2, A = b > yn && (r ? +r.apply(this, arguments) : so(d * d + f * f)), w = Eh(Tv(f - d) / 2, +n.apply(this, arguments)), O = w, P = w, E, C;
      if (A > yn) {
        var T = Mv(A / d * Dr(b)), D = Mv(A / f * Dr(b));
        (y -= T * 2) > yn ? (T *= v ? 1 : -1, M += T, k -= T) : (y = 0, M = k = (h + m) / 2), (x -= D * 2) > yn ? (D *= v ? 1 : -1, _ += D, I -= D) : (x = 0, _ = I = (h + m) / 2);
      }
      var z = f * ua(_), F = f * Dr(_), W = d * ua(k), L = d * Dr(k);
      if (w > yn) {
        var S = f * ua(I), j = f * Dr(I), Y = d * ua(M), N = d * Dr(M);
        if (g < Gi) {
          var X = y > yn ? ZW(z, F, Y, N, S, j, W, L) : [W, L], G = z - X[0], q = F - X[1], $ = S - X[0], Q = j - X[1], V = 1 / Dr(VW((G * $ + q * Q) / (so(G * G + q * q) * so($ * $ + Q * Q))) / 2), H = so(X[0] * X[0] + X[1] * X[1]);
          O = Eh(w, (d - H) / (V - 1)), P = Eh(w, (f - H) / (V + 1));
        }
      }
      x > yn ? P > yn ? (E = Lc(Y, N, z, F, f, P, v), C = Lc(S, j, W, L, f, P, v), s.moveTo(E.cx + E.x01, E.cy + E.y01), P < w ? s.arc(E.cx, E.cy, P, mn(E.y01, E.x01), mn(C.y01, C.x01), !v) : (s.arc(E.cx, E.cy, P, mn(E.y01, E.x01), mn(E.y11, E.x11), !v), s.arc(0, 0, f, mn(E.cy + E.y11, E.cx + E.x11), mn(C.cy + C.y11, C.cx + C.x11), !v), s.arc(C.cx, C.cy, P, mn(C.y11, C.x11), mn(C.y01, C.x01), !v))) : (s.moveTo(z, F), s.arc(0, 0, f, _, I, !v)) : s.moveTo(z, F), !(d > yn) || !(y > yn) ? s.lineTo(W, L) : O > yn ? (E = Lc(W, L, S, j, d, -O, v), C = Lc(z, F, Y, N, d, -O, v), s.lineTo(E.cx + E.x01, E.cy + E.y01), O < w ? s.arc(E.cx, E.cy, O, mn(E.y01, E.x01), mn(C.y01, C.x01), !v) : (s.arc(E.cx, E.cy, O, mn(E.y01, E.x01), mn(E.y11, E.x11), !v), s.arc(0, 0, d, mn(E.cy + E.y11, E.cx + E.x11), mn(C.cy + C.y11, C.cx + C.x11), v), s.arc(C.cx, C.cy, O, mn(C.y11, C.x11), mn(C.y01, C.x01), !v))) : s.arc(0, 0, d, k, M, v);
    }
    if (s.closePath(), l) return s = null, l + "" || null;
  }
  return c.centroid = function() {
    var l = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, u = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - Gi / 2;
    return [ua(u) * l, Dr(u) * l];
  }, c.innerRadius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : tt(+l), c) : e;
  }, c.outerRadius = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : tt(+l), c) : t;
  }, c.cornerRadius = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : tt(+l), c) : n;
  }, c.padRadius = function(l) {
    return arguments.length ? (r = l == null ? null : typeof l == "function" ? l : tt(+l), c) : r;
  }, c.startAngle = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : tt(+l), c) : i;
  }, c.endAngle = function(l) {
    return arguments.length ? (a = typeof l == "function" ? l : tt(+l), c) : a;
  }, c.padAngle = function(l) {
    return arguments.length ? (o = typeof l == "function" ? l : tt(+l), c) : o;
  }, c.context = function(l) {
    return arguments.length ? (s = l ?? null, c) : s;
  }, c;
}
function O2(e) {
  this._context = e;
}
O2.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function gd(e) {
  return new O2(e);
}
function k0(e) {
  return e[0];
}
function T0(e) {
  return e[1];
}
function M0() {
  var e = k0, t = T0, n = tt(!0), r = null, i = gd, a = null;
  function o(s) {
    var c, l = s.length, u, d = !1, f;
    for (r == null && (a = i(f = Zi())), c = 0; c <= l; ++c)
      !(c < l && n(u = s[c], c, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(u, c, s), +t(u, c, s));
    if (f) return a = null, f + "" || null;
  }
  return o.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : tt(+s), o) : e;
  }, o.y = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : tt(+s), o) : t;
  }, o.defined = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : tt(!!s), o) : n;
  }, o.curve = function(s) {
    return arguments.length ? (i = s, r != null && (a = i(r)), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (s == null ? r = a = null : a = i(r = s), o) : r;
  }, o;
}
function R2() {
  var e = k0, t = null, n = tt(0), r = T0, i = tt(!0), a = null, o = gd, s = null;
  function c(u) {
    var d, f, h, m = u.length, g, v = !1, _, I = new Array(m), M = new Array(m);
    for (a == null && (s = o(_ = Zi())), d = 0; d <= m; ++d) {
      if (!(d < m && i(g = u[d], d, u)) === v)
        if (v = !v)
          f = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), h = d - 1; h >= f; --h)
            s.point(I[h], M[h]);
          s.lineEnd(), s.areaEnd();
        }
      v && (I[d] = +e(g, d, u), M[d] = +n(g, d, u), s.point(t ? +t(g, d, u) : I[d], r ? +r(g, d, u) : M[d]));
    }
    if (_) return s = null, _ + "" || null;
  }
  function l() {
    return M0().defined(i).curve(o).context(a);
  }
  return c.x = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : tt(+u), t = null, c) : e;
  }, c.x0 = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : tt(+u), c) : e;
  }, c.x1 = function(u) {
    return arguments.length ? (t = u == null ? null : typeof u == "function" ? u : tt(+u), c) : t;
  }, c.y = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : tt(+u), r = null, c) : n;
  }, c.y0 = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : tt(+u), c) : n;
  }, c.y1 = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : tt(+u), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return l().x(e).y(n);
  }, c.lineY1 = function() {
    return l().x(e).y(r);
  }, c.lineX1 = function() {
    return l().x(t).y(n);
  }, c.defined = function(u) {
    return arguments.length ? (i = typeof u == "function" ? u : tt(!!u), c) : i;
  }, c.curve = function(u) {
    return arguments.length ? (o = u, a != null && (s = o(a)), c) : o;
  }, c.context = function(u) {
    return arguments.length ? (u == null ? a = s = null : s = o(a = u), c) : a;
  }, c;
}
function tH(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function nH(e) {
  return e;
}
function rH() {
  var e = nH, t = tH, n = null, r = tt(0), i = tt(Fi), a = tt(0);
  function o(s) {
    var c, l = s.length, u, d, f = 0, h = new Array(l), m = new Array(l), g = +r.apply(this, arguments), v = Math.min(Fi, Math.max(-Fi, i.apply(this, arguments) - g)), _, I = Math.min(Math.abs(v) / l, a.apply(this, arguments)), M = I * (v < 0 ? -1 : 1), k;
    for (c = 0; c < l; ++c)
      (k = m[h[c] = c] = +e(s[c], c, s)) > 0 && (f += k);
    for (t != null ? h.sort(function(y, x) {
      return t(m[y], m[x]);
    }) : n != null && h.sort(function(y, x) {
      return n(s[y], s[x]);
    }), c = 0, d = f ? (v - l * M) / f : 0; c < l; ++c, g = _)
      u = h[c], k = m[u], _ = g + (k > 0 ? k * d : 0) + M, m[u] = {
        data: s[u],
        index: c,
        value: k,
        startAngle: g,
        endAngle: _,
        padAngle: I
      };
    return m;
  }
  return o.value = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : tt(+s), o) : e;
  }, o.sortValues = function(s) {
    return arguments.length ? (t = s, n = null, o) : t;
  }, o.sort = function(s) {
    return arguments.length ? (n = s, t = null, o) : n;
  }, o.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : tt(+s), o) : r;
  }, o.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : tt(+s), o) : i;
  }, o.padAngle = function(s) {
    return arguments.length ? (a = typeof s == "function" ? s : tt(+s), o) : a;
  }, o;
}
var D2 = I0(gd);
function P2(e) {
  this._curve = e;
}
P2.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(e, t) {
    this._curve.point(t * Math.sin(e), t * -Math.cos(e));
  }
};
function I0(e) {
  function t(n) {
    return new P2(e(n));
  }
  return t._curve = e, t;
}
function Os(e) {
  var t = e.curve;
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e.curve = function(n) {
    return arguments.length ? t(I0(n)) : t()._curve;
  }, e;
}
function Iv() {
  return Os(M0().curve(D2));
}
function Nv() {
  var e = R2().curve(D2), t = e.curve, n = e.lineX0, r = e.lineX1, i = e.lineY0, a = e.lineY1;
  return e.angle = e.x, delete e.x, e.startAngle = e.x0, delete e.x0, e.endAngle = e.x1, delete e.x1, e.radius = e.y, delete e.y, e.innerRadius = e.y0, delete e.y0, e.outerRadius = e.y1, delete e.y1, e.lineStartAngle = function() {
    return Os(n());
  }, delete e.lineX0, e.lineEndAngle = function() {
    return Os(r());
  }, delete e.lineX1, e.lineInnerRadius = function() {
    return Os(i());
  }, delete e.lineY0, e.lineOuterRadius = function() {
    return Os(a());
  }, delete e.lineY1, e.curve = function(o) {
    return arguments.length ? t(I0(o)) : t()._curve;
  }, e;
}
function Rs(e, t) {
  return [(t = +t) * Math.cos(e -= Math.PI / 2), t * Math.sin(e)];
}
var cm = Array.prototype.slice;
function iH(e) {
  return e.source;
}
function aH(e) {
  return e.target;
}
function N0(e) {
  var t = iH, n = aH, r = k0, i = T0, a = null;
  function o() {
    var s, c = cm.call(arguments), l = t.apply(this, c), u = n.apply(this, c);
    if (a || (a = s = Zi()), e(a, +r.apply(this, (c[0] = l, c)), +i.apply(this, c), +r.apply(this, (c[0] = u, c)), +i.apply(this, c)), s) return a = null, s + "" || null;
  }
  return o.source = function(s) {
    return arguments.length ? (t = s, o) : t;
  }, o.target = function(s) {
    return arguments.length ? (n = s, o) : n;
  }, o.x = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : tt(+s), o) : r;
  }, o.y = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : tt(+s), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (a = s ?? null, o) : a;
  }, o;
}
function oH(e, t, n, r, i) {
  e.moveTo(t, n), e.bezierCurveTo(t = (t + r) / 2, n, t, i, r, i);
}
function sH(e, t, n, r, i) {
  e.moveTo(t, n), e.bezierCurveTo(t, n = (n + i) / 2, r, n, r, i);
}
function lH(e, t, n, r, i) {
  var a = Rs(t, n), o = Rs(t, n = (n + i) / 2), s = Rs(r, n), c = Rs(r, i);
  e.moveTo(a[0], a[1]), e.bezierCurveTo(o[0], o[1], s[0], s[1], c[0], c[1]);
}
function cH() {
  return N0(oH);
}
function uH() {
  return N0(sH);
}
function fH() {
  var e = N0(lH);
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e;
}
const O0 = {
  draw: function(e, t) {
    var n = Math.sqrt(t / Gi);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, Fi);
  }
}, L2 = {
  draw: function(e, t) {
    var n = Math.sqrt(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
};
var z2 = Math.sqrt(1 / 3), dH = z2 * 2;
const B2 = {
  draw: function(e, t) {
    var n = Math.sqrt(t / dH), r = n * z2;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
};
var hH = 0.8908130915292852, F2 = Math.sin(Gi / 10) / Math.sin(7 * Gi / 10), pH = Math.sin(Fi / 10) * F2, mH = -Math.cos(Fi / 10) * F2;
const $2 = {
  draw: function(e, t) {
    var n = Math.sqrt(t * hH), r = pH * n, i = mH * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (var a = 1; a < 5; ++a) {
      var o = Fi * a / 5, s = Math.cos(o), c = Math.sin(o);
      e.lineTo(c * n, -s * n), e.lineTo(s * r - c * i, c * r + s * i);
    }
    e.closePath();
  }
}, Y2 = {
  draw: function(e, t) {
    var n = Math.sqrt(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
};
var kh = Math.sqrt(3);
const j2 = {
  draw: function(e, t) {
    var n = -Math.sqrt(t / (kh * 3));
    e.moveTo(0, n * 2), e.lineTo(-kh * n, -n), e.lineTo(kh * n, -n), e.closePath();
  }
};
var nr = -0.5, rr = Math.sqrt(3) / 2, um = 1 / Math.sqrt(12), gH = (um / 2 + 1) * 3;
const W2 = {
  draw: function(e, t) {
    var n = Math.sqrt(t / gH), r = n / 2, i = n * um, a = r, o = n * um + n, s = -a, c = o;
    e.moveTo(r, i), e.lineTo(a, o), e.lineTo(s, c), e.lineTo(nr * r - rr * i, rr * r + nr * i), e.lineTo(nr * a - rr * o, rr * a + nr * o), e.lineTo(nr * s - rr * c, rr * s + nr * c), e.lineTo(nr * r + rr * i, nr * i - rr * r), e.lineTo(nr * a + rr * o, nr * o - rr * a), e.lineTo(nr * s + rr * c, nr * c - rr * s), e.closePath();
  }
};
var yH = [
  O0,
  L2,
  B2,
  Y2,
  $2,
  j2,
  W2
];
function xH() {
  var e = tt(O0), t = tt(64), n = null;
  function r() {
    var i;
    if (n || (n = i = Zi()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), i) return n = null, i + "" || null;
  }
  return r.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : tt(i), r) : e;
  }, r.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : tt(+i), r) : t;
  }, r.context = function(i) {
    return arguments.length ? (n = i ?? null, r) : n;
  }, r;
}
function Vi() {
}
function of(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function yd(e) {
  this._context = e;
}
yd.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        of(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        of(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function vH(e) {
  return new yd(e);
}
function H2(e) {
  this._context = e;
}
H2.prototype = {
  areaStart: Vi,
  areaEnd: Vi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        of(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function AH(e) {
  return new H2(e);
}
function U2(e) {
  this._context = e;
}
U2.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        of(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function bH(e) {
  return new U2(e);
}
function G2(e, t) {
  this._basis = new yd(e), this._beta = t;
}
G2.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length - 1;
    if (n > 0)
      for (var r = e[0], i = t[0], a = e[n] - r, o = t[n] - i, s = -1, c; ++s <= n; )
        c = s / n, this._basis.point(
          this._beta * e[s] + (1 - this._beta) * (r + c * a),
          this._beta * t[s] + (1 - this._beta) * (i + c * o)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
const wH = function e(t) {
  function n(r) {
    return t === 1 ? new yd(r) : new G2(r, t);
  }
  return n.beta = function(r) {
    return e(+r);
  }, n;
}(0.85);
function sf(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function R0(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
R0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        sf(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      default:
        sf(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const _H = function e(t) {
  function n(r) {
    return new R0(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function D0(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
D0.prototype = {
  areaStart: Vi,
  areaEnd: Vi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        sf(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const SH = function e(t) {
  function n(r) {
    return new D0(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function P0(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
P0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        sf(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const CH = function e(t) {
  function n(r) {
    return new P0(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function L0(e, t, n) {
  var r = e._x1, i = e._y1, a = e._x2, o = e._y2;
  if (e._l01_a > yn) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, c = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / c, i = (i * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / c;
  }
  if (e._l23_a > yn) {
    var l = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, u = 3 * e._l23_a * (e._l23_a + e._l12_a);
    a = (a * l + e._x1 * e._l23_2a - t * e._l12_2a) / u, o = (o * l + e._y1 * e._l23_2a - n * e._l12_2a) / u;
  }
  e._context.bezierCurveTo(r, i, a, o, e._x2, e._y2);
}
function V2(e, t) {
  this._context = e, this._alpha = t;
}
V2.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        L0(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const EH = function e(t) {
  function n(r) {
    return t ? new V2(r, t) : new R0(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function Q2(e, t) {
  this._context = e, this._alpha = t;
}
Q2.prototype = {
  areaStart: Vi,
  areaEnd: Vi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        L0(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const kH = function e(t) {
  function n(r) {
    return t ? new Q2(r, t) : new D0(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function q2(e, t) {
  this._context = e, this._alpha = t;
}
q2.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        L0(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const TH = function e(t) {
  function n(r) {
    return t ? new q2(r, t) : new P0(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function X2(e) {
  this._context = e;
}
X2.prototype = {
  areaStart: Vi,
  areaEnd: Vi,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function MH(e) {
  return new X2(e);
}
function Ov(e) {
  return e < 0 ? -1 : 1;
}
function Rv(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (r || i < 0 && -0), o = (n - e._y1) / (i || r < 0 && -0), s = (a * i + o * r) / (r + i);
  return (Ov(a) + Ov(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function Dv(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function Th(e, t, n) {
  var r = e._x0, i = e._y0, a = e._x1, o = e._y1, s = (a - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, a - s, o - s * n, a, o);
}
function lf(e) {
  this._context = e;
}
lf.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Th(this, this._t0, Dv(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Th(this, Dv(this, n = Rv(this, e, t)), n);
          break;
        default:
          Th(this, this._t0, n = Rv(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function J2(e) {
  this._context = new K2(e);
}
(J2.prototype = Object.create(lf.prototype)).point = function(e, t) {
  lf.prototype.point.call(this, t, e);
};
function K2(e) {
  this._context = e;
}
K2.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, a) {
    this._context.bezierCurveTo(t, e, r, n, a, i);
  }
};
function IH(e) {
  return new lf(e);
}
function NH(e) {
  return new J2(e);
}
function Z2(e) {
  this._context = e;
}
Z2.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = Pv(e), i = Pv(t), a = 0, o = 1; o < n; ++a, ++o)
          this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Pv(e) {
  var t, n = e.length - 1, r, i = new Array(n), a = new Array(n), o = new Array(n);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, a[n - 1] = 7, o[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = i[t] / a[t - 1], a[t] -= r, o[t] -= r * o[t - 1];
  for (i[n - 1] = o[n - 1] / a[n - 1], t = n - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function OH(e) {
  return new Z2(e);
}
function xd(e, t) {
  this._context = e, this._t = t;
}
xd.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function RH(e) {
  return new xd(e, 0.5);
}
function DH(e) {
  return new xd(e, 0);
}
function PH(e) {
  return new xd(e, 1);
}
function Po(e, t) {
  if ((o = e.length) > 1)
    for (var n = 1, r, i, a = e[t[0]], o, s = a.length; n < o; ++n)
      for (i = a, a = e[t[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function Lo(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function LH(e, t) {
  return e[t];
}
function zH() {
  var e = tt([]), t = Lo, n = Po, r = LH;
  function i(a) {
    var o = e.apply(this, arguments), s, c = a.length, l = o.length, u = new Array(l), d;
    for (s = 0; s < l; ++s) {
      for (var f = o[s], h = u[s] = new Array(c), m = 0, g; m < c; ++m)
        h[m] = g = [0, +r(a[m], f, m, a)], g.data = a[m];
      h.key = f;
    }
    for (s = 0, d = t(u); s < l; ++s)
      u[d[s]].index = s;
    return n(u, d), u;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : tt(cm.call(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : tt(+a), i) : r;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? Lo : typeof a == "function" ? a : tt(cm.call(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (n = a ?? Po, i) : n;
  }, i;
}
function BH(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = n = 0; n < r; ++n) o += e[n][i][1] || 0;
      if (o) for (n = 0; n < r; ++n) e[n][i][1] /= o;
    }
    Po(e, t);
  }
}
function FH(e, t) {
  if ((c = e.length) > 1)
    for (var n, r = 0, i, a, o, s, c, l = e[t[0]].length; r < l; ++r)
      for (o = s = 0, n = 0; n < c; ++n)
        (a = (i = e[t[n]][r])[1] - i[0]) >= 0 ? (i[0] = o, i[1] = o += a) : a < 0 ? (i[1] = s, i[0] = s += a) : i[0] = o;
}
function $H(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, a = r.length; n < a; ++n) {
      for (var o = 0, s = 0; o < i; ++o) s += e[o][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    Po(e, t);
  }
}
function YH(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, a, o; r < a; ++r) {
      for (var s = 0, c = 0, l = 0; s < o; ++s) {
        for (var u = e[t[s]], d = u[r][1] || 0, f = u[r - 1][1] || 0, h = (d - f) / 2, m = 0; m < s; ++m) {
          var g = e[t[m]], v = g[r][1] || 0, _ = g[r - 1][1] || 0;
          h += v - _;
        }
        c += d, l += h * d;
      }
      i[r - 1][1] += i[r - 1][0] = n, c && (n -= l / c);
    }
    i[r - 1][1] += i[r - 1][0] = n, Po(e, t);
  }
}
function eC(e) {
  var t = e.map(tC);
  return Lo(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function tC(e) {
  for (var t = 0, n = -1, r = e.length, i; ++n < r; ) (i = +e[n][1]) && (t += i);
  return t;
}
function jH(e) {
  return eC(e).reverse();
}
function WH(e) {
  var t = e.length, n, r, i = e.map(tC), a = Lo(e).sort(function(u, d) {
    return i[d] - i[u];
  }), o = 0, s = 0, c = [], l = [];
  for (n = 0; n < t; ++n)
    r = a[n], o < s ? (o += i[r], c.push(r)) : (s += i[r], l.push(r));
  return l.reverse().concat(c);
}
function HH(e) {
  return Lo(e).reverse();
}
function Lv(e) {
  return function() {
    return e;
  };
}
function UH(e) {
  return e[0];
}
function GH(e) {
  return e[1];
}
function cf() {
  this._ = null;
}
function vd(e) {
  e.U = // parent node
  e.C = // color - true for red, false for black
  e.L = // left node
  e.R = // right node
  e.P = // previous node
  e.N = null;
}
cf.prototype = {
  constructor: cf,
  insert: function(e, t) {
    var n, r, i;
    if (e) {
      if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
        for (e = e.R; e.L; ) e = e.L;
        e.L = t;
      } else
        e.R = t;
      n = e;
    } else this._ ? (e = zv(this._), t.P = null, t.N = e, e.P = e.L = t, n = e) : (t.P = t.N = null, this._ = t, n = null);
    for (t.L = t.R = null, t.U = n, t.C = !0, e = t; n && n.C; )
      r = n.U, n === r.L ? (i = r.R, i && i.C ? (n.C = i.C = !1, r.C = !0, e = r) : (e === n.R && (ms(this, n), e = n, n = e.U), n.C = !1, r.C = !0, gs(this, r))) : (i = r.L, i && i.C ? (n.C = i.C = !1, r.C = !0, e = r) : (e === n.L && (gs(this, n), e = n, n = e.U), n.C = !1, r.C = !0, ms(this, r))), n = e.U;
    this._.C = !1;
  },
  remove: function(e) {
    e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
    var t = e.U, n, r = e.L, i = e.R, a, o;
    if (r ? i ? a = zv(i) : a = r : a = i, t ? t.L === e ? t.L = a : t.R = a : this._ = a, r && i ? (o = a.C, a.C = e.C, a.L = r, r.U = a, a !== i ? (t = a.U, a.U = e.U, e = a.R, t.L = e, a.R = i, i.U = a) : (a.U = t, t = a, e = a.R)) : (o = e.C, e = a), e && (e.U = t), !o) {
      if (e && e.C) {
        e.C = !1;
        return;
      }
      do {
        if (e === this._) break;
        if (e === t.L) {
          if (n = t.R, n.C && (n.C = !1, t.C = !0, ms(this, t), n = t.R), n.L && n.L.C || n.R && n.R.C) {
            (!n.R || !n.R.C) && (n.L.C = !1, n.C = !0, gs(this, n), n = t.R), n.C = t.C, t.C = n.R.C = !1, ms(this, t), e = this._;
            break;
          }
        } else if (n = t.L, n.C && (n.C = !1, t.C = !0, gs(this, t), n = t.L), n.L && n.L.C || n.R && n.R.C) {
          (!n.L || !n.L.C) && (n.R.C = !1, n.C = !0, ms(this, n), n = t.L), n.C = t.C, t.C = n.L.C = !1, gs(this, t), e = this._;
          break;
        }
        n.C = !0, e = t, t = t.U;
      } while (!e.C);
      e && (e.C = !1);
    }
  }
};
function ms(e, t) {
  var n = t, r = t.R, i = n.U;
  i ? i.L === n ? i.L = r : i.R = r : e._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
}
function gs(e, t) {
  var n = t, r = t.L, i = n.U;
  i ? i.L === n ? i.L = r : i.R = r : e._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
}
function zv(e) {
  for (; e.L; ) e = e.L;
  return e;
}
function Ds(e, t, n, r) {
  var i = [null, null], a = xn.push(i) - 1;
  return i.left = e, i.right = t, n && uf(i, e, t, n), r && uf(i, t, e, r), qn[e.index].halfedges.push(a), qn[t.index].halfedges.push(a), i;
}
function ys(e, t, n) {
  var r = [t, n];
  return r.left = e, r;
}
function uf(e, t, n, r) {
  !e[0] && !e[1] ? (e[0] = r, e.left = t, e.right = n) : e.left === n ? e[1] = r : e[0] = r;
}
function VH(e, t, n, r, i) {
  var a = e[0], o = e[1], s = a[0], c = a[1], l = o[0], u = o[1], d = 0, f = 1, h = l - s, m = u - c, g;
  if (g = t - s, !(!h && g > 0)) {
    if (g /= h, h < 0) {
      if (g < d) return;
      g < f && (f = g);
    } else if (h > 0) {
      if (g > f) return;
      g > d && (d = g);
    }
    if (g = r - s, !(!h && g < 0)) {
      if (g /= h, h < 0) {
        if (g > f) return;
        g > d && (d = g);
      } else if (h > 0) {
        if (g < d) return;
        g < f && (f = g);
      }
      if (g = n - c, !(!m && g > 0)) {
        if (g /= m, m < 0) {
          if (g < d) return;
          g < f && (f = g);
        } else if (m > 0) {
          if (g > f) return;
          g > d && (d = g);
        }
        if (g = i - c, !(!m && g < 0)) {
          if (g /= m, m < 0) {
            if (g > f) return;
            g > d && (d = g);
          } else if (m > 0) {
            if (g < d) return;
            g < f && (f = g);
          }
          return !(d > 0) && !(f < 1) || (d > 0 && (e[0] = [s + d * h, c + d * m]), f < 1 && (e[1] = [s + f * h, c + f * m])), !0;
        }
      }
    }
  }
}
function QH(e, t, n, r, i) {
  var a = e[1];
  if (a) return !0;
  var o = e[0], s = e.left, c = e.right, l = s[0], u = s[1], d = c[0], f = c[1], h = (l + d) / 2, m = (u + f) / 2, g, v;
  if (f === u) {
    if (h < t || h >= r) return;
    if (l > d) {
      if (!o) o = [h, n];
      else if (o[1] >= i) return;
      a = [h, i];
    } else {
      if (!o) o = [h, i];
      else if (o[1] < n) return;
      a = [h, n];
    }
  } else if (g = (l - d) / (f - u), v = m - g * h, g < -1 || g > 1)
    if (l > d) {
      if (!o) o = [(n - v) / g, n];
      else if (o[1] >= i) return;
      a = [(i - v) / g, i];
    } else {
      if (!o) o = [(i - v) / g, i];
      else if (o[1] < n) return;
      a = [(n - v) / g, n];
    }
  else if (u < f) {
    if (!o) o = [t, g * t + v];
    else if (o[0] >= r) return;
    a = [r, g * r + v];
  } else {
    if (!o) o = [r, g * r + v];
    else if (o[0] < t) return;
    a = [t, g * t + v];
  }
  return e[0] = o, e[1] = a, !0;
}
function qH(e, t, n, r) {
  for (var i = xn.length, a; i--; )
    (!QH(a = xn[i], e, t, n, r) || !VH(a, e, t, n, r) || !(Math.abs(a[0][0] - a[1][0]) > gt || Math.abs(a[0][1] - a[1][1]) > gt)) && delete xn[i];
}
function XH(e) {
  return qn[e.index] = {
    site: e,
    halfedges: []
  };
}
function JH(e, t) {
  var n = e.site, r = t.left, i = t.right;
  return n === i && (i = r, r = n), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (n === r ? (r = t[1], i = t[0]) : (r = t[0], i = t[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
}
function nC(e, t) {
  return t[+(t.left !== e.site)];
}
function KH(e, t) {
  return t[+(t.left === e.site)];
}
function ZH() {
  for (var e = 0, t = qn.length, n, r, i, a; e < t; ++e)
    if ((n = qn[e]) && (a = (r = n.halfedges).length)) {
      var o = new Array(a), s = new Array(a);
      for (i = 0; i < a; ++i) o[i] = i, s[i] = JH(n, xn[r[i]]);
      for (o.sort(function(c, l) {
        return s[l] - s[c];
      }), i = 0; i < a; ++i) s[i] = r[o[i]];
      for (i = 0; i < a; ++i) r[i] = s[i];
    }
}
function eU(e, t, n, r) {
  var i = qn.length, a, o, s, c, l, u, d, f, h, m, g, v, _ = !0;
  for (a = 0; a < i; ++a)
    if (o = qn[a]) {
      for (s = o.site, l = o.halfedges, c = l.length; c--; )
        xn[l[c]] || l.splice(c, 1);
      for (c = 0, u = l.length; c < u; )
        m = KH(o, xn[l[c]]), g = m[0], v = m[1], d = nC(o, xn[l[++c % u]]), f = d[0], h = d[1], (Math.abs(g - f) > gt || Math.abs(v - h) > gt) && (l.splice(c, 0, xn.push(ys(
          s,
          m,
          Math.abs(g - e) < gt && r - v > gt ? [e, Math.abs(f - e) < gt ? h : r] : Math.abs(v - r) < gt && n - g > gt ? [Math.abs(h - r) < gt ? f : n, r] : Math.abs(g - n) < gt && v - t > gt ? [n, Math.abs(f - n) < gt ? h : t] : Math.abs(v - t) < gt && g - e > gt ? [Math.abs(h - t) < gt ? f : e, t] : null
        )) - 1), ++u);
      u && (_ = !1);
    }
  if (_) {
    var I, M, k, y = 1 / 0;
    for (a = 0, _ = null; a < i; ++a)
      (o = qn[a]) && (s = o.site, I = s[0] - e, M = s[1] - t, k = I * I + M * M, k < y && (y = k, _ = o));
    if (_) {
      var x = [e, t], b = [e, r], A = [n, r], w = [n, t];
      _.halfedges.push(
        xn.push(ys(s = _.site, x, b)) - 1,
        xn.push(ys(s, b, A)) - 1,
        xn.push(ys(s, A, w)) - 1,
        xn.push(ys(s, w, x)) - 1
      );
    }
  }
  for (a = 0; a < i; ++a)
    (o = qn[a]) && (o.halfedges.length || delete qn[a]);
}
var rC = [], z0;
function tU() {
  vd(this), this.x = this.y = this.arc = this.site = this.cy = null;
}
function lo(e) {
  var t = e.P, n = e.N;
  if (!(!t || !n)) {
    var r = t.site, i = e.site, a = n.site;
    if (r !== a) {
      var o = i[0], s = i[1], c = r[0] - o, l = r[1] - s, u = a[0] - o, d = a[1] - s, f = 2 * (c * d - l * u);
      if (!(f >= -1e-12)) {
        var h = c * c + l * l, m = u * u + d * d, g = (d * h - l * m) / f, v = (c * m - u * h) / f, _ = rC.pop() || new tU();
        _.arc = e, _.site = i, _.x = g + o, _.y = (_.cy = v + s) + Math.sqrt(g * g + v * v), e.circle = _;
        for (var I = null, M = Tl._; M; )
          if (_.y < M.y || _.y === M.y && _.x <= M.x)
            if (M.L) M = M.L;
            else {
              I = M.P;
              break;
            }
          else if (M.R) M = M.R;
          else {
            I = M;
            break;
          }
        Tl.insert(I, _), I || (z0 = _);
      }
    }
  }
}
function _o(e) {
  var t = e.circle;
  t && (t.P || (z0 = t.N), Tl.remove(t), rC.push(t), vd(t), e.circle = null);
}
var iC = [];
function nU() {
  vd(this), this.edge = this.site = this.circle = null;
}
function Bv(e) {
  var t = iC.pop() || new nU();
  return t.site = e, t;
}
function Mh(e) {
  _o(e), So.remove(e), iC.push(e), vd(e);
}
function rU(e) {
  var t = e.circle, n = t.x, r = t.cy, i = [n, r], a = e.P, o = e.N, s = [e];
  Mh(e);
  for (var c = a; c.circle && Math.abs(n - c.circle.x) < gt && Math.abs(r - c.circle.cy) < gt; )
    a = c.P, s.unshift(c), Mh(c), c = a;
  s.unshift(c), _o(c);
  for (var l = o; l.circle && Math.abs(n - l.circle.x) < gt && Math.abs(r - l.circle.cy) < gt; )
    o = l.N, s.push(l), Mh(l), l = o;
  s.push(l), _o(l);
  var u = s.length, d;
  for (d = 1; d < u; ++d)
    l = s[d], c = s[d - 1], uf(l.edge, c.site, l.site, i);
  c = s[0], l = s[u - 1], l.edge = Ds(c.site, l.site, null, i), lo(c), lo(l);
}
function iU(e) {
  for (var t = e[0], n = e[1], r, i, a, o, s = So._; s; )
    if (a = aC(s, n) - t, a > gt) s = s.L;
    else if (o = t - aU(s, n), o > gt) {
      if (!s.R) {
        r = s;
        break;
      }
      s = s.R;
    } else {
      a > -gt ? (r = s.P, i = s) : o > -gt ? (r = s, i = s.N) : r = i = s;
      break;
    }
  XH(e);
  var c = Bv(e);
  if (So.insert(r, c), !(!r && !i)) {
    if (r === i) {
      _o(r), i = Bv(r.site), So.insert(c, i), c.edge = i.edge = Ds(r.site, c.site), lo(r), lo(i);
      return;
    }
    if (!i) {
      c.edge = Ds(r.site, c.site);
      return;
    }
    _o(r), _o(i);
    var l = r.site, u = l[0], d = l[1], f = e[0] - u, h = e[1] - d, m = i.site, g = m[0] - u, v = m[1] - d, _ = 2 * (f * v - h * g), I = f * f + h * h, M = g * g + v * v, k = [(v * I - h * M) / _ + u, (f * M - g * I) / _ + d];
    uf(i.edge, l, m, k), c.edge = Ds(l, e, null, k), i.edge = Ds(e, m, null, k), lo(r), lo(i);
  }
}
function aC(e, t) {
  var n = e.site, r = n[0], i = n[1], a = i - t;
  if (!a) return r;
  var o = e.P;
  if (!o) return -1 / 0;
  n = o.site;
  var s = n[0], c = n[1], l = c - t;
  if (!l) return s;
  var u = s - r, d = 1 / a - 1 / l, f = u / l;
  return d ? (-f + Math.sqrt(f * f - 2 * d * (u * u / (-2 * l) - c + l / 2 + i - a / 2))) / d + r : (r + s) / 2;
}
function aU(e, t) {
  var n = e.N;
  if (n) return aC(n, t);
  var r = e.site;
  return r[1] === t ? r[0] : 1 / 0;
}
var gt = 1e-6, So, qn, Tl, xn;
function oU(e, t, n) {
  return (e[0] - n[0]) * (t[1] - e[1]) - (e[0] - t[0]) * (n[1] - e[1]);
}
function sU(e, t) {
  return t[1] - e[1] || t[0] - e[0];
}
function fm(e, t) {
  var n = e.sort(sU).pop(), r, i, a;
  for (xn = [], qn = new Array(e.length), So = new cf(), Tl = new cf(); ; )
    if (a = z0, n && (!a || n[1] < a.y || n[1] === a.y && n[0] < a.x))
      (n[0] !== r || n[1] !== i) && (iU(n), r = n[0], i = n[1]), n = e.pop();
    else if (a)
      rU(a.arc);
    else
      break;
  if (ZH(), t) {
    var o = +t[0][0], s = +t[0][1], c = +t[1][0], l = +t[1][1];
    qH(o, s, c, l), eU(o, s, c, l);
  }
  this.edges = xn, this.cells = qn, So = Tl = xn = qn = null;
}
fm.prototype = {
  constructor: fm,
  polygons: function() {
    var e = this.edges;
    return this.cells.map(function(t) {
      var n = t.halfedges.map(function(r) {
        return nC(t, e[r]);
      });
      return n.data = t.site.data, n;
    });
  },
  triangles: function() {
    var e = [], t = this.edges;
    return this.cells.forEach(function(n, r) {
      if (s = (a = n.halfedges).length)
        for (var i = n.site, a, o = -1, s, c, l = t[a[s - 1]], u = l.left === i ? l.right : l.left; ++o < s; )
          c = u, l = t[a[o]], u = l.left === i ? l.right : l.left, c && u && r < c.index && r < u.index && oU(i, c, u) < 0 && e.push([i.data, c.data, u.data]);
    }), e;
  },
  links: function() {
    return this.edges.filter(function(e) {
      return e.right;
    }).map(function(e) {
      return {
        source: e.left.data,
        target: e.right.data
      };
    });
  },
  find: function(e, t, n) {
    for (var r = this, i, a = r._found || 0, o = r.cells.length, s; !(s = r.cells[a]); ) if (++a >= o) return null;
    var c = e - s.site[0], l = t - s.site[1], u = c * c + l * l;
    do
      s = r.cells[i = a], a = null, s.halfedges.forEach(function(d) {
        var f = r.edges[d], h = f.left;
        if (!((h === s.site || !h) && !(h = f.right))) {
          var m = e - h[0], g = t - h[1], v = m * m + g * g;
          v < u && (u = v, a = h.index);
        }
      });
    while (a !== null);
    return r._found = i, n == null || u <= n * n ? s.site : null;
  }
};
function lU() {
  var e = UH, t = GH, n = null;
  function r(i) {
    return new fm(i.map(function(a, o) {
      var s = [Math.round(e(a, o, i) / gt) * gt, Math.round(t(a, o, i) / gt) * gt];
      return s.index = o, s.data = a, s;
    }), n);
  }
  return r.polygons = function(i) {
    return r(i).polygons();
  }, r.links = function(i) {
    return r(i).links();
  }, r.triangles = function(i) {
    return r(i).triangles();
  }, r.x = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Lv(+i), r) : e;
  }, r.y = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Lv(+i), r) : t;
  }, r.extent = function(i) {
    return arguments.length ? (n = i == null ? null : [[+i[0][0], +i[0][1]], [+i[1][0], +i[1][1]]], r) : n && [[n[0][0], n[0][1]], [n[1][0], n[1][1]]];
  }, r.size = function(i) {
    return arguments.length ? (n = i == null ? null : [[0, 0], [+i[0], +i[1]]], r) : n && [n[1][0] - n[0][0], n[1][1] - n[0][1]];
  }, r;
}
function zc(e) {
  return function() {
    return e;
  };
}
function cU(e, t, n) {
  this.target = e, this.type = t, this.transform = n;
}
function mi(e, t, n) {
  this.k = e, this.x = t, this.y = n;
}
mi.prototype = {
  constructor: mi,
  scale: function(e) {
    return e === 1 ? this : new mi(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new mi(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Ad = new mi(1, 0, 0);
oC.prototype = mi.prototype;
function oC(e) {
  return e.__zoom || Ad;
}
function Ih() {
  De.stopImmediatePropagation();
}
function xs() {
  De.preventDefault(), De.stopImmediatePropagation();
}
function uU() {
  return !De.button;
}
function fU() {
  var e = this, t, n;
  return e instanceof SVGElement ? (e = e.ownerSVGElement || e, t = e.width.baseVal.value, n = e.height.baseVal.value) : (t = e.clientWidth, n = e.clientHeight), [[0, 0], [t, n]];
}
function Fv() {
  return this.__zoom || Ad;
}
function dU() {
  return -De.deltaY * (De.deltaMode ? 120 : 1) / 500;
}
function hU() {
  return "ontouchstart" in this;
}
function pU(e, t, n) {
  var r = e.invertX(t[0][0]) - n[0][0], i = e.invertX(t[1][0]) - n[1][0], a = e.invertY(t[0][1]) - n[0][1], o = e.invertY(t[1][1]) - n[1][1];
  return e.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o)
  );
}
function mU() {
  var e = uU, t = fU, n = pU, r = dU, i = hU, a = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, c = R_, l = [], u = Ji("start", "zoom", "end"), d, f, h = 500, m = 150, g = 0;
  function v(C) {
    C.property("__zoom", Fv).on("wheel.zoom", b).on("mousedown.zoom", A).on("dblclick.zoom", w).filter(i).on("touchstart.zoom", O).on("touchmove.zoom", P).on("touchend.zoom touchcancel.zoom", E).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  v.transform = function(C, T) {
    var D = C.selection ? C.selection() : C;
    D.property("__zoom", Fv), C !== D ? k(C, T) : D.interrupt().each(function() {
      y(this, arguments).start().zoom(null, typeof T == "function" ? T.apply(this, arguments) : T).end();
    });
  }, v.scaleBy = function(C, T) {
    v.scaleTo(C, function() {
      var D = this.__zoom.k, z = typeof T == "function" ? T.apply(this, arguments) : T;
      return D * z;
    });
  }, v.scaleTo = function(C, T) {
    v.transform(C, function() {
      var D = t.apply(this, arguments), z = this.__zoom, F = M(D), W = z.invert(F), L = typeof T == "function" ? T.apply(this, arguments) : T;
      return n(I(_(z, L), F, W), D, o);
    });
  }, v.translateBy = function(C, T, D) {
    v.transform(C, function() {
      return n(this.__zoom.translate(
        typeof T == "function" ? T.apply(this, arguments) : T,
        typeof D == "function" ? D.apply(this, arguments) : D
      ), t.apply(this, arguments), o);
    });
  }, v.translateTo = function(C, T, D) {
    v.transform(C, function() {
      var z = t.apply(this, arguments), F = this.__zoom, W = M(z);
      return n(Ad.translate(W[0], W[1]).scale(F.k).translate(
        typeof T == "function" ? -T.apply(this, arguments) : -T,
        typeof D == "function" ? -D.apply(this, arguments) : -D
      ), z, o);
    });
  };
  function _(C, T) {
    return T = Math.max(a[0], Math.min(a[1], T)), T === C.k ? C : new mi(T, C.x, C.y);
  }
  function I(C, T, D) {
    var z = T[0] - D[0] * C.k, F = T[1] - D[1] * C.k;
    return z === C.x && F === C.y ? C : new mi(C.k, z, F);
  }
  function M(C) {
    return [(+C[0][0] + +C[1][0]) / 2, (+C[0][1] + +C[1][1]) / 2];
  }
  function k(C, T, D) {
    C.on("start.zoom", function() {
      y(this, arguments).start();
    }).on("interrupt.zoom end.zoom", function() {
      y(this, arguments).end();
    }).tween("zoom", function() {
      var z = this, F = arguments, W = y(z, F), L = t.apply(z, F), S = D || M(L), j = Math.max(L[1][0] - L[0][0], L[1][1] - L[0][1]), Y = z.__zoom, N = typeof T == "function" ? T.apply(z, F) : T, X = c(Y.invert(S).concat(j / Y.k), N.invert(S).concat(j / N.k));
      return function(G) {
        if (G === 1) G = N;
        else {
          var q = X(G), $ = j / q[2];
          G = new mi($, S[0] - q[0] * $, S[1] - q[1] * $);
        }
        W.zoom(null, G);
      };
    });
  }
  function y(C, T) {
    for (var D = 0, z = l.length, F; D < z; ++D)
      if ((F = l[D]).that === C)
        return F;
    return new x(C, T);
  }
  function x(C, T) {
    this.that = C, this.args = T, this.index = -1, this.active = 0, this.extent = t.apply(C, T);
  }
  x.prototype = {
    start: function() {
      return ++this.active === 1 && (this.index = l.push(this) - 1, this.emit("start")), this;
    },
    zoom: function(C, T) {
      return this.mouse && C !== "mouse" && (this.mouse[1] = T.invert(this.mouse[0])), this.touch0 && C !== "touch" && (this.touch0[1] = T.invert(this.touch0[0])), this.touch1 && C !== "touch" && (this.touch1[1] = T.invert(this.touch1[0])), this.that.__zoom = T, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (l.splice(this.index, 1), this.index = -1, this.emit("end")), this;
    },
    emit: function(C) {
      sl(new cU(v, C, this.that.__zoom), u.apply, u, [C, this.that, this.args]);
    }
  };
  function b() {
    if (!e.apply(this, arguments)) return;
    var C = y(this, arguments), T = this.__zoom, D = Math.max(a[0], Math.min(a[1], T.k * Math.pow(2, r.apply(this, arguments)))), z = Di(this);
    if (C.wheel)
      (C.mouse[0][0] !== z[0] || C.mouse[0][1] !== z[1]) && (C.mouse[1] = T.invert(C.mouse[0] = z)), clearTimeout(C.wheel);
    else {
      if (T.k === D) return;
      C.mouse = [z, T.invert(z)], wa(this), C.start();
    }
    xs(), C.wheel = setTimeout(F, m), C.zoom("mouse", n(I(_(T, D), C.mouse[0], C.mouse[1]), C.extent, o));
    function F() {
      C.wheel = null, C.end();
    }
  }
  function A() {
    if (f || !e.apply(this, arguments)) return;
    var C = y(this, arguments), T = Vt(De.view).on("mousemove.zoom", W, !0).on("mouseup.zoom", L, !0), D = Di(this), z = De.clientX, F = De.clientY;
    qf(De.view), Ih(), C.mouse = [D, this.__zoom.invert(D)], wa(this), C.start();
    function W() {
      if (xs(), !C.moved) {
        var S = De.clientX - z, j = De.clientY - F;
        C.moved = S * S + j * j > g;
      }
      C.zoom("mouse", n(I(C.that.__zoom, C.mouse[0] = Di(C.that), C.mouse[1]), C.extent, o));
    }
    function L() {
      T.on("mousemove.zoom mouseup.zoom", null), Xf(De.view, C.moved), xs(), C.end();
    }
  }
  function w() {
    if (e.apply(this, arguments)) {
      var C = this.__zoom, T = Di(this), D = C.invert(T), z = C.k * (De.shiftKey ? 0.5 : 2), F = n(I(_(C, z), T, D), t.apply(this, arguments), o);
      xs(), s > 0 ? Vt(this).transition().duration(s).call(k, F, T) : Vt(this).call(v.transform, F);
    }
  }
  function O() {
    if (e.apply(this, arguments)) {
      var C = y(this, arguments), T = De.changedTouches, D, z = T.length, F, W, L;
      for (Ih(), F = 0; F < z; ++F)
        W = T[F], L = _u(this, T, W.identifier), L = [L, this.__zoom.invert(L), W.identifier], C.touch0 ? C.touch1 || (C.touch1 = L) : (C.touch0 = L, D = !0);
      if (d && (d = clearTimeout(d), !C.touch1)) {
        C.end(), L = Vt(this).on("dblclick.zoom"), L && L.apply(this, arguments);
        return;
      }
      D && (d = setTimeout(function() {
        d = null;
      }, h), wa(this), C.start());
    }
  }
  function P() {
    var C = y(this, arguments), T = De.changedTouches, D = T.length, z, F, W, L;
    for (xs(), d && (d = clearTimeout(d)), z = 0; z < D; ++z)
      F = T[z], W = _u(this, T, F.identifier), C.touch0 && C.touch0[2] === F.identifier ? C.touch0[0] = W : C.touch1 && C.touch1[2] === F.identifier && (C.touch1[0] = W);
    if (F = C.that.__zoom, C.touch1) {
      var S = C.touch0[0], j = C.touch0[1], Y = C.touch1[0], N = C.touch1[1], X = (X = Y[0] - S[0]) * X + (X = Y[1] - S[1]) * X, G = (G = N[0] - j[0]) * G + (G = N[1] - j[1]) * G;
      F = _(F, Math.sqrt(X / G)), W = [(S[0] + Y[0]) / 2, (S[1] + Y[1]) / 2], L = [(j[0] + N[0]) / 2, (j[1] + N[1]) / 2];
    } else if (C.touch0) W = C.touch0[0], L = C.touch0[1];
    else return;
    C.zoom("touch", n(I(F, W, L), C.extent, o));
  }
  function E() {
    var C = y(this, arguments), T = De.changedTouches, D = T.length, z, F;
    for (Ih(), f && clearTimeout(f), f = setTimeout(function() {
      f = null;
    }, h), z = 0; z < D; ++z)
      F = T[z], C.touch0 && C.touch0[2] === F.identifier ? delete C.touch0 : C.touch1 && C.touch1[2] === F.identifier && delete C.touch1;
    C.touch1 && !C.touch0 && (C.touch0 = C.touch1, delete C.touch1), C.touch0 ? C.touch0[1] = this.__zoom.invert(C.touch0[0]) : C.end();
  }
  return v.wheelDelta = function(C) {
    return arguments.length ? (r = typeof C == "function" ? C : zc(+C), v) : r;
  }, v.filter = function(C) {
    return arguments.length ? (e = typeof C == "function" ? C : zc(!!C), v) : e;
  }, v.touchable = function(C) {
    return arguments.length ? (i = typeof C == "function" ? C : zc(!!C), v) : i;
  }, v.extent = function(C) {
    return arguments.length ? (t = typeof C == "function" ? C : zc([[+C[0][0], +C[0][1]], [+C[1][0], +C[1][1]]]), v) : t;
  }, v.scaleExtent = function(C) {
    return arguments.length ? (a[0] = +C[0], a[1] = +C[1], v) : [a[0], a[1]];
  }, v.translateExtent = function(C) {
    return arguments.length ? (o[0][0] = +C[0][0], o[1][0] = +C[1][0], o[0][1] = +C[0][1], o[1][1] = +C[1][1], v) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, v.constrain = function(C) {
    return arguments.length ? (n = C, v) : n;
  }, v.duration = function(C) {
    return arguments.length ? (s = +C, v) : s;
  }, v.interpolate = function(C) {
    return arguments.length ? (c = C, v) : c;
  }, v.on = function() {
    var C = u.on.apply(u, arguments);
    return C === u ? v : C;
  }, v.clickDistance = function(C) {
    return arguments.length ? (g = (C = +C) * C, v) : Math.sqrt(g);
  }, v;
}
const gU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  active: s$,
  arc: eH,
  area: R2,
  areaRadial: Nv,
  ascending: Ba,
  axisBottom: t_,
  axisLeft: C6,
  axisRight: S6,
  axisTop: _6,
  bisect: Ea,
  bisectLeft: Kz,
  bisectRight: Ea,
  bisector: wg,
  brush: y$,
  brushSelection: p$,
  brushX: m$,
  brushY: g$,
  chord: v$,
  clientPoint: Qf,
  cluster: $j,
  color: Hi,
  create: QB,
  creator: Gf,
  cross: e6,
  csv: Q7,
  csvFormat: z$,
  csvFormatRows: B$,
  csvParse: q_,
  csvParseRows: L$,
  cubehelix: Er,
  curveBasis: vH,
  curveBasisClosed: AH,
  curveBasisOpen: bH,
  curveBundle: wH,
  curveCardinal: _H,
  curveCardinalClosed: SH,
  curveCardinalOpen: CH,
  curveCatmullRom: EH,
  curveCatmullRomClosed: kH,
  curveCatmullRomOpen: TH,
  curveLinear: gd,
  curveLinearClosed: MH,
  curveMonotoneX: IH,
  curveMonotoneY: NH,
  curveNatural: OH,
  curveStep: RH,
  curveStepAfter: PH,
  curveStepBefore: DH,
  customEvent: sl,
  descending: t6,
  deviation: qw,
  dispatch: Ji,
  drag: n8,
  dragDisable: qf,
  dragEnable: Xf,
  dsvFormat: Hg,
  easeBack: ux,
  easeBackIn: e$,
  easeBackInOut: ux,
  easeBackOut: t$,
  easeBounce: pl,
  easeBounceIn: KF,
  easeBounceInOut: ZF,
  easeBounceOut: pl,
  easeCircle: cx,
  easeCircleIn: jF,
  easeCircleInOut: cx,
  easeCircleOut: WF,
  easeCubic: Rp,
  easeCubicIn: DF,
  easeCubicInOut: Rp,
  easeCubicOut: PF,
  easeElastic: fx,
  easeElasticIn: n$,
  easeElasticInOut: r$,
  easeElasticOut: fx,
  easeExp: lx,
  easeExpIn: $F,
  easeExpInOut: lx,
  easeExpOut: YF,
  easeLinear: NF,
  easePoly: ox,
  easePolyIn: LF,
  easePolyInOut: ox,
  easePolyOut: zF,
  easeQuad: ax,
  easeQuadIn: OF,
  easeQuadInOut: ax,
  easeQuadOut: RF,
  easeSin: sx,
  easeSinIn: BF,
  easeSinInOut: sx,
  easeSinOut: FF,
  entries: R$,
  get event() {
    return De;
  },
  extent: Xw,
  forceCenter: j$,
  forceCollide: sY,
  forceLink: cY,
  forceManyBody: mY,
  forceRadial: gY,
  forceSimulation: pY,
  forceX: yY,
  forceY: xY,
  get format() {
    return od;
  },
  formatDefaultLocale: tS,
  formatLocale: eS,
  get formatPrefix() {
    return Vg;
  },
  formatSpecifier: gl,
  geoAlbers: $S,
  geoAlbersUsa: Aj,
  geoArea: kY,
  geoAzimuthalEqualArea: bj,
  geoAzimuthalEqualAreaRaw: r0,
  geoAzimuthalEquidistant: wj,
  geoAzimuthalEquidistantRaw: i0,
  geoBounds: NY,
  geoCentroid: zY,
  geoCircle: BY,
  geoClipAntimeridian: Qp,
  geoClipCircle: SS,
  geoClipExtent: UY,
  geoClipRectangle: sd,
  geoConicConformal: Sj,
  geoConicConformalRaw: WS,
  geoConicEqualArea: tf,
  geoConicEqualAreaRaw: FS,
  geoConicEquidistant: Ej,
  geoConicEquidistantRaw: HS,
  geoContains: KY,
  geoDistance: Hs,
  geoEquirectangular: Cj,
  geoEquirectangularRaw: Al,
  geoGnomonic: kj,
  geoGnomonicRaw: a0,
  geoGraticule: kS,
  geoGraticule10: ZY,
  geoIdentity: Tj,
  geoInterpolate: ej,
  geoLength: CS,
  geoMercator: _j,
  geoMercatorRaw: Gl,
  geoNaturalEarth1: Mj,
  geoNaturalEarth1Raw: o0,
  geoOrthographic: Ij,
  geoOrthographicRaw: s0,
  geoPath: fj,
  geoProjection: Ci,
  geoProjectionMutator: t0,
  geoRotation: xS,
  geoStereographic: Nj,
  geoStereographicRaw: l0,
  geoStream: yr,
  geoTransform: dj,
  geoTransverseMercator: Oj,
  geoTransverseMercatorRaw: c0,
  hcl: ku,
  hierarchy: cd,
  histogram: a6,
  hsl: Su,
  html: W7,
  interpolate: jl,
  interpolateArray: C_,
  interpolateBasis: b_,
  interpolateBasisClosed: w_,
  interpolateCool: $W,
  interpolateCubehelix: N8,
  interpolateCubehelixDefault: BW,
  interpolateCubehelixLong: Zf,
  interpolateDate: E_,
  interpolateHcl: M8,
  interpolateHclLong: I8,
  interpolateHsl: E8,
  interpolateHslLong: k8,
  interpolateInferno: HW,
  interpolateLab: T8,
  interpolateMagma: WW,
  interpolateNumber: Vn,
  interpolateObject: k_,
  interpolatePlasma: UW,
  interpolateRainbow: YW,
  interpolateRgb: fl,
  interpolateRgbBasis: y8,
  interpolateRgbBasisClosed: x8,
  interpolateRound: T_,
  interpolateString: Lg,
  interpolateTransformCss: N_,
  interpolateTransformSvg: O_,
  interpolateViridis: jW,
  interpolateWarm: FW,
  interpolateZoom: R_,
  interrupt: wa,
  interval: L8,
  isoFormat: EW,
  isoParse: TW,
  json: H7,
  keys: N$,
  lab: Eu,
  line: M0,
  lineRadial: Iv,
  linkHorizontal: cH,
  linkRadial: fH,
  linkVertical: uH,
  local: f_,
  map: Xr,
  matcher: Eg,
  max: l6,
  mean: c6,
  median: u6,
  merge: Sg,
  min: Zw,
  mouse: Di,
  namespace: $l,
  namespaces: Sp,
  nest: T$,
  now: Go,
  pack: f7,
  packEnclose: GS,
  packSiblings: l7,
  pairs: Zz,
  partition: d7,
  path: Zi,
  permute: f6,
  pie: rH,
  pointRadial: Rs,
  polygonArea: E7,
  polygonCentroid: k7,
  polygonContains: N7,
  polygonHull: I7,
  polygonLength: O7,
  precisionFixed: nS,
  precisionPrefix: rS,
  precisionRound: iS,
  quadtree: ad,
  quantile: ol,
  quantize: O8,
  queue: n2,
  radialArea: Nv,
  radialLine: Iv,
  randomBates: F7,
  randomExponential: $7,
  randomIrwinHall: i2,
  randomLogNormal: B7,
  randomNormal: r2,
  randomUniform: z7,
  range: Ar,
  request: f0,
  rgb: cl,
  ribbon: k$,
  scaleBand: p0,
  scaleIdentity: c2,
  scaleImplicit: lm,
  scaleLinear: bl,
  scaleLog: f2,
  scaleOrdinal: h0,
  scalePoint: X7,
  scalePow: y0,
  scaleQuantile: d2,
  scaleQuantize: h2,
  scaleSequential: N2,
  scaleSqrt: a9,
  scaleThreshold: p2,
  scaleTime: OW,
  scaleUtc: RW,
  scan: d6,
  schemeCategory10: DW,
  schemeCategory20: zW,
  schemeCategory20b: PW,
  schemeCategory20c: LW,
  select: Vt,
  selectAll: XB,
  selection: Fa,
  selector: Vf,
  selectorAll: Cg,
  set: V_,
  shuffle: h6,
  stack: zH,
  stackOffsetDiverging: FH,
  stackOffsetExpand: BH,
  stackOffsetNone: Po,
  stackOffsetSilhouette: $H,
  stackOffsetWiggle: YH,
  stackOrderAscending: eC,
  stackOrderDescending: jH,
  stackOrderInsideOut: WH,
  stackOrderNone: Lo,
  stackOrderReverse: HH,
  stratify: g7,
  style: ka,
  sum: p6,
  symbol: xH,
  symbolCircle: O0,
  symbolCross: L2,
  symbolDiamond: B2,
  symbolSquare: Y2,
  symbolStar: $2,
  symbolTriangle: j2,
  symbolWye: W2,
  symbols: yH,
  text: U7,
  thresholdFreedmanDiaconis: o6,
  thresholdScott: s6,
  thresholdSturges: Kw,
  tickIncrement: js,
  tickStep: al,
  ticks: _g,
  timeDay: ql,
  timeDays: l9,
  get timeFormat() {
    return S0;
  },
  timeFormatDefaultLocale: M2,
  timeFormatLocale: C2,
  timeFriday: v2,
  timeFridays: h9,
  timeHour: v0,
  timeHours: s9,
  timeInterval: tn,
  timeMillisecond: Oa,
  timeMilliseconds: mv,
  timeMinute: x0,
  timeMinutes: o9,
  timeMonday: Sl,
  timeMondays: c9,
  timeMonth: A0,
  timeMonths: m9,
  get timeParse() {
    return T2;
  },
  timeSaturday: A2,
  timeSaturdays: p9,
  timeSecond: wl,
  timeSeconds: gv,
  timeSunday: _l,
  timeSundays: yv,
  timeThursday: Us,
  timeThursdays: d9,
  timeTuesday: y2,
  timeTuesdays: u9,
  timeWednesday: x2,
  timeWednesdays: f9,
  timeWeek: _l,
  timeWeeks: yv,
  timeYear: Ai,
  timeYears: g9,
  timeout: Ip,
  timer: td,
  timerFlush: F_,
  touch: _u,
  touches: JB,
  transition: j_,
  transpose: e_,
  tree: w7,
  treemap: e2,
  treemapBinary: _7,
  treemapDice: Vl,
  treemapResquarify: C7,
  treemapSlice: ud,
  treemapSliceDice: S7,
  treemapSquarify: ZS,
  tsv: q7,
  tsvFormat: $$,
  tsvFormatRows: Y$,
  tsvParse: X_,
  tsvParseRows: F$,
  utcDay: Xl,
  utcDays: v9,
  get utcFormat() {
    return pd;
  },
  utcFriday: _2,
  utcFridays: S9,
  utcHour: w0,
  utcHours: x9,
  utcMillisecond: Oa,
  utcMilliseconds: mv,
  utcMinute: b0,
  utcMinutes: y9,
  utcMonday: El,
  utcMondays: A9,
  utcMonth: _0,
  utcMonths: E9,
  get utcParse() {
    return C0;
  },
  utcSaturday: S2,
  utcSaturdays: C9,
  utcSecond: wl,
  utcSeconds: gv,
  utcSunday: Cl,
  utcSundays: xv,
  utcThursday: Gs,
  utcThursdays: _9,
  utcTuesday: b2,
  utcTuesdays: b9,
  utcWednesday: w2,
  utcWednesdays: w9,
  utcWeek: Cl,
  utcWeeks: xv,
  utcYear: bi,
  utcYears: k9,
  values: O$,
  variance: Qw,
  version: Xz,
  voronoi: lU,
  window: kg,
  xml: G7,
  zip: g6,
  zoom: mU,
  zoomIdentity: Ad,
  zoomTransform: oC
}, Symbol.toStringTag, { value: "Module" })), yU = /* @__PURE__ */ jE(gU);
var Nh = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
var $v;
function xU() {
  return $v || ($v = 1, function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : t.numeral = n();
    })(Ca, function() {
      var t, n, r = "2.0.6", i = {}, a = {}, o = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: !0
      }, s = {
        currentLocale: o.currentLocale,
        zeroFormat: o.zeroFormat,
        nullFormat: o.nullFormat,
        defaultFormat: o.defaultFormat,
        scalePercentBy100: o.scalePercentBy100
      };
      function c(l, u) {
        this._input = l, this._value = u;
      }
      return t = function(l) {
        var u, d, f, h;
        if (t.isNumeral(l))
          u = l.value();
        else if (l === 0 || typeof l > "u")
          u = 0;
        else if (l === null || n.isNaN(l))
          u = null;
        else if (typeof l == "string")
          if (s.zeroFormat && l === s.zeroFormat)
            u = 0;
          else if (s.nullFormat && l === s.nullFormat || !l.replace(/[^0-9]+/g, "").length)
            u = null;
          else {
            for (d in i)
              if (h = typeof i[d].regexps.unformat == "function" ? i[d].regexps.unformat() : i[d].regexps.unformat, h && l.match(h)) {
                f = i[d].unformat;
                break;
              }
            f = f || t._.stringToNumber, u = f(l);
          }
        else
          u = Number(l) || null;
        return new c(l, u);
      }, t.version = r, t.isNumeral = function(l) {
        return l instanceof c;
      }, t._ = n = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(l, u, d) {
          var f = a[t.options.currentLocale], h = !1, m = !1, g = 0, v = "", _ = 1e12, I = 1e9, M = 1e6, k = 1e3, y = "", x = !1, b, A, w, O, P, E, C;
          if (l = l || 0, A = Math.abs(l), t._.includes(u, "(") ? (h = !0, u = u.replace(/[\(|\)]/g, "")) : (t._.includes(u, "+") || t._.includes(u, "-")) && (P = t._.includes(u, "+") ? u.indexOf("+") : l < 0 ? u.indexOf("-") : -1, u = u.replace(/[\+|\-]/g, "")), t._.includes(u, "a") && (b = u.match(/a(k|m|b|t)?/), b = b ? b[1] : !1, t._.includes(u, " a") && (v = " "), u = u.replace(new RegExp(v + "a[kmbt]?"), ""), A >= _ && !b || b === "t" ? (v += f.abbreviations.trillion, l = l / _) : A < _ && A >= I && !b || b === "b" ? (v += f.abbreviations.billion, l = l / I) : A < I && A >= M && !b || b === "m" ? (v += f.abbreviations.million, l = l / M) : (A < M && A >= k && !b || b === "k") && (v += f.abbreviations.thousand, l = l / k)), t._.includes(u, "[.]") && (m = !0, u = u.replace("[.]", ".")), w = l.toString().split(".")[0], O = u.split(".")[1], E = u.indexOf(","), g = (u.split(".")[0].split(",")[0].match(/0/g) || []).length, O ? (t._.includes(O, "[") ? (O = O.replace("]", ""), O = O.split("["), y = t._.toFixed(l, O[0].length + O[1].length, d, O[1].length)) : y = t._.toFixed(l, O.length, d), w = y.split(".")[0], t._.includes(y, ".") ? y = f.delimiters.decimal + y.split(".")[1] : y = "", m && Number(y.slice(1)) === 0 && (y = "")) : w = t._.toFixed(l, 0, d), v && !b && Number(w) >= 1e3 && v !== f.abbreviations.trillion)
            switch (w = String(Number(w) / 1e3), v) {
              case f.abbreviations.thousand:
                v = f.abbreviations.million;
                break;
              case f.abbreviations.million:
                v = f.abbreviations.billion;
                break;
              case f.abbreviations.billion:
                v = f.abbreviations.trillion;
                break;
            }
          if (t._.includes(w, "-") && (w = w.slice(1), x = !0), w.length < g)
            for (var T = g - w.length; T > 0; T--)
              w = "0" + w;
          return E > -1 && (w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + f.delimiters.thousands)), u.indexOf(".") === 0 && (w = ""), C = w + y + (v || ""), h ? C = (h && x ? "(" : "") + C + (h && x ? ")" : "") : P >= 0 ? C = P === 0 ? (x ? "-" : "+") + C : C + (x ? "-" : "+") : x && (C = "-" + C), C;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(l) {
          var u = a[s.currentLocale], d = l, f = {
            thousand: 3,
            million: 6,
            billion: 9,
            trillion: 12
          }, h, m, g;
          if (s.zeroFormat && l === s.zeroFormat)
            m = 0;
          else if (s.nullFormat && l === s.nullFormat || !l.replace(/[^0-9]+/g, "").length)
            m = null;
          else {
            m = 1, u.delimiters.decimal !== "." && (l = l.replace(/\./g, "").replace(u.delimiters.decimal, "."));
            for (h in f)
              if (g = new RegExp("[^a-zA-Z]" + u.abbreviations[h] + "(?:\\)|(\\" + u.currency.symbol + ")?(?:\\))?)?$"), d.match(g)) {
                m *= Math.pow(10, f[h]);
                break;
              }
            m *= (l.split("-").length + Math.min(l.split("(").length - 1, l.split(")").length - 1)) % 2 ? 1 : -1, l = l.replace(/[^0-9\.]+/g, ""), m *= Number(l);
          }
          return m;
        },
        isNaN: function(l) {
          return typeof l == "number" && isNaN(l);
        },
        includes: function(l, u) {
          return l.indexOf(u) !== -1;
        },
        insert: function(l, u, d) {
          return l.slice(0, d) + u + l.slice(d);
        },
        reduce: function(l, u) {
          if (this === null)
            throw new TypeError("Array.prototype.reduce called on null or undefined");
          if (typeof u != "function")
            throw new TypeError(u + " is not a function");
          var d = Object(l), f = d.length >>> 0, h = 0, m;
          if (arguments.length === 3)
            m = arguments[2];
          else {
            for (; h < f && !(h in d); )
              h++;
            if (h >= f)
              throw new TypeError("Reduce of empty array with no initial value");
            m = d[h++];
          }
          for (; h < f; h++)
            h in d && (m = u(m, d[h], h, d));
          return m;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function(l) {
          var u = l.toString().split(".");
          return u.length < 2 ? 1 : Math.pow(10, u[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function() {
          var l = Array.prototype.slice.call(arguments);
          return l.reduce(function(u, d) {
            var f = n.multiplier(d);
            return u > f ? u : f;
          }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(l, u, d, f) {
          var h = l.toString().split("."), m = u - (f || 0), g, v, _, I;
          return h.length === 2 ? g = Math.min(Math.max(h[1].length, m), u) : g = m, _ = Math.pow(10, g), I = (d(l + "e+" + g) / _).toFixed(g), f > u - g && (v = new RegExp("\\.?0{1," + (f - (u - g)) + "}$"), I = I.replace(v, "")), I;
        }
      }, t.options = s, t.formats = i, t.locales = a, t.locale = function(l) {
        return l && (s.currentLocale = l.toLowerCase()), s.currentLocale;
      }, t.localeData = function(l) {
        if (!l)
          return a[s.currentLocale];
        if (l = l.toLowerCase(), !a[l])
          throw new Error("Unknown locale : " + l);
        return a[l];
      }, t.reset = function() {
        for (var l in o)
          s[l] = o[l];
      }, t.zeroFormat = function(l) {
        s.zeroFormat = typeof l == "string" ? l : null;
      }, t.nullFormat = function(l) {
        s.nullFormat = typeof l == "string" ? l : null;
      }, t.defaultFormat = function(l) {
        s.defaultFormat = typeof l == "string" ? l : "0.0";
      }, t.register = function(l, u, d) {
        if (u = u.toLowerCase(), this[l + "s"][u])
          throw new TypeError(u + " " + l + " already registered.");
        return this[l + "s"][u] = d, d;
      }, t.validate = function(l, u) {
        var d, f, h, m, g, v, _, I;
        if (typeof l != "string" && (l += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", l)), l = l.trim(), l.match(/^\d+$/))
          return !0;
        if (l === "")
          return !1;
        try {
          _ = t.localeData(u);
        } catch {
          _ = t.localeData(t.locale());
        }
        return h = _.currency.symbol, g = _.abbreviations, d = _.delimiters.decimal, _.delimiters.thousands === "." ? f = "\\." : f = _.delimiters.thousands, I = l.match(/^[^\d]+/), I !== null && (l = l.substr(1), I[0] !== h) || (I = l.match(/[^\d]+$/), I !== null && (l = l.slice(0, -1), I[0] !== g.thousand && I[0] !== g.million && I[0] !== g.billion && I[0] !== g.trillion)) ? !1 : (v = new RegExp(f + "{2}"), l.match(/[^\d.,]/g) ? !1 : (m = l.split(d), m.length > 2 ? !1 : m.length < 2 ? !!m[0].match(/^\d+.*\d$/) && !m[0].match(v) : m[0].length === 1 ? !!m[0].match(/^\d+$/) && !m[0].match(v) && !!m[1].match(/^\d+$/) : !!m[0].match(/^\d+.*\d$/) && !m[0].match(v) && !!m[1].match(/^\d+$/)));
      }, t.fn = c.prototype = {
        clone: function() {
          return t(this);
        },
        format: function(l, u) {
          var d = this._value, f = l || s.defaultFormat, h, m, g;
          if (u = u || Math.round, d === 0 && s.zeroFormat !== null)
            m = s.zeroFormat;
          else if (d === null && s.nullFormat !== null)
            m = s.nullFormat;
          else {
            for (h in i)
              if (f.match(i[h].regexps.format)) {
                g = i[h].format;
                break;
              }
            g = g || t._.numberToFormat, m = g(d, f, u);
          }
          return m;
        },
        value: function() {
          return this._value;
        },
        input: function() {
          return this._input;
        },
        set: function(l) {
          return this._value = Number(l), this;
        },
        add: function(l) {
          var u = n.correctionFactor.call(null, this._value, l);
          function d(f, h, m, g) {
            return f + Math.round(u * h);
          }
          return this._value = n.reduce([this._value, l], d, 0) / u, this;
        },
        subtract: function(l) {
          var u = n.correctionFactor.call(null, this._value, l);
          function d(f, h, m, g) {
            return f - Math.round(u * h);
          }
          return this._value = n.reduce([l], d, Math.round(this._value * u)) / u, this;
        },
        multiply: function(l) {
          function u(d, f, h, m) {
            var g = n.correctionFactor(d, f);
            return Math.round(d * g) * Math.round(f * g) / Math.round(g * g);
          }
          return this._value = n.reduce([this._value, l], u, 1), this;
        },
        divide: function(l) {
          function u(d, f, h, m) {
            var g = n.correctionFactor(d, f);
            return Math.round(d * g) / Math.round(f * g);
          }
          return this._value = n.reduce([this._value, l], u), this;
        },
        difference: function(l) {
          return Math.abs(t(this._value).subtract(l).value());
        }
      }, t.register("locale", "en", {
        delimiters: {
          thousands: ",",
          decimal: "."
        },
        abbreviations: {
          thousand: "k",
          million: "m",
          billion: "b",
          trillion: "t"
        },
        ordinal: function(l) {
          var u = l % 10;
          return ~~(l % 100 / 10) === 1 ? "th" : u === 1 ? "st" : u === 2 ? "nd" : u === 3 ? "rd" : "th";
        },
        currency: {
          symbol: "$"
        }
      }), function() {
        t.register("format", "bps", {
          regexps: {
            format: /(BPS)/,
            unformat: /(BPS)/
          },
          format: function(l, u, d) {
            var f = t._.includes(u, " BPS") ? " " : "", h;
            return l = l * 1e4, u = u.replace(/\s?BPS/, ""), h = t._.numberToFormat(l, u, d), t._.includes(h, ")") ? (h = h.split(""), h.splice(-1, 0, f + "BPS"), h = h.join("")) : h = h + f + "BPS", h;
          },
          unformat: function(l) {
            return +(t._.stringToNumber(l) * 1e-4).toFixed(15);
          }
        });
      }(), function() {
        var l = {
          base: 1e3,
          suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        }, u = {
          base: 1024,
          suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
        }, d = l.suffixes.concat(u.suffixes.filter(function(h) {
          return l.suffixes.indexOf(h) < 0;
        })), f = d.join("|");
        f = "(" + f.replace("B", "B(?!PS)") + ")", t.register("format", "bytes", {
          regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(f)
          },
          format: function(h, m, g) {
            var v, _ = t._.includes(m, "ib") ? u : l, I = t._.includes(m, " b") || t._.includes(m, " ib") ? " " : "", M, k, y;
            for (m = m.replace(/\s?i?b/, ""), M = 0; M <= _.suffixes.length; M++)
              if (k = Math.pow(_.base, M), y = Math.pow(_.base, M + 1), h === null || h === 0 || h >= k && h < y) {
                I += _.suffixes[M], k > 0 && (h = h / k);
                break;
              }
            return v = t._.numberToFormat(h, m, g), v + I;
          },
          unformat: function(h) {
            var m = t._.stringToNumber(h), g, v;
            if (m) {
              for (g = l.suffixes.length - 1; g >= 0; g--) {
                if (t._.includes(h, l.suffixes[g])) {
                  v = Math.pow(l.base, g);
                  break;
                }
                if (t._.includes(h, u.suffixes[g])) {
                  v = Math.pow(u.base, g);
                  break;
                }
              }
              m *= v || 1;
            }
            return m;
          }
        });
      }(), function() {
        t.register("format", "currency", {
          regexps: {
            format: /(\$)/
          },
          format: function(l, u, d) {
            var f = t.locales[t.options.currentLocale], h = {
              before: u.match(/^([\+|\-|\(|\s|\$]*)/)[0],
              after: u.match(/([\+|\-|\)|\s|\$]*)$/)[0]
            }, m, g, v;
            for (u = u.replace(/\s?\$\s?/, ""), m = t._.numberToFormat(l, u, d), l >= 0 ? (h.before = h.before.replace(/[\-\(]/, ""), h.after = h.after.replace(/[\-\)]/, "")) : l < 0 && !t._.includes(h.before, "-") && !t._.includes(h.before, "(") && (h.before = "-" + h.before), v = 0; v < h.before.length; v++)
              switch (g = h.before[v], g) {
                case "$":
                  m = t._.insert(m, f.currency.symbol, v);
                  break;
                case " ":
                  m = t._.insert(m, " ", v + f.currency.symbol.length - 1);
                  break;
              }
            for (v = h.after.length - 1; v >= 0; v--)
              switch (g = h.after[v], g) {
                case "$":
                  m = v === h.after.length - 1 ? m + f.currency.symbol : t._.insert(m, f.currency.symbol, -(h.after.length - (1 + v)));
                  break;
                case " ":
                  m = v === h.after.length - 1 ? m + " " : t._.insert(m, " ", -(h.after.length - (1 + v) + f.currency.symbol.length - 1));
                  break;
              }
            return m;
          }
        });
      }(), function() {
        t.register("format", "exponential", {
          regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
          },
          format: function(l, u, d) {
            var f, h = typeof l == "number" && !t._.isNaN(l) ? l.toExponential() : "0e+0", m = h.split("e");
            return u = u.replace(/e[\+|\-]{1}0/, ""), f = t._.numberToFormat(Number(m[0]), u, d), f + "e" + m[1];
          },
          unformat: function(l) {
            var u = t._.includes(l, "e+") ? l.split("e+") : l.split("e-"), d = Number(u[0]), f = Number(u[1]);
            f = t._.includes(l, "e-") ? f *= -1 : f;
            function h(m, g, v, _) {
              var I = t._.correctionFactor(m, g), M = m * I * (g * I) / (I * I);
              return M;
            }
            return t._.reduce([d, Math.pow(10, f)], h, 1);
          }
        });
      }(), function() {
        t.register("format", "ordinal", {
          regexps: {
            format: /(o)/
          },
          format: function(l, u, d) {
            var f = t.locales[t.options.currentLocale], h, m = t._.includes(u, " o") ? " " : "";
            return u = u.replace(/\s?o/, ""), m += f.ordinal(l), h = t._.numberToFormat(l, u, d), h + m;
          }
        });
      }(), function() {
        t.register("format", "percentage", {
          regexps: {
            format: /(%)/,
            unformat: /(%)/
          },
          format: function(l, u, d) {
            var f = t._.includes(u, " %") ? " " : "", h;
            return t.options.scalePercentBy100 && (l = l * 100), u = u.replace(/\s?\%/, ""), h = t._.numberToFormat(l, u, d), t._.includes(h, ")") ? (h = h.split(""), h.splice(-1, 0, f + "%"), h = h.join("")) : h = h + f + "%", h;
          },
          unformat: function(l) {
            var u = t._.stringToNumber(l);
            return t.options.scalePercentBy100 ? u * 0.01 : u;
          }
        });
      }(), function() {
        t.register("format", "time", {
          regexps: {
            format: /(:)/,
            unformat: /(:)/
          },
          format: function(l, u, d) {
            var f = Math.floor(l / 60 / 60), h = Math.floor((l - f * 60 * 60) / 60), m = Math.round(l - f * 60 * 60 - h * 60);
            return f + ":" + (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m);
          },
          unformat: function(l) {
            var u = l.split(":"), d = 0;
            return u.length === 3 ? (d = d + Number(u[0]) * 60 * 60, d = d + Number(u[1]) * 60, d = d + Number(u[2])) : u.length === 2 && (d = d + Number(u[0]) * 60, d = d + Number(u[1])), Number(d);
          }
        });
      }(), t;
    });
  }(Nh)), Nh.exports;
}
(function(e, t) {
  (function(n, r) {
    e.exports = r(yU, IE, xU());
  })(self, function(n, r, i) {
    return (() => {
      var a = { 605: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && _(C, T);
            })(E, A);
            var w, O, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return w = E, (O = [{ key: "render", value: function(C, T, D, z, F) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, F);
              var W = { margin: { top: 20, right: 30, bottom: 20, left: 40 }, yTicks: 4, xFormat: y.format(",.0f"), yFormat: y.format("s") }, L = D - (F = Object.assign({}, W, F)).margin.left - F.margin.right, S = z - F.margin.top - F.margin.bottom, j = y.scaleLinear().domain(y.extent(C, function($) {
                return $.x;
              })).range([0, L]), Y = y.scaleLinear().domain([0, y.max(C, function($) {
                return $.y;
              })]).range([S, 0]), N = y.axisBottom().scale(j).tickFormat(F.xFormat).ticks(10), X = y.axisLeft().scale(Y).tickFormat(F.yFormat).ticks(F.yTicks), G = y.area().x(function($) {
                return j($.x);
              }).y0(S).y1(function($) {
                return Y($.y);
              }), q = this.createSvg(T, D, z).append("g").attr("transform", "translate(" + F.margin.left + "," + F.margin.top + ")");
              q.append("path").data([C]).attr("class", "area").attr("d", G), q.append("g").attr("class", "x axis").attr("transform", "translate(0," + S + ")").call(N), q.append("g").attr("class", "y axis").call(X);
            } }]) && g(w.prototype, O), E;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 648: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && _(C, T);
            })(E, A);
            var w, O, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return w = E, (O = [{ key: "render", value: function(C, T, D, z, F) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, F);
              var W = this.getOptions({ maxPercent: 100 }, F), L = this.createSvg(T, D, z), S = L.append("g").attr("transform", "translate(".concat(D / 2, ", ").concat(z / 2, ")")), j = Math.min(D - 10, z - 10) / 2, Y = 0.3 * j, N = y.scaleLinear().domain([0, W.maxPercent]).range([Y, j]), X = y.arc().innerRadius(Y).outerRadius(function(K) {
                return N(K.data.percent);
              }), G = y.arc().innerRadius(Y).outerRadius(j), q = [0, 2 * Math.PI], $ = y.pie().sort(null).startAngle(q[0]).endAngle(q[1]).value(function(K) {
                return K.weight;
              });
              C.length > 1 && $.padAngle(0.01), S.selectAll(".solidArc").data($(C)).enter().append("path").attr("fill", function(K) {
                return W.colors(K.data.id);
              }).attr("class", "solidArc").attr("d", X), S.selectAll(".outlineArc").data($(C)).enter().append("path").attr("fill", "none").attr("stroke", function(K) {
                return W.colors(K.data.id);
              }).attr("class", "outlineArc").attr("d", G), W.asterLabel && L.append("svg:text").attr("class", "aster-label").attr("dy", ".35em").attr("text-anchor", "middle").text(asterLabel());
              for (var Q = S.append("g").attr("class", "axisWrapper"), V = Math.ceil(W.maxPercent / 25), H = 1; H < V; H++) Q.append("circle").attr("class", "gridCircle").attr("r", N(25 * H)).style("fill", "none").style("stroke", "#c5c5c5").style("stroke-width", 0.6), H % 2 == 1 && (Q.append("rect").attr("x", -8).attr("y", -N(25 * H) - 5).attr("width", 20).style("height", 10).attr("fill", "#fff"), Q.append("text").attr("class", "axisLabel").attr("x", -6).attr("y", -N(25 * H)).attr("dy", ".4em").style("font-size", "8px").attr("fill", "#737373").text(function(K, U) {
                return "".concat(25 * H, "%");
              }));
            } }]) && g(w.prototype, O), E;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 131: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && _(C, T);
            })(E, A);
            var w, O, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return w = E, (O = [{ key: "render", value: function(C, T, D, z, F) {
              var W = this;
              v(k(E.prototype), "render", this).call(this, C, T, D, z, F);
              var L = this.getOptions({ label: "label", value: "value", rotate: 0, textAnchor: "middle", showLabels: !1 }, F), S = this.createSvg(T, D, z);
              this.useTip(function(se) {
                se.attr("class", "d3-tip").offset([-10, 0]).html(function(ne) {
                  return ne.value;
                });
              });
              var j = L.label, Y = L.value, N = 0;
              C.forEach(function(se) {
                N += se[Y];
              });
              var X = D - L.margins.left - L.margins.right, G = z - L.margins.top - L.margins.bottom, q = y.scaleBand().range([0, X]).padding(0.1).round(1 / C.length), $ = y.scaleLinear().range([G, 0]), Q = y.axisBottom().scale(q).tickSize(2, 0), V = y.axisLeft().scale($).tickFormat(L.yFormat).ticks(5);
              q.domain(C.map(function(se) {
                return se[j];
              })), $.domain([0, L.yMax || y.max(C, function(se) {
                return se[Y];
              })]);
              var H = S.append("g").attr("class", "axis");
              H.call(Q);
              var K = Math.round(H.node().getBBox().height), U = Math.round(H.node().getBBox().width);
              G -= K, X -= Math.max(0, U - X), H.remove();
              var ee = S.append("g").attr("class", "axis");
              ee.call(V);
              var ce = Math.round(ee.node().getBBox().width);
              X -= ce, ee.remove(), q.range([0, X]), $.range([G, 0]), (S = S.append("g").attr("transform", `translate(
	          `.concat(L.margins.left + ce, `,
	          `).concat(L.margins.top, `
	        )`))).append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(G, ")")).call(Q).selectAll(".tick text").style("text-anchor", L.textAnchor).attr("transform", function(se) {
                return "rotate(".concat(L.rotate, ")");
              }), L.wrap && S.selectAll(".tick text").call(this.wrap, q.bandwidth()), S.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(V), S.selectAll(".bar").data(C).enter().append("rect").attr("class", "bar").attr("x", function(se) {
                return q(se[j]);
              }).attr("width", q.bandwidth()).attr("y", function(se) {
                return $(se[Y]);
              }).attr("height", function(se) {
                return G - $(se[Y]);
              }).attr("title", function(se) {
                var ne = "".concat(se[j], ": ").concat(W.formatters.commaseparated(se[Y], ","));
                return ne += " (".concat(N > 0 ? W.formatters.formatpercent(se[Y] / N) : W.formatters.formatpercent(0), ")");
              }).style("fill", function(se) {
                return L.colors(se[j]);
              }).on("mouseover", function(se) {
                return W.tip.show(se, event.target);
              }).on("mouseout", function(se) {
                return W.tip.hide(se, event.target);
              }).exit().remove(), L.showLabels && S.selectAll(".barlabel").data(C).enter().append("text").attr("class", "barlabel").text(function(se) {
                return W.formatters.formatpercent(se[Y] / N);
              }).attr("x", function(se) {
                return q(se[j]) + q.bandwidth() / 2;
              }).attr("y", function(se) {
                return $(se[Y]) - 3;
              }).attr("text-anchor", "middle");
            } }, { key: "formatters", get: function() {
              return { commaseparated: y.format(","), formatpercent: y.format(".1%") };
            } }]) && g(w.prototype, O), E;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 316: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && _(C, T);
            })(E, A);
            var w, O, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return w = E, (O = [{ key: "defaultTip", value: function(C, T) {
              C.attr("class", "d3-tip").offset(function(D) {
                return D.tipOffset || [-10, 0];
              }).direction(function(D) {
                return D.tipDirection || "n";
              }).html(function(D) {
                return `<table class='boxplotValues'>
					<tr>
						<td>Max:</td>
						<td>`.concat(T.valueFormatter(D.max), `</td>
					</tr>
					<tr>
						<td>P90:</td>
						<td>`).concat(T.valueFormatter(D.UIF), `</td>
					</tr>
					<tr>
						<td>P75:</td>
						<td>`).concat(T.valueFormatter(D.q3), `</td>
					</tr>
					<tr>
						<td>Median:</td>
						<td>`).concat(T.valueFormatter(D.median), `</td>
					</tr>
					<tr>
						<td>P25:</td>
						<td>`).concat(T.valueFormatter(D.q1), `</td>
					</tr>
					<tr>
						<td>P10:</td>
						<td>`).concat(T.valueFormatter(D.LIF), `</td>
					</tr>
					<tr>
						<td>Min:</td>
						<td>`).concat(T.valueFormatter(D.min), `</td>
					</tr>
				</table>`);
              });
            } }, { key: "render", value: function(C, T, D, z, F) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, F);
              var W = { valueFormatter: this.formatters.formatSI(3) }, L = this.getOptions(W, F), S = this.createSvg(T, D, z);
              L.valueFormatter, this.useTip(this.defaultTip, L);
              var j = 0, Y = 0;
              if (L.xLabel) {
                var N = S.append("g").attr("transform", "translate(".concat(D / 2, ", ").concat(z - L.margins.bottom, ")"));
                N.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(L.xLabel), j = N.node().getBBox().height;
              }
              if (L.yLabel) {
                var X = S.append("g").attr("transform", `translate(
	            `.concat(L.margins.left, `,
	            `).concat((z - L.margins.bottom - L.margins.top) / 2 + L.margins.top, `
	          )`));
                X.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(L.yLabel), Y = X.node().getBBox().width;
              }
              var G = D - L.margins.left - Y - L.margins.right, q = z - L.margins.top - j - L.margins.bottom, $ = y.scaleBand().range([0, G]).round(1 / C.length).domain(C.map(function(de) {
                return de.Category;
              })), Q = y.scaleLinear().range([q, 0]).domain([L.yMin || 0, L.yMax || y.max(C, function(de) {
                return de.max;
              })]), V = y.axisBottom().scale($), H = y.axisLeft().scale(Q).tickFormat(L.yFormat).ticks(5), K = S.append("g").attr("class", "axis");
              K.call(V);
              var U = Math.round(K.node().getBBox().height), ee = Math.round(K.node().getBBox().width);
              q -= U, G -= Math.max(0, ee - G), K.remove();
              var ce = S.append("g").attr("class", "axis");
              ce.call(H);
              var se = Math.round(ce.node().getBBox().width);
              G -= se, ce.remove(), $.range([0, G]), Q.range([q, 0]);
              var ne = $.bandwidth() / 2 - 5, re = $.bandwidth() / 2 - 2.5, Me = S.append("g").attr("transform", `translate(
	          `.concat(L.margins.left + Y + se, `,
	          `).concat(L.margins.top, `
	        )`)), Re = Me.selectAll(".boxplot").data(C).enter().append("g").attr("class", "boxplot").attr("transform", function(de) {
                return "translate(".concat($(de.Category), ", 0)");
              }), oe = this;
              Re.each(function(de) {
                var ue = y.select(this);
                de.LIF != de.q1 && (ue.append("line").attr("class", "bar").attr("x1", re).attr("y1", Q(de.LIF)).attr("x2", re + 5).attr("y2", Q(de.LIF)), ue.append("line").attr("class", "whisker").attr("x1", $.bandwidth() / 2).attr("y1", Q(de.LIF)).attr("x2", $.bandwidth() / 2).attr("y2", Q(de.q1))), ue.append("rect").attr("class", "box").attr("x", ne).attr("y", Q(de.q3)).attr("width", 10).attr("height", Math.max(1, Q(de.q1) - Q(de.q3))).on("mouseover", function(me) {
                  return oe.tip.show(me, event.target);
                }).on("mouseout", function(me) {
                  return oe.tip.hide(me, event.target);
                }), ue.append("line").attr("class", "median").attr("x1", ne).attr("y1", Q(de.median)).attr("x2", ne + 10).attr("y2", Q(de.median)), de.UIF != de.q3 && (ue.append("line").attr("class", "bar").attr("x1", re).attr("y1", Q(de.UIF)).attr("x2", $.bandwidth() - re).attr("y2", Q(de.UIF)), ue.append("line").attr("class", "whisker").attr("x1", $.bandwidth() / 2).attr("y1", Q(de.UIF)).attr("x2", $.bandwidth() / 2).attr("y2", Q(de.q3)));
              }), Me.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(q, ")")).call(V), Me.selectAll(".tick text").call(this.wrap, $.bandwidth() || $.range()), Me.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(H);
            } }]) && g(w.prototype, O), E;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 842: (c, l, u) => {
        var d, f;
        function h(m, g) {
          for (var v = 0; v < g.length; v++) {
            var _ = g[v];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(m, _.key, _);
          }
        }
        d = [u(680), u(92), u(383)], f = (function(m, g, v) {
          var _ = function() {
            function I() {
              (function(x, b) {
                if (!(x instanceof b)) throw new TypeError("Cannot call a class as a function");
              })(this, I);
            }
            var M, k, y;
            return M = I, k = [{ key: "render", value: function(x, b, A, w, O) {
              var P = this;
              typeof b == "string" && (b = document.querySelector(b)), this.cachedData = x, this.doResize || (this.doResize = g.debounce(function() {
                P.render(P.cachedData, b, b.clientWidth, b.clientHeight, O);
              }, 250), window.addEventListener("resize", this.doResize));
            } }, { key: "getOptions", value: function(x, b) {
              return Object.assign({}, { margins: { top: 10, right: 10, bottom: 10, left: 10 }, xFormat: m.format(",.0f"), yFormat: m.format("s"), colors: m.scaleOrdinal(m.schemeCategory20.concat(m.schemeCategory20c)) }, Object.assign({}, x), Object.assign({}, b));
            } }, { key: "createSvg", value: function(x, b, A) {
              this.destroyTipIfExists();
              var w = m.select(x);
              w.select("svg").remove();
              var O = w.append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", `
	        0
	        0
	        `.concat(b, `
	        `).concat(A)).append("g").attr("class", "chart");
              return this.chart = O, O;
            } }, { key: "useTip", value: function() {
              var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
              }, b = arguments.length > 1 ? arguments[1] : void 0;
              return this.destroyTipIfExists(), this.tip = v().attr("class", "d3-tip"), x(this.tip, b), this.chart && this.chart.call(this.tip), this.tip;
            } }, { key: "destroyTipIfExists", value: function() {
              this.tip && this.tip.destroy();
            } }, { key: "truncate", value: function(x, b) {
              x.each(function() {
                for (var A = m.select(this), w = A.text(), O = A.node().getComputedTextLength(), P = A.text(); O > b && P.length > 0; ) P = P.slice(0, -1), A.text("".concat(P, "...")), O = A.node().getComputedTextLength();
                A.append("title").text(w);
              });
            } }, { key: "wrap", value: function(x, b, A) {
              x.each(function() {
                for (var w, O = m.select(this), P = O.text(), E = O.text().split(/\s+/).reverse(), C = [], T = 0, D = 0, z = O.attr("y"), F = parseFloat(O.attr("dy")), W = O.text(null).append("tspan").attr("x", 0).attr("y", z).attr("dy", "".concat(F, "em")); w = E.pop(); ) if (C.push(w), W.text(C.join(" ")), W.node().getComputedTextLength() > b) {
                  if (C.length > 1) {
                    C.pop(), E.push(w);
                    var L = A && ++D === A ? "".concat(C.splice(0, C.length - 1).join(" "), "...") : C.join(" ");
                    W.text(L);
                  }
                  if (C = [], W = O.append("tspan").attr("x", 0).attr("y", z).attr("dy", "".concat(1.1 * ++T + F, "em")), A && A === D) {
                    W.remove();
                    break;
                  }
                }
                O.append("title").text(P);
              });
            } }, { key: "tooltipFactory", value: function(x) {
              return function(b) {
                var A = "";
                if (x !== void 0) for (var w = 0; w < x.length; w += 1) {
                  var O = x[w].accessor(b);
                  x[w].format !== void 0 && (O = x[w].format(O)), A += "".concat(x[w].label, ": ").concat(O, "</br>");
                }
                return A;
              };
            } }, { key: "lineDefaultTooltip", value: function(x, b, A, w, O, P, E) {
              return function(C) {
                var T = "";
                return E(C) && (T = "Series: ".concat(E(C), "</br>")), T += "".concat(x, ": ").concat(b(A(C)), "</br>"), T += "".concat(w, ": ").concat(O(P(C)));
              };
            } }, { key: "donutDefaultTooltip", value: function(x, b, A) {
              return function(w) {
                return "".concat(x(w), ": ").concat(b(w), " (").concat(A(w), ")");
              };
            } }, { key: "dispose", value: function() {
              this.destroyTipIfExists(), this.doResize && window.removeEventListener("resize", this.doResize);
            } }, { key: "formatters", get: function() {
              return { formatSI: function(x) {
                x = x || 0;
                var b = m.format(",.".concat(x, "s"));
                return function(A) {
                  return A < 1 ? A.toFixed(x).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "") : b(A).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "");
                };
              } };
            } }], y = [{ key: "normalizeDataframe", value: function(x) {
              var b = m.keys(x), A = Object.assign({}, x);
              return b.forEach(function(w) {
                x[w] instanceof Array || (A[w] = [x[w]]);
              }), A;
            } }, { key: "dataframeToArray", value: function(x) {
              var b = m.keys(x);
              return x[b[0]] instanceof Array ? x[b[0]].map(function(A, w) {
                var O = {};
                return b.forEach(function(P) {
                  O[P] = x[P][w];
                }), O;
              }) : [x];
            } }, { key: "mapMonthYearDataToSeries", value: function(x, b) {
              var A = Object.assign({}, { dateField: "x", yValue: "y", yPercent: "p" }, b), w = { name: "All Time", values: [] };
              return x[A.dateField].map(function(O, P) {
                w.values.push({ xValue: new Date(Math.floor(x[A.dateField][P] / 100), x[A.dateField][P] % 100 - 1, 1), yValue: x[A.yValue][P], yPercent: x[A.yPercent][P] });
              }), w.values.sort(function(O, P) {
                return O.xValue - P.xValue;
              }), [w];
            } }, { key: "prepareData", value: function(x, b) {
              if (b === this.chartTypes.BOXPLOT) {
                if (!x.CATEGORY.length) return null;
                var A = x.CATEGORY.map(function(w, O) {
                  return { Category: x.CATEGORY[O], min: x.MIN_VALUE[O], max: x.MAX_VALUE[O], median: x.MEDIAN_VALUE[O], LIF: x.P10_VALUE[O], q1: x.P25_VALUE[O], q3: x.P75_VALUE[O], UIF: x.P90_VALUE[O] };
                }, x);
                return Object.values(A).reduce(function(w, O) {
                  return w.concat(O);
                }, []).length ? A : null;
              }
            } }, { key: "chartTypes", get: function() {
              return { AREA: "AREA", BOXPLOT: "BOXPLOT", DONUT: "DONUT", HISTOGRAM: "HISTOGRAM", LINE: "LINE", TRELLISLINE: "TRELLISLINE" };
            } }], k && h(M.prototype, k), y && h(M, y), I;
          }();
          return _;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 535: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(756), u(842)], f = (function(y, x, b) {
          var A = function(w) {
            (function(T, D) {
              if (typeof D != "function" && D !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(D && D.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), D && _(T, D);
            })(C, w);
            var O, P, E = I(C);
            function C() {
              return m(this, C), E.apply(this, arguments);
            }
            return O = C, (P = [{ key: "render", value: function(T, D, z, F, W) {
              var L = this;
              v(k(C.prototype), "render", this).call(this, T, D, z, F, W);
              var S = this.getOptions(W), j = this.createSvg(D, z, F), Y = 0;
              T.forEach(function(ee) {
                Y += +ee.value;
              });
              var N = this.donutDefaultTooltip(function(ee) {
                return ee.label;
              }, function(ee) {
                return x(ee.value).format("0,0");
              }, function(ee) {
                return L.formatters.formatpercent(Y != 0 ? ee.value / Y : 0);
              });
              if (this.useTip(function(ee) {
                return ee.attr("class", "d3-tip").direction("s").offset([3, 0]).html(N);
              }), T.length > 0) {
                var X = j.append("g").attr("id", "chart"), G = y.drag().on("drag", function() {
                  var ee = y.select(this), ce = event.y - parseFloat(ee.attr("initialY"));
                  if (isNaN(ce)) return !1;
                  ee.attr("transform", `translate(
	        `.concat(parseFloat(ee.attr("initialPositionX")), `,
	        `).concat(parseFloat(ee.attr("initialPositionY")) + ce, `
	      )`));
                }).on("start", function() {
                  var ee = y.select(this);
                  ee.attr("initialX", event.x), ee.attr("initialY", event.y);
                }).on("end", function() {
                  var ee = y.select(this);
                  ee.transition().duration(300).attr("transform", `translate(
	          `.concat(ee.attr("initialPositionX"), `,
	          `).concat(ee.attr("initialPositionY"), `
	        )`));
                }), q = j.append("g").attr("class", "legend").call(G);
                q.selectAll("rect").data(T).enter().append("rect").attr("x", 0).attr("y", function(ee, ce) {
                  return 15 * ce;
                }).attr("width", 10).attr("height", 10).style("fill", function(ee) {
                  return S.colors(ee.id);
                });
                var $ = 0, Q = q.selectAll("g.legend-item").data(T).enter().append("g").attr("class", "legend-item");
                Q.append("text").attr("x", 12).attr("y", function(ee, ce) {
                  return 15 * ce + 9;
                }).text(function(ee) {
                  return ee.label;
                }), Q.append("title").attr("x", 12).attr("y", function(ee, ce) {
                  return 15 * ce + 9;
                }).text(function(ee) {
                  return ee.label;
                }), Q.each(function() {
                  var ee = this.getBBox().width;
                  ee > $ && $ + ee < 0.75 * z && ($ = ee);
                }), $ += 12, q.attr("transform", `translate(
	            `.concat(z - $ - S.margins.right, `,
	            `).concat(S.margins.top, `
	          )`)).attr("initialPositionX", z - $ - S.margins.right).attr("initialPositionY", S.margins.top), X.attr("transform", "translate(".concat((z - $) / 2, ", ").concat(F / 2, ")"));
                var V = Math.min(F, z - $) / 2 - S.margins.top, H = Math.min(F, z - $) / 6 - S.margins.top, K = y.arc().innerRadius(H).outerRadius(V), U = y.pie().value(function(ee) {
                  return ee.value > 0 ? Math.max(ee.value, 0.015 * Y) : 0;
                });
                X.selectAll("g.slice").data(U(T)).enter().append("g").attr("class", "slice").append("path").attr("fill", function(ee) {
                  return S.colors(ee.data.id);
                }).attr("stroke", "#fff").attr("stroke-width", 5).attr("title", function(ee) {
                  return ee.label;
                }).on("mouseover", function(ee) {
                  return L.tip.show(ee.data, event.target);
                }).on("mouseout", function(ee) {
                  return L.tip.hide(ee.data, event.target);
                }).attr("d", K);
              } else j.append("text").attr("transform", "translate(".concat(z / 2, ", ").concat(F / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "formatters", get: function() {
              return { formatpercent: y.format(".1%") };
            } }]) && g(O.prototype, P), C;
          }(b);
          return A;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 502: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(756), u(842)], f = (function(y, x, b) {
          var A = function(w) {
            (function(D, z) {
              if (typeof z != "function" && z !== null) throw new TypeError("Super expression must either be null or a function");
              D.prototype = Object.create(z && z.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), z && _(D, z);
            })(T, w);
            var O, P, E, C = I(T);
            function T() {
              return m(this, T), C.apply(this, arguments);
            }
            return O = T, E = [{ key: "mapHistogram", value: function(D) {
              for (var z = [], F = D.OFFSET || 0, W = D.INTERVAL_SIZE, L = this.normalizeDataframe(D.DATA), S = 0; S < D.INTERVALS; S += 1) {
                var j = {};
                j.x = F + 1 * L.INTERVAL_INDEX[S] * W, j.dx = W, j.y = L.COUNT_VALUE[S] || 0, z.push(j);
              }
              return z;
            } }], (P = [{ key: "drawBoxplot", value: function(D, z, F, W) {
              var L = D, S = this.xScale, j = W / 2;
              z.LIF !== z.q1 && (L.append("line").attr("class", "bar").attr("x1", S(z.LIF)).attr("y1", W / 2 - j / 2).attr("x2", S(z.LIF)).attr("y2", W / 2 + j / 2), L.append("line").attr("class", "whisker").attr("x1", S(z.LIF)).attr("y1", W / 2).attr("x2", S(z.q1)).attr("y2", W / 2)), L.append("rect").attr("class", "box").attr("x", S(z.q1)).attr("width", S(z.q3) - S(z.q1)).attr("height", W), L.append("line").attr("class", "median").attr("x1", S(z.median)).attr("y1", 0).attr("x2", S(z.median)).attr("y2", W), z.UIF !== z.q3 && (L.append("line").attr("class", "bar").attr("x1", S(z.UIF)).attr("y1", W / 2 - j / 2).attr("x2", S(z.UIF)).attr("y2", W / 2 + j / 2), L.append("line").attr("class", "whisker").attr("x1", S(z.q3)).attr("y1", W / 2).attr("x2", S(z.UIF)).attr("y2", W / 2));
            } }, { key: "render", value: function(D, z, F, W, L) {
              var S = this;
              v(k(T.prototype), "render", this).call(this, D, z, F, W, L);
              var j = { ticks: 10, yTicks: 4, yScale: y.scaleLinear(), boxplotHeight: 10, getTooltipBuilder: null }, Y = this.getOptions(j, L), N = this.createSvg(z, F, W);
              this.xScale = {};
              var X = D || [], G = typeof Y.getTooltipBuilder == "function" ? Y.getTooltipBuilder(Y) : function(me) {
                return x(me.y).format("0,0");
              };
              this.useTip(function(me) {
                me.attr("class", "d3-tip").offset([-10, 0]).html(G);
              });
              var q = 0, $ = 0;
              if (Y.xLabel) {
                var Q = N.append("g").attr("transform", "translate(".concat(F / 2, ", ").concat(W - Y.margins.bottom, ")"));
                Q.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(Y.xLabel), q = Q.node().getBBox().height;
              }
              if (Y.yLabel) {
                var V = N.append("g").attr("transform", `translate(
	            `.concat(Y.margins.left, `,
	            `).concat((W - Y.margins.bottom - Y.margins.top) / 2 + Y.margins.top, `
	          )`));
                V.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(Y.yLabel), $ = 1.5 * V.node().getBBox().width;
              }
              var H = F - Y.margins.left - Y.margins.right - $, K = W - Y.margins.top - Y.margins.bottom - q, U = this.xScale = y.scaleLinear().domain(Y.xDomain || [y.min(X, function(me) {
                return me.x;
              }), y.max(X, function(me) {
                return me.x + me.dx;
              })]).range([0, H]), ee = y.axisBottom().scale(U).ticks(Y.ticks).tickFormat(Y.xFormat), ce = Y.yScale.domain([0, Y.yMax || y.max(X, function(me) {
                return me.y;
              })]).range([K, 0]), se = y.axisLeft().scale(ce).ticks(Y.yTicks).tickFormat(Y.yFormat), ne = N.append("g").attr("class", "axis");
              ne.call(ee);
              var re = Math.round(ne.node().getBBox().height), Me = Math.round(ne.node().getBBox().width);
              K -= re, H -= Math.max(0, Me - H), ne.remove();
              var Re = N.append("g").attr("class", "axis");
              Re.call(se);
              var oe = Math.round(Re.node().getBBox().width);
              if (H -= oe, Re.remove(), Y.boxplot) {
                K -= 12;
                var de = N.append("g").attr("class", "boxplot").attr("transform", "translate(".concat(Y.margins.left + $ + oe, `,
	          `).concat(Y.margins.top + K + re, ")"));
                this.drawBoxplot(de, Y.boxplot, H, 8);
              }
              U.range([0, H]), ce.range([K, 0]);
              var ue = N.append("g").attr("transform", `translate(
	        `.concat(Y.margins.left + $ + oe, `,
	        `).concat(Y.margins.top, ")"));
              ue.selectAll(".bar").data(X).enter().append("g").attr("class", "bar").attr("transform", function(me) {
                return "translate(".concat(U(me.x), ", ").concat(ce(me.y), ")");
              }).on("mouseover", function(me) {
                return S.tip.show(me, event.target);
              }).on("mouseout", function(me) {
                return S.tip.hide(me, event.target);
              }).append("rect").attr("x", 1).attr("width", function(me) {
                return Math.max(U(me.x + me.dx) - U(me.x) - 1, 0.5);
              }).attr("height", function(me) {
                return K - ce(me.y);
              }), ue.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(K, ")")).call(ee), ue.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(se);
            } }]) && g(O.prototype, P), E && g(O, E), T;
          }(b);
          return A;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 487: (c, l, u) => {
        var d, f;
        function h(k) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
            return typeof y;
          } : function(y) {
            return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
          }, h(k);
        }
        function m(k, y) {
          if (!(k instanceof y)) throw new TypeError("Cannot call a class as a function");
        }
        function g(k, y) {
          for (var x = 0; x < y.length; x++) {
            var b = y[x];
            b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(k, b.key, b);
          }
        }
        function v(k, y) {
          return v = Object.setPrototypeOf || function(x, b) {
            return x.__proto__ = b, x;
          }, v(k, y);
        }
        function _(k) {
          var y = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var x, b = M(k);
            if (y) {
              var A = M(this).constructor;
              x = Reflect.construct(b, arguments, A);
            } else x = b.apply(this, arguments);
            return I(this, x);
          };
        }
        function I(k, y) {
          return !y || h(y) !== "object" && typeof y != "function" ? function(x) {
            if (x === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return x;
          }(k) : y;
        }
        function M(k) {
          return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
            return y.__proto__ || Object.getPrototypeOf(y);
          }, M(k);
        }
        d = [u(680), u(316)], f = (function(k, y) {
          var x = function(b) {
            (function(E, C) {
              if (typeof C != "function" && C !== null) throw new TypeError("Super expression must either be null or a function");
              E.prototype = Object.create(C && C.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), C && v(E, C);
            })(P, b);
            var A, w, O = _(P);
            function P() {
              return m(this, P), O.apply(this, arguments);
            }
            return A = P, (w = [{ key: "render", value: function(E, C, T, D, z) {
              var F = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 4 } }, W = this.getOptions(F, z), L = D < E.length * W.boxHeight ? E.length * W.boxHeight : D, S = this.createSvg(C, T, L), j = W.valueFormatter;
              this.useTip(this.defaultTip, W), E.forEach(function(de) {
                return de.Category = de.Category || "Default";
              });
              var Y = T - W.margins.left - W.margins.right;
              L = L - W.margins.top - W.margins.bottom;
              var N = k.scaleLinear().range([0, Y]).domain([W.xMin || k.min(E, function(de) {
                return de.min;
              }), W.xMax || k.max(E, function(de) {
                return de.max;
              })]).nice(), X = k.scaleBand().range([0, L]).round(1 / E.length).domain(E.map(function(de) {
                return de.Category;
              })), G = k.axisBottom().scale(N).tickFormat(j), q = k.axisLeft().scale(X), $ = k.scaleOrdinal().domain(E.map(function(de) {
                return de.Category;
              })).range(["#ff9315", "#0d61ff", "gold", "blue", "green", "red", "black", "orange", "brown", "grey", "slateblue", "grey1", "darkgreen"]), Q = 0, V = Q;
              if (W.showXAxis) {
                var H = S.append("g").attr("class", "axis");
                H.call(G), Q = Math.round(H.node().getBBox().height) + 2, V = Math.round(H.node().getBBox().width) + 4, L -= Q, Y -= Math.max(0, V - Y), H.remove();
              }
              var K = 0;
              if (W.showYAxis) {
                var U = S.append("g").attr("class", "axis");
                U.call(q), Y -= K = Math.round(U.node().getBBox().width), U.remove();
              }
              var ee = W.boxHeight, ce = X.bandwidth() / 2 - ee / 2, se = ee / 2, ne = se / 10;
              W.showMinMarkers && (Y -= ne > K ? 2 * ne - K : ne), N.range([0, Y]), X.range([L, 0]);
              var re = S.append("g").attr("transform", `translate(
	          `.concat(W.margins.left + Math.max(K, ne), `,
	          `).concat(W.margins.top, `
	        )`)), Me = re.selectAll(".boxplot").data(E).enter().append("g").attr("class", "boxplot").attr("transform", function(de) {
                return "translate(0, ".concat(X(de.Category), ")");
              }), Re = this, oe = k.scaleLinear().range([ee / 2, 0]).domain([0, ee]);
              Me.each(function(de) {
                var ue = de, me = k.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(ce, ")");
                }).append("g").datum(de);
                ue.LIF != ue.q1 && (me.append("line").attr("class", "bar").attr("x1", N(ue.LIF)).attr("y1", oe(1.5 * se)).attr("x2", N(ue.LIF)).attr("y2", oe(0.5 * se)).style("stroke", $(ue.Category)), me.append("line").attr("class", "whisker").attr("x1", N(ue.LIF)).attr("y1", oe(se)).attr("x2", N(ue.q1)).attr("y2", oe(se)).style("stroke", $(ue.Category))), me.append("rect").attr("class", "box").attr("x", N(ue.q1)).attr("y", Math.min(oe(0), oe(ee))).attr("width", Math.max(1, N(ue.q3) - N(ue.q1))).attr("height", Math.abs(oe(0) - oe(ee))).style("fill", $(ue.Category)).style("stroke", $(ue.Category)).style("fill-opacity", 0.4).on("mouseover", function(Z) {
                  return Re.tip.show(Z, event.target);
                }).on("mouseout", function(Z) {
                  return Re.tip.hide(Z, event.target);
                }), me.append("line").attr("class", "median").attr("x1", N(ue.median)).attr("y1", oe(0)).attr("x2", N(ue.median)).attr("y2", oe(ee)).style("stroke", $(ue.Category)), ue.UIF != ue.q3 && (me.append("line").attr("class", "bar").attr("x1", N(ue.UIF)).attr("y1", oe(1.5 * se)).attr("x2", N(ue.UIF)).attr("y2", oe(0.5 * se)).style("stroke", $(ue.Category)), me.append("line").attr("class", "whisker").attr("x1", N(ue.q3)).attr("y1", oe(se)).attr("x2", N(ue.UIF)).attr("y2", oe(se)).style("stroke", $(ue.Category))), W.showMinMarkers && me.append("circle").attr("cx", N(ue.min)).attr("cy", oe(se)).attr("r", ne).style("fill", $(ue.Category)).style("stroke", $(ue.Category)).style("fill-opacity", 0.4), W.showMaxMarkers && me.append("circle").attr("cx", N(ue.max)).attr("cy", oe(se)).attr("r", ne).style("fill", $(ue.Category)).style("stroke", $(ue.Category)).style("fill-opacity", 0.4);
              }), W.showXAxis && re.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(L, ")")).call(G), W.showYAxis && re.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(q).selectAll(".tick text").call(this.wrap, X.bandwidth() || X.range()).selectAll(".tick text tspan").attr("x", -9);
            } }]) && g(A.prototype, w), P;
          }(y);
          return x;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 557: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(T, D) {
              if (typeof D != "function" && D !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(D && D.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), D && _(T, D);
            })(C, A);
            var w, O, P, E = I(C);
            function C() {
              return m(this, C), E.apply(this, arguments);
            }
            return w = C, P = [{ key: "convertData", value: function(T) {
              return T[0].hasOwnProperty("values") || (T = [{ name: "", values: T }]), T;
            } }, { key: "getMinValue", value: function(T, D) {
              return y.min(T, function(z) {
                return y.min(z.values, function(F) {
                  return F[D];
                });
              });
            } }, { key: "getMaxValue", value: function(T, D) {
              return y.max(T, function(z) {
                return y.max(z.values, function(F) {
                  return F[D];
                });
              });
            } }, { key: "getZeroBasedY", value: function(T) {
              var D = T.data, z = T.yValue, F = T.height, W = C.getMaxValue(D, z);
              return y.scaleLinear().domain([0, W]).range([F, 0]);
            } }, { key: "getRelativeY", value: function(T) {
              var D = T.data, z = T.yValue, F = z === void 0 ? "yValue" : z, W = T.height, L = T.yRangePadding, S = L === void 0 ? 0.1 : L, j = T.defaultYRangePadding, Y = j === void 0 ? 10 : j;
              D = C.convertData(D);
              var N = C.getMinValue(D, F), X = C.getMaxValue(D, F), G = (X - N) * S || Y;
              return y.scaleLinear().domain([N - G, X + G]).range([W, 0]);
            } }], (O = [{ key: "render", value: function(T, D, z, F, W) {
              v(k(C.prototype), "render", this).call(this, T, D, z, F, W), typeof D == "string" && (D = document.querySelector(D));
              var L = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: this.interpolation.linear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, getTooltipBuilder: null }, S = this.getOptions(L, W), j = this.createSvg(D, z, F), Y = typeof S.getTooltipBuilder == "function" ? S.getTooltipBuilder(S) : this.lineDefaultTooltip(S.xLabel || "x", S.xFormat, function(J) {
                return J[S.xValue];
              }, S.yLabel || "y", S.yFormat, function(J) {
                return J[S.yValue];
              }, function(J) {
                return J[S.seriesName];
              });
              if (T.length > 0) {
                T = C.convertData(T), this.useTip(function(J) {
                  J.attr("class", "d3-tip").offset([-10, 0]).html(Y);
                });
                var N = 0, X = 0;
                if (S.xLabel) {
                  var G = j.append("g").attr("transform", "translate(".concat(z / 2, ", ").concat(F - S.margins.bottom, ")"));
                  G.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(S.xLabel), N += G.node().getBBox().height;
                }
                if (S.yLabel) {
                  var q = j.append("g").attr("transform", `translate(
	              `.concat(S.margins.left, `,
	              `).concat((F - S.margins.bottom - S.margins.top) / 2 + S.margins.top, `
	            )`));
                  q.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(S.yLabel), X = 1.2 * q.node().getBBox().width;
                }
                var $ = 0;
                if (S.showLegend) {
                  var Q = j.append("g").attr("class", "legend"), V = 0;
                  T.forEach(function(J, ae) {
                    Q.append("rect").attr("x", 0).attr("y", 15 * ae).attr("width", 10).attr("height", 10).style("fill", S.colors(J.name));
                    var ge = Q.append("text").attr("x", 12).attr("y", 15 * ae + 9).text(J.name);
                    V = Math.max(ge.node().getBBox().width + 12, V);
                  }), Q.attr("transform", `translate(
	          `.concat(z - S.margins.right - V, `,
	          `).concat(S.margins.top, `
	        )`)), ($ += V + 5) > z / 3 && Q.style("display", "none");
                }
                var H = z - S.margins.left - S.margins.right - X - ($ > z / 5 ? 0 : $), K = F - S.margins.top - S.margins.bottom - N, U = S.xScale || y.scaleLinear().domain([y.min(T, function(J) {
                  return y.min(J.values, function(ae) {
                    return ae[S.xValue];
                  });
                }), y.max(T, function(J) {
                  return y.max(J.values, function(ae) {
                    return ae[S.xValue];
                  });
                })]), ee = y.axisBottom().scale(U).ticks(S.ticks);
                S.tickFormat ? ee.tickFormat(S.tickFormat) : ee.tickFormat(S.xFormat), typeof U.rangePoints == "function" ? U.rangePoints([0, H]) : U.range([0, H]);
                var ce = S.yScale || C.getZeroBasedY({ data: T, height: K, yValue: S.yValue }), se = y.axisLeft().scale(ce).tickFormat(S.yFormat).ticks(S.yTicks), ne = j.append("g").attr("class", "axis");
                ne.call(ee);
                var re = Math.round(ne.node().getBBox().height), Me = Math.round(ne.node().getBBox().width);
                K -= re, H -= Math.max(0, Me - H), ne.remove();
                var Re = S.yAxisWidth;
                if (S.yAxisWidth == null) {
                  var oe = j.append("g").attr("class", "axis");
                  oe.call(se), Re = Math.round(oe.node().getBBox().width), oe.remove();
                }
                H -= Re, typeof U.rangePoints == "function" ? U.rangePoints([0, H]) : U.range([0, H]), ce.range([K, 0]);
                var de = y.line().x(function(J) {
                  return U(J[S.xValue]);
                }).y(function(J) {
                  return ce(J[S.yValue]);
                }).curve(S.interpolate), ue = j.append("g").attr("class", S.cssClass).attr("transform", `translate(
	            `.concat(S.margins.left + X + Re, `,
	            `).concat(S.margins.top, `
	          )`)), me = ue.selectAll(".series").data(T).enter().append("g"), Z = me.append("path").attr("class", "line").attr("d", function(J) {
                  return de(J.values.sort(function(ae, ge) {
                    return y.ascending(ae[S.xValue], ge[S.xValue]);
                  }));
                });
                S.colors && Z.style("stroke", function(J, ae) {
                  return S.colors(J.name);
                }), S.showSeriesLabel && me.append("text").datum(function(J) {
                  return { name: J.name, value: J.values[J.values.length - 1] };
                }).attr("transform", function(J) {
                  return "translate(".concat(U(J.value[S.xValue]), ", ").concat(ce(J.value[S.yValue]), ")");
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(J) {
                  return J.name;
                });
                var le = { x: 0, y: 0 };
                ue.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(K, ")")).call(ee), ue.append("g").attr("class", "y axis").call(se), S.labelIndexDate && ue.append("rect").attr("transform", "translate(".concat(le.x - 0.5, ", ").concat(le.y, ")")).attr("width", 1).attr("height", K), this.appendTracker({ vis: ue, data: T, width: H, height: K, x: U, y: ce, options: S });
              } else j.append("text").attr("transform", "translate(".concat(z / 2, ", ").concat(F / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "appendTracker", value: function(T) {
              var D = this, z = T.vis, F = T.data, W = T.width, L = T.height, S = T.x, j = T.y, Y = T.options, N = z.append("g").attr("class", "current-focus").style("display", "none"), X = N.append("line").attr("class", "x-hover-line").style("stroke-width", "2px").style("stroke-dasharray", "3,3").attr("y1", 0), G = N.append("circle").attr("r", 2), q = z.append("rect").style("opacity", 0), $ = y.quadtree().x(function(V) {
                return S(V[Y.xValue]);
              }).y(function(V) {
                return j(V[Y.yValue]);
              }), Q = F.reduce(function(V, H) {
                return V.concat(H.values.map(function(K) {
                  return K.name = H.name, K;
                }));
              }, []);
              $.addAll(Q), q.attr("class", "overlay").attr("width", W).attr("height", L).attr("pointer-events", "all").on("mouseover", function() {
                return N.style("display", null);
              }).on("mouseout", function() {
                N.style("display", "none"), D.tip.hide({}, N.node());
              }), q.on("mousemove", function() {
                var V = y.event, H = y.mouse(V.target), K = $.find(H[0], H[1]);
                G.style("fill", Y.colors(K.name)), X.style("stroke", Y.colors(K.name)), X.attr("y2", L - j(K[Y.yValue])), N.attr("transform", "translate(" + S(K[Y.xValue]) + "," + j(K[Y.yValue]) + ")"), D.tip.show(K, N.node());
              });
            } }, { key: "interpolation", get: function() {
              return { linear: y.curveLinear, curveStep: y.curveStep, curveStepBefore: y.curveStepBefore, curveStepAfter: y.curveStepAfter, curveBasis: y.curveBasis, curveCardinal: y.curveCardinal, curveMonotoneX: y.curveMonotoneX, curveCatmullRom: y.curveCatmullRom };
            } }]) && g(w.prototype, O), P && g(w, P), C;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 76: (c, l, u) => {
        var d;
        c = u.nmd(c), d = (function(f) {
          var h = { version: "0.0.1" }, m = u(842), g = u(648), v = u(605), _ = u(131), I = u(316), M = u(535), k = u(502), y = u(487), x = u(557), b = u(775), A = u(312), w = u(345), O = u(255), P = u(587), E = u(132);
          return h.chart = m, h.aster = g, h.areachart = v, h.barchart = _, h.boxplot = I, h.donut = M, h.histogram = k, h.horizontalBoxplot = y, h.line = x, h.trellisline = b, h.treemap = A, h.scatterplot = w, h.splitBoxplot = O, h.sunburst = P, h.util = E, h;
        }).call(l, u, l, c), d === void 0 || (c.exports = d);
      }, 345: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && _(C, T);
            })(E, A);
            var w, O, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return w = E, (O = [{ key: "render", value: function(C, T, D, z, F) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, F);
              var W = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: y.curveLinear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, truncateLabelAtLine: 2, showXAxis: !0, tooltip: function(Z) {
                return "<div>Series: ".concat(Z.seriesName, `</div>
					<div>X: `).concat(Z[L.xValue], `</div>
					<div>Y: `).concat(Z[L.yValue], `</div>
					`);
              }, circleRadius: 1, addDiagonal: !1, diagonalColor: "#ccc" }, L = this.getOptions(W, F);
              F.colors ? L.colors = y.scaleOrdinal(Object.values(F.colors)).domain(Object.keys(F.colors)) : L.colors = y.scaleOrdinal(y.schemeCategory20).domain(C.map(function(Z) {
                return Z.name;
              }));
              var S = this.createSvg(T, D, z);
              if (C.length > 0) {
                C[0].hasOwnProperty("values") || (C = [{ name: "", values: C }]), this.useTip(function(Z) {
                  Z.attr("class", "d3-tip").offset([-10, 0]).html(L.tooltip);
                });
                var j, Y, N = 0, X = 0;
                L.xLabel && ((j = S.append("g")).append("text").attr("class", "axislabel").attr("dy", 0).attr("y", 0).style("text-anchor", "middle").text(L.xLabel), N += j.node().getBBox().height), L.yLabel && ((Y = S.append("g")).append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(L.yLabel), X = 1.5 * Y.node().getBBox().width);
                var G = 0;
                if (L.showLegend) {
                  var q = S.append("g").attr("class", "legend"), $ = 0;
                  C.forEach(function(Z, le) {
                    q.append("rect").attr("x", 0).attr("y", 15 * le).attr("width", 10).attr("height", 10).style("fill", L.colors(Z.name));
                    var J = q.append("text").attr("x", 12).attr("y", 15 * le + 9).text(Z.name);
                    $ = Math.max(J.node().getBBox().width + 12, $);
                  }), q.attr("transform", "translate(" + (D - L.margins.right - $) + ",0)"), G += $ + 5;
                }
                var Q = D - L.margins.left - L.margins.right - X - G, V = z - L.margins.top - L.margins.bottom - N, H = L.xScale || y.scaleLinear().domain([y.min(C, function(Z) {
                  return y.min(Z.values, function(le) {
                    return le[L.xValue];
                  });
                }), y.max(C, function(Z) {
                  return y.max(Z.values, function(le) {
                    return le[L.xValue];
                  });
                })]), K = y.axisBottom().scale(H).ticks(L.ticks);
                L.tickFormat ? K.tickFormat(L.tickFormat) : K.tickFormat(L.xFormat), typeof H.rangePoints == "function" ? H.rangePoints([0, Q]) : H.range([0, Q]);
                var U = L.yScale || y.scaleLinear().domain([0, y.max(C, function(Z) {
                  return y.max(Z.values, function(le) {
                    return le[L.yValue];
                  });
                })]).range([V, 0]), ee = y.axisLeft().scale(U).tickFormat(L.yFormat).ticks(L.yTicks), ce = S.append("g").attr("class", "axis");
                ce.call(K);
                var se = Math.round(ce.node().getBBox().height), ne = Math.round(ce.node().getBBox().width);
                V -= se, Q -= Math.max(0, ne - Q), ce.remove();
                var re = S.append("g").attr("class", "axis");
                re.call(ee);
                var Me = Math.round(re.node().getBBox().width);
                if (Q -= Me, re.remove(), L.xLabel && j) {
                  j.selectAll("text").call(this.wrap, Q, L.truncateLabelAtLine);
                  var Re = j.node().getBBox().height;
                  V -= Re, j.attr("transform", `translate(
								`.concat(X + Me + L.margins.left + Q / 2, `,
								`).concat(z - L.margins.bottom - Re, `
							)`));
                }
                L.yLabel && Y && (Y.attr("transform", `translate(
							`.concat(L.margins.left, `,
							`).concat(L.margins.bottom + V / 2, `
						)`)).selectAll("text").call(this.wrap, V, L.truncateLabelAtLine), X = Y.node().getBBox().width), typeof H.rangePoints == "function" ? H.rangePoints([0, Q]) : H.range([0, Q]), U.range([V, 0]);
                var oe = S.append("g").attr("class", L.cssClass).attr("transform", "translate(" + (L.margins.left + X + Me) + "," + L.margins.top + ")"), de = oe.selectAll(".series").data(C).enter().append("g");
                de.selectAll(".dot").data(function(Z) {
                  return Z.values.map(function(le) {
                    return Object.assign({}, le, { seriesName: Z.name });
                  });
                }).enter().append("circle").attr("class", "dot").attr("r", L.circleRadius).style("fill", function(Z, le) {
                  return L.colors(Z.seriesName);
                }).attr("transform", function(Z) {
                  return "translate(" + H(Z[L.xValue]) + "," + U(Z[L.yValue]) + ")";
                }), L.addDiagonal && de.append("line").attr("x1", 0).attr("y1", V).attr("x2", Q).attr("y2", 0).attr("stroke-width", 1).attr("stroke", L.diagonalColor).attr("stroke-dasharray", "5,5"), L.showSeriesLabel && de.append("text").datum(function(Z) {
                  return { name: Z.name, value: Z.values[Z.values.length - 1] };
                }).attr("transform", function(Z) {
                  return "translate(" + H(Z.value[L.xValue]) + "," + U(Z.value[L.yValue]) + ")";
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(Z) {
                  return Z.name;
                });
                var ue = { x: 0, y: 0 }, me = this;
                de.selectAll(".focus").data(function(Z) {
                  return Z.values.map(function(le) {
                    return Object.assign({}, le, { seriesName: Z.name });
                  });
                }).enter().append("circle").attr("class", "focus").attr("r", L.circleRadius).attr("transform", function(Z) {
                  var le = H(Z[L.xValue]), J = U(Z[L.yValue]);
                  return Z[L.xValue] === 0 && ue.y === 0 && (ue.x = le, ue.y = J), "translate(" + le + "," + J + ")";
                }).on("mouseover", function(Z) {
                  y.select(this).style("opacity", "1").style("stroke", L.colors(Z.seriesName)).style("stroke-width", L.circleRadius / 2), me.tip.show(Z, event.target);
                }).on("mouseout", function(Z) {
                  y.select(this).style("opacity", "0"), me.tip.hide(Z, event.target);
                }), L.showXAxis && oe.append("g").attr("class", "x axis").attr("transform", "translate(0," + V + ")").call(K), oe.append("g").attr("class", "y axis").call(ee), L.labelIndexDate && oe.append("rect").attr("transform", function() {
                  return "translate(" + (ue.x - 0.5) + "," + ue.y + ")";
                }).attr("width", 1).attr("height", V);
              } else S.append("text").attr("transform", "translate(" + D / 2 + "," + z / 2 + ")").style("text-anchor", "middle").text("No Data");
            } }]) && g(w.prototype, O), E;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 255: (c, l, u) => {
        var d, f;
        function h(k) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
            return typeof y;
          } : function(y) {
            return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
          }, h(k);
        }
        function m(k, y) {
          if (!(k instanceof y)) throw new TypeError("Cannot call a class as a function");
        }
        function g(k, y) {
          for (var x = 0; x < y.length; x++) {
            var b = y[x];
            b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(k, b.key, b);
          }
        }
        function v(k, y) {
          return v = Object.setPrototypeOf || function(x, b) {
            return x.__proto__ = b, x;
          }, v(k, y);
        }
        function _(k) {
          var y = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var x, b = M(k);
            if (y) {
              var A = M(this).constructor;
              x = Reflect.construct(b, arguments, A);
            } else x = b.apply(this, arguments);
            return I(this, x);
          };
        }
        function I(k, y) {
          return !y || h(y) !== "object" && typeof y != "function" ? function(x) {
            if (x === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return x;
          }(k) : y;
        }
        function M(k) {
          return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
            return y.__proto__ || Object.getPrototypeOf(y);
          }, M(k);
        }
        d = [u(680), u(316)], f = (function(k, y) {
          var x = function(b) {
            (function(E, C) {
              if (typeof C != "function" && C !== null) throw new TypeError("Super expression must either be null or a function");
              E.prototype = Object.create(C && C.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), C && v(E, C);
            })(P, b);
            var A, w, O = _(P);
            function P() {
              return m(this, P), O.apply(this, arguments);
            }
            return A = P, (w = [{ key: "render", value: function(E, C, T, D, z) {
              var F = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 0 } }, W = this.getOptions(F, z), L = this.createSvg(C, T, D), S = W.valueFormatter;
              this.useTip(this.defaultTip, W), E.forEach(function(Z) {
                return Z.Category = Z.Category || "Default";
              });
              var j = T - W.margins.left - W.margins.right, Y = D - W.margins.top - W.margins.bottom, N = k.scaleLinear().range([0, j]).domain([W.xMin || k.min(E, function(Z) {
                return Math.min(Z.target.min, Z.compare.min);
              }), W.xMax || k.max(E, function(Z) {
                return Math.max(Z.target.max, Z.compare.max);
              })]), X = k.scaleBand().range([0, Y]).round(1 / E.length).domain(E.map(function(Z) {
                return Z.Category;
              })), G = k.axisBottom().scale(N).tickFormat(S).ticks(5), q = k.axisLeft().scale(X), $ = 0, Q = $;
              if (W.showXAxis) {
                var V = L.append("g").attr("class", "axis");
                V.call(G), $ = Math.round(V.node().getBBox().height) + 2, Q = Math.round(V.node().getBBox().width) + 4, Y -= $, j -= Math.max(0, Q - j), V.remove();
              }
              var H = 0;
              if (W.showYAxis) {
                var K = L.append("g").attr("class", "axis");
                K.call(q), j -= H = Math.round(K.node().getBBox().width), K.remove();
              }
              var U = W.boxHeight, ee = X.bandwidth() / 2 - U / 2, ce = U / 2, se = ce / 10;
              W.showMinMarkers && (j -= se > H ? 2 * se - H : se), N.range([0, j]), X.range([Y, 0]);
              var ne = L.append("g").attr("transform", `translate(
	          `.concat(W.margins.left + Math.max(H, se), `,
	          `).concat(W.margins.top, `
	        )`));
              if (W.showLegend) {
                var re = L.append("g").attr("class", "legend"), Me = re.append("g"), Re = re.append("g");
                Me.append("rect").attr("x", 0).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "target"), Me.append("text").attr("x", 15).attr("y", 9).text("Target"), Re.append("rect").attr("x", Me.node().getBBox().width + 10).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "compare"), Re.append("text").attr("x", Me.node().getBBox().width + 25).attr("y", 9).text("Compare"), re.attr("transform", `translate(
					`.concat((T - re.node().getBBox().width) / 2, `,
					0
				)`));
              }
              var oe = ne.selectAll(".boxplot").data(E).enter().append("g").attr("class", "boxplot").attr("transform", function(Z) {
                return "translate(0, ".concat(X(Z.Category), ")");
              }), de = this, ue = k.scaleLinear().range([U / 2, 0]).domain([0, U]), me = k.scaleLinear().range([0, U / 2]).domain([0, U]);
              X.bandwidth(), oe.each(function(Z) {
                var le = k.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(ee, ")");
                }), J = le.append("g").datum(Z.target).attr("class", "target"), ae = le.append("g").datum(Z.compare).attr("class", "compare").attr("transform", function() {
                  return "translate(0, ".concat(U / 2 + 2, ")");
                });
                [{ boxPlotData: Z.target, boxplot: J, boxScale: ue }, { boxPlotData: Z.compare, boxplot: ae, boxScale: me, tipDirection: "s", tipOffset: [10, 0] }].forEach(function(ge) {
                  var be = ge.boxPlotData, we = ge.boxplot, We = ge.boxScale;
                  be.LIF != be.q1 && (we.append("line").attr("class", "bar").attr("x1", N(be.LIF)).attr("y1", We(0)).attr("x2", N(be.LIF)).attr("y2", We(ce)), we.append("line").attr("class", "whisker").attr("x1", N(be.LIF)).attr("y1", We(0)).attr("x2", N(be.q1)).attr("y2", We(0))), we.append("rect").attr("class", "box").attr("x", N(be.q1)).attr("y", Math.min(We(0), We(U))).attr("width", Math.max(1, N(be.q3) - N(be.q1))).attr("height", Math.abs(We(0) - We(U))).on("mouseover", function(ie) {
                    return de.tip.show(Object.assign({}, ie, { tipDirection: ge.tipDirection, tipOffset: ge.tipOffset }), event.target);
                  }).on("mouseout", function(ie) {
                    return de.tip.hide(ie, event.target);
                  }), we.append("line").attr("class", "median").attr("x1", N(be.median)).attr("y1", We(0)).attr("x2", N(be.median)).attr("y2", We(U)), be.UIF != be.q3 && (we.append("line").attr("class", "bar").attr("x1", N(be.UIF)).attr("y1", We(0)).attr("x2", N(be.UIF)).attr("y2", We(ce)), we.append("line").attr("class", "whisker").attr("x1", N(be.q3)).attr("y1", We(0)).attr("x2", N(be.UIF)).attr("y2", We(0))), W.showMinMarkers && we.append("circle").attr("cx", N(be.min)).attr("cy", We(ce / 2)).attr("r", se), W.showMaxMarkers && we.append("circle").attr("cx", N(be.max)).attr("cy", We(ce / 2)).attr("r", se);
                });
              }), W.showXAxis && ne.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Y, ")")).call(G), W.showYAxis && ne.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(q).selectAll(".tick text").call(this.wrap, X.bandwidth() || X.range());
            } }]) && g(A.prototype, w), P;
          }(y);
          return x;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 587: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && _(C, T);
            })(E, A);
            var w, O, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return w = E, (O = [{ key: "getTipDirection", value: function(C) {
              return "n";
            } }, { key: "getTipOffset", value: function(C, T) {
              var D = event.target.getBBox(), z = T.centroid(C), F = Math.abs(D.x - z[0]) - D.width / 2;
              return [Math.abs(D.y - z[1]) - 10, F];
            } }, { key: "render", value: function(C, T, D, z, F) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, F);
              var W = this.getOptions({ tooltip: function($) {
                return "<div>No Tooltip Set</div>";
              }, minRadians: 5e-3 }, F), L = this.createSvg(T, D, z);
              L.attr("class", "sunburst"), this.useTip(function($, Q) {
                $.attr("class", "d3-tip ".concat(Q.tipClass || "")).offset(function(V) {
                  return V.tipOffset || [-10, 0];
                }).direction(function(V) {
                  return V.tipDirection || "n";
                }).html(function(V) {
                  return Q.tooltip(V);
                });
              }, W);
              var S = L.append("svg:g").attr("transform", "translate(" + D / 2 + "," + z / 2 + ")"), j = Math.min(D, z) / 2, Y = y.partition().size([2 * Math.PI, j]), N = y.arc().startAngle(function($) {
                return $.x0;
              }).endAngle(function($) {
                return $.x1;
              }).innerRadius(function($) {
                return $.y0;
              }).outerRadius(function($) {
                return $.y1;
              });
              S.append("svg:circle").attr("r", j).style("opacity", 0);
              var X = Y(y.hierarchy(C).sum(function($) {
                return $.size;
              }).sort(function($, Q) {
                return Q.value - $.value;
              })).descendants().filter(function($) {
                return $.x1 - $.x0 > W.minRadians;
              }).reverse();
              if (W.split) {
                var G = X.reduce(function($, Q) {
                  var V = W.split(Q);
                  return V.length > 1 && (Q.isSplit = !0, $ = $.concat(V.map(function(H) {
                    return Object.assign(H, { isPartialNode: !0 });
                  }))), $;
                }, []);
                S.data([C]).selectAll("partialnode").data(G).enter().append("svg:path").attr("d", N).attr("fill-rule", "evenodd").attr("class", "partial").style("fill", function($) {
                  return W.colors($.data.name);
                });
              }
              var q = this;
              S.data([C]).selectAll("pathnode").data(X).enter().append("svg:path").attr("display", function($) {
                return $.depth ? null : "none";
              }).attr("d", N).attr("fill-rule", "evenodd").attr("class", function($) {
                return W.nodeClass && W.nodeClass($) || "node";
              }).style("fill", function($) {
                return $.isSplit ? "#000" : W.colors($.data.name);
              }).style("opacity", function($) {
                return $.isSplit ? 0 : 1;
              }).on("mouseover", function($) {
                return q.tip.show(Object.assign({}, $, { tipDirection: q.getTipDirection($), tipOffset: q.getTipOffset($, N) }), event.target);
              }).on("mouseout", function($) {
                return q.tip.hide($, event.target);
              }).on("click", function($) {
                return W.onclick && W.onclick($);
              });
            } }]) && g(w.prototype, O), E;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 312: (c, l, u) => {
        var d, f;
        function h(k) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
            return typeof y;
          } : function(y) {
            return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
          }, h(k);
        }
        function m(k, y) {
          if (!(k instanceof y)) throw new TypeError("Cannot call a class as a function");
        }
        function g(k, y) {
          for (var x = 0; x < y.length; x++) {
            var b = y[x];
            b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(k, b.key, b);
          }
        }
        function v(k, y) {
          return v = Object.setPrototypeOf || function(x, b) {
            return x.__proto__ = b, x;
          }, v(k, y);
        }
        function _(k) {
          var y = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var x, b = M(k);
            if (y) {
              var A = M(this).constructor;
              x = Reflect.construct(b, arguments, A);
            } else x = b.apply(this, arguments);
            return I(this, x);
          };
        }
        function I(k, y) {
          return !y || h(y) !== "object" && typeof y != "function" ? function(x) {
            if (x === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return x;
          }(k) : y;
        }
        function M(k) {
          return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
            return y.__proto__ || Object.getPrototypeOf(y);
          }, M(k);
        }
        d = [u(680), u(842)], f = (function(k, y) {
          var x = function(b) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && v(C, T);
            })(E, b);
            var A, w, O, P = _(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return A = E, w = [{ key: "render", value: function(C, T, D, z, F) {
              var W = this, L = this.getOptions(F), S = this.createSvg(T, D, z), j = k.scaleLinear().range([0, D]), Y = k.scaleLinear().range([0, z]);
              k.select(T).select(".treemap_zoomtarget").text("");
              var N = 0, X = k.treemap().round(!1).size([D, z]), G = k.hierarchy(C, function(ne) {
                return ne.children;
              }).sum(L.getsizevalue), q = X(G);
              function $(ne) {
                var re = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], Me = D / (ne.x1 - ne.x0) || D, Re = z / (ne.y1 - ne.y0) || z;
                ne.x1 && ne.y1 ? (j.domain([ne.x0, ne.x0 + (ne.x1 - ne.x0)]), Y.domain([ne.y0, ne.y0 + (ne.y1 - ne.y0)])) : (j.domain([0, D]), Y.domain([0, z]));
                var oe = k.select(T).select(".treemap_zoomtarget");
                if (oe.size()) if (ne.data.name === "root") oe.text("");
                else {
                  var de = oe.text();
                  oe.text("".concat(de, " > ").concat(ne.data.name));
                }
                var ue = S.selectAll("g.cell, .grouper");
                re && (ue = ue.transition().duration(750)), ue.attr("transform", function(me) {
                  return "translate(".concat(j(me.x0), ", ").concat(Y(me.y0), ")");
                }).on("end", function() {
                  S.selectAll(".grouper").attr("display", "block");
                }), ue.select("rect").attr("width", function(me) {
                  return Math.max(0, Me * (me.x1 - me.x0) - 1);
                }).attr("height", function(me) {
                  return Math.max(0, Re * (me.y1 - me.y0) - 1);
                }), event && event.stopPropagation(), L.onZoom && L.onZoom(ne);
              }
              function Q(ne) {
                var re = D / (ne.x1 - ne.x0), Me = z / (ne.y1 - ne.y0), Re = q.children.filter(function(oe) {
                  return oe.parent === ne;
                });
                S.selectAll(".grouper").remove(), S.selectAll(".grouper").data(Re).enter().append("g").attr("class", "grouper").attr("transform", function(oe) {
                  return "translate(".concat(oe.x0 + 1, ", ").concat(oe.y0 + 1, ")");
                }).attr("display", "none").append("rect").attr("width", function(oe) {
                  return Math.max(0, re * (oe.x1 - oe.x0) - 1);
                }).attr("height", function(oe) {
                  return Math.max(0, Me * (oe.y1 - oe.y0) - 1);
                }).attr("title", function(oe) {
                  return oe.name;
                }).attr("id", function(oe) {
                  return oe.id;
                });
              }
              var V, H = q.leaves().filter(function(ne) {
                return L.getsizevalue(ne.data);
              }), K = k.extent(H, function(ne) {
                return L.getcolorvalue(ne.data);
              }), U = k.median(H, function(ne) {
                return L.getcolorvalue(ne.data);
              });
              V = L.getcolorrange ? L.getcolorrange() : ["#E4FF7A", "#FC7F00"];
              var ee = [K[0], U, K[1]];
              L.getcolorscale && (ee = L.getcolorscale());
              var ce = k.scaleLinear().domain(ee).range(V), se = S.selectAll("g").data(H).enter().append("g").attr("class", "cell").attr("transform", function(ne) {
                return "translate(".concat(ne.x0, ", ").concat(ne.y0, ")");
              });
              se.append("rect").attr("width", function(ne) {
                return Math.max(0, ne.x1 - ne.x0 - 1);
              }).attr("height", function(ne) {
                return Math.max(0, ne.y1 - ne.y0 - 1);
              }).attr("id", function(ne) {
                return ne.id;
              }).style("fill", function(ne) {
                return ce(L.getcolorvalue(ne.data));
              }).on("click", function(ne) {
                if (L.useTip && W.tip.hide(), event.altKey) $(G), Q(G);
                else if (event.ctrlKey) {
                  for (var re = ne; re.depth !== N + 1; ) re = re.parent;
                  N = re.depth, re.children && re.children.length > 1 ? (Q(re), $(re)) : (N = 0, Q(G), $(G));
                } else L.onclick(ne.data);
              }), L.useTip ? (this.useTip(function(ne) {
                ne.attr("class", "d3-tip").direction(function(re) {
                  var Me = j.domain()[1] === 1 ? D : j.domain()[1];
                  return re.x1 >= Me - Me / 10 ? "w" : re.x0 <= Me / 10 ? "e" : "n";
                }).offset([3, 0]).html(function(re) {
                  return "".concat(L.gettitle(re.data), "<br/><br/>").concat(L.getcontent(re.data));
                });
              }), se.on("mouseover", function(ne) {
                return W.tip.show(ne, event.target);
              }).on("mouseout", function(ne) {
                return W.tip.hide(ne, event.target);
              })) : se.attr("data-container", "body").attr("data-toggle", "popover").attr("data-trigger", "hover").attr("data-placement", "top").attr("data-html", !0).attr("data-title", function(ne) {
                return L.gettitle(ne.data);
              }).attr("data-content", function(ne) {
                return L.getcontent(ne.data);
              }), L.initialZoomedConcept ? (Q(L.initialZoomedConcept), $(L.initialZoomedConcept, !1)) : Q(G), S.selectAll(".grouper").attr("display", "block");
            } }, { key: "formatters", get: function() {
              return { format_pct: k.format(".2%"), format_fixed: k.format(".2f"), format_comma: k.format(",") };
            } }], O = [{ key: "buildHierarchyFromJSON", value: function(C, T, D) {
              var z = 0, F = { name: "root", children: [] };
              return C.PERCENT_PERSONS.forEach(function(W) {
                z += W;
              }), C.CONCEPT_PATH.forEach(function(W, L) {
                for (var S = W.split("||"), j = F, Y = function(X) {
                  var G = j.children, q = S[X], $ = void 0;
                  if (X + 1 < S.length) {
                    var Q = !1;
                    G.forEach(function(V) {
                      V.name === q && ($ = V, Q = !0);
                    }), Q || ($ = { name: q, children: [] }, G.push($)), j = $;
                  } else $ = D(q, L, C), C.PERCENT_PERSONS[L] / z > T && G.push($);
                }, N = 0; N < S.length; N += 1) Y(N);
              }), F;
            } }], w && g(A.prototype, w), O && g(A, O), E;
          }(y);
          return x;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 775: (c, l, u) => {
        var d, f;
        function h(y) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, h(y);
        }
        function m(y, x) {
          if (!(y instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function g(y, x) {
          for (var b = 0; b < x.length; b++) {
            var A = x[b];
            A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, A.key, A);
          }
        }
        function v(y, x, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(A, w, O) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(A, w);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, w);
              return E.get ? E.get.call(O) : E.value;
            }
          }, v(y, x, b || y);
        }
        function _(y, x) {
          return _ = Object.setPrototypeOf || function(b, A) {
            return b.__proto__ = A, b;
          }, _(y, x);
        }
        function I(y) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, A = k(y);
            if (x) {
              var w = k(this).constructor;
              b = Reflect.construct(A, arguments, w);
            } else b = A.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(y, x) {
          return !x || h(x) !== "object" && typeof x != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(y) : x;
        }
        function k(y) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, k(y);
        }
        d = [u(680), u(842)], f = (function(y, x) {
          var b = function(A) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && _(C, T);
            })(E, A);
            var w, O, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return w = E, (O = [{ key: "render", value: function(C, T, D, z, F) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, F);
              var W = { trellisSet: y.keys(C), yTicks: 4, xFormat: y.format("d"), yFormat: y.format("d"), interpolate: y.curveLinear }, L = this.getOptions(W, F), S = this.createSvg(T, D, z);
              function j() {
                var _e = oe.invert(y.mouse(event.target)[0]);
                we.selectAll(".g-label-value.g-start").call(Y, _e), we.selectAll(".g-label-year.g-start").call(N, _e), we.selectAll(".g-value").attr("transform", function(Ie) {
                  var Pe = Ie.values;
                  if (Pe) {
                    var Qe = Pe[q(Pe, _e, 0, Pe.length - 1)], et = Qe.Y_PREVALENCE_1000PP === 0 || Qe.Y_PREVALENCE_1000PP ? Qe.Y_PREVALENCE_1000PP : Qe.yPrevalence1000Pp;
                    return Qe && Qe.date ? "translate(" + oe(Qe.date) + "," + de(et) + ")" : "translate(0,0);";
                  }
                });
              }
              function Y(_e, Ie) {
                var Pe = y.scaleLinear().domain(oe.range()), Qe = {};
                _e.each(function(et, _t) {
                  var tr = y.select(this), St = et.values, $t = q(St, Ie, 0, St.length - 1), dn = Math.round($t / (St.length - 1) * (St.length - 12)), mt = St[$t];
                  if (mt && mt.date) {
                    var Bn = oe(mt.date), Dt = mt.Y_PREVALENCE_1000PP === 0 || mt.Y_PREVALENCE_1000PP ? mt.Y_PREVALENCE_1000PP : mt.yPrevalence1000Pp, Pt = Pe.range([0, Re.bandwidth()])(Bn), Ei = de(y.max(St.slice(dn, dn + 12), function(qo) {
                      return Dt;
                    })), Fn = mt.TRELLIS_NAME || mt.trellisName;
                    if (Fn) {
                      !Qe[Fn] && (Qe[Fn] = []);
                      var Wa = mt.date.getTime() === Q.getTime() ? "end" : (mt.date.getTime(), $.getTime(), "start");
                      Qe[Fn].push({ y: Ei, x: Pt, textAnchor: Wa, value: Dt, text: tr, color: L.colors(et.key) });
                    }
                  }
                }), Object.keys(Qe).forEach(function(et) {
                  var _t = Qe[et];
                  _t.sort(function(St, $t) {
                    return St.y - $t.y;
                  }), _t.forEach(function(St, $t) {
                    if ($t > 0) {
                      var dn = _t[$t - 1].y;
                      _t[$t].y += Math.max(0, dn + 15 - _t[$t].y);
                    }
                  });
                  var tr = _t.filter(function(St) {
                    return St.value <= 20;
                  });
                  _t.forEach(function(St) {
                    var $t = St.text, dn = St.x, mt = St.y, Bn = (St.color, St.textAnchor), Dt = St.value;
                    $t.text(L.yFormat(Dt)).style("display", "block").style("text-anchor", Bn).attr("transform", `translate(
	              `.concat(Bn === "start" ? dn + 4 : dn - 4, `,
	              `).concat(Dt <= 20 && tr.length !== 1 ? mt - 20 : mt, `
	            )`));
                  });
                });
              }
              function N(_e, Ie) {
                var Pe = y.scaleLinear().domain(oe.range()), Qe = C[0] && C[0].values[0] && C[0].values[0].values || [], et = Qe[q(Qe, Ie, 0, Qe.length - 1)];
                if (et && et.date) {
                  var _t = oe(et.date);
                  _e.each(function(tr) {
                    y.select(this).text(et.date.getFullYear()).attr("transform", `translate(
	              `.concat(Pe.range([0, Re.bandwidth() - this.getComputedTextLength()])(_t), `,
	              `).concat(Me + 6, `
	              )`)).style("display", null);
                  });
                }
              }
              var X, G, q = y.bisector(function(_e) {
                return _e.date;
              }).left, $ = y.min(C, function(_e) {
                return y.min(_e.values, function(Ie) {
                  return y.min(Ie.values, function(Pe) {
                    return Pe.date;
                  });
                });
              }), Q = y.max(C, function(_e) {
                return y.max(_e.values, function(Ie) {
                  return y.max(Ie.values, function(Pe) {
                    return Pe.date;
                  });
                });
              }), V = y.min(C, function(_e) {
                return y.min(_e.values, function(Ie) {
                  return y.min(Ie.values, function(Pe) {
                    return Pe.Y_PREVALENCE_1000PP === 0 || Pe.Y_PREVALENCE_1000PP ? Pe.Y_PREVALENCE_1000PP : Pe.yPrevalence1000Pp;
                  });
                });
              }), H = y.max(C, function(_e) {
                return y.max(_e.values, function(Ie) {
                  return y.max(Ie.values, function(Pe) {
                    return Pe.Y_PREVALENCE_1000PP === 0 || Pe.Y_PREVALENCE_1000PP ? Pe.Y_PREVALENCE_1000PP : Pe.yPrevalence1000Pp;
                  });
                });
              }), K = 0;
              L.seriesLabel && ((X = S.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(L.seriesLabel), (K = X.node()) && (K = X.node().getBBox().height + 10));
              var U, ee, ce, se = 0;
              L.trellisLabel && ((G = S.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(L.trellisLabel), se = G.node().getBBox().height + 10), (U = S.append("g").attr("class", "g-label-trellis")).append("text").text(L.trellisSet.join("")), ee = U.node().getBBox().height + 10, U.remove();
              var ne = 0;
              L.yLabel && ((ce = S.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").text(L.yLabel), ne = ce.node().getBBox().height + 4);
              var re = D - L.margins.left - ne - L.margins.right, Me = z - L.margins.top - se - ee - K - 2 * L.margins.bottom, Re = y.scaleBand().domain(L.trellisSet).range([0, re]).paddingOuter(0.2).paddingInner(0.25), oe = y.scaleTime().domain([$, Q]).range([0, Re.bandwidth()]), de = y.scaleLinear().domain([V, H]).range([Me, 0]), ue = y.axisLeft().scale(de).tickFormat(L.yFormat).ticks(L.yTicks), me = y.axisBottom().scale(oe), Z = S.append("g").attr("class", "axis");
              Z.call(me);
              var le = Math.round(Z.node().getBBox().height), J = Math.round(Z.node().getBBox().width);
              Me -= le, re -= Math.max(0, J - re), Z.remove();
              var ae = S.append("g").attr("class", "axis");
              ae.call(ue);
              var ge = Math.round(ae.node().getBBox().width);
              re -= ge, ae.remove(), Re.range([0, re]).paddingOuter(0.2).paddingInner(0.25), oe.range([0, Re.bandwidth()]), de.range([Me, 0]), L.trellisLabel && G.attr("transform", `translate(
	        `.concat(re / 2 + L.margins.left, `,
	        `).concat(L.margins.top, `
	      )`)), L.seriesLabel && X.attr("transform", `translate(
	        `.concat(re / 2 + L.margins.left, `,
	        `).concat(se + Me + le + K + 2 * L.margins.top, `
	      )`)), L.yLabel && (ce.attr("transform", `translate(
	        `.concat(L.margins.left, `,
	        `).concat(Me / 2 + se + ee, `
	      )`)), ce.select("text").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em"));
              var be = y.line().x(function(_e) {
                return oe(_e.date);
              }).y(function(_e) {
                return de(_e.Y_PREVALENCE_1000PP === 0 || _e.Y_PREVALENCE_1000PP ? _e.Y_PREVALENCE_1000PP : _e.yPrevalence1000Pp);
              }).curve(L.interpolate), we = y.select(S.node()).append("g").attr("transform", function(_e) {
                return `translate(
	        `.concat(ne + ge + L.margins.left, `,
	        `).concat(se, `
	      )`);
              }).selectAll(".g-trellis").data(Re.domain()).enter().append("g").attr("class", "g-trellis").attr("transform", function(_e) {
                return "translate(".concat(Re(_e), ", ").concat(ee, ")");
              }), We = y.axisBottom().scale(oe).tickFormat("").tickSize(-Me), ie = y.axisLeft().scale(de).tickFormat("").tickSize(-Re.bandwidth()).ticks(8);
              we.append("g").attr("class", "x-guide").attr("transform", "translate(0, ".concat(Me, ")")).call(We), we.append("g").attr("class", "y-guide").call(ie);
              var ve = we.selectAll(".g-series").data(function(_e) {
                var Ie = C.filter(function(Pe) {
                  return Pe.key === _e;
                });
                return Ie.length > 0 ? Ie[0].values : [];
              }).enter().append("g").attr("class", "g-series lineplot");
              ve.append("path").attr("class", "line").attr("d", function(_e) {
                return be(_e.values.sort(function(Ie, Pe) {
                  return y.ascending(Ie.date, Pe.date);
                }));
              }).style("stroke", function(_e) {
                return L.colors(_e.key);
              }), ve.append("circle").attr("class", "g-value").attr("transform", function(_e) {
                var Ie = _e.values;
                if (Ie && Ie[Ie.length - 1] && Ie[Ie.length - 1].date && Ie[Ie.length - 1] && (Ie[Ie.length - 1].Y_PREVALENCE_1000PP || Ie[Ie.length - 1].yPrevalence1000Pp)) {
                  var Pe = Ie[Ie.length - 1].Y_PREVALENCE_1000PP === 0 || Ie[Ie.length - 1].Y_PREVALENCE_1000PP ? Ie[Ie.length - 1].Y_PREVALENCE_1000PP : Ie[Ie.length - 1].yPrevalence1000Pp;
                  return "translate(".concat(oe(Ie[Ie.length - 1].date), ", ").concat(de(Pe), ")");
                }
                return "translate(0, 0)";
              }).attr("r", 2.5).style("display", "none"), ve.append("text").attr("class", "g-label-value g-start").call(Y, $), ve.append("text").attr("class", "g-label-value g-end").call(Y, Q), we.append("text").attr("class", "g-label-year g-start").attr("dy", ".71em").call(N, $), we.append("text").attr("class", "g-label-year g-end").attr("dy", ".71em").call(N, Q), we.append("g").attr("class", "x axis").append("line").attr("x2", Re.bandwidth()).attr("y1", de(V)).attr("y2", de(V)), we.append("g").attr("class", "g-label-trellis").attr("transform", function(_e) {
                return "translate(".concat(Re.bandwidth() / 2, ", 0)");
              }).append("text").attr("dy", "-1em").style("text-anchor", "middle").text(function(_e) {
                return _e;
              }), we.append("rect").attr("class", "g-overlay").attr("x", -4).attr("width", Re.bandwidth() + 8).attr("height", Me + 18).on("mouseover", function() {
                we.selectAll(".g-end").style("display", "none"), we.selectAll(".g-value").style("display", null), j.call(this);
              }).on("mousemove", j).on("mouseout", function() {
                we.selectAll(".g-end").style("display", null), we.selectAll(".g-label-value.g-start").call(Y, $), we.selectAll(".g-label-year.g-start").call(N, $), we.selectAll(".g-label-year.g-end").call(N, Q), we.selectAll(".g-value").style("display", "none");
              }), y.select(we.nodes()[0]).append("g").attr("class", "y axis").attr("transform", "translate(-4,0)").call(ue), S.append("g").attr("transform", "translate(".concat(L.margins.left, ", ").concat(L.margins.top, ")")).call(function(_e) {
                var Ie = 0;
                L.colors.domain().forEach(function(Pe) {
                  var Qe = _e.append("g").attr("class", "trellisLegend"), et = Qe.append("text").text(Pe), _t = Qe.node().getBBox();
                  et.attr("x", 12).attr("y", _t.height), Qe.append("line").attr("x1", 0).attr("y1", 10).attr("x2", 10).attr("y2", 10).style("stroke", function() {
                    return L.colors(Pe);
                  }), Qe.attr("transform", "translate(".concat(Ie, ", 0)")), Ie += Qe.node().getBBox().width + 5;
                });
              });
            } }]) && g(w.prototype, O), E;
          }(x);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 132: (c, l, u) => {
        var d, f;
        d = [u(680)], (f = (function(h) {
          var m = h.format(",.3r");
          return { wrap: function(g, v) {
            g.each(function() {
              for (var _, I = h.select(this), M = I.text().split(/\s+/).reverse(), k = [], y = 0, x = I.attr("y"), b = parseFloat(I.attr("dy")), A = I.text(null).append("tspan").attr("x", 0).attr("y", x).attr("dy", b + "em"); _ = M.pop(); ) k.push(_), A.text(k.join(" ")), A.node().getComputedTextLength() > v && (k.length > 1 && (k.pop(), M.push(_), A.text(k.join(" "))), k = [], y += 1, A = I.append("tspan").attr("x", 0).attr("y", x).attr("dy", 1.1 * y + b + "em"));
            });
          }, formatInteger: function(g) {
            return m(g);
          }, formatSI: function(g) {
            return g = g || 0, function(v) {
              if (v < 1) return h.round(v, g);
              var _ = h.formatPrefix(v);
              return h.round(_.scale(v), g) + _.symbol;
            };
          }, buildHierarchy: function(g, v, _) {
            for (var I = v || function(z) {
              return z[0];
            }, M = _ || function(z) {
              return z[1];
            }, k = { name: "root", children: [] }, y = 0; y < g.length; y++) {
              var x = I(g[y]), b = +M(g[y]);
              if (!isNaN(b)) for (var A = x.split("-"), w = k, O = 0; O < A.length; O++) {
                var P, E = w.children, C = A[O];
                if (O + 1 < A.length) {
                  for (var T = !1, D = 0; D < E.length; D++) if (E[D].name == C && E[D].children) {
                    P = E[D], T = !0;
                    break;
                  }
                  T || (P = { name: C, children: [] }, E.push(P)), w = P;
                } else P = { name: C, size: b }, E.push(P);
              }
            }
            return k;
          } };
        }).apply(l, d)) === void 0 || (c.exports = f);
      }, 383: function(c, l, u) {
        var d, f, h;
        f = [u(680)], d = function(m) {
          return function() {
            var g = b, v = A, _ = w, I = S(), M = null, k = null, y = null;
            function x(G) {
              M = j(G), k = M.createSVGPoint(), document.body.appendChild(I);
            }
            function b() {
              return "n";
            }
            function A() {
              return [0, 0];
            }
            function w() {
              return " ";
            }
            x.show = function() {
              var G = Array.prototype.slice.call(arguments);
              G[G.length - 1] instanceof SVGElement && (y = G.pop());
              var q, $ = _.apply(this, G), Q = v.apply(this, G), V = g.apply(this, G), H = Y(), K = P.length, U = document.documentElement.scrollTop || document.body.scrollTop, ee = document.documentElement.scrollLeft || document.body.scrollLeft;
              for (H.html($).style("opacity", 1).style("pointer-events", "all"); K--; ) H.classed(P[K], !1);
              return q = O.get(V).apply(this), H.classed(V, !0).style("top", q.top + Q[0] + U + "px").style("left", q.left + Q[1] + ee + "px"), x;
            }, x.hide = function() {
              return Y().style("opacity", 0).style("pointer-events", "none"), x;
            }, x.attr = function(G, q) {
              if (arguments.length < 2 && typeof G == "string") return Y().attr(G);
              var $ = Array.prototype.slice.call(arguments);
              return m.selection.prototype.attr.apply(Y(), $), x;
            }, x.style = function(G, q) {
              if (arguments.length < 2 && typeof G == "string") return Y().style(G);
              var $ = Array.prototype.slice.call(arguments);
              return m.selection.prototype.style.apply(Y(), $), x;
            }, x.direction = function(G) {
              return arguments.length ? (g = G == null ? G : X(G), x) : g;
            }, x.offset = function(G) {
              return arguments.length ? (v = G == null ? G : X(G), x) : v;
            }, x.html = function(G) {
              return arguments.length ? (_ = G == null ? G : X(G), x) : _;
            }, x.destroy = function() {
              return I && (Y().remove(), I = null), x;
            };
            var O = m.map({ n: E, s: C, e: T, w: D, nw: z, ne: F, sw: W, se: L }), P = O.keys();
            function E() {
              var G = N();
              return { top: G.n.y - I.offsetHeight, left: G.n.x - I.offsetWidth / 2 };
            }
            function C() {
              var G = N();
              return { top: G.s.y, left: G.s.x - I.offsetWidth / 2 };
            }
            function T() {
              var G = N();
              return { top: G.e.y - I.offsetHeight / 2, left: G.e.x };
            }
            function D() {
              var G = N();
              return { top: G.w.y - I.offsetHeight / 2, left: G.w.x - I.offsetWidth };
            }
            function z() {
              var G = N();
              return { top: G.nw.y - I.offsetHeight, left: G.nw.x - I.offsetWidth };
            }
            function F() {
              var G = N();
              return { top: G.ne.y - I.offsetHeight, left: G.ne.x };
            }
            function W() {
              var G = N();
              return { top: G.sw.y, left: G.sw.x - I.offsetWidth };
            }
            function L() {
              var G = N();
              return { top: G.se.y, left: G.e.x };
            }
            function S() {
              var G = m.select(document.createElement("div"));
              return G.style("position", "absolute").style("top", 0).style("opacity", 0).style("pointer-events", "none").style("box-sizing", "border-box"), G.node();
            }
            function j(G) {
              return (G = G.node()).tagName.toLowerCase() === "svg" ? G : G.ownerSVGElement;
            }
            function Y() {
              return I === null && (I = S(), document.body.appendChild(I)), m.select(I);
            }
            function N() {
              for (var G = y || m.event.target; G.getScreenCTM === void 0 && G.parentNode === "undefined"; ) G = G.parentNode;
              var q = {}, $ = G.getScreenCTM(), Q = G.getBBox(), V = Q.width, H = Q.height, K = Q.x, U = Q.y;
              return k.x = K, k.y = U, q.nw = k.matrixTransform($), k.x += V, q.ne = k.matrixTransform($), k.y += H, q.se = k.matrixTransform($), k.x -= V, q.sw = k.matrixTransform($), k.y -= H / 2, q.w = k.matrixTransform($), k.x += V, q.e = k.matrixTransform($), k.x -= V / 2, k.y -= H / 2, q.n = k.matrixTransform($), k.y += H, q.s = k.matrixTransform($), q;
            }
            function X(G) {
              return typeof G == "function" ? G : function() {
                return G;
              };
            }
            return x;
          };
        }, (h = typeof d == "function" ? d.apply(l, f) : d) === void 0 || (c.exports = h);
      }, 680: (c) => {
        c.exports = n;
      }, 756: (c) => {
        c.exports = i;
      }, 92: (c) => {
        c.exports = r;
      } }, o = {};
      function s(c) {
        if (o[c]) return o[c].exports;
        var l = o[c] = { id: c, loaded: !1, exports: {} };
        return a[c].call(l.exports, l, l.exports, s), l.loaded = !0, l.exports;
      }
      return s.nmd = (c) => (c.paths = [], c.children || (c.children = []), c), s(76);
    })();
  });
})(Uw);
var ir = Uw.exports;
function vU(e, t = "untitled") {
  const { svgBlob: n } = sC(e), r = URL.createObjectURL(n);
  cC(r, t + ".svg");
}
function AU(e, t = "untitled") {
  const { svgBlob: n, width: r, height: i } = sC(e), a = window.URL || window.webkitURL || window, o = a.createObjectURL(n), s = new Image();
  s.onload = function() {
    const c = document.createElement("canvas");
    c.width = r, c.height = i;
    const l = c.getContext("2d");
    l == null || l.drawImage(s, 0, 0, r, i), a.revokeObjectURL(o), c.toBlob((u) => {
      if (!u) {
        console.error("Failed to create chart PNG blob", {
          name: t,
          width: r,
          height: i
        });
        return;
      }
      const d = a.createObjectURL(u);
      cC(d, t + ".png"), window.setTimeout(() => a.revokeObjectURL(d));
    }, "image/png");
  }, s.onerror = function() {
    a.revokeObjectURL(o), console.error("Failed to render chart SVG as PNG", {
      name: t,
      width: r,
      height: i
    });
  }, s.src = o;
}
function sC(e) {
  var s;
  const t = (s = e == null ? void 0 : e.current) == null ? void 0 : s.querySelector("svg");
  if (!t)
    throw new Error("Chart SVG was not found");
  const { width: n, height: r } = bU(t), i = t.cloneNode(!0);
  lC(t, i), i.setAttribute("xmlns", "http://www.w3.org/2000/svg"), i.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), i.setAttribute("width", String(n)), i.setAttribute("height", String(r)), i.getAttribute("viewBox") || i.setAttribute("viewBox", `0 0 ${n} ${r}`), wU(i, n, r);
  const a = new XMLSerializer().serializeToString(i);
  return { svgBlob: new Blob([a], {
    type: "image/svg+xml;charset=utf-8"
  }), width: n, height: r };
}
function bU(e) {
  var i, a, o, s, c, l, u, d;
  const t = e.getBoundingClientRect(), n = t.width || ((a = (i = e.viewBox) == null ? void 0 : i.baseVal) == null ? void 0 : a.width) || ((s = (o = e.width) == null ? void 0 : o.baseVal) == null ? void 0 : s.value) || Number(e.getAttribute("width")) || 0, r = t.height || ((l = (c = e.viewBox) == null ? void 0 : c.baseVal) == null ? void 0 : l.height) || ((d = (u = e.height) == null ? void 0 : u.baseVal) == null ? void 0 : d.value) || Number(e.getAttribute("height")) || 0;
  return {
    width: Math.ceil(n),
    height: Math.ceil(r)
  };
}
function lC(e, t) {
  const n = window.getComputedStyle(e), r = Array.from(n).map((i) => `${i}:${n.getPropertyValue(i)}`).join(";");
  t.setAttribute("style", r), Array.from(e.children).forEach((i, a) => {
    const o = t.children[a];
    o && lC(i, o);
  });
}
function wU(e, t, n) {
  const r = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "rect"
  );
  r.setAttribute("width", String(t)), r.setAttribute("height", String(n)), r.setAttribute("fill", "#fff"), e.insertBefore(r, e.firstChild);
}
function cC(e, t) {
  const n = document.createElement("a");
  n.href = e, n.download = t, document.body.appendChild(n), n.click(), document.body.removeChild(n);
}
const _U = (e) => {
  const { type: t, chartData: n, width: r, height: i, options: a, report: o = {} } = e, [s, c] = Se(null), l = qt(null), u = `${e.fileName ? e.fileName.replace(/[^A-Z0-9]+/gi, "_") + "__" : ""}${t}`, d = (f) => {
    switch (f) {
      case "line":
        return new ir.line();
      case "donut":
        return new ir.donut();
      case "areachart":
        return new ir.areachart();
      case "barchart":
        return new ir.barchart();
      case "treemap":
        return new ir.treemap();
      case "boxplot":
        return new ir.boxplot();
      case "histogram":
        return new ir.histogram();
      case "scatterplot":
        return new ir.scatterplot();
      case "trellisline":
        return new ir.trellisline();
      case "sunburst":
        return new ir.sunburst();
      case "splitBoxplot":
        return new ir.splitBoxplot();
      case "horizontalBoxplot":
        return new ir.horizontalBoxplot();
    }
  };
  return He(() => {
    if (!l) return;
    const f = d(t);
    c(f);
  }, [l]), He(() => {
    if (t === "treeMapCustom")
      return Vt(l.current).selectAll("svg").remove(), EU(n, l.current, a, r, i);
    s && s.render(
      n || [],
      l.current,
      r,
      i,
      a == null ? void 0 : a(s)
    );
  }, [s, n, t, r, i]), /* @__PURE__ */ B(he, { className: "chart-wrapper", sx: { width: r, height: i }, children: [
    /* @__PURE__ */ B(
      sE,
      {
        sx: { position: "absolute", top: 0, right: 0 },
        className: "chart-wrapper_button-group",
        children: [
          /* @__PURE__ */ p(Te, { onClick: () => vU(l, u), size: "small", children: "SVG" }),
          /* @__PURE__ */ p(Te, { onClick: () => AU(l, u), size: "small", children: "PNG" })
        ]
      }
    ),
    /* @__PURE__ */ p(
      he,
      {
        ref: l,
        id: "myChart",
        sx: { width: r, height: i }
      }
    )
  ] });
};
function SU(e) {
  for (var t = 0, n = 0; n < e.length; n++)
    e[n] === "1" && t++;
  return t;
}
function CU(e) {
  var t = SU(e), n = e.length - t;
  return t === e.length ? "#7BB209" : n === e.length ? "#FF3D19" : n === 1 ? "#95B90A" : n === 2 ? "#C9C40D" : n < 5 ? "#E77F13" : "#FF3D19";
}
function EU(e, t, n, r, i) {
  var a = r || 300, o = i || 300;
  bl().range([0, a]), bl().range([0, o]);
  var s = e2().round(!1).size([a, o]), c = cd(e, (h) => h.children).sum((h) => h.size), l = s(c), u = l.leaves().filter((h) => h.data.size), d = Vt(t).append("svg:svg").attr("width", a).attr("height", o).attr("id", "treemap-chart").append("svg:g"), f = d.selectAll("g").data(u).enter().append("svg:g").attr("class", function(h) {
    return "cell";
  }).attr("transform", function(h) {
    return `translate(${h.x0}, ${h.y0})`;
  });
  f.append("svg:rect").attr("width", function(h) {
    return Math.max(0, h.x1 - h.x0 - 1);
  }).attr("height", function(h) {
    return Math.max(0, h.y1 - h.y0 - 1);
  }).attr("class", "rect").attr("id", function(h) {
    return h.data.name;
  }).text(function(h) {
    return h.children ? null : h.data.name;
  }).style("fill", function(h) {
    return n.colorPicker ? n.colorPicker(h.data) : CU(h.data.name);
  }).on("mouseenter", function(h) {
    Vt(this).classed("selected", !0), n.handleCellOver(h.data.name, h.data.size, h);
  }).on("mouseout", function() {
    Vt(this).classed("selected", !1), n.handleCellOut();
  });
}
const gQ = (e) => /* @__PURE__ */ p(zE, { children: ({ height: t, width: n }) => /* @__PURE__ */ p(_U, { ...e, height: t, width: n }) }), yQ = ({ colorPicker: e, calculateRate: t }) => {
  const n = qt(null);
  function r(i, a) {
    if (i.scale.domain().length == 0 || isNaN(i.scale.domain()[0]))
      return;
    let o = 400, s = 40, c = bl().domain(i.scale.domain()).range([0, o - 30]);
    for (var l = Vt(n == null ? void 0 : n.current).append("svg:svg").attr("width", o).attr("height", s).append("svg:g").attr("transform", "translate(15,0)").attr("class", "treeLegend"), u = [], d = i.scale.domain()[1] - i.scale.domain()[0], f = d / i.scale.range().length, h = 0; h < i.scale.range().length; h++)
      u.push(i.scale.domain()[0] + h * f);
    u.push(i.scale.domain()[1]);
    for (var m = l.append("g").attr("transform", "translate(0,0)"), g = 0; g < u.length - 1; g++)
      m.append("rect").attr("x", c(u[g])).attr("width", c(u[g + 1]) - c(u[g]) - 1).attr("height", 20).style(
        "fill",
        i.scale((u[g] + u[g + 1]) / 2)
      );
    var v = t_().scale(c).tickValues(u).tickFormat(function(_) {
      return a.calculateRate(_, 1);
    });
    l.append("g").attr("class", "axis").attr("transform", "translate(0,20)").call(v);
  }
  return He(() => {
    n && (Vt(n.current).selectAll("svg").remove(), r(e, {
      calculateRate: t
    }));
  }, [n]), /* @__PURE__ */ p(he, { ref: n, sx: { height: 100 } });
}, xQ = en((e) => {
  var d;
  const { onClose: t, item: n, inviteMethod: r, propId: i } = e, [a, o] = Se(Ce.INITIAL), [s, c] = Se(), { enqueueSnackbar: l } = Zr(), u = async () => {
    o(Ce.IN_PROGRESS);
    try {
      const f = await r({
        [i]: n.id,
        message: s
      });
      o(Ce.SUCCESS);
    } catch {
      o(Ce.ERROR);
    }
  };
  return He(() => {
    a === Ce.SUCCESS && (l({
      message: `${n.title || n.name} successfully requested to be published`,
      variant: "success"
    }), t());
  }, [a]), /* @__PURE__ */ p(R, { container: !0, p: 2, children: /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ B(R, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: "Name", textLabel: "Name", children: ((d = n == null ? void 0 : n.base) == null ? void 0 : d.title) || n.title || n.name }) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: "message", textLabel: "Message", children: /* @__PURE__ */ p(
      _r,
      {
        type: "text",
        value: s || "",
        minRows: 2,
        maxRows: 4,
        multiline: !0,
        size: "medium",
        onChange: (f) => c(f.target.value),
        fullWidth: !0,
        name: "message",
        placeholder: "Enter message..."
      }
    ) }) }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, textAlign: "right", children: [
      /* @__PURE__ */ p(
        Te,
        {
          variant: "outlined",
          onClick: t,
          disabled: a === Ce.IN_PROGRESS,
          startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Te,
        {
          onClick: u,
          variant: "contained",
          color: "success",
          disabled: a === Ce.IN_PROGRESS,
          name: "save",
          sx: { ml: 1 },
          startIcon: a === Ce.IN_PROGRESS ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: "submit" }),
          children: "Publish"
        }
      )
    ] })
  ] }) }) });
}), Oh = (e, t) => {
  const n = {};
  return Object.keys(e).forEach((r) => {
    const i = e[r], a = i.type === Bt.INTEGER || i.type === Bt.STRING ? e[r].values[0] : e[r].values;
    n[r] = {
      attributeId: i.id,
      dataSourceId: t,
      type: i.type,
      required: i.required,
      values: i.type === Bt.INTEGER || i.type === Bt.STRING ? {
        valueId: a == null ? void 0 : a.id,
        value: a == null ? void 0 : a.value
      } : a.map((o) => {
        var s, c;
        return {
          valueId: o.id,
          value: (s = o.attributeOption) == null ? void 0 : s.value,
          optionId: (c = o.attributeOption) == null ? void 0 : c.id
        };
      })
    };
  }), n;
}, kU = (e) => {
  const { id: t, metaAttributes: n, onChange: r, onClose: i } = e, [a, o] = Se(!1), [s, c] = Se({
    meta: Oh(n, t)
  }), l = Ee(() => ({
    required: Object.values(n).filter(
      (f) => f.required
    ),
    optional: Object.values(n).filter(
      (f) => !f.required
    )
  }), [n]), u = async () => {
    o(!0);
    const f = Oh(n, t);
    Qs(f, s.meta) || await r({
      currentState: s,
      metaAttributes: n
    }), o(!1);
  };
  return /* @__PURE__ */ B(R, { container: !0, children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      wr,
      {
        elevation: 3,
        sx: {
          borderRadius: 0,
          borderTop: "1px solid",
          borderColor: "borderColor.light"
        },
        children: /* @__PURE__ */ B(R, { container: !0, spacing: 2, px: 2, py: 1, justifyContent: "flex-end", children: [
          /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
            Te,
            {
              variant: "outlined",
              onClick: i,
              startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
              name: "delete",
              children: "Cancel"
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
            Te,
            {
              disabled: a || (() => {
                const f = Oh(n, t);
                let h = !0;
                return Object.keys(s.meta).forEach((m) => {
                  const g = s.meta[m];
                  if (g.required)
                    switch (g.type) {
                      case Bt.INTEGER:
                      case Bt.STRING:
                        g.values && g.values.value || (h = !1);
                        break;
                      case Bt.ENUM:
                      case Bt.ENUM_MULTI:
                        g.values && g.values.length > 0 || (h = !1);
                        break;
                    }
                }), !h || Qs(f, s.meta);
              })(),
              onClick: u,
              variant: "contained",
              color: "success",
              startIcon: a ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: "submit" }),
              name: "save",
              children: "Save"
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ p(R, { container: !0, px: 2, py: 2, spacing: 2, children: /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
      /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ p(R, { container: !0, p: 2, spacing: 1, children: l.required && l.required.map((f) => {
        const h = f, m = s.meta[h.id], g = m.values, v = h.type === Bt.INTEGER ? "number" : "text";
        return /* @__PURE__ */ p(R, { item: !0, xs: 6, children: /* @__PURE__ */ B(
          an,
          {
            name: h.name,
            textLabel: h.name,
            required: h.required,
            children: [
              (h.type === Bt.STRING || h.type === Bt.INTEGER) && /* @__PURE__ */ p(
                _r,
                {
                  id: h.name,
                  name: h.name,
                  type: v,
                  size: "medium",
                  value: g.value,
                  onChange: (_) => c((I) => ({
                    ...I,
                    meta: {
                      ...I.meta,
                      [h.id]: {
                        ...m,
                        values: {
                          ...g,
                          value: _.target.value
                        }
                      }
                    }
                  })),
                  fullWidth: !0
                }
              ),
              h.type === Bt.ENUM_MULTI && /* @__PURE__ */ p(
                xr,
                {
                  className: "",
                  name: "role",
                  disablePortal: !0,
                  multiple: !0,
                  id: "new-analysis-type",
                  options: h.options.map((_) => ({
                    ..._,
                    name: _.value
                  })),
                  value: g.map((_) => _.value),
                  placeholder: "Select values...",
                  onChange: (_, I) => {
                    const M = { ...m };
                    M.values = [], _.length > 0 && _.forEach((k) => {
                      const y = h.options.find(
                        (x) => k.includes(x.value)
                      );
                      M.values.push({
                        value: y.value,
                        optionId: y.id
                      });
                    }), c({
                      ...s,
                      meta: {
                        ...s.meta,
                        [h.id]: {
                          ...M
                        }
                      }
                    });
                  },
                  fullWidth: !0
                }
              ),
              h.type === Bt.ENUM && /* @__PURE__ */ p(
                xr,
                {
                  className: "",
                  name: "role",
                  disablePortal: !0,
                  id: "new-analysis-type",
                  options: h.options.map((_) => ({
                    ..._,
                    name: _.value
                  })),
                  value: g.length > 0 ? g[0].value : [],
                  placeholder: "Select type...",
                  onChange: (_, I) => {
                    const M = h.options.find(
                      (k) => k.value === _
                    );
                    c((k) => ({
                      ...k,
                      meta: {
                        ...k.meta,
                        [h.id]: {
                          ...m,
                          values: [
                            {
                              value: M.value,
                              optionId: M.id
                            }
                          ]
                        }
                      }
                    }));
                  },
                  fullWidth: !0
                }
              )
            ]
          }
        ) }, h.id);
      }) }) }),
      /* @__PURE__ */ B(dr, { children: [
        /* @__PURE__ */ p(oA, { title: "Optional" }),
        /* @__PURE__ */ p(R, { container: !0, p: 2, spacing: 1, children: l.optional && l.optional.map((f) => {
          const h = f, m = s.meta[h.id], g = m.values, v = h.type === Bt.INTEGER ? "number" : "text";
          return /* @__PURE__ */ p(R, { item: !0, xs: 6, children: /* @__PURE__ */ B(
            an,
            {
              name: h.name,
              textLabel: h.name,
              required: h.required,
              children: [
                (h.type === Bt.STRING || h.type === Bt.INTEGER) && /* @__PURE__ */ p(
                  _r,
                  {
                    id: h.name,
                    name: h.name,
                    type: v,
                    size: "medium",
                    value: g.value,
                    onChange: (_) => c((I) => ({
                      ...I,
                      meta: {
                        ...I.meta,
                        [h.id]: {
                          ...m,
                          values: {
                            ...g,
                            value: _.target.value
                          }
                        }
                      }
                    })),
                    fullWidth: !0
                  }
                ),
                h.type === Bt.ENUM_MULTI && /* @__PURE__ */ p(
                  xr,
                  {
                    className: "",
                    name: "role",
                    disablePortal: !0,
                    multiple: !0,
                    id: "new-analysis-type",
                    options: h.options.map((_) => ({
                      ..._,
                      name: _.value
                    })),
                    value: g.map((_) => _.value),
                    placeholder: "Select values...",
                    onChange: (_, I) => {
                      const M = { ...m };
                      M.values = [], _.length > 0 && _.forEach((k) => {
                        const y = h.options.find(
                          (x) => k.includes(x.value)
                        );
                        M.values.push({
                          value: y.value,
                          optionId: y.id
                        });
                      }), c((k) => ({
                        ...k,
                        meta: {
                          ...k.meta,
                          [h.id]: {
                            ...M
                          }
                        }
                      }));
                    },
                    fullWidth: !0
                  }
                ),
                h.type === Bt.ENUM && /* @__PURE__ */ p(
                  xr,
                  {
                    className: "",
                    name: "role",
                    disablePortal: !0,
                    id: "new-analysis-type",
                    options: h.options.map((_) => ({
                      ..._,
                      name: _.value
                    })),
                    value: g.length > 0 ? g[0].value : [],
                    placeholder: "Select type...",
                    onChange: (_, I) => {
                      const M = h.options.find(
                        (k) => k.value === _
                      );
                      c((k) => ({
                        ...k,
                        meta: {
                          ...k.meta,
                          [h.id]: {
                            ...m,
                            values: [
                              {
                                value: M.value,
                                optionId: M.id
                              }
                            ]
                          }
                        }
                      }));
                    },
                    fullWidth: !0
                  }
                )
              ]
            }
          ) }, h.id);
        }) })
      ] })
    ] }) })
  ] });
}, co = te.div`
  /* margin: 10px; */
  label {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    width: 230px;
    display: block;
    font-size: 14px;
  }
  p {
    margin: 0;
    margin-top: 5px;
    font-size: 13px;
    line-height: 1.5;
    color: #323232;
  }
`;
te.div`
  border-bottom: 1px solid #e7e7e7;
`;
const Yv = te.div`
  font-size: 16px;
  text-align: center;
  width: 100%;
  color: ${({ theme: e }) => e.palette.textColor.label};
`, TU = te.div`
position: absolute;
width: 100%;
height: 100%
top: 0;
right: 0;
background: #eff8fd96;
display: flex;
align-items: center;
justify-content: center;
align-self: center;
z-index: 1000;
`, MU = te.div`
  color: #21304f;
  font-weight: 700;
  display: block;
  font-size: 16px;
  padding-left: 21px;
  margin: 0;
  margin-top: 30px;
`, ff = ({
  onChange: e,
  initialId: t,
  baseUrl: n,
  query: r,
  searchFilterName: i,
  sortBy: a,
  title: o,
  multiple: s,
  initialList: c,
  initialValue: l,
  loading: u
}) => {
  const [d, f] = Se(""), [h, m] = Se(""), { list: g, status: v, loadMore: _, hasMore: I, setSearch: M } = pE(
    n,
    c,
    {
      query: r,
      searchFilterName: i,
      sortBy: a
    }
  ), k = Ee(() => {
    const A = (w) => String(w) === String(t);
    return (g == null ? void 0 : g.find((w) => A(w == null ? void 0 : w.id))) || ((l == null ? void 0 : l.id) != null && A(l.id) ? l : void 0);
  }, [t, l, g]), y = Ee(() => {
    const A = g || [];
    return !k || A.some((w) => (w == null ? void 0 : w.id) === (k == null ? void 0 : k.id)) ? A : [k, ...A];
  }, [g, k]), x = u || v === Ce.IN_PROGRESS, b = x && !(g != null && g.length) && !d;
  return He(() => {
    const A = setTimeout(() => {
      m(d);
    }, 300);
    return () => clearTimeout(A);
  }, [d]), He(() => {
    M(h);
  }, [h, M]), /* @__PURE__ */ p(
    mA,
    {
      className: "",
      disabled: b,
      name: "user-studies",
      id: "user-studies",
      value: k,
      placeholder: x ? `Loading ${o} list...` : `Select ${o}...`,
      multiple: s,
      fullWidth: !0,
      isOptionEqualToValue: (A, w) => A.id === w.id,
      options: y,
      onChange: function(A, w) {
        e(w);
      },
      onInputChange: (A, w, O) => {
        (O === "input" || O === "clear") && f(w || "");
      },
      ListboxProps: {
        onScroll: (A) => {
          const w = A.currentTarget, O = w.scrollTop + w.clientHeight;
          w.scrollHeight - O < 24 && I && _();
        }
      },
      filterOptions: (A) => A,
      getOptionKey: (A) => A.id,
      loading: x,
      loadingText: `Loading ${o} list...`,
      getOptionLabel: (A) => A.title || A.name
    }
  );
}, IU = (e, t = [], n) => {
  const [r, i] = Se(
    t[t.length - 1] || {}
  ), {
    status: a,
    values: o,
    getMetadataValues: s
  } = vA(r == null ? void 0 : r.id, n), c = (l) => {
    r.id !== l && i(t.find((u) => u.id == l));
  };
  return He(() => {
    s(r.id);
  }, [r]), He(() => {
    c(t[t.length - 1].id);
  }, [t]), {
    status: a,
    diffValues: o,
    changeCurrentEntityDiff: c,
    currentEntityDiff: r,
    diffMetadata: tA(e, o)
  };
}, jv = (e) => {
  const { attrId: t, name: n, targetValue: r, sourceValue: i } = e;
  return /* @__PURE__ */ p(R, { item: !0, xs: 4, children: /* @__PURE__ */ B(co, { children: [
    /* @__PURE__ */ B("label", { htmlFor: t, children: [
      n,
      ":"
    ] }),
    r === i ? /* @__PURE__ */ p("p", { children: /* @__PURE__ */ p(
      he,
      {
        component: "span",
        sx: {
          display: "block",
          marginRight: "6px",
          padding: "2px 5px"
        },
        children: r
      }
    ) }) : /* @__PURE__ */ B("p", { children: [
      r && /* @__PURE__ */ p(
        he,
        {
          component: "span",
          sx: {
            display: "block",
            marginRight: "6px",
            padding: "2px 5px",
            textDecoration: "line-through"
          },
          children: r
        }
      ),
      /* @__PURE__ */ p(
        he,
        {
          component: "span",
          sx: {
            background: "#b0dfe3",
            display: "inline-block",
            padding: "3px 8px",
            borderRadius: "4px",
            marginTop: "5px"
          },
          children: i
        }
      )
    ] })
  ] }) }, t);
}, NU = (e) => {
  const { options: t, value: n, onChange: r } = e;
  return /* @__PURE__ */ p(
    xr,
    {
      className: "",
      name: "diff",
      disablePortal: !0,
      id: "diff",
      options: t.map((i) => ({
        value: i.id,
        name: i.name
      })),
      value: n,
      placeholder: "Select items...",
      onChange: (i) => {
        r(i);
      }
    }
  );
}, uC = (e) => {
  const {
    diffEntities: t,
    isImport: n,
    name: r,
    values: i,
    attributes: a,
    configMetadataValuesApi: o
  } = e, {
    diffValues: s,
    status: c,
    diffMetadata: l,
    changeCurrentEntityDiff: u,
    currentEntityDiff: d
  } = IU(a, t, o);
  Ge(() => t.length > 1 ? /* @__PURE__ */ p(
    NU,
    {
      options: t,
      value: d.id,
      onChange: u
    }
  ) : t == null ? void 0 : t[0].name, [t, d]);
  const f = (h) => ({
    name: h.name,
    value: h.values.map((m) => {
      var g;
      return [
        Bt.INTEGER,
        Bt.STRING
      ].includes(h.type) ? m.value : (g = m.attributeOption) == null ? void 0 : g.value;
    }).join(", ")
  });
  return He(() => {
  }, []), [
    or.INITIAL,
    or.LOADING_METADATA
  ].includes(c) && n ? /* @__PURE__ */ p(Sf, { children: /* @__PURE__ */ p(yt, { size: 32 }) }) : n && s.length === 0 ? /* @__PURE__ */ p(R, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ p(vm, { severity: "info", children: "There is no metadata for import" }) }) : /* @__PURE__ */ p(R, { container: !0, children: /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(R, { container: !0, spacing: 3, p: 2, children: [
    [
      or.INITIAL,
      or.LOADING_METADATA
    ].includes(c) && /* @__PURE__ */ p(TU, { children: /* @__PURE__ */ p(yt, { size: 32 }) }),
    Object.keys(n ? l : i).map((h) => {
      const m = f(i == null ? void 0 : i[h]), g = f(l == null ? void 0 : l[h]);
      return /* @__PURE__ */ p(ze, { children: n ? g.value && /* @__PURE__ */ p(
        jv,
        {
          attrId: h,
          name: g.name,
          sourceValue: g.value,
          targetValue: m.value
        }
      ) : m.value && /* @__PURE__ */ p(
        jv,
        {
          attrId: h,
          name: m.name,
          sourceValue: m.value,
          targetValue: g.value
        }
      ) });
    })
  ] }) }) });
}, OU = (e) => {
  const {
    onCancel: t,
    getBaseUrl: n,
    title: r,
    configMetadataValuesApi: i,
    metadataAttributes: a,
    metadataValues: o,
    name: s,
    onSave: c,
    isContainer: l,
    isErrorCopy: u,
    initialTypeContainer: d = Ae.WORKSPACE,
    initialParentId: f,
    initialParentName: h
  } = e, [m, g] = Se(!1), [v, _] = Se({
    typeContainer: d,
    parentId: f,
    entities: []
  }), I = Ee(
    () => String(v.parentId) === String(f) && h ? [{ id: f, name: h }] : void 0,
    [f, h, v.parentId]
  ), M = Ee(
    () => v.parentId && String(v.parentId) === String(f) ? {
      id: f,
      title: h || f,
      name: h || f
    } : void 0,
    [f, h, v.parentId]
  );
  return He(() => {
    u && g(!1);
  }, [u]), /* @__PURE__ */ p(R, { container: !0, p: 2, children: /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ B(R, { container: !0, spacing: 2, p: 2, children: [
    l && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      an,
      {
        name: "typeContainer",
        textLabel: "Select from",
        required: !0,
        children: /* @__PURE__ */ p(
          xr,
          {
            className: "",
            name: "typeContainer",
            disablePortal: !0,
            id: "typeContainer",
            options: gm.filter((k) => k.value !== "ATLAS"),
            value: v.typeContainer,
            placeholder: "Select type",
            onChange: (k) => {
              _({
                ...v,
                typeContainer: k,
                parentId: void 0,
                entities: []
              });
            },
            fullWidth: !0
          }
        )
      }
    ) }),
    v.typeContainer === Ae.STUDY && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: "study", textLabel: "Study", required: !0, children: /* @__PURE__ */ p(
      ff,
      {
        title: "Study",
        initialId: v.parentId,
        initialList: I,
        initialValue: M,
        searchFilterName: "filter.search",
        sortBy: { id: "title", desc: !1 },
        onChange: (k) => {
          _(k ? {
            ...v,
            parentId: k.id,
            entities: []
          } : {
            ...v,
            parentId: void 0,
            entities: []
          });
        }
      }
    ) }) }),
    (v.typeContainer === Ae.WORKSPACE || v.typeContainer === Ae.STUDY && v.parentId) && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: r, textLabel: r, required: !0, children: /* @__PURE__ */ p(
      ff,
      {
        title: r,
        initialId: "",
        baseUrl: n(v.typeContainer, v.parentId),
        query: "metadata.present=filter.boolean.true",
        searchFilterName: "filter.search",
        sortBy: { id: "name", desc: !1 },
        onChange: (k) => {
          _(k ? (y) => ({
            ...y,
            entities: [k]
          }) : (y) => ({
            ...y,
            entities: []
          }));
        }
      }
    ) }) }),
    v.entities.map((k) => /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      uC,
      {
        isImport: !0,
        diffEntities: [k],
        name: s,
        attributes: a,
        values: o,
        configMetadataValuesApi: i
      }
    ) })),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(xf, { children: [
      /* @__PURE__ */ p(
        Te,
        {
          variant: "outlined",
          onClick: t,
          startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Te,
        {
          onClick: async () => {
            g(!0), await c(v.entities) === !1 && g(!1);
          },
          variant: "contained",
          disabled: v.entities.length == 0 || m,
          color: "success",
          startIcon: m ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: "submit" }),
          name: "save",
          children: "Import"
        }
      )
    ] }) })
  ] }) }) });
}, RU = (e) => {
  const {
    onCancel: t,
    getBaseUrl: n,
    title: r,
    configMetadataValuesApi: i,
    metadataAttributes: a,
    metadataValues: o,
    name: s,
    onSave: c,
    isContainer: l,
    isErrorCopy: u,
    initialTypeContainer: d = Ae.WORKSPACE,
    initialParentId: f,
    initialParentName: h
  } = e, [m, g] = Se(!1), [v, _] = Se({
    typeContainer: d,
    parentId: f,
    entities: []
  }), I = v.parentId ? {
    id: v.parentId,
    title: h || v.parentId,
    name: h || v.parentId
  } : void 0;
  return He(() => {
    u && g(!1);
  }, [u]), /* @__PURE__ */ p(R, { container: !0, p: 2, children: /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ B(R, { container: !0, spacing: 2, p: 2, children: [
    l && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: "typeContainer", textLabel: "Container", required: !0, children: /* @__PURE__ */ p(
      xr,
      {
        className: "",
        name: "typeContainer",
        disablePortal: !0,
        id: "typeContainer",
        options: gm.filter((M) => M.value !== "ATLAS"),
        value: v.typeContainer,
        placeholder: "Select type",
        onChange: (M) => {
          _({
            ...v,
            typeContainer: M,
            parentId: void 0,
            entities: []
          });
        },
        fullWidth: !0
      }
    ) }) }),
    v.typeContainer === Ae.STUDY && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: "study", textLabel: "Study", required: !0, children: /* @__PURE__ */ p(
      ff,
      {
        title: "Study",
        initialId: v.parentId,
        initialValue: I,
        searchFilterName: "filter.search",
        sortBy: { id: "title", desc: !1 },
        onChange: (M) => {
          _(M ? {
            ...v,
            parentId: M.id,
            entities: []
          } : {
            ...v,
            parentId: void 0,
            entities: []
          });
        }
      }
    ) }) }),
    (v.typeContainer === Ae.WORKSPACE || v.typeContainer === Ae.STUDY && v.parentId) && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: r, textLabel: r, required: !0, children: /* @__PURE__ */ p(
      ff,
      {
        title: r,
        multiple: !0,
        initialId: "",
        baseUrl: n(v.typeContainer, v.parentId),
        searchFilterName: "filter.search",
        sortBy: { id: "name", desc: !1 },
        onChange: (M) => {
          _(M ? (k) => ({
            ...k,
            entities: M
          }) : (k) => ({
            ...k,
            entities: []
          }));
        }
      }
    ) }) }),
    v.entities.length > 0 && /* @__PURE__ */ B(MU, { children: [
      "Export Attributes from ",
      s,
      ":"
    ] }),
    v.entities.map((M, k) => /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Fr,
      {
        collapsible: !0,
        title: M.name,
        isDark: !0,
        defaultState: k === 0,
        size: "dense",
        children: /* @__PURE__ */ p(
          uC,
          {
            diffEntities: [M],
            name: s,
            attributes: a,
            values: o,
            configMetadataValuesApi: i
          }
        )
      }
    ) })),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(xf, { children: [
      /* @__PURE__ */ p(
        Te,
        {
          variant: "outlined",
          onClick: t,
          startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Te,
        {
          onClick: async () => {
            g(!0), await c(v.entities) === !1 && g(!1);
          },
          variant: "contained",
          color: "success",
          disabled: v.entities.length == 0 || m,
          startIcon: m ? /* @__PURE__ */ p(yt, { size: 16 }) : /* @__PURE__ */ p(pe, { iconName: "submit" }),
          name: "save",
          children: "Export"
        }
      )
    ] }) })
  ] }) }) });
}, dm = te.pre`
  margin: 5px 0 0;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  color: #323232;
`, hm = te(dm)`
  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.35;
`, DU = te.div`
  margin-top: 5px;
  font-size: 13px;
  line-height: 1.5;
  color: #323232;

  p,
  li,
  ol,
  ul,
  a {
    font-size: inherit;
    line-height: inherit;
    color: inherit;
  }

  p {
    margin: 0 0 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ol,
  ul {
    margin: 0 0 8px;
    padding-left: 24px;
  }
`, PU = [
  { name: "ai-reasoning", type: "markdown", size: 12 },
  { name: "ai-raw-output", type: "json", size: 12 },
  { name: "ai-error", type: "json", size: 12 }
], LU = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return { error: "Invalid JSON", output: e };
  }
}, zU = [
  "CohortGenerationService Version",
  "CohortGenerator LLM Version",
  "ConceptSetGenerationService Version",
  "ConceptSetGenerator LLM Version"
], fC = /^\s*(?:#{1,6}\s*)?(?:\d+[.)]\s*)?(?:Sources|Resources|References)(?:\s*(?:and|\/)\s*(?:Sources|Resources|References))*\s*:?\s*$/i, dC = /^(?:[-*\u2022]|\d+[.)])/, hC = (e) => {
  const t = e.split(`
`), n = t.findIndex(
    (a) => fC.test(a.trim())
  );
  if (n === -1)
    return e;
  let r = !1, i = n + 1;
  for (; i < t.length && (dC.test(t[i].trim()) || t[i].trim() === ""); ) {
    const a = t[i].trim(), o = a.match(/https?:\/\/[^\s)]+/);
    if (o && !a.includes("](")) {
      const s = o[0], l = a.replace(/^(?:[-*\u2022]|\d+[.)])\s*/, "").replace(s, "").trim().replace(/[:\-.]+$/, "") || s;
      t[i] = `- [${l}](${s})`, r = !0;
    }
    i++;
  }
  return r ? t.join(`
`) : e;
}, BU = (e, t) => {
  const n = `https://clinicaltrials.gov/study/${t}`, r = hC(e), i = r.split(`
`), a = i.findIndex(
    (s) => fC.test(s.trim())
  );
  if (a === -1)
    return `${r.trim()}

## Sources:
- [ClinicalTrials.gov reference: ${n}](${n})`;
  let o = a + 1;
  for (; o < i.length && (dC.test(i[o].trim()) || i[o].trim() === ""); )
    o++;
  return i.some((s) => s.includes(n)) || i.splice(
    o,
    0,
    `- [ClinicalTrials.gov reference: ${n}](${n})`
  ), i.join(`
`);
}, FU = (e) => {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true")
      return !0;
    if (t === "false")
      return !1;
  }
}, Wv = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    if (Number.isFinite(t))
      return t;
  }
}, pC = (e) => {
  if (Array.isArray(e))
    return e.map((n) => String(n).trim()).filter(Boolean);
  if (typeof e != "string")
    return null;
  const t = e.trim();
  if (!t)
    return [];
  try {
    const n = JSON.parse(t);
    if (Array.isArray(n))
      return n.map((r) => String(r).trim()).filter(Boolean);
  } catch {
  }
  if (t.startsWith("[") && t.endsWith("]")) {
    const n = t.slice(1, -1).trim();
    return n ? n.split(",").map((r) => r.trim().replace(/^['"]|['"]$/g, "")).filter(Boolean) : [];
  }
  return null;
}, wi = (e) => {
  if (e == null)
    return !1;
  if (typeof e == "string") {
    const t = pC(e);
    return t ? t.length > 0 : e.trim() !== "";
  }
  return Array.isArray(e) ? e.length > 0 : !0;
}, no = (e) => {
  if (!wi(e))
    return "";
  const t = pC(e);
  return t ? t.join(", ") : Array.isArray(e) ? e.filter((n) => n != null && n !== "").join(", ") : String(e);
}, $U = (e) => e.filter((t) => wi(t.value)).map((t) => `${t.label}: ${t.value}`).join(`\r
`), YU = (e) => {
  var i;
  const t = e.trim();
  if (!t)
    return "";
  const r = (((i = globalThis == null ? void 0 : globalThis.location) == null ? void 0 : i.pathname) || "").match(/^\/study-manager\/([^/]+)\//);
  return r != null && r[1] ? `/study-manager/${r[1]}/cohorts/${encodeURIComponent(t)}` : `/workspace/cohorts/${encodeURIComponent(t)}`;
}, jU = (e) => {
  try {
    const t = JSON.parse(e);
    if (t && typeof t == "object" && !Array.isArray(t))
      return t;
  } catch {
    return null;
  }
  return null;
}, B0 = (e) => e !== mf.COHORT, WU = (e) => {
  const t = Wv(e["Search precision"]);
  return t !== void 0 && t >= 0 && t < q0.length ? q0[t] : {
    skipVectorSearch: FU(e["~ai_skip_vector_search"]),
    vectorSearchResultLimit: Wv(
      e["~vector_search_result_limit"]
    )
  };
}, HU = (e, t) => {
  const n = t.map((r) => r.toLowerCase());
  return e.find(
    (r) => typeof r == "object" && r !== null && "name" in r && n.includes(
      String(r.name).toLowerCase()
    )
  );
}, UU = (e, t, n, r) => {
  const i = WU(e), a = [], o = no(e.Domain), s = no(e.Vocabulary), c = no(e["Standard concept"]), l = no(e["NCT number"]) || r, u = no(i.vectorSearchResultLimit) || vn(t, [
    "~vector_search_result_limit",
    "vector_search_result_limit",
    "ai-vector-search-result-limit"
  ]), d = no(i.skipVectorSearch) || vn(t, [
    "~ai_skip_vector_search",
    "ai_skip_vector_search",
    "ai-skip-vector-search"
  ]);
  return n === mf.COHORT ? l && a.push({ label: "ai-clinical-trials-id", value: l }) : B0(n) && o && a.push({ label: "ai-domains", value: o }), s && a.push({ label: "ai-vocabularies", value: s }), c && a.push({ label: "ai-standard-concepts", value: c }), wi(u) && a.push({
    label: "ai-vector-search-result-limit",
    value: u
  }), wi(d) && a.push({
    label: "ai-skip-vector-search",
    value: d
  }), a;
}, vn = (e, t) => {
  var a, o, s, c;
  const n = HU(e, t);
  if (!((a = n == null ? void 0 : n.values) != null && a.length))
    return "";
  const r = (o = n.values.find(
    (l) => (l == null ? void 0 : l.value) !== null && (l == null ? void 0 : l.value) !== void 0 && l.value !== ""
  )) == null ? void 0 : o.value;
  if (typeof r == "string")
    return r;
  const i = (c = (s = n.values.find(
    (l) => {
      var u, d;
      return ((u = l == null ? void 0 : l.attributeOption) == null ? void 0 : u.value) !== null && ((d = l == null ? void 0 : l.attributeOption) == null ? void 0 : d.value) !== void 0 && l.attributeOption.value !== "";
    }
  )) == null ? void 0 : s.attributeOption) == null ? void 0 : c.value;
  return typeof i == "string" ? i : "";
}, GU = (e, t, n) => {
  const r = [], i = vn(e, ["Domain", "ai-domains"]), a = vn(e, [
    "Vocabulary",
    "ai-vocabularies"
  ]), o = vn(e, [
    "Standard concept",
    "ai-standard-concepts"
  ]), s = vn(e, ["NCT number", "ai-clinical-trials-id"]) || n, c = vn(e, [
    "~vector_search_result_limit",
    "vector_search_result_limit",
    "ai-vector-search-result-limit"
  ]), l = vn(e, [
    "~ai_skip_vector_search",
    "ai_skip_vector_search",
    "ai-skip-vector-search"
  ]);
  return t === mf.COHORT ? s && r.push({ label: "ai-clinical-trials-id", value: s }) : B0(t) && i && r.push({ label: "ai-domains", value: i }), a && r.push({ label: "ai-vocabularies", value: a }), o && r.push({ label: "ai-standard-concepts", value: o }), wi(c) && r.push({
    label: "ai-vector-search-result-limit",
    value: c
  }), wi(l) && r.push({
    label: "ai-skip-vector-search",
    value: l
  }), r;
}, VU = (e, t) => {
  const n = [...e];
  return t.forEach((r) => {
    wi(r.value) && !n.some((i) => i.label === r.label) && n.push(r);
  }), n;
}, QU = (e, t) => {
  const n = LU(t), r = [
    {
      label: "ai-job-id",
      value: vn(e, ["ai-job-id"])
    },
    {
      label: "ai-status",
      value: vn(e, ["ai-status"])
    },
    {
      label: "ai-generated-as-part-of-cohort",
      value: vn(e, [
        "ai-generated-as-part-of-cohort"
      ])
    },
    {
      label: "ai-generation-complete-timestamp",
      value: vn(e, [
        "ai-generation-complete-timestamp"
      ])
    }
  ];
  if (!(n != null && n.error)) {
    const i = zU.filter(
      (a) => typeof n[a] == "string" && n[a]
    ).map((a) => `${a}: ${n[a]}`).filter(Boolean).join(`\r
`);
    i && r.push({
      label: "ai-version-info",
      value: i
    });
  }
  return r.filter((i) => wi(i.value));
}, qU = (e, t, n) => e ? t ? typeof t.Description == "string" && t.Description.trim() ? t.Description : Object.entries(t).filter(
  ([r]) => B0(n) ? !0 : r !== "Domain"
).filter(([r, i]) => r !== "Description" && !$C(i)).map(([r, i]) => `${r}: ${i}`).join(`\r
`) : e : "", XU = (e) => {
  const t = e.map(
    (n) => n.label === "ai-generation-complete-timestamp" ? {
      ...n,
      value: Kn(n.value)
    } : n
  );
  return /* @__PURE__ */ p(hm, { as: "div", children: t.map((n, r) => {
    const i = n.label === "ai-generated-as-part-of-cohort" && wi(n.value), a = i ? YU(n.value) : "";
    return /* @__PURE__ */ B(Xe.Fragment, { children: [
      n.label,
      ":",
      " ",
      i && a ? /* @__PURE__ */ B(ze, { children: [
        /* @__PURE__ */ p(
          "a",
          {
            href: a,
            target: "_blank",
            rel: "noreferrer",
            style: {
              color: "#1976d2",
              textDecoration: "underline"
            },
            children: n.value
          }
        ),
        " ",
        /* @__PURE__ */ p(
          "a",
          {
            href: a,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": `Open cohort ${n.value} in a new tab`,
            style: {
              color: "#98A2B3",
              textDecoration: "none",
              display: "inline-flex",
              verticalAlign: "text-bottom",
              marginBottom: "5px"
            },
            children: /* @__PURE__ */ B(
              "svg",
              {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                children: [
                  /* @__PURE__ */ p(
                    "path",
                    {
                      d: "M14 3H21V10",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  ),
                  /* @__PURE__ */ p(
                    "path",
                    {
                      d: "M10 14L21 3",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  ),
                  /* @__PURE__ */ p(
                    "path",
                    {
                      d: "M21 14V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H10",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  )
                ]
              }
            )
          }
        )
      ] }) : n.value,
      r < t.length - 1 ? `
` : ""
    ] }, n.label);
  }) });
}, JU = ({
  meta: e,
  name: t,
  type: n
}) => {
  const r = Object.values(e), i = Ee(
    () => pf(rn.JSON),
    []
  ), a = Ee(() => vn(r, ["ai-clinical-trials-id"]).trim(), [r]), o = Ee(() => vn(r, ["ai-prompt"]), [r]), s = Ee(
    () => o ? jU(o) : null,
    [o]
  ), c = Ee(
    () => qU(o, s, n),
    [o, s, n]
  ), l = Ee(
    () => s ? UU(
      s,
      r,
      n,
      a
    ) : [],
    [s, r, n, a]
  ), u = Ee(
    () => VU(
      l,
      GU(r, n, a)
    ),
    [r, n, a, l]
  ), d = Ee(
    () => QU(
      r,
      vn(r, ["ai-version-info"])
    ),
    [r]
  ), f = Ee(() => {
    const h = [
      c,
      u.length,
      d.length
    ].filter(Boolean).length;
    return h <= 1 ? 12 : h === 2 ? 6 : 4;
  }, [c, u.length, d.length]);
  return /* @__PURE__ */ B(R, { container: !0, spacing: 3, children: [
    c && /* @__PURE__ */ p(R, { item: !0, xs: 12, md: f, children: /* @__PURE__ */ B(co, { children: [
      /* @__PURE__ */ p("label", { children: "ai-prompt:" }),
      /* @__PURE__ */ p(hm, { children: c })
    ] }) }),
    u.length > 0 && /* @__PURE__ */ p(R, { item: !0, xs: 12, md: f, children: /* @__PURE__ */ B(co, { children: [
      /* @__PURE__ */ p("label", { children: "ai-generation-options:" }),
      /* @__PURE__ */ p(hm, { children: $U(u) })
    ] }) }),
    d.length > 0 && /* @__PURE__ */ p(R, { item: !0, xs: 12, md: f, children: /* @__PURE__ */ B(co, { children: [
      /* @__PURE__ */ p("label", { children: "ai-generation-details:" }),
      XU(d)
    ] }) }),
    PU.map(({ name: h, type: m, size: g }) => {
      const v = vn(r, [h]) || null, _ = m === "markdown" && v ? a ? BU(v, a) : hC(v) : v, I = m === "json" ? v : null;
      return /* @__PURE__ */ p(Xe.Fragment, { children: (I && m == "json" || v && m != "json") && /* @__PURE__ */ p(R, { item: !0, xs: g, children: /* @__PURE__ */ B(co, { children: [
        /* @__PURE__ */ B("label", { children: [
          h,
          ":"
        ] }),
        (() => {
          switch (m) {
            case "markdown":
              return n == mf.CONCEPT_SET ? /* @__PURE__ */ p(dm, { children: _ }) : /* @__PURE__ */ p(DU, { children: /* @__PURE__ */ p(
                Um,
                {
                  components: {
                    a: ({ node: M, ...k }) => /* @__PURE__ */ p(
                      "a",
                      {
                        ...k,
                        target: "_blank",
                        rel: "noreferrer",
                        style: {
                          color: "#1976d2",
                          textDecoration: "underline"
                        }
                      }
                    )
                  },
                  children: _
                }
              ) });
            case "json":
              return /* @__PURE__ */ p("p", { children: /* @__PURE__ */ p(
                Nl,
                {
                  data: I,
                  fileName: t,
                  language: i,
                  readOnly: !0,
                  fileExtension: rn.JSON
                }
              ) });
            default:
              return /* @__PURE__ */ p(dm, { children: v });
          }
        })()
      ] }) }) }, h);
    })
  ] });
}, vQ = (e) => {
  const {
    id: t,
    name: n,
    title: r,
    getBaseUrl: i,
    metadataSubject: a,
    canUpdate: o,
    configMetadataValuesApi: s,
    callback: c,
    url: l,
    initialTypeContainer: u,
    initialParentId: d,
    initialParentName: f,
    aiMode: h
  } = e, { openModal: m, closeModal: g } = zo(bm), { enqueueSnackbar: v } = Zr(), [_, I] = Se({}), { status: M, data: k } = yA(
    `&filter.metadata.subject=${a}`,
    h,
    !1
  ), {
    status: y,
    values: x,
    isLoading: b,
    saveMetadataValue: A,
    getMetadataValues: w,
    copyMetadataValues: O
  } = vA(t, s, h), P = u === Ae.STUDY ? Ae.STUDY : Ae.WORKSPACE, E = P === Ae.STUDY ? d : void 0, C = () => {
    m(
      () => /* @__PURE__ */ p(
        kU,
        {
          id: t,
          metaAttributes: _,
          onChange: async (z) => {
            var F;
            await A(
              (F = z.currentState) == null ? void 0 : F.meta,
              z.metaAttributes
            ), c == null || c(), g(), v({
              message: "Meta attributes updated",
              variant: "success"
            });
          },
          onClose: g
        }
      ),
      "Update metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: g
      }
    );
  }, T = () => {
    m(
      () => /* @__PURE__ */ p(
        OU,
        {
          isContainer: !0,
          name: n,
          title: r,
          getBaseUrl: i,
          onCancel: g,
          metadataAttributes: k,
          metadataValues: _,
          url: l,
          initialTypeContainer: P,
          initialParentId: E,
          initialParentName: f,
          configMetadataValuesApi: s,
          isErrorCopy: y === or.ERROR_LOADED_COPY_METADATA,
          onSave: async (z) => O(z[0].id, [{ id: t }])
        }
      ),
      "Import metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: g
      }
    );
  }, D = () => {
    m(
      () => /* @__PURE__ */ p(
        RU,
        {
          isContainer: !0,
          name: n,
          title: r,
          getBaseUrl: i,
          onCancel: g,
          metadataAttributes: k,
          metadataValues: _,
          initialTypeContainer: P,
          initialParentId: E,
          initialParentName: f,
          isErrorCopy: y === or.ERROR_LOADED_COPY_METADATA,
          configMetadataValuesApi: s,
          onSave: async (z) => O(t, z)
        }
      ),
      "Export metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: g
      }
    );
  };
  return He(() => {
    y === or.LOADED_COPY_METADATA && (w(t), c == null || c(), g(), v({
      message: "Meta attributes copied",
      variant: "success"
    })), y === or.ERROR_LOADED_COPY_METADATA && v({
      message: "Meta attributes not copied",
      variant: "error"
    });
  }, [y]), He(() => {
    ![
      or.INITIAL,
      or.LOADING_METADATA
    ].includes(y) && ![Ce.INITIAL, Ce.IN_PROGRESS].includes(M) && I(tA(k, x));
  }, [y, M]), [
    or.INITIAL,
    or.LOADING_METADATA
  ].includes(y) || [Ce.INITIAL, Ce.IN_PROGRESS].includes(M) ? /* @__PURE__ */ p(Sf, { children: /* @__PURE__ */ p(yt, { size: 32 }) }) : /* @__PURE__ */ p(Zm, { children: /* @__PURE__ */ p(
    Fr,
    {
      outlined: !0,
      title: h ? "Generative AI" : "Metadata",
      actions: /* @__PURE__ */ B(R, { container: !0, spacing: 1, children: [
        !h && /* @__PURE__ */ B(ze, { children: [
          /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
            Te,
            {
              className: "update-metadata",
              variant: "contained",
              onClick: C,
              disabled: !o || Object.keys(_).length === 0,
              color: "info",
              startIcon: /* @__PURE__ */ p(pe, { iconName: "edit", name: "edit", sx: { fontSize: 22 } }),
              children: "Update"
            }
          ) }),
          /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
            Te,
            {
              className: "import-metadata",
              variant: "contained",
              onClick: T,
              disabled: !o || Object.keys(_).length === 0,
              color: "info",
              startIcon: /* @__PURE__ */ p(
                pe,
                {
                  iconName: "import",
                  name: "import",
                  sx: { fontSize: 22 }
                }
              ),
              children: "Import"
            }
          ) })
        ] }),
        !h && /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
          Te,
          {
            className: "export-metadata",
            variant: "contained",
            onClick: D,
            disabled: !o || Object.keys(_).length === 0 || x.length === 0,
            color: "info",
            startIcon: /* @__PURE__ */ p(
              pe,
              {
                iconName: "export",
                name: "export",
                sx: { fontSize: 22 }
              }
            ),
            children: "Export"
          }
        ) })
      ] }),
      children: /* @__PURE__ */ B(R, { container: !0, children: [
        _ && !h && /* @__PURE__ */ p(R, { container: !0, spacing: 3, children: Object.keys(_).map((z) => {
          const F = _ == null ? void 0 : _[z];
          if (!(Array.isArray(F.values) && F.values.length > 0))
            return null;
          const L = F.values.map((S) => {
            var j;
            return F.type == Bt.INTEGER || F.type == Bt.STRING ? S.value : (j = S.attributeOption) == null ? void 0 : j.value;
          }).filter(
            (S) => S != null && S !== ""
          ).join(", ");
          return /* @__PURE__ */ p(R, { item: !0, xs: 4, children: /* @__PURE__ */ B(co, { children: [
            /* @__PURE__ */ B("label", { htmlFor: "", children: [
              F.name || F.title || z,
              ":"
            ] }),
            /* @__PURE__ */ p("p", { children: L || "-" })
          ] }) }, z);
        }) }),
        _ && h && /* @__PURE__ */ p(JU, { type: a, meta: _, name: n }),
        !_ || Object.keys(_).length === 0 && /* @__PURE__ */ p(Yv, { children: "No specified metadata" }),
        Object.keys(_).length > 0 && x.length === 0 && /* @__PURE__ */ p(Yv, { children: "No values" })
      ] })
    }
  ) });
}, mC = te.div`
  font-size: 70px;
  font-weight: 800;
  color: ${({ theme: e }) => {
  var t, n;
  return fE(0.1, ((n = (t = e.palette) == null ? void 0 : t.backgroundColor) == null ? void 0 : n.main) || "#F7F8FA");
}};
  margin-right: 8px;
`, gC = te.div`
  font-size: 28px;
  font-weight: 800;
  /* margin-bottom: 50px; */
  color: ${({ theme: e }) => {
  var t, n;
  return Un(0.1, ((n = (t = e.palette) == null ? void 0 : t.textColor) == null ? void 0 : n.label) || "#798395");
}};
`, yC = te.div`
  font-size: 20px;
  padding: 0 40px;
  /* margin-bottom: 16px; */
  color: ${({ theme: e }) => {
  var t, n;
  return ((n = (t = e.palette) == null ? void 0 : t.textColor) == null ? void 0 : n.label) || "#798395";
}};
`, KU = (e) => {
  const { status: t, statusText: n, message: r, data: i, path: a, noAction: o = !1 } = e, s = (i == null ? void 0 : i.message) || r || "", c = Qi(), l = Tr();
  return /* @__PURE__ */ B(
    R,
    {
      container: !0,
      direction: "row",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      spacing: 1,
      py: 2,
      children: [
        /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
          /* @__PURE__ */ p(mC, { children: t }),
          /* @__PURE__ */ p(gC, { children: n })
        ] }),
        s && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(yC, { children: s }) }),
        !o && /* @__PURE__ */ B(
          R,
          {
            item: !0,
            xs: 12,
            container: !0,
            justifyContent: "center",
            spacing: 2,
            mt: 1,
            sx: {
              zIndex: 10,
              position: "relative"
            },
            children: [
              t === 406 && /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
                Te,
                {
                  onClick: () => {
                    var u, d;
                    c(ME((d = (u = i.tenants) == null ? void 0 : u[0]) == null ? void 0 : d.id));
                  },
                  variant: "outlined",
                  size: "medium",
                  startIcon: /* @__PURE__ */ p(pe, { iconName: "reload" }),
                  children: "Switch tenant"
                }
              ) }),
              t === 42 ? /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
                Te,
                {
                  onClick: () => {
                    l("/");
                  },
                  variant: "outlined",
                  size: "medium",
                  startIcon: /* @__PURE__ */ p(pe, { iconName: "list" }),
                  children: "Go to home"
                }
              ) }) : /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
                Te,
                {
                  onClick: () => {
                    l(`/${a}`);
                  },
                  variant: "outlined",
                  size: "medium",
                  startIcon: /* @__PURE__ */ p(pe, { iconName: "list" }),
                  children: "Go to list"
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, AQ = (e) => {
  const { status: t, statusText: n, message: r, data: i, path: a } = e;
  return /* @__PURE__ */ B(
    R,
    {
      container: !0,
      direction: "row",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      children: [
        /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
          /* @__PURE__ */ p(mC, { children: t }),
          /* @__PURE__ */ p(gC, { children: n })
        ] }),
        /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
          /* @__PURE__ */ p(yC, { children: r }),
          /* @__PURE__ */ p(R, { container: !0, justifyContent: "center", spacing: 2, children: /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
            Te,
            {
              onClick: () => {
                window.location.href = "/";
              },
              variant: "outlined",
              size: "medium",
              startIcon: /* @__PURE__ */ p(pe, { iconName: "list" }),
              children: "Go to home"
            }
          ) }) })
        ] })
      ]
    }
  );
}, bQ = en((e) => {
  var a;
  const { data: t } = e, n = Ee(() => t, [t]), r = Ee(() => {
    var o;
    return (o = t == null ? void 0 : t.base) == null ? void 0 : o.title;
  }, [(a = t == null ? void 0 : t.base) == null ? void 0 : a.title]), i = Ee(
    () => pf(rn.JSON),
    []
  );
  return /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    Nl,
    {
      data: n,
      fileName: r,
      language: i,
      readOnly: !0,
      fileExtension: rn.JSON
    }
  ) });
}), xC = en((e) => {
  const {
    onChange: t,
    typeContainer: n,
    parentId: r,
    createListMethods: i,
    createListFiltersMethod: a,
    cols: o,
    disableRowSelect: s,
    isSelect: c = !1,
    titleTable: l = "All",
    titleExtra: u,
    footerStart: d,
    loadingMessage: f = "Loading",
    buttonImportText: h = "Add",
    isLoadingButton: m = !1,
    idSelector: g = "id",
    children: v,
    isOutsideLoading: _,
    reloadId: I,
    hideHeader: M = !1,
    hideEmptyTable: k = !1,
    toggleSelectionOnRowClick: y = !1
  } = e, x = Ee(() => o, []), b = Ee(() => i(n, r), [n, r]), A = Xe.useMemo(() => a(n, r), [n, r]), { selectedConcepts: w, detectSelectedAction: O, clear: P, init: E } = mE({}, g), {
    data: { tableData: C, filtersData: T },
    filters: D,
    status: z,
    pageCount: F,
    pageSize: W,
    getEntity: L,
    totalElements: S,
    numberOfElements: j,
    updateFilters: Y,
    resetState: N
  } = xA(
    {
      get: b.fetch,
      remove: () => {
      },
      getFilters: A && A.getFilters
    },
    I,
    !1
  ), X = Object.values(D).some(
    (U) => (U == null ? void 0 : U.length) > 0
  ), G = z === Ce.IN_PROGRESS || z === Ce.IN_PROGRESS_RELOAD || _, q = k && !G && !X && Number(S || 0) === 0, $ = Ge(
    (U) => {
      var ee;
      if (c) {
        t(Object.keys(w).map((ce) => w[ce]));
        return;
      }
      if (!(!(U != null && U.original) || ((ee = U == null ? void 0 : U.original) == null ? void 0 : ee[g]) == null)) {
        if (y) {
          const ce = String(U.original[g]);
          if (!!w[ce]) {
            E({}), t([]);
            return;
          }
          E({ [ce]: U.original }), t([U.original]);
          return;
        }
        E({ [U.original[g]]: U.original }), t([U.original]);
      }
    },
    [
      g,
      E,
      c,
      t,
      w,
      y
    ]
  ), Q = Ge((U, ee) => {
    const ce = {};
    U == null || U.forEach((se) => {
      ce[se[g]] = se;
    }), O(ce, ee);
  }, []), V = Object.keys(w).length;
  He(() => () => {
    N();
  }, [n]);
  const { otherFilters: H, searchFilter: K } = eA(T);
  return /* @__PURE__ */ B(R, { container: !0, sx: { position: "relative" }, children: [
    m && /* @__PURE__ */ p(GM, { children: /* @__PURE__ */ p(yt, { size: 62 }) }),
    !M && /* @__PURE__ */ p(R, { item: !0, xs: 12, mt: -1, children: /* @__PURE__ */ p(
      Hw,
      {
        title: l,
        titleExtra: u,
        customButtons: v
      }
    ) }),
    /* @__PURE__ */ p(
      qz,
      {
        onAdd: () => {
          $();
        },
        disabled: m,
        onClear: P,
        selectedConceptsCount: c ? V : 0,
        buttonText: h,
        buttonStartIcon: null,
        startContent: c && V > 0 ? d : void 0,
        width: V != null ? "calc(100% - 250px)" : window.innerWidth - 250 + "px"
      }
    ),
    /* @__PURE__ */ p(
      R,
      {
        container: !0,
        className: "table-list-widget",
        pb: V ? 4 : 2,
        mt: M ? 1 : 2,
        children: /* @__PURE__ */ p(R, { item: !0, xs: 12, className: "table-data-list-widget", children: !q && /* @__PURE__ */ p(
          ha,
          {
            enableRowSelection: c,
            showFilterToggle: !0,
            variant: "controlled",
            data: C,
            className: "import-concepts-table",
            columns: x,
            pageCount: F,
            pageSize: W,
            fetchData: L,
            getRowId: (U) => String(U[g]),
            totalElements: S,
            loadingMessage: f,
            onRowSelect: Q,
            disableRowSelect: s,
            onRowClick: c ? () => {
            } : $,
            loading: G,
            hasFilters: X,
            noDataText: X ? "The result listing is empty because of the filter you applied" : "No data currently available",
            selectedRowIds: Object.keys(w).reduce(
              (U, ee) => (U[ee] = !0, U),
              {}
            ),
            searchComponent: K && /* @__PURE__ */ p(
              pA,
              {
                ...K,
                value: D == null ? void 0 : D[K == null ? void 0 : K.name],
                onChange: (U) => Y({ [K == null ? void 0 : K.name]: U })
              }
            ),
            children: /* @__PURE__ */ p(
              ym,
              {
                filters: H,
                value: D,
                isReloading: z === Ce.IN_PROGRESS_RELOAD,
                isLoading: z === Ce.IN_PROGRESS || _,
                onChange: (U, ee) => Y({ [U]: ee })
              }
            )
          }
        ) })
      }
    )
  ] });
}), ZU = () => un.get("/atlases"), eG = (e, t, n, r, i, a, o, s) => {
  const c = [];
  return t && c.push({
    value: li.LOCAL,
    title: "Local",
    onTabClick: i
  }), a === Ae.WORKSPACE && (n.includes(Ae.WORKSPACE) && c.push({
    value: Ae.WORKSPACE,
    title: "Workspace",
    onTabClick: i
  }), n.includes(Ae.STUDY) && c.push({
    value: Ae.STUDY,
    title: "Studies",
    onTabClick: i
  })), a === Ae.STUDY && (n.includes(Ae.STUDY) && c.push({
    value: Ae.STUDY,
    title: "Studies",
    onTabClick: i
  }), n.includes(Ae.WORKSPACE) && c.push({
    value: Ae.WORKSPACE,
    title: "Workspace",
    onTabClick: i
  })), a === Ae.LIBRARY && (n.includes(Ae.STUDY) && c.push({
    value: Ae.STUDY,
    title: "Studies",
    onTabClick: i
  }), n.includes(Ae.WORKSPACE) && c.push({
    value: Ae.WORKSPACE,
    title: "Workspace",
    onTabClick: i
  })), n.includes(Ae.LIBRARY) && c.push({
    value: Ae.LIBRARY,
    title: "Artifacts library",
    onTabClick: i
  }), r && !s && c.push({
    value: li.ATLAS,
    title: "Atlas",
    onTabClick: i
  }), e && !o && c.push({
    value: li.MANUAL,
    title: "Manual",
    onTabClick: i
  }), c;
}, tG = (e, t, n) => {
  const { pageNumber: r, pageSize: i, sortBy: a, query: o } = n, s = YC(a), c = `/atlas/${e}/assets/${t}?size=${i || ""}&page=${r || 0}&sort=${s}&${o || ""}`;
  return un.get(c).then((l) => ({
    ...l,
    content: l.content.map((u) => ({
      ...u,
      type: t
    }))
  }));
}, nG = (e, t) => un.get(`/atlas/${e}/assets/${t}/last-refresh`), rG = (e, t) => un.post(`/atlas/${e}/assets/${t}/refresh`), iG = (e, t, n, r, i, a) => {
  const o = (() => {
    switch (a) {
      case Et.CREATE_NEW_OBJECT:
        return Et.CREATE_NEW_OBJECT;
      case Et.CREATE_NEW_VERSION:
        return Et.CREATE_NEW_VERSION;
      default:
        return a;
    }
  })(), s = o ? `?resolution=${encodeURIComponent(o)}` : "";
  switch (e) {
    case Ae.WORKSPACE:
      return un.post(
        `/atlas/${t}/assets/${n}/${r}/import-to-workspace${s}`
      );
    case Ae.STUDY:
      return un.post(
        `/atlas/${t}/assets/${n}/${r}/import-to-study/${i}${s}`
      );
  }
}, Hv = (e) => {
  switch (e) {
    case Mi.CS:
      return wt.CONCEPT_SET;
    case Mi.COHORT:
      return wt.COHORT;
    case Mi.CC:
      return ya.COHORT_CHARACTERIZATION;
    case Mi.PATHWAY:
      return ya.PATHWAY;
    case Mi.IR:
      return ya.INCIDENCE_RATE;
    case Mi.PLE:
      return ya.ESTIMATION;
  }
}, Rh = {
  createCrudMethod: (e, t) => ({
    fetch: (n, r, i, a) => tG(t, e, {
      pageNumber: n,
      pageSize: r,
      sortBy: i,
      query: a
    })
  }),
  createFiltersPanel: (e, t) => ({
    getFilters: (n) => {
      const r = `/atlas/${t}/assets/${e}/filter?${n}`;
      return un.get(r);
    }
  }),
  cols: [
    OL({
      accessorKey: "type",
      id: "typeIcon",
      cell: ({ getValue: e }) => [Mi.CS, Mi.COHORT].includes(
        e()
      ) ? /* @__PURE__ */ p(
        Xi,
        {
          value: Hv(e()),
          size: 26,
          cell: !0
        }
      ) : /* @__PURE__ */ p(
        hA,
        {
          value: Hv(e()),
          size: 26,
          cell: !0
        }
      )
    }),
    Kb({ accessorKey: "externalId", id: "externalId" }),
    qm(),
    Jm(),
    Xm(),
    Km()
  ]
}, aG = (e) => {
  const {
    atlasList: t,
    entity: n,
    isLoadingButton: r,
    onChange: i,
    message: a,
    typeContainer: o,
    parentId: s,
    isSelect: c,
    resolution: l,
    titleExtra: u,
    footerStart: d,
    hideListHeader: f = !1,
    buttonImportText: h
  } = e, { t: m } = Da(), [g, v] = Se(
    t.length > 0 ? t[0].value : null
  ), { enqueueSnackbar: _ } = Zr(), [I, M] = Se(n[0]), [k, y] = Se(Ce.INITIAL), [x, b] = Se(null), [A, w] = Se(!1), [O, P] = Se(), E = n.length > 1 ? 4 : 6, C = async (T) => {
    y(Ce.IN_PROGRESS);
    const D = [];
    try {
      T.forEach((F) => {
        D.push(
          iG(
            o,
            g,
            I,
            F.id || F.externalId,
            s,
            l
          )
        );
      });
      const z = await Promise.all(D);
      i(z), y(Ce.SUCCESS);
    } catch (z) {
      _({
        message: m("messages.atlas_error_import"),
        variant: "error"
      }), y(Ce.ERROR), console.log(z);
    }
  };
  return He(() => {
    nG(g, I).then((T) => {
      b(`Last update ${ke(T.lastRefreshedAt).fromNow()}`);
    });
  }, [g, I, A]), /* @__PURE__ */ B(R, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 12, md: E, children: /* @__PURE__ */ p(an, { name: "atlas", textLabel: m("forms.atlas"), required: !0, children: /* @__PURE__ */ p(
      xr,
      {
        className: "",
        name: "atlas",
        disablePortal: !0,
        id: "atlas",
        options: t,
        value: g,
        placeholder: m("forms.atlas_placeholder"),
        onChange: (T) => {
          v(T);
        },
        fullWidth: !0
      }
    ) }) }),
    n.length > 1 && /* @__PURE__ */ p(R, { item: !0, xs: 12, md: E, children: /* @__PURE__ */ p(an, { name: "asset", textLabel: m("forms.asset"), required: !0, children: /* @__PURE__ */ p(
      xr,
      {
        className: "",
        name: "asset",
        disablePortal: !0,
        id: "asset",
        options: WC.filter(
          (T) => n.includes(T.value)
        ),
        value: I,
        placeholder: m("forms.asset_placeholder"),
        onChange: (T) => {
          M(T);
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ p(
      R,
      {
        item: !0,
        xs: 12,
        md: E,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: { xs: "flex-start", md: "flex-end" },
        children: /* @__PURE__ */ p(he, { sx: { minHeight: 40, display: "flex", alignItems: "center" }, children: A ? /* @__PURE__ */ p(yt, { size: 12 }) : /* @__PURE__ */ B(
          Ks,
          {
            size: "small",
            onClick: async () => {
              try {
                w(!0), await rG(g, I), P(Kv()), w(!1);
              } catch {
                w(!1);
              }
            },
            name: "reload",
            children: [
              /* @__PURE__ */ p(
                he,
                {
                  component: "span",
                  sx: { display: "inline-block", paddingRight: "10px" },
                  children: x
                }
              ),
              /* @__PURE__ */ p(pt, { text: "reload", children: /* @__PURE__ */ p(pe, { iconName: "reload", sx: { fontSize: 12 } }) })
            ]
          }
        ) })
      }
    ),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
      /* @__PURE__ */ p(Sa, {}),
      /* @__PURE__ */ p(
        xC,
        {
          titleTable: m("features.atlas_import.all_elements", {
            message: a
          }),
          titleExtra: u,
          footerStart: d,
          loadingMessage: m("features.atlas_import.loading_message", {
            message: a
          }),
          buttonImportText: h || m("features.atlas_import.add_button", {
            message: a
          }),
          isLoadingButton: r || k === Ce.IN_PROGRESS,
          isSelect: c,
          onChange: async (T) => {
            await C(T);
          },
          typeContainer: I,
          parentId: g,
          isOutsideLoading: A,
          hideHeader: f,
          reloadId: O,
          idSelector: "externalId",
          createListMethods: Rh.createCrudMethod,
          cols: Rh.cols,
          createListFiltersMethod: Rh.createFiltersPanel
        }
      )
    ] })
  ] });
}, oG = (e) => {
  switch (e) {
    case Et.CREATE_NEW_OBJECT:
      return Et.CREATE_NEW_OBJECT;
    case Et.CREATE_NEW_VERSION:
      return Et.CREATE_NEW_VERSION;
    default:
      return e;
  }
}, sG = (e, t, n, r, i) => (a, o, s) => {
  const c = oG(s), l = c ? `?resolution=${encodeURIComponent(c)}` : "";
  switch (t) {
    case Ae.STUDY:
      return un.post(
        `/studies/${n}/${e}/copy/${a}${l}`,
        o ? { name: o } : {}
      );
    case Ae.WORKSPACE:
      return un.post(
        `/workspace/${e}/copy/${a}${l}`,
        o ? { name: o } : {}
      );
    case li.ATLAS:
      return un.post(
        `/atlas/${r}/assets/${i}/export?id=${a}&name=${o}`
      );
  }
}, wQ = (e) => {
  const {
    name: t,
    manualImport: n = !1,
    localImport: r = !1,
    currentContainer: i,
    parentId: a,
    isSelect: o = !1,
    onChange: s,
    subModules: c,
    analysisMode: l,
    atlasEntity: u,
    successMessage: d,
    analysesTypes: f,
    disableImportContainer: h,
    localImportComponent: m,
    manualImportComponent: g,
    cols: v,
    createListMethods: _,
    createListFiltersMethod: I,
    createMethodCreate: M,
    getEntity: k,
    disableRowSelect: y,
    disableRowSelectOnSameContainerOnly: x = !1,
    alertText: b,
    disableManualImport: A,
    disableAltasImport: w,
    defaultResolution: O = Et.CREATE_NEW_OBJECT,
    hideConflictResolutionMethod: P = !1,
    hideConflictResolutionControls: E = !1,
    hidePendingCancelButton: C = !1,
    toggleSingleSelectionOnRowClick: T = !1,
    disableCopy: D = !1
  } = e, { enqueueSnackbar: z } = Zr(), [F, W] = Se([]), [L, S] = Se(!1), [j, Y] = Se(O), N = Et.CREATE_NEW_OBJECT, X = Ee(
    () => ["cohorts", "concept-sets"].includes(t),
    [t]
  ), G = Ee(
    () => ["cohorts", "concept-sets", "analyses"].includes(t),
    [t]
  ), q = Ee(
    () => ["cohorts", "concept-sets", "analyses"].includes(t),
    [t]
  ), $ = Ee(() => t === "cohorts" ? "cohorts" : t === "concept-sets" ? "concept-sets" : "objects", [t]), Q = Ee(() => t === "cohorts" ? "Fully identical cohort(s) will not be created, instead existing ones will be reused. Cohort(s) with the same name, but different content will create a new version of the existing ones." : t === "concept-sets" ? "Fully identical concept set(s) will not be created, instead existing ones will be reused. Concept set(s) with the same name, but different content will create a new version of the existing ones and Cohort design will reference these newly created versions." : "Fully identical objects will not be created, instead existing ones will be reused.", [t]), V = Ee(() => t === "cohorts" ? "New cohort(s) will be created, even if identical cohort(s) exist." : t === "concept-sets" ? "New concept set(s) will be created, even if identical concept set(s) exist." : "New objects will be created, even if identical objects exist.", [t]), H = Ee(
    () => t === "concept-sets" || t === "cohorts" || t === "analyses" ? "Import" : `Add ${t}`,
    [t]
  ), K = Ee(() => d || (t === "concept-sets" ? "Concept set(s) successfully imported." : t === "cohorts" ? "Cohort(s) successfully imported." : "Successfully copied"), [t, d]), [U, ee] = Se(
    r ? li.LOCAL : l ? i === Ae.WORKSPACE ? Ae.WORKSPACE : i === Ae.LIBRARY ? Ae.LIBRARY : Ae.STUDY : i === Ae.WORKSPACE ? Ae.STUDY : i === Ae.LIBRARY ? Ae.LIBRARY : Ae.WORKSPACE
  ), [ce, se] = Se(
    i === Ae.STUDY ? a : void 0
  ), ne = Ee(
    () => U !== Ae.STUDY || !!ce,
    [U, ce]
  ), re = Ee(
    () => q && U === Ae.STUDY && !ce,
    [q, U, ce]
  ), [Me, Re] = Se([]), oe = Ee(
    () => !E && X && [
      Ae.WORKSPACE,
      Ae.STUDY,
      Ae.LIBRARY,
      li.ATLAS
    ].includes(U),
    [U, E, X]
  ), de = Ee(() => U === Ae.WORKSPACE ? i === Ae.WORKSPACE : U === Ae.STUDY ? i === Ae.STUDY && ce === a : !1, [U, i, a, ce]), ue = Ee(() => {
    if (y)
      return x ? de ? y : void 0 : y;
  }, [
    y,
    x,
    de
  ]), me = (c == null ? void 0 : c.study) || /* @__PURE__ */ p(ze, {}), Z = Ee(() => sG(t, i, a), [i, a]), le = Ee(() => M(i, a), [i, a]), J = Ee(() => {
    if (!l && i === Ae.WORKSPACE)
      return h ? [Ae.STUDY] : [Ae.STUDY, Ae.LIBRARY];
    const ie = h ? [Ae.WORKSPACE, Ae.STUDY] : [
      Ae.WORKSPACE,
      Ae.STUDY,
      Ae.LIBRARY
    ];
    return h && i === Ae.LIBRARY && !ie.includes(Ae.LIBRARY) ? [...ie, Ae.LIBRARY] : ie;
  }, [l, i, h]), ae = Ee(() => eG(
    n,
    r,
    J,
    F.length,
    ee,
    i,
    A,
    w
  ), [F, A, w]), ge = Ee(() => D ? !1 : t === "concept-sets" || t === "cohorts" ? i !== Ae.LIBRARY : !(l && i === U && (U === Ae.WORKSPACE || U === Ae.STUDY && a === ce)), [
    t,
    l,
    i,
    U,
    D,
    a,
    ce
  ]);
  He(() => {
    w || ZU().then((ie) => {
      W(
        ie.map((ve) => ({
          value: ve.id,
          name: ve.url
        }))
      );
    }).catch(() => {
      z({
        message: "Atlas list have not loaded",
        variant: "error"
      });
    });
  }, [w, z]);
  const be = async (ie, ve) => {
    const _e = X ? P ? N : de ? Et.CREATE_NEW_VERSION : j : void 0;
    try {
      const Ie = ie.map((Qe) => {
        const et = Z == null ? void 0 : Z(Qe.id, void 0, _e);
        return !et || typeof et.then != "function" ? Promise.resolve(null) : et.catch((_t) => (z({
          message: `Something wrong. ${Qe.name} was not copied!`,
          variant: "error"
        }), console.error(_t), null));
      }), Pe = await Promise.all(Ie);
      s(Pe.filter((Qe) => Qe)), z({
        message: K,
        variant: "success"
      });
    } catch {
      s(null), z({
        message: "Oops! Something wrong",
        variant: "error"
      });
    } finally {
      S(!1);
    }
  }, we = async (ie) => {
    try {
      return k ? await Promise.all(ie.map((ve) => k(ve.id))) : ie;
    } catch (ve) {
      return console.log(ve), ie;
    }
  }, We = /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", columnGap: 1.5, flexWrap: "wrap", children: [
    /* @__PURE__ */ p(fe, { variant: "caption", sx: { whiteSpace: "nowrap" }, children: "Select conflict resolution method:" }),
    /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
      /* @__PURE__ */ p(
        lu,
        {
          checked: j === Et.CREATE_NEW_VERSION,
          onChange: () => Y(Et.CREATE_NEW_VERSION),
          name: "import-resolution",
          size: "small",
          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
        }
      ),
      /* @__PURE__ */ p(fe, { variant: "caption", children: `Overwrite existing ${$}` }),
      /* @__PURE__ */ p(pt, { text: Q, children: /* @__PURE__ */ p(
        pe,
        {
          iconName: "info",
          sx: { fontSize: 12, color: "text.secondary" }
        }
      ) })
    ] }),
    /* @__PURE__ */ B(he, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
      /* @__PURE__ */ p(
        lu,
        {
          checked: j === Et.CREATE_NEW_OBJECT,
          onChange: () => Y(Et.CREATE_NEW_OBJECT),
          name: "import-resolution",
          size: "small",
          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
        }
      ),
      /* @__PURE__ */ p(fe, { variant: "caption", children: `Create new ${$}` }),
      /* @__PURE__ */ p(pt, { text: V, children: /* @__PURE__ */ p(
        pe,
        {
          iconName: "info",
          sx: { fontSize: 12, color: "text.secondary" }
        }
      ) })
    ] })
  ] });
  return /* @__PURE__ */ B(R, { container: !0, children: [
    /* @__PURE__ */ p(wr, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ p(Of, { tabs: ae, active: U }) }),
    /* @__PURE__ */ p(R, { container: !0, p: 2, children: U === li.LOCAL ? /* @__PURE__ */ p(R, { item: !0, xs: 12, children: m }) : /* @__PURE__ */ p(dr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ B(R, { item: !0, container: !0, xs: 12, p: 2, children: [
      b && /* @__PURE__ */ p(R, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ p(vm, { severity: "warning", children: b }) }),
      U === li.MANUAL && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: Xe.isValidElement(g) ? Xe.cloneElement(g, {
        resolution: X ? P ? N : j : void 0,
        onResolutionChange: X && !P && !E ? Y : void 0
      }) : g }),
      U === Ae.STUDY && /* @__PURE__ */ p(R, { item: !0, xs: 12, pb: 2, children: /* @__PURE__ */ p(
        me,
        {
          type: "component",
          name: "studies-list-select",
          subModules: c,
          config: {
            onChange: (ie) => {
              se(ie || void 0);
            },
            analysisMode: l,
            studyInitialId: ce,
            pureControl: !0
          }
        }
      ) }),
      [
        Ae.WORKSPACE,
        Ae.STUDY,
        Ae.LIBRARY
      ].includes(U) && ne && /* @__PURE__ */ B(R, { item: !0, xs: 12, children: [
        /* @__PURE__ */ p(
          xC,
          {
            titleTable: `All ${t}`,
            loadingMessage: `Loading ${t}`,
            buttonImportText: H,
            hideHeader: G,
            footerStart: oe && o ? We : void 0,
            hideEmptyTable: re,
            isLoadingButton: L,
            isSelect: o,
            toggleSelectionOnRowClick: T,
            disableRowSelect: ue,
            onChange: async (ie) => {
              const ve = await we(ie);
              if (Z && ge) {
                if (!Array.isArray(ve) || ve.length === 0)
                  return;
                S(!0), await be(ve);
              } else
                s(ve);
            },
            typeContainer: U,
            parentId: ce || void 0,
            createListMethods: _,
            cols: v,
            createListFiltersMethod: I
          },
          `${U}-${ce || "empty"}`
        ),
        Me.length > 0 && /* @__PURE__ */ B(
          he,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: oe ? "space-between" : "flex-end",
            sx: {
              position: "sticky",
              bottom: 0,
              zIndex: 3,
              px: 2,
              py: 1,
              borderTop: 1,
              borderColor: "divider",
              bgcolor: "background.paper",
              boxShadow: "0 -2px 8px rgba(15, 23, 42, 0.08)"
            },
            children: [
              oe && We,
              /* @__PURE__ */ B(he, { display: "flex", gap: 1, ml: 2, children: [
                !C && /* @__PURE__ */ p(
                  Te,
                  {
                    variant: "outlined",
                    size: "small",
                    onClick: () => Re([]),
                    children: "Cancel"
                  }
                ),
                /* @__PURE__ */ p(
                  Te,
                  {
                    variant: "contained",
                    size: "small",
                    disabled: L,
                    onClick: async () => {
                      S(!0), await be(Me), Re([]);
                    },
                    children: "Add"
                  }
                )
              ] })
            ]
          }
        )
      ] }),
      U === li.ATLAS && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
        aG,
        {
          message: t,
          buttonImportText: H,
          hideListHeader: G,
          isLoadingButton: L,
          resolution: X ? P ? N : j : void 0,
          footerStart: oe ? We : void 0,
          atlasList: F,
          entity: u,
          createMethod: le,
          analysesTypes: f,
          typeContainer: i,
          parentId: a,
          isSelect: o,
          onChange: (ie) => {
            s(ie), z({
              message: K,
              variant: "success"
            });
          }
        }
      ) })
    ] }) }) })
  ] });
}, lG = () => un.get("/atlases"), cG = (e) => (e = e ? "&analysis.type=" + e : "", un.get("studies/export-list?size=10000" + e)), uG = (e, t, n) => {
  const r = [
    {
      value: "CONTAINER",
      title: "Export",
      onTabClick: t
    },
    {
      value: "JSON",
      title: e,
      onTabClick: t
    }
  ];
  return n && r.push({
    value: "SQL",
    title: "SQL",
    onTabClick: t
  }), r;
}, yi = (e) => typeof e == "object" && e !== null, fG = (e) => e === Ae.WORKSPACE || e === Ae.STUDY || e === Ae.LIBRARY || e === Ae.DETACHED || e === "ATLAS", dG = (e) => {
  if (!yi(e))
    return "Oops! Something wrong";
  const t = e.response;
  if (!yi(t))
    return "Oops! Something wrong";
  const n = t.data;
  return yi(n) && typeof n.message == "string" ? n.message : "Oops! Something wrong";
}, vC = (e) => {
  if (!yi(e))
    return null;
  const t = e.response;
  if (!yi(t))
    return null;
  const n = t.data;
  return yi(n) ? n : null;
}, hG = (e) => {
  var t;
  return typeof e != "string" ? null : ((t = e.match(/Object with name \[(.*)] already exists/)) == null ? void 0 : t[1]) ?? null;
}, pG = (e) => {
  const t = vC(e), n = t == null ? void 0 : t.suggestedName;
  return typeof n == "string" && n.trim() ? n.trim() : null;
}, mG = (e) => Array.isArray(e) ? e.map((t) => {
  if (!yi(t))
    return null;
  const n = t.id, r = t.url;
  return typeof n != "string" && typeof n != "number" || typeof r != "string" ? null : {
    value: n,
    name: r
  };
}).filter((t) => t !== null) : [], gG = (e) => !yi(e) || !Array.isArray(e.content) ? [] : e.content.map((t) => {
  if (!yi(t))
    return null;
  const n = t.id, r = t.title;
  return typeof n != "string" && typeof n != "number" || typeof r != "string" ? null : {
    ...t,
    id: n,
    value: n,
    name: r
  };
}).filter((t) => t !== null), _Q = ({
  id: e,
  name: t,
  jsonImportTabName: n = "JSON",
  currentContainer: r,
  parentId: i,
  createCopyMethod: a,
  successMessage: o = "Successfully copied",
  onChange: s,
  typeEntity: c,
  analysisType: l,
  entityAtlas: u,
  validateName: d,
  exportJson: f,
  exportSql: h,
  exportAtlasWarning: m,
  exportJsonWarning: g,
  customAction: v,
  defaultResolution: _,
  hideConflictResolutionControls: I = !1
}) => {
  const M = Tr(), { enqueueSnackbar: k } = Zr(), [y, x] = Se("CONTAINER"), [b, A] = Se({
    typeContainer: r,
    studyId: i,
    title: t
  }), [w, O] = Se(Ce.INITIAL), [P, E] = Se([]), [C, T] = Se(null), [D, z] = Se(
    []
  ), [F, W] = Se(""), [L, S] = Se(
    _ ?? (c === "concept-sets" ? Et.CREATE_NEW_OBJECT : Et.CREATE_NEW_VERSION)
  ), [j, Y] = Se(""), [N, X] = Se(null), G = Ge((oe) => {
    (oe === "JSON" || oe === "SQL" || oe === "CONTAINER") && x(oe);
  }, []), q = Ee(
    () => uG(n, G, !!h),
    [n, G, h]
  ), $ = Ee(
    () => b.typeContainer === "ATLAS" ? a(
      b.typeContainer,
      b.studyId,
      C,
      u
    ) : a(b.typeContainer, b.studyId),
    [
      b.typeContainer,
      b.studyId,
      C,
      u,
      a
    ]
  ), Q = Ee(() => b.typeContainer === Ae.WORKSPACE ? `/workspace/${c}/` : b.typeContainer === Ae.STUDY && b.studyId ? `/study-manager/${b.studyId}/${c}/` : null, [b.typeContainer, b.studyId, c]);
  He(() => {
    lG().then((oe) => {
      var ue;
      const de = mG(oe);
      E(de), T(((ue = de[0]) == null ? void 0 : ue.value) ?? null);
    }).catch(() => {
      k({
        message: "Atlas list have not loaded",
        variant: "error"
      });
    }), cG(l || "").then((oe) => {
      z(gG(oe));
    }).catch(() => {
      k({
        message: "Export Study list have not loaded",
        variant: "error"
      });
    });
  }, [l, k]), He(() => {
    w === Ce.SUCCESS && k({
      message: o,
      variant: "success"
    });
  }, [w, o, k]);
  const V = ["concept-sets", "cohorts"].includes(c) && b.typeContainer !== "ATLAS", H = L === Et.CREATE_NEW_OBJECT, K = Ge(() => {
    W(""), Y("");
  }, []);
  He(() => {
    H || K();
  }, [H, K]);
  const U = async () => {
    O(Ce.IN_PROGRESS);
    const oe = b.title.trim(), de = !!d && b.typeContainer !== "ATLAS" && (!V || H), ue = V ? H ? Et.CREATE_NEW_OBJECT : Et.CREATE_NEW_VERSION : Et.CREATE_NEW_OBJECT;
    try {
      if (d && de) {
        const le = await Promise.resolve(
          d({
            typeContainer: b.typeContainer,
            studyId: b.studyId,
            name: oe
          })
        );
        if (!(le != null && le.isValid)) {
          W(
            (le == null ? void 0 : le.message) || "Error! Name is already used by another object."
          ), Y(oe), O(Ce.INITIAL);
          return;
        }
        K();
      }
      const me = (le) => Promise.resolve($(e, le, ue));
      let Z;
      try {
        Z = await me(oe);
      } catch (le) {
        const J = vC(le), ae = hG(J == null ? void 0 : J.message), ge = pG(le);
        if (!(c === "analyses" && b.typeContainer !== "ATLAS" && ue === Et.CREATE_NEW_OBJECT && !!ge && ae === oe) || !ge)
          throw le;
        Z = await me(ge);
      }
      O(Ce.SUCCESS), b.typeContainer !== "ATLAS" && Q && Z && typeof Z == "object" && "id" in Z && M(`${Q}${Z.id}`), s();
    } catch (me) {
      k({
        message: dG(me),
        variant: "error"
      }), O(Ce.ERROR);
    }
  }, ee = Ee(() => !!(b.typeContainer === Ae.WORKSPACE || b.typeContainer === "ATLAS" || b.typeContainer === Ae.STUDY && b.studyId), [b.typeContainer, b.studyId]), ce = "Select conflict resolution method:", se = "concept-sets", ne = "Fully identical concept set(s) will not be created, instead existing ones will be reused. Concept set(s) with the same name, but different content will create a new version of the existing ones and Cohort design will reference these newly created versions.", re = "New concept set(s) will be created, even if identical concept set(s) exist.", Me = H && F.length > 0 && b.title.trim().length > 0 && b.title.trim() === j, Re = y === "CONTAINER" && b.typeContainer === "ATLAS" && m || y === "JSON" && g || null;
  return /* @__PURE__ */ B(R, { container: !0, children: [
    /* @__PURE__ */ p(wr, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ B(R, { container: !0, justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ p(Of, { tabs: q, active: y }),
      /* @__PURE__ */ p(R, { item: !0, children: v })
    ] }) }),
    /* @__PURE__ */ B(R, { item: !0, xs: 12, p: 2, children: [
      Re && /* @__PURE__ */ p(R, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ p(vm, { severity: "warning", children: Re }) }),
      y === "CONTAINER" && /* @__PURE__ */ p(dr, { children: /* @__PURE__ */ B(R, { container: !0, spacing: 1, p: 2, children: [
        /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
          an,
          {
            name: "typeContainer",
            textLabel: "Export to",
            required: !0,
            children: /* @__PURE__ */ p(
              xr,
              {
                name: "typeContainer",
                disablePortal: !0,
                id: "typeContainer",
                options: gm.filter(
                  (oe) => u ? oe : oe.value !== "ATLAS"
                ),
                value: b.typeContainer,
                placeholder: "Select type",
                onChange: (oe) => {
                  fG(oe) && (A((de) => ({
                    ...de,
                    typeContainer: oe
                  })), K());
                },
                fullWidth: !0
              }
            )
          }
        ) }),
        b.typeContainer === Ae.STUDY && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(an, { name: "study", textLabel: "Study", children: /* @__PURE__ */ p(
          mA,
          {
            name: "studies",
            id: "studies",
            options: D,
            value: N,
            placeholder: "Select study...",
            fullWidth: !0,
            isOptionEqualToValue: (oe, de) => oe.value === de.value,
            onChange: (oe, de) => {
              X(de), A((ue) => ({
                ...ue,
                studyId: de == null ? void 0 : de.id
              })), K();
            },
            getOptionLabel: (oe) => oe.name
          }
        ) }) }),
        b.typeContainer === "ATLAS" && u && /* @__PURE__ */ p(R, { item: !0, xs: 5, children: /* @__PURE__ */ p(an, { name: "atlas", textLabel: "Atlas", required: !0, children: /* @__PURE__ */ p(
          xr,
          {
            name: "atlas",
            disablePortal: !0,
            id: "atlas",
            options: P,
            value: C,
            placeholder: "Select atlas resource",
            onChange: (oe) => {
              typeof oe != "string" && typeof oe != "number" || T(oe);
            },
            fullWidth: !0
          }
        ) }) }),
        ee && /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(an, { name: "title", textLabel: "Title", required: !0, children: [
          /* @__PURE__ */ p(
            _r,
            {
              id: "title",
              name: "title",
              type: "text",
              size: "medium",
              placeholder: "Enter title",
              value: b.title,
              onChange: (oe) => {
                A((de) => ({
                  ...de,
                  title: oe.target.value
                })), oe.target.value.trim() !== j && K();
              },
              fullWidth: !0,
              required: !0
            }
          ),
          F && /* @__PURE__ */ p(fe, { color: "error.main", variant: "caption", children: F })
        ] }) }),
        /* @__PURE__ */ p(R, { item: !0, xs: 12, mt: 0.5, children: /* @__PURE__ */ B(
          R,
          {
            container: !0,
            alignItems: "center",
            justifyContent: "space-between",
            columnSpacing: 2,
            rowSpacing: 1,
            children: [
              /* @__PURE__ */ p(R, { item: !0, xs: 12, md: !0, children: V && !I && /* @__PURE__ */ B(
                R,
                {
                  display: "flex",
                  alignItems: "center",
                  columnGap: 1.5,
                  flexWrap: "nowrap",
                  sx: { maxWidth: "100%", overflowX: "auto", py: 0.25 },
                  children: [
                    /* @__PURE__ */ p(
                      fe,
                      {
                        variant: "caption",
                        sx: { whiteSpace: "nowrap" },
                        children: ce
                      }
                    ),
                    /* @__PURE__ */ B(
                      R,
                      {
                        display: "flex",
                        alignItems: "center",
                        columnGap: 1.5,
                        sx: { whiteSpace: "nowrap" },
                        children: [
                          /* @__PURE__ */ B(
                            R,
                            {
                              display: "flex",
                              alignItems: "center",
                              columnGap: 0.75,
                              children: [
                                /* @__PURE__ */ p(
                                  lu,
                                  {
                                    checked: L === Et.CREATE_NEW_VERSION,
                                    onChange: () => S(
                                      Et.CREATE_NEW_VERSION
                                    ),
                                    name: "export-resolution",
                                    size: "small",
                                    sx: {
                                      p: 0.25,
                                      "& .MuiSvgIcon-root": { fontSize: 16 }
                                    }
                                  }
                                ),
                                /* @__PURE__ */ p(fe, { variant: "caption", children: `Overwrite existing ${se}` }),
                                /* @__PURE__ */ p(
                                  pt,
                                  {
                                    text: ne,
                                    children: /* @__PURE__ */ p(
                                      pe,
                                      {
                                        iconName: "info",
                                        sx: { fontSize: 12, color: "text.secondary" }
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ B(
                            R,
                            {
                              display: "flex",
                              alignItems: "center",
                              columnGap: 0.75,
                              children: [
                                /* @__PURE__ */ p(
                                  lu,
                                  {
                                    checked: L === Et.CREATE_NEW_OBJECT,
                                    onChange: () => S(
                                      Et.CREATE_NEW_OBJECT
                                    ),
                                    name: "export-resolution",
                                    size: "small",
                                    sx: {
                                      p: 0.25,
                                      "& .MuiSvgIcon-root": { fontSize: 16 }
                                    }
                                  }
                                ),
                                /* @__PURE__ */ p(fe, { variant: "caption", children: `Create new ${se}` }),
                                /* @__PURE__ */ p(
                                  pt,
                                  {
                                    text: re,
                                    children: /* @__PURE__ */ p(
                                      pe,
                                      {
                                        iconName: "info",
                                        sx: { fontSize: 12, color: "text.secondary" }
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ) }),
              /* @__PURE__ */ p(R, { item: !0, xs: 12, md: "auto", children: /* @__PURE__ */ B(xf, { children: [
                /* @__PURE__ */ p(
                  Te,
                  {
                    variant: "outlined",
                    onClick: s,
                    size: "small",
                    startIcon: /* @__PURE__ */ p(pe, { iconName: "deactivate" }),
                    name: "cancel",
                    children: "Cancel"
                  }
                ),
                /* @__PURE__ */ p(
                  Te,
                  {
                    disabled: !ee || Ce.IN_PROGRESS === w || Me,
                    onClick: U,
                    variant: "contained",
                    size: "small",
                    color: "success",
                    startIcon: /* @__PURE__ */ p(pe, { iconName: "submit" }),
                    name: "export",
                    children: "Export"
                  }
                )
              ] }) })
            ]
          }
        ) })
      ] }) }),
      y === "JSON" && /* @__PURE__ */ p(wr, { elevation: 3, children: f }),
      y === "SQL" && h && /* @__PURE__ */ p(wr, { elevation: 3, children: h })
    ] })
  ] });
}, AC = te(Ks)`
  &:hover {
    background: transparent;
  }
`, SQ = ({
  title: e,
  onClick: t,
  iconName: n,
  description: r,
  buttonName: i
}) => /* @__PURE__ */ p(wr, { elevation: 3, sx: { minHeight: "100%" }, children: /* @__PURE__ */ p(R, { container: !0, p: 3, children: /* @__PURE__ */ B(
  R,
  {
    item: !0,
    xs: 12,
    justifyContent: "space-between",
    container: !0,
    sx: { cursor: "default" },
    children: [
      /* @__PURE__ */ p(AC, { onClick: t, children: /* @__PURE__ */ p(
        yf,
        {
          iconName: n,
          sx: { fontSize: "80px", pl: 1.5, alignSelf: "start", pt: 1 }
        }
      ) }),
      /* @__PURE__ */ B(R, { item: !0, container: !0, maxWidth: "calc(100% - 116px)", spacing: 1, children: [
        /* @__PURE__ */ p(
          R,
          {
            item: !0,
            xs: 12,
            fontSize: 20,
            fontWeight: 400,
            color: "textColor.header",
            children: e
          }
        ),
        /* @__PURE__ */ p(
          R,
          {
            item: !0,
            xs: 12,
            sx: (a) => ({ color: a.palette.grey[600], fontSize: 13 }),
            children: r
          }
        ),
        /* @__PURE__ */ p(R, { item: !0, xs: 12, children: i && /* @__PURE__ */ p(R, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ p(
          Te,
          {
            onClick: () => t == null ? void 0 : t(),
            variant: "outlined",
            name: "save",
            children: i
          }
        ) }) })
      ] })
    ]
  }
) }) }), CQ = ({ children: e, title: t, description: n, actions: r, iconName: i, onClick: a }) => /* @__PURE__ */ p(wr, { elevation: 3, sx: { minHeight: e ? "100%" : "auto" }, children: /* @__PURE__ */ B(R, { container: !0, p: 3, children: [
  /* @__PURE__ */ B(
    R,
    {
      item: !0,
      xs: 12,
      borderBottom: e ? "1px solid" : "none",
      borderColor: "borderColor.main",
      justifyContent: "space-between",
      pb: e ? 2 : 0,
      container: !0,
      sx: { cursor: "default" },
      children: [
        /* @__PURE__ */ p(AC, { onClick: a, children: /* @__PURE__ */ p(
          yf,
          {
            iconName: i,
            sx: { fontSize: "80px", pl: 1.5, alignSelf: "start", pt: 1 }
          }
        ) }),
        /* @__PURE__ */ B(R, { item: !0, container: !0, maxWidth: "calc(100% - 116px)", spacing: 1, children: [
          /* @__PURE__ */ p(
            R,
            {
              item: !0,
              xs: 12,
              fontSize: 20,
              fontWeight: 400,
              color: "textColor.header",
              children: t
            }
          ),
          /* @__PURE__ */ p(
            R,
            {
              item: !0,
              xs: 12,
              sx: (o) => ({ color: o.palette.grey[600], fontSize: 13 }),
              children: n
            }
          ),
          /* @__PURE__ */ p(R, { item: !0, xs: 12, children: r })
        ] })
      ]
    }
  ),
  e
] }) }), EQ = ({ children: e, title: t, description: n, iconName: r, onCardClick: i }) => /* @__PURE__ */ p(
  R,
  {
    container: !0,
    item: !0,
    xs: 12,
    sx: (a) => ({
      padding: 1.5,
      "&:hover": {
        backgroundColor: a.palette.info.light + 50,
        ".description": {
          color: a.palette.grey[800]
        }
      }
    }),
    onClick: (a) => {
      a.stopPropagation(), i(a);
    },
    children: /* @__PURE__ */ B(
      R,
      {
        container: !0,
        spacing: 2,
        flexWrap: "nowrap",
        alignItems: "center",
        flexDirection: { xs: "row", md: "column", lg: "row" },
        sx: { cursor: "pointer" },
        children: [
          /* @__PURE__ */ B(
            R,
            {
              item: !0,
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "center",
              xs: 12,
              children: [
                /* @__PURE__ */ p(R, { item: !0, mr: 2, className: "icon-container", children: /* @__PURE__ */ p(
                  yf,
                  {
                    iconName: r,
                    sx: { fontSize: 48 },
                    color: "secondary"
                  }
                ) }),
                /* @__PURE__ */ B(
                  R,
                  {
                    item: !0,
                    sx: (a) => ({
                      ".title": {
                        fontSize: 14,
                        fontWeight: 500,
                        color: "textColor.header",
                        marginBottom: 0.5
                      },
                      ".description": {
                        fontSize: 12,
                        color: a.palette.grey[600]
                      }
                    }),
                    children: [
                      /* @__PURE__ */ p("div", { className: "title", children: t }),
                      /* @__PURE__ */ p("div", { className: "description", children: n })
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ p(R, { item: !0, children: e })
        ]
      }
    )
  }
), kQ = te((e) => /* @__PURE__ */ p(R, { item: !0, xs: 12, pt: 1.5, children: /* @__PURE__ */ p(R, { container: !0, spacing: 1, ...e, children: e.children }) }))({}), TQ = te((e) => /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p("div", { ...e, children: e.children }) }))(
  ({ theme: e, light: t }) => ({
    maxWidth: "100%",
    fontSize: 13,
    fontWeight: "bold",
    color: e.palette.grey[900],
    backgroundColor: t ? "#f6f8fa" : e.palette.backgroundColor.main,
    padding: "8px 12px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: e.palette.info.main + 20
    },
    ".light-text": {
      flex: "1 1 auto",
      fontWeight: 300,
      minWidth: 132,
      maxWidth: 220,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    ".list-item-section": {
      display: "flex",
      alignItems: "center",
      height: 24,
      minWidth: 0,
      "&.nowrap": {
        flex: "1 1 auto",
        overflow: "hidden",
        "> *:first-of-type": {
          flex: "0 0 auto"
        }
      },
      "&:not(.nowrap)": {
        flex: "0 1 auto",
        justifyContent: "flex-end",
        maxWidth: "45%",
        overflow: "hidden",
        ".status-tag": {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flex: "0 0 24px",
          width: 24,
          minWidth: 24
        }
      },
      "> *:not(:last-child)": {
        marginRight: 12
      },
      ".list-item-title": {
        flex: "1 1 auto",
        minWidth: 0,
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        paddingRight: "4px"
      }
    },
    "&.documentation-list-item": {
      ".list-item-section": {
        "&.nowrap": {
          flex: "1 1 0%",
          minWidth: 0,
          overflow: "hidden"
        },
        "&:not(.nowrap)": {
          flex: "0 0 auto",
          maxWidth: "none",
          overflow: "visible",
          gap: 12,
          "> *:not(:last-child)": {
            marginRight: 0
          },
          ".status-tag": {
            flex: "0 0 auto",
            width: "auto",
            minWidth: 60,
            whiteSpace: "nowrap"
          }
        }
      },
      // Ellipsis the (often long) file name instead of hard-clipping it.
      ".list-item-title": {
        display: "block",
        flex: "1 1 auto",
        minWidth: 0,
        maxWidth: "100%",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    },
    "&.favorite-study-list-item": {
      display: "flex",
      alignItems: "center",
      gap: 12,
      ".list-item-section": {
        height: 24,
        minWidth: 0,
        // Icons + study name — fills all remaining space.
        "&.nowrap": {
          flex: "1 1 auto",
          overflow: "hidden"
        },
        // Study type + status icon — sized to its content, so the type
        // sits right next to the name instead of leaving a large gap.
        "&:not(.nowrap)": {
          flex: "0 0 auto",
          maxWidth: "none",
          justifyContent: "flex-end",
          overflow: "hidden",
          gap: 12,
          "> *:not(:last-child)": {
            marginRight: 0
          }
        }
      },
      // Study name — fills remaining space, ellipsis when it doesn't fit.
      ".list-item-title": {
        flex: "1 1 auto",
        minWidth: 0,
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        paddingRight: "4px"
      },
      // Study type — natural width up to the width of "Safety and Efficacy",
      // then ellipsis. Shorter types (e.g. "Epidemiology") take only the
      // space they need, giving the name more room.
      ".light-text": {
        flex: "0 0 auto",
        minWidth: 0,
        maxWidth: 132,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      ".status-tag": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 24px",
        width: 24,
        minWidth: 24
      }
    }
  })
), yG = [
  {
    Header: "Type",
    accessor: "entityType",
    Cell: Xi,
    width: "5%",
    minWidth: 40
  },
  qm({ Cell: ML }),
  Jm({ Header: "Date" }),
  Xm(),
  Km()
], MQ = ({ getList: e }) => {
  const t = Tr(), n = gE({
    methods: {
      read: {
        method: e,
        // todo
        formatter: ([a, o, s, c]) => [
          ...(a == null ? void 0 : a.content.map((u) => ({
            ...u,
            entityType: wt.COHORT
          }))) || [],
          ...(s == null ? void 0 : s.content.map((u) => ({
            ...u,
            entityType: wt.CONCEPT_SET
          }))) || [],
          ...(o == null ? void 0 : o.content.map((u) => ({
            ...u,
            entityType: wt.ANALYSIS,
            name: u.title
          }))) || [],
          ...(c == null ? void 0 : c.content.map((u) => ({
            ...u,
            entityType: wt.ANALYSIS_SUBMISSION,
            name: u.analysisTitle + " executed"
          }))) || []
        ]
      }
    },
    primaryKey: "id"
  }), r = Xe.useMemo(
    () => Object.values(n.data.byId),
    [n.data.byId]
  ), i = (a) => {
    switch (a.original.entityType) {
      case wt.ANALYSIS_SUBMISSION: {
        t(
          `${P1[a.original.entityType]}/${a.original.analysisId}/executions`
        );
        break;
      }
      default:
        t(
          `${P1[a.original.entityType]}/${a.original.id}`
        );
    }
  };
  return Xe.useEffect(() => {
    n.getEntityList();
  }, []), /* @__PURE__ */ B(R, { container: !0, item: !0, xs: 12, children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 12, mb: 1.5, children: /* @__PURE__ */ p(fe, { variant: "h2", children: "Latest activity" }) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Ml,
      {
        data: r,
        columns: yG,
        initialSort: { id: "modified.timestamp", desc: !0 },
        pageSize: 8,
        isLoading: n.isLoading,
        onRowClick: i,
        hiddenColumns: { "created.timestamp": !1 },
        skeletonRows: 8,
        skeletonVariant: "default",
        skeletonShowHeader: !0,
        skeletonColumnWidths: ["56px", "minmax(0, 1fr)", "190px", "210px"],
        skeletonColumnKinds: ["type-icon", "double-text", "text", "text"],
        skeletonColumnAlignments: ["left", "left", "left", "left"]
      }
    ) })
  ] });
}, xG = te.div`
  /* margin: 3px; */
`, Ps = te.div`
  text-align: center;
  opacity: 0.2;
  font-size: 20px;
  margin: 100px 0;
`;
class vG extends Xe.Component {
  constructor(n) {
    super(n);
    $0(this, "state", {});
    this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0 };
  }
  componentDidCatch(n, r) {
    console.error(n, r);
  }
  render() {
    var n, r;
    return this.state.hasError ? (n = this.props) == null ? void 0 : n.fallback : (r = this.props) == null ? void 0 : r.children;
  }
}
const AG = (e) => {
  switch (e) {
    case rn.CSV:
      return "CSV";
    case rn.PDF:
      return "PDF";
    case rn.HTML:
    case rn.JSON:
    case rn.JS:
    case rn.SQL:
    case rn.R:
    case rn.RPROFILE:
    case rn.TXT:
      return "CODE";
    case rn.ZIP:
    case rn.JAR:
      return "ARCHIVE";
    default:
      return "CODE";
  }
}, bG = (e) => {
  const { fileContent: t, fileMetadata: n, status: r, pdfLink: i, height: a } = e, [o, s] = Se();
  return He(() => {
    n != null && n.ext && s(AG(n.ext));
  }, [n]), r === "LOADING_FILE" ? /* @__PURE__ */ p(Ps, { children: "Loading..." }) : /* @__PURE__ */ p(xG, { children: /* @__PURE__ */ p(
    vG,
    {
      fallback: /* @__PURE__ */ p(Ps, { children: "Content of this file cannot be displayed" }),
      children: /* @__PURE__ */ B(ze, { children: [
        (!t || !o) && /* @__PURE__ */ p(Ps, { children: "Select file to display content" }),
        t && o && /* @__PURE__ */ B(ze, { children: [
          o === "CODE" && /* @__PURE__ */ p(
            Nl,
            {
              data: t,
              height: a || "80vh",
              containerStyles: { padding: 0 },
              enableDownload: !1,
              enableCopy: !0,
              language: pf(n.ext)
            }
          ),
          o === "CSV" && /* @__PURE__ */ p(HA, { data: t, height: 550 }),
          o === "PDF" && /* @__PURE__ */ p(he, { sx: { height: "600px" }, children: /* @__PURE__ */ p(
            GA,
            {
              data: n,
              height: "80vh",
              linkDownload: i,
              scaleDefault: 0.7,
              scroll: !0
            }
          ) }),
          o === "ARCHIVE" && /* @__PURE__ */ p(Ps, { children: "Content of this file cannot be displayed" })
        ] })
      ] })
    }
  ) });
}, wG = te.div`
  box-shadow: ${(e) => e.subList ? "2px 0px 4px -3px transparent;" : "2px 0px 4px -3px transparent"};
  max-height: ${(e) => e.subList ? "auto" : "calc(100vh - 250px)"}; // not good
  overflow: hidden;
  overflow-y: auto;
  border-left: ${(e) => e.subList ? "1px solid #232323" : "0px solid #232323"};
  z-index: 2;
  section {
    height: calc(100vh - 250px);
  }
`, _G = te.div`
  padding: 5px 10px;
  display: flex;
`, SG = te.div`
  margin-left: 15px;
`, CG = te.div`
  width: 5px;
  height: 1px;
  border-bottom: 1px solid #343434;
  position: relative;
  top: 17px;
`;
te.div`
  display: flex;
  flex-direction: row;
`;
const Uv = te.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: ${(e) => e.selectedFile ? "600" : "300"};
  margin-top: 2px;
  margin-left: 7px;
  margin-right: 7px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`, EG = te.span`
  font-weight: 700;
  font-size: 10px;
`, kG = te.div`
  padding: 0px 7px 0px;
  font-size: 11px;
  background: #3a4452;
  color: #ffffff;
  /* width: 18px; */
  /* height: 16px; */
  text-align: center;
  border-radius: 4px;
  padding-top: 2px;
  margin-top: 6px;
  position: relative;
  top: -4px;
`, TG = te.div``, MG = te.div`
  background: #3a4452;
  color: #ffffff;
  padding: 10px 10px;
`, Gv = te.div`
  display: inline-block;
  position: relative;
  top: 2px;
  margin-left: ${(e) => e.marginLeft};
`, Vv = te.div`
  display: unline-block;
  float: right;
`, IG = (e) => {
  const { item: t, selectFile: n, selectedFile: r, status: i, files: a, subList: o } = e, [s, c] = Se(!1), l = (d) => {
    d.__type__ === "FOLDER" && c((f) => !f), d.__type__ === "FILE" && n(d);
  }, u = (d) => {
    var h;
    const f = H0((h = t == null ? void 0 : t.fileMetadata) == null ? void 0 : h.length, 2);
    return d.__type__ === "FILE" ? `${t.__name__} (${f})` : `${t.__name__}`;
  };
  return t ? /* @__PURE__ */ B(ze, { children: [
    o && /* @__PURE__ */ p(CG, {}),
    /* @__PURE__ */ B(
      _G,
      {
        title: u(t),
        onClick: () => l(t),
        children: [
          t.__type__ === "FOLDER" && /* @__PURE__ */ B(ze, { children: [
            /* @__PURE__ */ p(TG, { children: /* @__PURE__ */ p(
              pe,
              {
                iconName: "folder",
                sx: { "&.MuiSvgIcon-root": { fontSize: 20 } }
              }
            ) }),
            /* @__PURE__ */ p(
              Uv,
              {
                selectedFile: t.id && r && r.id === t.id,
                children: t.__name__
              }
            ),
            /* @__PURE__ */ p(kG, { children: t.__size__ })
          ] }),
          t.__type__ === "FILE" && /* @__PURE__ */ B(ze, { children: [
            (r == null ? void 0 : r.id) === t.id && i === yE.LOADING_FILE ? /* @__PURE__ */ p(yt, { size: 18 }) : /* @__PURE__ */ p(
              pe,
              {
                iconName: t.ext,
                sx: { "&.MuiSvgIcon-root": { fontSize: 20 } }
              }
            ),
            /* @__PURE__ */ B(Uv, { selectedFile: t.id && (r == null ? void 0 : r.id) === t.id, children: [
              t.__name__,
              " ",
              /* @__PURE__ */ p(EG, { children: " (" + H0(t.fileMetadata.length, 2) + ")" })
            ] })
          ] })
        ]
      }
    ),
    s && /* @__PURE__ */ p(SG, { children: /* @__PURE__ */ p(
      bC,
      {
        subList: !0,
        fileTree: t,
        selectedFile: r,
        selectFile: n,
        status: i
      }
    ) })
  ] }) : /* @__PURE__ */ p(ze, {});
}, bC = (e) => {
  const { selectedFile: t, selectFile: n, status: r, subList: i, fileTree: a } = e, { t: o } = Da(), s = (a == null ? void 0 : a.__size__) > 0 ? Object.values(a) : [];
  return s.sort((c, l) => c.__type__ < l.__type__ ? 1 : c.__type__ > l.__type__ ? -1 : 0), /* @__PURE__ */ p(wG, { subList: i, children: /* @__PURE__ */ p(R, { container: !0, children: (s == null ? void 0 : s.length) > 0 ? s.map((c, l) => /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    IG,
    {
      subList: i,
      files: a,
      selectedFile: t,
      selectFile: n,
      item: c,
      status: r
    }
  ) }, l)) : /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(fe, { py: 3, variant: "h2", align: "center", children: o("features.file_explorer.no_files_to_display") }) }) }) });
}, IQ = (e) => {
  const { t } = Da(), {
    submissionId: n,
    url: r,
    noDataMessage: i = t("messages.result_empty"),
    files: a,
    heightCount: o = 250
  } = e, { fileTree: s, status: c, selectedFile: l, filesContent: u, selectFile: d } = xE(n, r, a);
  return [Ce.INITIAL, Ce.IN_PROGRESS].includes(c) ? /* @__PURE__ */ p(R, { item: !0, xs: 12, py: "100px", children: /* @__PURE__ */ p(Sf, { children: /* @__PURE__ */ p(yt, { size: 30 }) }) }) : /* @__PURE__ */ p(wr, { elevation: 0, sx: { p: 2 }, children: (s == null ? void 0 : s.__size__) === 0 ? /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(Ps, { children: i }) }) : /* @__PURE__ */ B(R, { container: !0, border: "1px solid", borderColor: "borderColor.main", children: [
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(MG, { children: /* @__PURE__ */ B(R, { container: !0, children: [
      /* @__PURE__ */ B(
        R,
        {
          item: !0,
          xs: 3,
          sx: {
            paddingRight: "21px",
            borderRight: "1px solid"
          },
          children: [
            /* @__PURE__ */ p(Gv, { children: t("features.file_explorer.header") }),
            /* @__PURE__ */ p(Vv, { children: /* @__PURE__ */ p(
              "a",
              {
                href: `/api/${r}/${n}/results/download`,
                target: "_blank",
                children: /* @__PURE__ */ p(
                  Te,
                  {
                    variant: "outlined",
                    size: "small",
                    name: "download-all-result-files",
                    startIcon: /* @__PURE__ */ p(pe, { iconName: "import" }),
                    children: t("buttons.download_all")
                  }
                )
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ p(R, { item: !0, xs: 9, children: l && /* @__PURE__ */ B(ze, { children: [
        /* @__PURE__ */ p(Gv, { marginLeft: "20px", children: l.__name__ }),
        /* @__PURE__ */ p(Vv, { children: /* @__PURE__ */ p(
          "a",
          {
            href: `/api/${r}/${n}/results/${l == null ? void 0 : l.id}/download`,
            target: "_blank",
            children: /* @__PURE__ */ p(
              Te,
              {
                variant: "outlined",
                size: "small",
                startIcon: /* @__PURE__ */ p(pe, { iconName: "import" }),
                children: t("buttons.download")
              }
            )
          }
        ) })
      ] }) })
    ] }) }) }),
    /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ B(R, { container: !0, children: [
      /* @__PURE__ */ p(
        R,
        {
          item: !0,
          xs: 3,
          borderRight: "1px solid",
          borderColor: "borderColor.main",
          sx: { height: "80vh", overflowY: "auto" },
          children: /* @__PURE__ */ p(
            bC,
            {
              fileTree: s,
              status: c,
              selectedFile: l,
              selectFile: d
            }
          )
        }
      ),
      /* @__PURE__ */ p(
        R,
        {
          item: !0,
          xs: 9,
          sx: { height: `calc(100vh - ${o}px)` },
          children: /* @__PURE__ */ p(
            bG,
            {
              fileContent: u == null ? void 0 : u[l.id],
              fileMetadata: l,
              status: c,
              pdfLink: `/api/${r}/${n}/results/${l == null ? void 0 : l.id}/download`,
              height: `calc(100vh - ${o}px)`
            }
          )
        }
      )
    ] }) })
  ] }) });
}, NQ = ({
  tooltipText: e
}) => /* @__PURE__ */ p(pt, { text: e || "", children: /* @__PURE__ */ p(
  Ra,
  {
    sx: (t) => ({
      backgroundColor: t.palette.grey[200],
      borderRadius: "50%",
      width: 20,
      height: 20,
      p: "4px",
      ":hover": {
        backgroundColor: t.palette.grey[300]
      }
    }),
    children: /* @__PURE__ */ p(pe, { iconName: "message", sx: { fontSize: 12, color: "grey" } })
  }
) }), OQ = (e) => {
  const {
    onChange: t,
    titleButton: n = "Upload file",
    initialTextFile: r,
    required: i = !1
  } = e, a = qt(null), o = () => {
    a && a.current && (a.current.value = "");
  }, { enqueueSnackbar: s } = Zr(), [c, l] = Se(
    r ? {
      name: r
    } : null
  ), u = (d) => {
    const f = new FileReader();
    f.readAsText(d), f.onload = function() {
      try {
        const h = JSON.parse(f.result);
        t(h, d), l(d);
      } catch {
        s({
          message: "invalid JSON",
          variant: "error"
        });
      }
    }, f.onerror = function() {
      s({
        message: f.error,
        variant: "error"
      });
    };
  };
  return /* @__PURE__ */ p(R, { container: !0, children: /* @__PURE__ */ B(
    R,
    {
      item: !0,
      xs: 12,
      p: 1.5,
      borderRadius: 1,
      bgcolor: "backgroundColor.main",
      container: !0,
      alignItems: "center",
      flexWrap: "nowrap",
      children: [
        /* @__PURE__ */ B(R, { item: !0, children: [
          /* @__PURE__ */ B(
            Te,
            {
              variant: "contained",
              component: "label",
              color: "info",
              size: "small",
              startIcon: /* @__PURE__ */ p(pe, { iconName: "upload" }),
              sx: { minWidth: 150 },
              children: [
                n,
                /* @__PURE__ */ p(
                  "input",
                  {
                    type: "file",
                    accept: "application/json",
                    ref: a,
                    onChange: (d) => {
                      const f = d.target.files[0];
                      u(f);
                    },
                    hidden: !0
                  }
                )
              ]
            }
          ),
          " "
        ] }),
        /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, ml: 2, display: "flex", alignItems: "center", children: c ? /* @__PURE__ */ B(ze, { children: [
          /* @__PURE__ */ p(
            fe,
            {
              sx: { maxWidth: "calc(100% - 30px)", wordBreak: "break-all" },
              children: c == null ? void 0 : c.name
            }
          ),
          /* @__PURE__ */ p(
            Ra,
            {
              size: "small",
              color: "error",
              sx: { p: 0.5, ml: 1 },
              onClick: () => {
                l(null), t(null), o();
              },
              children: /* @__PURE__ */ p(pe, { iconName: "delete", sx: { fontSize: 14 } })
            }
          )
        ] }) : /* @__PURE__ */ B(
          fe,
          {
            variant: "subtitle2",
            sx: { sup: { color: "error.main", fontSize: 12 } },
            children: [
              "Choose file to upload",
              i && /* @__PURE__ */ p("sup", { children: "*" })
            ]
          }
        ) })
      ]
    }
  ) });
}, NG = te(he, {
  shouldForwardProp(e) {
    return e !== "count" && e !== "fontSize";
  }
})(({ theme: e, count: t = 0, fontSize: n }) => ({
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  position: "relative",
  ":before": {
    content: '""',
    display: "block",
    paddingBottom: "100%",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #40527F 18.33%, #2F467C 23.38%, #5E89EF 98.5%)"
  },
  ":after": {
    content: `'${t}'`,
    color: e.palette.textColor.secondary,
    fontSize: n || "40px",
    fontWeight: 700,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    top: 0,
    width: "calc(100% - 24px)",
    height: "calc(100% - 24px)",
    margin: "12px",
    borderRadius: "50%",
    textAlign: "center",
    background: "#ffffff",
    transform: "scale(100%)"
  }
})), F0 = ({ infoText: e, placement: t }) => {
  function n() {
    switch (t) {
      case "top-left":
        return {
          top: 6,
          left: 6
        };
      case "top-right":
        return {
          top: 6,
          right: 6
        };
      case "bottom-right":
        return {
          bottom: 6,
          right: 6
        };
      case "bottom-left":
        return {
          bottom: 6,
          left: 6
        };
    }
  }
  return /* @__PURE__ */ p(pt, { text: e, children: /* @__PURE__ */ p(
    pe,
    {
      iconName: "info",
      sx: {
        fontSize: 18,
        position: "absolute",
        ...n(),
        color: "#9fa8bd",
        cursor: "pointer",
        "&:hover": {
          color: "#808ba7"
        }
      }
    }
  ) });
}, OG = ({ count: e = 0, infoText: t, loading: n, title: r }) => {
  const [i, a] = Se(0), o = Ge(
    (s) => {
      s !== null && a(
        Math.round(
          s.getBoundingClientRect().width * 1.05 / (String(e).length || 1)
        )
      );
    },
    [e]
  );
  return /* @__PURE__ */ B(
    wr,
    {
      variant: "outlined",
      sx: (s) => ({
        position: "relative",
        height: "100%",
        boxShadow: s.customShadows[3]
      }),
      children: [
        /* @__PURE__ */ p(F0, { infoText: t, placement: "bottom-right" }),
        /* @__PURE__ */ B(he, { p: 1.2, children: [
          /* @__PURE__ */ p(fe, { fontSize: 12, children: r }),
          /* @__PURE__ */ B(fe, { fontSize: 12, children: [
            "Total number: ",
            /* @__PURE__ */ p("b", { children: e })
          ] })
        ] }),
        /* @__PURE__ */ p(he, { px: 5, py: 2, pt: 1.5, children: n ? /* @__PURE__ */ p(yt, { size: 116, thickness: 4.4, color: "secondary" }) : /* @__PURE__ */ p(
          NG,
          {
            ref: o,
            count: e,
            fontSize: i > 40 ? 40 : i
          }
        ) })
      ]
    }
  );
};
function RG(e, t) {
  let n = String(e).length, r = Math.round(t / (n || 1));
  try {
    return r > 23 ? 40 : r < 3 ? 5 : 30 * r * 0.95 / 16.85;
  } catch (i) {
    return console.log(i), 30;
  }
}
const Qv = ({ count: e = 0, title: t, infoText: n, iconName: r, loading: i }) => {
  const [a, o] = Se(0), s = Ge(
    (c) => {
      c !== null && o(RG(e, c.getBoundingClientRect().width));
    },
    [e]
  );
  return /* @__PURE__ */ B(
    wr,
    {
      variant: "outlined",
      sx: (c) => ({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flexGrow: 1,
        maxWidth: "100%",
        boxShadow: c.customShadows[3]
      }),
      children: [
        /* @__PURE__ */ p(F0, { infoText: n, placement: "top-right" }),
        /* @__PURE__ */ p(R, { item: !0, p: 1.2, children: /* @__PURE__ */ p(fe, { fontSize: 12, children: t }) }),
        /* @__PURE__ */ B(
          R,
          {
            container: !0,
            justifyContent: "space-between",
            alignItems: "flex-end",
            px: 1.2,
            pb: 0.5,
            flexWrap: "nowrap",
            children: [
              /* @__PURE__ */ p(
                R,
                {
                  item: !0,
                  flexGrow: 1,
                  fontSize: a,
                  fontWeight: 700,
                  color: "textColor.secondary",
                  lineHeight: "1em",
                  ref: s,
                  maxWidth: "calc(100% - 30px)",
                  children: i ? /* @__PURE__ */ p(
                    ai,
                    {
                      height: 36,
                      sx: { mb: 0.5, maxWidth: 100, bgcolor: "secondary.main" }
                    }
                  ) : e
                }
              ),
              /* @__PURE__ */ p(R, { item: !0, children: /* @__PURE__ */ p(
                pe,
                {
                  iconName: r,
                  sx: { fontSize: 24, color: "#40527F" },
                  color: "primary"
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, DG = () => {
  const [e, t] = Se([]), n = Ge((r) => {
    if (r !== null) {
      let i = [];
      for (let a = 0; a < r.getBoundingClientRect().width / 50; a++)
        i.push(Math.floor(Math.random() * 101 + 20));
      t(i);
    }
  }, []);
  return /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    R,
    {
      container: !0,
      spacing: 1,
      alignItems: "flex-end",
      height: 175,
      ref: n,
      children: e.map((r, i) => /* @__PURE__ */ p(R, { item: !0, flexGrow: 1, children: /* @__PURE__ */ p(
        ai,
        {
          sx: { bgcolor: "secondary.main" },
          width: "80%",
          height: r
        }
      ) }, i))
    }
  ) });
}, PG = ({ data: e, loading: t, title: n, infoText: r }) => /* @__PURE__ */ B(
  wr,
  {
    variant: "outlined",
    sx: (i) => ({
      flexGrow: 1,
      p: 1.2,
      maxWidth: "calc(100% - 16px)",
      position: "relative",
      boxShadow: i.customShadows[3]
    }),
    children: [
      /* @__PURE__ */ p(F0, { placement: "top-right", infoText: r }),
      /* @__PURE__ */ p(fe, { fontSize: 12, children: n }),
      /* @__PURE__ */ p(he, { children: t ? /* @__PURE__ */ p(DG, {}) : /* @__PURE__ */ p(OE, { width: "100%", height: 165, children: /* @__PURE__ */ B(
        _A,
        {
          data: e,
          margin: { top: 15, left: 0, right: 10, bottom: 0 },
          children: [
            /* @__PURE__ */ p(RE, { strokeDasharray: "3 3", vertical: !1 }),
            /* @__PURE__ */ p(
              DE,
              {
                dataKey: "weeksAgo",
                fontSize: 10,
                padding: { left: 20, right: 20 },
                tickLine: !1,
                height: 20,
                fill: "white",
                axisLine: !1,
                tickFormatter: (i) => i === 0 ? "Current week" : i === e.length - 1 ? i === 1 ? i + " week ago" : i + " weeks ago" : ""
              }
            ),
            /* @__PURE__ */ p(PE, { fontSize: 10, width: 30 }),
            /* @__PURE__ */ p(
              LE,
              {
                labelFormatter: (i) => {
                  switch (i) {
                    case 0:
                      return "Current week";
                    case 1:
                      return i + " week ago";
                    default:
                      return i + " weeks ago";
                  }
                }
              }
            ),
            /* @__PURE__ */ p(
              SA,
              {
                type: "linear",
                dataKey: "count",
                stroke: "#1054A8",
                strokeWidth: 5,
                dot: {
                  stroke: "white",
                  strokeWidth: 2,
                  r: 4,
                  fill: "#1054A8",
                  strokeDasharray: ""
                }
              }
            )
          ]
        }
      ) }) })
    ]
  }
), Dh = 210, LG = 233, zG = ({
  data: { chart: e, topLeft: t, bottomLeft: n, score: r },
  status: i
}) => {
  const a = i === Ce.IN_PROGRESS || i === Ce.INITIAL;
  return /* @__PURE__ */ B(R, { container: !0, spacing: 1.5, height: LG, children: [
    /* @__PURE__ */ B(
      R,
      {
        item: !0,
        maxWidth: Dh,
        flexGrow: 1,
        flexDirection: "column",
        display: "flex",
        children: [
          /* @__PURE__ */ p(R, { item: !0, xs: 12, flexGrow: 1, display: "flex", mb: 1.5, children: /* @__PURE__ */ p(Qv, { ...t, loading: a }) }),
          /* @__PURE__ */ p(R, { item: !0, xs: 12, flexGrow: 1, display: "flex", children: /* @__PURE__ */ p(Qv, { ...n, loading: a }) })
        ]
      }
    ),
    /* @__PURE__ */ p(
      R,
      {
        container: !0,
        item: !0,
        flexDirection: "column",
        flexGrow: 2,
        maxWidth: `calc(100% - ${Dh * 2}px)`,
        children: /* @__PURE__ */ p(PG, { loading: a, ...e })
      }
    ),
    /* @__PURE__ */ p(R, { flexGrow: 1, item: !0, maxWidth: Dh, children: /* @__PURE__ */ p(OG, { ...r, loading: a }) })
  ] });
}, RQ = ({ children: e }) => /* @__PURE__ */ p(Fr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ B(he, { sx: { display: "flex", alignItems: "center" }, children: [
  /* @__PURE__ */ p(bg, {}),
  /* @__PURE__ */ p(fe, { sx: { ml: 1.5 }, variant: "body2", children: e })
] }) }), BG = ({ list: e, status: t }) => {
  var i, a;
  const [n, r] = Se("study");
  return /* @__PURE__ */ B(dr, { elevated: !0, outlined: !0, children: [
    /* @__PURE__ */ p(
      Of,
      {
        active: n,
        tabs: [
          {
            value: "study",
            title: /* @__PURE__ */ p(
              jh,
              {
                title: "By Studies",
                count: (i = e.study) == null ? void 0 : i.length,
                status: t
              }
            ),
            onTabClick: () => r("study")
          },
          {
            value: "workspace",
            title: /* @__PURE__ */ p(
              jh,
              {
                title: "By Users",
                count: (a = e.workspace) == null ? void 0 : a.length,
                status: t
              }
            ),
            onTabClick: () => r("workspace")
          }
        ],
        secondary: !0
      }
    ),
    /* @__PURE__ */ p(Sa, {}),
    /* @__PURE__ */ p(
      Ml,
      {
        data: e[n],
        enablePagination: !0,
        enableSorting: !0,
        initialSort: { id: "lastUsed", desc: !0 },
        isLoading: t === Ce.IN_PROGRESS,
        columns: [
          // {
          //   Header: '',
          //   accessor: 'object.type',
          //   Cell: ContainerIcon,
          //   isCropped: true,
          //   width: '3%',
          //   minWidth: 50,
          //   maxWidth: 50,
          // },
          {
            Header: "Name",
            accessor: "object.name",
            Cell: fp,
            isCropped: !0,
            width: "45%",
            minWidth: 200,
            maxWidth: 250
          },
          {
            Header: "# of analyses",
            accessor: "analyses"
          },
          {
            Header: "# of derived objects",
            accessor: "derived"
          },
          {
            Header: "Last used",
            accessor: "lastUsed",
            Cell: ji
          }
        ]
      }
    )
  ] });
}, DQ = ({ status: e, board: t, list: n }) => /* @__PURE__ */ p(Zm, { children: /* @__PURE__ */ B(ze, { children: [
  /* @__PURE__ */ p(R, { item: !0, xs: 12, children: /* @__PURE__ */ p(zG, { status: e, data: t }) }),
  /* @__PURE__ */ p(R, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ p(BG, { list: n, status: e }) })
] }) }), Vs = (e) => String(e ?? "").toLowerCase().replace(/[^a-z]/g, ""), FG = (e) => String(e ?? "").trim().replace(/\s+/g, " ").toLowerCase(), uo = (e) => {
  if (typeof e == "boolean") return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true") return !0;
    if (t === "false") return !1;
  }
}, df = (e) => e.map(FG).filter((t, n, r) => t && r.indexOf(t) === n), hf = (e, t) => [e, t].filter(Boolean).join(" "), $G = (e) => df([
  hf(e == null ? void 0 : e.firstName, e == null ? void 0 : e.lastName),
  hf(e == null ? void 0 : e.lastName, e == null ? void 0 : e.firstName),
  e == null ? void 0 : e.name,
  e == null ? void 0 : e.title,
  e == null ? void 0 : e.displayName,
  e == null ? void 0 : e.username,
  e == null ? void 0 : e.login,
  e == null ? void 0 : e.email
]), YG = (e) => {
  var t, n, r, i;
  return df([
    (t = e == null ? void 0 : e.object) == null ? void 0 : t.title,
    e == null ? void 0 : e.title,
    e == null ? void 0 : e.name,
    e == null ? void 0 : e.displayName,
    hf(e == null ? void 0 : e.firstName, e == null ? void 0 : e.lastName),
    hf((n = e == null ? void 0 : e.object) == null ? void 0 : n.firstName, (r = e == null ? void 0 : e.object) == null ? void 0 : r.lastName),
    (i = e == null ? void 0 : e.object) == null ? void 0 : i.email,
    e == null ? void 0 : e.email
  ]);
}, jG = (e, t) => {
  var o, s, c;
  const n = df([
    t == null ? void 0 : t.id,
    (o = t == null ? void 0 : t.object) == null ? void 0 : o.id,
    t == null ? void 0 : t.userId
  ]);
  if (df([
    (s = e == null ? void 0 : e.object) == null ? void 0 : s.id,
    e == null ? void 0 : e.id,
    e == null ? void 0 : e.userId,
    (c = e == null ? void 0 : e.object) == null ? void 0 : c.userId
  ]).some((l) => n.includes(l))) return !0;
  const i = $G(t);
  return YG(e).some((l) => i.includes(l));
}, WG = (e) => {
  const t = uo(e);
  if (t !== void 0) return t;
  if (Array.isArray(e))
    return e.some((n) => {
      const r = Vs(n);
      return r.includes("datasteward") || r.includes("steward") || r.includes("owner");
    });
  if (typeof e == "string") {
    const n = Vs(e);
    return n.includes("datasteward") || n.includes("steward") || n.includes("owner");
  }
  return !!(uo(e == null ? void 0 : e.dataSteward) ?? uo(e == null ? void 0 : e.steward) ?? uo(e == null ? void 0 : e.owner));
}, HG = (e, t) => {
  if (Array.isArray(t) && t.some((r) => Vs(r) === "admin"))
    return !0;
  const n = uo(e);
  return n !== void 0 ? n : Array.isArray(e) ? e.some((r) => Vs(r).includes("admin")) : typeof e == "string" ? Vs(e).includes("admin") : !!uo(e == null ? void 0 : e.admin);
}, UG = (e, t) => e == null ? void 0 : e.find((n) => jG(n, t)), GG = (e) => {
  var i, a, o, s, c, l, u;
  const t = (e == null ? void 0 : e.roles) ?? ((i = e == null ? void 0 : e.object) == null ? void 0 : i.roles), n = WG(
    (e == null ? void 0 : e.dataSteward) ?? (e == null ? void 0 : e.steward) ?? (e == null ? void 0 : e.owner) ?? ((a = e == null ? void 0 : e.object) == null ? void 0 : a.dataSteward) ?? ((o = e == null ? void 0 : e.object) == null ? void 0 : o.steward) ?? ((s = e == null ? void 0 : e.object) == null ? void 0 : s.owner) ?? t
  ), r = HG(
    (e == null ? void 0 : e.admin) ?? ((c = e == null ? void 0 : e.object) == null ? void 0 : c.admin) ?? t ?? (e == null ? void 0 : e.actions) ?? ((l = e == null ? void 0 : e.object) == null ? void 0 : l.actions),
    (e == null ? void 0 : e.moduleIds) ?? ((u = e == null ? void 0 : e.object) == null ? void 0 : u.moduleIds)
  );
  return { steward: n, admin: r };
}, wC = () => {
  const e = Rt((r) => r.user.data), [t, n] = Se({ steward: !1, admin: !1 });
  return He(() => {
    if (!(e != null && e.activeTenant)) {
      n({ steward: !1, admin: !1 });
      return;
    }
    let r = !1;
    return un.get(`/users/tenant/${e.activeTenant}`).then((i) => {
      if (r) return;
      const a = Array.isArray(i) ? i : (i == null ? void 0 : i.data) ?? [], o = UG(a, e);
      if (!o) {
        n({ steward: !1, admin: !1 });
        return;
      }
      n(GG(o));
    }).catch(() => {
      r || n({ steward: !1, admin: !1 });
    }), () => {
      r = !0;
    };
  }, [e == null ? void 0 : e.activeTenant, e == null ? void 0 : e.id, e == null ? void 0 : e.email]), t;
};
function VG() {
  const { steward: e, admin: t } = wC();
  return e || t;
}
function PQ() {
  const { steward: e } = wC();
  return e;
}
const QG = /* @__PURE__ */ B(ze, { children: [
  /* @__PURE__ */ p(fe, { variant: "h6", gutterBottom: !0, children: "Archive artifact" }),
  /* @__PURE__ */ p(fe, { variant: "body1", gutterBottom: !0, children: "Are you sure you want to archive this published artifact?" }),
  /* @__PURE__ */ p(fe, { variant: "body2", color: "text.secondary", children: "Basic users will no longer be able to see it in the library. Data stewards and Administrators will be able to see it in read-only mode with “Show archived” filter enabled." })
] }), qG = (e) => {
  var r;
  const t = e == null ? void 0 : e.response, n = (r = t == null ? void 0 : t.data) == null ? void 0 : r.message;
  return typeof n == "string" ? n : "Failed to archive. Please try again.";
};
function LQ(e, t, n) {
  const r = VG(), { showDialog: i, hideDialog: a } = zo(Am), o = Tr(), [s] = wA(), { enqueueSnackbar: c } = Zr(), l = !!s.get("typePublish");
  if (!(!t || !r || !e || l))
    return () => i(Em, {
      onSubmit: async () => {
        try {
          await un.delete(`/library/members/${e}`), a(), o(`/${n}`);
        } catch (u) {
          a(), c({
            message: qG(u),
            variant: "error"
          });
        }
      },
      onClose: a,
      text: QG,
      confirmButtonText: "ARCHIVE",
      variant: "warning"
    });
}
export {
  $V as AIChat,
  Km as AUTHOR_COLUMN,
  EV as AcceptConsentDialog,
  QM as Access,
  CL as ActionCell,
  NL as AliasCell,
  tQ as AnalysisBaseInfo,
  aQ as AnalysisResultsBaseInfo,
  NT as AnalysisSubmissionStatusBadge,
  L1 as AuthorCell,
  UV as AuthorCellWithIcon,
  qV as BaseContentWrapper,
  XV as BaseEntityContent,
  xV as BaseFormUpdateTitle,
  QV as BaseInfoWrapper,
  Jm as CREATED_COLUMN,
  gQ as Chart,
  Nl as CodeEditor,
  nQ as CohortBaseInfo,
  CV as CohortImport,
  YV as Compare,
  iQ as ConceptSetBaseInfo,
  Em as ConfirmationDialog,
  yV as Content,
  Wc as Count,
  MV as CreateStudyFormBackdrop,
  HA as CsvViewer,
  cQ as CustomCodeBaseInfo,
  VV as DATE_COLUMN,
  rQ as DataCatalogBaseInfo,
  VA as DataSourceLabel,
  $L as DataSourceLogo,
  sQ as DatabaseBaseInfo,
  ji as DateCell,
  RQ as DescriptionCard,
  IV as Dropzone,
  va as ENTITY_TO_ROUTE,
  iT as EditButton,
  sb as EmptyListPlaceholder,
  rT as EntityImport,
  wV as EntityMessages,
  ui as EntityMessagesActionType,
  bV as EntityMessagesCntBadge,
  Wk as EntityMessagesIcon,
  AV as EntityMessagesTab,
  Uk as EntityMessagesText,
  Xi as EntityTypeCell,
  vG as ErrorBoundary,
  KU as ErrorPage,
  bQ as Export,
  ff as ExportListControl,
  RU as ExportMetadata,
  _Q as ExportMultipleSource,
  ZV as ExportWrapper,
  AQ as FallbackErrorPage,
  LV as Favorite,
  PV as FavoritesHeader,
  oQ as FeatureAnalysisBaseInfo,
  jA as FileContentType,
  IQ as FileExplorer,
  OV as FileItem,
  bG as FileViewer,
  Vz as FloatingBlock,
  qz as FloatingButton,
  xf as FormActionsContainer,
  an as FormElement,
  BE as FormElementContainer,
  _V as FormLabel,
  kQ as HomePageWidgetList,
  TQ as HomePageWidgetListItem,
  OL as ICON_COLUMN,
  Kb as ID_COLUMN,
  yQ as IRChartScale,
  FQ as IconActionButton,
  Ks as IconButton,
  AC as IconButtonStyled,
  xT as ImageViewer,
  OQ as ImportJsonFile,
  xC as ImportList,
  OU as ImportMetadata,
  wQ as ImportMultipleSource,
  Qv as InfoCard,
  bg as InfoIcon,
  SV as InlineFormElement,
  RV as InlineSpinner,
  BV as Invitations,
  NV as ItemsCart,
  MQ as LastInteracted,
  GV as LineChartCell,
  Ls as Link,
  WV as ListCell,
  ub as ListContainer,
  TV as ListEntityBackdrop,
  jz as ListHeaderDescription,
  Yz as ListHeaderPrimary,
  Hw as ListHeaderSecondary,
  lb as ListItemContainer,
  cb as ListItemDate,
  kV as MediaViewer,
  NQ as MessageIcon,
  vQ as MetaAttributes,
  CQ as ModuleDescriptionCard,
  qm as NAME_COLUMN,
  fp as NameCell,
  HV as NameWithAliasCell,
  ML as NameWithSubtitleCell,
  KV as NestedInfoWrapper,
  jV as NoData,
  FV as Notifications,
  Ef as NotificationsButton,
  dQ as PageList,
  GA as PdfViewer,
  Cf as PopupContainer,
  ob as PopupContainerHeader,
  LL as PrimaryButton,
  xQ as PublishEntity,
  oT as RemoveButton,
  OG as ScoreCard,
  zL as SecondaryButton,
  Zm as SecondaryContentWrapper,
  hQ as Section,
  JV as ShortListWrapper,
  SQ as SimpleRedirectBlock,
  GM as SpinnerContainer,
  DV as SpinnerFullContainer,
  Sf as SpinnerWidgetContainer,
  DQ as Statistics,
  zG as StatisticsBoard,
  eQ as StudyBaseInfo,
  uQ as StudyDetails,
  EQ as SubModuleDescriptionBlock,
  jh as TabWithCounter,
  Of as TabsNavigationNew,
  vL as TitleWithCount,
  Xm as UPDATED_COLUMN,
  kU as UpdateMetaAttributes,
  FL as UseInAnalysis,
  zV as UserForm,
  mQ as VersionCopyLink,
  Pl as VersionPreviewButtons,
  Hz as VersionPreviewLink,
  pQ as Versions,
  aT as ViewButton,
  lQ as VocabularyManagementBaseInfo,
  fQ as WorkspaceDetails,
  CA as entityMessagesInitialState,
  z1 as initialStorage,
  TL as lastInteractedEntityMapping,
  P1 as lastInteractedPathMapping,
  RL as pageListConfig,
  uI as parseMessageEntity,
  LQ as useArchiveLibraryMember,
  vV as useEntityMessages,
  VG as useIsLibraryAdmin,
  PQ as useIsLibraryDataSteward,
  DL as useLocalStorage
};
//# sourceMappingURL=features.js.map
